'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name sprechstunde
   * @description
   */
  angular.module('sprechstunde', ['ngAria', 'ui.router', 'ui.bootstrap', 'ngCookies', 'ngTagsInput', 'ui.bootstrap.typeahead', 'restmod', 'ngLodash', 'cfp.hotkeys', 'home', 'vcutils', 'vcclient', 'vcconsult', 'vcexam', 'vcexamtemplate', 'vcdms', 'vcdms.vcfile', 'vcdrug', 'vctodo', 'vcchat', 'vcfinance', 'vcreminder', 'vcuser', 'vcuser.vclogin', 'vcpatdocs', 'vctracker' //,
  // 'vcdevice'
  ]);

  angular.module('sprechstunde').filter('moment', function () {
    return function (dateString, format) {
      return moment(dateString).locale('de-at').format(format);
    };
  }).filter('addweeks', function () {
    return function (weeks, format) {
      return moment().add(weeks * 7, 'days').locale('de-at').format(format);
    };
  }).filter('javadate', function () {
    return function (javadate, format) {
      return moment(javadate, 'YYYYMMDD-HHmmss').locale('de-at').format(format);
    };
  }).filter('trustUrl', ['$sce', function ($sce) {
    return function (recordingUrl) {
      return $sce.trustAsResourceUrl('/routes/files/filereader/' + recordingUrl);
    };
  }]).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|data|blob):/);
  }]).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|local|data):/);
  }])
  // this interceptor will ad a custom header containing the tabid to every request
  .factory('tabidInterceptor', ['$log', '$window', function ($log, $window) {
    return {
      request: function request(config) {
        var uuid;

        // helper function to create uuid
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
          }

          return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        if ($window.sessionStorage.getItem('sprtabid')) {
          uuid = $window.sessionStorage.getItem('sprtabid');
        } else {
          uuid = guid();
          $log.debug('Tab UUID created: ', uuid);
          $window.sessionStorage.setItem('sprtabid', uuid);
        }
        config.headers['X-tabid'] = uuid;
        return config;
      }
    };
  }]).config(function ($httpProvider) {
    $httpProvider.interceptors.push('tabidInterceptor');
  })
  // restmod cookie handling?
  .run(['$cookies', '$rootScope', '$log', function ($cookies, $rootScope, $log) {
    $rootScope.username = $cookies.get('username');
    $log.debug('cookies initialised: ', $cookies.get('username'));
  }]).config(['restmodProvider', '$httpProvider', function (restmodProvider, $httpProvider) {
    restmodProvider.rebase({
      $config: {
        style: 'SprechstundeStyle!'
      },
      $hooks: {
        'before-request': function beforeRequest() {
          $httpProvider.defaults.withCredentials = true;
        }
      }
    });
  }])

  // login: HTTP 401 interceptor
  .factory('AuthInterceptor', ['$injector', '$location', '$q', '$log', function ($injector, $location, $q, $log) {
    return {
      responseError: function responseError(rejection) {
        var $state;
        console.log('rejection: ', rejection);
        if (rejection.status === 401 && rejection.config.url !== '/login') {
          $state = $injector.get('$state');
          // This is the interesting bit: (redirect to initially entered url)
          $log.debug('app-module location url: ', $location.url());
          if ($location.url() !== '/login') {
            $state.go('login', { url: $location.url() });
          }
        }
        return $q.reject(rejection);
      }
    };
  }]).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
  }]).config(['vertxEventBusProvider', function (vertxEventBusProvider) {
    vertxEventBusProvider.enable().useDebug(true).useSockJsReconnectInterval(5000).useReconnect(true);
  }]).config(['vertxEventBusServiceProvider', function (vertxEventBusServiceProvider) {
    vertxEventBusServiceProvider.useDebug(true);
  }])
  // make sure that hotkeys ngroute support does not interfere with ui.router
  .config(['hotkeysProvider', function (hotkeysProvider) {
    hotkeysProvider.useNgRoute = false;
  }]).run(['hotkeys', '$state', '$log', function (hotkeys, $state, $log) {
    $log.debug('app hotkeys entered');
    var OSName = "Unknown OS";
    if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
    if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
    if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
    if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";
    console.log("%%%%% OS:  ", OSName);
    hotkeys.add({
      combo: 'alt+n',
      description: 'Neuer Patient',
      callback: function callback() {
        $state.go('newpatient');
      }
    });
    hotkeys.add({
      combo: 'alt+f',
      description: 'Patient Finden',
      callback: function callback() {
        $state.go('patientsearch');
      }
    });
  }])
  // get previous state tagged onto new state
  .run(['$rootScope', '$state', function ($rootScope, $state) {
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      $state.previousState = fromState;
      $state.previousParams = fromParams;
    });
  }]).directive('ngReallyClick', [function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('click', function () {
          var message = attrs.ngReallyMessage;
          if (message && confirm(message)) {
            scope.$apply(attrs.ngReallyClick);
          }
        });
      }
    };
  }]).directive('autofocus', function () {
    return {
      restrict: 'A',
      link: function link(scope, element) {
        element[0].focus();
      }
    };
  }).directive('showfocus', function ($timeout) {
    return function (scope, element, attrs) {
      scope.$watch(attrs.showFocus, function (newValue) {
        $timeout(function () {
          newValue && element[0].focus();
        });
      }, true);
    };
  }).directive('mobilerefresh', ['$window', '$rootScope', '$log', function ($window, $rootScope, $log) {
    $window.onfocus = function () {
      console.log('%%%% Window received focus');

      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {

        $log.debug('This is a mobile browser!');

        // setting up heartbeat if not initalised yet
        if (angular.isUndefined($rootScope.connfailure)) {
          $rootScope.connfailure = 0;
        }
        if (angular.isUndefined($rootScope.heartbeat)) {
          $rootScope.heartbeat = moment();
        }
        // check if there was a heartbeat recorded within the last then 10s
        // Opening and closing file selection for file upload triggered page refresh, and killing file upload
        if (!$rootScope.heartbeat.isBetween(moment().subtract(10000, 'ms'), moment())) {
          // $log.debug('connection exists');
          $window.location.reload();
        }
      }
    };
    // $document.onvisibilitychange = function () {console.log('%%%% document changed visibility: ', $document);};
  }]);
})();
angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcutils/sv/svform-component.tpl.html',
    '<form class="form-vertical" id="editsvform" autocomplete="noway">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="short">Kürzel <span ng-show="vm.sv.old">(ehem. {{vm.sv.old}})</span></label>\n' +
    '      <input type="text" ng-model="vm.sv.short" class="form-control" id="short" tabindex="1"\n' +
    '             placeholder="Kürzel">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="name">Kassencode</label>\n' +
    '      <input type="text" ng-model="vm.sv.code" class="form-control" id="code" tabindex="2"\n' +
    '             placeholder="Kassencode">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <label for="short">Druckerausgabe</label>\n' +
    '      <input type="text" ng-model="vm.sv.printlong" class="form-control" id="printlong" tabindex="1"\n' +
    '             placeholder="Ausgabe Langform">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="name">Name (vollständiger)</label>\n' +
    '      <input type="text" ng-model="vm.sv.name" class="form-control" id="name" tabindex="2"\n' +
    '             placeholder="Vorname">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="phone1">Telefon</label>\n' +
    '      <input type="text" ng-model="vm.sv.phone" class="form-control" id="phone1" tabindex="3"\n' +
    '             placeholder="Telefon">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="fax">Fax</label>\n' +
    '      <input type="text" ng-model="vm.sv.fax" class="form-control" id="fax" tabindex="4"\n' +
    '             placeholder="Fax">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <label for="email">E-Mail</label>\n' +
    '      <input type="text" ng-model="vm.sv.email" class="form-control" id="email" tabindex="5"\n' +
    '             placeholder="E-Mail">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <label for="address">Adresse</label>\n' +
    '      <input type="text" ng-model="vm.sv.address" class="form-control" id="address" tabindex="6"\n' +
    '             placeholder="Adresse">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <zipcode zip="vm.sv.postcode" city="vm.sv.city" ti="0" ti2="0" parentsave="vm.zipsave(zip, city)"></zipcode>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcutils/share/shareform-component.tpl.html',
    '<form class="form-vertical" id="editshareform" data-hook="editshareform">\n' +
    '    <div class="form-group">\n' +
    '      <label for="sharename">Name</label>\n' +
    '      <input type="text" ng-model="vm.share.name" class="form-control" id="sharename">\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="sharepath">Pfad</label>\n' +
    '      <input type="text" ng-model="vm.share.path" class="form-control" id="sharepath">\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="shareendpoint">API endpoint</label>\n' +
    '      <input type="text" ng-model="vm.share.endpoint" class="form-control" id="shareendpoint">\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="sharedesc">Beschreibung</label>\n' +
    '      <input type="text" ng-model="vm.share.desc" class="form-control" id="sharedesc">\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="sharetype">Sharetype</label>\n' +
    '      <select class="form-control" id="sharetype" ng-model="vm.share.sharetype">\n' +
    '        <option>scan</option>\n' +
    '        <option>gdt</option>\n' +
    '        <option>generic</option>\n' +
    '      </select>\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="mimetype">Filetyp</label>\n' +
    '      <select class="form-control" id="mimetype" ng-model="vm.share.filetype">\n' +
    '        <option>image/jpeg</option>\n' +
    '        <option>image/gif</option>\n' +
    '        <option>image/tiff</option>\n' +
    '        <option>application/pdf</option>\n' +
    '        <option>video/mpeg</option>\n' +
    '        <option>audio/mpeg3</option>\n' +
    '      </select>\n' +
    '    </div>\n' +
    '\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcutils/doctor/doctorform-component.tpl.html',
    '<form class="form-vertical" id="editdoctorform" data-hook="editdoctorform" autocomplete="noway">\n' +
    '  <!-- Name -->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-2">\n' +
    '      <label for="titlefront">Titel</label>\n' +
    '      <input type="text" ng-model="vm.doctor.titlefront" class="form-control" id="titlefront">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-4">\n' +
    '      <label for="firstname">Vorname <sprhelp tip="Sie können Arzt und/oder Institut ausfüllen"></sprhelp></label>\n' +
    '      <input type="text" ng-model="vm.doctor.firstname" class="form-control" id="firstname"\n' +
    '             placeholder="Vorname">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-4">\n' +
    '      <label for="lastname">Nachname <sprhelp tip="Sie können Arzt und/oder Institut ausfüllen"></sprhelp></label>\n' +
    '      <input type="text" ng-model="vm.doctor.lastname" class="form-control" id="lastname"\n' +
    '             placeholder="Nachname">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-2">\n' +
    '      <label for="titleback">Titel</label>\n' +
    '      <input type="text" ng-model="vm.doctor.titleback" class="form-control" id="titleback">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <!-- Institut -->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="institute">Institut <sprhelp tip="Sie können Arzt und/oder Institut ausfüllen"></sprhelp></label>\n' +
    '      <input type="text" ng-model="vm.doctor.institute" class="form-control" id="institute"\n' +
    '             placeholder="Nachname">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <!-- Fachgebiet -->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="speciality">Fachgebiet</label>\n' +
    '      <select id="speciality" ng-model="vm.doctor.speciality">\n' +
    '        <option value="Allgemeinmedizin">Allgemeinmedizin</option>\n' +
    '        <option value="Allergieambulatorium">Allergieambulatorium</option>\n' +
    '        <option value="Anästhesiologie und Intensivmedizin">Anästhesiologie und Intensivmedizin</option>\n' +
    '        <option value="Anatomie">Anatomie</option>\n' +
    '        <option value="Arbeitsmedizin">Arbeitsmedizin</option>\n' +
    '        <option value="Augenheilkunde und Optometrie">Augenheilkunde und Optometrie</option>\n' +
    '        <option value="Blutgruppenserologie und Transfusionsmedizin">Blutgruppenserologie und Transfusionsmedizin</option>\n' +
    '        <option value="Chirurgie">Chirurgie</option>\n' +
    '        <option value="Frauenheilkunde und Geburtshilfe">Frauenheilkunde und Geburtshilfe</option>\n' +
    '        <option value="Gerichtsmedizin">Gerichtsmedizin</option>\n' +
    '        <option value="Hals-, Nasen- und Ohrenkrankheiten">Hals-, Nasen- und Ohrenkrankheiten</option>\n' +
    '        <option value="Haut- und Geschlechtskrankheiten">Haut- und Geschlechtskrankheiten</option>\n' +
    '        <option value="Herzchirurgie">Herzchirurgie</option>\n' +
    '        <option value="Histologie und Embryologie">Histologie und Embryologie</option>\n' +
    '        <option value="Hygiene und Mikrobiologie">Hygiene und Mikrobiologie</option>\n' +
    '        <option value="Immunologie">Immunologie</option>\n' +
    '        <option value="Innere Medizin">Innere Medizin</option>\n' +
    '        <option value="Kinder- und Jugendchirurgie">Kinder- und Jugendchirurgie</option>\n' +
    '        <option value="Kinder- und Jugendheilkunde">Kinder- und Jugendheilkunde</option>\n' +
    '        <option value="Kinder- und Jugendpsychiatrie">Kinder- und Jugendpsychiatrie</option>\n' +
    '        <option value="Lungenkrankheiten">Lungenkrankheiten</option>\n' +
    '        <option value="Medizinische Biologie">Medizinische Biologie</option>\n' +
    '        <option value="Medizinische Biophysik">Medizinische Biophysik</option>\n' +
    '        <option value="Medizinische Genetik">Medizinische Genetik</option>\n' +
    '        <option value="Medizinische und Chemische Labordiagnostik">Medizinische und Chemische Labordiagnostik</option>\n' +
    '        <option value="Medizinische Leistungsphysiologie">Medizinische Leistungsphysiologie</option>\n' +
    '        <option value="Mikrobiologisch-Serologische Labordiagnostik">Mikrobiologisch-Serologische Labordiagnostik</option>\n' +
    '        <option value="Mund-, Kiefer- und Gesichtschirurgie">Mund-, Kiefer- und Gesichtschirurgie</option>\n' +
    '        <option value="Neurobiologie">Neurobiologie</option>\n' +
    '        <option value="Neurochirurgie">Neurochirurgie</option>\n' +
    '        <option value="Neurologie">Neurologie</option>\n' +
    '        <option value="Neurologie und Psychiatrie">Neurologie und Psychiatrie</option>\n' +
    '        <option value="Neuropathologie">Neuropathologie</option>\n' +
    '        <option value="Nuklearmedizin">Nuklearmedizin</option>\n' +
    '        <option value="Orthopädie und Orthopädische Chirurgie">Orthopädie und Orthopädische Chirurgie</option>\n' +
    '        <option value="Pathologie">Pathologie</option>\n' +
    '        <option value="Pathophysiologie">Pathophysiologie</option>\n' +
    '        <option value="Pharmakologie und Toxikologie">Pharmakologie und Toxikologie</option>\n' +
    '        <option value="Physikalische Medizin und Allgemeine Rehabilitation">Physikalische Medizin und Allgemeine Rehabilitation</option>\n' +
    '        <option value="Physiologie">Physiologie</option>\n' +
    '        <option value="Plastische, Ästhetische und Rekonstruktive Chirurgie">Plastische, Ästhetische und Rekonstruktive Chirurgie</option>\n' +
    '        <option value="Psychiatrie">Psychiatrie</option>\n' +
    '        <option value="Psychiatrie und Neurologie">Psychiatrie und Neurologie</option>\n' +
    '        <option value="Psychiatrie und Psychotherapeutische Medizin">Psychiatrie und Psychotherapeutische Medizin</option>\n' +
    '        <option value="Radiologie">Radiologie</option>\n' +
    '        <option value="Sozialmedizin">Sozialmedizin</option>\n' +
    '        <option value="Spezifische Prophylaxe und Tropenmedizin">Spezifische Prophylaxe und Tropenmedizin</option>\n' +
    '        <option value="Strahlentherapie-Radioonkologie">Strahlentherapie-Radioonkologie</option>\n' +
    '        <option value="Theoretische Sonderfächer">Theoretische Sonderfächer</option>\n' +
    '        <option value="Thoraxchirurgie">Thoraxchirurgie</option>\n' +
    '        <option value="Tumorbiologie">Tumorbiologie</option>\n' +
    '        <option value="Unfallchirurgie">Unfallchirurgie</option>\n' +
    '        <option value="Urologie">Urologie</option>\n' +
    '        <option value="Virologie">Virologie</option>\n' +
    '        <option value="Zahn-, Mund- und Kieferheilkunde">Zahn-, Mund- und Kieferheilkunde</option>\n' +
    '      </select>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  \n' +
    '  <!-- Tel, Fax, E-Mail-->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="phone1">Telefon 1</label>\n' +
    '      <input type="text" ng-model="vm.doctor.phone1" class="form-control" id="phone1" placeholder="Telefon">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="phone2">Telefon 2</label>\n' +
    '      <input type="text" ng-model="vm.doctor.phone2" class="form-control" id="phone2" placeholder="Telefon">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="fax">Fax</label>\n' +
    '      <input type="text" ng-model="vm.doctor.fax" class="form-control" id="fax" placeholder="Telefon">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-3">\n' +
    '      <label for="email">E-Mail</label>\n' +
    '      <input type="text" ng-model="vm.doctor.email" class="form-control" id="email" placeholder="E-Mail">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <!-- Adresse -->\n' +
    '  <div class=" row">\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <label for="address">Adresse</label>\n' +
    '      <input type="text" ng-model="vm.doctor.address" class="form-control" id="address"\n' +
    '             placeholder="Adresse">\n' +
    '    </div>\n' +
    '    <div class="form-group col-md-6">\n' +
    '      <zipcode zip="vm.doctor.postcode" city="vm.doctor.city" parentsave="vm.zipsave(zip, city)"></zipcode>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcuser/vcuser/userform-component.tpl.html',
    '<form class="form-vertical" id="editsafeform" data-hook="editsafeform">\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-md-6 col-xs-12">\n' +
    '            <label for="username">Username</label>\n' +
    '            <input type="text" id="username" ng-model="vm.user.username"\n' +
    '                   class="form-control"\n' +
    '                   placeholder="Username" required>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-6 form-group">\n' +
    '            <label for="password">Passwort</label>\n' +
    '            <input type="password" id="password" ng-model="vm.user.password" placeholder="Passwort" class="form-control"\n' +
    '                   required>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 form-group">\n' +
    '            <label for="role">Rolle</label>\n' +
    '            <select id="role" ng-model="vm.user.role" class="form-control">\n' +
    '                <option ng-repeat="role in vm.roles" value="{{role.role}}" >{{role.label}}</option>\n' +
    '            </select>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 form-group">\n' +
    '            <label for="realName">Vor- und Nachname</label>\n' +
    '            <input type="text" ng-model="vm.user.realName" id="realName" class="form-control"\n' +
    '                   placeholder="Vor- und Nachname">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 form-group">\n' +
    '            <label for="email">E-Mail</label>\n' +
    '            <input type="email" id="email" ng-model="vm.user.email"\n' +
    '                   placeholder="E-Mail" class="form-control">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 form-group">\n' +
    '            <label for="telnum">Telefonnummer</label>\n' +
    '            <input id="telnum" ng-model="vm.user.tel" type="tel" class="form-control" placeholder="Telefonnummer">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '<!--\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="roles">Typ</label>\n' +
    '            <select class="form-control" tabindex="0" ng-model="vm.user.roles" id="roles" multiple>\n' +
    '                <option>Admin</option>\n' +
    '                <option>Techniker</option>\n' +
    '                <option>Main-Mitarbeiter</option>\n' +
    '            </select>\n' +
    '        </div>\n' +
    '    </div>-->\n' +
    '\n' +
    '    <div class="row">\n' +
    '        <div class="col-xs-12 form-group">\n' +
    '            <label for="comment">Anmerkungen</label>\n' +
    '            <textarea ng-model="vm.user.comment" id="comment" class="form-control" placeholder="Anmerkungen"></textarea>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcuser/vclogin/loginform-component.tpl.html',
    '<div class="panel panel-default">\n' +
    '    <div class="panel-heading">\n' +
    '        <h3>Login</h3>\n' +
    '    </div>\n' +
    '    <div class="panel-body">\n' +
    '        <div class="alert alert-danger" ng-show="vm.error">Benutzername und/oder Passwort falsch!</div>\n' +
    '        <form class="form-vertical">\n' +
    '            <div class="form-group">\n' +
    '                <label for="username">Benutzername</label>\n' +
    '                <input type="text" class="form-control" name="username" id="username"\n' +
    '                       autocapitalize="off" autocorrect="off"  spellcheck="false"\n' +
    '                       ng-model="vm.login.username">\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '                <label for="password">Passwort</label>\n' +
    '                <input type="password" class="form-control" name="password" id="password"\n' +
    '                       autocapitalize="off" autocorrect="off" spellcheck="false"\n' +
    '                       ng-model="vm.login.password" ng-keydown="$event.keyCode === 13 && vm.sendcreds()">\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.sendcreds()">Login</button>\n' +
    '            </div>\n' +
    '        </form>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/unicat/unicatform-component.tpl.html',
    '<form class="form-vertical" id="editunicatform" data-hook="editunicatform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="xxx">xxx</label>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="yyy">xxx</label>\n' +
    '     \n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/unicat/unicateditor-component.tpl.html',
    '<uib-tabset active="active">\n' +
    '    <!-- Allgemeine Infos -->\n' +
    '    <uib-tab index="0" heading="Static title">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-3">\n' +
    '                <label>Nummer/ID</label>\n' +
    '                <input type="text" ng-model="vm.entry.sprnum" ng-blur="vm.save(vm.entry)" name="sprnum" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-9">\n' +
    '                <label>Bezeichnung</label>\n' +
    '                <input type="text" ng-model="vm.entry.name" ng-blur="vm.save(vm.entry)" name="name" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </uib-tab>\n' +
    '    <!-- KK spezifische Infos -->\n' +
    '    <uib-tab index="$index + 1" ng-repeat="sv in vm.entry.svs" heading="{{sv.svname}}">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-3">\n' +
    '                <label>KK Nummer/ID</label>\n' +
    '                <input type="text" ng-model="sv.num" ng-blur="vm.save(vm.entry)" name="sprnum" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-9">\n' +
    '                <label>Bezeichnung <span class="btn btn-primary btn-xs" uib-tooltip="Text aus Spr Katalog kopieren"\n' +
    '                                         ng-click="sv.text = vm.entry.name"><i class="fa fa-copy"></i> </span> </label>\n' +
    '                <input type="text" ng-model="sv.text" ng-blur="vm.save(vm.entry)" name="name" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '<!--        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Begründung erforderlich</label>\n' +
    '                <input type="text" ng-model="sv.reason" ng-blur="vm.save(vm.entry)" name="reason" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Erklärung/Erläuterung</label>\n' +
    '                <input type="text" ng-model="sv.explanation" ng-blur="vm.save(vm.entry)" name="explanation" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Ausführliche Erklärung</label>\n' +
    '                <textarea ng-model="sv.explantionext" ng-blur="vm.save(vm.entry)" name="explainext" class="form-control"></textarea>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Beschränkte Verrechenbarkeit nach Fachrichtung </label>\n' +
    '                <input type="text" ng-model="sv.doc" ng-blur="vm.save(vm.entry)" name="doc" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Limits</label>\n' +
    '                <input type="text" ng-model="sv.limit" ng-blur="vm.save(vm.entry)" name="limit" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Ausführliche Erklärung der Limits</label>\n' +
    '                <textarea ng-model="sv.limitext" ng-blur="vm.save(vm.entry)" name="limitext" class="form-control"></textarea>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <label>Punkte</label>\n' +
    '                <input type="text" ng-model="sv.points" ng-blur="vm.save(vm.entry)" name="points" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <label>Preis</label>\n' +
    '                <input type="text" ng-model="sv.price" ng-blur="vm.save(vm.entry)" name="price" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <label>Regiezuschlag</label>\n' +
    '                <input type="text" ng-model="sv.regie" ng-blur="vm.save(vm.entry)" name="regie" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Materialzuschlag</label>\n' +
    '                <input type="text" ng-model="sv.material" ng-blur="vm.save(vm.entry)" name="material" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Ausführliche Erklärung der Meterialzuschläge</label>\n' +
    '                <textarea ng-model="sv.materialext" ng-blur="vm.save(vm.entry)" name="materialext" class="form-control"></textarea>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-3">\n' +
    '                <label>Nicht zusammen mit</label>\n' +
    '                <input type="text" ng-model="sv.exclude" ng-blur="vm.save(vm.entry)" name="exclude" class="form-control">\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-9">\n' +
    '                <label>Nur zusammen mit</label>\n' +
    '                <input type="text" ng-model="sv.onlywith" ng-blur="vm.save(vm.entry)" name="onlywith" class="form-control">\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-12">\n' +
    '                <label>Ausführliche Erklärung der Ausschließungsgründe</label>\n' +
    '                <textarea ng-model="sv.excludext" ng-blur="vm.save(vm.entry)" name="excludext" class="form-control"></textarea>\n' +
    '            </div>\n' +
    '        </div>-->\n' +
    '\n' +
    '    </uib-tab>\n' +
    '\n' +
    '</uib-tabset>\n' +
    '\n' +
    '\n' +
    '<!--<div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n' +
    '    <h3><i class="fa fa-check"></i> unicat erfolgreich gespeichert!</h3>\n' +
    '</div>\n' +
    '<div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n' +
    '    <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen unicat wurde abgebrochen!</h3>\n' +
    '</div>\n' +
    '<div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n' +
    '    <h3>\n' +
    '        <i class="fa fa-warning"></i> unicat konnte nicht gespeichert werden,\n' +
    '        der Fehler wurde protokolliert!\n' +
    '    </h3>\n' +
    '</div>\n' +
    '-->');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/turnover/turnover-component.tpl.html',
    '<h2>Umsätze</h2>\n' +
    '\n' +
    '<!-- Menü / Nav pills -->\n' +
    '<div class="btn-group spacer-top spacer-bottom" style="align-content: center;">\n' +
    '  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="\'summary\'">Überblick</label>\n' +
    '  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="\'cash\'">Bar-Umsätze</label>\n' +
    '  <label class="btn btn-primary" ng-model="vm.view" uib-btn-radio="\'check\'">Umsatz auf Rechnung</label>\n' +
    '</div>\n' +
    '\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '<!-- Summary view -->\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '\n' +
    '<div ng-show="vm.view === \'summary\'">\n' +
    '  \n' +
    '  <h3>Gesamtumsatz</h3>\n' +
    '  \n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th>Zeitraum</th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos, exkl. offene Beträge">Netto verfügbar</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Noch nicht beglichene Rechnungen">Offen</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>\n' +
    '    \n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Heute</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total\n' +
    '        - vm.thisyear.todaycashstats.tax - vm.thisyear.todaycheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total\n' +
    '        - vm.thisyear.todaycashstats.tax - vm.thisyear.todaycheckstats.tax\n' +
    '        - vm.thisyear.todaycheckstats.open\n' +
    '        | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.total + vm.thisyear.todaycheckstats.total | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.tax + vm.thisyear.todaycheckstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.storno + vm.thisyear.todaycheckstats.storno | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Diese Woche</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total\n' +
    '        - vm.thisyear.weekcashstats.tax - vm.thisyear.weekcheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total\n' +
    '        - vm.thisyear.weekcashstats.tax - vm.thisyear.weekcheckstats.tax\n' +
    '        - vm.thisyear.weekcheckstats.open\n' +
    '        | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.total + vm.thisyear.weekcheckstats.total | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.tax + vm.thisyear.weekcheckstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.storno + vm.thisyear.weekcheckstats.storno | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Monat</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total\n' +
    '        - vm.thisyear.monthcashstats.tax - vm.thisyear.monthcheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total\n' +
    '        - vm.thisyear.monthcashstats.tax - vm.thisyear.monthcheckstats.tax\n' +
    '        - vm.thisyear.monthcheckstats.open\n' +
    '        | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.total + vm.thisyear.monthcheckstats.total | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.tax + vm.thisyear.monthcheckstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.storno + vm.thisyear.monthcheckstats.storno | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Quartal</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total\n' +
    '        - vm.thisyear.quartercashstats.tax - vm.thisyear.quartercheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total\n' +
    '        - vm.thisyear.quartercashstats.tax - vm.thisyear.quartercheckstats.tax\n' +
    '        - vm.thisyear.quartercheckstats.open\n' +
    '        | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.total + vm.thisyear.quartercheckstats.total | currency : \'\'\n' +
    '        : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.tax + vm.thisyear.quartercheckstats.tax | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.storno + vm.thisyear.quartercheckstats.storno | currency :\n' +
    '        \'\' : 2}} €\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Jahr</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total\n' +
    '        - vm.thisyear.yearcashstats.tax - vm.thisyear.yearcheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total\n' +
    '        - vm.thisyear.yearcashstats.tax - vm.thisyear.yearcheckstats.tax\n' +
    '        - vm.thisyear.yearcheckstats.open\n' +
    '        | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.total + vm.thisyear.yearcheckstats.total | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.tax + vm.thisyear.yearcheckstats.tax | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.storno + vm.thisyear.yearcheckstats.storno | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  \n' +
    '  \n' +
    '  <h3>Barumsätze</h3>\n' +
    '  \n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th>Zeitraum</th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Umsätze durch Bargeld">Bargeld</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Umsätze durch Bankomat oder Kreditkarten">Karte</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>\n' +
    '      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Heute</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.total - vm.thisyear.todaycashstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycashstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">\n' +
    '        <span class="text-success">{{vm.thisyear.todaycashstats.totalcount - vm.thisyear.todaycashstats.stornocount}}</span>/\n' +
    '        <span class="text-danger">{{vm.thisyear.todaycashstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.todaycashstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.todaycashstats.stddev | currency\n' +
    '        : \'\' : 2}} €) </span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Diese Woche</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.total - vm.thisyear.weekcashstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcashstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">\n' +
    '        <span class="text-success">{{vm.thisyear.weekcashstats.totalcount - vm.thisyear.weekcashstats.stornocount}}</span>/\n' +
    '        <span class="text-danger">{{vm.thisyear.weekcashstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.weekcashstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.weekcashstats.stddev | currency\n' +
    '        : \'\' : 2}} €) </span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Monat</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.total - vm.thisyear.monthcashstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcashstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">\n' +
    '        <span class="text-success">{{vm.thisyear.monthcashstats.totalcount - vm.thisyear.monthcashstats.stornocount}}</span>/\n' +
    '        <span class="text-danger">{{vm.thisyear.monthcashstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.monthcashstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.monthcashstats.stddev | currency\n' +
    '        : \'\' : 2}} €) </span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Quartal</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.total - vm.thisyear.quartercashstats.tax | currency : \'\' :\n' +
    '        2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercashstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">\n' +
    '        <span class="text-success">{{vm.thisyear.quartercashstats.totalcount - vm.thisyear.quartercashstats.stornocount}}</span>/\n' +
    '        <span class="text-danger">{{vm.thisyear.quartercashstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.quartercashstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.quartercashstats.stddev |\n' +
    '        currency : \'\' : 2}} €) </span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Jahr</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.total - vm.thisyear.yearcashstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcashstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">\n' +
    '        <span class="text-success">{{vm.thisyear.yearcashstats.totalcount - vm.thisyear.yearcashstats.stornocount}}</span>/\n' +
    '        <span class="text-danger">{{vm.thisyear.yearcashstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.yearcashstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.yearcashstats.stddev | currency :\n' +
    '        \'\' : 2}} €) </span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  \n' +
    '  \n' +
    '  <h3>Umsatz auf Rechnung</h3>\n' +
    '  \n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th>Zeitraum</th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos, inkl. offene Beträge">Gesamt Netto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos, exkl. offene Beträge">Netto verfügbar</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="abzgl. Stornos">Gesamt Brutto</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Bereits beglichene Rechnungen">Bezahlt</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Noch nicht beglichene Rechnungen">Offen</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summiert über alle Umsatzsteuersätze">USt.</span></th>\n' +
    '      <th class="nrr"><span uib-tooltip="Summe stornierter Einzelrechnungen">Storno</span></th>\n' +
    '      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Heute</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.total - vm.thisyear.todaycheckstats.tax -\n' +
    '        vm.thisyear.todaycheckstats.storno| currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.total - vm.thisyear.todaycheckstats.tax -\n' +
    '        vm.thisyear.todaycheckstats.open | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.total| currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.todaycheckstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">\n' +
    '        <span class="text-success">{{vm.thisyear.todaycheckstats.totalcount - vm.thisyear.todaycheckstats.stornocount}}</span>/<span\n' +
    '          class="text-danger">{{vm.thisyear.todaycheckstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.todaycheckstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.todaycheckstats.stddev |\n' +
    '        currency : \'\' : 2}} €)</span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Diese Woche</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.total - vm.thisyear.weekcheckstats.tax -\n' +
    '        vm.thisyear.weekcheckstats.storno| currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.total - vm.thisyear.weekcheckstats.tax -\n' +
    '        vm.thisyear.weekcheckstats.open | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.total| currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.weekcheckstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">\n' +
    '        <span class="text-success">{{vm.thisyear.weekcheckstats.totalcount - vm.thisyear.weekcheckstats.stornocount}}</span>/<span\n' +
    '          class="text-danger">{{vm.thisyear.weekcheckstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.weekcheckstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.weekcheckstats.stddev |\n' +
    '        currency : \'\' : 2}} €)</span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Monat</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.total - vm.thisyear.monthcheckstats.tax -\n' +
    '        vm.thisyear.monthcheckstats.storno| currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.total - vm.thisyear.monthcheckstats.tax -\n' +
    '        vm.thisyear.monthcheckstats.open | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.total| currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.monthcheckstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">\n' +
    '        <span class="text-success">{{vm.thisyear.monthcheckstats.totalcount - vm.thisyear.monthcheckstats.stornocount}}</span>/<span\n' +
    '          class="text-danger">{{vm.thisyear.monthcheckstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.monthcheckstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.monthcheckstats.stddev |\n' +
    '        currency : \'\' : 2}} €)</span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Quartal</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.total - vm.thisyear.quartercheckstats.tax | currency : \'\'\n' +
    '        : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.total - vm.thisyear.quartercheckstats.tax -\n' +
    '        vm.thisyear.quartercheckstats.open | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.total| currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.quartercheckstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">\n' +
    '        <span class="text-success">{{vm.thisyear.quartercheckstats.totalcount - vm.thisyear.quartercheckstats.stornocount}}</span>/<span\n' +
    '          class="text-danger">{{vm.thisyear.quartercheckstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.quartercheckstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.quartercheckstats.stddev |\n' +
    '        currency : \'\' : 2}} €)</span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '    <tr>\n' +
    '      <td>Dieses Jahr</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.total - vm.thisyear.yearcheckstats.tax | currency : \'\' : 2}}\n' +
    '        €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.total - vm.thisyear.yearcheckstats.tax -\n' +
    '        vm.thisyear.yearcheckstats.open | currency : \'\' : 2}} €\n' +
    '      </td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.total| currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{vm.thisyear.yearcheckstats.storno | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">\n' +
    '        <span class="text-success">{{vm.thisyear.yearcheckstats.totalcount - vm.thisyear.yearcheckstats.stornocount}}</span>/<span\n' +
    '          class="text-danger">{{vm.thisyear.yearcheckstats.stornocount}}</span>,\n' +
    '        {{vm.thisyear.yearcheckstats.avg | currency : \'\' : 2}} € ({{vm.thisyear.yearcheckstats.stddev | currency\n' +
    '        : \'\' : 2}} €)</span>,\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '<!-- Cash View -->\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '<div ng-show="vm.view === \'cash\'">\n' +
    '  <h3>Barumsätze</h3>\n' +
    '  \n' +
    '  <!-- per year -->\n' +
    '  <h4>Jahresübersicht</h4>\n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th class="nrr">Jahr</th>\n' +
    '      <th class="nrr">Gesamt</th>\n' +
    '      <th class="nrr">Bar</th>\n' +
    '      <th class="nrr">Karte</th>\n' +
    '      <th class="nrr">Ust.</th>\n' +
    '      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>\n' +
    '    </tr>\n' +
    '    <tr ng-repeat="line in vm.yearlycashstats">\n' +
    '      <td class="nrr">{{ line._id.year}}</td>\n' +
    '      <td class="nrr">{{ line.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">\n' +
    '        <span class="text-success" ng-bind="line.invcount"></span>/\n' +
    '        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;\n' +
    '        <span class="text-primary">{{ line.avg | currency : \'\' : 2}} €</span>&nbsp;\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  <!-- per month -->\n' +
    '  <h4>Monatsübersicht</h4>\n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th class="nrr">Monat</th>\n' +
    '      <th class="nrr">Gesamt</th>\n' +
    '      <th class="nrr">Bar</th>\n' +
    '      <th class="nrr">Karte</th>\n' +
    '      <th class="nrr">Ust.</th>\n' +
    '      <th class="nrr" uib-tooltip="Rechnung/Storno, Durchschnitt (+- Standardabweichung)">Statistik</th>\n' +
    '    </tr>\n' +
    '    <tr ng-repeat="line in vm.monthlycashstats">\n' +
    '      <td class="nrr">{{ line._id.month}}/{{ line._id.year}}</td>\n' +
    '      <td class="nrr">{{ line.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.cash | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.card | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">\n' +
    '        <span class="text-success" ng-bind="line.invcount"></span>/\n' +
    '        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;\n' +
    '        <span class="text-primary">{{ line.avg | currency : \'\' : 2}} €</span>&nbsp;\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  \n' +
    '</div>\n' +
    '\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '<!-- Check View -->\n' +
    '<!-- --------------------------------------------------------------------------------------------------------------- -->\n' +
    '<div ng-show="vm.view === \'check\'">\n' +
    '  <h3>Umsatz auf Rechnung</h3>\n' +
    '  \n' +
    '  \n' +
    '  <!-- per year -->\n' +
    '  <h4>Jahresübersicht</h4>\n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th class="nrr">Jahr</th>\n' +
    '      <th class="nrr">Gesamt</th>\n' +
    '      <th class="nrr">Ust.</th>\n' +
    '      <th class="nrr">Bezahlt</th>\n' +
    '      <th class="nrr">Offen</th>\n' +
    '      <th class="nrr">Stats</th>\n' +
    '    </tr>\n' +
    '    <tr ng-repeat="line in vm.yearlycheckstats">\n' +
    '      <td class="nrr">{{ line._id.year}}</td>\n' +
    '      <td class="nrr">{{ line.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">\n' +
    '        <span class="text-success" ng-bind="line.invcount"></span>/\n' +
    '        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;\n' +
    '        <span class="text-primary">{{ line.avg | currency : \'\' : 2}} €</span>&nbsp;\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  \n' +
    '  <!-- per month -->\n' +
    '  <h4>Monatsübersicht</h4>\n' +
    '  <table class="table table-striped">\n' +
    '    <tr>\n' +
    '      <th class="nrr">Monat</th>\n' +
    '      <th class="nrr">Gesamt</th>\n' +
    '      <th class="nrr">Ust.</th>\n' +
    '      <th class="nrr">Bezahlt</th>\n' +
    '      <th class="nrr">Offen</th>\n' +
    '      <th class="nrr">Stats</th>\n' +
    '    </tr>\n' +
    '    <tr ng-repeat="line in vm.monthlycheckstats">\n' +
    '      <td class="nrr">{{ line._id.month}}/{{ line._id.year}}</td>\n' +
    '      <td class="nrr">{{ line.total | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.tax | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.paid | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr">{{ line.open | currency : \'\' : 2}} €</td>\n' +
    '      <td class="nrr" uib-tooltip="Gesamtzahl/Stornozahl, Durchschnittl. Rechnungshöhe">\n' +
    '        <span class="text-success" ng-bind="line.invcount"></span>/\n' +
    '        <span class="text-danger" ng-bind="line.stornocount"></span>&nbsp;\n' +
    '        <span class="text-primary">{{ line.avg | currency : \'\' : 2}} €</span>&nbsp;\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/rksv/deplist-component.tpl.html',
    '<h3>Datenerfassungsprotokoll (DEP)</h3>\n' +
    '\n' +
    '<table class="table table-striped">\n' +
    '  <tr>\n' +
    '    <th>Datum</th>\n' +
    '    <th>BelegNr.</th>\n' +
    '    <th>Typ</th>\n' +
    '    <th>Signiert</th>\n' +
    '    <th>PDF</th>\n' +
    '  </tr>\n' +
    '  <tr ng-repeat="entry in vm.dep">\n' +
    '    <td>{{entry.created | datetime}}</td>\n' +
    '    <td ng-bind="entry.receiptnr"></td>\n' +
    '    <td ng-bind="entry.type"></td>\n' +
    '    <td><input type="checkbox" ng-model="entry.signatureok" disabled></td>\n' +
    '    <td><a href="/routes/pdfreader/{{entry.pdfid}}" target="_blank"><i class="fa fa-file-pdf-o"></i></a></td>\n' +
    '  </tr>\n' +
    '  \n' +
    '</table>\n' +
    '\n' +
    '<uib-pagination total-items="vm.totalItems"\n' +
    '                items-per-page="20"\n' +
    '                max-size="10"\n' +
    '                first-text="Erste"\n' +
    '                last-text="Letzte"\n' +
    '                next-text="N&auml;chste"\n' +
    '                previous-text="Vorige"\n' +
    '                boundary-links="true"\n' +
    '                rotate="false"\n' +
    '                ng-model="vm.currentPage"\n' +
    '                ng-change="vm.pageChanged()"></uib-pagination>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/rksv/depexport-component.tpl.html',
    '<h3>Registrierkassen DEP Datenexport (Datenerfassungsprotokoll)</h3>\n' +
    '\n' +
    '<div class="alert alert-info">\n' +
    '  <h3>Anleitung</h3>\n' +
    '  <p>Diese Routine exportiert das Registrierkassen Datenerfassungsprotokoll gemäß RKSV17.\n' +
    '    Da diese Registrierkasse Klasse III als Teil einer integrierten Branchenlösung ausschließlich Belege für Rechnungen erzeugt,\n' +
    '    sind diese Daten möglicherweise nicht ausreichend. Bitte Rücksprache halten und ggf. den\n' +
    '    <a ui-sref="finance.bmfexport">Finanzamtsexport</a> anwenden, der mehr Daten beinhaltet.</p>\n' +
    '  <p>Daten können beginnend mit 1.1.2017, für das aktuelle Jahr oder einen beliebigen Zeitraum exportiert werden.</p>\n' +
    '  <p>Das Ergebnis des Exports ist eine Datei namens <tt>depexport.json</tt>. Diese Datei muss lokal gespeichert und auf\n' +
    '    einen Memorystick kopiert werden. Der Memorystick wird an die Finanz übergeben.\n' +
    '    Nach Rücksprache mit dem Finanzbeamten kann die Datei eventuell auch per E-Mail übermittelt werden.</p>\n' +
    '</div>\n' +
    '\n' +
    '<a ng-click="vm.thisyear()" class="btn btn-success" >Dieses Jahr</a>\n' +
    '<a ng-click="vm.allyears()" class="btn btn-success" >Seit 1.1.2017</a>\n' +
    '\n' +
    '<form class="form-vertical">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="startdate">Von</label>\n' +
    '\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.startdate"\n' +
    '               is-open="start.opened" ng-required="true" id="startdate" name="startdate"\n' +
    '               clear-text="Löschen" close-text="Schließen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="start.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="enddate">Bis</label>\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.enddate"\n' +
    '               is-open="end.opened" ng-required="true" id="enddate" name="enddate"\n' +
    '               close-text="Schließen" clear-text="Löschen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="end.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <button class="btn btn-success" ng-click="vm.exportDEP()"><i class="fa fa-download"></i> Exportieren</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/privcat/privcatgroupform-component.tpl.html',
    '<form class="form-vertical" id="editprivgroupform" data-hook="editprivcatgroupform">\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-3">\n' +
    '            <label for="grpshortcut">Kürzel</label>\n' +
    '            <input class="form-control" type="text" required ng-model="vm.privcatgroup.shortcut" id="grpshortcut">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-9">\n' +
    '            <label for="grpname">Bezeichnung der Leistungsgruppe</label>\n' +
    '            <input class="form-control" type="text" required ng-model="vm.privcatgroup.name" id="grpname">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-12">\n' +
    '            <label for="grpname">Privatleistung hinzufügen</label>\n' +
    '            <div class="input-group">\n' +
    '                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n' +
    '                       ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n' +
    '                       autofocus\n' +
    '                       placeholder="Kürzel oder Bezeichnung der Privatleistung"\n' +
    '                       ng-model="vm.asyncSelected"\n' +
    '                       typeahead-on-select="vm.addPrivcat($item, $model, $label)"\n' +
    '                       uib-typeahead="privcat as privcat.text for privcat in vm.getPrivcats($viewValue)"\n' +
    '                       typeahead-loading="loadingNames"\n' +
    '                       typeahead-no-results="noResults">\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button type="submit" ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n' +
    '                            class="btn" tabindex="-1">\n' +
    '                        <i class="fa fa-search"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '            <div><i ng-show="loadingNames" class="fa fa-refresh"></i></div>\n' +
    '            <div ng-show="noResults">\n' +
    '                <i class="fa fa-warning"></i> Keine passenden Privatleistungen gefunden\n' +
    '                <!--<span class="btn btn-success" ng-click="vm.addPrivcat()"\n' +
    '                      ng-hide="vm.error">Neue Privatleistung eingeben</span>-->\n' +
    '                <!--<span ng-click="vm.addPrivcatEntry()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Privatleistung konnte nicht angelegt werden!</span>-->\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <label for="grpname">Enthaltene Leistungen</label>\n' +
    '            <div class="alert alert-info" ng-hide="vm.privcatgroup.items.length > 0">\n' +
    '                <i class="fa fa-info-circle"></i> Diese Gruppe enthält derzeit keine Leistungen!\n' +
    '            </div>\n' +
    '            <ul>\n' +
    '                <li ng-repeat="entry in vm.privcatgroup.items" style="padding: 3px">\n' +
    '                    <span class="pull-left">{{entry.shortcut}} - {{entry.name}}</span>\n' +
    '                    <span class="pull-right">\n' +
    '                        <span class="btn btn-danger btn-xs" uib-tooltip="Leistung aus Gruppe entfernen" ng-click="vm.removeEntry($index)">\n' +
    '                            <i class="fa fa-remove"></i>\n' +
    '                        </span>\n' +
    '                    </span>\n' +
    '                </li>\n' +
    '            </ul>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/privcat/privcatentryform-component.tpl.html',
    '\n' +
    '<form class="form-vertical" id="editprivcatform" data-hook="editprivcatform">\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-3">\n' +
    '            <label for="serviceshortcut">Kürzel</label>\n' +
    '            <input class="form-control" type="text" required ng-model="vm.privcatentry.shortcut" id="serviceshortcut">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-9">\n' +
    '            <label for="servicename">Bezeichnung der Privatleistungs</label>\n' +
    '            <input class="form-control" type="text" required ng-model="vm.privcatentry.name" id="servicename">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-12">\n' +
    '            <label for="servicedetails">Details</label>\n' +
    '            <textarea class="form-control"\n' +
    '                      ng-model="vm.privcatentry.details" id="servicedetails"></textarea>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-6 col-md-3">\n' +
    '            <label for="serviceprice">Preis</label>\n' +
    '            <input class="form-control" type="number" required\n' +
    '                   ng-change="vm.normPrice()"\n' +
    '                   ng-model="vm.privcatentry.price" id="serviceprice"\n' +
    '                   style="text-align: right"\n' +
    '\n' +
    '                   step="0.01" min="0" max="100000">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-6 col-md-3">\n' +
    '            <label for="servicetax">Steuersatz (%)</label>\n' +
    '            <input class="form-control" type="number" required ng-model="vm.privcatentry.tax" id="servicetax"\n' +
    '                   style="text-align: right"\n' +
    '                   step="1" min="0" max="100">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-6">\n' +
    '            <label for="servicerepeat">Wiederholbarkeit<sprhelp tip="Es können mehrere Einheiten dieser\n' +
    '                   Position auf einer Rechnung vorkommen"></sprhelp></label>\n' +
    '            <div style="padding-bottom: 6px; padding-top: 6px;"><input type="checkbox"  ng-model="vm.privcatentry.repeatable"  id="servicerepeat"\n' +
    '        >&nbsp;Position is wiederholbar</div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bva">BVA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bva" id="bva">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="sva">SVA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.sva" id="sva">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="vaeb">VAEB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.vaeb" id="vaeb">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="wgkk">WGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.wgkk" id="wgkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="noegkk">NöGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.noegkk" id="noegkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bgkk">BGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="bgkk">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="ooegkk">OÖGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.ooegkk" id="ooegkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="sgkk">SGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.sgkk" id="sgkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="stgkk">STGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.stgkk" id="stgkk">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kgkk">KGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kgkk" id="kgkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="tgkk">TGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.tgkk" id="tgkk">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="vgkk">VGKK Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.vgkk" id="vgkk">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="svb">SVB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.svb" id="svb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bkk-va">BKK-VA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkva" id="bkk-va">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bkkmondi">BKKMondi Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="bkkmondi">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bkkwvb">BKK-WVB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkwvb" id="bkkwvb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bkkzw">BKK-ZW Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkzw" id="bkkzw">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="bkkka">BKK-KA Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bkkka" id="bkkka">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfawien">KFA-Wien Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.wgkk" id="kfawien">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfabaden">KFA-Baden Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfabaden" id="kfabaden">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfalinz">KFA-Linz Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.bgkk" id="kfalinz">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfaooegb">KFA-OÖ-GemB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfaooegb" id="kfaooegb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfaooelb">KFA-OÖ-LandB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfaooelb" id="kfaooelb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="ooelku">OÖLehrerKUF Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.ooelku" id="ooelku">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfasteyr">KFA-Steyr Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfasteyr" id="kfasteyr">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfawels">KFA-Wels Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfawels" id="kfawels">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfagraz">KFA-Graz Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfagraz" id="kfagraz">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '     <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfavillach">KFA-Villach Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfavillach" id="kfavillach">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfasalzburg">KFA-Salzburg Codes(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfasalzburg" id="kfasalzburg">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kuftlehrer">KUF-Tirol-Lehrer Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kuftlehrer" id="kuftlehrer">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kuftlb">KUF-Tirol-LandB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kuftlb" id="kuftlb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kufttgb">KUF-Tirol-GemB Code(s)<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kufttgb" id="kufttgb">\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-4">\n' +
    '            <label for="kfehallein">KFE-Hallein<sprhelp tip="Sie können mehrere Kassencodes eintragen"></sprhelp></label>\n' +
    '            <input class="form-control" type="text"  ng-model="vm.privcatentry.svs.kfehallein" id="kfehallein">\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">\n' +
    '                    Speichern\n' +
    '                </button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">\n' +
    '                    Abbrechen\n' +
    '                </button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/invoice/invoicebrowser-directive.tpl.html',
    '<h2>Rechnungen</h2>\n' +
    '<!-- Nav tabs -->\n' +
    '<ul class="nav nav-tabs hidden-xs hidden-sm" role="tablist" style="padding-top: 1ex;">\n' +
    '  <li ui-sref="finance.invoices.cashinv" ui-sref-active="active"><a>Barrechnungen</a></li>\n' +
    '  <li ui-sref="finance.invoices.checkinv" ui-sref-active="active"><a>Zielrechnungen</a></li>\n' +
    '  <li ui-sref="finance.invoices.checkpaid" ui-sref-active="active"><a>Bezahlt</a></li>\n' +
    '  <li ui-sref="finance.invoices.checkopen" ui-sref-active="active"><a>Offenen</a></li>\n' +
    '  <li ui-sref="finance.invoices.checkoverdue" ui-sref-active="active"><a>Überfällige</a></li>\n' +
    '</ul>\n' +
    '<!--view for invoice details-->\n' +
    '<div ui-view="invoicedetails"></div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/invoice/invoiceDateTpl.html',
    '<div style="text-align: center">\n' +
    '  <uib-datepicker ng-model="miCtrl.paiddate" class="well well-sm" datepicker-options="miCtrl.dateoptions"></uib-datepicker>\n' +
    '  \n' +
    '  <div  style="margin-bottom: 1em">Zahlung am: {{miCtrl.paiddate | date : \'dd.MM.yyyy\'}}</div>\n' +
    '  <!--<div  style="margin-bottom: 1em">max Date: {{miCtrl.dateoptions.maxDate | date : \'dd.MM.yyyy\'}}</div>-->\n' +
    '  \n' +
    '  <div style="margin-bottom: 1em"><span class="btn btn-primary" ng-click="miCtrl.setDate(miCtrl.invoice)" data-ng-disabled="!miCtrl.paiddate">\n' +
    '          Zahlung registrieren</span>&nbsp;<span class="btn btn-danger" ng-click="miCtrl.dialog.close()">Schliessen</span>\n' +
    '        </div>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/invoice/checkinvoice-component.tpl.html',
    '\n' +
    '<h3 ng-bind="vm.title"></h3>\n' +
    '\n' +
    '\n' +
    '<div class="alert alert-info" ng-show="vm.checkinvoices.length === 0">\n' +
    '  <h4>Keine Zielrechnungen mit diesen Merkmalen gefunden</h4>\n' +
    '</div>\n' +
    '\n' +
    '<table class="table table-striped"\n' +
    '       ng-hide="vm.checkinvoices.length === 0">\n' +
    '  <tr>\n' +
    '    <th>RNr</th>\n' +
    '    <th>Datum</th>\n' +
    '    <th>Patient</th>\n' +
    '    <th align="right">Brutto</th>\n' +
    '    <th align="right">Steuer</th>\n' +
    '    <th align="center">PDF</th>\n' +
    '    <th align="center">Beleg</th>\n' +
    '    <th align="center">Aktion</th>\n' +
    '  </tr>\n' +
    '  <tr ng-repeat="inv in vm.checkinvoices"  ng-class="{testinv: inv.test}">\n' +
    '    <td ng-bind="inv.invoicenr">inv.invoicenr</td>\n' +
    '    <td ng-bind="inv.fdate"></td>\n' +
    '    <td><a ui-sref="patientrecord.history({clientid: inv.patientid})"   ng-class="{testinv: inv.test}">{{inv.patientid}}</a></td>\n' +
    '    <td align="right">{{inv.total | currency : \'€\' : 2 }}</td>\n' +
    '    <td align="right">{{inv.tax | currency : \'€\' : 2 }}</td>\n' +
    '    <td align="center">\n' +
    '      <a href="/routes/pdfreader/{{inv.doctorinvoiceid}}" target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-primary"></i>\n' +
    '      </a>\n' +
    '    </td>\n' +
    '    <td align="center">\n' +
    '      <a href="/routes/pdfreader/{{inv.receiptid}}" target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-success"></i></a>\n' +
    '      <a href="/routes/pdfreader/{{inv.stornoreceiptid}}"\n' +
    '         ng-show="inv.stornoreceiptid"\n' +
    '         target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-danger"></i></a>\n' +
    '    </td>\n' +
    '    <td align="center">\n' +
    '      <span ng-show="inv.paid">\n' +
    '        {{inv.paid | bezahlt }}, {{inv.fpaiddate}}\n' +
    '      </span>\n' +
    '      <span class="btn btn-primary btn-sm" ng-hide="inv.paid || inv.storno"\n' +
    '            ng-click="vm.enterPaidDate(inv)"\n' +
    '            uib-tooltip="Zahlungseingang registrieren">Zahlung eintragen</span>\n' +
    '      <span ng-hide="inv.storno || inv.paid" class="btn btn-danger btn-sm" ng-click="vm.storno(inv)">Stornieren</span>\n' +
    '      <span ng-show="inv.storno === true && inv.test === true">test, </span>\n' +
    '      <span ng-show="inv.storno === true">storniert</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '</table>\n' +
    '<uib-pagination total-items="vm.totalItems"\n' +
    '                items-per-page="20"\n' +
    '                max-size="10"\n' +
    '                first-text="Erste"\n' +
    '                last-text="Letzte"\n' +
    '                next-text="N&auml;chste"\n' +
    '                previous-text="Vorige"\n' +
    '                boundary-links="true"\n' +
    '                rotate="false"\n' +
    '                ng-model="vm.currentPage"\n' +
    '                ng-change="vm.pageChanged()"></uib-pagination>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/invoice/cashinvoice-component.tpl.html',
    '\n' +
    '<h3 ng-bind="vm.title"></h3>\n' +
    '\n' +
    '<div class="alert alert-info" ng-show="vm.cashinvoices.length === 0">\n' +
    '  <h4>Keine Barrechnungen mit diesen Merkmalen gefunden</h4>\n' +
    '</div>\n' +
    '\n' +
    '<table class="table table-striped"\n' +
    '       ng-hide="vm.cashinvoices.length === 0">\n' +
    '  <tr>\n' +
    '    <th>RNr</th>\n' +
    '    <th>Datum</th>\n' +
    '    <th>Patient</th>\n' +
    '    <th align="right">Brutto</th>\n' +
    '    <th align="right">Steuer</th>\n' +
    '    <th align="center">PDF</th>\n' +
    '    <th align="center">Beleg</th>\n' +
    '    <th align="center">Aktion</th>\n' +
    '  </tr>\n' +
    '  <tr ng-repeat="inv in vm.cashinvoices"  ng-class="{testinv: inv.test}">\n' +
    '    <td ng-bind="inv.invoicenr">inv.invoicenr</td>\n' +
    '    <td ng-bind="inv.fdate"></td>\n' +
    '    <td><a ui-sref="patientrecord.history({clientid: inv.patientid})"   ng-class="{testinv: inv.test}">{{inv.patientid}}</a></td>\n' +
    '    <td align="right">{{inv.total | currency : \'€\' : 2 }}</td>\n' +
    '    <td align="right">{{inv.tax | currency : \'€\' : 2 }}</td>\n' +
    '    <td align="center">\n' +
    '      <a href="/routes/pdfreader/{{inv.doctorinvoiceid}}" target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-primary"></i>\n' +
    '      </a>\n' +
    '    </td>\n' +
    '    <td align="center">\n' +
    '      <a href="/routes/pdfreader/{{inv.receiptid}}" target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-success"></i></a>\n' +
    '      <a href="/routes/pdfreader/{{inv.stornoreceiptid}}"\n' +
    '         ng-show="inv.stornoreceiptid"\n' +
    '         target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o text-danger"></i></a>\n' +
    '    </td>\n' +
    '    <td align="center">\n' +
    '      <span ng-hide="inv.storno === true" class="btn btn-danger" ng-click="vm.storno(inv)">Stornieren</span>\n' +
    '      <span ng-show="inv.storno === true && inv.test === true">test, </span>\n' +
    '      <span ng-show="inv.storno === true">storniert</span>\n' +
    '    </td>\n' +
    '  </tr>\n' +
    '</table>\n' +
    '<uib-pagination total-items="vm.totalItems"\n' +
    '                items-per-page="20"\n' +
    '                max-size="10"\n' +
    '                first-text="Erste"\n' +
    '                last-text="Letzte"\n' +
    '                next-text="N&auml;chste"\n' +
    '                previous-text="Vorige"\n' +
    '                boundary-links="true"\n' +
    '                rotate="false"\n' +
    '                ng-model="vm.currentPage"\n' +
    '                ng-change="vm.pageChanged()"></uib-pagination>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/closing/closing-component.tpl.html',
    '<h3>Monatsabschluß &amp; Datenexport</h3>\n' +
    '<span class="btn btn-primary" ng-click="vm.lastmonth()">Letztes Monat</span>\n' +
    '\n' +
    '\n' +
    '<h3>Datenexport für beliebige Zeiträume</h3>\n' +
    '<form class="form-vertical">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="startdate">Von</label>\n' +
    '\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.startdate"\n' +
    '               is-open="start.opened" ng-required="true" id="startdate" name="startdate"\n' +
    '               clear-text="Löschen" close-text="Schließen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="start.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="enddate">Bis</label>\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.enddate"\n' +
    '               is-open="end.opened" ng-required="true" id="enddate" name="enddate"\n' +
    '               close-text="Schließen" clear-text="Löschen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="end.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <button class="btn btn-success" ng-click="vm.freeinterval()"><i class="fa fa-download"></i> Exportieren</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/kkcat/kkcatform-component.tpl.html',
    '<form class="form-vertical" id="editkkcatform" data-hook="editkkcatform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="xxx">xxx</label>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="yyy">xxx</label>\n' +
    '     \n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/cashbook/cashbook-component.tpl.html',
    '<h3>Kassabuch</h3>\n' +
    '\n' +
    '<div class="alert alert-info"><h3>Aktueller Bargeldbestand: {{vm.cashbook[0].cashvalue | currency: \'€ \' : 2}}</h3></div>\n' +
    '\n' +
    '<div class="row">\n' +
    '  <div class="col-xs-12 col-md-6">\n' +
    '    <form class="form-vertical">\n' +
    '      <div class="form-group">\n' +
    '        <label for="deposit">Bareinlage</label>\n' +
    '        \n' +
    '        <div class="input-group">\n' +
    '          <input type="number" class="form-control" ng-model="vm.depositvalue" id="deposit" placeholder="Bareinlage">\n' +
    '          <span class="input-group-btn">\n' +
    '          <button class="btn btn-success" type="submit" ng-click="vm.deposit()" uib-tooltip="Bareinlage">\n' +
    '            <i class="fa fa-plus"></i>\n' +
    '          </button>\n' +
    '            </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 col-md-6">\n' +
    '    <form class="form-vertical">\n' +
    '      <div class="form-group">\n' +
    '        <label for="withdrawal">Barentnahme</label>\n' +
    '        \n' +
    '        <div class="input-group">\n' +
    '          <input type="number" class="form-control" id="withdrawal" ng-model="vm.withdrawalvalue"\n' +
    '                 placeholder="Barentnahme">\n' +
    '          <span class="input-group-btn">\n' +
    '            <button class="btn btn-danger" type="submit" ng-click="vm.withdrawal()" uib-tooltip="Barentnahme">\n' +
    '              <i class="fa fa-minus"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </form>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="row" ng-hide="vm.cashlog.length === 0">\n' +
    '  <div class="col-xs-12">\n' +
    '    <table class="table table-striped">\n' +
    '      <tr>\n' +
    '        <th>Datum</th>\n' +
    '        <th align="center">Bareinlage</th>\n' +
    '        <th align="center">Barentnahme</th>\n' +
    '        <th align="center">Bareinnahme</th>\n' +
    '        <th align="center">Bareinnahmestorno</th>\n' +
    '      </tr>\n' +
    '      \n' +
    '      <tr ng-repeat="entry in vm.cashlog">\n' +
    '        <td ng-bind="entry.created | datetime"></td>\n' +
    '        <td ng-bind="entry.bareinlagebetrag | currency" align="right"></td>\n' +
    '        <td ng-bind="entry.barentnahmebetrag | currency" align="right"></td>\n' +
    '        <td ng-bind="entry.bareinnahmebetrag | currency" align="right"></td>\n' +
    '        <td ng-bind="entry.bareinnahmestornobetrag | currency" align="right"></td>\n' +
    '      </tr>\n' +
    '    </table>\n' +
    '    \n' +
    '    \n' +
    '    <uib-pagination total-items="vm.totalItems"\n' +
    '                    items-per-page="20"\n' +
    '                    max-size="10"\n' +
    '                    first-text="Erste"\n' +
    '                    last-text="Letzte"\n' +
    '                    next-text="N&auml;chste"\n' +
    '                    previous-text="Vorige"\n' +
    '                    boundary-links="true"\n' +
    '                    rotate="false"\n' +
    '                    ng-model="vm.currentPage"\n' +
    '                    ng-change="vm.pageChanged()"></uib-pagination>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/cart/cartform-component.tpl.html',
    '\n' +
    '<privcatsearch privcat="" privcatref="" hideaddoption="true" onselectcb="">\n' +
    '\n' +
    '\n' +
    '<div class="row">\n' +
    '  <div class="col-xs-3 col-md-1">Stk</div>\n' +
    '  <div class="col-xs-9 col-md-9">Bezeichnung</div>\n' +
    '  <div class="col-xs-6 col-md-1">Brutto</div>\n' +
    '  <div class="col-xs-6 col-md-1">Steuer</div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<div class="row" ng-repeat="item in vm.cart.items">\n' +
    '  <div class="col-xs-3 col-md-1">{{item.quantity}}</div>\n' +
    '  <div class="col-xs-9 col-md-9">{{item.name}}</div>\n' +
    '  <div class="col-xs-6 col-md-1">&euro; {{item.price}}</div>\n' +
    '  <div class="col-xs-6 col-md-1">{{item.tax}}%</div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcfinance/bmfexport/bmfexport-component.tpl.html',
    '<h3>Datenexport für Finanzamt</h3>\n' +
    '\n' +
    '\n' +
    '<a href="{{vm.thisyearquery}}" class="btn btn-success" >Dieses Jahr</a>\n' +
    '\n' +
    '\n' +
    '<form class="form-vertical">\n' +
    '  <div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="startdate">Von</label>\n' +
    '\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.startdate"\n' +
    '               is-open="start.opened" ng-required="true" id="startdate" name="startdate"\n' +
    '               clear-text="Löschen" close-text="Schließen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="start.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '      <label for="enddate">Bis</label>\n' +
    '      <p class="input-group">\n' +
    '        <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd" ng-model="vm.enddate"\n' +
    '               is-open="end.opened" ng-required="true" id="enddate" name="enddate"\n' +
    '               close-text="Schließen" clear-text="Löschen" current-text="Heute" starting-day="1"\n' +
    '               alt-input-formats="vm.altInputFormats"/>\n' +
    '              <span class="input-group-btn">\n' +
    '                <button type="button" class="btn btn-default" ng-click="end.opened = true;"><i\n' +
    '                  class="fa fa-calendar"></i></button>\n' +
    '              </span>\n' +
    '      </p>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <button class="btn btn-success" ng-click="vm.rangequery()"><i class="fa fa-download"></i> Exportieren</button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/scan/scansorter-component.tpl.html',
    '<!-- Menubar -->\n' +
    '<div class="row spacer-top" ng-show="vm.docready">\n' +
    '  <!-- viewer column  -->\n' +
    '  <div class="col-xs-12 col-md-6">\n' +
    '    <!-- PDF viewer actions-->\n' +
    '    <div class="pull-left">\n' +
    '      <div ng-show="vm.pdferror !== true">\n' +
    '        <button class="btn btn-info" ng-click="vm.zoomIn()" uib-tooltip="Hineinzoomen"><i\n' +
    '          class="fa fa-search-plus"></i></button>\n' +
    '        <button class="btn btn-info" ng-click="vm.zoomOut()" uib-tooltip="Herauszoomen"><i\n' +
    '          class="fa fa-search-minus"></i></button>\n' +
    '        <button class="btn btn-info" ng-click="vm.rotatePage()" uib-tooltip="Dokument drehen"><i\n' +
    '          class="fa fa-rotate-right"></i></button>\n' +
    '        <button class="btn btn-info" ng-click="vm.previousPage()" uib-tooltip="Zurückblättern"><i\n' +
    '          class="fa fa-arrow-left"></i></button>\n' +
    '        <!--  Seite: {{vm.currentpage}} / {{vm.maxpc}}  -->\n' +
    '        <form style="display: inline" class="form-horizontal">\n' +
    '          <label for="pagenr"> Seite: </label>\n' +
    '          <input type="number" class="form-control"\n' +
    '                 style="display: inline; width: 4em"\n' +
    '                 width="5em" name="pagenr" id="pagenr"\n' +
    '                 ng-change="vm.gotoPage()"\n' +
    '                 ng-model="vm.currentpage">\n' +
    '          <label>/{{vm.maxpc}}</label>\n' +
    '        </form>\n' +
    '        <button class="btn btn-info" ng-click="vm.nextPage()" uib-tooltip="Vorblättern"><i\n' +
    '          class="fa fa-arrow-right"></i></button>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- ************************************************************ -->\n' +
    '    <!-- Document Viewer                                              -->\n' +
    '    <!-- ************************************************************ -->\n' +
    '    <div>\n' +
    '      <div class="alert alert-info spacer-top spacer-bottom" ng-show="vm.docloading">\n' +
    '        <h3><i class="fa fa-spinner fa-spin"></i> Dokument wird geladen ...</h3>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <!--  Broken Document / wrong doc type warning    -->\n' +
    '      <div class="alert alert-warning" ng-show="vm.pdferror === true">\n' +
    '        <h4 class="spacer-top spacer-bottom">\n' +
    '          Das Dokument ist wahrscheinlich defekt, oder gar kein PDF Dokument. Sie können das Dokument\n' +
    '          herunter laden und lokal betrachten.</h4>\n' +
    '        <a href="/routes/files/filedownload/{{vm.file.fileid}}">\n' +
    '          <div class="spacer-top spacer-bottom btn btn-primary">\n' +
    '            <i class="fa fa-download"></i> Dokument herunterladen\n' +
    '          </div>\n' +
    '        </a>\n' +
    '        <h4 class="spacer-top">Informationen für Fehlerreport</h4>\n' +
    '\n' +
    '        <div class="spacer-top">Mimetype: {{vm.file.mimetype}} {{vm.file.mimeType}}</div>\n' +
    '        <div>fileid: {{vm.file.fileid}}</div>\n' +
    '        <div>Share: {{vm.file.sharetype}}</div>\n' +
    '        <div>Endpoint: {{vm.file.endpoint}}</div>\n' +
    '        <div>Type: {{vm.file.type}}</div>\n' +
    '        <div>Filecat: {{vm.file.filecat}}</div>\n' +
    '        <div>Filename: {{vm.file.filename}}</div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- PDF Viewer -->\n' +
    '      <div style="position: relative">\n' +
    '        <pdf-viewer ng-hide="vm.pdferror === true"\n' +
    '                    delegate-handle="scans-pdf-container"\n' +
    '                    url="pdfUrl"\n' +
    '                    scale="1.2"\n' +
    '                    show-toolbar="false"\n' +
    '                    ng-class="vm.landscape ? \'landscapeview\' : \'portraitview\'"\n' +
    '        >\n' +
    '        </pdf-viewer>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '  </div>\n' +
    '  <!-- ************************************************************ -->\n' +
    '  <!-- Assignment column                                            -->\n' +
    '  <!-- ************************************************************ -->\n' +
    '  <div class="pull-right col-xs-12 col-md-6">\n' +
    '    <!-- document assigment menu -->\n' +
    '    <div>\n' +
    '      <!-- scan sorter menu -->\n' +
    '      <span ng-show="vm.filemode === \'scan\'">\n' +
    '                <button data-hook="assign_patient" class="btn btn-success" ng-click="vm.assignCat(\'patient\')"\n' +
    '                        uib-tooltip="Dokument Patient zuordnen">\n' +
    '                    <i class="fa fa-arrow-down"></i><i class="fa fa-user"></i>\n' +
    '                </button>\n' +
    '                <button data-hook="assign_generic" class="btn btn-success" ng-click="vm.assignCat(\'generic\')"\n' +
    '                        uib-tooltip="Allgemeines Dokument zuordnen">\n' +
    '                    <i class="fa fa-arrow-down"></i><i class="fa fa-book"></i>\n' +
    '                </button>\n' +
    '                <button class="btn btn-warning" data-hook="finish_assignment"\n' +
    '                        data-ng-disabled="vm.formDisabled(vm.file) || vm.saving === true"\n' +
    '                        ng-click="vm.finish()"\n' +
    '                        uib-tooltip="Dokument abschliessen">\n' +
    '                    <i class="fa fa-check" data-hook="assign_saved" ng-if="vm.saved === true"></i>\n' +
    '                    <i class="fa fa-spin fa-spinner" ng-if="vm.saving === true"></i>\n' +
    '                    <i class="fa fa-warning" uib-tooltip="Bitte noch einmal probieren" ng-if="vm.saverror === true"></i>\n' +
    '                  Dokument abschließen\n' +
    '                </button>\n' +
    '            </span>\n' +
    '      <!-- scan signoff menu -->\n' +
    '      <span ng-show="vm.filemode === \'signoff\'">\n' +
    '        <span class="input-group">\n' +
    '            <input type="text" data-hook="signature" class="form-control" ng-model="vm.file.signature"\n' +
    '                   placeholder="Signatur">\n' +
    '            <span class="input-group-btn">\n' +
    '                <button class="btn btn-warning" data-hook="finish_signoff"\n' +
    '                        data-ng-disabled="vm.formSignoffDisabled(vm.file)"\n' +
    '                        ng-click="vm.finishSignoff()"\n' +
    '                        uib-tooltip="Dokument abschließen">\n' +
    '                    <i class="fa fa-check"  data-hook="signoff_saved"  ng-if="vm.saved === true"></i>\n' +
    '                    <i class="fa fa-spin fa-spinner" ng-if="vm.saving === true"></i>\n' +
    '                    <i class="fa fa-warning" uib-tooltip="Bitte noch einmal probieren" ng-if="vm.saverror === true"></i>\n' +
    '                    Dokument vidieren\n' +
    '                </button>\n' +
    '            </span>\n' +
    '        </span>\n' +
    '\n' +
    '    </span>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div>\n' +
    '      <form class="form-vertical spacer-top">\n' +
    '        <!-- keywords -->\n' +
    '        <div class="row" ng-show="vm.file.doccat">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '              <label for="dockeywords">Stichworte</label>\n' +
    '              <tags-input ng-model="vm.file.keywords" data-hook="keywords"\n' +
    '                          display-property="text"\n' +
    '                          id="filekeywords{{$index}}"\n' +
    '                          add-on-paste="true"\n' +
    '                          add-on-comma="false"\n' +
    '                          add-on-enter="true"\n' +
    '                          min-length="1"\n' +
    '                          ng-blur="vm.saveKeywords()"\n' +
    '                          enable-editing-last-tag="true"\n' +
    '                          add-from-autocomplete-only="false"\n' +
    '                          replace-spaces-with-dashes="false"\n' +
    '                          template="filetag-template">\n' +
    '                <auto-complete source="vm.getTags($query)"\n' +
    '                               min-length="1"\n' +
    '                               load-on-focus="true"\n' +
    '                               load-on-empty="false"\n' +
    '                               load-on-down-arrow="true"\n' +
    '                               max-results-to-show="32"\n' +
    '                               select-first-match="true"\n' +
    '                               template="filetagautocomplete-template">\n' +
    '                </auto-complete>\n' +
    '              </tags-input>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!--on-tag-added="vm.assignKeyword($tag)"-->\n' +
    '        <!-- ************************************************************ -->\n' +
    '        <!-- Patient/Client Document Actions                              -->\n' +
    '        <!-- ************************************************************ -->\n' +
    '\n' +
    '        <!-- patient docs -->\n' +
    '        <div class="row" ng-show="vm.file.doccat === \'patient\'" data-hook="patientactions">\n' +
    '          <div class="col-xs-12 col-md-6">\n' +
    '\n' +
    '            <div ng-hide="vm.file.clientid || vm.file.patientid">\n' +
    '              <label for="clientsearch">{{vm.kunde}}</label>\n' +
    '              <clientsearch parentsave="vm.saveClient(client, mode)" mode="{{vm.clientmode}}"\n' +
    '                            data-hook="assign-patient-name"\n' +
    '                            id="clientsearch"></clientsearch>\n' +
    '            </div>\n' +
    '            <div ng-show="vm.file.patientid">\n' +
    '              <label for="patient">Patient</label>\n' +
    '\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control"\n' +
    '                       id="patient"\n' +
    '                       readonly\n' +
    '                       ng-model="vm.file.patientfname">\n' +
    '                <span class="input-group-btn">\n' +
    '                                <button class="btn btn-danger"\n' +
    '                                        ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '            <div ng-show="vm.file.clientid">\n' +
    '              <label for="client">Kunde</label>\n' +
    '\n' +
    '              <div class="input-group">\n' +
    '                <input type="text" class="form-control"\n' +
    '                       id="client"\n' +
    '                       readonly\n' +
    '                       ng-model="vm.file.clientfname">\n' +
    '                <span class="input-group-btn">\n' +
    '                                <button class="btn btn-danger"\n' +
    '                                        ng-click="vm.clearClient()"><i class="fa fa-remove"></i>\n' +
    '                                </button>\n' +
    '                            </span>\n' +
    '              </div>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '          <!-- PatientDokument type -->\n' +
    '          <div class="col-xs-12 col-md-6">\n' +
    '            <div class="form-group">\n' +
    '              <label for="patdoctype">{{vm.kunden}}-Dokumenttyp</label>\n' +
    '              <select id="patdoctype" data-hook="patient_doctype" ng-model="vm.file.type" class="form-control"\n' +
    '                      ng-change="vm.save()">\n' +
    '                <option ng-repeat="v in vm.dmspatientcat" value="{{v}}">{{v}}</option>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '\n' +
    '          <div class="form-group col-xs-12" ng-show="vm.file.patientid">\n' +
    '            <label for="client">Diagnosen</label>\n' +
    '            <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.diagClientSave()"></diagnosesedit>\n' +
    '          </div>\n' +
    '\n' +
    '          <!-- Logging -->\n' +
    '          <div class="form-group col-xs-12 col-md-6">\n' +
    '            <button type="button" ng-click="vm.addLog()"\n' +
    '                    uib-tooltip="Logeintrag für Patienten erstellen"\n' +
    '                    class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Logeintrag\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          <!-- PatTodo -->\n' +
    '          <div class="form-group col-xs-12 col-md-6">\n' +
    '            <button type="button" ng-click="vm.addReminder()" uib-tooltip="Erinnerung für {{vm.kunden}} erstellen"\n' +
    '                    class="btn btn-success form-control"><i class="fa fa-plus"></i> {{vm.kunden}}-Erinnerung/Todo\n' +
    '            </button>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '          <!-- Befunde nachtragen -->\n' +
    '          <div class="col-xs-12" ng-show="vm.file.patientid">\n' +
    '            <h4>Untersuchungsergebnisse nachtragen</h4>\n' +
    '            <addexamdiagnoses patientid="vm.file.patientid"></addexamdiagnoses>\n' +
    '          </div>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- ************************************************************ -->\n' +
    '        <!-- Generic Document Actions                                     -->\n' +
    '        <!-- ************************************************************ -->\n' +
    '\n' +
    '        <div class="row" ng-show="vm.file.doccat === \'generic\'" data-hook="genericactions">\n' +
    '          <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '              <label for="gendoctype">Allgemeiner Dokumenttyp</label>\n' +
    '              <select id="gendoctype" ng-model="vm.file.type" class="form-control" ng-change="vm.save()">\n' +
    '                <option ng-repeat="v in vm.dmsgencat" value="{{v}}">{{v}}</option>\n' +
    '              </select>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '      </form>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<div class="row spacer-top">\n' +
    '\n' +
    '\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- tag template -->\n' +
    '<script type="text/ng-template" id="filetag-template">\n' +
    '  <div class="tag-template" style="z-index: 10000">\n' +
    '    <div class="right-panel">\n' +
    '      <span>{{$getDisplayText()}}</span>\n' +
    '      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- tag autocomplete template -->\n' +
    '<script type="text/ng-template" id="filetagautocomplete-template">\n' +
    '  <div class="filetagautocomplete-template" style="z-index: 10000">\n' +
    '    <div>\n' +
    '      <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/printer/printerform-component.tpl.html',
    '<form class="form-vertical" id="editprinterform" data-hook="editprinterform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="xxx">xxx</label>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="yyy">xxx</label>\n' +
    '     \n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/pdfprinter/pdfprinterform-component.tpl.html',
    '<form class="form-vertical" id="editpdfprinterform" data-hook="editpdfprinterform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="xxx">xxx</label>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="yyy">xxx</label>\n' +
    '     \n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/file/complexfilelist-component.tpl.html',
    '<div class="alert alert-info" ng-show="vm.files.length == 0">Keine Daten gefunden</div>\n' +
    '\n' +
    '<!--table-->\n' +
    '<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->\n' +
    '<div class="gridStyle fileGrid" ui-grid="vm.gridOptions" ng-if="vm.files.length > 0"></div>\n' +
    '<div class="comfortspace">&nbsp;</div>\n' +
    '\n' +
    '<!-- template for tags cell -->\n' +
    '<script type="text/ng-template" id="filetagtemplate">\n' +
    '    <tags-input ng-model="row.entity.keywords"\n' +
    '                display-property="text"\n' +
    '                id="filekeywords{{$index}}"\n' +
    '                add-on-paste="true"\n' +
    '                add-on-comma="false"\n' +
    '                add-on-enter="true"\n' +
    '                min-length="1"\n' +
    '                ng-blur="grid.appScope.vm.saveFile(row.entity)"\n' +
    '                enable-editing-last-tag="true"\n' +
    '                add-from-autocomplete-only="false"\n' +
    '                replace-spaces-with-dashes="false"\n' +
    '                template="filetag-template">\n' +
    '        <auto-complete source="grid.appScope.vm.getTags($query)"\n' +
    '                       min-length="1"\n' +
    '                       load-on-focus="true"\n' +
    '                       load-on-empty="false"\n' +
    '                       load-on-down-arrow="true"\n' +
    '                       max-results-to-show="32"\n' +
    '                       select-first-match="true"\n' +
    '                       template="filetagautocomplete-template">\n' +
    '        </auto-complete>\n' +
    '    </tags-input>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<!--template for action buttons-->\n' +
    '<script type="text/ng-template" id="fileactiontemplate">\n' +
    '    <div class="ui-grid-cell-contents">\n' +
    '    <span style="text-align: right">\n' +
    '        <a href="/routes/files/filereader/{{row.entity.fileid}}" target="_blank" class="btn btn-primary btn-xs"><i\n' +
    '            class="fa fa-eye"></i></a>\n' +
    '        <a href="/routes/files/filedownload/{{row.entity.fileid}}" class="btn btn-primary btn-xs"><i\n' +
    '            class="fa fa-download"></i></a>\n' +
    '        <!-- delete file, mit Rückfrage -->\n' +
    '        <a ng-really-click="grid.appScope.vm.removeFile(row.entity, $index)"\n' +
    '           ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?"\n' +
    '           class="btn btn-danger btn-xs">\n' +
    '            <i class="fa fa-remove"></i>\n' +
    '        </a>\n' +
    '        <!-- unlink file, mit Rückfrage -->\n' +
    '        <a ng-really-click="grid.appScope.vm.unlinkFile(row.entity)"\n' +
    '           ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n' +
    '           class="btn btn-warning btn-xs">\n' +
    '            <i class="fa fa-unlink"></i>\n' +
    '        </a><sprhelp tip="Dateizuordnung aufheben" descref="grid.appScope.vm.helpunlink"></sprhelp>\n' +
    '        <!-- TODO: is there really not better way to access the help content? -->\n' +
    '      </span>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- tag template -->\n' +
    '<script type="text/ng-template" id="filetag-template">\n' +
    '    <div class="tag-template" style="z-index: 10000">\n' +
    '        <div class="right-panel">\n' +
    '            <span>{{$getDisplayText()}}</span>\n' +
    '            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- tag autocomplete template -->\n' +
    '<script type="text/ng-template" id="filetagautocomplete-template">\n' +
    '    <div class="filetagautocomplete-template" style="z-index: 10000">\n' +
    '        <div>\n' +
    '            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/document/documentform-component.tpl.html',
    '<form class="form-vertical" id="editdocumentform" data-hook="editdocumentform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="xxx">xxx</label>\n' +
    '      \n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="yyy">xxx</label>\n' +
    '     \n' +
    '    </div>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/document/complexdocumentlist-component.tpl.html',
    '<div class="alert alert-info" ng-show="vm.documents.length == 0">Keine Daten gefunden</div>\n' +
    '\n' +
    '<!--table-->\n' +
    '<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->\n' +
    '<div class="gridStyle documentGrid" ui-grid="vm.gridOptions" ng-if="vm.documents.length > 0"></div>\n' +
    '<div class="comfortspace">&nbsp;</div>\n' +
    '\n' +
    '<!-- template for tags cell -->\n' +
    '<script type="text/ng-template" id="documenttagtemplate">\n' +
    '    <tags-input ng-model="row.entity.keywords"\n' +
    '                display-property="text"\n' +
    '                id="documentkeywords{{$index}}"\n' +
    '                add-on-paste="true"\n' +
    '                add-on-comma="false"\n' +
    '                add-on-enter="true"\n' +
    '                min-length="1"\n' +
    '                ng-blur="grid.appScope.vm.saveDocument(row.entity)"\n' +
    '                enable-editing-last-tag="true"\n' +
    '                add-from-autocomplete-only="false"\n' +
    '                replace-spaces-with-dashes="false"\n' +
    '                template="documenttag-template">\n' +
    '        <auto-complete source="grid.appScope.vm.getTags($query)"\n' +
    '                       min-length="1"\n' +
    '                       load-on-focus="true"\n' +
    '                       load-on-empty="false"\n' +
    '                       load-on-down-arrow="true"\n' +
    '                       max-results-to-show="32"\n' +
    '                       select-first-match="true"\n' +
    '                       template="documenttagautocomplete-template">\n' +
    '        </auto-complete>\n' +
    '    </tags-input>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<!--template for action buttons-->\n' +
    '<script type="text/ng-template" id="documentactiontemplate">\n' +
    '    <div class="ui-grid-cell-contents">\n' +
    '    <span style="text-align: right">\n' +
    '        <a href="/routes/pdfreader/{{row.entity._id}}" target="_blank" class="btn btn-primary btn-xs"><i\n' +
    '            class="fa fa-eye"></i></a>\n' +
    '        <a href="/routes/pdfdownload/{{row.entity._id}}" class="btn btn-primary btn-xs"><i\n' +
    '            class="fa fa-download"></i></a>\n' +
    '        <!-- delete document, mit Rückfrage -->\n' +
    '<!--        <a ng-really-click="grid.appScope.vm.removeDocument(row.entity, $index)"\n' +
    '           ng-really-message="Wollen Sie dieses Dokument wirklich l&ouml;schen?"\n' +
    '           class="btn btn-danger btn-xs">\n' +
    '            <i class="fa fa-remove"></i>\n' +
    '        </a>-->\n' +
    '        <!-- unlink document, mit Rückfrage -->\n' +
    '<!--        <a ng-really-click="grid.appScope.vm.unlinkdocument(row.entity, $index)"\n' +
    '           ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n' +
    '           class="btn btn-warning btn-xs">\n' +
    '            <i class="fa fa-unlink"></i>\n' +
    '        </a><sprhelp tip="Dateizuordnung aufheben" descref="grid.appScope.vm.helpunlink"></sprhelp>-->\n' +
    '      </span>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- tag template -->\n' +
    '<script type="text/ng-template" id="documenttag-template">\n' +
    '    <div class="tag-template">\n' +
    '        <div class="right-panel">\n' +
    '            <span>{{$getDisplayText()}}</span>\n' +
    '            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- tag autocomplete template -->\n' +
    '<script type="text/ng-template" id="documenttagautocomplete-template">\n' +
    '    <div class="documenttagautocomplete-template" style="z-index: 10000!important">\n' +
    '        <div>\n' +
    '            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdms/doctype/doctypeform-component.tpl.html',
    '<form class="form-vertical" id="editdoctypeform" data-hook="editdoctypeform">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="dtid">ID</label>\n' +
    '      <input type="text" ng-model="vm.doctype._id" class="form-control" id="dtid" tabindex="-1" readonly\n' +
    '             placeholder="ID">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="name">Name</label>\n' +
    '      <input type="text" ng-model="vm.doctype.name" class="form-control" id="name" tabindex="1"\n' +
    '             placeholder="Name">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-md-12">\n' +
    '      <label for="filename">Filename</label>\n' +
    '      <input type="text" ng-model="vm.doctype.filename" class="form-control" id="filename" tabindex="2"\n' +
    '             placeholder="Filename">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <form class="form-vertical" id="editsvform">\n' +
    '    <div class="row">\n' +
    '      <div class="form-group col-md-12">\n' +
    '        <label for="xslt">Stylesheet (Filename, ohne Pfad)</label>\n' +
    '        <input type="text" ng-model="vm.doctype.stylesheet" class="form-control" id="xslt" tabindex="3"\n' +
    '               placeholder="XSLT Stylesheet Dateiname">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="row">\n' +
    '      <div class="form-group col-md-12">\n' +
    '        <label for="print">Drucker  (Derzeit gewählt: {{vm.doctype.printer}} )</label>\n' +
    '        <select ng-model="vm.doctype.printer" class="form-control" id="print"  tabindex="3">\n' +
    '          <option value="{{p.printername}}" ng-repeat="p in vm.allprinters">{{p.printername}}, {{p.description}}</option>\n' +
    '        </select>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vctracker/trackervalueform-component.tpl.html',
    '<form class="form-vertical" id="edittrackervalueform" data-hook="edittrackervalueform">\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-6">\n' +
    '            <label for="date">Datum\n' +
    '                <sprhelp tip="Eingabeformat" descref="vm.datehelp"></sprhelp>\n' +
    '                <span ng-show="vm.dateerror" style="color: #cc3333"><i\n' +
    '                    class="fa fa-warning"></i> {{vm.dateerror}}</span></label>\n' +
    '\n' +
    '\n' +
    '            <input ng-show="!vm.trackervalue.dateat  || vm.trackervalue.dateat === \'Invalid date\'"\n' +
    '                   type="text" ng-model="vm.trackervalue.date" tabindex="0"\n' +
    '                   ng-blur="vm.formatdate(vm.trackervalue.date)"\n' +
    '                   class="form-control" id="date"\n' +
    '                   ng-focus="vm.setCurrentField(\'date\')"\n' +
    '                   ng-change="vm.setCurrentFieldContent(vm.trackervalue.date)"\n' +
    '                   placeholder="TTMMJJJJ">\n' +
    '\n' +
    '            <div class="input-group" ng-show="vm.trackervalue.dateat  && vm.trackervalue.dateat !== \'Invalid date\'">\n' +
    '                <input type="text" class="form-control"\n' +
    '                       id="dateat"\n' +
    '                       readonly\n' +
    '                       ng-model="vm.trackervalue.dateat">\n' +
    '                <span class="input-group-btn">\n' +
    '        <button class="btn btn-danger"\n' +
    '                ng-click="vm.cleardate()"><i class="fa fa-remove"></i>\n' +
    '        </button>\n' +
    '      </span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12 col-md-6">\n' +
    '            <label>{{tracker.name}}</label>\n' +
    '            <div class="row" ng-repeat="def in vm.trackervalue.def">\n' +
    '                <div class="col-xs-8 col-md-6 text-right">{{def.label}}</div>\n' +
    '                <div class="col-xs-4 col-md-6">\n' +
    '                    <input type="number" step="def.step" min="def.absmin" max="def.absmax"\n' +
    '                           ng-model="def.value" class="form-control">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vctracker/trackerform-component.tpl.html',
    '<form class="form-vertical" name="edittrackerform" id="edittrackerform" data-hook="edittrackerform">\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-12">\n' +
    '            <label for="trackername">Bezeichnung*</label>\n' +
    '            <input type="text" class="form-control" id="trackername" name="trackername" ng-model="vm.tracker.name" required>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="panel panel-info" ng-repeat="def in vm.tracker.def">\n' +
    '        <div class="panel-heading">\n' +
    '            <span class="pull-left"> Sub-Tracker {{$index}}: {{def.label}}</span>\n' +
    '            <span class="pull-right">\n' +
    '                <span class="btn btn-danger" ng-click="vm.removeDef($index)"><i class="fa fa-remove"></i></span>\n' +
    '            </span>\n' +
    '            <span class="clearfix"></span>\n' +
    '        </div>\n' +
    '        <div class="panel-body">\n' +
    '            <trackerdef trackerdef="def" index="$index" parentsave="vm.defsave(trackerdef, index)"></trackerdef>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-12">\n' +
    '            <span class="btn btn-success" ng-click="vm.addDef()">Weiteren Sub-Tracker einfügen</span>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success disabled" type="button" tabindex="9" ng-click="vm.save()"\n' +
    '                ng-hide="edittrackerform.trackername.$valid">Speichern</button>\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()"\n' +
    '                        ng-show="edittrackerform.trackername.$valid">Speichern</button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vctodo/todowidget-component.tpl.html',
    '<form class="form-inline">\n' +
    '  <div class="panel panel-default">\n' +
    '    <div class="panel-heading">\n' +
    '      <h3 class="panel-title">Todo&nbsp;\n' +
    '        <span class="label label-default" ng-model="todoCtrl.count"></span>\n' +
    '      </h3>\n' +
    '    </div>\n' +
    '    <div class="panel-body">\n' +
    '      \n' +
    '      \n' +
    '      <!-- Neues Todo -->\n' +
    '      <form class="form-vertical">\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" ng-model="vm.newitem.label" class="form-control" id="newtodo" placeholder="Neues Todo">\n' +
    '          <div uib-dropdown class="input-group-btn" ng-class="gtClass">\n' +
    '            <button uib-dropdown-toggle type="button" class="btn btn-secondary">\n' +
    '              <span ng-show="vm.newitem.duestr">{{vm.newitem.duestr}}</span>\n' +
    '              <span ng-hide="vm.newitem.duestr">Fällig  </span><span class="caret"></span>\n' +
    '            </button>\n' +
    '            <!-- override bootstrap .dropdown-menu { min-width: 160px } -->\n' +
    '            <ul class="dropdown-menu" style="min-width: 0;">\n' +
    '              <li><a ng-click="vm.calcdue(0, \'Sofort\')">Sofort</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(1, \'Morgen\')">Morgen</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(2, \'Übermorgen\')">Übermorgen</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(7, \'1 Woche\')">1 Woche</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(14, \'2 Wochen\')">2 Wochen</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(30, \'1 Monat\')">1 Monat</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(90, \'3 Monate\')">3 Monate</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(180, \'6 Monate\')">6 Monate</a></li>\n' +
    '              <li><a ng-click="vm.calcdue(365, \'1 Jahr\')">1 Jahr</a></li>\n' +
    '            </ul>\n' +
    '            <button class="btn btn-success" type="submit" ng-click="vm.add()">\n' +
    '              <i class="fa fa-plus"></i>\n' +
    '            </button>\n' +
    '          </div>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '      </form>\n' +
    '      \n' +
    '      <!-- Todos gruppiert anzeigen -->\n' +
    '      <h4><span class="label label-xs label-danger">{{vm.todos.overdue.length}}</span> Fällig &amp; Überfällig  </h4>\n' +
    '      <!--<div class="alert alert-info" ng-hide="vm.todos.overdue.length > 0">Derzeit keine überfälligen Todos</div>-->\n' +
    '      <div class="spacer-top" ng-repeat="item in vm.todos.overdue | orderBy: \'due\'">\n' +
    '        <label style="color: #bb3333">\n' +
    '          <input type="checkbox"\n' +
    '                 ng-model="item.done"\n' +
    '                 ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}} ({{item.user}})</label>\n' +
    '      </div>\n' +
    '      <h4><span class="label label-xs label-warning">{{vm.todos.upcoming.length}}</span> Offen  </h4>\n' +
    '      <!--<div class="alert alert-info" ng-hide="vm.todos.upcoming.length > 0">Derzeit keine offenen Todos</div>-->\n' +
    '      <div class="spacer-top" ng-repeat="item in vm.todos.upcoming | orderBy: \'due\' ">\n' +
    '        <label style="color: #ccbb33">\n' +
    '          <input type="checkbox"\n' +
    '                 ng-model="item.done"\n' +
    '                 ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}} ({{item.user}})</label>\n' +
    '      </div>\n' +
    '      \n' +
    '      <h4><span class="label label-xs label-success">{{vm.todos.lastcompleted.length}}</span> Zuletzt abgeschlossen  </h4>\n' +
    '      <div class="spacer-top" ng-repeat="item in vm.todos.lastcompleted | orderBy: \'due\' ">\n' +
    '        <label style="color: #33cc33">\n' +
    '          <input type="checkbox"\n' +
    '                 ng-model="item.done"\n' +
    '                 ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}} ({{item.user}})</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- panelbody -->\n' +
    '  </div>\n' +
    '  <!-- panel -->\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcreminder/clientreminder-component.tpl.html',
    '<h4>Patienten-Todos</h4>\n' +
    '\n' +
    '<!-- some comment -->\n' +
    '<form class="form-vertical">\n' +
    '    <!-- add new reminder-->\n' +
    '    <div class="input-group">\n' +
    '        <input type="text" ng-model="vm.newreminder.label" class="form-control" id="newtodo" placeholder="Neues Todo">\n' +
    '        <div uib-dropdown class="input-group-btn" ng-class="gtClass">\n' +
    '            <button uib-dropdown-toggle type="button" class="btn btn-secondary">\n' +
    '                 <span ng-show="vm.newreminder.duestr">{{vm.newreminder.duestr}}</span>\n' +
    '                <span ng-hide="vm.newreminder.duestr">Fällig  </span><span class="caret"></span>\n' +
    '            </button>\n' +
    '            <!-- override bootstrap .dropdown-menu { min-width: 160px } -->\n' +
    '            <ul class="dropdown-menu" style="min-width: 0;">\n' +
    '                <li><a ng-click="vm.calcdue(0, \'Sofort\')">Sofort</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(14, \'2 Wochen\')">2 Wochen</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(30, \'1 Monat\')">1 Monat</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(90, \'3 Monate\')">3 Monate</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(180, \'6 Monate\')">6 Monate</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(365, \'1 Jahr\')">1 Jahr</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(730, \'2 Jahre\')">2 Jahre</a></li>\n' +
    '                <li><a ng-click="vm.calcdue(1100, \'3 Jahre\')">3 Jahre</a></li>\n' +
    '            </ul>\n' +
    '            <button class="btn btn-success" type="submit" ng-click="vm.addTodoEntry()">\n' +
    '            <i class="fa fa-plus"></i>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>\n' +
    '\n' +
    '<!-- Show  Patientreminders-->\n' +
    '<div class="myscrollbox scrollwindow">\n' +
    '<form>\n' +
    '    <div class="form-group spacer-top" ng-repeat="item in vm.reminders | orderBy: [\'done\', \'due\']">\n' +
    '        <label>\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="item.done"\n' +
    '                   ng-change="vm.save(item)"/>&nbsp;{{item.label}}, {{item.due | moment: \'l\' }}</label>\n' +
    '    </div>\n' +
    '</form>\n' +
    '</div>\n' +
    '<div class="alert alert-info" ng-hide="vm.reminders.length > 0">Keine Todos</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcreminder/allreminders-component.tpl.html',
    '\n' +
    '<h3>Patienten Erinnerungen</h3>\n' +
    '\n' +
    '<form>\n' +
    '    <h4>Fällig &amp; Überfällig</h4>\n' +
    '    <div class="alert alert-info" ng-hide="vm.todos.overdue.length > 0">Derzeit keine überfälligen Erinnerungen</div>\n' +
    '    <div class="form-group spacer-top" ng-repeat="item in vm.todos.overdue | orderBy: \'due\'">\n' +
    '        <label style="color: #bb3333">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="item.done"\n' +
    '                   ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}},\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.patientid})" ng-show="item.patientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.clientid})" ng-show="item.clientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '        </label>\n' +
    '    </div>\n' +
    '    <h4>Bald fällig (2 Wochen <span >\n' +
    '        <i class="fa fa-toggle-on fa-rotate-180 slactive"\n' +
    '           ng-show="vm.weeks === 2"\n' +
    '           ng-click="vm.switchRange(6);">\n' +
    '        </i>\n' +
    '        <i class="fa fa-toggle-on slinactive"\n' +
    '           ng-show="vm.weeks === 6"\n' +
    '           ng-click="vm.switchRange(2);">\n' +
    '        </i>\n' +
    '    </span> 6 Wochen)</h4>\n' +
    '    <div class="alert alert-info" ng-hide="vm.todos.upcoming.length > 0">Derzeit keine fälligen Erinnerungen</div>\n' +
    '    <div class="form-group spacer-top" ng-repeat="item in vm.todos.upcoming | orderBy: \'due\' ">\n' +
    '        <label style="color: #ccbb33">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="item.done"\n' +
    '                   ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}},\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.patientid})" ng-show="item.patientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.clientid})" ng-show="item.clientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '        </label>\n' +
    '    </div>\n' +
    '\n' +
    '    <h4>Zuletzt abgeschlossen</h4>\n' +
    '    <div class="alert alert-info" ng-hide="vm.todos.lastcompleted.length > 0">Zuletzt wurden keine Erinnerungen abgeschlossen</div>\n' +
    '    <div class="form-group spacer-top" ng-repeat="item in vm.todos.lastcompleted | orderBy: \'due\' ">\n' +
    '        <label style="color: #ccbb33">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="item.done"\n' +
    '                   ng-change="vm.save(item)"/>&nbsp;{{item.due | moment: \'l\' }}, {{item.label}},\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.patientid})" ng-show="item.patientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '            <a ui-sref="patientrecord.history({clientid: item.clientid})" ng-show="item.clientid"> {{item.pfname}} {{item.plname}}</a>\n' +
    '        </label>\n' +
    '    </div>\n' +
    '\n' +
    '</form>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/textprocesssing-smartcomponent.tpl.html',
    '<h3>Textverarbeitung</h3>\n' +
    '\n' +
    '\n' +
    '<form class="form-vertical" id="textdocform" name="textdocform">\n' +
    '  <!-- Überweisung für: -->\n' +
    '  <div class="form-group">\n' +
    '    <!-- Patientensuche -->\n' +
    '    <label for="reffor">Patient</label>\n' +
    '    <div class="form-group  col-xs-12" ng-hide="vm.textdoc.patientid">\n' +
    '      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12" ng-show="vm.textdoc.patientid">\n' +
    '      <div class="input-group">\n' +
    '        <input type="text" class="form-control"\n' +
    '               id="patientname"\n' +
    '               tabindex="0"\n' +
    '               readonly\n' +
    '               ng-model="vm.textdoc.patient.fname">\n' +
    '        <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Empfänger Doctor: -->\n' +
    '  <div class="form-group">\n' +
    '    <label for="refto">Empfänger\n' +
    '      (Arzt) <i class="fa fa-info-circle text-primary" uib-tooltip="Wird kein Arzt als Empfänger ausgewählt, wird der Brief an den Patienten adressiert"></i>\n' +
    '    </label>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '      <!-- Arztsuche - -->\n' +
    '      <div class="form-group  col-xs-12" ng-hide="vm.textdoc.doctor._id">\n' +
    '        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>\n' +
    '      </div>\n' +
    '      <div class="form-group col-xs-12" ng-show="vm.textdoc.doctor._id">\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="pdoctorname"\n' +
    '                 tabindex="0"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.textdoc.doctor.fname">\n' +
    '          <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- Betreff -->\n' +
    '  <div class="form-group">\n' +
    '    <label for="subject">Betreff</label>\n' +
    '    <input type="text" class="form-control" id="subject" tabindex="5"\n' +
    '           required placeholder="Betreff" ng-model="vm.textdoc.subject">\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="form-group">\n' +
    '    <div><label>Inkludieren</label></div>\n' +
    '    <div class="checkbox">\n' +
    '      <label>\n' +
    '        <input type="checkbox" ng-model="vm.textdoc.getdiagnoses" ng-true-value="true" ng-false-value="false">\n' +
    '        Diagnosen\n' +
    '      </label>\n' +
    '      <label>\n' +
    '        <input type="checkbox" ng-model="vm.textdoc.getdrugs" ng-true-value="true" ng-false-value="false"> Medikamente\n' +
    '      </label>\n' +
    '      <label>\n' +
    '        <input type="checkbox" ng-model="vm.textdoc.getrisks" ng-true-value="true" ng-false-value="false">\n' +
    '        Risikofaktoren\n' +
    '      </label>\n' +
    '      <label>\n' +
    '        <input type="checkbox" ng-model="vm.textdoc.getnotes" ng-true-value="true" ng-false-value="false"> Notizen\n' +
    '      </label>\n' +
    '\n' +
    '      <!--      <label>\n' +
    '              <input type="checkbox" ng-model="vm.textdoc.gettodos" ng-true-value="true" ng-false-value="false"> Patienten-Todos\n' +
    '            </label>-->\n' +
    '    </div>\n' +
    '    <div class="checkbox">\n' +
    '      <label>\n' +
    '        <input type="checkbox" ng-model="vm.textdoc.greetings" ng-true-value="true" ng-false-value="false">\n' +
    '        Schlußformel (Mit freundlichen Grüßen ...)\n' +
    '      </label>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- WYSIWYG tinymce editor -->\n' +
    '  <textarea ui-tinymce="vm.tinymceOptions" ng-model="vm.xhtml"></textarea>\n' +
    '  <!--<textarea ui-tinymce ng-model="vm.textdoc.text"></textarea>-->\n' +
    '\n' +
    '\n' +
    '  <!-- Buttons -->\n' +
    '  <div class="spacer-top spacer-bottom">\n' +
    '    <button class="btn btn-success" ng-click="vm.print()"><i class="fa fa-print"></i> Drucken</button>\n' +
    '    <button class="btn btn-info" ng-click="vm.preview()"><i class="fa fa-file-pdf-o"></i> Vorschau</button>\n' +
    '    <button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-remove"></i> Abbrechen</button>\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '\n' +
    '<div class="alert alert-success spacer-top" ng-show="vm.printed === true"><i class="fa fa-check-circle-o fa-2x"></i>&nbsp;Erfolgreich\n' +
    '  gedruckt\n' +
    '</div>\n' +
    '<div class="alert alert-danger spacer-top" ng-show="vm.printed === false"><i class="fa fa-warning fa-2x"></i>&nbsp;Druck\n' +
    '  fehlgeschlagen\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/newref-smartcomponent.tpl.html',
    '<style>fieldset.group  {\n' +
    '  margin: 0;\n' +
    '  padding: 0;\n' +
    '  margin-bottom: 1.25em;\n' +
    '  padding: .125em;\n' +
    '}\n' +
    '\n' +
    'fieldset.group legend {\n' +
    '  margin: 0;\n' +
    '  padding: 0;\n' +
    '  font-weight: bold;\n' +
    '  margin-left: 20px;\n' +
    '  font-size: 100%;\n' +
    '  color: black;\n' +
    '}\n' +
    '\n' +
    '\n' +
    'ul.checkbox  {\n' +
    '  margin: 0;\n' +
    '  padding: 0;\n' +
    '  margin-left: 20px;\n' +
    '  list-style: none;\n' +
    '}\n' +
    '\n' +
    'ul.checkbox li input {\n' +
    '  margin-right: .25em;\n' +
    '}\n' +
    '\n' +
    'ul.checkbox li {\n' +
    '  border: 1px transparent solid;\n' +
    '  display:inline-block;\n' +
    '  width:16em;\n' +
    '}\n' +
    '\n' +
    '</style>\n' +
    '\n' +
    '<h3>Überweisungen</h3>\n' +
    '\n' +
    '<form class="form-vertical">\n' +
    '  <!-- Überweisung für: -->\n' +
    '  <div class="form-group" ng-show="vm.standalone">\n' +
    '    <!-- Patientensuche -->\n' +
    '    <label for="reffor">Patient</label>\n' +
    '    <div class="form-group  col-xs-12" ng-hide="vm.newref.patientid">\n' +
    '      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12" ng-show="vm.newref.patientid">\n' +
    '      <div class="input-group">\n' +
    '        <input type="text" class="form-control"\n' +
    '               id="patientname"\n' +
    '               tabindex="0"\n' +
    '               readonly\n' +
    '               ng-model="vm.newref.patient.fname">\n' +
    '        <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Überweisungsart: lab, img, default -->\n' +
    '  <div style="font-weight:bold"><label>Überweisungsart</label></div>\n' +
    '  <div class="form-group">\n' +
    '    <div class="radio" ng-init="vm.newref.reftype = \'std\'">\n' +
    '      <label for="stdref" class="radio-inline">\n' +
    '        <input type="radio" ng-value="std" tabindex="1"\n' +
    '               ng-model="vm.newref.reftype"\n' +
    '               id="stdref"> Standard</label>\n' +
    '      <label for="labref" class="radio-inline">\n' +
    '        <input type="radio" value="lab" tabindex="2"\n' +
    '               ng-model="vm.newref.reftype"\n' +
    '               ng-click="vm.setlab()"\n' +
    '               id="labref"> Labor</label>\n' +
    '      <label for="imgref" class="radio-inline">\n' +
    '        <input type="radio" value="img"\n' +
    '               ng-model="vm.newref.reftype"\n' +
    '               ng-click="vm.setimg()"\n' +
    '               id="imgref"> Bildgebende Diagnostik</label>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '<!-- Überweisung an: -->\n' +
    '<form class="form-vertical" id="refform" name="refform">\n' +
    '  <div class="form-group">\n' +
    '    <label for="refto">\n' +
    '      <span\n' +
    '          uib-tooltip="Es muß entweder ein Arzt aus der Liste ausgewählt werden oder das Feld Freitext ausgefüllt werden">\n' +
    '        An/Zu: Arztauswahl ODER freie Texteingabe\n' +
    '      </span>\n' +
    '      <span uib-tooltip="Pflichtfeld">*</span>\n' +
    '    </label>\n' +
    '    <!-- Arztsuche -->\n' +
    '    <div class=" row">\n' +
    '      <!-- Arztsuche - -->\n' +
    '      <div class="form-group  col-xs-12" ng-hide="vm.newref.doctor._id">\n' +
    '        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>\n' +
    '      </div>\n' +
    '      <div class="form-group col-xs-12" ng-show="vm.newref.doctor._id">\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="pdoctorname"\n' +
    '                 tabindex="0"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.newref.doctor.fname">\n' +
    '          <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class=" row">\n' +
    '      <!-- Freitext -->\n' +
    '      <div class="col-xs-12 spacer-bottom">\n' +
    '        <input type="text" ng-model="vm.newref.to" tabindex="0"\n' +
    '               ng-required="!(vm.newref.to || vm.newref.doctor)"\n' +
    '               ng-hide="vm.newref.doctor"\n' +
    '               tabindex="0"\n' +
    '               style="margin-top: -5px;"\n' +
    '               placeholder="Freitext für Überweisungsziel" class="form-control" id="refto">\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '    <!-- diagnose/Begründung -->\n' +
    '    <div class="form-group">\n' +
    '      <label for="refdiag">Diagnose/Begründung<span uib-tooltip="Pflichtfeld">*</span></label>\n' +
    '      <fieldset class="group">\n' +
    '          <ul class="checkbox">\n' +
    '            <li ng-repeat="diag in vm.diagnoses">\n' +
    '              <input type="checkbox" id="diag{$index}" ng-model="diag.use" ng-change="vm.setDiag()"/>\n' +
    '              <label for="diag{$index}">{{diag.text}}</label></li>\n' +
    '          </ul>\n' +
    '        </fieldset>\n' +
    '      </fieldset>\n' +
    '      <input required type="text" ng-model="vm.newref.diag"\n' +
    '             class="form-control" id="refdiag" tabindex="0">\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Selected Labvalue Output -->\n' +
    '    <div ng-if="vm.newref.reftype === \'lab\'">\n' +
    '      <labreferral parentsave="vm.saveLabvalues(allvalues, ginclude, additionalvalues, cleangroups)"\n' +
    '                   reset="vm.labreset">\n' +
    '      </labreferral>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Selected Imaging Output -->\n' +
    '    <div ng-if="vm.newref.reftype === \'img\'">\n' +
    '      <imagingreferral parentsave="vm.saveImagingvalues(allvalues, ginclude, additionalvalues)"\n' +
    '                       reset="vm.imagingreset">\n' +
    '      </imagingreferral>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Erbeten -->\n' +
    '    <div class="form-group">\n' +
    '      <label for="refref">Erbeten<span uib-tooltip="Pflichtfeld">*</span></label>\n' +
    '      <textarea class="form-control" ng-model="vm.newref.ref" rows="5"\n' +
    '                ng-required="!(vm.newref.ref || vm.newref.labvalues || vm.newref.imagingvalues)"\n' +
    '                id="refref" tabindex="4"></textarea>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- gültig -->\n' +
    '    <div class="form-group">\n' +
    '      <label>Gültig </label>\n' +
    '      <div class="radio">\n' +
    '        <label class="radio-inline">\n' +
    '          <input type="radio" ng-value="true" ng-model="vm.newref.pdate"\n' +
    '                 ng-click="vm.setRefDate()">\n' +
    '          1 Monat</label>\n' +
    '        <label class="radio-inline">\n' +
    '          <input type="radio" ng-value="false" ng-model="vm.newref.pdate"\n' +
    '                 ng-click="vm.newref.refdate = \'\'">\n' +
    '          Kein Datum</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Buttons -->\n' +
    '    <div ng-show="vm.standalone" class="spacer-bottom ">\n' +
    '      <button class="btn btn-success" ng-disabled="refform.$invalid" type="button" ng-click="vm.print();"\n' +
    '              tabindex="0">\n' +
    '        Drucken\n' +
    '      </button>\n' +
    '\n' +
    '<!--      <button class="btn btn-info" ng-disabled="refform.$invalid" type="button" ng-click="vm.preview();" tabindex="0">\n' +
    '        <i class="fa fa-file-pdf-o" ng-hide="vm.previewed"></i>\n' +
    '        <i class="fa fa-check-circle-o" ng-show="vm.previewed"></i>\n' +
    '        PDF Vorschau\n' +
    '      </button>-->\n' +
    '\n' +
    '      <a href="{{vm.previewurl}}" class="btn btn-primary" uib-tooltip="Vorschau PDF in neuem Fenster öffnen"\n' +
    '         ng-show="vm.previewed" type="button" tabindex="0" target="_blank">\n' +
    '        <i class="fa fa-file-pdf-o"></i>\n' +
    '      </a>\n' +
    '\n' +
    '    </div>\n' +
    '    <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Überweisung erfolgreich\n' +
    '      gedruckt\n' +
    '    </div>\n' +
    '    <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Überweisung\n' +
    '      fehlgeschlagen\n' +
    '    </div>\n' +
    '    <div class="alert alert-danger" ng-show="vm.previewed === false"><i class="fa fa-warning"></i> Überweisungsvorschau fehlgeschlagen</div>\n' +
    '\n' +
    '\n' +
    '    <div ng-hide="vm.standalone">\n' +
    '      <button class="btn btn-success" ng-disabled="refform.$invalid" type="button" ng-click="vm.add();" tabindex="50">\n' +
    '        Speichern\n' +
    '      </button>\n' +
    '\n' +
    '\n' +
    '      <button class="btn btn-danger" type="button" ng-click="vm.cancel()" tabindex="51">\n' +
    '        Abbrechen\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="spacer-top"></div>\n' +
    '  <div class="alert alert-success" ng-show="vm.saved"><i class="fa fa-check text-success"></i> Überweisung erfolgreich gespeichert!</div>\n' +
    '  <div class="alert alert-info" ng-show="vm.canceled"><i class="fa fa-info-circle text-primary"></i> Erstellen der Überweisung wurde abgebrochen.</div>\n' +
    '  <div class="alert alert-danger" ng-show="vm.savefailed"><i class="fa fa-warning text-danger"></i> Überweisung konnte nicht gespeichert werden!</div>\n' +
    '</form>\n' +
    '\n' +
    '<div style="min-height:3cm">&nbsp;</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/newaide-smartcomponent.tpl.html',
    '<h3>Heilbehelfe &amp; Hilfsmittel</h3>\n' +
    '\n' +
    '\n' +
    '<form class="form-vertical" id="aideform" name="aideform">\n' +
    '  <!-- Überweisung für: -->\n' +
    '  <div class="form-group" ng-show="vm.standalone">\n' +
    '    <!-- Patientensuche -->\n' +
    '    <label for="reffor">Patient</label>\n' +
    '    <div class="form-group  col-xs-12" ng-hide="vm.newaide.patientid">\n' +
    '      <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12" ng-show="vm.newaide.patientid">\n' +
    '      <div class="input-group">\n' +
    '        <input type="text" class="form-control"\n' +
    '               id="patientname"\n' +
    '               tabindex="0"\n' +
    '               readonly\n' +
    '               ng-model="vm.newaide.patient.fname">\n' +
    '        <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Überweisung an: -->\n' +
    '  <div class="form-group">\n' +
    '    <label for="refto">\n' +
    '      <span\n' +
    '        uib-tooltip="Es muß entweder ein Arzt aus der Liste ausgewählt werden oder das Feld Freitext ausgefüllt werden">\n' +
    '        An/Zu: Arztauswahl ODER freie Texteingabe\n' +
    '      </span>\n' +
    '      <span uib-tooltip="Pflichtfeld">*</span>\n' +
    '    </label>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '      <!-- Arztsuche - -->\n' +
    '      <div class="form-group  col-xs-12" ng-hide="vm.newaide.doctor._id">\n' +
    '        <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>\n' +
    '      </div>\n' +
    '      <div class="form-group col-xs-12" ng-show="vm.newaide.doctor._id">\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="pdoctorname"\n' +
    '                 tabindex="0"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.newaide.doctor.fname">\n' +
    '          <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class=" row">\n' +
    '      <!-- Freitext -->\n' +
    '      <div class="col-xs-12 spacer-bottom">\n' +
    '        <input type="text" ng-model="vm.newaide.to" tabindex="0"\n' +
    '               ng-required="!(vm.newaide.to || vm.newaide.doctor)"\n' +
    '               ng-hide="vm.newaide.doctor"\n' +
    '               tabindex="0"\n' +
    '               style="margin-top: -5px;"\n' +
    '               placeholder="Freitext für Überweisungsziel" class="form-control" id="refto">\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <!-- diagnose/Begründung -->\n' +
    '  <div class="form-group">\n' +
    '    <label for="refdiag">Diagnose/Begründung<span uib-tooltip="Pflichtfeld">*</span></label>\n' +
    '    <input required type="text" ng-model="vm.newaide.diag"\n' +
    '           class="form-control" id="refdiag" tabindex="0">\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div>\n' +
    '    <form class="form-inline">\n' +
    '      <div class="row" ng-show="vm.aideconfig.groups.length > 0">\n' +
    '        <h4>Heilbehelfsgruppen</h4>\n' +
    '        <!-- value groups -->\n' +
    '        <div ng-repeat="group in vm.aideconfig.groups">\n' +
    '          <div class="form-group col-md-4">\n' +
    '            <label>\n' +
    '              <input type="checkbox"\n' +
    '                     ng-model="vm.newaide.ginclude[$index]"\n' +
    '                     tabindex="0"\n' +
    '                     ng-checked="vm.newaide.ginclude[$index]"\n' +
    '                     ng-init="vm.newaide.ginclude[$index] = false"\n' +
    '                     ng-click="vm.toggleGroup()"/> {{group.name}}</label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- add additional values -->\n' +
    '      <label for="addlabval" ng-show="vm.aideconfig.groups.length > 0">Zusätzliche Heilbehelfe</label>\n' +
    '      <label for="addlabval" ng-show="vm.aideconfig.groups.length === 0">Heilbehelfe</label>\n' +
    '      <tags-input ng-model="vm.newaide.additionalvalues"\n' +
    '                  ng-init="vm.newaide.additionalvalues = []"\n' +
    '                  tabindex="0"\n' +
    '                  display-property="name" id="addlabval"\n' +
    '                  add-on-comma="false"\n' +
    '                  min-length="1"\n' +
    '                  placeholder="Tippen zum Vervollständigen"\n' +
    '                  replace-spaces-with-dashes="false"\n' +
    '                  on-tag-added="vm.joinValues()"\n' +
    '                  on-tag-removed="vm.joinValues()"\n' +
    '                  template="tag-template">\n' +
    '        <auto-complete source="vm.loadValues($query)"\n' +
    '                       min-length="1"\n' +
    '                       load-on-focus="false"\n' +
    '                       load-on-down-arrow="true"\n' +
    '                       load-on-empty="true"\n' +
    '                       max-results-to-show="32"\n' +
    '                       template="autocomplete-template"></auto-complete>\n' +
    '      </tags-input>\n' +
    '\n' +
    '      <!-- selected values -->\n' +
    '      <h4>Ausgewählte Heilbehelfe &amp; Hilfsmittel</h4>\n' +
    '\n' +
    '      <div class="alert alert-info">\n' +
    '        <span ng-show="vm.newaide.allvalues.length > 0" ng-repeat="val in vm.newaide.allvalues">{{val}}{{$last ? \'\' : \', \'}} </span>\n' +
    '        <span ng-hide="vm.newaide.allvalues.length > 0">Keine Werte ausgewählt</span>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '    </form>\n' +
    '\n' +
    '\n' +
    '    <!-- Erbeten -->\n' +
    '    <div class="form-group">\n' +
    '      <label for="refref">Erbeten<span uib-tooltip="Pflichtfeld">*</span></label>\n' +
    '      <textarea class="form-control" ng-model="vm.newaide.aide" rows="5"\n' +
    '                ng-required="!(vm.newaide.ref ||  vm.newaide.allvalues)"\n' +
    '                id="refref" tabindex="0"></textarea>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- gültig -->\n' +
    '    <div class="form-group">\n' +
    '      <label>Gültig </label>\n' +
    '      <div class="radio">\n' +
    '        <label class="radio-inline">\n' +
    '          <input type="radio" ng-value="true" ng-model="vm.newaide.pdate"\n' +
    '                 ng-click="vm.setRefDate()">\n' +
    '          1 Monat</label>\n' +
    '        <label class="radio-inline">\n' +
    '          <input type="radio" ng-value="false" ng-model="vm.newaide.pdate"\n' +
    '                 ng-click="vm.newaide.refdate = \'\'">\n' +
    '          Kein Datum</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Buttons -->\n' +
    '    <div ng-show="vm.standalone" class="spacer-bottom ">\n' +
    '      <button class="btn btn-success" ng-disabled="aideform.$invalid" type="button" ng-click="vm.print();"\n' +
    '              tabindex="0">\n' +
    '        Drucken\n' +
    '      </button>\n' +
    '    </div>\n' +
    '    <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Verordnung erfolgreich gedruckt</div>\n' +
    '    <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Verordnung fehlgeschlagen</div>\n' +
    '\n' +
    '\n' +
    '    <div ng-hide="vm.standalone">\n' +
    '      <button class="btn btn-success" ng-disabled="aideform.$invalid" type="button" ng-click="vm.add();"\n' +
    '              tabindex="0">\n' +
    '        Speichern\n' +
    '      </button>\n' +
    '\n' +
    '      <button class="btn btn-danger" type="button" ng-click="vm.cancel()" tabindex="0">\n' +
    '        Abbrechen\n' +
    '      </button>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="spacer-top"></div>\n' +
    ' <div class="alert alert-success" ng-show="vm.saved"><i class="fa fa-check text-success"></i> Verordnung erfolgreich gespeichert!</div>\n' +
    ' <div class="alert alert-info" ng-show="vm.canceled"><i class="fa fa-info-circle text-primary"></i> Erstellen der Verordnung wurde abgebrochen.</div>\n' +
    ' <div class="alert alert-danger" ng-show="vm.savefailed"><i class="fa fa-warning text-danger"></i> Verordnung konnte nicht gespeichert werden!</div>\n' +
    '</form>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="tag-template">\n' +
    '  <div class="tag-template">\n' +
    '    <div class="right-panel">\n' +
    '      <span>{{$getDisplayText()}}</span>\n' +
    '      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="autocomplete-template">\n' +
    '  <div class="autocomplete-template">\n' +
    '    <div>\n' +
    '      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<div style="min-height:3cm">&nbsp;</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/labvalueconfig-component.tpl.html',
    '<div class="spacer-bottom">\n' +
    '\n' +
    '<h2>Laborwerte und Laborwertgruppen</h2>\n' +
    '\n' +
    '<h3>Werte</h3>\n' +
    '\n' +
    '<tags-input ng-model="vm.labconfig.values"\n' +
    '            display-property="name"\n' +
    '            placeholder="Neuen Laborwert hinzufügen"\n' +
    '            replace-spaces-with-dashes="false"\n' +
    '            add-on-comma="false"\n' +
    '            min-length="1"\n' +
    '            on-tag-added="vm.saveConfig()"\n' +
    '            on-tag-removed="vm.saveConfig()"\n' +
    '            template="tag-template">\n' +
    '    <auto-complete source="vm.loadValues($query)"\n' +
    '                   min-length="0"\n' +
    '                   load-on-focus="true"\n' +
    '                   load-on-empty="true"\n' +
    '                   max-results-to-show="32"\n' +
    '                   template="autocomplete-template"></auto-complete>\n' +
    '</tags-input>\n' +
    '\n' +
    '\n' +
    '<h3>Neue Laborwertgruppe</h3>\n' +
    '\n' +
    '\n' +
    '<form>\n' +
    '    <div class="input-group">\n' +
    '        <input class="form-control"\n' +
    '               ng-model="vm.newgroup" id="newgroup" placeholder="Neue Laborwertgruppe"/>\n' +
    '        <span class="input-group-btn">\n' +
    '          <button class="btn btn-success"\n' +
    '                  type="submit"\n' +
    '                  ng-click="vm.addGroup()"><i class="fa fa-plus"></i> Neue Gruppe anlegen</button>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '</form>\n' +
    '\n' +
    '<h3>Gruppen</h3>\n' +
    '<form class="form-vertical">\n' +
    '    <div ng-repeat="group in vm.labconfig.groups" class="spacer-top">\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="pull-left" ng-bind="group.name" style="font-weight: bold; padding-top: 20px"></span>\n' +
    '            <span class="pull-right">\n' +
    '                <span class="btn btn-danger btn-sm"\n' +
    '                      ng-click="vm.removeGroup($index)"\n' +
    '                      style="margin-top: 2ex; margin-bottom: 0.8ex;"><i class="fa fa-remove"></i> Gruppe löschen\n' +
    '                </span>\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <tags-input ng-model="group.values"\n' +
    '                        display-property="name"\n' +
    '                        placeholder="Tippen zum Vervollständigen"\n' +
    '                        replace-spaces-with-dashes="false"\n' +
    '                        ng-blur="vm.saveConfig()"\n' +
    '                        add-on-comma="false"\n' +
    '                        min-length="1"\n' +
    '                        tabindex="0"\n' +
    '                        enable-editing-last-tag="true"\n' +
    '                        on-tag-removed="vm.saveConfig()"\n' +
    '                        template="tag-template">\n' +
    '                <auto-complete source="vm.loadValues($query)"\n' +
    '                               min-length="0"\n' +
    '                               load-on-focus="false"\n' +
    '                               load-on-down-arrow="true"\n' +
    '                               load-on-empty="true"\n' +
    '                               max-results-to-show="32"\n' +
    '                               template="autocomplete-template"></auto-complete>\n' +
    '            </tags-input>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <script type="text/ng-template" id="tag-template">\n' +
    '        <div class="tag-template">\n' +
    '            <div class="right-panel">\n' +
    '                <span>{{$getDisplayText()}}</span>\n' +
    '                <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '\n' +
    '    <script type="text/ng-template" id="autocomplete-template">\n' +
    '        <div class="autocomplete-template">\n' +
    '            <div>\n' +
    '                <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '</form>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/labreferral-component.tpl.html',
    '<div>\n' +
    '  <form class="form-vertical">\n' +
    '    <div class="row">\n' +
    '\n' +
    '      <!-- value groups -->\n' +
    '      <div ng-repeat="group in vm.labconfig.groups">\n' +
    '        <div class="form-group col-md-4">\n' +
    '          <label>\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="vm.ginclude[$index]"\n' +
    '                   tabindex="0"\n' +
    '                   ng-checked="vm.ginclude[$index]"\n' +
    '                   ng-init="vm.ginclude[$index] = false"\n' +
    '                   ng-click="vm.toggleGroup()"/> {{group.name}}</label>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- add additional values -->\n' +
    '    <label for="addlabval">Zusätzliche Laborwerte</label>\n' +
    '    <tags-input ng-model="vm.additionalvalues"\n' +
    '                ng-init="vm.additionalvalues = []"\n' +
    '                tabindex="0"\n' +
    '                display-property="name" id="addlabval"\n' +
    '                add-on-comma="false"\n' +
    '                min-length="1"\n' +
    '                placeholder="Tippen zum Vervollständigen"\n' +
    '                replace-spaces-with-dashes="false"\n' +
    '                on-tag-added="vm.joinValues()"\n' +
    '                on-tag-removed="vm.joinValues()"\n' +
    '                template="tag-template">\n' +
    '      <auto-complete source="vm.loadValues($query)"\n' +
    '                     min-length="1"\n' +
    '                     load-on-focus="false"\n' +
    '                     load-on-down-arrow="true"\n' +
    '                     load-on-empty="true"\n' +
    '                     max-results-to-show="32"\n' +
    '                     template="autocomplete-template"></auto-complete>\n' +
    '    </tags-input>\n' +
    '\n' +
    '    <!-- selected values -->\n' +
    '    <h4>Ausgewählte Laborwerte</h4>\n' +
    '\n' +
    '<!--    <div class="alert alert-info">\n' +
    '      <span ng-show="vm.allvalues.length > 0" ng-repeat="val in vm.allvalues">{{val}}{{$last ? \'\' : \', \'}} </span>\n' +
    '      <span ng-hide="vm.allvalues.length > 0">Keine Werte ausgewählt</span>\n' +
    '    </div>-->\n' +
    '\n' +
    '    <div class="form-group">\n' +
    '      <label for="addlabval">Ausgewählte Laborwerte (Gruppen und Einzelwerte)</label>\n' +
    '      <tags-input ng-model="vm.filtered"\n' +
    '                  tabindex="0"\n' +
    '                  useStrings="true"\n' +
    '                  id="dellabval"\n' +
    '                  min-length="1"\n' +
    '                  placeholder="Unerwünschte Laborwerte löschen"\n' +
    '                  replace-spaces-with-dashes="false"\n' +
    '                  on-tag-removed="vm.deleteLabVal($tag)"\n' +
    '                  template="tag-template">\n' +
    '        <auto-complete source="vm.loadValues($query)"\n' +
    '                       min-length="1"\n' +
    '                       load-on-focus="false"\n' +
    '                       load-on-down-arrow="true"\n' +
    '                       load-on-empty="true"\n' +
    '                       max-results-to-show="32"\n' +
    '                       template="autocomplete-template"></auto-complete>\n' +
    '      </tags-input>\n' +
    '    </div>\n' +
    '    <div class="form-group">\n' +
    '      <label for="addlabval">Ausgeschlossene Laborwerte</label>\n' +
    '      <tags-input ng-model="vm.deleteList"\n' +
    '                  tabindex="0"\n' +
    '                  useStrings="true"\n' +
    '                  id="undellabval"\n' +
    '                  min-length="1"\n' +
    '                  placeholder=""\n' +
    '                  replace-spaces-with-dashes="false"\n' +
    '                  on-tag-removed="vm.undeleteLabVal($tag)"\n' +
    '                  template="tag-template">\n' +
    '        <auto-complete source="vm.loadValues($query)"\n' +
    '                       min-length="1"\n' +
    '                       load-on-focus="false"\n' +
    '                       load-on-down-arrow="true"\n' +
    '                       load-on-empty="true"\n' +
    '                       max-results-to-show="32"\n' +
    '                       template="autocomplete-template"></auto-complete>\n' +
    '      </tags-input>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '  <script type="text/ng-template" id="tag-template">\n' +
    '    <div class="tag-template">\n' +
    '      <div class="right-panel">\n' +
    '        <span>{{$getDisplayText()}}</span>\n' +
    '        <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </script>\n' +
    '\n' +
    '\n' +
    '  <script type="text/ng-template" id="autocomplete-template">\n' +
    '    <div class="autocomplete-template">\n' +
    '      <div>\n' +
    '        <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </script>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/imagingreferral-component.tpl.html',
    '<div>\n' +
    '    <form class="form-inline">\n' +
    '        <div class="row">\n' +
    '\n' +
    '            <!-- value groups -->\n' +
    '            <div ng-repeat="group in vm.imagingconfig.groups">\n' +
    '                <div class="form-group col-md-4">\n' +
    '                    <label>\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.ginclude[$index]"\n' +
    '                               tabindex="0"\n' +
    '                               ng-checked="vm.ginclude[$index]"\n' +
    '                               ng-init="vm.ginclude[$index] = false"\n' +
    '                               ng-click="vm.toggleGroup()"/> {{group.name}}</label>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- add additional values -->\n' +
    '        <label for="addimagingval">Zusätzliche Untersuchungn</label>\n' +
    '        <tags-input ng-model="vm.additionalvalues"\n' +
    '                    ng-init="vm.additionalvalues = []"\n' +
    '                    tabindex="0"\n' +
    '                    display-property="name" id="addimagingval"\n' +
    '                    add-on-comma="false"\n' +
    '                    min-length="1"\n' +
    '                    placeholder="Tippen zum Vervollständigen"\n' +
    '                    replace-spaces-with-dashes="false"\n' +
    '                    on-tag-added="vm.joinValues()"\n' +
    '                    on-tag-removed="vm.joinValues()"\n' +
    '                    template="tag-template">\n' +
    '            <auto-complete source="vm.loadValues($query)"\n' +
    '                           min-length="1"\n' +
    '                           load-on-focus="false"\n' +
    '                           load-on-down-arrow="true"\n' +
    '                           load-on-empty="true"\n' +
    '                           max-results-to-show="32"\n' +
    '                           template="autocomplete-template"></auto-complete>\n' +
    '        </tags-input>\n' +
    '\n' +
    '        <!-- selected values -->\n' +
    '        <h4>Ausgewählte Untersuchungen</h4>\n' +
    '\n' +
    '        <div class="alert alert-info">\n' +
    '            <span ng-show="vm.allvalues.length > 0" ng-repeat="val in vm.allvalues">{{val}}{{$last ? \'\' : \', \'}} </span>\n' +
    '            <span ng-hide="vm.allvalues.length > 0">Keine Untersuchungen ausgewählt</span>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '    </form>\n' +
    '    <script type="text/ng-template" id="tag-template">\n' +
    '        <div class="tag-template">\n' +
    '            <div class="right-panel">\n' +
    '                <span>{{$getDisplayText()}}</span>\n' +
    '                <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '\n' +
    '    <script type="text/ng-template" id="autocomplete-template">\n' +
    '        <div class="autocomplete-template">\n' +
    '            <div>\n' +
    '                <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/imagingconfig-component.tpl.html',
    '<div class="spacer-bottom">\n' +
    '\n' +
    '<h2>Bildgebende Verfahren</h2>\n' +
    '\n' +
    '<h3>Verfahren</h3>\n' +
    '\n' +
    '<tags-input ng-model="vm.imagingconfig.values"\n' +
    '            display-property="name"\n' +
    '            placeholder="Neues bildgebendes Verfahren hinzufügen ..."\n' +
    '            replace-spaces-with-dashes="false"\n' +
    '            add-on-comma="false"\n' +
    '            min-length="1"\n' +
    '            on-tag-added="vm.saveConfig()"\n' +
    '            on-tag-removed="vm.saveConfig()"\n' +
    '            template="tag-template">\n' +
    '    <auto-complete source="vm.loadValues($query)"\n' +
    '                   min-length="0"\n' +
    '                   load-on-focus="true"\n' +
    '                   load-on-empty="true"\n' +
    '                   max-results-to-show="32"\n' +
    '                   template="autocomplete-template"></auto-complete>\n' +
    '</tags-input>\n' +
    '\n' +
    '\n' +
    '<h3>Neue Gruppe</h3>\n' +
    '\n' +
    '\n' +
    '<form>\n' +
    '    <div class="input-group">\n' +
    '        <input class="form-control"\n' +
    '               ng-model="vm.newgroup" id="newgroup" placeholder="Neue Laborwertgruppe"/>\n' +
    '        <span class="input-group-btn">\n' +
    '          <button class="btn btn-success"\n' +
    '                  type="submit"\n' +
    '                  ng-click="vm.addGroup()"><i class="fa fa-plus"></i> Neue Gruppe anlegen</button>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '</form>\n' +
    '\n' +
    '<h3>Gruppen</h3>\n' +
    '<form class="form-vertical">\n' +
    '    <div ng-repeat="group in vm.imagingconfig.groups" class="spacer-top">\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="pull-left" ng-bind="group.name" style="font-weight: bold; padding-top: 20px"></span>\n' +
    '            <span class="pull-right">\n' +
    '                <span class="btn btn-danger btn-sm"\n' +
    '                      ng-click="vm.removeGroup($index)"\n' +
    '                      style="margin-top: 2ex; margin-bottom: 0.8ex;"><i class="fa fa-remove"></i> Gruppe löschen\n' +
    '                </span>\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <tags-input ng-model="group.values"\n' +
    '                        display-property="name"\n' +
    '                        placeholder="Tippen zum Vervollständigen"\n' +
    '                        replace-spaces-with-dashes="false"\n' +
    '                        ng-blur="vm.saveConfig()"\n' +
    '                        add-on-comma="false"\n' +
    '                        min-length="1"\n' +
    '                        tabindex="0"\n' +
    '                        enable-editing-last-tag="true"\n' +
    '                        on-tag-removed="vm.saveConfig()"\n' +
    '                        template="tag-template">\n' +
    '                <auto-complete source="vm.loadValues($query)"\n' +
    '                               min-length="0"\n' +
    '                               load-on-focus="false"\n' +
    '                               load-on-down-arrow="true"\n' +
    '                               load-on-empty="true"\n' +
    '                               max-results-to-show="32"\n' +
    '                               template="autocomplete-template"></auto-complete>\n' +
    '            </tags-input>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <script type="text/ng-template" id="tag-template">\n' +
    '        <div class="tag-template">\n' +
    '            <div class="right-panel">\n' +
    '                <span>{{$getDisplayText()}}</span>\n' +
    '                <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '\n' +
    '    <script type="text/ng-template" id="autocomplete-template">\n' +
    '        <div class="autocomplete-template">\n' +
    '            <div>\n' +
    '                <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '</form>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcpatdocs/aideconfig-component.tpl.html',
    '<div class="spacer-bottom">\n' +
    '<h2>Heilbehelfe &amp; Hilfsmittelgruppen</h2>\n' +
    '\n' +
    '<h3>Heil- &amp; Hilfsmittel</h3>\n' +
    '\n' +
    '<tags-input ng-model="vm.aideconfig.values"\n' +
    '            display-property="name"\n' +
    '            placeholder="Neuen Heilbehelf hinzufügen"\n' +
    '            replace-spaces-with-dashes="false"\n' +
    '            add-on-comma="false"\n' +
    '            min-length="1"\n' +
    '            on-tag-added="vm.saveConfig()"\n' +
    '            on-tag-removed="vm.saveConfig()"\n' +
    '            template="tag-template">\n' +
    '    <auto-complete source="vm.loadValues($query)"\n' +
    '                   min-length="0"\n' +
    '                   load-on-focus="true"\n' +
    '                   load-on-empty="true"\n' +
    '                   max-results-to-show="32"\n' +
    '                   template="autocomplete-template"></auto-complete>\n' +
    '</tags-input>\n' +
    '\n' +
    '\n' +
    '<h3>Neue Gruppe</h3>\n' +
    '\n' +
    '<form>\n' +
    '    <div class="input-group">\n' +
    '        <input class="form-control"\n' +
    '               ng-model="vm.newgroup" id="newgroup" placeholder="Neue Laborwertgruppe"/>\n' +
    '        <span class="input-group-btn">\n' +
    '          <button class="btn btn-success"\n' +
    '                  type="submit"\n' +
    '                  ng-click="vm.addGroup()"><i class="fa fa-plus"></i> Neue Gruppe anlegen</button>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '</form>\n' +
    '\n' +
    '<h3>Gruppen</h3>\n' +
    '<form class="form-vertical">\n' +
    '    <div ng-repeat="group in vm.aideconfig.groups" class="spacer-top">\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <span class="pull-left" ng-bind="group.name" style="font-weight: bold; padding-top: 20px"></span>\n' +
    '            <span class="pull-right">\n' +
    '                <span class="btn btn-danger btn-sm"\n' +
    '                      ng-click="vm.removeGroup($index)"\n' +
    '                      style="margin-top: 2ex; margin-bottom: 0.8ex;"><i class="fa fa-remove"></i> Gruppe löschen\n' +
    '                </span>\n' +
    '            </span>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <tags-input ng-model="group.values"\n' +
    '                        display-property="name"\n' +
    '                        placeholder="Tippen zum Vervollständigen"\n' +
    '                        replace-spaces-with-dashes="false"\n' +
    '                        ng-blur="vm.saveConfig()"\n' +
    '                        add-on-comma="false"\n' +
    '                        min-length="1"\n' +
    '                        tabindex="0"\n' +
    '                        enable-editing-last-tag="true"\n' +
    '                        on-tag-removed="vm.saveConfig()"\n' +
    '                        template="tag-template">\n' +
    '                <auto-complete source="vm.loadValues($query)"\n' +
    '                               min-length="0"\n' +
    '                               load-on-focus="false"\n' +
    '                               load-on-down-arrow="true"\n' +
    '                               load-on-empty="true"\n' +
    '                               max-results-to-show="32"\n' +
    '                               template="autocomplete-template"></auto-complete>\n' +
    '            </tags-input>\n' +
    '        </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <script type="text/ng-template" id="tag-template">\n' +
    '        <div class="tag-template">\n' +
    '            <div class="right-panel">\n' +
    '                <span>{{$getDisplayText()}}</span>\n' +
    '                <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '\n' +
    '    <script type="text/ng-template" id="autocomplete-template">\n' +
    '        <div class="autocomplete-template">\n' +
    '            <div>\n' +
    '                <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </script>\n' +
    '\n' +
    '</form>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexamtemplate/examtemplateform-component.tpl.html',
    '<form class="form-vertical" id="editexamtemplateform" data-hook="editexamtemplateform">\n' +
    '\n' +
    '\n' +
    '  <!-- Template Editor Main -->\n' +
    '  <div class="form-group myform">\n' +
    '    <label>Kürzel/Typ\n' +
    '      <input type="text" ng-model="vm.examtemplate.template.type" class="form-control"\n' +
    '             ng-blur="vm.examtemplate.$save()" placeholder="Kürzel/Typ"></label>\n' +
    '  </div>\n' +
    '  <div class="form-group myform">\n' +
    '    <label>Vollständige Bezeichnung\n' +
    '      <input type="text" ng-model="vm.examtemplate.template.displayname" class="form-control"\n' +
    '             ng-blur="vm.examtemplate.$save()" placeholder="Vollständige Bezeichnung"></label>\n' +
    '  </div>\n' +
    '  <div class="form-group myform">\n' +
    '    <label>Quellenangabe\n' +
    '      <input type="text" ng-model="vm.examtemplate.template.sources" class="form-control"\n' +
    '             ng-blur="vm.examtemplate.$save()"\n' +
    '             placeholder="y.B. Deutsche Herzgesellschaft, Lehrbuch der Endoskopie ..."></label>\n' +
    '  </div>\n' +
    '  <div class="form-group">\n' +
    '    <label>Befundinhalte in Gesamtbefund inkludieren\n' +
    '      <div class="radio">\n' +
    '        <label for="tinc1" class="radio-inline"><input type="radio" ng-value="true"\n' +
    '                                                       ng-model="vm.examtemplate.template.includefindings"\n' +
    '                                                       id="tinc1">Ja</label>\n' +
    '        <label for="tinc2" class="radio-inline"><input type="radio" ng-value="false"\n' +
    '                                                       ng-model="vm.examtemplate.template.includefindings"\n' +
    '                                                       id="tinc2">Nein</label>\n' +
    '      </div>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!--  Networkgrabber  -->\n' +
    '  <div class="form-group">\n' +
    '    <label>Bilder/Dateien von Netzwerklaufwerk einbeziehen\n' +
    '      <div class="radio">\n' +
    '        <label for="tnet1" class="radio-inline"><input type="radio" ng-value="true"\n' +
    '                                                       ng-model="vm.examtemplate.template.loadfiles"\n' +
    '                                                       id="tnet1">Ja</label>\n' +
    '        <label for="tnet2" class="radio-inline"><input type="radio" ng-value="false"\n' +
    '                                                       ng-model="vm.examtemplate.template.loadfiles"\n' +
    '                                                       id="tnet2">Nein</label>\n' +
    '      </div>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group" ng-show="vm.examtemplate.template.loadfiles === true">\n' +
    '    <label for="tname">Netzwerklaufwerk</label>\n' +
    '    <select ng-model="vm.examtemplate.template.shareid" class="form-control" id="tname">\n' +
    '      <option ng-repeat="share in vm.allshares" value="{{share._id}}">{{share.name}}</option>\n' +
    '    </select>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="alert alert-warning" ng-show="vm.shareserror" ng-bind="vm.gdtperror"></div>\n' +
    '\n' +
    '\n' +
    '  <!--  DICOM Configuration   -->\n' +
    '\n' +
    '  <div class="form-group">\n' +
    '    <label>DICOM Untersuchung\n' +
    '      <div class="radio">\n' +
    '        <label for="isdicom1" class="radio-inline"><input type="radio" ng-value="true"\n' +
    '                                                          ng-model="vm.examtemplate.template.isdicom"\n' +
    '                                                          id="isdicom1">Ja</label>\n' +
    '        <label for="isdicom2" class="radio-inline"><input type="radio" ng-value="false"\n' +
    '                                                          ng-model="vm.examtemplate.template.isdicom"\n' +
    '                                                          id="isdicom2">Nein</label>\n' +
    '      </div>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="form-group" ng-show="vm.examtemplate.template.isdicom === true">\n' +
    '    <label for="dicommodalitytype">DICOM Modality Type</label>\n' +
    '    <select ng-model="vm.examtemplate.template.dicommodalitytype" class="form-control" id="dicommodalitytype">\n' +
    '      <option ng-repeat="mod in vm.modalitypes" value="{{mod.type}}">{{mod.text}}</option>\n' +
    '    </select>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group" ng-show="vm.examtemplate.template.isdicom === true">\n' +
    '    <label for="dicommodalityae">DICOM Modality AE Title</label>\n' +
    '    <select ng-model="vm.examtemplate.template.dicommodalityaetitle" class="form-control" id="dicommodalityae">\n' +
    '      <option ng-repeat="modname in vm.dicomaetitle.dicomaetitle" value="{{modname}}">{{modname}}</option>\n' +
    '    </select>\n' +
    '\n' +
    '    <div class="alert alert-warning" ng-show="vm.dicomerror" ng-bind="vm.dicomerror"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- GDT Configuration -->\n' +
    '  <div class="form-group">\n' +
    '    <label>GDT Untersuchung\n' +
    '      <div class="radio">\n' +
    '        <label for="isdicom1" class="radio-inline"><input type="radio" ng-value="true"\n' +
    '                                                          ng-model="vm.examtemplate.template.isgdt"\n' +
    '                                                          id="isgdt1">Ja</label>\n' +
    '        <label for="isdicom2" class="radio-inline"><input type="radio" ng-value="false"\n' +
    '                                                          ng-model="vm.examtemplate.template.isgdt"\n' +
    '                                                          id="isgdt2">Nein</label>\n' +
    '      </div>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group" ng-show="vm.examtemplate.template.isgdt === true">\n' +
    '    <label for="gdtsw">GDT Software Share</label>\n' +
    '    <select ng-model="vm.examtemplate.template.gdtsoftwareshareid" class="form-control" id="gdtsw">\n' +
    '      <option ng-repeat="share in vm.gdtshares " value="{{share._id}}${{share.name}}">{{share.name}}</option>\n' +
    '    </select>\n' +
    '  </div>\n' +
    '  <div class="alert alert-warning" ng-show="vm.gdtswerror" ng-bind="vm.gdtperror"></div>\n' +
    '\n' +
    '  <div class="form-group" ng-show="vm.examtemplate.template.isgdt === true">\n' +
    '    <label for="dicommodalityae">GDT Profil</label>\n' +
    '    <select ng-model="vm.examtemplate.template.gdtprofil" class="form-control" id="gdtprofil">\n' +
    '      <option ng-repeat="profil in vm.gdtprofil.gdtprofil" value="{{profil}}">{{profil}}</option>\n' +
    '    </select>\n' +
    '\n' +
    '    <div class="alert alert-warning" ng-show="vm.gdtperror" ng-bind="vm.gdtperror"></div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!--  Template Layout   -->\n' +
    '  <div class="form-group">\n' +
    '    <!-- TODO: add layout help pdf-->\n' +
    '    <label>Vorlagenlayout\n' +
    '      <sprhelp tip="Vorlagenlayout" descref="vm.sprlayout" file="templatelayouthelp.pdf"></sprhelp>\n' +
    '      <div class="radio">\n' +
    '        <label for="tinc1" class="radio-inline"><input type="radio" value="col"\n' +
    '                                                       ng-model="vm.examtemplate.template.layout"\n' +
    '                                                       id="layout1">Spaltenorientiert</label>\n' +
    '        <label for="tinc2" class="radio-inline"><input type="radio" value="row"\n' +
    '                                                       ng-model="vm.examtemplate.template.layout"\n' +
    '                                                       id="layout2">Zeilenorientiert</label>\n' +
    '      </div>\n' +
    '    </label>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div>\n' +
    '    <h4>Feldgruppen</h4>\n' +
    '    <a class="btn btn-success"\n' +
    '       ng-click="vm.newFieldGroup()"\n' +
    '       style="margin-right: 8px;">\n' +
    '      <i class="fa fa-plus"></i> Neue Kategorie/Feldgruppe hinzuf&uuml;gen\n' +
    '    </a>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="clear: both"></div>\n' +
    '  <!-- main exameditor tree -->\n' +
    '  <div ui-tree class="mtree" data-drag-delay="100" data-max-depth="2">\n' +
    '    <ol ui-tree-nodes="" ng-model="vm.examtemplate.template.fieldgroups">\n' +
    '      <li ui-tree-node ng-repeat="fieldgroup in vm.examtemplate.template.fieldgroups" data-drag-delay="100"\n' +
    '          data-expand-on-hover="500">\n' +
    '        <div class="tree-node tree-node-content" data-drag-delay="100">\n' +
    '          <!-- Fieldgroup title, edit title -->\n' +
    '          <span class="pull-left">\n' +
    '                        <a class="btn btn-success btn-xs" style="margin-left: 8px"\n' +
    '                           ng-if="fieldgroup.fields && fieldgroup.fields.length > 0"\n' +
    '                           data-nodrag ng-click="toggle(this)">\n' +
    '                            <i class="fa"\n' +
    '                               ng-class="{\'fa-chevron-up\': collapsed, \'fa-chevron-down\': !collapsed }"></i>\n' +
    '                        </a>\n' +
    '            <!-- TODO: make nicer version of label editing -->\n' +
    '            <!-- prepared fieldgroupnamewidget and functions, but ui-tree can\'t easily access callerscope -->\n' +
    '            <!--                    <span ng-hide="fieldgroup.label == \'\'">\n' +
    '                                    {{fieldgroup.label}}&nbsp;\n' +
    '                                    <span class="btn btn-primary btn-xs" uib-tooltip="Kategorie/Feldgruppe umbennen" ng-click="$parent.$parent.$parent.$parent.vm.showFGN($index)">\n' +
    '                                        <i class="fa fa-pencil"></i>\n' +
    '                                    </span>\n' +
    '                                    <span class="btn btn-primary btn-xs" uib-tooltip="Alle Felder in &laquo;Felder ohne Kategorie&raquo; umwandeln"\n' +
    '                                          ng-click="fieldgroup.label = \'\'">\n' +
    '                                        <i class="fa fa-chevron-left"></i><i class="fa fa-outdent"></i>\n' +
    '                                    </span>\n' +
    '                                </span>\n' +
    '                                <span ng-show="fieldgroup.label == \'\'">\n' +
    '                                    Felder ohne Gruppe&nbsp;\n' +
    '                                    <span class="btn btn-primary btn-xs" uib-tooltip="Alle Felder zu &laquo;Feldern in einer Kategorie&raquo; umwandeln">\n' +
    '                                        <i class="fa fa-chevron-right" ng-click="$parent.$parent.$parent.$parent.$parent.vm.showFGN($index)"></i><i class="fa fa-indent"></i>\n' +
    '                                    </span>\n' +
    '                                </span>-->\n' +
    '\n' +
    '            <!--<fieldgroupname ng-show="$parent.$parent.$parent.$parent.vm.fgnshow[$index]" fgname="fieldgroup.label" ondone="$parent.$parent.$parent.$parent.vm.hideFGN($index)"></fieldgroupname>-->\n' +
    '            <!--                    <input type="text" data-nodrag\n' +
    '                                       ng-model-options="{ updateOn: \'default blur\', debounce: { default: 500, blur: 0 } }"\n' +
    '                                       class="form-control small-input"\n' +
    '                                       ng-model="fieldgroup.label"/>-->\n' +
    '                        <span ng-hide="fieldgroup.label === \'\'">\n' +
    '                            {{fieldgroup.label}}\n' +
    '                            <input type="text" data-nodrag\n' +
    '                                   ng-model-options="{ updateOn: \'blur default\', debounce: { default: 500, blur: 0 } }"\n' +
    '                                   class="form-control small-input"\n' +
    '                                   ng-model="fieldgroup.label">\n' +
    '                        </span>\n' +
    '                        <span ng-show="fieldgroup.label === \'\'">Felder ohne Gruppe\n' +
    '                          <input type="text" class="form-control small-input" ng-model="fieldgroup.label"\n' +
    '                                 ng-model-options="{ updateOn: \'blur default\', debounce: { default: 500, blur: 0 } }"\n' +
    '                                 data-nodrag\n' +
    '                                 uib-tooltip="Leer lassen damit Felder direkt ohne Feldgruppe erscheinen">\n' +
    '                        </span>\n' +
    '                    </span>\n' +
    '          <!-- Fieldgroup action buttons -->\n' +
    '          <span class="pull-right">\n' +
    '                        <!-- add field to fieldgroup -->\n' +
    '                        <a class="btn btn-success btn-xs"\n' +
    '                           uib-tooltip="Neues Feld in diese Gruppe einfügen"\n' +
    '                           data-nodrag ng-click="vm.newSubItem(this)"\n' +
    '                           style="margin-right: 8px;">\n' +
    '                            <i class="fa fa-plus"></i>\n' +
    '                        </a>\n' +
    '            <!-- delete fieldgroup -->\n' +
    '                        <a class="btn btn-danger btn-xs"\n' +
    '                           uib-tooltip="Feldgruppe Löschen"\n' +
    '                           data-nodrag\n' +
    '                           ng-really-click="vm.remove(this)"\n' +
    '                           ng-really-message="Wollen Sie diese Kategorie/Feldgruppe wirklich l&ouml;schen? Diese &Auml;nderung kann nicht r&uuml;ckg&auml;ngig gemacht werden!"\n' +
    '                        >\n' +
    '                            <i class="fa fa-remove"></i>\n' +
    '                        </a>\n' +
    '            <!-- drag handle -->\n' +
    '                        <a class="btn btn-info btn-xs" style="margin-right: 8px;"\n' +
    '                           uib-tooltip="Ziehen um die Gruppen umzusortieren"\n' +
    '                           ui-tree-handle>\n' +
    '                            <i class="fa fa-bars"></i>\n' +
    '                        </a>\n' +
    '                    </span>\n' +
    '          <span class="clearfix"></span>\n' +
    '        </div>\n' +
    '        <!-- render fields of fieldgroup using custom template included below -->\n' +
    '        <ol ui-tree-nodes="" ng-model="fieldgroup.fields" ng-class="{\'hidden\': !collapsed}">\n' +
    '          <li ui-tree-node\n' +
    '              ng-repeat="field in fieldgroup.fields"\n' +
    '              ng-include="\'field_renderer.html\'">\n' +
    '            <div ui-tree-handle>\n' +
    '              {{field.label}}\n' +
    '            </div>\n' +
    '        </ol>\n' +
    '      </li>\n' +
    '      <!-- ui-tree-node -->\n' +
    '    </ol>\n' +
    '    <!-- ui-tree-nodes -->\n' +
    '  </div>\n' +
    '  <!-- ui-tree -->\n' +
    '\n' +
    '<!--  Spezialfelder: Biopsie, Kommentar, Diagnose/Zusammenfassung, Emfehlung/Therapie-->\n' +
    '  <div ng-hide="vm.examtemplate.template.includefindings" class="spacer-bottom spacer-top">\n' +
    '    <h4>Zusatzfelder</h4>\n' +
    '    <!-- pseduo tree for named fields -->\n' +
    '    <div ui-tree data-nodrop-enabled="true" data-drag-enabled="false" class="mtree">\n' +
    '      <ol ui-tree-nodes="" ng-model="vm.examtemplate.template" data-nodrop-enabled="true"\n' +
    '          data-drag-enabled="false">\n' +
    '        <li ui-tree-node ng-model="vm.examtemplate.template.biopsy"\n' +
    '            ng-if="vm.examtemplate.template.biopsy"\n' +
    '            data-drag-enabled="false"\n' +
    '            ng-include="\'biopsy_renderer.html\'">\n' +
    '          <div ui-tree-handle>\n' +
    '            {{vm.examtemplate.template.biopsy.label}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li ui-tree-node ng-model="vm.examtemplate.template.comment"\n' +
    '            ng-if="vm.examtemplate.template.comment"\n' +
    '            data-drag-enabled="false"\n' +
    '            ng-include="\'comment_renderer.html\'">\n' +
    '          <div ui-tree-handle>\n' +
    '            {{vm.examtemplate.template.comment.label}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li ui-tree-node\n' +
    '            ng-model="vm.examtemplate.template.diagnosis"\n' +
    '            ng-if="vm.examtemplate.template.diagnosis"\n' +
    '            data-drag-enabled="false"\n' +
    '            ng-include="\'diagnosis_renderer.html\'">\n' +
    '          <div ui-tree-handle>\n' +
    '            {{vm.examtemplate.template.diagnosis.label}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '        <li ui-tree-node ng-model="vm.examtemplate.template.recommendation"\n' +
    '            ng-if="vm.examtemplate.template.recommendation"\n' +
    '            data-drag-enabled="false"\n' +
    '            ng-include="\'recommendation_renderer.html\'">\n' +
    '          <div ui-tree-handle>\n' +
    '            {{vm.examtemplate.template.recommendation.label}}\n' +
    '          </div>\n' +
    '        </li>\n' +
    '      </ol>\n' +
    '      <div class="spacer-top spacer-bottom">\n' +
    '        <div ng-hide="vm.examtemplate.template.biopsy"\n' +
    '             class="btn btn-success"\n' +
    '             ng-click="vm.addNamedField(\'biopsy\')">Biopsiefeld hinzufügen\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-hide="vm.examtemplate.template.diagnosis"\n' +
    '             class="btn btn-success"\n' +
    '             ng-click="vm.addNamedField(\'diagnosis\')">Diagnose-/Zusammenfassungsfeld hinzufügen\n' +
    '        </div>\n' +
    '        <div ng-hide="vm.examtemplate.template.recommendation"\n' +
    '             class="btn btn-success"\n' +
    '             ng-click="vm.addNamedField(\'recommendation\')">(Therapie-) Empfehlungsfeld hinzufügen\n' +
    '        </div>\n' +
    '        <div ng-hide="vm.examtemplate.template.comment"\n' +
    '             class="btn btn-success"\n' +
    '             ng-click="vm.addNamedField(\'comment\')">Kommentarfeld hinzufügen\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Default Services for exam-->\n' +
    '  <div class="row spacer-top spacer-bottom">\n' +
    '    <div class="col-xs-12">\n' +
    '\n' +
    '      <div class="panel panel-default">\n' +
    '        <div class="panel-heading"><h4>Rechnungspositionen für diese Untersuchung</h4></div>\n' +
    '        <div class="panel-body">\n' +
    '          <div class="alert alert-info spacer-top spacer-bottom">Wenn Sie Leistungspositionen und/oder Leistungsgruppen mit dieser Untersuchungsvorlage verknüpfen,\n' +
    '            werden die Leistungspositionen/-gruppen beim Start der Untersuchung automatisch zur Rechnung hinzugefügt.</div>\n' +
    '          <label>Suche nach Leistungsositionen</label>\n' +
    '          <privcatsearch onselectcb="vm.addCatItem(privcat, privcatref)" editinplace="false"\n' +
    '                         privcat="" privcatref=""\n' +
    '                         hideaddoption="true"></privcatsearch>\n' +
    '          <label>Leistungsgruppen hinzufügen</label>\n' +
    '          <privcatgroupchooser onselectcb="vm.addCatGroup(privcat, privcatref)"></privcatgroupchooser>\n' +
    '          <div ng-show="vm.examtemplate.template.services.items.length">\n' +
    '            <label>Gewählte Leistungen</label>\n' +
    '            <ul>\n' +
    '              <li ng-repeat="item in vm.examtemplate.template.services.items">\n' +
    '                <span class="pull-left">{{item.name}}</span>\n' +
    '                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeCatItem($index)">\n' +
    '                        <i class="fa fa-remove"></i>\n' +
    '                    </span>\n' +
    '                <span class="clearfix"></span>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '          <div ng-show="vm.examtemplate.template.services.groups.length">\n' +
    '            <label>Gewählte Leistungsgruppen</label>\n' +
    '            <ul>\n' +
    '              <li ng-repeat="item in vm.examtemplate.template.services.groups">\n' +
    '                <span class="pull-left">{{item.name}}</span>\n' +
    '                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeCatGroup($index)">\n' +
    '                        <i class="fa fa-remove"></i>\n' +
    '                    </span>\n' +
    '                <span class="clearfix"></span>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Tracker fields for exam-->\n' +
    '  <div class="row spacer-top spacer-bottom">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="panel panel-default">\n' +
    '        <div class="panel-heading"><h4>Tracker Dateneingabe für diese Untersuchung</h4></div>\n' +
    '        <div class="panel-body">\n' +
    '          <div class="alert alert-info spacer-top spacer-bottom">Wenn Sie einen Tracker mit dieser Untersuchungsvorlage verknüpfen,\n' +
    '            erscheint das Tracker Eingabefeld im Untersuchungsformular.\n' +
    '            Der aktuelle Wert wird in der Untersuchung gespeichert und ausgegeben und erscheint zusätzlich im Tracker.</div>\n' +
    '          <label>Tracker hinzufügen</label>\n' +
    '          <trackerchooser onselectcb="vm.addTracker(tracker)"></trackerchooser>\n' +
    '          <div ng-show="vm.examtemplate.template.trackers.length" class="spacer-top">\n' +
    '            <label>Gewählte Tracker</label>\n' +
    '            <ul>\n' +
    '              <li ng-repeat="tracker in vm.examtemplate.template.trackers">\n' +
    '                <span class="pull-left">{{tracker.name}}</span>\n' +
    '                <span class="pull-right btn btn-danger btn-xs" ng-click="vm.removeTracker($index)">\n' +
    '                          <i class="fa fa-remove"></i>\n' +
    '                        </span>\n' +
    '                <span class="clearfix"></span>\n' +
    '              </li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Speichern, Abbrechen -->\n' +
    '  <div class="row spacer-top">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>\n' +
    '\n' +
    '\n' +
    '<!-- ######################################################################################## -->\n' +
    '<!-- Inline Templates                                                                         -->\n' +
    '<!-- ######################################################################################## -->\n' +
    '\n' +
    '<!-- Nested field render template -->\n' +
    '<script type="text/ng-template" id="field_renderer.html">\n' +
    '  <div class="tree-node tree-node-content">\n' +
    '    <div style="margin: 8px">\n' +
    '      <div>\n' +
    '                <span class="pull-left">\n' +
    '                    <a class="btn btn-success btn-xs"\n' +
    '                       uib-tooltip="Feld editieren"\n' +
    '                       data-nodrag ng-click="ecollapsed=!ecollapsed">\n' +
    '                        <i class="fa fa-chevron-down" ng-show="ecollapsed"></i>\n' +
    '                        <i class="fa fa-chevron-up" ng-hide="ecollapsed"></i>\n' +
    '                    </a>\n' +
    '                    {{field.label}}</span>\n' +
    '        <span class="pull-right">\n' +
    '                    <!-- edit -->\n' +
    '                    <a class="btn btn-primary btn-xs"\n' +
    '                       uib-tooltip="Feld editieren"\n' +
    '                       data-nodrag ng-click="ecollapsed=!ecollapsed"\n' +
    '                       style="margin-right: 8px;">\n' +
    '                        <i class="fa fa-edit"></i>\n' +
    '                    </a>\n' +
    '          <!-- remove -->\n' +
    '                    <a class="btn btn-danger btn-xs"\n' +
    '                       uib-tooltip="Feld entfernen"\n' +
    '                       data-nodrag ng-really-click="vm.remove(this)"\n' +
    '                       ng-really-message="Wollen Sie dieses Feld wirklich l&ouml;schen? Diese &Auml;nderung kann nicht r&uuml;ckg&auml;ngig gemacht werden!">\n' +
    '                        <i class="fa fa-remove"></i>\n' +
    '                    </a>\n' +
    '          <!-- drag handle -->\n' +
    '                    <a class="btn btn-info btn-xs"\n' +
    '                       uib-tooltip="Ziehen um die Gruppen umzusortieren"\n' +
    '                       ui-tree-handle>\n' +
    '                        <i class="fa fa-bars"></i>\n' +
    '                    </a>\n' +
    '                </span>\n' +
    '        <span class="clearfix"></span>\n' +
    '\n' +
    '\n' +
    '        <div id="meta{{$index}}" ng-class="{\'hidden\':ecollapsed}" ng-init="ecollapsed = true">\n' +
    '          <div class="form-group">\n' +
    '            <label>Feldname\n' +
    '              <input type="text" ng-model="field.label" class="form-control" data-nodrag></label>\n' +
    '          </div>\n' +
    '          <div class="form-group">\n' +
    '            <label uib-tooltip="Wird automatisch in der Vorlage vorausgefüllt">Standardwert(e)\n' +
    '              <tags-input ng-model="field.avalues" data-nodrag\n' +
    '                          display-property="name"\n' +
    '                          add-on-comma="false"\n' +
    '                          enableEditingLastTag="true"\n' +
    '                          placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                          replace-spaces-with-dashes="false"\n' +
    '                          template="tag-template">\n' +
    '              </tags-input>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '          <div class="form-group">\n' +
    '            <label>Mögliche Werte\n' +
    '              <tags-input ng-model="field.values" data-nodrag\n' +
    '                          display-property="name"\n' +
    '                          add-on-comma="false"\n' +
    '                          enableEditingLastTag="true"\n' +
    '                          min-length="1"\n' +
    '                          placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                          replace-spaces-with-dashes="false"\n' +
    '                          template="tag-template">\n' +
    '              </tags-input>\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Nested biopsy render template -->\n' +
    '<script type="text/ng-template" id="biopsy_renderer.html">\n' +
    '  <div ui-tree-handle class="tree-node tree-node-content">\n' +
    '    <div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-10">\n' +
    '          {{vm.examtemplate.template.biopsy.label}}\n' +
    '          <div ng-class="{\'hidden\':ecollapsed}" ng-init="ecollapsed = true">\n' +
    '            <div class="form-group">\n' +
    '              <label>Feldname\n' +
    '                <input type="text" ng-model="vm.examtemplate.template.biopsy.label"\n' +
    '                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Defaultwert(e)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.biopsy.avalues"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Mögliche Werte (mit Eingabetaste trennen)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.biopsy.values"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-2">\n' +
    '          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField(\'biopsy\')">\n' +
    '            <span class="fa fa-remove"></span>\n' +
    '          </a>\n' +
    '          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"\n' +
    '             style="margin-right: 8px;">\n' +
    '            <span\n' +
    '                class="fa fa-edit"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Nested comment render template -->\n' +
    '<script type="text/ng-template" id="comment_renderer.html">\n' +
    '  <div ui-tree-handle class="tree-node tree-node-content">\n' +
    '    <div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-10">\n' +
    '          {{vm.examtemplate.template.comment.label}}\n' +
    '          <div ng-class="{\'hidden\':ecollapsed}" ng-init="ecollapsed = true">\n' +
    '            <div class="form-group">\n' +
    '              <label>Feldname\n' +
    '                <input type="text" ng-model="vm.examtemplate.template.comment.label"\n' +
    '                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Defaultwert(e)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.comment.avalues"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.comment.values"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-2">\n' +
    '          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField(\'comment\')">\n' +
    '            <span class="fa fa-remove"></span>\n' +
    '          </a>\n' +
    '          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"\n' +
    '             style="margin-right: 8px;">\n' +
    '            <span\n' +
    '                class="fa fa-edit"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Nested diagnosis render template -->\n' +
    '<script type="text/ng-template" id="diagnosis_renderer.html">\n' +
    '  <div ui-tree-handle class="tree-node tree-node-content">\n' +
    '    <div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-10">\n' +
    '          {{vm.examtemplate.template.diagnosis.label}}\n' +
    '          <div ng-class="{\'hidden\':ecollapsed}" ng-init="ecollapsed = true">\n' +
    '            <div class="form-group">\n' +
    '              <label>Feldname\n' +
    '                <input type="text" ng-model="vm.examtemplate.template.diagnosis.label"\n' +
    '                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Defaultwert\n' +
    '                <tags-input ng-model="vm.examtemplate.template.diagnosis.avalues"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.diagnosis.values"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-2">\n' +
    '          <a class="pull-right btn btn-danger btn-xs" data-nodrag ng-click="vm.removeNamedField(\'diagnosis\')">\n' +
    '            <span class="fa fa-remove"></span>\n' +
    '          </a>\n' +
    '          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"\n' +
    '             style="margin-right: 8px;">\n' +
    '            <span\n' +
    '                class="fa fa-edit"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Nested recommendation render template -->\n' +
    '<script type="text/ng-template" id="recommendation_renderer.html">\n' +
    '  <div ui-tree-handle class="tree-node tree-node-content">\n' +
    '    <div>\n' +
    '      <div class="row">\n' +
    '        <div class="col-md-10">\n' +
    '          {{vm.examtemplate.template.recommendation.label}}\n' +
    '          <div ng-class="{\'hidden\':ecollapsed}" ng-init="ecollapsed = true">\n' +
    '            <div class="form-group">\n' +
    '              <label>Feldname\n' +
    '                <input type="text" ng-model="vm.examtemplate.template.recommendation.label"\n' +
    '                       ng-blur="vm.examtemplate.$save().$save()" class="form-control"></label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Defaultwert(e)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.recommendation.avalues"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '            <div class="form-group">\n' +
    '              <label>Mögliche Werte (mit Komma oder Eingabetaste trennen)\n' +
    '                <tags-input ng-model="vm.examtemplate.template.recommendation.values"\n' +
    '                            display-property="name"\n' +
    '                            add-on-comma="false"\n' +
    '                            enableEditingLastTag="true"\n' +
    '                            placeholder="Neuer Eintrag <Eingabetaste>"\n' +
    '                            replace-spaces-with-dashes="false"\n' +
    '                            template="tag-template">\n' +
    '                </tags-input>\n' +
    '              </label>\n' +
    '            </div>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '        <div class="col-md-2">\n' +
    '          <a class="pull-right btn btn-danger btn-xs" data-nodrag\n' +
    '             ng-click="vm.removeNamedField(\'recommendation\')">\n' +
    '            <span class="fa fa-remove"></span>\n' +
    '          </a>\n' +
    '          <a class="pull-right btn btn-primary btn-xs" data-nodrag ng-click="ecollapsed=!ecollapsed"\n' +
    '             style="margin-right: 8px;">\n' +
    '            <span\n' +
    '                class="fa fa-edit"></span>\n' +
    '          </a>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<!-- ngTagsInput tag formatting -->\n' +
    '<script type="text/ng-template" id="tag-template">\n' +
    '  <div class="tag-template">\n' +
    '    <div class="right-panel">\n' +
    '      <span>{{$getDisplayText()}}</span>\n' +
    '      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/sampleexameditor-component.tpl.html',
    '<form name="postexameditorform">\n' +
    '  <h3 ng-bind="vm.exam.template.displayname"></h3>\n' +
    '\n' +
    '  <!-- fieldgroups -->\n' +
    '  <div ng-repeat="fieldgroup in vm.exam.template.fieldgroups">\n' +
    '    <fieldgroup fieldgroup="fieldgroup" gi="{{$index}}" on-fieldgroup-change="vm.save()"></fieldgroup>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Biopsy fields -->\n' +
    '  <div ng-show="vm.exam.template.biopsy" class="panel panel-default">\n' +
    '    <div class="panel-heading">Biopsien</div>\n' +
    '    <div class="panel-body">\n' +
    '\n' +
    '      <!-- biopsy referral doctor -->\n' +
    '      <label for="patho">Labor/Pathologie</label>\n' +
    '\n' +
    '      <!-- Arztsuche -->\n' +
    '      <div class=" row">\n' +
    '        <!-- Arztsuche - -->\n' +
    '        <div class="form-group  col-xs-12" ng-hide="vm.newref.doctor._id">\n' +
    '          <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>\n' +
    '        </div>\n' +
    '        <div class="form-group col-xs-12" ng-show="vm.newref.doctor._id">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control"\n' +
    '                   id="pdoctorname"\n' +
    '                   tabindex="0"\n' +
    '                   readonly\n' +
    '                   ng-model="vm.newref.doctor.fname">\n' +
    '            <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <h4>Meßwerte erfassen</h4>\n' +
    '      <trackervaluenew trackerid="tracker._id" clientid="vm.exam.patientid" onentrycb="vm.addTrackerValue(trackervalue)"\n' +
    '                       class="spacer-top" ng-repeat="tracker in vm.exam.template.trackers"></trackervaluenew>\n' +
    '\n' +
    '\n' +
    '      <div class=" spacer-top"></div>\n' +
    '      <!-- exam images/files -->\n' +
    '      <examfiles examid="vm.exam._id"></examfiles>\n' +
    '\n' +
    '      <!-- biopsy referral fields -->\n' +
    '      <label for="pathdiag">Diagnose/Begründung</label>\n' +
    '      <input type="text" tabindex="901" id="pathdiag" class="form-control" ng-model="vm.newref.diag">\n' +
    '\n' +
    '      <label for="pathcomment">Kommentar/Anweisung</label>\n' +
    '      <textarea tabindex="901" id="pathcomment" class="form-control" ng-model="vm.newref.pathcomment"></textarea>\n' +
    '\n' +
    '      <!-- Biopsy fields -->\n' +
    '      <biopsyfield field="bf" bvalues="vm.exam.template.biopsy.values"\n' +
    '                   ng-init="bf.label  = \'PE \' + ($index + 1) + \' \' + vm.exam.template.type"\n' +
    '                   ng-repeat="bf in vm.exam.template.biopsy.biopsies">\n' +
    '      </biopsyfield>\n' +
    '    </div>\n' +
    '  </div> <!-- Biopsy group-->\n' +
    '\n' +
    '  <!-- special fields -->\n' +
    '  <div class="panel panel-default">\n' +
    '    <div class="panel-heading"><h4>Befundzusammenfassung</h4></div>\n' +
    '    <div class="panel-body">\n' +
    '      <examfield field="vm.exam.template.diagnosis" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.diagnosis"></examfield>\n' +
    '      <examfield field="vm.exam.template.recommendation" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.recommendation"></examfield>\n' +
    '      <examfield field="vm.exam.template.comment" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.comment"></examfield>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Files/Images -->\n' +
    '  <examfiles examid="vm.exam._id"></examfiles>\n' +
    '\n' +
    '\n' +
    '  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">\n' +
    '    <a class="btn btn-info" href="{{vm.previewUrl}}" target="_blank"><i class="fa fa-eye"></i>\n' +
    '      Befundvorschau</a>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group spacer-top">\n' +
    '    <button type="submit" class="btn btn-primary" ng-click="vm.finishEdit()">Editieren beenden und neues PDF\n' +
    '      erstellen\n' +
    '    </button>\n' +
    '    <button type="submit" class="btn btn-danger" ng-click="vm.cancelEdit()">Editieren abbrechen</button>\n' +
    '  </div>\n' +
    '</form> <!-- exam editor form -->\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/postexameditor-component.tpl.html',
    '<form name="postexameditorform">\n' +
    '  <h3 ng-bind="vm.exam.template.displayname"></h3>\n' +
    '\n' +
    '\n' +
    '  <!-- Biopsy fields -->\n' +
    '  <div ng-show="vm.exam.template.biopsy" class="panel panel-default">\n' +
    '    <div class="panel-heading">Biopsien</div>\n' +
    '    <div class="panel-body">\n' +
    '\n' +
    '      <!-- biopsy referral doctor -->\n' +
    '      <label for="patho">Labor/Pathologie</label>\n' +
    '\n' +
    '      <!-- Arztsuche -->\n' +
    '      <div class=" row">\n' +
    '        <!-- Arztsuche - -->\n' +
    '        <!--                <div class="form-group  col-xs-12" ng-hide="vm.newref.doctor._id">\n' +
    '                            <doctorsearch id="doctor" parentsave="vm.saveDoctor(doctor)"></doctorsearch>\n' +
    '                        </div>-->\n' +
    '        <div class="form-group col-xs-12" ng-show="vm.newref.doctor._id">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control"\n' +
    '                   id="pdoctorname"\n' +
    '                   tabindex="0"\n' +
    '                   readonly\n' +
    '                   ng-model="vm.newref.doctor.fname">\n' +
    '            <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <!-- biopsy referral fields -->\n' +
    '      <label for="pathdiag">Diagnose/Begründung</label>\n' +
    '      <input type="text" tabindex="901" id="pathdiag" class="form-control" ng-model="vm.newref.diag">\n' +
    '\n' +
    '      <label for="pathcomment">Kommentar/Anweisung</label>\n' +
    '      <textarea tabindex="901" id="pathcomment" class="form-control" ng-model="vm.newref.pathcomment"></textarea>\n' +
    '\n' +
    '      <!-- Biopsy fields -->\n' +
    '      <biopsyfield field="bf" bvalues="vm.exam.template.biopsy.values"\n' +
    '                   ng-init="bf.label  = \'PE \' + ($index + 1) + \' \' + vm.exam.template.type"\n' +
    '                   ng-repeat="bf in vm.exam.template.biopsy.biopsies">\n' +
    '      </biopsyfield>\n' +
    '    </div>\n' +
    '  </div> <!-- Biopsy group-->\n' +
    '\n' +
    '  <!-- special fields -->\n' +
    '  <div class="panel panel-default">\n' +
    '    <div class="panel-heading"><h4>Befundzusammenfassung</h4></div>\n' +
    '    <div class="panel-body">\n' +
    '      <examfield field="vm.exam.template.diagnosis" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.diagnosis"></examfield>\n' +
    '      <examfield field="vm.exam.template.recommendation" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.recommendation"></examfield>\n' +
    '      <examfield field="vm.exam.template.comment" on-field-change="vm.save()"\n' +
    '                 ng-show="vm.exam.template.comment"></examfield>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <h4>Meßwerte erfassen</h4>\n' +
    '  <trackervaluenew trackerid="tracker._id" clientid="vm.exam.patientid" onentrycb="vm.addTrackerValue(trackervalue)"\n' +
    '                   class="spacer-top" ng-repeat="tracker in vm.exam.template.trackers"></trackervaluenew>\n' +
    '\n' +
    '\n' +
    '  <div class=" spacer-top"></div>\n' +
    '\n' +
    '  <!-- exam images/files -->\n' +
    '\n' +
    '  <div class="spacer-top spacer-bottom btn btn-primary" ng-click="vm.loadimages=true" ng-if="!vm.loadimages && vm.exam.files && vm.exam.files.length > 0">\n' +
    '    Bilder der Untersuchung laden\n' +
    '  </div>\n' +
    '\n' +
    '  <examfiles  ng-if="vm.loadimages" examid="vm.exam._id"></examfiles>\n' +
    '\n' +
    '\n' +
    '\n' +
    '  <!-- fieldgroups -->\n' +
    '  <div ng-repeat="fieldgroup in vm.exam.template.fieldgroups">\n' +
    '    <fieldgroup fieldgroup="fieldgroup" gi="{{$index}}" on-fieldgroup-change="vm.save()"></fieldgroup>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">\n' +
    '    <a class="btn btn-info" href="{{vm.previewUrl}}" target="_blank"><i class="fa fa-eye"></i>\n' +
    '      Befundvorschau</a>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group spacer-top">\n' +
    '    <button type="submit" class="btn btn-primary" ng-click="vm.finishEdit()">Editieren beenden und neues PDF\n' +
    '      erstellen\n' +
    '    </button>\n' +
    '    <button type="submit" class="btn btn-danger" ng-click="vm.cancelEdit()">Editieren abbrechen</button>\n' +
    '  </div>\n' +
    '</form> <!-- exam editor form -->\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/fieldgroup-component.tpl.html',
    '<!-- labelled groups -->\n' +
    '<div class="spacer-top"></div>\n' +
    '<div class="panel panel-default" ng-hide="vm.fieldgroup.label == \'\'" tabindex="-1">\n' +
    '  <div class="panel-heading"  tabindex="-1" ng-model="vm.fieldgroup.label">\n' +
    '    <h4>{{vm.fieldgroup.label}}</h4>\n' +
    '  </div>\n' +
    '  <div class="panel-body"  tabindex="-1">\n' +
    '    <div ng-style="{\'margin-left\': vm.fieldgroup.marginleft}">\n' +
    '      <div ng-repeat="field in vm.fieldgroup.fields">\n' +
    '        <examfield field="field" ti="{{$index}}" gi="{{vm.gi}}" on-field-change="vm.save()"></examfield>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- unlabelled groups -->\n' +
    '<div class="spacer-top"></div>\n' +
    '<div ng-show="vm.fieldgroup.label == \'\'"  tabindex="-1">\n' +
    '  <div ng-repeat="field in vm.fieldgroup.fields">\n' +
    '    <examfield field="field" ti="{{$index}}" gi="{{vm.gi}}" on-field-change="vm.save()"></examfield>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/examview-component.tpl.html',
    '<div class="col-xs-12">\n' +
    '  <!-- fieldgroups -->\n' +
    '  <div ng-repeat="grp in vm.exam.template.fieldgroups">\n' +
    '    <!-- Group header -->\n' +
    '    <h5 class="dl-horizontal" ng-hide="grp.label == \'\'" data-ng-model="grp.label"\n' +
    '        style="border-bottom: 1px solid black; border-top: 1px solid black;  padding-top: 5px; padding-bottom: 5px">\n' +
    '      {{grp.label}}\n' +
    '    </h5>\n' +
    '    <h5 class="dl-horizontal" ng-show="grp.label == \'\'" data-ng-model="grp.label"\n' +
    '        style="border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '    </h5>\n' +
    '    <!-- fields col view -->\n' +
    '    <dl class="dl-horizontal" ng-if="vm.exam.template.layout === \'col\' || !vm.exam.template.layout">\n' +
    '      <dt ng-repeat-start="field in grp.fields">{{field.label}}</dt>\n' +
    '      <dd ng-repeat-end>\n' +
    '        <examtagstring valuearray="field.avalues"></examtagstring>\n' +
    '      </dd>\n' +
    '    </dl>\n' +
    '\n' +
    '    <!-- fields row view -->\n' +
    '    <div class="dl-horizontal" ng-if="vm.exam.template.layout === \'row\'">\n' +
    '      <div style="font-weight: bold" ng-repeat-start="field in grp.fields">{{field.label}}</div>\n' +
    '      <div class="spacer-bottom" ng-repeat-end>\n' +
    '        <examtagstring valuearray="field.avalues"></examtagstring>\n' +
    '        </dd>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- exam images -->\n' +
    '  <examfiles examid="vm.exam._id"></examfiles>\n' +
    '\n' +
    '<!--  <div class="spacer-top" ng-if="vm.exam.files.length > 0">\n' +
    '    <h5 class="dl-horizontal"\n' +
    '        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '      Bilder der Untersuchung</h5>\n' +
    '    <imagelist images="vm.exam.files"></imagelist>\n' +
    '  </div>-->\n' +
    '\n' +
    '  <div ng-if="vm.exam.template.biopsy">\n' +
    '    <h5 class="dl-horizontal"\n' +
    '        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '      Biopsien\n' +
    '    </h5>\n' +
    '    <div class="row" ng-repeat="bio in vm.exam.template.biopsy.biopsies">\n' +
    '      <div class="col-xs-12">{{bio.label}} -\n' +
    '        <examtagstring valuearray="bio.avalues"></examtagstring>\n' +
    '        <span ng-show="bio.result">: {{bio.result}}</span></div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- exam trackers -->\n' +
    '  <div class="spacer-top" ng-if="vm.exam.template.trackervalues">\n' +
    '    <h5 class="dl-horizontal"\n' +
    '        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '      Meßwerte\n' +
    '    </h5>\n' +
    '\n' +
    '    <dl class="dl-horizontal">\n' +
    '      <dt ng-repeat-start="tr in vm.exam.template.trackervalues">{{tr.name}}</dt>\n' +
    '      <dd ng-repeat-end>\n' +
    '        <div ng-repeat="set in tr.entries">\n' +
    '          <div ng-repeat="def in set">{{def.label}}: {{def.value}} {{def.unit}} (Referenzbereich: {{def.normmin}} - {{def.normmax}})</div>\n' +
    '        </div>\n' +
    '      </dd>\n' +
    '    </dl>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Befundblock  -->\n' +
    '  <div ng-if="vm.exam.includefindings === false || !vm.exam.includefindings">\n' +
    '    <h5 class="dl-horizontal"\n' +
    '        style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '      Befund</h5>\n' +
    '    <dl class="dl-horizontal">\n' +
    '      <dt>Zusammenfassung</dt>\n' +
    '      <dd>\n' +
    '        <examtagstring valuearray="vm.exam.template.diagnosis.avalues"></examtagstring>\n' +
    '      </dd>\n' +
    '      <dt>Empfehlung</dt>\n' +
    '      <dd>\n' +
    '        <examtagstring valuearray="vm.exam.template.recommendation.avalues"></examtagstring>\n' +
    '      </dd>\n' +
    '      <dt>Anmerkung</dt>\n' +
    '      <dd>\n' +
    '        <examtagstring valuearray="vm.exam.template.comment.avalues"></examtagstring>\n' +
    '      </dd>\n' +
    '    </dl>\n' +
    '  </div>\n' +
    '\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/examfield-component.tpl.html',
    '<div class="form-group examfield">\n' +
    '  <label ng-model="vm.field.label" tabindex="-1">{{vm.field.label}}\n' +
    '    <span ng-if="vm.hint" class="text-danger"><i class="fa fa-warning"></i> {{vm.hint}}</span></label>\n' +
    '  <tags-input ng-model="vm.field.avalues"\n' +
    '              display-property="name"\n' +
    '              placeholder="Tippen zum Vervollständigen"\n' +
    '              add-on-comma="false"\n' +
    '              min-length="1"\n' +
    '              id="{{$id}}"\n' +
    '              tabindex="0"\n' +
    '              enable-editing-last-tag="true"\n' +
    '              ng-blur="vm.save()"\n' +
    '              replace-spaces-with-dashes="false"\n' +
    '              template="tag-template">\n' +
    '    <auto-complete source="vm.loadValues($query)"\n' +
    '                   min-length="0"\n' +
    '                   load-on-focus="true"\n' +
    '                   load-on-empty="true"\n' +
    '                   load-on-down-arrow="true"\n' +
    '                   max-results-to-show="32"\n' +
    '                   select-first-match="false"\n' +
    '                   template="autocomplete-template"></auto-complete>\n' +
    '  </tags-input>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="tag-template">\n' +
    '  <div class="tag-template">\n' +
    '    <div class="right-panel">\n' +
    '      <span>{{$getDisplayText()}}</span>\n' +
    '      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="autocomplete-template">\n' +
    '  <div class="autocomplete-template">\n' +
    '    <div>\n' +
    '      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/exameditor-component.tpl.html',
    '<form name="exameditorform">\n' +
    '  <h3 ng-bind="vm.exam.template.displayname"></h3>\n' +
    '\n' +
    '  <div class=" spacer-top"></div>\n' +
    '  <!-- exam images/files -->\n' +
    '  <examfiles examid="vm.exam._id" ng-if="vm.exam.template.loadfiles === true"></examfiles>\n' +
    '  <examgdtfiles examid="vm.exam._id" ng-if="vm.exam.template.isgdt === true"></examgdtfiles>\n' +
    '<!--  <examdicomfiles examid="vm.exam._id" ng-if="vm.exam.template.isdicom === true"></examdicomfiles>-->\n' +
    '\n' +
    '  <div class=" spacer-top"></div>\n' +
    '  <!-- fieldgroups -->\n' +
    '  <div ng-repeat="fieldgroup in vm.exam.template.fieldgroups">\n' +
    '    <fieldgroup fieldgroup="fieldgroup" gi="{{$index}}" on-fieldgroup-change="vm.save()"></fieldgroup>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Biopsy fields -->\n' +
    '  <!-- biopsy format in db\n' +
    '      "biopsy" : {\n' +
    '        "label" : "Biopsien",\n' +
    '        "values" : [\n' +
    '          {\n' +
    '            "name" : "Magenpförtner"\n' +
    '          },\n' +
    '          {\n' +
    '            "name" : "Magenrückwand"\n' +
    '          }\n' +
    '        ],\n' +
    '        "biopsies" : [\n' +
    '          {\n' +
    '            "label" : "",\n' +
    '            "avalues" : "",\n' +
    '            "values" : ""\n' +
    '          }\n' +
    '        ]\n' +
    '      }\n' +
    '  -->\n' +
    '\n' +
    '\n' +
    '  <!-- Biopsy fields -->\n' +
    '  <div ng-show="vm.exam.template.biopsy" class="panel panel-default">\n' +
    '    <div class="panel-heading"><h4>Biopsien</h4></div>\n' +
    '    <div class="panel-body">\n' +
    '\n' +
    '\n' +
    '      <div ng-show="vm.exam.open === true">\n' +
    '        <!-- biopsy referral doctor -->\n' +
    '        <label for="patho">Labor/Pathologie</label>\n' +
    '        <div class="form-group" ng-hide="vm.exam.template.biopsy.pathology._id">\n' +
    '          <doctorsearch doctor="vm.exam.template.biopsy.pathology"\n' +
    '                        doctorref="vm.exam.template.biopsy.pathologyref"\n' +
    '                        parentsave="vm.saveDoctor(doctor)"\n' +
    '                        data-hook="biopsydoctor"\n' +
    '          ></doctorsearch>\n' +
    '        </div>\n' +
    '        <div class="form-group" ng-show="vm.exam.template.biopsy.pathology._id">\n' +
    '          <div class="input-group">\n' +
    '            <input type="text" class="form-control"\n' +
    '                   readonly\n' +
    '                   ng-model="vm.exam.template.biopsy.pathology.fname">\n' +
    '            <span class="input-group-btn">\n' +
    '                  <button class="btn btn-danger"\n' +
    '                          ng-click="vm.clearDoctor()"><i class="fa fa-remove"></i>\n' +
    '                  </button>\n' +
    '              </span>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <!-- biopsy referral fields -->\n' +
    '        <label for="pathdiag">Diagnose/Begründung</label>\n' +
    '        <input type="text" tabindex="901" id="pathdiag" class="form-control"\n' +
    '               ng-blur="vm.save()"\n' +
    '               ng-model="vm.exam.template.biopsy.pathdiag">\n' +
    '\n' +
    '        <label for="pathcomment">Kommentar/Anweisung</label>\n' +
    '        <textarea tabindex="901" id="pathcomment" class="form-control"\n' +
    '                  ng-blur="vm.save()"\n' +
    '                  ng-model="vm.exam.template.biopsy.pathcomment"></textarea>\n' +
    '\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <div ng-hide="vm.exam.open === true">\n' +
    '        <label for="patho">Labor/Pathologie\n' +
    '          <sprhelp tip="Überweisungen" descref="vm.sprref"></sprhelp>\n' +
    '        </label>\n' +
    '        <div class="form-group" ng-show="vm.exam.template.biopsy.pathology._id">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.exam.template.biopsy.pathology.fname">\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Biopsy fields -->\n' +
    '      <biopsyfield field="bf" bvalues="vm.exam.template.biopsy.values" on-field-change="vm.save()" data-hook="biopsyfield"\n' +
    '                   ng-init="bf.label  = \'PE \' + ($index + 1) + \' \' + vm.exam.template.type"\n' +
    '                   ng-repeat="bf in vm.exam.template.biopsy.biopsies">\n' +
    '      </biopsyfield>\n' +
    '\n' +
    '\n' +
    '      <!-- biopsy buttons -->\n' +
    '      <div class="form-group spacer-top">\n' +
    '        <button type="submit" class="btn btn-success" data-hook="addbiofield"\n' +
    '                ng-click="vm.addBiopsyField()">\n' +
    '          <i class="fa fa-plus"></i> Biopsiefeld hinzufügen\n' +
    '        </button>\n' +
    '\n' +
    '        <button type="submit" class="btn btn-primary" ng-class="{\'btn-success\': vm.labelsprinted}" data-hook="printlabels"\n' +
    '                ng-click="vm.printBiopsyLabels()">\n' +
    '          <span ng-show="!vm.labelsprinted"><i class="fa fa-print"></i>&nbsp;Etiketten drucken</span>\n' +
    '          <span ng-show="vm.labelsprinted"><i class="fa fa-check"></i>&nbsp;Etiketten gedruckt</span>\n' +
    '        </button>\n' +
    '\n' +
    '        <a class="btn btn-info" target="_blank" data-hook="pdflabels"\n' +
    '           href="/routes/fop/examlabels/false/false/{{vm.exam._id}}">\n' +
    '          <i class="fa fa-eye"></i> Etiketten als PDF\n' +
    '        </a>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div> <!-- Biopsy group-->\n' +
    '\n' +
    '  <h4>Meßwerte erfassen</h4>\n' +
    '  <trackervaluenew trackerid="tracker._id" clientid="vm.exam.patientid" onentrycb="vm.addTrackerValue(trackervalue)"\n' +
    '                   class="spacer-top" ng-repeat="tracker in vm.exam.template.trackers"></trackervaluenew>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '  <div class=" spacer-top"></div>\n' +
    '  <!-- special fields -->\n' +
    '  <div class="panel panel-default" ng-if="vm.exam.template.includefindings !== true">\n' +
    '    <div class="panel-heading"><h4>Befundzusammenfassung</h4></div>\n' +
    '    <div class="panel-body">\n' +
    '      <examfield field="vm.exam.template.diagnosis" on-field-change="vm.save()" data-hook="diagnosis"\n' +
    '                 ng-show="vm.exam.template.diagnosis"></examfield>\n' +
    '      <examfield field="vm.exam.template.recommendation" on-field-change="vm.save()"  data-hook="recommendation"\n' +
    '                 ng-show="vm.exam.template.recommendation"></examfield>\n' +
    '      <examfield field="vm.exam.template.comment" on-field-change="vm.save()"  data-hook="comment"\n' +
    '                 ng-show="vm.exam.template.comment"></examfield>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">\n' +
    '    <a class="btn btn-info" href="{{vm.previewUrl}}" target="_blank"><i class="fa fa-eye"></i> Befundvorschau</a>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="spacer-top spacer-bottom" ng-if="vm.exam.open === true">\n' +
    '    <div class="btn btn-warning" ng-click="vm.finishExam(vm.exam)" data-hook="closeexam">Untersuchung abschließen</div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '</form> <!-- exam editor form -->\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/exam-list-component.tpl.html',
    '<div class="alert alert-info" ng-show="vm.exams.length == 0">Keine Daten gefunden</div>\n' +
    '\n' +
    '<!--table-->\n' +
    '<!-- Must use ng-if to display, ng-show will not render automatically, only after resize -->\n' +
    '<div class="gridStyle" ui-grid="vm.gridOptions" ng-if="vm.exams.length > 0"></div>\n' +
    '\n' +
    '<!--template for action buttons-->\n' +
    '<script type="text/ng-template" id="examactiontemplate">\n' +
    '\n' +
    '    <span style="text-align: right">\n' +
    '      <!-- Biopsie eintragen -->\n' +
    '      <a ng-click="grid.appScope.vm.editExam(row.entity, $index)" class="btn btn-success btn-xs"\n' +
    '         ng-show="row.entity.template.biopsy"\n' +
    '         uib-tooltip="Biopsiebericht eintragen"><i class="fa fa-flask"></i></a>\n' +
    '        <!-- Existierendes PDF anzeigen -->\n' +
    '        <a href="/routes/pdfreader/{{row.entity.docid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Anzeigen">\n' +
    '            <i ng-show="!vm.spinners[$index]" class="fa fa-eye"></i>\n' +
    '            <i ng-show="vm.spinners[$index]" class="fa fa-spinner fa-spin"></i>\n' +
    '        </a>\n' +
    '        <!-- existierendes PDF laden -->\n' +
    '        <a href="/routes/pdfdownload/{{row.entity.docid}}" class="btn btn-primary btn-xs" uib-tooltip="Herunterladen">\n' +
    '            <i class="fa fa-download"></i>\n' +
    '        </a>\n' +
    '        <!-- Untersuchung nachträglich editieren, mit Rückfrage -->\n' +
    '        <a ng-really-click="grid.appScope.vm.editExam(row.entity, $index)"\n' +
    '           ng-really-message="Wollen Sie wirklich diese Untersuchung nachträglich editieren und einen neuen PDF Befund erstellen?"\n' +
    '           class="btn btn-warning btn-xs"\n' +
    '           uib-tooltip="Editieren &amp; neues PDF erzeugen">\n' +
    '            <i class="fa fa-edit"></i>\n' +
    '        </a>\n' +
    '      </span>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/currentexams-component.tpl.html',
    '<!-- TODO: this template seems to belong to component in vcexam -->\n' +
    '<uib-accordion close-others="oneAtATime" data-hook="currentexams-component">\n' +
    '    <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}  | orderBy: \'-_id\'"\n' +
    '         data-exam-type="{{exam.template.type}}"\n' +
    '         is-open="vm.status.isOpen[$index]">\n' +
    '        <!-- exam header -->\n' +
    '        <uib-accordion-heading>\n' +
    '            <div class="row">\n' +
    '                <div class="col-xs-12 col-sm-8">\n' +
    '                    <h4>\n' +
    '                        <span ng-show="vm.status.isOpen[$index]" data-hook="hideexam"\n' +
    '                              ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i\n' +
    '                                class="fa fa-caret-up"></i></span>\n' +
    '                        <span ng-hide="vm.status.isOpen[$index]" data-hook="showexam"\n' +
    '                              ng-click="vm.status.isOpen[$index] = !status.isOpen[$index]"><i\n' +
    '                                class="fa fa-caret-down"></i></span>\n' +
    '                        {{exam.template.displayname}}&nbsp;\n' +
    '                        <span style="color: #999999; font-size: smaller"\n' +
    '                              ng-show="exam.open === true && (exam.template.loadfiles === true || exam.template.shareid !== \'\')">(autom. Bildimport aktiv)</span>\n' +
    '                    </h4>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-4" style="text-align: right">\n' +
    '                    <h4>\n' +
    '                        <!-- print btn radio toggle -->\n' +
    '                        <a class="btn-group">\n' +
    '                            <a class="btn btn-success btn-sm" ng-model="exam.print" data-hook="printexam"\n' +
    '                               uib-tooltip="Drucken" uib-btn-radio="true"\n' +
    '                               style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; "\n' +
    '                               ng-click="$event.stopPropagation(); vm.setprint(exam, true); "><i\n' +
    '                                    class="fa fa-print"></i></a><!-- do not remove this comment, css sucks\n' +
    '                  --><a class="btn btn-danger btn-sm" ng-model="exam.print" uib-tooltip="Nicht drucken"\n' +
    '                        uib-btn-radio="false"\n' +
    '                        style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; "\n' +
    '                        ng-click="$event.stopPropagation(); vm.setprint(exam, false); "><i class="fa fa-ban"></i></a>\n' +
    '                        </a>\n' +
    '                        <!-- finish exam button button-->\n' +
    '                        <a class="btn btn-warning btn-sm"\n' +
    '                           data-hook="finishexam"\n' +
    '                           ng-click="$event.stopPropagation(); vm.finishExam(exam); "\n' +
    '                           ng-hide="exam.open === false"\n' +
    '                           uib-tooltip="Untersuchung abschließen">\n' +
    '                            <i class="fa fa-flag-checkered"></i>\n' +
    '                        </a>\n' +
    '                        <!-- textansicht button-->\n' +
    '                        <a class="btn btn-primary btn-sm"\n' +
    '                           data-hook="viewexam"\n' +
    '                           ng-click="$event.stopPropagation(); editexam[$index] = false; "\n' +
    '                           ng-hide="vm.showview(exam.open, editexam[$index])"\n' +
    '                           uib-tooltip="Textansicht">\n' +
    '                            <i class="fa fa-table"></i>\n' +
    '                        </a>\n' +
    '                        <!-- Edit button -->\n' +
    '                        <a class="btn btn-primary btn-sm"\n' +
    '                           data-hook="editexam"\n' +
    '                           ng-click="$event.stopPropagation(); editexam[$index] = true;"\n' +
    '                           ng-hide="vm.showeditor(exam.open, editexam[$index])"\n' +
    '                           uib-tooltip="Editieren">\n' +
    '                            <i class="fa fa-edit"></i>\n' +
    '                        </a>\n' +
    '                        <!-- PDF ansicht button-->\n' +
    '                        <a class="btn btn-info btn-sm"\n' +
    '                           data-hook="viewpdfexam"\n' +
    '                           ng-click="$event.stopPropagation()"\n' +
    '                           href="{{vm.examPreviewUrl(exam._id, exam.patientid)}}"\n' +
    '                           target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>\n' +
    '                        <!-- TODO: stress test exam identifcation by $index when deleting adding adding exams -->\n' +
    '                        <!-- delete button-->\n' +
    '                        <a class="btn btn-danger btn-sm"\n' +
    '                           data-hook="deleteexam"\n' +
    '                           ng-click="vm.deleteExam(exam)" uib-tooltip="Entfernen">\n' +
    '                            <i class="fa fa-remove"></i></a>\n' +
    '                    </h4>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </uib-accordion-heading>\n' +
    '        <!-- exam data -->\n' +
    '        <div class="row">\n' +
    '            <examview exam="exam" ng-if="vm.showview(exam.open, editexam[$index])"></examview>\n' +
    '            <div class="spacer-sides" ng-if="vm.showeditor(exam.open, editexam[$index])">\n' +
    '                <exameditor exam="exam"></exameditor>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>  <!-- exam in openConsult.examinations -->\n' +
    '</uib-accordion>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/consultexamlist-component.tpl.html',
    '<uib-accordion close-others="oneAtATime">\n' +
    '  <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}"\n' +
    '       is-open="status.isOpen[$index]">\n' +
    '    <!-- exam header -->\n' +
    '    <uib-accordion-heading>\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12 col-sm-9">\n' +
    '          <span style="position:absolute; top:20%; margin-right: 1em">\n' +
    '            <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i\n' +
    '                class="fa fa-caret-up fa-2x text-primary"></i></span>\n' +
    '            <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index]"><i\n' +
    '                class="fa fa-caret-down fa-2x text-success"></i></span>&nbsp;\n' +
    '          </span>\n' +
    '          <span style="display: inline; position:relative; left: 2em">\n' +
    '            <h4>{{exam.template.displayname}}</h4>\n' +
    '            <p>{{exam.diagnosis}}</p>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-sm-3" style="text-align: right">\n' +
    '          <h4>\n' +
    '            <a class="btn btn-primary btn-sm" href="/routes/pdfreader/{{exam.docid}}" target="_blank"\n' +
    '               ng-click="$event.stopPropagation();"\n' +
    '               uib-tooltip="PDF Ansicht">\n' +
    '              <i class="fa fa-eye"></i>\n' +
    '            </a>\n' +
    '            <a class="btn btn-primary btn-sm" href="/routes/pdfdownload/{{exam.docid}}"\n' +
    '               ng-click="$event.stopPropagation();"\n' +
    '               uib-tooltip="PDF speichern">\n' +
    '              <i class="fa fa-download"></i>\n' +
    '            </a>\n' +
    '          </h4>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </uib-accordion-heading>\n' +
    '    <!-- exam data -->\n' +
    '    <div class="row">\n' +
    '      <examview exam="exam"></examview>\n' +
    '    </div>\n' +
    '  </div>  <!-- exam in openConsult.examinations -->\n' +
    '</uib-accordion>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/biopsyfield-component.tpl.html',
    '<div class="row spacer-top spacer-bottom examfield">\n' +
    '  <!-- Biopsie -->\n' +
    '  <div class="col-xs-12 col-sm-6 spacer-top">\n' +
    '\n' +
    '    <label>Bezeichnung der Probe <span ng-bind="vm.field.label"></span></label>\n' +
    '    <tags-input ng-model="vm.field.avalues" data-hook="biopsyname"\n' +
    '                display-property="name"\n' +
    '                placeholder="Tippen zum Vervollständigen"\n' +
    '                add-on-comma="false"\n' +
    '                min-length="1"\n' +
    '                tabindex="0"\n' +
    '                enable-editing-last-tag="true"\n' +
    '                replace-spaces-with-dashes="false"\n' +
    '                ng-blur="vm.save()"\n' +
    '                template="tag-template">\n' +
    '      <auto-complete source="vm.loadBValues($query)"\n' +
    '                     min-length="0"\n' +
    '                     load-on-focus="true"\n' +
    '                     load-on-down-arrow="true"\n' +
    '                     load-on-empty="true"\n' +
    '                     max-results-to-show="32"\n' +
    '                     select-first-match="false"\n' +
    '                     template="autocomplete-template"></auto-complete>\n' +
    '    </tags-input>\n' +
    '  </div>\n' +
    '  \n' +
    '  <!-- Ergebnis -->\n' +
    '  <div class="col-xs-12 col-sm-6 spacer-top">\n' +
    '    <label>Ergebnis</label>\n' +
    '    <input class="form-control" ng-model="vm.field.result" ng-blur="vm.save()" placeholder="Ergebnis der Biopsie">\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- tag templates -->\n' +
    '<script type="text/ng-template" id="tag-template">\n' +
    '  <div class="tag-template">\n' +
    '    <div class="right-panel">\n' +
    '      <span>{{$getDisplayText()}}</span>\n' +
    '      <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '\n' +
    '\n' +
    '<script type="text/ng-template" id="autocomplete-template">\n' +
    '  <div class="autocomplete-template">\n' +
    '    <div>\n' +
    '      <span ng-bind-html="$highlight($getDisplayText())">{{name}}</span>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</script>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcexam/addexamdiagnoses-component.tpl.html',
    '<uib-accordion close-others="oneAtATime">\n' +
    '    <div uib-accordion-group ng-repeat="exam in vm.examinations | filter: {active: true}  | orderBy: \'-_id\'"\n' +
    '         is-open="status.isOpen[$index]" class="panel-warning">\n' +
    '        <!-- exam header -->\n' +
    '        <uib-accordion-heading>\n' +
    '            <div class="row">\n' +
    '                <div class="col-xs-12 col-sm-9">\n' +
    '                    <h4>\n' +
    '                        <span ng-show="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index];"><i class="fa fa-caret-up"></i></span>\n' +
    '                        <span ng-hide="status.isOpen[$index]" ng-click="status.isOpen[$index] = !status.isOpen[$index];"><i class="fa fa-caret-down"></i></span>\n' +
    '                        &nbsp;{{exam.template.displayname}}  vom {{exam.created | moment: \'lll\'}}\n' +
    '                        <span ng-show="exam.files.length > 0">, {{exam.files.length}} <i class="fa fa-image"></i></span>\n' +
    '                    </h4>\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-3" style="text-align: right">\n' +
    '                    <h4>\n' +
    '                        <!-- PDF ansicht button-->\n' +
    '                        <a class="btn btn-info btn-sm" ng-show="exam.postediting === true" ng-click="$event.stopPropagation();"\n' +
    '                           href="/routes/pdfprinter/exampreview?patientid={{exam.patientid}}&examid={{exam._id}}&doctype=examfinding"\n' +
    '                           target="_blank" uib-tooltip="PDF Vorschau"><i class="fa fa-eye"></i></a>\n' +
    '                        <sprhelp tip="PDF Vorschau" descref="vm.sprpreview"  ng-show="exam.postediting === true" ></sprhelp>\n' +
    '                        <a class="btn btn-primary btn-sm" ng-hide="exam.postediting === true"\n' +
    '                           href="/routes/files/pdfreader/{{exam.fileid}}"  ng-click="$event.stopPropagation();"\n' +
    '                           target="_blank" uib-tooltip="PDF Ansicht"><i class="fa fa-eye"></i></a>\n' +
    '                        <a class="btn btn-primary btn-sm" ng-hide="exam.postediting === true"\n' +
    '                           href="/routes/files/pdfdownload/{{exam.fileid}}"  ng-click="$event.stopPropagation();"\n' +
    '                           target="_blank" uib-tooltip="PDF Download"><i class="fa fa-download"></i></a>\n' +
    '                    </h4>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </uib-accordion-heading>\n' +
    '        <!-- exam data -->\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12">\n' +
    '                <!--<examview exam="exam" ng-if="vm.showview(exam.open, editexam[$index])"></examview>-->\n' +
    '                <!--<div class="spacer-sides" ng-if="vm.showeditor(exam.open, editexam[$index])"></div>-->\n' +
    '                <div class="spacer-top spacer-bottom btn btn-primary" ng-click="vm.showexam[$index]=true" ng-if="!vm.showexam[$index] && $index > 2 ">\n' +
    '                    Untersuchungsdetails laden\n' +
    '                </div>\n' +
    '                <postexameditor ng-if="vm.showexam[$index] || $index < 3" exam="exam" ></postexameditor>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>  <!-- exam in openConsult.examinations -->\n' +
    '</uib-accordion>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdrug/drugprescription-smartcomponent.tpl.html',
    '<div class="alert alert-info" ng-show="vm.ready === \'loading\'">\n' +
    '    <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...\n' +
    '</div>\n' +
    '\n' +
    '<h4>Medikament verordnen</h4>\n' +
    '<form class="form-vertical" name="newdrugform" id="newdrugform">\n' +
    '<!-- Suchbox, Medikamentendaten -->\n' +
    '    <div class="row form-group">\n' +
    '        <!-- Medikamentensuchbox-->\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <label for="newdrugname">Medikament <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Medikamentensuche" descref="vm.sprsearch"></sprhelp>  </label>\n' +
    '            <div class="input-group">\n' +
    '                <input type="text" class="form-control" placeholder="Medikament oder PharmaNr."\n' +
    '                       ng-model="vm.newdrug.name"\n' +
    '                       ng-required="!vm.newdrug.name"\n' +
    '                       autocomplete="noway"\n' +
    '                       ng-class="{ \'has-error\': newdrugform.$invalid }"\n' +
    '                       typeahead-on-select="vm.showdruginfo($item)"\n' +
    '                       typeahead-min-length="3"\n' +
    '                       uib-typeahead="drug as drug.text for drug in vm.getDrugs($viewValue)"\n' +
    '                       typeahead-loading="loadingNames"\n' +
    '                       id="newdrugname"\n' +
    '                       select-first-match="false"\n' +
    '                       typeahead-no-results="vm.noResults">\n' +
    '                <span class="input-group-btn">\n' +
    '                    <button class="btn btn-info" type="button"><i class="fa fa-search"></i></button>\n' +
    '                </span>\n' +
    '            </div>\n' +
    '            <i ng-show="loadingNames" class="fa fa-refresh"></i>\n' +
    '\n' +
    '            <div ng-show="vm.noResults" style="color: #cc3333; font-weight: bold">\n' +
    '                <i class="fa fa-warning"></i> Keine Medikamente gefunden!\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <!-- SV Box, FI, Alternativen -->\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <label for="fooname">Detailinformationen, Alternativen</label>\n' +
    '            <div style="display: block" class="druginfo">\n' +
    '                <!-- Platzhalter -->\n' +
    '                <span ng-hide="vm.newdrug.name"><i class="btn btn-info fa fa-warning"></i> W&auml;hlen Sie zuerst ein Medikament aus</span>\n' +
    '                <!-- Button SV Box -->\n' +
    '                <span class="btn btn-success" ng-show="vm.newdrug.box === \'G\'"\n' +
    '                      uib-tooltip="SV Green Box">G</span>\n' +
    '                <span class="btn btn-warning" ng-show="vm.newdrug.box === \'Y\'"\n' +
    '                      uib-tooltip="SV Yellow Box">Y</span>\n' +
    '                <span class="btn btn-danger" ng-show="vm.newdrug.box === \'NB\'" uib-tooltip="SV No Box">NB</span>\n' +
    '\n' +
    '                <!-- Fachinformationen -->\n' +
    '                <a class="btn btn-info"\n' +
    '                   href="/routes{{vm.newdrug.fi}}" target="_blank"\n' +
    '                   ng-show="vm.newdrug.fi"\n' +
    '                   uib-tooltip="Fachinformationen">FI PDF</a>\n' +
    '\n' +
    '                <!-- Button Restriktionen, Ind -->\n' +
    '                <span class="btn btn-danger" ng-show="vm.newdrug.re"\n' +
    '                      uib-tooltip="Restriktionen" ng-bind="vm.newdrug.re"\n' +
    '                      uib-popover-template="vm.repopovertpl" popover-title="Restriktionen"\n' +
    '                      popover-placement="auto bottom" popover-trigger="outsideClick"></span>\n' +
    '                <span class="btn btn-primary" ng-show="vm.newdrug.ind"\n' +
    '                      uib-tooltip="Indikationen" popover-trigger="outsideClick"\n' +
    '                      uib-popover-template="vm.indpopovertpl" popover-title="Indikationen"\n' +
    '                      popover-placement="auto bottom">IND</span>\n' +
    '                <span class="btn btn-info" ng-show="vm.newdrug.hint"\n' +
    '                      uib-tooltip="Hinweis" popover-trigger="outsideClick"\n' +
    '                      uib-popover-template="vm.hintpopovertpl" popover-title="Hinweis"\n' +
    '                      popover-placement="auto bottom"><i\n' +
    '                    class="fa fa-info-circle"></i></span>\n' +
    '                <span class="btn btn-warning" ng-show="vm.newdrug.kz"\n' +
    '                      uib-tooltip="Kassenzeichen"\n' +
    '                      uib-popover-template="vm.kzpopover" popover-title="Hinweis" popover-placement="auto bottom"\n' +
    '                      ng-bind="vm.newdrug.kz"></span>\n' +
    '\n' +
    '                <!-- Button Langzeitbewilligung -->\n' +
    '                <span class="btn btn-info" ng-show="vm.newdrug.permpermit"\n' +
    '                      uib-tooltip="Langzeitbewilligung" ng-bind="vm.newdrug.permpermit"\n' +
    '                      uib-popover-template="vm.pppopovertpl" popover-title="Langzeitbewilligung"\n' +
    '                      popover-placement="auto bottom" popover-trigger="outsideClick"></span>\n' +
    '\n' +
    '                <!-- Alternativen -->\n' +
    '                <span class="btn btn-{{vm.newdrug.alttype}}" ng-show="vm.newdrug.alternatives.length > 0"\n' +
    '                      uib-popover-template="vm.drugalternativestpl" popover-title="Alternativen"\n' +
    '                      popover-placement="auto bottom" popover-trigger="outsideClick"\n' +
    '                      uib-tooltip="{{vm.newdrug.alttypetext}}">Alternativen</span>\n' +
    '\n' +
    '                <!-- SV ATC Alternativen -->\n' +
    '                <span class="btn btn-warning" ng-show="vm.newdrug.atcalternatives.length > 0"\n' +
    '                      uib-popover-template="vm.atcalternativestpl"\n' +
    '                      popover-title="SV erstattete Alternativen laut ATC Code"\n' +
    '                      popover-placement="auto bottom" popover-trigger="outsideClick"\n' +
    '                      uib-tooltip="SV erstattete Alternativen laut ATC Code">SV Alternativen lt. ATC Code</span>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <!-- Einahme/Signatur, PkgSize, OP, Dauermed/permanent -->\n' +
    '    <div class="row  form-group">\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!-- Einnahmeanweisung -->\n' +
    '            <div class="form-group">\n' +
    '                <label for="newdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp>  </label>\n' +
    '                <div class="input-group">\n' +
    '                    <input class="form-control" ng-model="vm.newdrug.amount" id="newdrugamount"\n' +
    '                           autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"\n' +
    '                           placeholder="1-0-1-0" ng-required="!vm.newdrug.amount"\n' +
    '                           ng-class="{ \'has-error\': newdrugform.$invalid }">\n' +
    '                    <div class="input-group-btn" uib-dropdown>\n' +
    '                        <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>\n' +
    '                        </button>\n' +
    '                        <ul id="amountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                            ng-hide="vm.conf.drugsignature.length">\n' +
    '                            <li ng-click="vm.newdrug.amount=\'1-0-0\'">1-0-0</li>\n' +
    '                            <li ng-click="vm.newdrug.amount=\'1-0-1\'">1-0-1</li>\n' +
    '                            <li ng-click="vm.newdrug.amount=\'0-1-0\'">0-1-0</li>\n' +
    '                            <li ng-click="vm.newdrug.amount=\'0-0-1\'">0-0-1</li>\n' +
    '                            <li ng-click="vm.newdrug.amount=\'1-1-1\'">1-1-1</li>\n' +
    '                            <li ng-click="vm.newdrug.amount=\'0-0-0-1\'">0-0-0-1</li>\n' +
    '                        </ul>\n' +
    '                        <ul id="amountmenu2" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                            ng-show="vm.conf.drugsignature.length">\n' +
    '                            <li ng-repeat="sig in vm.conf.drugsignature" ng-click="vm.newdrug.amount=sig">{{sig}}</li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!--Packungsgroesse-->\n' +
    '            <label for="newdrugpkgsize">Packungsgröße <sprhelp tip="Packungsgr&ouml;&szlig;e" descref="vm.sprpkgsize"></sprhelp></label>\n' +
    '            <input class="form-control" ng-model="vm.newdrug.pkgsize" id="newdrugpkgsize"\n' +
    '                   placeholder="30 Stk">\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <label for="newdrugamount">Packungsanzahl <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Anzahl" descref="vm.sprpkgnr"></sprhelp></label>\n' +
    '            <!--OP-->\n' +
    '            <div class="radio" ng-init="vm.newdrug.op=\'OP I\'">\n' +
    '                <label for="newdrugop1" class="radio-inline">\n' +
    '                    <input type="radio" value="OP I" required\n' +
    '                           ng-model="vm.newdrug.op"\n' +
    '                           id="newdrugop1">OP I</label>\n' +
    '                <label for="newdrugop2" class="radio-inline">\n' +
    '                    <input type="radio" value="OP II"\n' +
    '                           ng-model="vm.newdrug.op"\n' +
    '                           id="newdrugop2">OP II</label>\n' +
    '                <label for="newdrugop3" class="radio-inline">\n' +
    '                    <input type="radio" value="OP III"\n' +
    '                           ng-model="vm.newdrug.op"\n' +
    '                           id="newdrugop3">OP III</label>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!--Dauermedikation-->\n' +
    '            <label for="newdrugamount">Einnahmedauer <sprhelp tip="Dauermedikation vs. Anla&szlig;medikation" descref="vm.sprduration"></sprhelp></label>\n' +
    '            <div class="input-group">\n' +
    '                <div class="checkbox">\n' +
    '                    <label for="newdrugperm" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.newdrug.permanent"\n' +
    '                               id="newdrugperm">Dauermedikation\n' +
    '                    </label><br>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <!-- Rezeptvermerk, IND, nocEx-->\n' +
    '    <div class="row form-group">\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <!--Rezeptvermerk-->\n' +
    '            <div class="row">\n' +
    '                <div class="col-xs-12">\n' +
    '                    <div class="form-group">\n' +
    '                        <label for="newdrugcomment">Rezeptvermerk <sprhelp tip="Rezeptvermerk" descref="vm.sprcomment"></sprhelp></label>\n' +
    '                        <textarea class="form-control" ng-model="vm.newdrug.comment" id="newdrugcomment"\n' +
    '                                  placeholder=""></textarea>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <div class="input-group">\n' +
    '                <strong>Spezifika <sprhelp tip="Indikationen" descref="vm.sprind"></sprhelp></strong>\n' +
    '\n' +
    '                <!--IND-->\n' +
    '                <div class="checkbox">\n' +
    '                    <label for="newdrugind" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.newdrug.ind"\n' +
    '                               id="newdrugind">IND (Indikation)\n' +
    '                        <!-- <span ng-show="vm.newdrug.indcriteria" uib-tooltip="Indikationen"\n' +
    '                               uib-popover-template="vm.indpopovertpl"\n' +
    '                               popover-title="Indikationen" popover-placement="auto bottom"><i class="fa fa-info-circle btn btn-primary"></i></span> -->\n' +
    '                    </label><br>\n' +
    '                    <label for="newdrugexpnoct" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.newdrug.expnoc"\n' +
    '                               id="newdrugexpnoct">Exp. Noct. (Nachtausgabe)\n' +
    '                    </label><br>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Verschreiben Button -->\n' +
    '    <div class="row form-group">\n' +
    '        <div class="col-xs-12">\n' +
    '            <button class="btn btn-success spacer-top" type="button"\n' +
    '                    ng-disabled="!newdrugform.$valid"\n' +
    '                    ng-click="vm.addDrug()">\n' +
    '                <span ng-show="vm.drug_saved"><i class="fa fa-check" ></i>&nbsp;Medikament verordnet</span>\n' +
    '                <span ng-hide="vm.drug_saved">Medikament verordnen</span>\n' +
    '            </button>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>\n' +
    '\n' +
    '<hr>\n' +
    '\n' +
    '\n' +
    '\n' +
    '<!-- Hinweis Pop-Over -->\n' +
    '<script type="text/ng-template" id="hintpopovertpl.html">\n' +
    '    <div ng-bind-html="vm.newdrug.hint"></div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Indikation Pop-Over -->\n' +
    '<script type="text/ng-template" id="indpopovertpl.html">\n' +
    '    <div ng-bind-html="vm.newdrug.indcriteria"></div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Restriktion Pop-Over -->\n' +
    '<script type="text/ng-template" id="repopovertpl.html">\n' +
    '    <div ng-bind-html="vm.newdrug.recriteria"></div></script>\n' +
    '\n' +
    '<!-- Langzeitbewilligung Pop-Over -->\n' +
    '<script type="text/ng-template" id="pppopovertpl.html">\n' +
    '    <div>\n' +
    '        <p>Dieses Arzneimittel ist langzeitbewilligungsf&auml;hig. Die Zahl gibt die Anzahl an Monaten an:\n' +
    '            <span ng-bind="vm.newdrug.permpermit"></span>\n' +
    '        </p>\n' +
    '        <p ng-bind-html="vm.newdrug.recriteria"></p>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Kassenzeichen Pop-Over-->\n' +
    '<script type="text/ng-template" id="kzpopover.html">\n' +
    '    <div>\n' +
    '        <h3>Allgemeine Kassenzeichen</h3>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">F2J</div>\n' +
    '            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern bis zum vollendeten 2.\n' +
    '                Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der angegebenen\n' +
    '                Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des Erstattungskodex\n' +
    '                zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kleinkindergerechten Therapie oder Dosierung\n' +
    '                entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und den Richtlinien über die\n' +
    '                ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des chef- und\n' +
    '                kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung ersetzt\n' +
    '                werden kann.\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">F6J</div>\n' +
    '            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern bis zum vollendeten 6.\n' +
    '                Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der angegebenen\n' +
    '                Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des Erstattungskodex\n' +
    '                zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kindergerechten Therapie oder Dosierung\n' +
    '                entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und den Richtlinien über die\n' +
    '                ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des chef- und\n' +
    '                kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung ersetzt\n' +
    '                werden kann.\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">F14</div>\n' +
    '            <div class="col-xs-11">Die Arzneispezialität ist nur für die Behandlung von Kindern und Jugendlichen bis zum\n' +
    '                vollendeten 14. Lebensjahr in den Grünen Bereich des Erstattungskodex aufgenommen. Für Verordnungen außerhalb der\n' +
    '                angegebenen Altersbeschränkung ist die Arzneispezialität wie eine Arzneispezialität des Gelben Bereichs des\n' +
    '                Erstattungskodex zu behandeln, wobei, wenn die Notwendigkeit für die Verordnung einer kindergerechten Zubereitung\n' +
    '                (z.B.: Saft) oder Dosierung entsprechend den Bestimmungen der Heilmittel-Bewilligungs- und Kontroll-Verordnung und\n' +
    '                den Richtlinien über die ökonomische Verschreibweise dokumentiert wird, die vorherige ärztliche Bewilligung des\n' +
    '                chef- und kontrollärztlichen Dienstes durch eine nachfolgende Kontrolle der Einhaltung der bestimmten Verwendung\n' +
    '                ersetzt werden kann.\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">DSX</div>\n' +
    '            <div class="col-xs-11">(steht für die Facharztkennzeichen A, D, K, L): Desensibilisierungsprodukt; frei\n' +
    '                verschreibbar durch Facharzt/Fachärztin für Lungenkrankheiten, Haut- und Geschlechtskrankheiten, Kinderheilkunde\n' +
    '                und Hals-, Nasen- und Ohrenkrankheiten.\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <h3>Kassenzeichen Facharztkennung</h3>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1"></div>\n' +
    '            <div class="col-xs-11"></div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">A</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Lungenkrankheiten</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">Au</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Augenkrankheiten</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">D</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Haut- und Geschlechtskrankheiten</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">F</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Frauenheilkunde und Geburtshilfe</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">K</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Kinderheilkunde</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">L</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Hals-, Nasen- und Ohrenkrankheiten</div>\n' +
    '        </div>\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">P</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Psychiatrie oder Psychiatrie und Neurologie oder Neurologie und\n' +
    '                Psychiatrie oder Kinder- und Jugendpsychiatrie\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">R</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Radiologie\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-1">U</div>\n' +
    '            <div class="col-xs-11">Facharzt/Fachärztin für Urologie</div>\n' +
    '        </div>\n' +
    '\n' +
    '\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- Alternativen Pop-Over -->\n' +
    '<script type="text/ng-template" id="drugalternativestpl.html">\n' +
    '    <div style="padding: 20px"><!-- template must be enclosed by single tag -->\n' +
    '        <div style="padding: 20px"><!-- template must be enclosed by single tag -->\n' +
    '            <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.alternatives">\n' +
    '                <div class="btn btn-{{alt.color}} col-xs-12"\n' +
    '                     uib-tooltip="{{alt.tooltip}}"\n' +
    '                     ng-click="vm.replaceDrug(alt)"\n' +
    '                     ng-bind="alt.name">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="alert alert-danger"><h3><i class="fa fa-warning"></i> Wichtiger Hinweis!</h3>\n' +
    '                <p>\n' +
    '                    Die hier gelisteten Medikamente wurden auf Basis des EKO Tools der SV ausgewählt. Sie sind nach Preis sortiert -\n' +
    '                    das günstigste zuerst. Es können echte Generika (gleicher Wirkstoff, gleiche Stärke), Alternativen mit\n' +
    '                    geringfügig anderer Wirkstoffkonzentration, oder Biosimilars (änhlicher Wirksstoff) aufgelistet sein.\n' +
    '                    Farbcodierung/Hinweise der jeweiligen Alternative beachten!</p>\n' +
    '\n' +
    '                <p>Prüfung der Alternativen auf ihre Einsatzmöglichkeit und ggf. Auswahl eines Ersatzpräparats obliegt\n' +
    '                    AUSSCHLIESSLICH der berhandelnden Ärztin / dem behandelndem Arzt!</p>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</script>\n' +
    '\n' +
    '<!-- ATC Wirkstoff Alternativen Pop-Over -->\n' +
    '<script type="text/ng-template" id="atcalternativestpl.html">\n' +
    '    <div style="padding: 20px"><!-- template must be enclosed by single tag -->\n' +
    '        <div class="alert alert-danger"><h3><i class="fa fa-warning"></i> Wichtiger Hinweis!</h3>\n' +
    '            <p>\n' +
    '                Die hier gelisteten Medikamente wurden auf Basis des ATC Codes ausgewählt. Wenn das ursprüngliche - nicht mehr\n' +
    '                erstattungsfähige - Präparat mehrere Wirkstoffe beinhaltet hat, werden auch Arzneien die nur einen der Wirkstoffe\n' +
    '                beinhalten angezeigt. Die Alternativen varieren in der Stärke des Wirkstoffes. </p>\n' +
    '\n' +
    '            <p>Prüfung der Alternativen auf ihre Einsatzmöglichkeit und ggf. Auswahl eines Ersatzpräparats obliegt AUSSCHLIESSLICH der berhandelnden Ärztin\n' +
    '                / dem behandelndem Arzt!</p>\n' +
    '\n' +
    '            <!-- <p>\n' +
    '             <div class="btn btn-danger" ng-click="atcaltshow = true" ng-hide="atcaltshow">Habe ich verstanden, Alternativen jetzt anzeigen</div>\n' +
    '             </p>-->\n' +
    '        </div>\n' +
    '\n' +
    '        <!--<div ng-show="atcaltshow">-->\n' +
    '        <div>\n' +
    '            <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.atcalternatives">\n' +
    '                <div ng-show="alt.box === \'G\'" class="btn btn-success col-xs-12"\n' +
    '                     uib-tooltip="SV Green Box Alternative"\n' +
    '                     ng-click="vm.replaceDrug(alt)"\n' +
    '                     ng-bind="alt.name">\n' +
    '                </div>\n' +
    '                <div ng-show="alt.box === \'Y\'" class="btn btn-warning col-xs-12"\n' +
    '                     uib-tooltip="SV Yellow Box Alternative"\n' +
    '                     ng-click="vm.replaceDrug(alt)"\n' +
    '                     ng-bind="alt.name">\n' +
    '                </div>\n' +
    '                <div ng-hide="alt.box" class="btn btn-danger col-xs-12"\n' +
    '                     uib-tooltip="Nicht erstattungsfähige Alternative"\n' +
    '                     ng-click="vm.replaceDrug(alt)"\n' +
    '                     ng-bind="alt.ZBEZ">\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '\n' +
    '    <div class="row" style="margin-bottom: 2px" ng-repeat="alt in vm.newdrug.alternatives">\n' +
    '        <div class="btn btn-{{alt.color}} col-xs-12"\n' +
    '             uib-tooltip="{{alt.tooltip}}"\n' +
    '             ng-click="vm.replaceDrug(alt)"\n' +
    '             ng-bind="alt.name">\n' +
    '        </div>\n' +
    '        <!--<div class="col-xs-9" ng-bind="alt.name"></div>\n' +
    '        <div class="col-xs-3">\n' +
    '          <button class="btn btn-{{alt.color}}" uib-tooltip="{{alt.tooltip}}" ng-click="replaceDrug(alt)">\n' +
    '            Auswählen\n' +
    '          </button>\n' +
    '        </div>-->\n' +
    '    </div>\n' +
    '    </div>\n' +
    '</script>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdrug/drugform-component.tpl.html',
    '<form class="form-vertical" id="editdrugform" data-hook="editdrugform">\n' +
    '  <div class="row  form-group">\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <!-- Einnahmeanweisung -->\n' +
    '      <div class="form-group">\n' +
    '        <label for="newdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp>  </label>\n' +
    '        <div class="input-group">\n' +
    '          <input class="form-control" ng-model="vm.amount" id="newdrugamount"\n' +
    '                 autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"\n' +
    '                 placeholder="1-0-1-0" ng-required="!vm.amount"\n' +
    '                 ng-class="{ \'has-error\': newdrugform.$invalid }">\n' +
    '          <div class="input-group-btn" uib-dropdown>\n' +
    '            <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>\n' +
    '            </button>\n' +
    '            <ul id="amountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                ng-hide="vm.conf.drugsignature.length">\n' +
    '              <li ng-click="vm.amount=\'1-0-0\'">1-0-0</li>\n' +
    '              <li ng-click="vm.amount=\'1-0-1\'">1-0-1</li>\n' +
    '              <li ng-click="vm.amount=\'0-1-0\'">0-1-0</li>\n' +
    '              <li ng-click="vm.amount=\'0-0-1\'">0-0-1</li>\n' +
    '              <li ng-click="vm.amount=\'1-1-1\'">1-1-1</li>\n' +
    '              <li ng-click="vm.amount=\'0-0-0-1\'">0-0-0-1</li>\n' +
    '            </ul>\n' +
    '            <ul id="amountmenu2" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                ng-show="vm.conf.drugsignature.length">\n' +
    '              <li ng-repeat="sig in vm.conf.drugsignature" ng-click="vm.amount=sig">{{sig}}</li>\n' +
    '            </ul>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <!--Packungsgroesse-->\n' +
    '      <label for="newdrugpkgsize">Packungsgröße <sprhelp tip="Packungsgr&ouml;&szlig;e" descref="vm.sprpkgsize"></sprhelp></label>\n' +
    '      <input class="form-control" ng-model="vm.pkgsize" id="newdrugpkgsize"\n' +
    '             placeholder="30 Stk">\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <label for="newdrugamount">Packungsanzahl <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Anzahl" descref="vm.sprpkgnr"></sprhelp></label>\n' +
    '      <!--OP-->\n' +
    '      <div class="radio" ng-init="vm.op=\'OP I\'">\n' +
    '        <label for="newdrugop1" class="radio-inline">\n' +
    '          <input type="radio" value="OP I" required\n' +
    '                 ng-model="vm.op"\n' +
    '                 id="newdrugop1">OP I</label>\n' +
    '        <label for="newdrugop2" class="radio-inline">\n' +
    '          <input type="radio" value="OP II"\n' +
    '                 ng-model="vm.op"\n' +
    '                 id="newdrugop2">OP II</label>\n' +
    '        <label for="newdrugop3" class="radio-inline">\n' +
    '          <input type="radio" value="OP III"\n' +
    '                 ng-model="vm.op"\n' +
    '                 id="newdrugop3">OP III</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-3">\n' +
    '      <!--Dauermedikation-->\n' +
    '      <label for="newdrugamount">Einnahmedauer <sprhelp tip="Dauermedikation vs. Anla&szlig;medikation" descref="vm.sprduration"></sprhelp></label>\n' +
    '      <div class="input-group">\n' +
    '        <div class="checkbox">\n' +
    '          <label for="newdrugperm" class="checkbox-inline">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="vm.permanent"\n' +
    '                   id="newdrugperm">Dauermedikamentation\n' +
    '          </label><br>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row form-group">\n' +
    '    <div class="col-xs-12 col-md-6">\n' +
    '      <!--Rezeptvermerk-->\n' +
    '      <div class="row">\n' +
    '        <div class="col-xs-12">\n' +
    '          <div class="form-group">\n' +
    '            <label for="newdrugcomment">Rezeptvermerk</label>\n' +
    '            <textarea class="form-control" ng-model="vm.comment" id="newdrugcomment"\n' +
    '                      placeholder=""></textarea>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-6">\n' +
    '      <div class="input-group">\n' +
    '        <strong>Spezifika</strong>\n' +
    '\n' +
    '        <!--IND-->\n' +
    '        <div class="checkbox">\n' +
    '          <label for="newdrugind" class="checkbox-inline">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="vm.ind"\n' +
    '                   id="newdrugind">IND (Indikation)\n' +
    '            <!-- <span ng-show="vm.indcriteria" uib-tooltip="Indikationen"\n' +
    '                   uib-popover-template="vm.indpopovertpl"\n' +
    '                   popover-title="Indikationen" popover-placement="auto bottom"><i class="fa fa-info-circle btn btn-primary"></i></span> -->\n' +
    '          </label><br>\n' +
    '          <label for="newdrugexpnoct" class="checkbox-inline">\n' +
    '            <input type="checkbox"\n' +
    '                   ng-model="vm.expnoc"\n' +
    '                   id="newdrugexpnoct">Exp. Noct. (Nachtausgabe)\n' +
    '          </label><br>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n' +
    '    <h3><i class="fa fa-check"></i> drug erfolgreich gespeichert!</h3>\n' +
    '  </div>\n' +
    '  <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n' +
    '    <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen drug wurde abgebrochen!</h3>\n' +
    '  </div>\n' +
    '  <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n' +
    '    <h3>\n' +
    '      <i class="fa fa-warning"></i> drug konnte nicht gespeichert werden,\n' +
    '      der Fehler wurde protokolliert!\n' +
    '    </h3>\n' +
    '  </div>\n' +
    '  \n' +
    '  <div class=" row">\n' +
    '    <div class="col-xs-12">\n' +
    '      <div class="form-group">\n' +
    '        <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '        <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcdrug/drugeditor-component.tpl.html',
    '<form class="form-vertical" id="editdrugform" data-hook="editdrugform">\n' +
    '    <h3 ng-bind="vm.tmpdrug.name"></h3>\n' +
    '    <div class="row  form-group">\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!-- Einnahmeanweisung -->\n' +
    '            <div class="form-group">\n' +
    '                <label for="newdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp>  </label>\n' +
    '                <div class="input-group">\n' +
    '                    <input class="form-control" ng-model="vm.tmpdrug.amount" id="newdrugamount"\n' +
    '                           autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"\n' +
    '                           placeholder="1-0-1-0" ng-required="!vm.tmpdrug.amount"\n' +
    '                           ng-class="{ \'has-error\': newdrugform.$invalid }">\n' +
    '                    <div class="input-group-btn" uib-dropdown>\n' +
    '                        <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>\n' +
    '                        </button>\n' +
    '                        <ul id="amountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                            ng-hide="vm.conf.drugsignature.length">\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'1-0-0\'">1-0-0</li>\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'1-0-1\'">1-0-1</li>\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'0-1-0\'">0-1-0</li>\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'0-0-1\'">0-0-1</li>\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'1-1-1\'">1-1-1</li>\n' +
    '                            <li ng-click="vm.tmpdrug.amount=\'0-0-0-1\'">0-0-0-1</li>\n' +
    '                        </ul>\n' +
    '                        <ul id="amountmenu2" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu\n' +
    '                            ng-show="vm.conf.drugsignature.length">\n' +
    '                            <li ng-repeat="sig in vm.conf.drugsignature" ng-click="vm.tmpdrug.amount=sig">{{sig}}</li>\n' +
    '                        </ul>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!--Packungsgroesse-->\n' +
    '            <label for="newdrugpkgsize">Packungsgröße <sprhelp tip="Packungsgr&ouml;&szlig;e" descref="vm.sprpkgsize"></sprhelp></label>\n' +
    '            <input class="form-control" ng-model="vm.tmpdrug.pkgsize" id="newdrugpkgsize"\n' +
    '                   placeholder="30 Stk">\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <label for="newdrugamount">Packungsanzahl <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Anzahl" descref="vm.sprpkgnr"></sprhelp></label>\n' +
    '            <!--OP-->\n' +
    '            <div class="radio" ng-init="vm.tmpdrug.op=\'OP I\'">\n' +
    '                <label for="newdrugop1" class="radio-inline">\n' +
    '                    <input type="radio" value="OP I" required\n' +
    '                           ng-model="vm.tmpdrug.op"\n' +
    '                           id="newdrugop1">OP I</label>\n' +
    '                <label for="newdrugop2" class="radio-inline">\n' +
    '                    <input type="radio" value="OP II"\n' +
    '                           ng-model="vm.tmpdrug.op"\n' +
    '                           id="newdrugop2">OP II</label>\n' +
    '                <label for="newdrugop3" class="radio-inline">\n' +
    '                    <input type="radio" value="OP III"\n' +
    '                           ng-model="vm.tmpdrug.op"\n' +
    '                           id="newdrugop3">OP III</label>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-3">\n' +
    '            <!--Dauermedikation-->\n' +
    '            <label for="newdrugamount">Einnahmedauer <sprhelp tip="Dauermedikation vs. Anla&szlig;medikation" descref="vm.sprduration"></sprhelp></label>\n' +
    '            <div class="input-group">\n' +
    '                <div class="checkbox">\n' +
    '                    <label for="newdrugperm" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.tmpdrug.permanent"\n' +
    '                               id="newdrugperm">Dauermedikamentation\n' +
    '                    </label><br>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div class="row form-group">\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <!--Rezeptvermerk-->\n' +
    '            <div class="row">\n' +
    '                <div class="col-xs-12">\n' +
    '                    <div class="form-group">\n' +
    '                        <label for="newdrugcomment">Rezeptvermerk</label>\n' +
    '                        <textarea class="form-control" ng-model="vm.tmpdrug.comment" id="newdrugcomment"\n' +
    '                                  placeholder=""></textarea>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '        <div class="col-xs-12 col-md-6">\n' +
    '            <div class="input-group">\n' +
    '                <strong>Spezifika</strong>\n' +
    '\n' +
    '                <!--IND-->\n' +
    '                <div class="checkbox">\n' +
    '                    <label for="newdrugind" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.tmpdrug.ind"\n' +
    '                               id="newdrugind">IND (Indikation)\n' +
    '                        <!-- <span ng-show="vm.tmpdrug.indcriteria" uib-tooltip="Indikationen"\n' +
    '                               uib-popover-template="vm.tmpdrug.indpopovertpl"\n' +
    '                               popover-title="Indikationen" popover-placement="auto bottom"><i class="fa fa-info-circle btn btn-primary"></i></span> -->\n' +
    '                    </label><br>\n' +
    '                    <label for="newdrugexpnoct" class="checkbox-inline">\n' +
    '                        <input type="checkbox"\n' +
    '                               ng-model="vm.tmpdrug.expnoc"\n' +
    '                               id="newdrugexpnoct">Exp. Noct. (Nachtausgabe)\n' +
    '                    </label><br>\n' +
    '                </div>\n' +
    '\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n' +
    '        <h3><i class="fa fa-check"></i> drug erfolgreich gespeichert!</h3>\n' +
    '    </div>\n' +
    '    <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n' +
    '        <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen drug wurde abgebrochen!</h3>\n' +
    '    </div>\n' +
    '    <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n' +
    '        <h3>\n' +
    '            <i class="fa fa-warning"></i> drug konnte nicht gespeichert werden,\n' +
    '            der Fehler wurde protokolliert!\n' +
    '        </h3>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class=" row">\n' +
    '        <div class="col-xs-12">\n' +
    '            <div class="form-group">\n' +
    '                <button class="btn btn-success" type="button" tabindex="9" ng-click="vm.save()">Speichern</button>\n' +
    '                <button class="btn btn-danger" type="button" tabindex="10" ng-click="vm.cancel()">Abbrechen</button>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</form>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcconsult/consultsummary-component.tpl.html',
    '<div class="row">\n' +
    '    <!-- Stern/starred -->\n' +
    '    <div class="col-xs-4 col-sm-3 col-md-2 col-lg-1">\n' +
    '        <div style="text-align: center;">\n' +
    '            <i ng-show="vm.consult.stared" class="fa fa-star fa-3x" style="color: #eedd33"></i>\n' +
    '            <i ng-hide="vm.consult.stared" class="fa fa-star-o fa-3x"></i>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '    <!-- tags -->\n' +
    '    <div class="col-xs-8 col-sm-9 col-md-10 col-lg-11">\n' +
    '        <!-- Consult Keywords -->\n' +
    '        <div class="spacer-bottom">\n' +
    '            {{vm.consult.created | date}} &ensp; <span ng-repeat="kw in vm.consult.keywords track by $index"><span class="label label-{{kw.col || primary}}">{{kw.key}}</span>&ensp; </span>\n' +
    '        </div>\n' +
    '        <!-- Exam Labels -->\n' +
    '        <div>\n' +
    '            <!-- old labels -->\n' +
    '            <span ng-repeat="label in vm.consult.examlabels track by $index"\n' +
    '                  ng-hide="vm.consult.examlabelsPrimary || vm.consult.examlabelsSecondary">\n' +
    '              <span class="label label-success">{{label}}</span>&ensp; </span>\n' +
    '            <!-- new primary examlabels labels -->\n' +
    '            <span ng-repeat="plabel in vm.consult.examlabelsPrimary track by $index">\n' +
    '              <!-- PDF vorhanden -->\n' +
    '              <a href="/routes/pdfreader/{{plabel.docid}}" uib-tooltip="Befund PDF Ansicht" ng-show="plabel.docid"\n' +
    '                 target="_blank" style="text-decoration: none">\n' +
    '                <span class="label label-primary">\n' +
    '                  {{plabel.type}}\n' +
    '                </span>&ensp;\n' +
    '              </a>\n' +
    '                <!-- PDF nicht vorhanden -->\n' +
    '              <span class="label label-primary" ng-hide="plabel.docid">\n' +
    '                  {{plabel.type}}\n' +
    '              </span>&ensp;\n' +
    '            </span>\n' +
    '            <!-- new secondary labels -> Gesamtbefund -->\n' +
    '            <span ng-repeat="slabel in vm.consult.examlabelsSecondary track by $index">\n' +
    '              <span class="label label-info">{{slabel.type}}</span>&ensp;\n' +
    '            </span>\n' +
    '\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcconsult/consultlist-component.tpl.html',
    '<div class="alert alert-info" ng-show="vm.numCC === 0">\n' +
    '    <h4><i class="fa fa-info-circle"></i>&nbsp;Es wurden noch keine Konsultationen abgeschlossen</h4>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!--<div class="alert alert-info" role="button" ng-click="vm.$log.debug(\'div clicked\')">\n' +
    '    <h4><i class="fa fa-info-circle"></i>&nbsp;Click-Test: wann reagiert das panel, und wann der button?</h4>\n' +
    '    <div class="btn btn-success" ng-click="vm.$log.debug(\'inner button clicked\');$event.stopPropagation()">Click me!\n' +
    '    </div>\n' +
    '\n' +
    '</div>\n' +
    '<div class="btn btn-success" ng-click="vm.$log.debug(\'outer button clicked\')">Click me!</div>-->\n' +
    '\n' +
    '<div ng-repeat="cons in vm.consults  | orderBy: \'-created\'| filter: {open: false} track by $index"\n' +
    '     class="panel panel-default">\n' +
    '    <div class="panel panel-heading" style="margin-bottom: 0px" role="button" ng-click="vm.togglePanel($index, cons)">\n' +
    '        <consultsummary consult="cons"></consultsummary>\n' +
    '    </div>\n' +
    '    <div class="panel panel-body" ng-show="vm.display[$index]">\n' +
    '        <h4 ng-show="cons.symptoms">Symptome</h4>\n' +
    '        <p ng-show="cons.symptoms">{{cons.symptoms}}</p>\n' +
    '        <h4 ng-show="cons.therapy">Therapie</h4>\n' +
    '        <p ng-show="cons.therapy">{{cons.therapy}}</p>\n' +
    '        <h4 ng-show="cons.diagnoses">Diagnosen</h4>\n' +
    '        <p ng-show="cons.diagnoses">{{cons.diagnoses}}</p>\n' +
    '        <div ng-show="cons.documents.length > 0">\n' +
    '            <h4>Dokumente</h4>\n' +
    '            <documentlist documents="cons.documents"></documentlist>\n' +
    '        </div>\n' +
    '        <div ng-show="cons.examinations.length > 0">\n' +
    '            <h4>Untersuchungen</h4>\n' +
    '            <consultexamlist examinations="cons.examinations"></consultexamlist>\n' +
    '        </div>\n' +
    '        <div ng-show="cons.images.length > 0">\n' +
    '            <h4>Bilder</h4>\n' +
    '            <imageviewer images="cons.images"></imageviewer>\n' +
    '        </div>\n' +
    '        <div ng-show="cons.files.length > 0">\n' +
    '            <h4>Dateien</h4>\n' +
    '            <filelist files="cons.files"></filelist>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<!--\n' +
    '\n' +
    '<uib-accordion close-others="oneAtATime">\n' +
    '    <div uib-accordion-group heading="{{group.title}}" class="panel-default"\n' +
    '         ng-repeat="cons in vm.consults  | filter: {open: false } | orderBy: \'-created\'">\n' +
    '        <uib-accordion-heading class="">\n' +
    '            <consultsummary consult="cons"></consultsummary>\n' +
    '        </uib-accordion-heading>\n' +
    '\n' +
    '\n' +
    '        <h4 ng-show="cons.symptoms">Symptome</h4>\n' +
    '        <p ng-show="cons.symptoms">{{cons.symptoms}}</p>\n' +
    '        <h4 ng-show="cons.therapy">Therapie</h4>\n' +
    '        <p ng-show="cons.therapy">{{cons.therapy}}</p>\n' +
    '        <h4 ng-show="cons.diagnoses">Diagnosen</h4>\n' +
    '        <p ng-show="cons.diagnoses">{{cons.diagnoses}}</p>\n' +
    '        <h4>Anmerkungen</h4>\n' +
    '        {{cons.comments}}\n' +
    '        <div>\n' +
    '            &lt;!&ndash; Dokumente einblenden &ndash;&gt;\n' +
    '            <button class="btn btn-primary" ng-hide="cons.docs" ng-click="vm.getDocuments(cons)">Dokumente einblenden\n' +
    '            </button>\n' +
    '            <button class="btn btn-primary" ng-show="cons.docs" ng-click="cons.docs = null">Dokumente ausblenden\n' +
    '            </button>\n' +
    '            &lt;!&ndash; Untersuchungen einblenden &ndash;&gt;\n' +
    '            <span>\n' +
    '        <button class="btn btn-primary" ng-hide="cons.exams" ng-click="vm.getExams(cons)">\n' +
    '          Untersuchungen einblenden\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary" ng-show="cons.exams" ng-click="cons.exams = null">\n' +
    '          Untersuchungen ausblenden\n' +
    '        </button>\n' +
    '      </span>\n' +
    '            &lt;!&ndash; Bilder einblenden &ndash;&gt;\n' +
    '            <span ng-show="cons.images.length > 0 ">\n' +
    '        <button class="btn btn-primary" ng-hide="cons.imgs" ng-click="cons.imgs = 1">\n' +
    '            Bilder der Konsultation einblenden\n' +
    '        </button>\n' +
    '        <button class="btn btn-primary" ng-show="cons.imgs" ng-click="cons.imgs = null">Bilder ausblenden</button>\n' +
    '      </span>\n' +
    '\n' +
    '            &lt;!&ndash; Dokumente Block &ndash;&gt;\n' +
    '            <div ng-show="cons.docs">\n' +
    '                <h4>Dokumente (Detail- &amp; Gesamtbefund, Überweisungen, ...)</h4>\n' +
    '                <div class="row" ng-repeat="doc in cons.docs">\n' +
    '                    <div class="col-md-10">{{doc.type}}</div>\n' +
    '                    <div class="col-md-2" style="text-align: right">\n' +
    '                        <a href="/routes/pdfreader/{{doc._id}}" target="_blank" class="btn btn-primary"\n' +
    '                           ng-show="doc._id"><i\n' +
    '                            class="fa fa-eye"></i></a>\n' +
    '                        <a href="/routes/pdfdownload/{{doc._id}}" class="btn btn-primary" ng-show="doc._id"><i\n' +
    '                            class="fa fa-download"></i></a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '            &lt;!&ndash; Exam Block  &ndash;&gt;\n' +
    '            <div ng-show="cons.exams">\n' +
    '                <h4>Untersuchungen</h4>\n' +
    '                <div class="alert alert-info" ng-show="cons.examinations.length === 0">Keine Untersuchungen gefunden\n' +
    '                </div>\n' +
    '                <div class="row examrow" ng-repeat="exam in cons.examinations">\n' +
    '                    <div class="col-md-9"><strong>{{exam.type}}</strong><br>{{exam.diagnosis}}</div>\n' +
    '                    <div class="col-md-3" style="text-align: right">\n' +
    '                        <a ng-show="exam.files.length > 0 && !eximg" ng-click="eximg = 1" class="btn btn-primary"\n' +
    '                           uib-tooltip="Bilder anzeigen">\n' +
    '                            <i class="fa fa-image"></i>\n' +
    '                        </a>\n' +
    '                        <a ng-show="exam.files.length > 0 && eximg" ng-click="eximg = null" class="btn btn-primary"\n' +
    '                           uib-tooltip="Bilder ausblenden">\n' +
    '                            <i class="fa fa-image"></i>\n' +
    '                        </a>\n' +
    '                        <a ng-show="!exdata" ng-click="exdata = 1" class="btn btn-primary" uib-tooltip="Daten anzeigen">\n' +
    '                            <i class="fa fa-table"></i>\n' +
    '                        </a>\n' +
    '                        <a ng-show="exdata" ng-click="exdata = null" class="btn btn-primary"\n' +
    '                           uib-tooltip="Daten ausblenden">\n' +
    '                            <i class="fa fa-table"></i>\n' +
    '                        </a>\n' +
    '                        &lt;!&ndash; Untersuchungs Befund PDF für includefindings false untersuchungen &ndash;&gt;\n' +
    '                        <a href="/routes/pdfreader/{{exam.docid}}" target="_blank"\n' +
    '                           ng-hide="exam.template.includefindings === true"\n' +
    '                           uib-tooltip="Befund PDF anzeigen" class="btn btn-primary"><i class="fa fa-eye"></i></a>\n' +
    '                        <a href="/routes/pdfdownload/{{exam.docid}}" ng-hide="exam.template.includefindings === true"\n' +
    '                           uib-tooltip="Befund PDF speichern" class="btn btn-primary"><i class="fa fa-download"></i></a>\n' +
    '                        &lt;!&ndash;            &lt;!&ndash; Gesamtbefund für includefindings untersuchungen &ndash;&gt;\n' +
    '                                    <a href="/routes/pdfreader/{{cons.docid}}" target="_blank" ng-show="exam.template.includefindings === true"\n' +
    '                                       uib-tooltip="Befund PDF anzeigen" class="btn btn-primary"><i class="fa fa-eye"></i></a>\n' +
    '                                    <a href="/routes/pdfdownload/{{cons.docid}}" ng-show="exam.template.includefindings === true"\n' +
    '                                       uib-tooltip="Befund PDF speichern" class="btn btn-primary"><i class="fa fa-download"></i></a>&ndash;&gt;\n' +
    '                    </div>\n' +
    '                    &lt;!&ndash; Exam Bilder &ndash;&gt;\n' +
    '                    <div ng-show="eximg" style="padding:20px">\n' +
    '\n' +
    '                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"\n' +
    '                             ng-click="vm.showImage(img)"\n' +
    '                             ng-repeat="img in exam.files | filter: {mimetype: \'image/jpeg\'} |  orderBy: \'_id\'">\n' +
    '\n' +
    '                            <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"\n' +
    '                                 uib-tooltip="{{img.label}}">\n' +
    '                        </div>\n' +
    '\n' +
    '                    </div>\n' +
    '                    &lt;!&ndash; Exam Daten &ndash;&gt;\n' +
    '                    <div ng-show="exdata" style="padding:20px">\n' +
    '\n' +
    '                        <div class="row">\n' +
    '                            <div class="col-xs-12">\n' +
    '                                &lt;!&ndash; fieldgroups &ndash;&gt;\n' +
    '                                <div ng-repeat="grp in exam.template.fieldgroups">\n' +
    '                                    <h5 class="dl-horizontal" ng-hide="grp.label == \'\'" ng-model="grp.label"\n' +
    '                                        style="border-bottom: 1px solid black; border-top: 1px solid black;  padding-top: 5px; padding-bottom: 5px">\n' +
    '                                        {{grp.label}}\n' +
    '                                    </h5>\n' +
    '                                    <h5 class="dl-horizontal" ng-show="grp.label == \'\'" ng-model="grp.label"\n' +
    '                                        style="border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '                                    </h5>\n' +
    '                                    &lt;!&ndash; fields &ndash;&gt;\n' +
    '                                    <dl class="dl-horizontal">\n' +
    '                    <span class="dl-horizontal" ng-repeat="field in grp.fields">\n' +
    '                      <dt>{{field.label}}</dt>\n' +
    '                      <dd><span ng-repeat="val in field.avalues">{{val.name}}{{$last ? \'\' : \', \'}}</span></dd>\n' +
    '                    </span>\n' +
    '                                    </dl>\n' +
    '                                </div>\n' +
    '\n' +
    '                                &lt;!&ndash; exam images &ndash;&gt;\n' +
    '                                <div class="row spacer-top" ng-show="exam.files">\n' +
    '                                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 imgcontainer"\n' +
    '                                         ng-repeat="img in exam.files | filter: {mimetype: \'image/jpeg\'} |  orderBy: \'_id\'">\n' +
    '\n' +
    '                                        <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"\n' +
    '                                             uib-tooltip="{{img.label}}">\n' +
    '                                        &lt;!&ndash;<img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"\n' +
    '                                             uib-tooltip="{{img.label}}"\n' +
    '                                             ng-click="celCtrl.editImage(img)">&ndash;&gt;\n' +
    '                                        &lt;!&ndash;<div class="imgcheckbox"><input type="checkbox" ng-model="img.include" ng-click="exam.$save()"></div>&ndash;&gt;\n' +
    '                                    </div>\n' +
    '                                </div>\n' +
    '\n' +
    '                                &lt;!&ndash; Befundblock  &ndash;&gt;\n' +
    '                                <h5 class="dl-horizontal"\n' +
    '                                    style="border-bottom: 1px solid black; border-top: 1px solid black; padding-top: 5px; padding-bottom: 5px">\n' +
    '                                    Befund</h5>\n' +
    '                                <dl class="dl-horizontal">\n' +
    '                                    <dt>Diagnose</dt>\n' +
    '                                    <dd><span\n' +
    '                                        ng-repeat="diagnosis in exam.template.diagnosis.avalues">{{diagnosis.name}}{{$last ? \'\' : \', \'}}</span>\n' +
    '                                    </dd>\n' +
    '                                    <dt>Empfehlung</dt>\n' +
    '                                    <dd><span\n' +
    '                                        ng-repeat="diagnosis in exam.template.recommendation.avalues">{{diagnosis.name}}{{$last ? \'\' : \', \'}}</span>\n' +
    '                                    </dd>\n' +
    '                                    <dt>Anmerkung</dt>\n' +
    '                                    <dd><span\n' +
    '                                        ng-repeat="diagnosis in exam.template.comment.avalues">{{diagnosis.name}}{{$last ? \'\' : \', \'}}</span>\n' +
    '                                    </dd>\n' +
    '                                </dl>\n' +
    '\n' +
    '                            </div>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '\n' +
    '            &lt;!&ndash; Bilder block &ndash;&gt;\n' +
    '            <div ng-show="cons.imgs">\n' +
    '                <h4>Bilder aus der Konsultation</h4>\n' +
    '                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"\n' +
    '                     ng-repeat="img in cons.images | filter: {mimetype: \'image/jpeg\'} |  orderBy: \'_id\'">\n' +
    '\n' +
    '                    <img class="img-responsive" src="/routes/files/filereader/{{img.fileid}}"\n' +
    '                         ng-click="vm.showImage(img)"\n' +
    '                         uib-tooltip="{{img.label}}">\n' +
    '                </div>\n' +
    '                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"\n' +
    '                     ng-repeat="video in cons.images | filter: {mimetype: \'video/quicktime\'} |  orderBy: \'_id\'">\n' +
    '                    <video controls class="img-responsive" ng-src="{{video.fileid | trustUrl}}"></video>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</uib-accordion>\n' +
    '-->\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcconsult/consultkeywords-component.tpl.html',
    '<div class="spacer-top">\n' +
    '<span class="input-group" style="display: inline" ng-model="vm.keywords">\n' +
    '    <span ng-repeat="kw in vm.keywords | filter: {active: \'!\'+false}" style="display: inline;">\n' +
    '      <span uib-dropdown>\n' +
    '        <button type="button"\n' +
    '                class="btn btn-{{kw.col}}" uib-dropdown-toggle\n' +
    '                data-toggle="uib-dropdown"\n' +
    '                aria-haspopup="true" aria-expanded="false">\n' +
    '          {{kw.key}} <span class="caret"></span>\n' +
    '        </button>\n' +
    '        <ul uib-dropdown-menu>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'success\')">\n' +
    '              <span class="label label-success">{{vm.customlabels[\'success\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'warning\')">\n' +
    '              <span class="label label-warning">{{vm.customlabels[\'warning\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'danger\')">\n' +
    '              <span class="label label-danger">{{vm.customlabels[\'danger\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'info\')">\n' +
    '              <span class="label label-info">{{vm.customlabels[\'info\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'primary\')">\n' +
    '              <span class="label label-primary">{{vm.customlabels[\'primary\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li uib-dropdown>\n' +
    '            <label for="key{{$index}}">Stichwort</label>\n' +
    '            <input id="key{{$index}}" class="form-control" ng-blur="vm.editKeyword(kw)" ng-model="kw.key" ng-click="$event.stopPropagation()">\n' +
    '          </li>\n' +
    '          <li role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.removeKeyword(kw)">\n' +
    '              <span class="label label-danger">X</span> Löschen\n' +
    '            </a>\n' +
    '          </li>\n' +
    '        </ul>\n' +
    '      </span>\n' +
    '    </span><!-- ng-repeat -->\n' +
    '  </span>\n' +
    '\n' +
    '  <form name="vm.formid" ng-submit="vm.addKeyword()">\n' +
    '        <div class="input-group spacer-top">\n' +
    '            <input class="form-control" ng-model="vm.newkeyword" id="newkeyword"\n' +
    '                   placeholder="Neue Stichwort für diese Konsultation ..."\n' +
    '                   ng-keyup="$event.keyCode == 13 && vm.addKeyword()"\n' +
    '                   ng-blur="vm.addKeyword()"/>\n' +
    '            <span class="input-group-btn">\n' +
    '          <button type="submit" class="btn btn-success"\n' +
    '                  ng-click="vm.addKeyword()"><i class="fa fa-plus"></i></button>\n' +
    '        </span>\n' +
    '        </div>\n' +
    '  </form>\n' +
    '\n' +
    '\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcconsult/consulteditor-component.tpl.html',
    '<!-- Error handling -->\n' +
    '<div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom" data-hook="consulterror">\n' +
    '  <h3>\n' +
    '    <p><i class="fa fa-warning"></i> Die Konsultation konnte nicht gespeichert werden,\n' +
    '      der Fehler wurde protokolliert!</p>\n' +
    '    <p><span class="btn btn-success" ng-click="vm.save()">Erneut probieren</span></p>\n' +
    '  </h3>\n' +
    '</div>\n' +
    '\n' +
    '<!-- Header, function buttons -->\n' +
    '<div class="row"data-hook="consulteditor-component">\n' +
    '  <div class="col-xs-12 col-md-4">\n' +
    '    <h3><span class="btn" ng-class="{\'btn-info\': !vm.consult.stared}" uib-tooltip="Besonders erinnerungswürdige Konsultation" ng-click="vm.togglestar()">\n' +
    '            <i class="fa fa-star" ng-class="{\'yellow\': vm.consult.stared}"></i>\n' +
    '        </span>&nbsp;Aktuelle Konsultation</h3>\n' +
    '  </div>\n' +
    '  <div class="col-xs-12 col-md-8" style="text-align: right">\n' +
    '        <span>\n' +
    '            <form class="form-inline" role="form">\n' +
    '                <div class="row">\n' +
    '                <div class="col-xs-12">\n' +
    '                    <h3>\n' +
    '                    <!-- Get media -->\n' +
    '                      <!-- Empfänger -->\n' +
    '                            <span class="input-group">\n' +
    '                                <span class="input-group-addon" uib-tooltip="Befundempfänger wählen">\n' +
    '                                        <i class="fa fa-envelope"></i></i>\n' +
    '                                </span>\n' +
    '                                <select ng-model="vm.consult.recipient" class="form-control" ng-change="vm.save()" data-hook="selectrecipient">\n' +
    '                                    <option value="patient">Patient</option>\n' +
    '                                    <option value="practdoctor"\n' +
    '                                            ng-show="vm.patient.svdata.practdoctor">Hausarzt</option>\n' +
    '                                    <option value="refdoctor"\n' +
    '                                            ng-show="vm.patient.svdata.refdoctor">Überweisender Arzt</option>\n' +
    '                                </select>\n' +
    '\n' +
    '                            </span>\n' +
    '                      <!-- Rechnungspositionen und Finish -->\n' +
    '                        <button class="btn btn-warning" data-hook="finishconsult"\n' +
    '                                ng-click="vm.closeConsultModal(vm.consult, vm.patient.diagnoses, vm.patient.test, vm.finish)">\n' +
    '                            <i class="fa fa-cart-plus" uib-tooltip="Rechnungsposition hinzuf&uuml;gen"></i><cartcounter\n' +
    '                            clientid="vm.consult.patientid"></cartcounter><i class="fa fa-sign-out" uib-tooltip="Rechnung &amp; Abschluß"></i>\n' +
    '                        </button>\n' +
    '                      <!-- Imagecapture -->\n' +
    '                        <imagecapture captureid="cconsultphoto" consultid="vm.consultid"  data-hook="consultimageupload"\n' +
    '                                      clientid="vm.consult.patientid"\n' +
    '                                      filecat="consultphoto"\n' +
    '                                      label="" color="info"></imagecapture>\n' +
    '                      <!-- Fileupload -->\n' +
    '                        <fileupload consultid="vm.consultid" clientid="vm.consult.patientid" label="" data-hook="consultfileupload"\n' +
    '                                    color="info"></fileupload>\n' +
    '                      <!-- Ueberweisung-->\n' +
    '                        <button class="btn btn-primary" uib-tooltip="Überweisung anlegen" data-hook="createreferral"\n' +
    '                                ng-click="vm.addReferralModal(vm.consult._id, vm.consult.patientid)">\n' +
    '                            <i class="fa fa-plus"></i> <i class="fa fa-user-md"> <refcounter\n' +
    '                          consultid="vm.consult._id"></refcounter></i>\n' +
    '                        </button>\n' +
    '                      <!-- Hilfsmittel-->\n' +
    '                        <button class="btn btn-primary" uib-tooltip="Hilfsmittel verordnen" data-hook="createaide"\n' +
    '                                ng-click="vm.addAideModal(vm.consult._id, vm.consult.patientid)">\n' +
    '                            <i class="fa fa-plus"></i> <i class="fa fa-wheelchair"><aidecounter\n' +
    '                          consultid="vm.consult._id"></aidecounter></i>\n' +
    '                        </button>\n' +
    '                    </h3>\n' +
    '                </div>\n' +
    '                </div>\n' +
    '            </form>\n' +
    '        </span>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- Consult Keywords, do call consult.save() directly as keywords are bi-dirctionally bound -->\n' +
    '<consultkeywords keywords="vm.consult.keywords" parentsave="vm.save()"></consultkeywords>\n' +
    '\n' +
    '<!-- Consult main fields -->\n' +
    '<form>\n' +
    '  <!-- Consult Findings data upper row (Symptome, Therapie) -->\n' +
    '  <div class="row">\n' +
    '    <!-- Symptome -->\n' +
    '    <div class="col-xs-12 col-sm-6">\n' +
    '      <div class="form-group">\n' +
    '        <div class="form-group">\n' +
    '          <h4>Symptome\n' +
    '            <sprhelp tip="Symptome und Annamnese" descref="vm.sprsymptoms" file="befundvorlagen.pdf"\n' +
    '                     video="befundvorlagen"></sprhelp>\n' +
    '            <span class="btn btn-xs">&nbsp;</span></h4>\n' +
    '          <vcarea model="vm.consult.symptoms"  data-hook="consultsymptoms"\n' +
    '                  parentsave="vm.childsave(key, value)"\n' +
    '                  id="symptoms"\n' +
    '                  options="{ updateOn: \'default blur\', debounce: { default: 20000, blur: 0 } }">\n' +
    '          </vcarea>\n' +
    '\n' +
    '\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <!-- Therapie -->\n' +
    '    <div class="col-xs-12 col-sm-6">\n' +
    '      <div class="form-group">\n' +
    '        <h4><span class="pull-left">Therapieempfehlung <sprhelp tip="Allgemeine Therapievorschläge"\n' +
    '                                                                descref="vm.sprtherapy"></sprhelp> </span>\n' +
    '          <span class="pull-right">\n' +
    '                            <currentexamstherapies consultid="vm.consultid"></currentexamstherapies>\n' +
    '            <!--<span class="btn btn-success btn-xs"><i class="fa fa-list-ul"></i> </span>-->\n' +
    '                        </span>\n' +
    '          <span class="clearfix"></span>\n' +
    '        </h4>\n' +
    '\n' +
    '        <vcarea model="vm.consult.therapy"  data-hook="consulttherapy"\n' +
    '                parentsave="vm.childsave(key, value)"\n' +
    '                id="therapy"\n' +
    '                options="{ updateOn: \'default blur\', debounce: { default: 20000, blur: 0 } }">\n' +
    '        </vcarea>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Consult Findings data lower row (Anmerkungen, Notizen) -->\n' +
    '  <div class="row">\n' +
    '    <!-- Befund -->\n' +
    '    <div class="col-xs-12 col-sm-6">\n' +
    '      <div class="form-group">\n' +
    '\n' +
    '        <!--uib-tooltip="Ergänzung zu Detailbefunden der einzelnen Untersuchungen"-->\n' +
    '        <h4>\n' +
    '                    <span class="pull-left">Gesamtbefund<sprhelp tip="Befundzusammenfassungen"\n' +
    '                                                                 descref="vm.sprfindings"></sprhelp></span>\n' +
    '          <span class="pull-right">\n' +
    '                        <currentexamsfindings consultid="vm.consultid"></currentexamsfindings>\n' +
    '                        <currentexamscomments consultid="vm.consultid"></currentexamscomments>\n' +
    '                        <a class="btn btn-info btn-xs" href="{{vm.consultPreviewUrl(vm.consult._id)}}" target="_blank"\n' +
    '                           uib-tooltip="PDF Vorschau">\n' +
    '                            <i class="fa fa-eye"></i>\n' +
    '                        </a>\n' +
    '                    </span>\n' +
    '          <span class="clearfix"></span>\n' +
    '        </h4>\n' +
    '        <vcarea model="vm.consult.findings"  data-hook="consultfindings"\n' +
    '                parentsave="vm.childsave(key, value)"\n' +
    '                id="findings"\n' +
    '                options="{ updateOn: \'default blur\', debounce: { default: 20000, blur: 0 } }">\n' +
    '        </vcarea>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-sm-6">\n' +
    '      <!-- Patientennotizen -->\n' +
    '      <div class="form-group">\n' +
    '        <!--uib-tooltip="Diese Patientennotizen werden nicht in Befunde oder andere Dokumente übernommen."-->\n' +
    '        <h4>\n' +
    '          Permanente Notizen zum Patienten (privat)\n' +
    '          <sprhelp tip="Private Notizen" descref="vm.sprnotes"></sprhelp>\n' +
    '          <span class="btn btn-xs">&nbsp;</span></h4>\n' +
    '        <clientnotes clientid="vm.consult.patientid" mode="patient" id="consultnotes"  data-hook="patientnotes"></clientnotes>\n' +
    '\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- show imges -->\n' +
    '  <consultimagelist consultid="vm.consultid"></consultimagelist>\n' +
    '\n' +
    '\n' +
    '  <!-- show files -->\n' +
    '  <consultfilelist consultid="vm.consultid"></consultfilelist>\n' +
    '\n' +
    '  <!-- Untersuchungsstarter (keine offene Untersuchung) -->\n' +
    '  <examstarter consult="vm.consult"></examstarter>\n' +
    '\n' +
    '  <!-- Aktuelle Untersuchungen -->\n' +
    '  <currentexams consultid="vm.consultid"></currentexams>\n' +
    '\n' +
    '</form>\n' +
    '\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/svedit-component.tpl.html',
    '<!-- TODO: some svedit fields are non-syncing, evaluate and replace where necessary  -->\n' +
    '<div class="svedit svedit-component" data-hook="svedit-component">\n' +
    '  <form name="patsvdata">\n' +
    '    <div class="row">\n' +
    '      <!-- Geburtsdatum -->\n' +
    '      <div class="form-group col-xs-12 col-md-3">\n' +
    '        <label for="birthdate">Geburtsdatum\n' +
    '          <sprhelp tip="Eingabeformat" descref="vm.bdatehelp"></sprhelp>\n' +
    '          <span ng-show="vm.bdateerror" style="color: #cc3333"><i class="fa fa-warning"></i> {{vm.bdateerror}}</span>\n' +
    '        </label>\n' +
    '\n' +
    '        <input ng-show="!vm.svdata.bdateat  || vm.svdata.bdateat === \'Invalid date\'"\n' +
    '               type="text" ng-model="vm.svdata.birthdate" tabindex="0"\n' +
    '               ng-blur="vm.formatbdate(vm.svdata.birthdate)"\n' +
    '               class="form-control" id="birthdate"\n' +
    '               ng-focus="vm.setCurrentField(\'birthdate\')"\n' +
    '               ng-change="vm.setCurrentFieldContent(vm.svdata.birthdate)"\n' +
    '               placeholder="TTMMJJJJ">\n' +
    '\n' +
    '        <div class="input-group" ng-show="vm.svdata.bdateat  && vm.svdata.bdateat !== \'Invalid date\'">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="birthdate"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.svdata.bdateat">\n' +
    '          <span class="input-group-btn">\n' +
    '        <button class="btn btn-danger"\n' +
    '                ng-click="vm.clearbdate()"><i class="fa fa-remove"></i>\n' +
    '        </button>\n' +
    '      </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '\n' +
    '\n' +
    '      <!-- SVNr -->\n' +
    '      <div class="form-group col-xs-12 col-md-3">\n' +
    '        <label for="svnr">SVNr\n' +
    '          <sprhelp tip="Eingabeformat: NNNN -&gt;| TTMMJJ"></sprhelp>\n' +
    '          <span ng-hide="vm.isvalidsvnr === true"\n' +
    '                class="text-danger"><i class="fa fa-warning"></i> SVNr ist ungültig!</span>\n' +
    '          <span ng-show="vm.isvalidsvnr === true"\n' +
    '                class="text-success"><i class="fa fa-check"></i> SVNr ist gültig!</span>\n' +
    '        </label>\n' +
    '        <span style="display: block"\n' +
    '              ng-hide="vm.svdata.svnr  && vm.isvalidsvnr">\n' +
    '          <input type="text" ng-model="vm.svdata.svnrlfd"\n' +
    '                 tabindex="0"\n' +
    '                 ng-change="vm.isvalidsvnr = vm.formatSVNR();"\n' +
    '                 ng-blur="vm.isvalidsvnr = vm.formatSVNR(); vm.save();"\n' +
    '                 style="width: 30%; display: inline;"\n' +
    '                 class="form-control" id="svnrlfd"\n' +
    '                 placeholder="NNNN"><!-- do not remove this comment\n' +
    '      --><input type="text" ng-model="vm.svdata.bdatesv" tabindex="0"\n' +
    '                ng-change="vm.isvalidsvnr = vm.formatSVNR();"\n' +
    '                ng-blur="vm.isvalidsvnr = vm.formatSVNR(); vm.save();"\n' +
    '                style="width: 60%; display: inline;"\n' +
    '                class="form-control" id="bdatesv" placeholder="DDMMJJ"></span>\n' +
    '\n' +
    '        <div class="input-group" ng-show="vm.svdata.svnr  && vm.isvalidsvnr">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="svnr"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.svdata.svnr">\n' +
    '          <span class="input-group-btn">\n' +
    '        <button class="btn btn-danger"\n' +
    '                ng-click="vm.clearSVNR()"><i class="fa fa-remove"></i>\n' +
    '        </button>\n' +
    '      </span>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Rezeptgebührenbefreiung -->\n' +
    '      <div class="row">\n' +
    '        <div class="form-group col-xs-12 col-md-6">\n' +
    '          <label for="feefree">Rezeptgebührenbefreiung</label>\n' +
    '          <div class="checkbox">\n' +
    '            <label>\n' +
    '              <input type="checkbox" ng-model="vm.svdata.feefree" tabindex="0"\n' +
    '                     ng-blur="vm.save()"\n' +
    '                     id="feefree"\n' +
    '              >&nbsp;befreit\n' +
    '            </label>\n' +
    '          </div>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- SV -->\n' +
    '    <div class="row">\n' +
    '      <!-- Sozialversicherung -->\n' +
    '      <div class="col-xs-2 col-md-2">\n' +
    '\n' +
    '        <label for="sv">Sozialversicherung</label>\n' +
    '        <svsearch ng-hide="vm.svdata.sv.short"\n' +
    '                  sv="vm.svdata.sv"\n' +
    '                  svref="vm.svdata.svref"\n' +
    '                  parentsave="vm.svsave(sv, svref)"\n' +
    '                  ti="0" id="sv"></svsearch>\n' +
    '        <div class="input-group"\n' +
    '             ng-show="vm.svdata.sv.short">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="svs"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.svdata.sv.short">\n' +
    '          <span class="input-group-btn">\n' +
    '            <button class="btn btn-danger"\n' +
    '                    ng-click="vm.clearSV()"><i class="fa fa-remove"></i>\n' +
    '            </button>\n' +
    '          </span>\n' +
    '        </div>\n' +
    '\n' +
    '      </div>\n' +
    '      <!-- Versichertengruppe -->\n' +
    '      <div class="form-group col-xs-9 col-md-4">\n' +
    '        <label for="svstatus">Versichertengruppe</label>\n' +
    '        <select ng-model="vm.svdata.svstatus" tabindex="0"\n' +
    '                ng-blur="vm.save()"\n' +
    '                class="form-control" id="svstatus">\n' +
    '          <option value="01">01 - Erwerbstätig, Arbeitslos, Selbstversichert</option>\n' +
    '          <option value="02">02 - Pensionist(in)</option>\n' +
    '          <option value="03">03 - Kriegshinterbliebene(r)</option>\n' +
    '          <option value="05">05 - Angehörige(r) von 01</option>\n' +
    '          <option value="06">06 - Angehörige(r) von 02</option>\n' +
    '          <option value="08">08 - Anspruch KOVG, OFG, HVG D u. DH</option>\n' +
    '          <option value="10">10 - VAEB (A/B), BVA</option>\n' +
    '          <option value="11">11 - Angehörige(r) von 10</option>\n' +
    '          <option value="12">12 - Sozialversicherungsabkommen</option>\n' +
    '        </select>\n' +
    '      </div>\n' +
    '\n' +
    '      <!-- Arbeitgeber -->\n' +
    '      <div class="form-group col-xs-12 col-md-6">\n' +
    '        <label for="employer">Arbeitgeber</label>\n' +
    '        <vcinput model="vm.svdata.employer" id="employer" placeholder="Arbeitgeber"\n' +
    '                 parentsave="vm.childsave(key, value)">\n' +
    '      </div>\n' +
    '\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Mitversicherung -->\n' +
    '    <div class=" row">\n' +
    '      <div class="form-group col-xs-12 col-md-6">\n' +
    '        <label for="insuredname">Mitversichert bei (Name)</label>\n' +
    '        <input type="text" ng-model="vm.svdata.insuredwith.name" tabindex="0"\n' +
    '               ng-blur="vm.save()"\n' +
    '               class="form-control" id="insuredname"\n' +
    '               placeholder="Name">\n' +
    '      </div>\n' +
    '      <div class="form-group col-xs-12 col-md-6">\n' +
    '        <label for="insurednr">Mitversichert bei (SVNr)\n' +
    '          <span ng-show="vm.inswvalid === false" class="text-danger"><i\n' +
    '            class="fa fa-warning"></i> SVNr ist ungülitg!</span>\n' +
    '          <span ng-show="vm.inswvalid === true" class="text-success"><i class="fa fa-check"></i> SVNr ist gülitg!</span>\n' +
    '        </label>\n' +
    '        <input type="text" ng-model="vm.svdata.insuredwith.svnr" tabindex="0"\n' +
    '               ng-blur="vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr); vm.save();"\n' +
    '               ng-change="vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr);"\n' +
    '               class="form-control" id="insurednr"\n' +
    '               placeholder="SVNr">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Andere Versicherungen -->\n' +
    '    <div class=" row">\n' +
    '      <!-- Versicherungsnummer -->\n' +
    '      <div class="form-group col-xs-12 col-md-6">\n' +
    '        <label for="insurancenr">Versicherungsnummer\n' +
    '          <sprhelp\n' +
    '            tip="Versicherungsnummer bei Privatversicherung od. ausländischem Versicherungsträger"></sprhelp>\n' +
    '        </label>\n' +
    '        <vcinput model="vm.svdata.insurancenr" id="insurancenr" placeholder="Versicherungsnummer"\n' +
    '                 parentsave="vm.childsave(key, value)">\n' +
    '      </div>\n' +
    '      <!-- Versicherungsträger -->\n' +
    '      <div class="form-group col-xs-12 col-md-6">\n' +
    '        <label for="insuranceprov">Versicherungsträger\n' +
    '          <sprhelp tip="Privatversicherung od. ausländischer Versicherungsträger"></sprhelp>\n' +
    '        </label>\n' +
    '        <vcinput model="vm.svdata.insuranceprov" id="insuranceprov" placeholder="Versicherung"\n' +
    '                 parentsave="vm.childsave(key, value)">\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Ärzte -->\n' +
    '    <div class=" row">\n' +
    '      <!-- Hausarzt- -->\n' +
    '      <div class="form-group  col-md-6" ng-hide="vm.svdata.practdoctor._id">\n' +
    '        <label for="doctor">Hausarzt</label>\n' +
    '        <doctorsearch id="doctor" parentsave="vm.savePractDoctor(doctor)"></doctorsearch>\n' +
    '      </div>\n' +
    '      <div class="form-group col-md-6" ng-show="vm.svdata.practdoctor._id">\n' +
    '        <label for="pdoctorname">Hausarzt</label>\n' +
    '\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="pdoctorname"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.svdata.practdoctor.fname">\n' +
    '          <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearPractDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Überweisender Arzt -->\n' +
    '      <div class="form-group  col-md-6" ng-hide="vm.svdata.refdoctor._id">\n' +
    '        <label for="refdoctor">Überweisender Arzt</label>\n' +
    '        <doctorsearch id="refdoctor" parentsave="vm.saveRefDoctor(doctor)"></doctorsearch>\n' +
    '      </div>\n' +
    '      <div class="form-group col-md-6" ng-show="vm.svdata.refdoctor._id">\n' +
    '        <label for="rdoctorname">Überweisender Arzt</label>\n' +
    '\n' +
    '        <div class="input-group">\n' +
    '          <input type="text" class="form-control"\n' +
    '                 id="rdoctorname"\n' +
    '                 readonly\n' +
    '                 ng-model="vm.svdata.refdoctor.fname">\n' +
    '          <span class="input-group-btn">\n' +
    '                    <button class="btn btn-danger"\n' +
    '                            ng-click="vm.clearRefDoctor()"><i class="fa fa-remove"></i>\n' +
    '                    </button>\n' +
    '                </span>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Baisdaten-->\n' +
    '    <div class="row">\n' +
    '      <!-- Größe -->\n' +
    '      <div class="form-group col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label for="height">Größe (cm)</label>\n' +
    '          <input type="number" id="height" ng-model="vm.svdata.height"\n' +
    '                 tabindex="0"\n' +
    '                 class="form-control" ng-blur="vm.setBMI()"/>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- Gewicht -->\n' +
    '      <div class="form-group col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label for="weight">Gewicht (kg)</label>\n' +
    '          <input type="number" id="weight" ng-model="vm.svdata.weight"\n' +
    '                 tabindex="0"\n' +
    '                 class="form-control" ng-blur="vm.setBMI()"/>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '      <!-- BMI -->\n' +
    '      <div class="form-group col-md-4">\n' +
    '        <div class="form-group">\n' +
    '          <label for="bmi">BMI\n' +
    '            <sprhelp tip="Wird automatisch aus Gewicht und Größe ermittelt"></sprhelp>\n' +
    '          </label>\n' +
    '          <input type="number" id="bmi" ng-model="vm.svdata.bmi" step="0.1" readonly class="form-control"/>\n' +
    '        </div>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/riskedit-component.tpl.html',
    '<!-- Risikofaktoren -->\n' +
    '<!-- Nikotin -->\n' +
    '<div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="nicr">Nikotin</label><br>\n' +
    '        <label class="radio-inline"><input type="radio" name="nicr" ng-value="true" tabindex="26"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.nicotin">ja</label>\n' +
    '        <label class="radio-inline"><input type="radio" name="nicr" ng-value="false" tabindex="27"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.nicotin">nein</label>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="nicotindetails">Nikotin Details</label>\n' +
    '        <vcinput model="vm.risk.nicotindetails" id="nicotindetails" placeholder="Details zum Nikotinkonsum" parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<!-- Alkohol -->\n' +
    '<div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="alcr">Alkohol</label><br>\n' +
    '        <label class="radio-inline"><input type="radio" name="alcr" ng-value="true" tabindex="29"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.alcohol">ja</label>\n' +
    '        <label class="radio-inline"><input type="radio" name="alcr" ng-value="false" tabindex="30"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.alcohol">nein</label>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="alcoholdetails">Alkohol Details</label>\n' +
    '        <vcinput model="vm.risk.alcoholdetails" id="alcoholdetails" placeholder="Details zum Alkoholkonsum" parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '<!-- Andere Risiken -->\n' +
    '<div class="row">\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="or">Andere Risiken</label><br>\n' +
    '        <label class="radio-inline"><input type="radio" name="or" ng-value="true" tabindex="32"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.otherb">ja</label>\n' +
    '        <label class="radio-inline"><input type="radio" name="or" ng-value="false" tabindex="33"\n' +
    '                                           ng-change="vm.save()"\n' +
    '                                           ng-model="vm.risk.otherb">nein</label>\n' +
    '    </div>\n' +
    '    <div class="col-md-6">\n' +
    '        <label for="other">Andere Risiken Details</label>\n' +
    '        <vcinput model="vm.risk.other" id="other" placeholder="Andere Risikofaktoren ..." parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/diagnosesedit-component.tpl.html',
    '<!-- <label for="newkeyword">{{vm.text}}</label> -->\n' +
    '<div class="spacer-top">\n' +
    '<span class="input-group" style="display: inline" as-sortable="vm.sortableOptions" ng-model="vm.diagnoses"\n' +
    '      id="sortable-container">\n' +
    '<!--    <span ng-repeat="kw in vm.diagnoses | filter: {active: \'!\'+false}" as-sortable-item style="display: inline;">-->\n' +
    '    <span ng-repeat="kw in vm.diagnoses" as-sortable-item style="display: inline;">\n' +
    '      <span uib-dropdown>\n' +
    '        <button type="button" as-sortable-item-handle\n' +
    '                class="btn btn-{{kw.col}}" uib-dropdown-toggle\n' +
    '                data-toggle="uib-dropdown"\n' +
    '                aria-haspopup="true" aria-expanded="false">\n' +
    '          <span class="fa fa-eye-slash" ng-show="kw.hideInInvoice === true"></span>\n' +
    '          {{kw.key}} <span class="caret"></span>\n' +
    '        </button>\n' +
    '        <ul uib-dropdown-menu style="min-width: 250px">\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'success\')">\n' +
    '              <span class="label label-success">{{vm.customlabels[\'success\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'warning\')">\n' +
    '              <span class="label label-warning">{{vm.customlabels[\'warning\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'danger\')">\n' +
    '              <span class="label label-danger">{{vm.customlabels[\'danger\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'info\')">\n' +
    '              <span class="label label-info">{{vm.customlabels[\'info\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li>\n' +
    '            <a ng-click="vm.updateColor(kw,\'primary\')">\n' +
    '              <span class="label label-primary">{{vm.customlabels[\'primary\']}}</span>\n' +
    '            </a>\n' +
    '          </li>\n' +
    '          <li role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li uib-dropdown>\n' +
    '            <label for="key{{$index}}" style="padding-left: 20px">Diagnose</label>\n' +
    '            <textarea id="key{{$index}}" class="form-control" ng-blur="vm.editKeyword(kw)" ng-model="kw.key"\n' +
    '                      ng-click="$event.stopPropagation()"></textarea>\n' +
    '          </li>\n' +
    '          <li role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li uib-dropdown ng-show="kw.created"><a><span class="label label-default">Erstellt: {{kw.created}}</span></a></li>\n' +
    '          <li uib-dropdown ng-show="kw.updated"><a><span class="label label-default">Geändert: {{kw.updated}}</span></a></li>\n' +
    '          <li role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li uib-dropdown>\n' +
    '            <span style="margin-left: 20px">\n' +
    '              <input id="vis{{$index}}" type="checkbox" class="form-check-input" ng-change="vm.updateInvoiceVisibility(kw); "\n' +
    '                     ng-model="kw.hideInInvoice">&nbsp;In Rechnung verbergen\n' +
    '            </span>\n' +
    '          </li>\n' +
    '          <li ng-hide="!vm.deleteable || kw.col === \'danger\'" role="separator" class="divider" uib-dropdown></li>\n' +
    '          <li ng-hide="!vm.deleteable || kw.col === \'danger\'">\n' +
    '              <span class="btn btn-danger btn-sm"  style="margin-left: 20px; margin-right: 20px; min-width:210px " ng-really-message="Stichwort wirklich löschen?"\n' +
    '                    ng-really-click="vm.removeKeyword(kw, $index)"><i class="fa fa-remove"></i> Löschen</span>\n' +
    '        </ul>\n' +
    '      </span>\n' +
    '    </span><!-- ng-repeat -->\n' +
    '  </span>\n' +
    '\n' +
    '  <form name="vm.formid" ng-submit="vm.addKeyword()">\n' +
    '    <div class="input-group spacer-top">\n' +
    '      <input class="form-control" ng-model="vm.newkeyword" id="newkeyword"\n' +
    '             placeholder="Neue Diagnose ..."\n' +
    '             ng-keyup="$event.keyCode == 13 && vm.addKeyword()"\n' +
    '             ng-blur="vm.addKeyword()"/>\n' +
    '      <span class="input-group-btn">\n' +
    '          <button type="submit" class="btn btn-success"\n' +
    '                  ng-click="vm.addKeyword()"><i class="fa fa-plus"></i></button>\n' +
    '        </span>\n' +
    '    </div>\n' +
    '  </form>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/contactedit-component.tpl.html',
    '<div class="contactedit-component" data-hook="contactedit-component">\n' +
    '  <div class="row">\n' +
    '    <!-- Geschlecht -->\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="gender1">Geschlecht</label>\n' +
    '      <div class="radio">\n' +
    '        <label for="gender1" class="radio-inline">\n' +
    '          <input type="radio" value="weiblich" tabindex="0"\n' +
    '                 ng-model="vm.contactdata.gender"\n' +
    '                 ng-change="vm.save()"\n' +
    '                 id="gender1">weiblich</label>\n' +
    '        <label for="gender2" class="radio-inline">\n' +
    '          <input type="radio" value="männlich" tabindex="0"\n' +
    '                 ng-model="vm.contactdata.gender"\n' +
    '                 ng-change="vm.save()"\n' +
    '                 id="gender2">männlich</label>\n' +
    '        <label for="gender3" class="radio-inline">\n' +
    '          <input type="radio" value="unbekannt" tabindex="0"\n' +
    '                 ng-model="vm.contactdata.gender"\n' +
    '                 ng-change="vm.save()"\n' +
    '                 id="gender3">unbekannt</label>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <div ng-show="vm.showrelation">\n' +
    '        <label for="relation">Bezug zum primären Kontakt</label>\n' +
    '        <vcinput model="vm.contactdata.relation" id="relation" placeholder="Bezug"\n' +
    '                 parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '      </div>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- Titel, Name -->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-2">\n' +
    '      <label for="titlefront">Titel</label>\n' +
    '      <vcinput model="vm.contactdata.titlefront" id="titlefront" parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="firstname">Vorname</label>\n' +
    '      <vcinput model="vm.contactdata.firstname" id="firstname" placeholder="Vorname"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="lastname">Nachname</label>\n' +
    '      <vcinput model="vm.contactdata.lastname" id="lastname" placeholder="Nachname"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-2">\n' +
    '      <label for="titleback">Titel</label>\n' +
    '      <vcinput model="vm.contactdata.titleback" id="titleback" parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <!-- Adresse -->\n' +
    '  <div class=" row">\n' +
    '    <div class="form-group col-xs-12">\n' +
    '      <label for="address">Adresse</label>\n' +
    '      <vcinput model="vm.contactdata.address" id="address" placeholder="Adresse"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <!-- PLZ & Ort, Land -->\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <zipcode zip="vm.contactdata.postcode" parentsave="vm.zipsave(zip, city)" city="vm.contactdata.city" ti="0"\n' +
    '               ti2="0"></zipcode>\n' +
    '    </div>\n' +
    '    <!-- Land -->\n' +
    '    <div class="form-group col-xs-12 col-md-6" ng-init="vm.contactdata.country=\'Österreich\'">\n' +
    '      <label for="country">Land</label>\n' +
    '      <!--      <input type="text" ng-model="vm.contactdata.country" tabindex="0"\n' +
    '                   ng-blur="vm.save()"\n' +
    '                   class="form-control" id="country" value="Österreich">-->\n' +
    '      <vcinput model="vm.contactdata.country" id="country" parentsave="vm.childsave(key, value)">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '\n' +
    '  <div class="row">\n' +
    '    <!-- Mobil -->\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="phone">Mobiltelefon</label>\n' +
    '      <!--      <input type="text" ng-model="vm.contactdata.phone" tabindex="0"\n' +
    '                   ng-blur="vm.save()"\n' +
    '                   class="form-control" id="phone" placeholder="Mobilnummer">-->\n' +
    '      <vcinput model="vm.contactdata.phone" id="phone" placeholder="Mobilnummer"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '    <!-- Festnetz -->\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="landline">Festnetz/2. Mobiltelefon</label>\n' +
    '      <!--      <input type="text" ng-model="vm.contactdata.landline" tabindex="0"\n' +
    '                   ng-blur="vm.save()"\n' +
    '                   class="form-control" id="landline" placeholder="Festnetznummer">-->\n' +
    '      <vcinput model="vm.contactdata.landline" id="landline" placeholder="Festnetznummer"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="row">\n' +
    '    <!-- E-Mail -->\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="email">E-Mail</label>\n' +
    '      <!--      <input type="email" ng-model="vm.contactdata.email" tabindex="0"\n' +
    '                   ng-blur="vm.save()"\n' +
    '                   class="form-control" id="email" placeholder="E-Mail">-->\n' +
    '      <vcinput model="vm.contactdata.email" id="email" placeholder="E-Mail"\n' +
    '               parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '    <!-- Fax -->\n' +
    '    <div class="form-group col-xs-12 col-md-6">\n' +
    '      <label for="fax">Fax</label>\n' +
    '      <!--      <input type="text" ng-model="vm.contactdata.fax" tabindex="0"\n' +
    '                   ng-blur="vm.save()"\n' +
    '                   class="form-control" id="fax" placeholder="Fax">-->\n' +
    '      <vcinput model="vm.contactdata.fax" id="fax" placeholder="Fax" parentsave="vm.childsave(key, value)"></vcinput>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/companyedit-component.tpl.html',
    '\n' +
    '<div class="companyedit-component" data-hook="companyedit-component">\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-8">\n' +
    '      <label for="compname">Name der Firma/Organisation</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.name" id="compname"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="comptype">Typ</label>\n' +
    '      <select class="form-control" tabindex="0" ng-model="vm.companydata.type" id="comptype" ng-blur="vm.save()">\n' +
    '        <option>Unternehmen</option>\n' +
    '        <option>Verwaltung</option>\n' +
    '        <option>Schule</option>\n' +
    '        <option>Universität</option>\n' +
    '        <option>Heer/Armee</option>\n' +
    '        <option>Polizei</option>\n' +
    '        <option>Kirche</option>\n' +
    '        <option>Partei</option>\n' +
    '        <option>Verein/NGO</option>\n' +
    '        <option>Anderes/Unbekannt</option>\n' +
    '      </select>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="compuid">UID</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.uid" id="compuid"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="compfbnr">FBNr.</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.fbnr" id="compfbnr"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12 col-md-4">\n' +
    '      <label for="compstnr">SteuerNr.</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.stnr" id="compstnr"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12  col-md-6">\n' +
    '      <label for="compaddr1">Firmensitz - Adresse</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.address1" id="compaddr1"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12  col-md-6">\n' +
    '      <label for="compaddr1">Firmensitz - Adresszusatz</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.address2" id="compaddr2"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '  \n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <!-- PLZ & Ort --><!-- TODO: figure out tabindex handling, zipcode componeparentsaveange? -->\n' +
    '    <div class="form-group form-group col-xs-12 col-md-6">\n' +
    '      <zipcode zip="vm.companydata.postcode" city="vm.companydata.city" ti="0" ti2="0" ng-blur="vm.save()"></zipcode>\n' +
    '    </div>\n' +
    '    <div class="form-group col-xs-12  col-md-6">\n' +
    '      <label for="compcountry">Land</label>\n' +
    '      <input type="text" class="form-control" tabindex="0" ng-model="vm.companydata.country" id="compcountry"\n' +
    '             ng-blur="vm.save()">\n' +
    '    </div>\n' +
    '  </div>\n' +
    '  <div class="row">\n' +
    '    <div class="form-group col-xs-12">\n' +
    '      <label for="compnote">Notiz zur Organisation</label>\n' +
    '      <textarea type="text" class="form-control" tabindex="0" ng-model="vm.companydata.note" id="compnote"\n' +
    '                ng-blur="vm.save()"></textarea>\n' +
    '    </div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/clientnew-component.tpl.html',
    '<div class="clientnew-component" data-hook="clientnew-component">\n' +
    '  <form class="form-vertical">\n' +
    '    <!-- Organisation -->\n' +
    '    <div class="form-group">\n' +
    '      <label for="org">Firma od. Organisation</label>\n' +
    '      <input type="text" class="form-control"\n' +
    '             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"\n' +
    '             placeholder="Name der Organisation"\n' +
    '             ng-model="vm.newclient.companydata.name" id="org"\n' +
    '             typeahead-on-select="vm.setOrgname($item, $model, $label, $event)"\n' +
    '             typeahead-template-url="lastnameTpl"\n' +
    '             typeahead-min-length="1"\n' +
    '             typeahead-editable="true"\n' +
    '             uib-typeahead="org as org.text for org in vm.orgSearch($viewValue)"\n' +
    '             typeahead-no-results="noOrgResults">\n' +
    '    </div>\n' +
    '    <div ng-repeat="pat in vm.orgs">\n' +
    '      <span ng-click="vm.showRecord(pat._id)" class="btn btn-info">Akte</span>\n' +
    '      {{pat.lastname | uppercase }} {{pat.firstname}}, * {{pat.birthdate}}\n' +
    '    </div>\n' +
    '    \n' +
    '    <!-- Nachname -->\n' +
    '    <div class="form-group">\n' +
    '      <label for="nlname">Nachname</label>\n' +
    '      <input type="text" class="form-control"\n' +
    '             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"\n' +
    '             placeholder="Nachname"\n' +
    '             ng-model="vm.newclient.primarycontact.lastname" id="nlname"\n' +
    '             typeahead-min-length="1"\n' +
    '             typeahead-template-url="lastnameTpl"\n' +
    '             typeahead-editable="true"\n' +
    '             typeahead-on-select="vm.setLastname($item, $model, $label, $event)"\n' +
    '             uib-typeahead="pat as pat.text for pat in vm.nameSearch($viewValue)"\n' +
    '             typeahead-no-results="noResults">\n' +
    '    </div>\n' +
    '\n' +
    '    <!-- Vorname -->\n' +
    '<!--    <div class="form-group">\n' +
    '      <label for="nfname">Vorname</label>\n' +
    '      <input type="text" ng-model="vm.newpatient.firstname" class="form-control"\n' +
    '             autocomplete="noway" autocorrect="off" autocapitalize="on" spellcheck="false"\n' +
    '             id="nfname" placeholder="Vorname">\n' +
    '    </div>-->\n' +
    '  </form>\n' +
    '  \n' +
    '  <!--<i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>-->\n' +
    '  <div ng-repeat="pat in vm.names">\n' +
    '    <span ng-click="vm.showRecord(pat._id)" class="btn btn-info">Akte</span>\n' +
    '    {{pat.primarycontact.lastname | uppercase }} {{pat.primarycontact.firstname}}, * {{pat.svdata.birthdate}}\n' +
    '  </div>\n' +
    '  \n' +
    '  <div ng-show="noResults" class="form-group">\n' +
    '    <i class="fa fa-warning"></i> Es existiert noch kein {{vm.kunde}} mit diesem Nachnamen\n' +
    '  </div>\n' +
    '\n' +
    '  <div ng-show="noOrgResults" class="form-group">\n' +
    '    <i class="fa fa-warning"></i> Es existiert noch keine Organisationen mit diesem Namen\n' +
    '  </div>\n' +
    '\n' +
    '  <div class="form-group">\n' +
    '    <div class="btn btn-success btn-spacer-top" ng-click="vm.createPatient(); $parent.$dismiss();">Neuen {{vm.kunden}}\n' +
    '      anlegen\n' +
    '    </div>\n' +
    '    <div class="btn btn-danger btn-spacer-top" ng-click="vm.cancel();">Abbrechen</div>\n' +
    '  </div>\n' +
    '</div>\n' +
    '\n' +
    '<script type="text/ng-template" id="lastnameTpl">\n' +
    '  <a>\n' +
    '    <span class="btn btn-info gotorec" ng-click="vm.gotoRecord(match.model)" style="z-index: 1000">Akte</span>\n' +
    '    <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>\n' +
    '  </a>\n' +
    '</script>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/clientlist-component.tpl.html',
    '<div class="clientlist-component" data-hook="clientlist-component">\n' +
    '  <table class="table table-striped">\n' +
    '    <thead>\n' +
    '    <tr>\n' +
    '      <th>Nachname</th>\n' +
    '      <th>Vorname</th>\n' +
    '      <th><span>Firmenname</span></th>\n' +
    '      <th>Kategorie</th>\n' +
    '      <th ng-show="vm.mode === \'patient\'">Test</th>\n' +
    '      <th>Aktion</th>\n' +
    '    </tr>\n' +
    '    </thead>\n' +
    '    <tr ng-repeat="client in vm.clients">\n' +
    '      <td>{{client.primarycontact.lastname}}</td>\n' +
    '      <td>{{client.primarycontact.firstname}}</td>\n' +
    '      <td>{{client.companydata.name}}</td>\n' +
    '      <td>{{client.companydata.type}}</td>\n' +
    '      <td ng-show="vm.mode === \'patient\'"><span ng-show="client.test === true"><i class="fa fa-check"></i></span></td>\n' +
    '      <td>\n' +
    '        <button class="btn btn-primary" ng-click="vm.goToRecord(client, vm.redirect)">Akte</button>\n' +
    '        <button ng-hide="vm.mode === \'patient\'" class="btn btn-danger" uib-tooltip="L&ouml;schen"  ng-click="vm.removeClient(client)">\n' +
    '          <i class="fa fa-remove"></i>\n' +
    '        </button>\n' +
    '      </td>\n' +
    '    </tr>\n' +
    '  </table>\n' +
    '  \n' +
    '  \n' +
    '  <div uib-pagination total-items="vm.totalItems"\n' +
    '                  items-per-page="vm.pageSize"\n' +
    '                  max-size="10"\n' +
    '                  first-text="Erste"\n' +
    '                  last-text="Letzte"\n' +
    '                  next-text="N&auml;chste"\n' +
    '                  previous-text="Vorige"\n' +
    '                  boundary-links="true"\n' +
    '                  rotate="false"\n' +
    '                  ng-model="vm.currentPage"\n' +
    '                  ng-change="vm.pageChanged()"></div>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('vcclient/clienteditor-component.tpl.html',
    '<div id="clienteditor" class="clienteditor-component" data-hook="clienteditor-component">\n' +
    '    <form name="clientedit" autocomplete="noway">\n' +
    '        <div class="row">\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <!-- Testpatient -->\n' +
    '                <div class="form-group">\n' +
    '                    <label for="testpat"\n' +
    '                           style="-webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;">\n' +
    '                        Status\n' +
    '                        <sprhelp tip="Status" descref="vm.testhelp" style="display: inline"></sprhelp>\n' +
    '                    </label>\n' +
    '                    <div class="form-group">\n' +
    '                        <label for="testpat" class="checkbox-inline">\n' +
    '                            <input type="checkbox" id="testpat" ng-change="vm.save()" tabindex="0"\n' +
    '                                   ng-model="vm.client.test"/> {{vm.testkunde}}</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <!-- ist Firma -->\n' +
    '                <div class="form-group">\n' +
    '                    <label for="testpat">Organsiation</label>\n' +
    '                    <div class="form-group">\n' +
    '                        <label for="iscompany" class="checkbox-inline">\n' +
    '                            <input type="checkbox" id="iscompany"\n' +
    '                                   ng-change="vm.save()" tabindex="0"\n' +
    '                                   ng-model="vm.client.iscompany"/> Organisation/Firma</label>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '            <div class="col-xs-12 col-md-4">\n' +
    '                <!-- Kundenkatgorie -->\n' +
    '                <div class="form-group">\n' +
    '                    <label for="clientcat"\n' +
    '                           style="-webkit-column-break-inside: avoid; page-break-inside: avoid; break-inside: avoid;">Kundenkategorie\n' +
    '                        <sprhelp tip="Kundenkategorie" descref="vm.clientcathelp" style="display: inline"></sprhelp>\n' +
    '                    </label>\n' +
    '                    <input type="text" class="form-control" tabindex="0"\n' +
    '                           ng-blur="vm.save()"\n' +
    '                           ng-show="angular.isUndefined(vm.clientcategories) || !angular.isArray(vm.clientcategories)"\n' +
    '                           id="clientcat" name="clientcat" ng-model="vm.client.category">\n' +
    '                    <select class="form-control" tabindex="0"\n' +
    '                            ng-show="angular.isDefined(vm.clientcategories) && vm.clientcategories.length > 0"\n' +
    '                            id="clientcat" name="clientcat" ng-model="vm.client.category"\n' +
    '                    >\n' +
    '                        <option ng-repeat="cat in vm.clientcategories" value="cat" ng-click="vm.save()">{{cat}}</option>\n' +
    '                    </select>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '\n' +
    '        <companyedit companydata="vm.client.companydata"\n' +
    '                     parentsave="vm.childsave()"\n' +
    '                     ng-show="vm.client.iscompany === true"></companyedit>\n' +
    '\n' +
    '\n' +
    '        <contactedit contactdata="vm.client.primarycontact"\n' +
    '                     parentsave="vm.childsave()"></contactedit>\n' +
    '\n' +
    '        <svedit svdata="vm.client.svdata"\n' +
    '                parentsave="vm.childsave()"\n' +
    '                ng-show="vm.mode === \'patient\'"></svedit>\n' +
    '\n' +
    '        <riskedit risk="vm.client.risk"\n' +
    '                  parentsave="vm.childsave()"\n' +
    '                  ng-show="vm.mode === \'patient\'"></riskedit>\n' +
    '\n' +
    '\n' +
    '        <div class="spacer-top spacer-bottom">\n' +
    '            <button class="btn btn-success" ng-click="vm.addContact()"><i class="fa fa-plus"></i> Neuen Ansprechpartner\n' +
    '                anlegen\n' +
    '            </button>\n' +
    '        </div>\n' +
    '\n' +
    '        <div ng-show="vm.client.contacts.length > 0">\n' +
    '            <h3>Ansprechpartner</h3>\n' +
    '\n' +
    '            <div class="panel panel-info" ng-repeat="contact in vm.client.contacts | orderBy:\'-\'">\n' +
    '                <div class="panel-heading">\n' +
    '        <span ng-show="contact.lastname">\n' +
    '          <span ng-bind="contact.firstname"> </span>\n' +
    '          <span ng-bind="contact.lastname"> </span>\n' +
    '        </span>\n' +
    '                    <span ng-hide="contact.lastname">Neuer Kontakt</span>\n' +
    '                </div>\n' +
    '                <div class="panel-body">\n' +
    '                    <contactedit contactdata="contact" parentsave="vm.childsave()" showrelation="true"></contactedit>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '\n' +
    '        </div>\n' +
    '    </form>\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('home/home.tpl.html',
    '<div class="row">\n' +
    '    <div class="col-xs-12 col-md-6 col-lg-3">\n' +
    '        <h3>In Behandlung</h3>\n' +
    '        <openconsultlist></openconsultlist>\n' +
    '        <h3>Kürzlich abgeschlossen</h3>\n' +
    '        <recentconsultlist></recentconsultlist>\n' +
    '    </div>\n' +
    '\n' +
    '    <div class="col-xs-12 col-md-6 col-lg-3">\n' +
    '        <h3>Wartelisten</h3>\n' +
    '        <div class="alert alert-info">Derzeit keine Patienten auf der Warteliste</div>\n' +
    '        <!--<waitinglists></waitinglists>-->\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-6 col-lg-3">\n' +
    '        <allreminders></allreminders>\n' +
    '    </div>\n' +
    '    <div class="col-xs-12 col-md-6 col-lg-3">\n' +
    '        <todowidget></todowidget>\n' +
    '        <chat></chat>\n' +
    '    </div>\n' +
    '\n' +
    '</div>');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('fonts/flaticon_medical.html',
    '<!DOCTYPE html>\n' +
    '<!--\n' +
    '  Flaticon icon font: Flaticon\n' +
    '  Creation date: 25/09/2017 11:10\n' +
    '-->\n' +
    '<html>\n' +
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '\n' +
    '<head>\n' +
    '    <title>Flaticon WebFont</title>\n' +
    '    <link href="http://fonts.googleapis.com/css?family=Varela+Round" rel="stylesheet" type="text/css" />\n' +
    '    <link rel="stylesheet" type="text/css" href="flaticon_medical.css">\n' +
    '    <meta charset="UTF-8">\n' +
    '    <style>\n' +
    '    html, body, div, span, applet, object, iframe,\n' +
    '    h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n' +
    '    a, abbr, acronym, address, big, cite, code,\n' +
    '    del, dfn, em, img, ins, kbd, q, s, samp,\n' +
    '    small, strike, strong, sub, sup, tt, var,\n' +
    '    b, u, i, center,\n' +
    '    dl, dt, dd, ol, ul, li,\n' +
    '    fieldset, form, label, legend,\n' +
    '    table, caption, tbody, tfoot, thead, tr, th, td,\n' +
    '    article, aside, canvas, details, embed, \n' +
    '    figure, figcaption, footer, header, hgroup, \n' +
    '    menu, nav, output, ruby, section, summary,\n' +
    '    time, mark, audio, video {\n' +
    '        margin: 0;\n' +
    '        padding: 0;\n' +
    '        border: 0;\n' +
    '        font-size: 100%;\n' +
    '        font: inherit;\n' +
    '        vertical-align: baseline;\n' +
    '    }\n' +
    '    /* HTML5 display-role reset for older browsers */\n' +
    '    article, aside, details, figcaption, figure, \n' +
    '    footer, header, hgroup, menu, nav, section {\n' +
    '        display: block;\n' +
    '    }\n' +
    '    body {\n' +
    '        line-height: 1;\n' +
    '    }\n' +
    '    ol, ul {\n' +
    '        list-style: none;\n' +
    '    }\n' +
    '    blockquote, q {\n' +
    '        quotes: none;\n' +
    '    }\n' +
    '    blockquote:before, blockquote:after,\n' +
    '    q:before, q:after {\n' +
    '        content: \'\';\n' +
    '        content: none;\n' +
    '    }\n' +
    '    table {\n' +
    '        border-collapse: collapse;\n' +
    '        border-spacing: 0;\n' +
    '    }\n' +
    '    body {\n' +
    '        font-family: \'Varela Round\', Helvetica, Arial, sans-serif;\n' +
    '        font-size: 16px;\n' +
    '        color: #222;\n' +
    '    }\n' +
    '    a {\n' +
    '        color: #333;\n' +
    '        border-bottom: 1px solid #a9fd00;\n' +
    '        font-weight: bold;\n' +
    '        text-decoration: none;\n' +
    '    }\n' +
    '    * {\n' +
    '        -moz-box-sizing: border-box;\n' +
    '        -webkit-box-sizing: border-box;\n' +
    '        box-sizing: border-box;\n' +
    '        margin: 0;\n' +
    '        padding: 0;\n' +
    '    }\n' +
    '    [class^="flaticon-"]:before, [class*=" flaticon-"]:before, [class^="flaticon-"]:after, [class*=" flaticon-"]:after {\n' +
    '        font-family: Flaticon;\n' +
    '        font-size: 30px;\n' +
    '        font-style: normal;\n' +
    '        margin-left: 20px;\n' +
    '        color: #333;\n' +
    '    }\n' +
    '    .wrapper {\n' +
    '        max-width: 600px;\n' +
    '        margin: auto;\n' +
    '        padding: 0 1em;\n' +
    '    }\n' +
    '    .title {\n' +
    '        font-size: 1.25em;\n' +
    '        text-align: center;\n' +
    '        margin-bottom: 1em;\n' +
    '        text-transform: uppercase;\n' +
    '    }\n' +
    '    header {\n' +
    '        text-align: center;\n' +
    '        background-color: #222;\n' +
    '        color: #fff;\n' +
    '        padding: 1em;\n' +
    '    }\n' +
    '    header .logo {\n' +
    '        width: 210px;\n' +
    '        height: 38px;\n' +
    '        display: inline-block;\n' +
    '        vertical-align: middle;\n' +
    '        margin-right: 1em;\n' +
    '        border: none;\n' +
    '    }\n' +
    '    header strong {\n' +
    '        font-size: 1.95em;\n' +
    '        font-weight: bold;\n' +
    '        vertical-align: middle;\n' +
    '        margin-top: 5px;\n' +
    '        display: inline-block;\n' +
    '    }\n' +
    '    .demo {\n' +
    '        margin: 2em auto;\n' +
    '        line-height: 1.25em;\n' +
    '    }\n' +
    '    .demo ul li {\n' +
    '        margin-bottom: 1em;\n' +
    '    }\n' +
    '    .demo ul li .num {\n' +
    '        color: #222;\n' +
    '        border-radius: 20px;\n' +
    '        display: inline-block;\n' +
    '        width: 26px;\n' +
    '        padding: 3px;\n' +
    '        height: 26px;\n' +
    '        text-align: center;\n' +
    '        margin-right: 0.5em;\n' +
    '        border: 1px solid #222;\n' +
    '    }\n' +
    '    .demo ul li code {\n' +
    '        background-color: #222;\n' +
    '        border-radius: 4px;\n' +
    '        padding: 0.25em 0.5em;\n' +
    '        display: inline-block;\n' +
    '        color: #fff;\n' +
    '        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;\n' +
    '        font-weight: lighter;\n' +
    '        margin-top: 1em;\n' +
    '        font-size: 0.8em;\n' +
    '        word-break: break-all;\n' +
    '    }\n' +
    '    .demo ul li code.big {\n' +
    '        padding: 1em;\n' +
    '        font-size: 0.9em;\n' +
    '    }\n' +
    '    .demo ul li code .red {\n' +
    '        color: #EF3159;\n' +
    '    }\n' +
    '    .demo ul li code .green {\n' +
    '        color: #ACFF65;\n' +
    '    }\n' +
    '    .demo ul li code .yellow {\n' +
    '        color: #FFFF99;\n' +
    '    }\n' +
    '    .demo ul li code .blue {\n' +
    '        color: #99D3FF;\n' +
    '    }\n' +
    '    .demo ul li code .purple {\n' +
    '        color: #A295FF;\n' +
    '    }\n' +
    '    .demo ul li code .dots {\n' +
    '        margin-top: 0.5em;\n' +
    '        display: block;\n' +
    '    }\n' +
    '    #glyphs {\n' +
    '        border-bottom: 1px solid #ccc;\n' +
    '        padding: 2em 0;\n' +
    '        text-align: center;\n' +
    '    }\n' +
    '    .glyph {\n' +
    '        display: inline-block;\n' +
    '        width: 9em;\n' +
    '        margin: 1em;\n' +
    '        text-align: center;\n' +
    '        vertical-align: top;\n' +
    '        background: #FFF;\n' +
    '    }\n' +
    '    .glyph .glyph-icon {\n' +
    '        padding: 10px;\n' +
    '        display: block;\n' +
    '        font-family:"Flaticon";\n' +
    '        font-size: 64px;\n' +
    '        line-height: 1;\n' +
    '    }\n' +
    '    .glyph .glyph-icon:before {\n' +
    '        font-size: 64px;\n' +
    '        color: #222;\n' +
    '        margin-left: 0;\n' +
    '    }\n' +
    '    .class-name {\n' +
    '        font-size: 0.65em;\n' +
    '        background-color: #222;\n' +
    '        color: #fff;\n' +
    '        border-radius: 4px 4px 0 0;\n' +
    '        padding: 0.5em;\n' +
    '        color: #FFFF99;\n' +
    '        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;\n' +
    '    }\n' +
    '    .author-name {\n' +
    '        font-size: 0.6em;\n' +
    '        background-color: #fcfcfd;\n' +
    '        border: 1px solid #DEDEE4;\n' +
    '        border-top: 0;\n' +
    '        border-radius: 0 0 4px 4px;\n' +
    '        padding: 0.5em;\n' +
    '    }\n' +
    '    .class-name:last-child {\n' +
    '        font-size: 10px;\n' +
    '        color:#888;\n' +
    '    }\n' +
    '    .class-name:last-child a {\n' +
    '        font-size: 10px;\n' +
    '        color:#555;\n' +
    '    }\n' +
    '    .class-name:last-child a:hover {\n' +
    '        color:#a9fd00;\n' +
    '    }\n' +
    '    .glyph > input {\n' +
    '        display: block;\n' +
    '        width: 100px;\n' +
    '        margin: 5px auto;\n' +
    '        text-align: center;\n' +
    '        font-size: 12px;\n' +
    '        cursor: text;\n' +
    '    }\n' +
    '    .glyph > input.icon-input {\n' +
    '        font-family:"Flaticon";\n' +
    '        font-size: 16px;\n' +
    '        margin-bottom: 10px;\n' +
    '    }\n' +
    '    .attribution .title {\n' +
    '        margin-top: 2em;\n' +
    '    }\n' +
    '    .attribution textarea {\n' +
    '        background-color: #fcfcfd;\n' +
    '        padding: 1em;\n' +
    '        border: none;\n' +
    '        box-shadow: none;\n' +
    '        border: 1px solid #DEDEE4;\n' +
    '        border-radius: 4px;\n' +
    '        resize: none;\n' +
    '        width: 100%;\n' +
    '        height: 150px;\n' +
    '        font-size: 0.8em;\n' +
    '        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;\n' +
    '        -webkit-appearance: none;\n' +
    '    }\n' +
    '    .iconsuse {\n' +
    '        margin: 2em auto;\n' +
    '        text-align: center;\n' +
    '        max-width: 1200px;\n' +
    '    }\n' +
    '    .iconsuse:after {\n' +
    '        content: \'\';\n' +
    '        display: table;\n' +
    '        clear: both;\n' +
    '    }\n' +
    '    .iconsuse .image {\n' +
    '        float: left;\n' +
    '        width: 25%;\n' +
    '        padding: 0 1em;\n' +
    '    }\n' +
    '    .iconsuse .image p {\n' +
    '        margin-bottom: 1em;\n' +
    '    }\n' +
    '    .iconsuse .image span {\n' +
    '        display: block;\n' +
    '        font-size: 0.65em;\n' +
    '        background-color: #222;\n' +
    '        color: #fff;\n' +
    '        border-radius: 4px;\n' +
    '        padding: 0.5em;\n' +
    '        color: #FFFF99;\n' +
    '        margin-top: 1em;\n' +
    '        font-family: Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;\n' +
    '    }\n' +
    '    #footer {\n' +
    '        text-align: center;\n' +
    '        background-color: #4C5B5C;\n' +
    '        color: #7c9192;\n' +
    '        padding: 1em;\n' +
    '    }\n' +
    '    #footer a {\n' +
    '        border: none;\n' +
    '        color: #a9fd00;\n' +
    '        font-weight: normal;\n' +
    '    }\n' +
    '    @media (max-width: 960px) {\n' +
    '        .iconsuse .image {\n' +
    '            width: 50%;\n' +
    '        }\n' +
    '    }\n' +
    '    @media (max-width: 560px) {\n' +
    '        .iconsuse .image {\n' +
    '            width: 100%;\n' +
    '        }\n' +
    '    }\n' +
    '    </style>\n' +
    '</head>\n' +
    '\n' +
    '<body class="characters-off">\n' +
    '\n' +
    '    <header>\n' +
    '        <a href="http://www.flaticon.com" target="_blank" class="logo">\n' +
    '            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/" viewBox="0 0 560.875 102.036" enable-background="new 0 0 560.875 102.036" xml:space="preserve">\n' +
    '                <defs>\n' +
    '                </defs>\n' +
    '                <g>\n' +
    '                    <g class="letters">\n' +
    '                        <path fill="#ffffff" d="M141.596,29.675c0-3.777,2.985-6.767,6.764-6.767h34.438c3.426,0,6.15,2.728,6.15,6.15\n' +
    '                        c0,3.43-2.724,6.149-6.15,6.149h-27.674v13.091h23.719c3.429,0,6.151,2.724,6.151,6.15c0,3.43-2.723,6.149-6.151,6.149h-23.719\n' +
    '                        v17.574c0,3.773-2.986,6.761-6.764,6.761c-3.779,0-6.764-2.989-6.764-6.761V29.675z"></path>\n' +
    '                        <path fill="#ffffff" d="M193.844,29.149c0-3.781,2.985-6.767,6.764-6.767c3.776,0,6.763,2.985,6.763,6.767v42.957h25.039\n' +
    '                        c3.426,0,6.149,2.726,6.149,6.153c0,3.425-2.723,6.15-6.149,6.15h-31.802c-3.779,0-6.764-2.986-6.764-6.768V29.149z"></path>\n' +
    '                        <path fill="#ffffff" d="M241.891,75.71l21.438-48.407c1.492-3.341,4.215-5.357,7.906-5.357h0.792\n' +
    '                        c3.686,0,6.323,2.017,7.815,5.357l21.439,48.407c0.436,0.967,0.701,1.845,0.701,2.723c0,3.602-2.809,6.501-6.414,6.501\n' +
    '                        c-3.161,0-5.269-1.845-6.499-4.655l-4.132-9.661h-27.059l-4.301,10.102c-1.144,2.631-3.426,4.214-6.237,4.214\n' +
    '                        c-3.517,0-6.24-2.81-6.24-6.325C241.1,77.64,241.451,76.677,241.891,75.71z M279.932,58.666l-8.521-20.297l-8.526,20.297H279.932\n' +
    '                        z"></path>\n' +
    '                        <path fill="#ffffff" d="M314.864,35.387H301.86c-3.429,0-6.239-2.813-6.239-6.238c0-3.429,2.811-6.24,6.239-6.24h39.533\n' +
    '                        c3.426,0,6.237,2.811,6.237,6.24c0,3.425-2.811,6.238-6.237,6.238h-13.001v42.785c0,3.773-2.99,6.761-6.764,6.761\n' +
    '                        c-3.779,0-6.764-2.989-6.764-6.761V35.387z"></path>\n' +
    '                        <path fill="#A9FD00" d="M352.615,29.149c0-3.781,2.985-6.767,6.767-6.767c3.774,0,6.761,2.985,6.761,6.767v49.024\n' +
    '                        c0,3.773-2.987,6.761-6.761,6.761c-3.781,0-6.767-2.989-6.767-6.761V29.149z"></path>\n' +
    '                        <path fill="#A9FD00" d="M374.132,53.836v-0.179c0-17.481,13.178-31.801,32.065-31.801c9.22,0,15.459,2.458,20.557,6.238\n' +
    '                        c1.402,1.054,2.637,2.985,2.637,5.357c0,3.692-2.985,6.59-6.681,6.59c-1.845,0-3.071-0.702-4.044-1.319\n' +
    '                        c-3.776-2.813-7.729-4.393-12.562-4.393c-10.364,0-17.831,8.611-17.831,19.154v0.173c0,10.542,7.291,19.329,17.831,19.329\n' +
    '                        c5.715,0,9.492-1.756,13.359-4.834c1.049-0.874,2.458-1.491,4.039-1.491c3.429,0,6.325,2.813,6.325,6.236\n' +
    '                        c0,2.106-1.056,3.78-2.282,4.834c-5.539,4.834-12.036,7.733-21.878,7.733C387.572,85.464,374.132,71.493,374.132,53.836z"></path>\n' +
    '                        <path fill="#A9FD00" d="M433.009,53.836v-0.179c0-17.481,13.79-31.801,32.766-31.801c18.981,0,32.592,14.143,32.592,31.628v0.173\n' +
    '                        c0,17.483-13.785,31.807-32.769,31.807C446.625,85.464,433.009,71.32,433.009,53.836z M484.224,53.836v-0.179\n' +
    '                        c0-10.539-7.725-19.326-18.626-19.326c-10.893,0-18.449,8.611-18.449,19.154v0.173c0,10.542,7.73,19.329,18.626,19.329\n' +
    '                        C476.676,72.986,484.224,64.378,484.224,53.836z"></path>\n' +
    '                        <path fill="#A9FD00" d="M506.233,29.321c0-3.774,2.99-6.763,6.767-6.763h1.401c3.252,0,5.183,1.583,7.029,3.953l26.093,34.265\n' +
    '                        V29.059c0-3.692,2.99-6.677,6.681-6.677c3.683,0,6.671,2.985,6.671,6.677v48.934c0,3.78-2.987,6.765-6.764,6.765h-0.436\n' +
    '                        c-3.257,0-5.188-1.581-7.034-3.953l-27.056-35.492v32.944c0,3.687-2.985,6.676-6.678,6.676c-3.683,0-6.673-2.989-6.673-6.676\n' +
    '                        V29.321z"></path>\n' +
    '                    </g>\n' +
    '                    <g class="insignia">\n' +
    '                        <path fill="#ffffff" d="M48.372,56.137h12.517l11.156-18.537H37.186L25.688,18.539h57.825L94.668,0H9.271\n' +
    '                        C5.925,0,2.842,1.801,1.198,4.716c-1.644,2.907-1.593,6.482,0.134,9.343l50.38,83.501c1.678,2.781,4.689,4.476,7.938,4.476\n' +
    '                        c3.246,0,6.257-1.695,7.935-4.476l2.898-4.804L48.372,56.137z"></path>\n' +
    '                        <g class="i">\n' +
    '                            <path fill="#A9FD00" d="M93.575,18.539h0.031v0.004l21.652,0.004l2.705-4.488c1.727-2.861,1.778-6.436,0.133-9.343\n' +
    '                            C116.454,1.801,113.371,0,110.026,0h-5.294L93.575,18.539z"></path>\n' +
    '                            <polygon fill="#A9FD00" points="88.291,27.356 64.725,66.486 75.519,84.404 109.942,27.356"></polygon>\n' +
    '                        </g>\n' +
    '                    </g>\n' +
    '                </g>\n' +
    '            </svg>\n' +
    '        </a>\n' +
    '        <strong>Font Demo</strong>\n' +
    '    </header>\n' +
    '\n' +
    '\n' +
    '    <section class="demo wrapper">\n' +
    '\n' +
    '        <p class="title">Instructions</p>\n' +
    '\n' +
    '        <ul>\n' +
    '            <li>\n' +
    '                <span class="num">1</span>Copy the "Fonts" files and CSS files to your website CSS folder.\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <span class="num">2</span>Add the CSS link to your website source code on header.\n' +
    '                <code class="big">\n' +
    '                    &lt;<span class="red">head</span>&gt;\n' +
    '                    <br/><span class="dots">...</span>\n' +
    '                    <br/>&lt;<span class="red">link</span> <span class="green">rel</span>=<span class="yellow">"stylesheet"</span> <span class="green">type</span>=<span class="yellow">"text/css"</span> <span class="green">href</span>=<span class="yellow">"your_website_domain/css_root/flaticon.css"</span>&gt;\n' +
    '                    <br/><span class="dots">...</span>\n' +
    '                    <br/>&lt;/<span class="red">head</span>&gt;\n' +
    '                </code>\n' +
    '            </li>\n' +
    '\n' +
    '            <li>\n' +
    '                <p>\n' +
    '                    <span class="num">3</span>Use the icon class on <code>"<span class="blue">display</span>:<span class="purple"> inline</span>"</code> elements:\n' +
    '                    <br />\n' +
    '                    Use example: <code>&lt;<span class="red">i</span> <span class="green">class</span>=<span class="yellow">&quot;flaticon-airplane49&quot;</span>&gt;&lt;/<span class="red">i</span>&gt;</code> or <code>&lt;<span class="red">span</span> <span class="green">class</span>=<span class="yellow">&quot;flaticon-airplane49&quot;</span>&gt;&lt;/<span class="red">span</span>&gt;</code>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '\n' +
    '    </section>\n' +
    '\n' +
    '\n' +
    '\n' +
    '\n' +
    '   <section id="glyphs">          \n' +
    '    \n' +
    '      \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-technology"></div>\n' +
    '            <div class="class-name">.flaticon-technology</div>\n' +
    '            <div class="author-name">Author: <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-42"></div>\n' +
    '            <div class="class-name">.flaticon-medical-42</div>\n' +
    '            <div class="author-name">Author: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-41"></div>\n' +
    '            <div class="class-name">.flaticon-medical-41</div>\n' +
    '            <div class="author-name">Author: <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-10"></div>\n' +
    '            <div class="class-name">.flaticon-people-10</div>\n' +
    '            <div class="author-name">Author: <a data-file="004-people-10" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-9"></div>\n' +
    '            <div class="class-name">.flaticon-people-9</div>\n' +
    '            <div class="author-name">Author: <a data-file="005-people-9" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-16"></div>\n' +
    '            <div class="class-name">.flaticon-medical-16</div>\n' +
    '            <div class="author-name">Author: <a data-file="006-medical-16" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-clinic-history"></div>\n' +
    '            <div class="class-name">.flaticon-clinic-history</div>\n' +
    '            <div class="author-name">Author: <a data-file="007-clinic-history" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-cardiogram"></div>\n' +
    '            <div class="class-name">.flaticon-cardiogram</div>\n' +
    '            <div class="author-name">Author: <a data-file="008-cardiogram" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-8"></div>\n' +
    '            <div class="class-name">.flaticon-people-8</div>\n' +
    '            <div class="author-name">Author: <a data-file="009-people-8" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-7"></div>\n' +
    '            <div class="class-name">.flaticon-people-7</div>\n' +
    '            <div class="author-name">Author: <a data-file="010-people-7" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-tool-3"></div>\n' +
    '            <div class="class-name">.flaticon-tool-3</div>\n' +
    '            <div class="author-name">Author: <a data-file="011-tool-3" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-tool-2"></div>\n' +
    '            <div class="class-name">.flaticon-tool-2</div>\n' +
    '            <div class="author-name">Author: <a data-file="012-tool-2" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-6"></div>\n' +
    '            <div class="class-name">.flaticon-people-6</div>\n' +
    '            <div class="author-name">Author: <a data-file="013-people-6" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-40"></div>\n' +
    '            <div class="class-name">.flaticon-medical-40</div>\n' +
    '            <div class="author-name">Author: <a data-file="014-medical-40" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-5"></div>\n' +
    '            <div class="class-name">.flaticon-people-5</div>\n' +
    '            <div class="author-name">Author: <a data-file="015-people-5" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-39"></div>\n' +
    '            <div class="class-name">.flaticon-medical-39</div>\n' +
    '            <div class="author-name">Author: <a data-file="016-medical-39" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-tool-1"></div>\n' +
    '            <div class="class-name">.flaticon-tool-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="017-tool-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-38"></div>\n' +
    '            <div class="class-name">.flaticon-medical-38</div>\n' +
    '            <div class="author-name">Author: <a data-file="018-medical-38" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-monitor"></div>\n' +
    '            <div class="class-name">.flaticon-monitor</div>\n' +
    '            <div class="author-name">Author: <a data-file="019-monitor" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-37"></div>\n' +
    '            <div class="class-name">.flaticon-medical-37</div>\n' +
    '            <div class="author-name">Author: <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-36"></div>\n' +
    '            <div class="class-name">.flaticon-medical-36</div>\n' +
    '            <div class="author-name">Author: <a data-file="021-medical-36" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-35"></div>\n' +
    '            <div class="class-name">.flaticon-medical-35</div>\n' +
    '            <div class="author-name">Author: <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-34"></div>\n' +
    '            <div class="class-name">.flaticon-medical-34</div>\n' +
    '            <div class="author-name">Author: <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-33"></div>\n' +
    '            <div class="class-name">.flaticon-medical-33</div>\n' +
    '            <div class="author-name">Author: <a data-file="024-medical-33" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-vision"></div>\n' +
    '            <div class="class-name">.flaticon-vision</div>\n' +
    '            <div class="author-name">Author: <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-32"></div>\n' +
    '            <div class="class-name">.flaticon-medical-32</div>\n' +
    '            <div class="author-name">Author: <a data-file="026-medical-32" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-14"></div>\n' +
    '            <div class="class-name">.flaticon-medical-14</div>\n' +
    '            <div class="author-name">Author: <a data-file="027-medical-14" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-31"></div>\n' +
    '            <div class="class-name">.flaticon-medical-31</div>\n' +
    '            <div class="author-name">Author: <a data-file="028-medical-31" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-4"></div>\n' +
    '            <div class="class-name">.flaticon-people-4</div>\n' +
    '            <div class="author-name">Author: <a data-file="029-people-4" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-computer"></div>\n' +
    '            <div class="class-name">.flaticon-computer</div>\n' +
    '            <div class="author-name">Author: <a data-file="030-computer" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-healthy-4"></div>\n' +
    '            <div class="class-name">.flaticon-healthy-4</div>\n' +
    '            <div class="author-name">Author: <a data-file="031-healthy-4" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-30"></div>\n' +
    '            <div class="class-name">.flaticon-medical-30</div>\n' +
    '            <div class="author-name">Author: <a data-file="032-medical-30" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-29"></div>\n' +
    '            <div class="class-name">.flaticon-medical-29</div>\n' +
    '            <div class="author-name">Author: <a data-file="033-medical-29" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-28"></div>\n' +
    '            <div class="class-name">.flaticon-medical-28</div>\n' +
    '            <div class="author-name">Author: <a data-file="034-medical-28" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-folder"></div>\n' +
    '            <div class="class-name">.flaticon-folder</div>\n' +
    '            <div class="author-name">Author: <a data-file="035-folder" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-27"></div>\n' +
    '            <div class="class-name">.flaticon-medical-27</div>\n' +
    '            <div class="author-name">Author: <a data-file="036-medical-27" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-26"></div>\n' +
    '            <div class="class-name">.flaticon-medical-26</div>\n' +
    '            <div class="author-name">Author: <a data-file="037-medical-26" href="https://www.flaticon.com/authors/smashicons">Smashicons</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medicine"></div>\n' +
    '            <div class="class-name">.flaticon-medicine</div>\n' +
    '            <div class="author-name">Author: <a data-file="038-medicine" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-25"></div>\n' +
    '            <div class="class-name">.flaticon-medical-25</div>\n' +
    '            <div class="author-name">Author: <a data-file="039-medical-25" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-24"></div>\n' +
    '            <div class="class-name">.flaticon-medical-24</div>\n' +
    '            <div class="author-name">Author: <a data-file="040-medical-24" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-23"></div>\n' +
    '            <div class="class-name">.flaticon-medical-23</div>\n' +
    '            <div class="author-name">Author: <a data-file="041-medical-23" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-sign-1"></div>\n' +
    '            <div class="class-name">.flaticon-sign-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="042-sign-1" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-22"></div>\n' +
    '            <div class="class-name">.flaticon-medical-22</div>\n' +
    '            <div class="author-name">Author: <a data-file="043-medical-22" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-21"></div>\n' +
    '            <div class="class-name">.flaticon-medical-21</div>\n' +
    '            <div class="author-name">Author: <a data-file="044-medical-21" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-danger"></div>\n' +
    '            <div class="class-name">.flaticon-danger</div>\n' +
    '            <div class="author-name">Author: <a data-file="045-danger" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-20"></div>\n' +
    '            <div class="class-name">.flaticon-medical-20</div>\n' +
    '            <div class="author-name">Author: <a data-file="046-medical-20" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-19"></div>\n' +
    '            <div class="class-name">.flaticon-medical-19</div>\n' +
    '            <div class="author-name">Author: <a data-file="047-medical-19" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-18"></div>\n' +
    '            <div class="class-name">.flaticon-medical-18</div>\n' +
    '            <div class="author-name">Author: <a data-file="048-medical-18" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-healthy-3"></div>\n' +
    '            <div class="class-name">.flaticon-healthy-3</div>\n' +
    '            <div class="author-name">Author: <a data-file="049-healthy-3" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-17"></div>\n' +
    '            <div class="class-name">.flaticon-medical-17</div>\n' +
    '            <div class="author-name">Author: <a data-file="050-medical-17" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-care"></div>\n' +
    '            <div class="class-name">.flaticon-care</div>\n' +
    '            <div class="author-name">Author: <a data-file="051-care" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-3"></div>\n' +
    '            <div class="class-name">.flaticon-people-3</div>\n' +
    '            <div class="author-name">Author: <a data-file="052-people-3" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-2"></div>\n' +
    '            <div class="class-name">.flaticon-people-2</div>\n' +
    '            <div class="author-name">Author: <a data-file="053-people-2" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-15"></div>\n' +
    '            <div class="class-name">.flaticon-medical-15</div>\n' +
    '            <div class="author-name">Author: <a data-file="054-medical-15" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-tool"></div>\n' +
    '            <div class="class-name">.flaticon-tool</div>\n' +
    '            <div class="author-name">Author: <a data-file="055-tool" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people-1"></div>\n' +
    '            <div class="class-name">.flaticon-people-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="056-people-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-microscope-2"></div>\n' +
    '            <div class="class-name">.flaticon-microscope-2</div>\n' +
    '            <div class="author-name">Author: <a data-file="057-microscope-2" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-microscope-1"></div>\n' +
    '            <div class="class-name">.flaticon-microscope-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="058-microscope-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-microscope"></div>\n' +
    '            <div class="class-name">.flaticon-microscope</div>\n' +
    '            <div class="author-name">Author: <a data-file="059-microscope" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-stethoscope"></div>\n' +
    '            <div class="class-name">.flaticon-stethoscope</div>\n' +
    '            <div class="author-name">Author: <a data-file="060-stethoscope" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-surgeon"></div>\n' +
    '            <div class="class-name">.flaticon-surgeon</div>\n' +
    '            <div class="author-name">Author: <a data-file="061-surgeon" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-healthy-2"></div>\n' +
    '            <div class="class-name">.flaticon-healthy-2</div>\n' +
    '            <div class="author-name">Author: <a data-file="062-healthy-2" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-healthy-1"></div>\n' +
    '            <div class="class-name">.flaticon-healthy-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="063-healthy-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-healthy"></div>\n' +
    '            <div class="class-name">.flaticon-healthy</div>\n' +
    '            <div class="author-name">Author: <a data-file="064-healthy" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-13"></div>\n' +
    '            <div class="class-name">.flaticon-medical-13</div>\n' +
    '            <div class="author-name">Author: <a data-file="065-medical-13" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-pills"></div>\n' +
    '            <div class="class-name">.flaticon-pills</div>\n' +
    '            <div class="author-name">Author: <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-people"></div>\n' +
    '            <div class="class-name">.flaticon-people</div>\n' +
    '            <div class="author-name">Author: <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-smoking-area"></div>\n' +
    '            <div class="class-name">.flaticon-smoking-area</div>\n' +
    '            <div class="author-name">Author: <a data-file="068-smoking-area" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-electrocardiogram-on-heart-shape"></div>\n' +
    '            <div class="class-name">.flaticon-electrocardiogram-on-heart-shape</div>\n' +
    '            <div class="author-name">Author: <a data-file="069-electrocardiogram-on-heart-shape" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-man"></div>\n' +
    '            <div class="class-name">.flaticon-man</div>\n' +
    '            <div class="author-name">Author: <a data-file="070-man" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-12"></div>\n' +
    '            <div class="class-name">.flaticon-medical-12</div>\n' +
    '            <div class="author-name">Author: <a data-file="071-medical-12" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-sign"></div>\n' +
    '            <div class="class-name">.flaticon-sign</div>\n' +
    '            <div class="author-name">Author: <a data-file="072-sign" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heart-rate-monitor-1"></div>\n' +
    '            <div class="class-name">.flaticon-heart-rate-monitor-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="073-heart-rate-monitor-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-lifeline-of-heartbeats-on-a-paper-on-a-clipboard"></div>\n' +
    '            <div class="class-name">.flaticon-lifeline-of-heartbeats-on-a-paper-on-a-clipboard</div>\n' +
    '            <div class="author-name">Author: <a data-file="074-lifeline-of-heartbeats-on-a-paper-on-a-clipboard" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-tool-to-listen-heart-beats"></div>\n' +
    '            <div class="class-name">.flaticon-medical-tool-to-listen-heart-beats</div>\n' +
    '            <div class="author-name">Author: <a data-file="075-medical-tool-to-listen-heart-beats" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heart-beat"></div>\n' +
    '            <div class="class-name">.flaticon-heart-beat</div>\n' +
    '            <div class="author-name">Author: <a data-file="076-heart-beat" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heartbeats-monitoring"></div>\n' +
    '            <div class="class-name">.flaticon-heartbeats-monitoring</div>\n' +
    '            <div class="author-name">Author: <a data-file="077-heartbeats-monitoring" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-11"></div>\n' +
    '            <div class="class-name">.flaticon-medical-11</div>\n' +
    '            <div class="author-name">Author: <a data-file="078-medical-11" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-10"></div>\n' +
    '            <div class="class-name">.flaticon-medical-10</div>\n' +
    '            <div class="author-name">Author: <a data-file="079-medical-10" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-9"></div>\n' +
    '            <div class="class-name">.flaticon-medical-9</div>\n' +
    '            <div class="author-name">Author: <a data-file="080-medical-9" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heartbeat"></div>\n' +
    '            <div class="class-name">.flaticon-heartbeat</div>\n' +
    '            <div class="author-name">Author: <a data-file="081-heartbeat" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heart-rate-monitor"></div>\n' +
    '            <div class="class-name">.flaticon-heart-rate-monitor</div>\n' +
    '            <div class="author-name">Author: <a data-file="082-heart-rate-monitor" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-unhealthy"></div>\n' +
    '            <div class="class-name">.flaticon-unhealthy</div>\n' +
    '            <div class="author-name">Author: <a data-file="083-unhealthy" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-cigarette-with-smoke"></div>\n' +
    '            <div class="class-name">.flaticon-cigarette-with-smoke</div>\n' +
    '            <div class="author-name">Author: <a data-file="084-cigarette-with-smoke" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-8"></div>\n' +
    '            <div class="class-name">.flaticon-medical-8</div>\n' +
    '            <div class="author-name">Author: <a data-file="085-medical-8" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-smoking-1"></div>\n' +
    '            <div class="class-name">.flaticon-smoking-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-smoking"></div>\n' +
    '            <div class="class-name">.flaticon-smoking</div>\n' +
    '            <div class="author-name">Author: <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-shapes"></div>\n' +
    '            <div class="class-name">.flaticon-shapes</div>\n' +
    '            <div class="author-name">Author: <a data-file="088-shapes" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-7"></div>\n' +
    '            <div class="class-name">.flaticon-medical-7</div>\n' +
    '            <div class="author-name">Author: <a data-file="089-medical-7" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-6"></div>\n' +
    '            <div class="class-name">.flaticon-medical-6</div>\n' +
    '            <div class="author-name">Author: <a data-file="090-medical-6" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-5"></div>\n' +
    '            <div class="class-name">.flaticon-medical-5</div>\n' +
    '            <div class="author-name">Author: <a data-file="091-medical-5" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-4"></div>\n' +
    '            <div class="class-name">.flaticon-medical-4</div>\n' +
    '            <div class="author-name">Author: <a data-file="092-medical-4" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-3"></div>\n' +
    '            <div class="class-name">.flaticon-medical-3</div>\n' +
    '            <div class="author-name">Author: <a data-file="093-medical-3" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-2"></div>\n' +
    '            <div class="class-name">.flaticon-medical-2</div>\n' +
    '            <div class="author-name">Author: <a data-file="094-medical-2" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical-1"></div>\n' +
    '            <div class="class-name">.flaticon-medical-1</div>\n' +
    '            <div class="author-name">Author: <a data-file="095-medical-1" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-heart-beating"></div>\n' +
    '            <div class="class-name">.flaticon-heart-beating</div>\n' +
    '            <div class="author-name">Author: <a data-file="096-heart-beating" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-medical"></div>\n' +
    '            <div class="class-name">.flaticon-medical</div>\n' +
    '            <div class="author-name">Author: <a data-file="097-medical" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-human"></div>\n' +
    '            <div class="class-name">.flaticon-human</div>\n' +
    '            <div class="author-name">Author: <a data-file="098-human" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '        <div class="glyph"><div class="glyph-icon flaticon-cigarette"></div>\n' +
    '            <div class="class-name">.flaticon-cigarette</div>\n' +
    '            <div class="author-name">Author: <a data-file="099-cigarette" href="http://www.freepik.com">Freepik</a> </div> \n' +
    '        </div>        \n' +
    '        \n' +
    '\n' +
    '    </section>\n' +
    '\n' +
    '\n' +
    '\n' +
    '    <section class="attribution wrapper"   style="text-align:center;">\n' +
    '\n' +
    '      <div class="title">License and attribution:</div><div class="attrDiv">Font generated by <a href="http://www.flaticon.com">flaticon.com</a>. <div><p>Under <a href="http://creativecommons.org/licenses/by/3.0/">CC</a>: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a>, <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a>, <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a>, <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a>, <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a>, <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a>, <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a>, <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a>, <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a>, <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a>, <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a></p>  </div>\n' +
    '      </div>\n' +
    '      <div class="title">Copy the Attribution License:</div>\n' +
    '\n' +
    '    <textarea onclick="this.focus();this.select();">Font generated by &lt;a href=&quot;http://www.flaticon.com&quot;&gt;flaticon.com&lt;/a&gt;. <p>Under <a href="http://creativecommons.org/licenses/by/3.0/">CC</a>: <a data-file="002-medical-42" href="http://www.freepik.com">Freepik</a>, <a data-file="087-smoking" href="https://www.flaticon.com/authors/dot-on-paper">Dot on Paper</a>, <a data-file="086-smoking-1" href="https://www.flaticon.com/authors/roundicons-freebies">Roundicons Freebies</a>, <a data-file="067-people" href="https://www.flaticon.com/authors/vectors-market">Vectors Market</a>, <a data-file="066-pills" href="https://www.flaticon.com/authors/sean-mccormick">Sean McCormick</a>, <a data-file="025-vision" href="https://www.flaticon.com/authors/maxim-basinski-premium">Maxim Basinski Premium</a>, <a data-file="003-medical-41" href="https://www.flaticon.com/authors/eucalyp">Eucalyp</a>, <a data-file="001-technology" href="https://www.flaticon.com/authors/prosymbols">Prosymbols</a>, <a data-file="020-medical-37" href="https://www.flaticon.com/authors/smashicons">Smashicons</a>, <a data-file="023-medical-34" href="https://www.flaticon.com/authors/zlatko-najdenovski">Zlatko Najdenovski</a>, <a data-file="022-medical-35" href="https://www.flaticon.com/authors/swifticons">Swifticons</a></p>  \n' +
    '     </textarea>\n' +
    '\n' +
    '    </section>\n' +
    '\n' +
    '    <section class="iconsuse">\n' +
    '\n' +
    '          <div class="title">Examples:</div>            \n' +
    '             \n' +
    '            <div class="image">\n' +
    '                <p>\n' +
    '                    <i class="glyph-icon flaticon-technology"></i> \n' +
    '                    <span>&lt;i class=&quot;flaticon-technology&quot;&gt;&lt;/i&gt;</span>\n' +
    '                </p>\n' +
    '            </div>\n' +
    '            \n' +
    '            <div class="image">\n' +
    '                <p>\n' +
    '                    <i class="glyph-icon flaticon-medical-42"></i> \n' +
    '                    <span>&lt;i class=&quot;flaticon-medical-42&quot;&gt;&lt;/i&gt;</span>\n' +
    '                </p>\n' +
    '            </div>\n' +
    '            \n' +
    '            <div class="image">\n' +
    '                <p>\n' +
    '                    <i class="glyph-icon flaticon-medical-41"></i> \n' +
    '                    <span>&lt;i class=&quot;flaticon-medical-41&quot;&gt;&lt;/i&gt;</span>\n' +
    '                </p>\n' +
    '            </div>\n' +
    '            \n' +
    '            <div class="image">\n' +
    '                <p>\n' +
    '                    <i class="glyph-icon flaticon-people-10"></i> \n' +
    '                    <span>&lt;i class=&quot;flaticon-people-10&quot;&gt;&lt;/i&gt;</span>\n' +
    '                </p>\n' +
    '            </div>\n' +
    '                       \n' +
    '        </div>\n' +
    '                            \n' +
    '    </section>\n' +
    '\n' +
    '<div id="footer">\n' +
    '    <div>Generated by <a href="http://www.flaticon.com">flaticon.com</a>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '\n' +
    '\n' +
    '</body>\n' +
    '</html>\n' +
    '');
}]);

angular.module('sprechstunde').run(['$templateCache', function($templateCache) {
  $templateCache.put('patientrecordmenu.tpl.html',
    '<ul class="nav nav-tabs" role="tablist" style="padding-top: 1ex;">\n' +
    '    <!-- Aktuell -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.current({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active"\n' +
    '        class="curtab">\n' +
    '        <a aria-controls="aktuell">\n' +
    '<!--            <i class="flaticon-people-8"></i>-->\n' +
    '            <svg height="22" aria-hidden="true" focusable="false"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M352 128a128 128 0 1 0-128 128 128 128 0 0 0 128-128zM144 370.6V288h-9.6a135.6 135.6 0 0 0-22.4 1.87v80.73a56 56 0 1 0 32 0zM128 448a24 24 0 1 1 24-24 23.94 23.94 0 0 1-24 24zm191.8-85.6v-74.25c-2.06-.1-4.12-.15-6.2-.15h-16.7q-4.38 2-8.9 3.79v70.41c-28.2 7.5-48 34.5-48 64.6V456a16.06 16.06 0 0 0 4.7 11.3l10.3 10.3a8 8 0 0 0 11.3 0l11.3-11.3a8 8 0 0 0 0-11.3l-5.7-5.7V424a32.14 32.14 0 0 1 37.4-31.6c15.7 2.6 26.6 17.4 26.6 33.3v23.6l-5.7 5.7a8 8 0 0 0 0 11.3l11.3 11.3a8 8 0 0 0 11.3 0l10.3-10.3a16.06 16.06 0 0 0 4.7-11.3v-32a63.8 63.8 0 0 0-48-61.6z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M319.8 288.15v74.25a63.8 63.8 0 0 1 48 61.6v32a16.06 16.06 0 0 1-4.7 11.3l-10.3 10.3a8 8 0 0 1-11.3 0l-11.3-11.3a8 8 0 0 1 0-11.3l5.7-5.7v-23.6c0-15.9-10.9-30.7-26.6-33.3a32.14 32.14 0 0 0-37.4 31.6v25.3l5.7 5.7a8 8 0 0 1 0 11.3l-11.3 11.3a8 8 0 0 1-11.3 0l-10.3-10.3A16.06 16.06 0 0 1 240 456v-29.2c0-30.1 19.8-57.1 48-64.6v-70.41A174 174 0 0 1 151.1 288H144v82.6a56 56 0 1 1-32 0v-80.73A134.47 134.47 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48v-41.6a134.44 134.44 0 0 0-128.2-134.25zM104 424a24 24 0 1 0 24-24 23.94 23.94 0 0 0-24 24z"></path></g></svg>\n' +
    '            <span class="hidden-xs hidden-sm"><u>A</u>ktuell</span></a>\n' +
    '    </li>\n' +
    '    <!-- Historie -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.history({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="ordination">\n' +
    '<!--            <i class="flaticon-medical-26"></i> -->\n' +
    '            <svg aria-hidden="true" focusable="false" height="22"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M416 48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v416a48 48 0 0 0 48 48h320a48 48 0 0 0 48-48zm-208 80a64 64 0 1 1-64 64 64.06 64.06 0 0 1 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5a103 103 0 0 0 79.6 0h5c37.1 0 67.2 25.8 67.2 57.6z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M252.8 288h-5a103 103 0 0 1-79.6 0h-5c-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6zM208 256a64 64 0 1 0-64-64 64.06 64.06 0 0 0 64 64zm228-32h-20v64h20a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 128h-20v64h20a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0-256h-20v64h20a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12z"></path></g></svg>\n' +
    '            <span class="hidden-xs hidden-sm"><u>H</u>istorie</span></a>\n' +
    '    </li>\n' +
    '    <!-- Medikamente -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.drugs({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="Medikamente"><!--<i class="flaticon-pills"></i>-->\n' +
    '            <svg aria-hidden="true" focusable="false" height="22"   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M112 32A112 112 0 0 0 0 144v112h224V144A112 112 0 0 0 112 32zm312.2 80.8a114.33 114.33 0 0 0-159.3-28.1c-3.12 2.18-6.07 4.51-8.9 6.94v179.67l47 67.1 187.38-131.06z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M0 368a112 112 0 0 0 224 0V256H0zm555.3-67.9l-64.92-92.75L303 338.41l65 92.79a114.31 114.31 0 1 0 187.3-131.1z"></path></g></svg>\n' +
    '            <span class="hidden-xs hidden-sm"><u>M</u>edikamente</span></a>\n' +
    '    </li>\n' +
    '    <!-- Untersuchungen -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.examinations({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="Untersuchungen">\n' +
    '<!--            <i class="flaticon-people-10"></i>-->\n' +
    '            <svg height="22"  version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
    '                 viewBox="0 0 460.899 460.899" style="enable-background:new 0 0 460.899 460.899;" xml:space="preserve">\n' +
    '		<g>\n' +
    '			<path d="M57.225,365.475l-29.609-30.017l-5.843,2.862c-9.781,4.859-13.872,16.655-9.2,26.527l40.025,84.574\n' +
    '				c4.736,10.008,16.687,14.28,26.695,9.545c10.007-4.736,14.281-16.687,9.545-26.695L57.225,365.475z"/>\n' +
    '            <path d="M254.391,242.209c-2.634-4.739-4.004-9.837-4.235-14.909v-0.001l-74.322-22.907c-8.734-2.692-17.981-4.169-27.12-4.295\n' +
    '				c-16.552-0.228-46.352-0.552-80.895-0.524c-21.383,0-38.923,17.15-39.518,38.418c-0.666,6.524-5.703,55.899-6.437,63.094\n' +
    '				c-0.505,4.947,1.221,9.862,4.707,13.408l39.644,40.317c6.469,6.58,17.048,6.667,23.624,0.199\n' +
    '				c6.578-6.469,6.667-17.045,0.199-23.624L55.9,296.664c6.185-60.626,5.792-56.441,5.797-57.589\n' +
    '				c0.01-1.878,1.537-3.393,3.415-3.388c1.877,0.005,3.396,1.529,3.396,3.406v51.881l30.786,31.309\n' +
    '				c5.872,5.971,8.695,13.796,8.502,21.555h16.933l43.547,21.636l-31.612,66.797c-4.736,10.007-0.463,21.959,9.545,26.695\n' +
    '				c10.002,4.735,21.957,0.465,26.695-9.545l40.025-84.574c4.673-9.872,0.581-21.668-9.2-26.527l-46.735-23.219\n' +
    '				c0-16.201,0-64.484,0-81.554l116.764,35.989c8.837,2.719,18.173-2.242,20.885-11.043c0.062-0.2,0.099-0.401,0.153-0.602\n' +
    '				C279.6,262.993,262.458,256.723,254.391,242.209z"/>\n' +
    '            <path d="M112.75,188.537c19.1,0,34.622-15.492,34.622-34.622c0-19.121-15.501-34.622-34.622-34.622\n' +
    '				c-19.121,0-34.622,15.501-34.622,34.622C78.128,173.064,93.664,188.537,112.75,188.537z"/>\n' +
    '            <circle cx="340.531" cy="37.578" r="37.578"/>\n' +
    '            <path d="M449.472,433.184l-28.084-102.427l11.52-75.103l-8.685-140.86c-1.244-15.137-14.524-26.4-29.661-25.155l-48.877,4.018\n' +
    '				c-15.137,1.244-26.4,14.524-25.155,29.661l0.296,3.595l-26.285,39.381l-62.575,36.76l22.101,6.812\n' +
    '				c2.965-5.614,7.53-10.464,13.493-13.779c13.705-7.618,51.523-28.638,66.459-36.94l21.361-31.301l-15.413,45.904l-64.803,36.019\n' +
    '				c-8.815,4.899-11.99,16.018-7.09,24.834c4.9,8.815,16.019,11.99,24.834,7.09l70.99-39.458c3.98-2.212,6.99-5.831,8.44-10.149\n' +
    '				l17.666-52.613l-2.827,57.595c-0.58,11.816-9.809,15.591-15.674,18.848l-41.465,23.048l1.92,23.359l-21.941,59.823\n' +
    '				c-1.418,3.868-1.719,8.056-0.865,12.086l23.144,109.285c2.507,11.838,14.135,19.405,25.979,16.899\n' +
    '				c11.84-2.507,19.406-14.139,16.899-25.979l-21.838-103.118l26.141-71.275l8.525-0.701l-10.641,69.382\n' +
    '				c-0.466,3.043-0.286,6.148,0.527,9.116l29.318,106.929c3.199,11.684,15.268,18.544,26.925,15.342\n' +
    '				C445.804,456.913,452.671,444.856,449.472,433.184z"/>\n' +
    '		</g>\n' +
    '</svg>\n' +
    '            <span class="hidden-xs hidden-sm"><u>U</u>ntersuchungen</span></a>\n' +
    '    </li>\n' +
    '    <!-- Dokumente -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.documents({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="Dokumente">\n' +
    '            <svg aria-hidden="true" focusable="false"  height="22"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M160 0H96a32 32 0 0 0-32 32v76.33a160.25 160.25 0 0 1 128 0V32a32 32 0 0 0-32-32zm64 480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-64H224zm353.62-17.78L465.08 42.71l-60.26 16.14 112.35 418.8c.11.39.2.79.29 1.18l60.29-16.15c-.04-.15-.09-.3-.13-.46zM64 401.68V480a32 32 0 0 0 32 32h64a32 32 0 0 0 32-32v-78.32a160.33 160.33 0 0 1-128 0zm191-49.36A160.35 160.35 0 0 1 224 383v1h128V127.84l-126.7.16A160 160 0 0 1 255 352.32zM320 0h-64a32 32 0 0 0-32 32v64h124.79l-8-29.65a23.94 23.94 0 0 1 11.17-27V32A32 32 0 0 0 320 0z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M128 127a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm64 144a5.33 5.33 0 0 1-5.33 5.33h-37.34v37.34A5.33 5.33 0 0 1 144 319h-32a5.33 5.33 0 0 1-5.33-5.33v-37.33H69.33A5.33 5.33 0 0 1 64 271v-32a5.33 5.33 0 0 1 5.33-5.33h37.34v-37.33A5.33 5.33 0 0 1 112 191h32a5.33 5.33 0 0 1 5.33 5.33v37.34h37.34A5.33 5.33 0 0 1 192 239zM402.39 49.78a23.89 23.89 0 0 0-29.18-17h-.09L357.73 37a24 24 0 0 0-16.9 29.36l8 29.65H224v32h128V108l103.62 386.22a23.89 23.89 0 0 0 29.18 17h.09l15.38-4.22a24 24 0 0 0 16.9-29.33zm236.78 395.87L524.39 17.78a23.89 23.89 0 0 0-29.18-17h-.09L479.73 5a24 24 0 0 0-16.9 29.36l114.79 427.86a23.89 23.89 0 0 0 29.18 17h.09l15.38-4.22a24 24 0 0 0 16.9-29.35zM224 416h128v-32H224z"></path></g></svg>\n' +
    '<!--            <i class="flaticon-medical-23"></i> -->\n' +
    '            <span class="hidden-xs hidden-sm"><u>D</u>okumente</span></a>\n' +
    '    </li>\n' +
    '    <!-- Tracker -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.trackers({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="Tracker">\n' +
    '<!--            <i class="flaticon-lifeline-of-heartbeats-on-a-paper-on-a-clipboard"></i>-->\n' +
    '\n' +
    '            <svg aria-hidden="true" focusable="false" height="22"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M448 488v.12A23.94 23.94 0 0 1 424 512H87.88A23.94 23.94 0 0 1 64 488V320h70.1l34.8 69.5a8 8 0 0 0 14.3 0L240 275.8l22.1 44.2h89.48a16.27 16.27 0 0 0 16.3-14 16.82 16.82 0 0 0 .13-2 16 16 0 0 0-16-16H281.8l-34.7-69.5a8 8 0 0 0-14.3 0L176 332.2l-19.9-39.8a8.14 8.14 0 0 0-7.2-4.4H64V23.88A23.94 23.94 0 0 1 88 0h232v112a16 16 0 0 0 16 16h112z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M441 105L343.1 7a24 24 0 0 0-17-7H320v112a16 16 0 0 0 16 16h112v-6.1a23.9 23.9 0 0 0-7-16.9zm-89 183h-70.2l-34.7-69.5a8 8 0 0 0-14.3 0L176 332.2l-19.9-39.8a8.14 8.14 0 0 0-7.2-4.4H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h126.1l34.8 69.5a8 8 0 0 0 14.3 0L240 275.8l22.1 44.2h89.48a16.27 16.27 0 0 0 16.3-14 16.82 16.82 0 0 0 .13-2A16 16 0 0 0 352 288z"></path></g></svg>\n' +
    '            <span class="hidden-xs hidden-sm"><u>T</u>racker</span></a>\n' +
    '    </li>\n' +
    '    <!-- Stammdaten -->\n' +
    '    <li role="presentation" ui-sref="patientrecord.basicdata({clientid: \'{{vm.clientid}}\', mode:\'{{vm.mode}}\'})"\n' +
    '        ui-sref-active="active">\n' +
    '        <a aria-controls="Stammdaten">\n' +
    '<!--            <i class="flaticon-man"></i> -->\n' +
    '            <svg aria-hidden="true" focusable="false" height="22"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><g class="fa-group"><path class="fa-secondary" fill="currentColor" d="M636.3 388.2l-25.8-14.9a117.31 117.31 0 0 0 0-42.6l25.8-14.9a7.24 7.24 0 0 0 3.3-8.5 150.07 150.07 0 0 0-33.2-57.4 7.29 7.29 0 0 0-9-1.4l-25.8 14.9a117.4 117.4 0 0 0-36.9-21.3v-29.8a7.28 7.28 0 0 0-5.7-7.1 150.88 150.88 0 0 0-66.2 0 7.28 7.28 0 0 0-5.7 7.1v29.8a117.4 117.4 0 0 0-36.9 21.3l-25.8-14.9a7.31 7.31 0 0 0-9 1.4 150.07 150.07 0 0 0-33.2 57.4 7.37 7.37 0 0 0 3.3 8.5l25.8 14.9a117.31 117.31 0 0 0 0 42.6l-25.8 14.9a7.24 7.24 0 0 0-3.3 8.5 150.82 150.82 0 0 0 33.2 57.4 7.29 7.29 0 0 0 9 1.4l25.8-14.9a117.4 117.4 0 0 0 36.9 21.3v29.8a7.28 7.28 0 0 0 5.7 7.1 150.88 150.88 0 0 0 66.2 0 7.28 7.28 0 0 0 5.7-7.1v-29.8a117.4 117.4 0 0 0 36.9-21.3l25.8 14.9a7.31 7.31 0 0 0 9-1.4 150.07 150.07 0 0 0 33.2-57.4 7.37 7.37 0 0 0-3.3-8.5zM496 400.5a48.5 48.5 0 1 1 48.5-48.5 48.55 48.55 0 0 1-48.5 48.5z" opacity="0.4"></path><path class="fa-primary" fill="currentColor" d="M425.2 491.7v-9.2c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6a39.23 39.23 0 0 1-48.5-7.3 182.34 182.34 0 0 1-40.2-69.6 39.11 39.11 0 0 1 17.9-45.7l7.9-4.6q-.15-3.9 0-7.8l-7.9-4.6a39.07 39.07 0 0 1-17.9-45.7c.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h352a47.94 47.94 0 0 0 27.2-8.5 39 39 0 0 1-2-11.8zM224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128z"></path></g></svg>\n' +
    '            <span class="hidden-xs hidden-sm">Stammdaten</span></a>\n' +
    '    </li>\n' +
    '</ul>\n' +
    '<div class="row">\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr1"></div>\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr2"></div>\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr3"></div>\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr4"></div>\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr5"></div>\n' +
    '    <div class="col-xs-12 spacer-top" ui-view="pr6"></div>\n' +
    '    <div class="col-xs-12 spacer-top hidden-md hidden-lg hidden-xl" ui-view="prsm1"></div>\n' +
    '    <div class="col-xs-12 spacer-top hidden-md hidden-lg hidden-xl" ui-view="prsm2"></div>\n' +
    '</div>');
}]);

/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular.module('vcutils.zipcode', ['restmod', 'ui.router', 'ui.bootstrap']);
})();
/**
 * Created by lari on 12/06/2017.
 */
'use strict';

(function () {
  'use strict';

  angular.module('vcutils.zipcode').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcutilszipcode', {
      url: '/vcutilszipcode',
      views: {
        'playgroundmain@playground': {
          template: '<h3><tt>&lt;zipcode zip="" city=""&gt;</tt></h3><div ui-view="zipcodeview"></div>'
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcutilszipcode entered');
      }
    });

    $stateProvider.state('playground.vcutilszipcode.allcomponents', {
      url: '/allcomponents',
      resolve: {
        zip: function zip() {
          return '';
        },
        city: function city() {
          return '';
        },
        onchange: function onchange() {
          return function () {
            console.log('debug: dummy onchange called for zipcode');
          };
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'zipcodeview@playground.vcutilszipcode': {
          component: 'zipcode',
          bindings: {
            zip: 'zip',
            city: 'city'
          }
        }
      },
      onEnter: function onEnter() {
        $log.debug('playground.vcutilszipcode.allcomponents entered');
      }
    });
  } // all routes
})();
/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcutils.zipcode.factory:Zipcode
   *
   * @description
   *
   */

  angular.module('vcutils.zipcode').factory('Zipcode', Zipcode).factory('Zipcodesearch', Zipcodesearch);

  Zipcode.$inject = ['restmod'];
  function Zipcode(restmod) {
    return restmod.model('/routes/zipcodes').mix({
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/zipcodes/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      } // extend
    });
  }

  Zipcodesearch.$inject = ['restmod'];
  function Zipcodesearch(restmod) {
    return restmod.model('/routes/zipcodes/numahead');
  }
})();
/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.zipcode').component('zipcode', {
    restrict: 'E',
    bindings: {
      zip: '<',
      city: '<',
      parentsave: '&',
      ti: '@?',
      ti2: '@?'
    },
    template: '\n        <div class="form-group zipcode-component" style="padding: 0px; margin-bottom: 0px" data-hook="zipcode-component">\n          <span class="col-md-4" style="padding: 0px; margin-top: 0px"><label for="postcode">PLZ</label>\n              <span class="input-group">\n                  <input type="text" ng-model="vm.zip" ng-show="vm.zip" tabindex="{{vm.ti}}" data-hook="zipcode-zip"\n                          class="form-control" id="postcode" placeholder="PLZ">\n                  <input type="text" class="form-control" ng-hide="vm.zip" tabindex="{{vm.ti}}"\n                         data-hook="zipcode-zipsearch"\n                         autocomplete="noway"\n                         id="postcode"\n                         placeholder="PLZ"\n                         ng-model="vm.asyncSelected"\n                         ng-blur="vm.foreignzip()"\n                         typeahead-on-select="vm.getzipcity($item, $model, $label)"\n                         uib-typeahead="zip as zip.text for zip in vm.getNames($viewValue)"\n                         typeahead-loading="loadingNames"\n                         typeahead-min-length="4"\n                         typeahead-no-results="noResults">\n                   <span class="input-group-btn">\n                        <button class="btn btn-danger" tabindex="-1"\n                                ng-click="vm.zip = \'\'; vm.city = \'\'; vm.asyncSelected = \'\'">\n                            <i class="fa fa-remove"></i>\n                        </button>\n                   </span>\n              </span>\n          </span><!-- css sucks, do not remove this comment\n       --><span class="col-md-8" style="padding: 0px">\n          <label for="postcode">Ort</label>\n              <input type="text" ng-model="vm.city" autocomplete="noway" tabindex="{{vm.ti2}}"\n                     ng-blur="vm.save()"\n                     data-hook="zipcode-city"\n                     class="form-control" id="city" placeholder="Ort">\n          </span>\n      </div>\n      <div ng-show="noResults">\n          <i class="fa fa-warning"></i> Keine Orte gefunden\n      </div>\n      <span ng-show="loadingNames"><i class="fa fa-spin fa-spinner"></i> Daten werden geladen ... </span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Zipcode', function ($log, Zipcode) {
      var vm = this;
      vm.title = 'zipcode-component-controller';

      vm.getzipcity = getzipcity;
      vm.foreignzip = foreignzip;
      vm.getNames = getNames;
      vm.save = save;

      vm.$onInit = function () {
        vm.lastzip = angular.copy(vm.zip);
        vm.lastcity = angular.copy(vm.city);
        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
        }
        if (angular.isUndefined(vm.ti2)) {
          vm.ti2 = 0;
        }
      };

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.zip) && changes.zip.currentValue !== vm.zip) {
            vm.zip = changes.zip.currentValue;
          }
          if (angular.isDefined(changes.city) && changes.city.currentValue !== vm.city) {
            vm.city = changes.city.currentValue;
          }
        }
      };

      // typeahead zipcode search backend query
      function getNames(val) {
        $log.debug('loading city names');

        return Zipcode.$searchahead({
          query: val,
          fields: ['zipstr']
        }).$asPromise().then(function (response) {
          $log.debug('response: ', response);
          var rezip = response.map(function (zipcode) {
            zipcode.text = zipcode.zip + ' ' + zipcode.city;
            zipcode.label = zipcode.zip + ' ' + zipcode.city;
            // $log.debug('response zip: ', zipcode);
            return zipcode;
          });
          $log.debug(rezip);
          return rezip;
        });
      }

      // typeahead patient search action
      function getzipcity($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        //  $log.debug('orig zip: ', vm.zip);
        //  $log.debug('$model zip: ', $model.zip);
        //  $log.debug('orig city: ', vm.city);
        vm.zip = $model.zip;
        vm.city = $model.city;
        vm.save();
      }

      function foreignzip() {
        // $log.debug('foreignzip vm.zip:', vm.zip);
        // $log.debug('foreignzip asyncSelected:', vm.asyncSelected);
        if (!vm.zip) {
          if (angular.isString(vm.asyncSelected)) {
            vm.zip = vm.asyncSelected;
            // $log.debug('foreignzip string vm.zip:', vm.zip);
          }
          if (angular.isObject(vm.asyncSelected) && vm.asyncSelected.hasOwnProperty('zip')) {
            vm.zip = vm.asyncSelected.zip;
            // $log.debug('foreignzip object vm.zip:', vm.zip);
          }
          vm.save();
        }
      }

      function save() {
        if (!angular.equals(vm.zip, vm.lastzip) || !angular.equals(vm.city, vm.city)) {
          vm.lastzip = angular.copy(vm.zip);
          vm.lastcity = angular.copy(vm.city);
          $log.debug('debug: calling zipcode parentsave');
          vm.parentsave({ zip: vm.zip, city: vm.city });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular.module('vcutils.vcfields', ['ui.router', 'ui.bootstrap']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcfields').component('vcinput', {
    restrict: 'E',
    bindings: {
      model: '<',
      parentsave: '&',
      id: '@',
      placeholder: '@?'
    },
    template: '\n           <input type="text" ng-model="vm.workingmodel" tabindex="0"\n               autocomplete="noway"\n               ng-blur="vm.setCurrentFieldContent(vm.workingmodel)"\n               ng-focus="vm.setCurrentField(vm.id)"\n               ng-change="vm.setCurrentFieldContent(vm.workingmodel)"\n               ng-class="{conflict: vm.dataconflict}"\n               ng-model-options="{ updateOn: \'blur\' }"\n               class="form-control" id="vm.id"\n               placeholder="{{vm.placeholder}}">\n      ',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;

      // TODO: what do these do?
      var lastmodel = undefined;
      var editing = undefined;
      var localcurrentvalue = undefined;

      vm.datachanged = false;
      vm.dataconflict = undefined;

      vm.save = save;
      vm.setCurrentField = setCurrentField;
      vm.setCurrentFieldContent = setCurrentFieldContent;

      vm.save = save;

      vm.$onInit = function () {
        vm.lastmodel = vm.model;
        vm.workingmodel = vm.model;
      };

      // TODO: code review, thorough testing required, looks weird
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if data did change compared to state before starting editing
          if (changes.model.currentValue !== vm.lastmodel) {
            vm.datachanged = true;
            // if editing is currently in progress -> merge content
            if (angular.isDefined(editing) && angular.isDefined(localcurrentvalue)) {
              // $log.debug('debug: editing in progress: ', editing);
              $log.debug('debug: data conflict: ', editing);
              vm.dataconflict = true;
              vm.lastmodel = changes.model.currentValue;
              vm.workingmodel = changes.model.currentValue + ' ' + localcurrentvalue;
            } else {
              // not currently editing -> override content
              vm.workingmodel = vm.model;
              vm.lastmodel = vm.model;
            }
          }
        }
      };

      function save() {

        if (vm.workingmodel !== vm.lastmodel) {
          editing = undefined;
          localcurrentvalue = undefined;
          vm.dataconflict = undefined;
          vm.lastmodel = vm.workingmodel;
          $log.debug('debug: vcinput calling parentsave');
          vm.parentsave({ key: vm.id, value: vm.workingmodel });
        }
      }

      function setCurrentField(fieldname) {
        editing = fieldname;
      }

      function setCurrentFieldContent(value) {
        localcurrentvalue = value;
        vm.save();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcfields').component('vcarea', {
    restrict: 'E',
    bindings: {
      model: '<',
      parentsave: '&',
      id: '@',
      placeholder: '@?',
      options: '<?'
    },
    template: '\n           <textarea ng-model="vm.workingmodel" tabindex="0"\n               ng-blur="vm.setCurrentFieldContent(vm.workingmodel)"\n               ng-focus="vm.setCurrentField(vm.id)"\n               ng-change="vm.setCurrentFieldContent(vm.workingmodel)"\n               ng-class="{conflict: vm.dataconflict}"\n               class="form-control" id="vm.id"\n               ng-model-options="vm.options"\n               >{{vm.placeholder}}</textarea>\n      ',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;

      // TODO: what are these supposed to do
      var lastmodel = undefined;
      var editing = undefined;
      var localcurrentvalue = undefined;

      vm.datachanged = false;
      vm.dataconflict = undefined;

      vm.save = save;
      vm.setCurrentField = setCurrentField;
      vm.setCurrentFieldContent = setCurrentFieldContent;

      vm.save = save;

      vm.$onInit = function () {
        vm.lastmodel = vm.model;
        vm.workingmodel = vm.model;
      };
      // TODO: looks weird, code review, riogous testing required
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if data did change compared to state before starting editing
          if (changes.model.currentValue !== vm.lastmodel) {
            vm.datachanged = true;
            // if editing is currently in progress -> merge content
            if (angular.isDefined(editing) && angular.isDefined(localcurrentvalue)) {
              // $log.debug('debug: editing in progress: ', editing);
              $log.debug('debug: data conflict: ', editing);
              vm.dataconflict = true;
              vm.lastmodel = changes.model.currentValue;
              vm.workingmodel = changes.model.currentValue + ' ' + localcurrentvalue;
            } else {
              // not currently editing -> override content
              vm.workingmodel = vm.model;
              vm.lastmodel = vm.model;
            }
          }
        }
      };

      function save() {
        if (vm.workingmodel !== vm.lastmodel) {
          editing = undefined;
          localcurrentvalue = undefined;
          vm.dataconflict = undefined;
          vm.lastmodel = vm.workingmodel;
          // $log.debug('debug: vcinput calling parentsave');
          vm.parentsave({ key: vm.id, value: vm.workingmodel });
        }
      }

      function setCurrentField(fieldname) {
        editing = fieldname;
      }

      function setCurrentFieldContent(value) {
        localcurrentvalue = value;
        vm.save();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcutils.sv
   * @description
   *
   */
  angular.module('vcutils.sv', ['ui.router', 'vcutils.rlog', 'vcutils.sprhelp', 'vcutils.zipcode']);
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sv').component('svsearch', {
    restrict: 'E',
    bindings: {
      sv: '<',
      svref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showsv($item, $model, $label)"\n                   uib-typeahead="sv as sv.text for sv in vm.getSvs($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-warning"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addSv()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addSv()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === \'true\'">\n          <sveditor sv="vm.sv"></sveditor>\n        </div>\n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Sv', 'SvHelper', function ($log, Sv, SvHelper) {
      var vm = this;
      vm.save = save;
      vm.showsv = showsv;

      vm.getSvs = getSvs;
      // vm.addSv = SvHelper.addSv;
      vm.addSv = addSv;
      vm.editSv = SvHelper.editSv;

      vm.$onInit = function () {
        vm.newsv = {};

        if (angular.isUndefined(vm.ti)) {
          vm.ti = '0';
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastsv = angular.copy(vm.sv);
        vm.lastsvref = angular.copy(vm.svref);
      };

      function addSv() {
        $log.debug('debug - svsearch addSv called');
        SvHelper.addSv(function (sv) {
          $log.debug('debug: handle newly create sv');
          vm.sv = {};
          vm.sv.name = sv.name;
          vm.sv.short = sv.short;
          vm.sv._id = sv._id;
          vm.svref = sv._id;
          vm.asyncSelected = sv.short;
          vm.parentsave({ sv: vm.sv, svref: vm.svref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead sv search backend query
      function getSvs(val) {
        // return Svahead.$search({query: val}).$asPromise().then(function (response) {
        return Sv.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (sv) {
            sv.text = sv.short;
            if (sv.old) {
              sv.text = sv.short + '(' + sv.old + ')';
            }
            delete vm.error;
            return sv;
          });
        });
      }

      // typeahead sv search action
      function showsv($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.sv = $model;
        vm.svref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        // $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === 'true') {
          vm.sv = $model;
          vm.svref = $model._id;
          // $log.debug('debug - svsearch editinplace');
        } else {
            vm.sv = {};
            vm.sv.name = $model.name;
            vm.sv.short = $model.short;
            vm.sv.printlong = $model.printlong;
            vm.sv.old = $model.old;
            vm.sv.code = $model.code;
            vm.sv._id = $model._id;
            vm.svref = $model._id;
            vm.parentsave({ sv: vm.sv, svref: vm.svref });
            // $log.debug('debug - svsearch do not editinplace', vm.parentsave);
          }
      }

      function save() {
        if (!angular.equals(vm.sv, vm.lastsv) || !angular.equals(vm.svref, vm.lastsvref)) {
          vm.lastsv = angular.copy(vm.sv);
          vm.lastsvref = angular.copy(vm.svref);
          vm.parentsave({ sv: vm.sv, svref: vm.svref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sv').component('svnew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="svnew-component" data-hook="svnew-component">\n        <h3>Neue Sozialversicherung anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addSv()" ng-hide="vm.newsv">Neue SV anlegen</div>\n        <div ng-show="vm.newsv">\n          <svform sv="vm.newsv" parentsave="vm.saveNewSv(sv)" oncancel="vm.cancel()"></svform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Sozialversicherung erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Sozialversicherung wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Sozialversicherung konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Sv', 'Rlog', function ($log, Sv, Rlog) {
      var vm = this;
      vm.addSv = addSv;
      vm.saveNewSv = saveNewSv;
      vm.cancel = cancel;

      function addSv() {
        vm.newsv = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewSv(sv) {
        $log.debug('debug: create new sv: ', sv);
        delete vm.newsv;
        Sv.$create(sv).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new SV failed: ', err);
          Rlog.error('vcutils.sv', 'svnew', 'Creation of new SV failed: ', { error: err, sv: vm.newsv });
        });
      }

      function cancel() {
        delete vm.newsv;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of svs (patients) to display or load svs */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sv').component('svlist', {
    restrict: 'E',
    bindings: {
      svs: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>SV Kürzel</th>\n            <th>Bezeichnung</th>\n            <th>PLZ</th>\n            <th>Ort</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="sv in vm.svs">\n            <td>{{sv.short}} <span ng-show="sv.old"> ({{sv.old}})</span></td>\n            <td>{{sv.name}}</td>\n            <td>{{sv.zipcode}}</td>\n            <td>{{sv.city}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editSv(sv)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeSv(sv)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Sv', 'SvHelper', 'vertxEventBusService', function ($log, $http, Rlog, Sv, SvHelper, vertxEventBusService) {
      var vm = this;
      vm.editSv = SvHelper.editSv;
      vm.removeSv = removeSv;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.svs)) {
          vm.svs = Sv.$search({ active: true });
        }
      }; // $onInit()

      function removeSv(sv) {
        sv.active = false;
        sv.$save();
      }

      var svsUpdateHandler = function svsUpdateHandler(message) {
        $log.debug('debug: SV update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.svs)) {
          vm.svs.$refresh().$then(function () {
            $log.debug('debug: svlist refreshed svs');
          }, function (error) {
            $log.debug('debug: svlist refresh svs failed: ', error);
          });
        }
      };

      vertxEventBusService.on('svs.update', {}, svsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('svs.update', {}, svsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sv').component('svform', {
    restrict: 'E',
    bindings: {
      sv: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcutils/sv/svform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastsv = angular.copy(vm.sv);
      };

      function save() {
        if (!angular.equals(vm.sv, vm.lastsv)) {
          vm.lastsv = angular.copy(vm.sv);
          vm.parentsave({ sv: vm.sv });
        }
      }

      function cancel() {
        vm.sv = angular.copy(vm.lastsv);
        vm.oncancel();
      }

      function zipsave(zip, city) {
        $log.debug('debug: svform zipsave called: ', zip, city);
        vm.sv.postcode = zip;
        vm.sv.city = city;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * saved by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sv').component('sveditor', {
    restrict: 'E',
    bindings: {
      sv: '<?',
      svid: '<?'
    },
    template: '\n        <svform sv="vm.sv" parentsave="vm.childsave(sv)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Sozialversicherung erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Sozialversicherung wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Sozialversicherung konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Sv', 'Rlog', function ($log, Sv, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.sv) || !vm.sv.hasOwnProperty('_id')) && angular.isDefined(vm.svid)) {
          Sv.$find(vm.svid).$then(function (sv) {
            vm.sv = sv;
          }, function (err) {
            $log.error('SV not found, id: ', vm.svid, err);
            Rlog.error('sv', 'sveditor', 'SV not found', { _id: vm.svid });
          });
        }
      };

      function childsave(sv) {
        // vm.sv = angular.copy(sv);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in sv) {
          if (sv.hasOwnProperty(key)) {
            vm.sv[key] = sv[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.sv.$hasPendingActions()) {
          vm.sv.$cancel();
          vm.sv.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of SV failed: ', err);
            Rlog.error('vcutils.sv', 'sveditor', 'Saving of SV failed: ', { error: err, svid: vm.sv._id });
          });
        } else {
          vm.sv.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of SV failed: ', err);
            Rlog.error('vcutils.sv', 'sveditor', 'Saving of SV failed: ', { error: err, svid: vm.sv._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 12/06/2017.
 */
'use strict';

(function () {
  'use strict';

  angular.module('vcutils.sv').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcutilssv', {
      url: '/vcutilssv',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;svsearch sv="" svref="" editinplace="true"&gt;</tt></h3><div ui-view="svsearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;svsearch sv="" svref="" parentsave=""&gt;</tt></h3><div ui-view="svsearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;sveditor sv="" mode="" onClose=""&gt;</tt></h3><div ui-view="sveditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;svnew&gt;</tt></h3><div ui-view="svnewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;svlist svs="?"&gt;</tt></h3><div ui-view="svlistview"></div>\n            '
        }
      },
      onEnter: ['$log', function ($log) {
        $log.debug('debug/routes - playground.vcutilssv entered');
      }]
    });

    $stateProvider.state('playground.vcutilssv.allcomponents', {
      url: '/allcomponents',
      resolve: {
        sv: function sv() {
          return '';
        },
        svref: function svref() {
          return '';
        },
        somesv: ['Sv', function (Sv) {
          return Sv.$find('572b31b07c01597e3e150923');
        }],
        allsvs: ['Sv', function (Sv) {
          return Sv.$search({ active: true });
        }],
        parentsavesearch: function parentsavesearch() {
          return function (sv, svref) {
            $log.debug('debug: dummy parentsave called for svsearch with: ', sv, svref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'svsearchview@playground.vcutilssv': {
          component: 'svsearch',
          bindings: {
            sv: 'sv',
            svref: 'svref',
            editinplace: 'eip'
          }
        },
        'svsearchview2@playground.vcutilssv': {
          component: 'svsearch',
          bindings: {
            sv: 'sv',
            svref: 'svref',
            parentsave: 'parentsavesearch(sv, svref)'
          }
        },
        'sveditview@playground.vcutilssv': {
          component: 'sveditor',
          bindings: {
            sv: 'somesv'
          }
        },
        'svnewview@playground.vcutilssv': {
          component: 'svnew',
          bindings: {}
        },
        'svlistview@playground.vcutilssv': {
          component: 'svlist',
          bindings: {
            svs: 'allsvs'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcutilssv.allcomponents entered');
      }
    });
  } // all routes

  //  klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcutils.sv.factory:SvHelper
   *
   * @description
   *
   */
  angular.module('vcutils.sv').factory('SvHelper', SvHelper);

  SvHelper.$inject = ['Sv', '$uibModal', '$log', 'Rlog'];

  function SvHelper(Sv, $uibModal, $log, Rlog) {
    var SvHelperBase = {};

    SvHelperBase.editSv = editSv;
    SvHelperBase.addSv = addSv;

    function addSv(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><svform sv="svaCtrl.sv" parentsave="svaCtrl.childsave(sv)" oncancel="svaCtrl.cancel()"></svnew></div>',
        controllerAs: 'svaCtrl',
        controller: ['sv', function () {
          var vm = this;
          vm.sv = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(sv) {
            Sv.$create(sv).$then(function (newsv) {
              vm.created = true;
              success(newsv);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ sv-helper.addSv: ', err);
              Rlog.error('vcutils.sv', 'sv-helper.addSv', 'Creation of new SV failed: ', { error: err, sv: sv });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          sv: function sv() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editSv(lsv) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><svform sv="sveCtrl.sv" parentsave="sveCtrl.childsave(sv)" oncancel="sveCtrl.cancel()"></svform></div>',
        controllerAs: 'sveCtrl',
        controller: ['sv', function (ssv) {
          var vm = this;
          vm.sv = ssv;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(sv) {
            // vm.sv = angular.copy(sv);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in sv) {
              if (sv.hasOwnProperty(key)) {
                vm.sv[key] = sv[key];
              }
            }

            if (vm.sv.$hasPendingActions()) {
              vm.sv.$cancel();
              vm.sv.$save();
              cancel();
            } else {
              vm.sv.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          sv: function sv() {
            return lsv;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return SvHelperBase;
  }
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name helpers.sv.factory:Sv
   *
   * @description
   *
   */
  angular.module('vcutils.sv').factory('Sv', Sv).factory('Svahead', Svahead);

  Sv.$inject = ['restmod'];
  function Sv(restmod) {
    return restmod.model('/routes/svs').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/svs/svahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      } // extend
    });
  }

  Svahead.$inject = ['restmod'];
  function Svahead(restmod) {
    return restmod.model('/routes/svs/svahead');
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcutils.vcshare
   * @description
   *
   */
  angular.module('vcutils.vcshare', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcshare').component('sharesearch', {
    restrict: 'E',
    bindings: {
      share: '<',
      shareref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   autofocus\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showshare($item, $model, $label)"\n                   uib-typeahead="share as share.text for share in vm.getShares($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="glyphicon glyphicon-refresh"></i>\n        <div ng-show="noResults">\n          <i class="glyphicon glyphicon-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addShare()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addShare()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <shareeditor share="vm.share"></shareeditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Share', 'ShareHelper', function ($log, Share, ShareHelper) {
      var vm = this;
      vm.save = save;
      vm.showshare = showshare;

      vm.getShares = getShares;
      // vm.addShare = ShareHelper.addShare;
      vm.addShare = addShare;
      vm.editShare = ShareHelper.editShare;

      vm.$onInit = function () {
        vm.newshare = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastshare = angular.copy(vm.shareresult);
        vm.lastshareref = angular.copy(vm.shareref);
      };

      function addShare() {
        $log.debug('debug - sharesearch addShare called');
        ShareHelper.addShare(function (share) {
          $log.debug('debug: handle newly create share');
          vm.share = {};
          vm.share.name = share.name;
          vm.share.short = share.short;
          vm.share._id = share._id;
          vm.shareref = share._id;
          vm.asyncSelected = share.short;
          vm.parentsave({ share: vm.share, shareref: vm.shareref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead share search backend query
      function getShares(val) {
        // return Shareahead.$search({query: val}).$asPromise().then(function (response) {
        return Share.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (share) {
            share.text = share.short;
            delete vm.error;
            return share;
          });
        });
      }

      // typeahead share search action
      function showshare($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.share = $model;
        vm.shareref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.share = $model;
          vm.shareref = $model._id;
          $log.debug('debug - sharesearch editinplace');
        } else {
          vm.share = {};
          vm.share.name = $model.name;
          vm.share.short = $model.short;
          vm.share._id = $model._id;
          vm.shareref = $model._id;
          vm.parentsave({ share: vm.share, shareref: vm.shareref });
          $log.debug('debug - sharesearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.share, vm.lastshare) || !angular.equals(vm.shareref, vm.lastshareref)) {
          vm.lastshare = angular.copy(vm.share);
          vm.lastshareref = angular.copy(vm.shareref);
          vm.parentsave({ share: vm.share, shareref: vm.shareref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcshare').component('sharenew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="sharenew-component" data-hook="sharenew-component">\n        <div class="btn btn-success" ng-click="vm.addShare()" ng-hide="vm.newshare">Neues Netzlaufwerk anlegen</div>\n        <div ng-show="vm.newshare">\n          <shareform share="vm.newshare" parentsave="vm.saveNewShare(share)" oncancel="vm.cancel()"></shareform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Netzlaufwerk erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Netzlaufwerks wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Netzlaufwerk konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Share', 'Rlog', function ($log, Share, Rlog) {
      var vm = this;
      vm.addShare = addShare;
      vm.saveNewShare = saveNewShare;
      vm.cancel = cancel;

      function addShare() {
        vm.newshare = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewShare(share) {
        $log.debug('debug: create new share: ', share);
        delete vm.newshare;
        Share.$create(share).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new share failed: ', err);
          Rlog.error('vcutils.share', 'sharenew', 'Creation of new share failed: ', { error: err, share: vm.newshare });
        });
      }

      function cancel() {
        delete vm.newshare;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of shares (patients) to display or load shares */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcshare').component('sharelist', {
    restrict: 'E',
    bindings: {
      shares: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n            <tr>\n              <th width="10%">Name</th>\n              <th width="30%">Beschreibung</th>\n              <th width="30%">Pfad/Endpoint</th>\n              <th width="15%">Filetype</th>\n              <th width="15%"></th>\n            </tr>\n          </thead>\n          <tr ng-repeat="share in vm.shares">\n            <td ng-bind="share.name"></td>\n            <td ng-bind="share.desc"></td>\n            <td>{{share.path}}<br>{{share.endpoint}}</td>\n            <td ng-bind="share.filetype"></td>\n            <td>\n              <span class="btn btn-primary btn-sm" ng-click="vm.editShare(share)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></span><!--\n              --><span class="btn btn-danger btn-sm" ng-click="vm.removeShare(share)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></span>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Share', 'ShareHelper', 'vertxEventBusService', function ($log, $http, Rlog, Share, ShareHelper, vertxEventBusService) {
      var vm = this;
      vm.editShare = ShareHelper.editShare;
      vm.removeShare = removeShare;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve share list from web
        if (angular.isUndefined(vm.shares)) {
          vm.shares = Share.$search({ active: true });
        }
      }; // $onInit()

      function removeShare(share) {
        share.active = false;
        share.$save();
      }

      var sharesUpdateHandler = function sharesUpdateHandler(message) {
        $log.debug('debug: share update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.shares)) {
          vm.shares.$refresh().$then(function () {
            $log.debug('debug: sharelist refreshed shares');
          }, function (error) {
            $log.debug('debug: sharelist refresh shares failed: ', error);
          });
        }
      };

      vertxEventBusService.on('shares.update', {}, sharesUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('shares.update', {}, sharesUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcshare').component('shareform', {
    restrict: 'E',
    bindings: {
      share: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcutils/share/shareform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastshare = angular.copy(vm.share);
      };

      function save() {
        if (!angular.equals(vm.share, vm.lastshare)) {
          vm.lastshare = angular.copy(vm.share);
          vm.parentsave({ share: vm.share });
        }
      }

      function cancel() {
        vm.share = angular.copy(vm.lastshare);
        vm.oncancel();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.vcshare').component('shareeditor', {
    restrict: 'E',
    bindings: {
      share: '<?',
      shareid: '<?'
    },
    template: '\n        <shareform share="vm.share" parentsave="vm.childsave(share)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Netzlaufwerk erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einers neuen Netzlaufwerks wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Netzlaufwerk konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Share', 'Rlog', function ($log, Share, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.share) || !vm.share.hasOwnProperty('_id')) && angular.isDefined(vm.shareid)) {
          Share.$find(vm.shareid).$then(function (share) {
            vm.share = share;
          }, function (err) {
            $log.error('share not found, id: ', vm.shareid);
            Rlog.error('share', 'shareeditor', 'share not found', { _id: vm.shareid });
          });
        }
      };

      function childsave(share) {
        // vm.share = angular.copy(share);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in share) {
          if (share.hasOwnProperty(key)) {
            vm.share[key] = share[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.share.$hasPendingActions()) {
          vm.share.$cancel();
          vm.share.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of share failed: ', err);
            Rlog.error('vcutils.share', 'shareeditor', 'Saving of share failed: ', { error: err, shareid: vm.share._id });
          });
        } else {
          vm.share.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of share failed: ', err);
            Rlog.error('vcutils.share', 'shareeditor', 'Saving of share failed: ', { error: err, shareid: vm.share._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcutils.vcshare').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcutilsshare', {
      url: '/vcutilsshare',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;sharesearch share="" shareref="" editinplace="true"&gt;</tt></h3><div ui-view="sharesearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;sharesearch share="" shareref="" parentsave=""&gt;</tt></h3><div ui-view="sharesearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;shareeditor share="" mode="" onClose=""&gt;</tt></h3><div ui-view="shareeditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;sharenew&gt;</tt></h3><div ui-view="sharenewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;sharelist shares="?"&gt;</tt></h3><div ui-view="sharelistview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vcutilsvcshare entered');
      }
    });

    $stateProvider.state('playground.vcutilsshare.allcomponents', {
      url: '/allcomponents',
      resolve: {
        share: function share() {
          return '';
        },
        shareref: function shareref() {
          return '';
        },
        someshare: function someshare(Share) {
          return Share.$find('572b31b07c01597e3e150923');
        },
        allshares: function allshares(Share) {
          return Share.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (share, shareref) {
            console.log('debug: dummy parentsave called for sharesearch with: ', share, shareref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'sharesearchview@playground.vcutilsshare': {
          component: 'sharesearch',
          bindings: {
            share: 'share',
            shareref: 'shareref',
            editinplace: 'eip'
          }
        },
        'sharesearchview2@playground.vcutilsshare': {
          component: 'sharesearch',
          bindings: {
            share: 'share',
            shareref: 'shareref',
            parentsave: 'parentsavesearch'
          }
        },
        'shareeditview@playground.vcutilsshare': {
          component: 'shareeditor',
          bindings: {
            share: 'someshare'
          }
        },
        'sharenewview@playground.vcutilsshare': {
          component: 'sharenew',
          bindings: {}
        },
        'sharelistview@playground.vcutilsshare': {
          component: 'sharelist',
          bindings: {
            shares: 'allshares'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcutilsshare.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcutils.vcshare.factory:ShareHelper
   *
   * @description
   *
   */
  angular.module('vcutils.vcshare').factory('ShareHelper', ShareHelper);

  ShareHelper.$inject = ['Share', '$uibModal', '$log', 'Rlog'];

  function ShareHelper(Share, $uibModal, $log, Rlog) {
    var ShareHelperBase = {};

    ShareHelperBase.editShare = editShare;
    ShareHelperBase.addShare = addShare;

    function addShare(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><shareform share="vm.share" parentsave="vm.childsave(share)" oncancel="vm.cancel()"></sharenew></div>',
        controllerAs: 'shareaCtrl',
        controller: ['share', function () {
          var vm = this;
          vm.share = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(share) {
            Share.$create(share).$then(function (newshare) {
              vm.created = true;
              success(newshare);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ share-helper.addShare: ', err);
              Rlog.error('vcutils.share', 'share-helper.addShare', 'Creation of new SV failed: ', { error: err, share: share });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          share: function share() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editShare(lshare) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><shareform share="shareeCtrl.share" parentsave="shareeCtrl.childsave(share)" oncancel="shareeCtrl.cancel()"></shareform></div>',
        controllerAs: 'shareeCtrl',
        controller: ['share', function (sshare) {
          var vm = this;
          vm.share = sshare;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(share) {
            // vm.share = angular.copy(share);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in share) {
              if (share.hasOwnProperty(key)) {
                vm.share[key] = share[key];
              }
            }

            if (vm.share.$hasPendingActions()) {
              vm.share.$cancel();
              vm.share.$save();
              cancel();
            } else {
              vm.share.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          share: function share() {
            return lshare;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return ShareHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcutils.share.factory:Share
   *
   * @description
   *
   */
  angular.module('vcutils.vcshare').factory('Share', Share);

  Share.$inject = ['restmod'];
  function Share(restmod) {
    return restmod.model('/routes/shares').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/shares/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular.module('vcutils.sprhelp', []);

  angular.module('vcutils.sprhelp').config(function ($uibTooltipProvider) {
    $uibTooltipProvider.options({
      mouseover: 'outsideClick'
    });
  });
})();
/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.sprhelp').component('sprhelp', {
    restrict: 'E',
    bindings: {
      tip: '@',
      descref: '<?',
      file: '@?',
      video: '@?'
    },
    template: '\n<!-- TODO: fix annozing mouse over behaviour, make extra links for video and pdf links -->\n        <span class="sprhelp-component" data-hook="sprhelp-component">\n      &nbsp;<span class="text-primary" ng-if="vm.complex === false"><i class="fa fa-info-circle" uib-popover="{{vm.tip}}" popover-trigger="\'mouseenter\'" popover-placement="auto top"></i></span>\n      &nbsp;<span class="text-primary" ng-if="vm.complex === true"><i class="fa fa-info-circle" uib-popover-html="vm.getPopcontent()"\n      popover-trigger="\'mouseover outsideClick\'" popover-title="{{vm.tip}}" popover-placement="auto top"></i></span>\n        </span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$sce', function ($log, $sce) {
      var vm = this;
      vm.getPopcontent = getPopcontent;

      vm.$onInit = function () {
        // noinspection JSUnresolvedVariable
        if (angular.isDefined(vm.descref) || angular.isDefined(vm.file)) {
          vm.complex = true;
          vm.template = '<div>';
          // noinspection JSUnresolvedVariable
          if (angular.isDefined(vm.descref)) {
            vm.template += '<p>';
            // noinspection JSUnresolvedVariable
            vm.template += vm.descref;
            vm.template += '</p>';
          }
          if (angular.isDefined(vm.file) || angular.isDefined(vm.video)) {
            vm.template += '<p>Mehr Informationen:</p><ul>';
          }

          if (angular.isDefined(vm.file)) {
            vm.template += '<li><a target="_blank" href="/help/';
            vm.template += vm.file;
            vm.template += '"><i class="fa fa-file-pdf-o"></i> Anleitung (PDF)</a></li>';
          }

          // TODO: add correct vimeo prefix, or maybe switch to embedded video
          if (angular.isDefined(vm.video)) {
            vm.template += '<li><a target="_blank" href="http://vimeo.com/sprechstunde/';
            vm.template += vm.video;
            vm.template += '"><i class="fa fa-video-camera"></i> Anleitung (Video)</a></li>';
          }

          if (angular.isDefined(vm.file) || angular.isDefined(vm.video)) {
            vm.template += '</ul>';
          }

          vm.template += '<div>';

          vm.popoverContent = $sce.trustAsHtml(vm.template);
        } else {
          vm.complex = false;
        }
      };

      function getPopcontent() {
        return vm.popoverContent;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name rlog
   * @description
   *
   */
  angular.module('vcutils.rlog', ['ui.router', 'knalli.angular-vertxbus']);
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name rlog.service:Rlog
   *
   * @description
   *
   */
  angular.module('vcutils.rlog').service('Rlog', Rlog);

  Rlog.$inject = ['vertxEventBusService'];

  function Rlog(vertxEventBusService) {
    this.debug = function (module, directive, text, payload) {
      var message = log('debug', module, directive, text, payload);
      console.log('Rlog debug: ', directive, text);
      // return vertxEventBusService.publish('rlog.entry', message);
      return;
    };

    this.error = function (module, directive, text, payload) {
      var message = log('error', module, directive, text, payload);
      console.log('Rlog error: ', directive, text);
      return vertxEventBusService.publish('rlog.entry', message);
    };

    function log(level, module, directive, text, payload) {
      var message = {};
      message.level = level;
      message.module = module;
      // noinspection ES6ModulesDependencies
      message.timestamp = moment().toISOString();
      // noinspection ES6ModulesDependencies
      message.fdate = moment().format('YYYY MMM DD (DDD), hh:mm:ss');
      message.directive = directive;
      message.text = text;
      message.payload = payload;
      return message;
    }
  }
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name rlog
   * @description
   *
   */
  angular.module('vcutils.printhelper', ['ui.router', 'knalli.angular-vertxbus']);
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name rlog.service:Rlog
   *
   * @description
   *
   */
  angular.module('vcutils.printhelper').service('PrintHelper', PrintHelper);

  PrintHelper.$inject = ['$http', '$log'];

  function PrintHelper($http, $log) {
    // Aides
    // router.get("/" + model + "/aide/:isprint/:ispersist/:patientid/:consultid").blockingHandler(this::referralHandler);
    this.aidePreviewUrl = function (patientid, consultid) {
      return '/routes/fop/aide/false/false/' + patientid + '/' + consultid;
    };

    this.aidePrint = function (patientid, consultid) {
      var url = '/routes/fop/aide/true/true/' + patientid + '/' + consultid;
      return $http.get(url);
    };

    this.aidePersist = function (patientid, consultid) {
      var url = '/routes/fop/aide/false/true/' + patientid + '/' + consultid;
      return $http.get(url);
    };

    this.aideSinglePrint = function (patdocid, patientid) {
      var url = '/routes/fop/aidesingle/true/true/' + patdocid + '/' + patientid;
      return $http.get(url);
    };

    // Referrals
    // router.get("/" + model + "/referral/:isprint/:ispersist/:patientid/:consultid").blockingHandler(this::referralHandler);
    this.referralPreviewUrl = function (patientid, consultid) {
      return '/routes/fop/referral/false/false/' + patientid + '/' + consultid;
    };

    this.referralPrint = function (patientid, consultid) {
      var url = '/routes/fop/referral/true/true/' + patientid + '/' + consultid;
      return $http.get(url);
    };

    this.referralPersist = function (patientid, consultid) {
      var url = '/routes/fop/referral/false/true/' + patientid + '/' + consultid;
      return $http.get(url);
    };

    this.referralSinglePrint = function (patdocid, patientid) {
      var url = '/routes/fop/referralsingle/true/true/' + patdocid + '/' + patientid;
      return $http.get(url);
    };

    this.referralSinglePreview = function (patdocid, patientid) {
      var url = '/routes/fop/referralsingle/false/false/' + patdocid + '/' + patientid;
      return $http.get(url);
    };

    // Exam
    // router.get("/" + model + "/exam/:isprint/:ispersist/:examid/:consultid").blockingHandler(this::examHandler);

    this.examPreviewUrl = function (examid, consultid) {
      return '/routes/fop/exam/false/false/' + examid + '/' + consultid;
    };

    this.examPrint = function (examid, consultid) {
      var url = '/routes/fop/exam/true/true/' + examid + '/' + consultid;
      return $http.get(url);
    };

    this.examPersist = function (examid, consultid) {
      var url = '/routes/fop/exam/false/true/' + examid + '/' + consultid;
      return $http.get(url);
    };

    // ExamSample
    // router.get("/" + model + "/examsample/:isprint/:ispersist/:examid").blockingHandler(this::examSampleHandler);
    this.examSamplePreviewUrl = function (examid) {
      return '/routes/fop/examsample/false/false/' + examid;
    };

    // Examlabels
    // router.get("/" + model + "/examlabels/:isprint/:ispersist/:examid").blockingHandler(this::examlabelsHandler);

    this.examlabelsPreviewUrl = function (examid) {
      return '/routes/fop/examlabels/false/false/' + examid;
    };

    this.examlabelsPrint = function (examid) {
      var url = '/routes/fop/examlabels/true/true/' + examid;
      return $http.get(url);
    };

    this.examlabelsPersist = function (examid) {
      var url = '/routes/fop/examlabels/false/true/' + examid;
      return $http.get(url);
    };

    // Consult
    // router.get("/" + model + "/consult/:isprint/:ispersist/:consultid").blockingHandler(this::consultHandler);

    this.consultPreviewUrl = function (consultid) {
      return '/routes/fop/consult/false/false/' + consultid;
    };

    this.consultPrint = function (consultid) {
      var url = '/routes/fop/consult/true/true/' + consultid;
      return $http.get(url);
    };

    this.consultPersist = function (consultid) {
      var url = '/routes/fop/consult/false/true/' + consultid;
      return $http.get(url);
    };

    // Prescription
    // router.get("/" + model + "/prescription/:isprint/:ispersist/:patientid").blockingHandler(this::prescriptionHandler);

    this.prescriptionPreviewUrl = function (patientid) {
      return '/routes/fop/prescription/false/false/' + patientid;
    };

    this.prescriptionPrint = function (patientid) {
      var url = '/routes/fop/prescription/true/true/' + patientid;
      return $http.get(url);
    };

    this.prescriptionPersist = function (patientid) {
      var url = '/routes/fop/prescription/false/true/' + patientid;
      return $http.get(url);
    };

    // Cart/InvoiceReminder
    // invoice printing is realised by CashInvoice and CheckInvoice handlers

    // router.get("/" + model + "/cart/:isprint/:ispersist/:cartid").blockingHandler(this::cartHandler);

    this.cartPreviewUrl = function (cartid) {
      $log.debug('cartPreviewUrl called');
      return '/routes/fop/cart/false/false/' + cartid;
    };

    // router.get("/" + model + "/reminder/:isprint/:ispersist/:checkinvoiceid").blockingHandler(this::reminderHandler);
    this.reminderPrint = function (checkinvoiceid) {
      var url = '/routes/fop/reminder/true/true/' + checkinvoiceid;
      return $http.get(url);
    };

    this.reminderPersist = function (checkinvoiceid) {
      var url = '/routes/fop/reminder/false/true/' + checkinvoiceid;
      return $http.get(url);
    };

    // router.post("/" + model + "/plainjson/:isprint/:ispersist/:patientid/:doctype").blockingHandler(this::plainJsonHandler);
    this.jsonPrint = function (patientid, doctype, json) {
      var url = '/routes/fop/plainjson/true/true/' + patientid + '/' + doctype;
      return $http.post(url, json);
    };

    this.jsonPersist = function (patientid, doctype, json) {
      var url = '/routes/fop/plainjson/false/true/' + patientid + '/' + doctype;
      return $http.post(url, json);
    };

    this.jsonPreviewUrl = function (patientid, doctype, json) {
      var url = '/routes/fop/plainjson/false/false/' + patientid + '/' + doctype;
      return $http.post(url, json);
    };
  }

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular.module('vcutils.map', ['restmod', 'ui.router', 'ngLodash', 'ui.bootstrap']);
})();
/* global angular, moment, google */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.map').component('vcmap', {
    restrict: 'E',
    bindings: {
      data: '=',
      redraw: '<',
      lat: '<?',
      lng: '<?',
      height: '<?',
      zoom: '<?',
      plotroot: '@?',
      addrname: '@?',
      zipname: '@?',
      cityname: '@?',
      ownerscope: '<?',
      clickcb: '&?',
      iconresolver: '&?'
    },
    template: ' \n            <div id="map">           \n            ',
    controllerAs: 'vm',
    controller: ['$log', '$http', '$rootScope', '$element', 'lodash', '$timeout', '$window', function ($log, $http, $rootScope, $element, _, $timeout, $window) {
      var vm = this;
      vm.markers = [];
      vm.drawMarker = drawMarker;

      vm.$onInit = function () {
        if (angular.isUndefined(vm.zoom)) {
          vm.zoom = 14;
        }
        if (angular.isUndefined(vm.lat)) {
          vm.lat = 48.2082;
        }
        if (angular.isUndefined(vm.lng)) {
          vm.lng = 16.3738;
        }
        if (angular.isDefined(vm.height) && vm.height === '100%') {
          angular.element($element[0].children[0]).css('height', $window.innerHeight - 45 + 'px');
        } else {
          angular.element($element[0].children[0]).css('height', '400px');
        }
        if (angular.isUndefined(vm.addrname)) {
          vm.addrname = 'address';
        }
        if (angular.isUndefined(vm.zipname)) {
          vm.zipname = 'postcode';
        }
        if (angular.isUndefined(vm.cityname)) {
          vm.cityname = 'city';
        }

        // initalise map
        // noinspection JSUnresolvedVariable
        // noinspection JSUnresolvedFunction
        vm.map = new google.maps.Map($element[0].children[0], {
          zoom: vm.zoom,
          center: { lat: vm.lat, lng: vm.lng }
        });

        // get geocoder
        // noinspection JSUnresolvedVariable
        // noinspection JSUnresolvedFunction
        vm.geocoder = new google.maps.Geocoder();

        // Cordova built apps have a problem with the custom resolve, data was not ready, added comfort delay
        $timeout(function () {
          for (var i = 0; i < vm.data.length; i++) {
            drawMarker(vm.data[i]);
          }
        }, 3000);
        /*            for (let i = 0; i < vm.data.length; i++) {
                      drawMarker(vm.data[i]);
                    }*/
      };

      // use redraw binding to redraw map data
      this.$onChanges = function (changes) {
        if (changes.redraw && !changes.redraw.isFirstChange()) {
          $log.debug('change detected: ', changes.redraw);
          // get rid of existing markers
          for (var i = 0; i < vm.markers; i++) {
            // noinspection JSUnresolvedFunction
            vm.markers[i].setMap(null);
          }
          // draw set of current markers
          $timeout(function () {
            for (var i = 0; i < vm.data.length; i++) {
              $log.debug('data i address', vm.data[i].building.address);
              drawMarker(vm.data[i]);
            }
          }, 1000);
        }
      };

      function drawMarker(dataset) {
        var position = undefined;
        var datapoint = undefined;

        // noinspection JSUnresolvedVariable
        if (angular.isDefined(vm.plotroot)) {
          // noinspection JSUnresolvedVariable
          datapoint = _.get(dataset, vm.plotroot);
        } else {
          datapoint = dataset;
        }

        if (angular.isDefined(datapoint[vm.addrname]) && angular.isDefined(datapoint[vm.zipname]) && angular.isDefined(datapoint[vm.cityname])) {
          position = datapoint[vm.addrname] + ', ' + datapoint[vm.zipname] + ' ' + datapoint[vm.cityname];
        } else if (angular.isDefined(datapoint[vm.addrname])) {
          position = datapoint[vm.addrname];
        }

        // noinspection JSUnresolvedFunction
        vm.geocoder.geocode({ 'address': position }, function (results, status) {
          var icon = undefined;
          var image = undefined;
          if (status === 'OK') {
            (function () {
              // noinspection JSUnresolvedFunction JSUnresolvedVariable
              vm.map.setCenter(results[0].geometry.location);
              if (angular.isDefined(vm.iconresolver) && angular.isFunction(vm.iconresolver)) {
                // noinspection JSUnresolvedFunction
                icon = vm.iconresolver({ datapoint: dataset });
              } else {
                // icon = '/img/marker_rot.png'
                icon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAACICAMAAABUddwpAAACDVBMVEUAAAD///+cJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSacJSbVqLAaAAAArnRSTlMAAAECAwQFBgcICQoMDQ4PEBESExUWGBkdHiEiIyQlJyorLS4vMDEzNzk6Oz0+P0FCQ0RFRkdISUpLTE1QU1ZXWFlbXF5iZWZnaGlrbHBxcnR2d3h5e31/goOEhoeKjY+QkpOVlpyfoqOkpqiqq6ytrq+wsbKztri5ury9vr/AwcPFyMnKy83P0NHS09bZ29ze3+Dh4uPk5ufo6err7O7v8PHy8/T29/j5+vv8/f4RCRTXAAAE7ElEQVR4AbXQiT9VYQLG8WfOFboSCUVa0pK00DItxTQtWsqimZGZlihXQsuMRnszGCqU9sUN3eIWcp+/cc7nJuF9zz3ve87x/QN+n+fz4A9zZA7DsOPPP1rb8vhdmKbwu8cttUfz/bBjF47fdqFznILxzgvb4p2HfduvDtHS0NXtPkfhxX97Sxtv/7pYO7yk9hsVfKtdohVOPivPSoTPJquHD3yghg9/Ugxn/puabmWqhHcPUtvAbtuw8Q868ncjdjjpX3Ton0mxwqntdKw91Tqc3ksXetOtwinddKU7RR5O/C9d+k+iNNxI1xpl4Qp6oEIMbxynB8Y3zg4veEVPvFowK1zH2EKdTZfOn7/U1BlibHUzw3kRWpu4e3KVgUnG6pN3J2gtkjc9bHTRUrAqA7NkVAVpqcuYFj5IK19P+yHh/8swrRz8Hfa9oIXWTFhY0koLL3xT4T9TbrzUgCWjdJxyB6bCnZT6shMx/fELpf73K7yBUl/zYCPvK6U2TIYDlBkrhK3CMcoEfobjByhTCgWllBmIj4YLKXMTSm5SpjAarqFEKBNKMkOUqImGeyhRDkXllOiBGU6LUPTRD0X+jxRF0szwDkqcgbIzlNhhhispimRBWVaEokozXE9RGzS0UVRvhh9SVA0N1RQ9NMPPKSqAhgKKnpvhQYoyoSGTokEzTNEItIxQJA+/hpbXyuFeaOlVDvdBS588PExBP7T0UzBshkMUTCRAQ8IEBSEz3EdRLjTkUtRnhtspOgINRyhqN8PXKGqAhgaKrpnhyxQF50HZvCBFl81wOSX2Q9l+SpSb4T2UaIWyVkrsMcM5lFkPRespk2OG40YpcQ+K7lFiNM4Mo4syh6DkEGW6YIYRoMxgFhRkDVImEA2XUKozEbYSOylVEg3nUq4lDjbiblEuNxr2DVGuKQExJTRRbsgXDaOFFh6kIobUh7TQgp/hMlp5mQ9L+S9ppWwyvJqWflxMgVTKxR+0tHoyjDe0FqxMhiC5Mkhrb/ArHGAsocAmA9MYmwIhxhKYCu+ljYEbFftWpiclpa/cX3FjgDb2ToX9I/TQiH8qjGZ6qBm/w8X0UPFU2NsvRvzTwmikZxoxPbyTntk5I+x7T4+8980I4xw9cg4zw8vpkeWzwnhATzzA7HAxPVEshOP76YH+eCGManqgGmI4Y5SujWZIwrhC165AFl5D19ZIw7hDl+5AHi6gSwUWYXTQlQ5YhYvoSpFl2HhCF54YlmEUuR8sDxtP3A+WhlHkfrA8bHTQoQ4jZhhb6dBWxA7jNh25Dbvw2ggdiKy1DaORDjTCPpw9Rm1j2Qph1FBbDVTCiwaoaWCRUhjHqek41MK+p9Ty1KcYxhZq2QLVMJqpoRnq4aVhKgsv1QijisqqoBNOeEZFzxK0wthMRZuhF0Y9ldRDN5z2iQo+pWmHcZgKDkM/jPu0dR9OwtkjtDGS7SiMU7RxCs7CxiPG9MhwGMaKMGMIr4DTMMoYQxmch31ttNTmcxHGsmFaGF4GN2GU0EIJ3IXRQqkWuA2nBykRTHcdxj5K7IP7MOooqIMX4fk9nKVnvidhrApzhvAqeBPGMc5wDF6FcZ3TXId34YV9nNK30MMw1n3npO/r4GUYJzjpBLwNo4FRDfA6nNRNU3eS52HkfCY/58D7MHZNTOzCXIRx+jR0wnNkzsL/B+5FM4Ny2IiiAAAAAElFTkSuQmCC';
              }
              $log.debug('icon :', icon);
              // noinspection JSUnresolvedVariable
              image = {
                url: icon,
                scaledSize: new google.maps.Size(20, 32)
              };
              $log.debug('marker: ', results[0].geometry);
              // noinspection JSUnresolvedVariable
              var marker = new google.maps.Marker({
                map: vm.map,
                position: results[0].geometry.location,
                icon: image
              });

              vm.markers.push(marker);

              // noinspection JSUnresolvedVariable
              if (angular.isDefined(vm.clickcb) && angular.isFunction(vm.clickcb)) {
                marker.addListener('click', function () {
                  // $log.debug('map marker clicked: ', marker);
                  // noinspection JSUnresolvedFunction
                  return vm.clickcb({ datapoint: dataset, marker: marker });
                });
              }
            })();
          } else {
            $log.error('Geocode was not successful for the following reason: ' + status);
          }
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.arrayEditor
   * @description
   *
   */
  angular.module('vcutils.listeditor', ['ui.router']);
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.listeditor').component('listeditor', {
    restrict: 'E',
    bindings: {
      list: '<',
      parentsave: '&'
    },
    //templateUrl: 'vcutils/listeditor/listeditorform-component.tpl.html',
    template: '\n        <div ng-repeat="a in vm.tmplist track by $index" ng-show="vm.tmplist.length > 0">\n          <div class="input-group">\n            <input type="text" class="form-control" ng-model="a" placeholder="Bestehendes ersetzen...">\n              <span class="input-group-btn">\n                <button class="btn btn-danger" type="button" ng-click="vm.splice($index)"><i class="fa fa-remove"></i></button>\n              </span>\n          </div>\n        </div>\n        <form name="vm.formid" >\n        <div class="input-group">\n          <input type="text" class="form-control" ng-model="vm.newvalue" \n            placeholder="Neuer Wert..." ng-keyup="$event.keyCode == 13 && vm.add()">\n              <span class="input-group-btn">\n                <button class="btn btn-success" type="button" ng-click="vm.add()"><i class="fa fa-plus"></i></button>\n              </span>\n        </div>\n        </form>      \n      \n      ',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.splice = splice;
      vm.add = add;
      vm.formid = guid;
      vm.$onInit = function () {
        vm.lastlist = angular.copy(vm.list);
        vm.tmplist = angular.copy(vm.list);
      };

      vm.$onChanges = function (changes) {
        if (changes.list) {
          if (!changes.list.isFirstChange()) {
            vm.lastlist = angular.copy(vm.list);
            vm.tmplist = angular.copy(vm.list);
          }
        }
      };

      function save() {
        if (!angular.equals(vm.tmplist, vm.lastlist)) {
          vm.lastlist = angular.copy(vm.tmplist);
          vm.parentsave({ list: vm.tmplist });
        }
      }

      /*        function cancel() {
                vm.tmplist = angular.copy(vm.lastlist);
                vm.oncancel();
              }*/

      function splice(i) {
        vm.tmplist.splice(i, 1);
        $log.debug('array: ', vm.tmplist);
        save();
      }

      function add() {
        if (!angular.isArray(vm.tmplist)) {
          vm.tmplist = [];
        }
        vm.tmplist.push(vm.newvalue);
        $log.debug('array: ', vm.tmplist);
        vm.newvalue = '';
        save();
      }

      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name heartbeat
   * @description
   *
   */
  angular.module('vcutils.heartbeat', ['ui.router', 'knalli.angular-vertxbus']);
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

// This MUST remain a directive, compnets do not allow placement as Attribute
// use in index.html as <body heartbeat>
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name heartbeat.directive:heartbeat
   * @restrict A
   * @element
   *
   * @description detects backend outages and warns user
   *
   *
   * @example
   <html name="index.html">
   <body heartbeat></body>
   </html>
   *
   */
  angular.module('vcutils.heartbeat').directive('heartbeat', heartbeat);

  heartbeat.$inject = ['$log', 'vertxEventBusService', 'vertxEventBus', '$state', '$rootScope', '$interval', '$window', '$timeout', '$uibModal'];

  function heartbeat($log, vertxEventBusService, vertxEventBus, $state, $rootScope, $interval, $window, $timeout, $uibModal) {
    return {
      restrict: 'A',
      scope: {},
      replace: false,
      controllerAs: 'heartbeat',
      controller: function controller() {
        var vm = this;
        vm.name = 'heartbeat';
        vm.refresh = refresh;

        function refresh() {
          $window.location.reload();
        }

        $interval(function () {
          // $log.debug('timout called');
          if (angular.isUndefined($rootScope.connfailure)) {
            $log.debug('heartbeat - initialising $rootScope.connfailure to 0');
            $rootScope.connfailure = 0;
          }

          // $log.debug('heartbeat : ', $rootScope.heartbeat.isBetween(moment().subtract(5, 'second'), moment()));

          if (angular.isDefined($rootScope.heartbeat)) {
            if ($rootScope.heartbeat.isBetween(moment().subtract(5000, 'ms'), moment())) {
              // $log.debug('heartbeat - validated');
              $rootScope.connfailure = 0;
            } else {
              $rootScope.connfailure++;
              $log.debug('heartbeat - connection failed: ', $rootScope.connfailure, moment().toISOString());
            }

            if ($rootScope.connfailure >= 3) {
              $log.error('heartbeat - Error allowed number of misses exceeded: ', $rootScope.connfailure, moment().toISOString(), $rootScope.heartbeat);
              $log.debug('heartbeat vertxbus connection status - ', vertxEventBusService.getConnectionState());
              $log.debug('heartbeat vertxbus connection isConnected - ', vertxEventBusService.isConnected());
              $log.debug('heartbeat vertxbus connection isConnectionOpen - ', vertxEventBusService.isConnectionOpen());
              $log.debug('heartbeat vertxbus message queue length - ', vertxEventBusService.getMessageQueueLength());

              // $log.debug('heartbeat vertxbus forcing immediate reconnect');

              if (angular.isUndefined($rootScope.lastebrestart)) {
                // $log.debug('heartbeat - validated');
                $rootScope.lastebrestart = moment();
              }

              // only force reconnect if vertxeventbus was not reconnected recently
              /*              if (!$rootScope.lastebrestart.isBetween(moment().subtract(15000, 'ms'), moment())) {
                              $log.debug('Force reconnect heartbeat vertxbus at: ', moment().toISOString());
                              vertxEventBus.reconnect(true);
                              $log.debug('heartbeat vertxbus connection status after forced reconnect - ', vertxEventBusService.getConnectionState() );
                            }*/

              if (angular.isUndefined($rootScope.connalert)) {
                $log.debug('heartbeat - opening new connection loss popup: ', $rootScope.connalert);
                $rootScope.connalert = $uibModal.open({
                  template: '<div class="modalspacer">' + '<div class="alert alert-danger" ng-hide="connfailure === 0">' + '<h1 style="text-align: center"><i class="fa fa-warning"></i> Die Verbindung zum Server wurde unterbrochen!</h1>' + '<h3 style="text-align: center">Dieser Hinweis verschwindet, sobald der Fehler behoben ist.</h3>' + '<div class="spacer-top"><h3>Fehlerbehebung</h3>' + '<ul><li>Bitte 2 Minuten warten, Verbindungsfehler beheben sich oft von alleine.</li>' + '<li>Bei WLAN/VPN Verbindungen (Handy, Tablet, Laptop) WLAN/VPN abdrehen, wieder neu verbinden und 1 Minute warten.</li>' + '<li>Strg + R drücken (CMD + R für Mac), oder hier <span class="btn btn-danger" ng-click="vm.refresh()"><span class="fa fa-refresh"></span> Seite neu laden</span> </li>' + '</ul></div></div>' + '<div class="alert alert-success" ng-show="connfailure === 0">' + '<h1 style="text-align: center"><i class="fa fa-check"></i> Die Verbindung zum Server wurde wieder hergestellt!</h1>' + '<h3>Je nach dem wo Sie gerade gearbeitet haben, kann es zu Datenverlust der letzten 10 Sekunden gekommen sein.' + 'Bitte überprüfen und ggf. nochmal eintragen.</h3>' + '<button class="btn btn-success" ng-click="connalert.close()">Weiterabeiten</button>' + '</div></div>',
                  size: 'lg',
                  backdrop: 'static',
                  controllerAs: 'miCtrl',
                  bindToController: true,
                  controller: function controller() {
                    // $log.debug('modal $scope: ', $rootScope);
                    // this an empty controller - weird
                    var vmi = this;
                    vmi.$rootScope = $rootScope;
                  },
                  resolve: {}
                });
              } else {
                // $log.debug('heartbeat - $rootscope.connalert already existed: ', $rootScope.connalert);

              }
            }
          }
        }, 3000);
      },
      link: function link(scope, element, attrs, ctrl) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */

        var heartbeatHandler = function heartbeatHandler(msg) {
          var now = moment();
          if ($rootScope.connfailure > 2) {
            var d = now.diff($rootScope.heartbeat);
            $log.debug('heartbeat - autorecovered after: ', moment.utc(d).format('HH:mm:ss'), ' after ', $rootScope.connfailure, ' fails');
          }
          $rootScope.heartbeat = now;
          // $log.debug('heartbeat - received: ', $rootScope.heartbeat);
        };

        vertxEventBusService.on('heartbeat', {}, heartbeatHandler);

        //         TODO: figure out how to unlink heartbeat handler on destroy
        /*
                vm.$onDestroy = function () {
                  vertxEventBusService.unregisterHandler('heartbeat', {}, heartbeatHandler);
                };*/
      }
    };
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name config
   * @description
   *
   */
  angular.module('vcutils.config', ['ui.router', 'vcutils.listeditor']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.config').component('version', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>Version</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <h4 ng-bind="vm.version"></h4>\n          </div>  \n        </div>\n  ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', '$http', function ($log, Rlog, $http) {
      var vm = this;

      vm.$onInit = function () {
        $http.get('/routes/version').then(function success(v) {
          vm.version = v.data;
        }, function failure(e) {
          vm.error = e.statusText + ' (Error: ' + e.status + ')';
        });
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name config.factory:Config
   *
   * @description
   *
   */
  angular.module('vcutils.config').factory('Config', Config);

  Config.$inject = ['restmod'];

  function Config(restmod) {
    return restmod.model('/routes/appconfig');
  }
})();
/* global angular, moment */

/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name utils.sprhelp
   * @description
   *
   */
  angular.module('vcutils.doctor', ['restmod', 'ui.router', 'ui.bootstrap', 'ui.grid', 'vcutils.rlog', 'vcutils.sprhelp', 'vcutils.zipcode']);
})();
/* global angular, moment */
/**
 * Created by lari on 07/06/2017.
 */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.doctor').component('doctorsearch', {
    restrict: 'E',
    bindings: {
      parentsave: '&?',
      editinplace: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="0"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Arztsuche ...."\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showdoctor($item, $model, $label)"\n                   uib-typeahead="doctor as doctor.fname for doctor in vm.getDoctors($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-warning"></i> Kein Arzt gefunden\n          <span class="btn btn-success" ng-click="vm.addDoctor()" ng-hide="vm.error" ng-show="vm.parentsave">Neuen Arzt eingeben</span>\n          <span ng-click="vm.addDoctor()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Arzt konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="(vm.editinplace === true || vm.editinplace === \'true\') && vm.showedit">\n          <doctoreditor doctor="vm.doctor"></doctoreditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctor', 'DoctorHelper', function ($log, Doctor, DoctorHelper) {
      var vm = this;
      vm.save = save;
      vm.showdoctor = showdoctor;

      vm.getDoctors = getDoctors;
      vm.addDoctor = addDoctor;
      vm.editDoctor = DoctorHelper.editDoctor;
      vm.$onInit = function () {
        vm.newdoctor = {};
        vm.lastdoctor = angular.copy(vm.doctor);
        vm.lastdoctorref = angular.copy(vm.doctorref);
      };

      function addDoctor() {
        $log.debug('debug - doctorsearch addDoctor called');
        DoctorHelper.addDoctor(function (doctor) {
          $log.debug('debug: handle newly create doctor: ', doctor);
          vm.doctor = {};
          vm.doctor.name = doctor.name;
          vm.doctor.short = doctor.short;
          vm.doctor.fname = doctor.fname;
          vm.doctor._id = doctor._id;
          vm.doctorref = doctor._id;
          vm.asyncSelected = doctor.short;
          $log.info('vm.doctor before parentsave: ', vm.doctor);
          if (angular.isDefined(vm.parentsave) && angular.isFunction(vm.parentsave)) {
            vm.parentsave({ doctor: vm.doctor });
          } else {
            vm.doctor.$save();
          }
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead doctor search backend query
      function getDoctors(val) {
        return Doctor.$searchahead({
          query: val,
          fields: ['lastname', 'firstname', 'institute', 'speciality']
        }).$asPromise().then(function (response) {
          return response.map(function (doctor) {
            var fname = DoctorHelper.fname(doctor);
            doctor.fname = fname;
            delete vm.error;
            return doctor;
          });
        });
      }

      // typeahead doctor search action
      function showdoctor($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.doctor = $model;
        vm.doctorref = $model._id;
        delete vm.asyncSelected;
        if (vm.editinplace === true || vm.editinplace === 'true') {
          vm.doctor = $model;
          vm.doctorref = $model._id;
          vm.showedit = true;
        } else {
          vm.doctor = $model;
          var doctorresult = {};
          doctorresult._id = vm.doctor._id;
          doctorresult.fname = DoctorHelper.fname(vm.doctor);
          doctorresult.fulldoc = vm.doctor;
          vm.parentsave({ doctor: doctorresult });
        }
      }

      function save() {
        if (!angular.equals(vm.doctor, vm.lastdoctor) || !angular.equals(vm.doctorref, vm.lastdoctorref)) {
          vm.lastdoctor = angular.copy(vm.doctor);
          if (angular.isDefined(vm.parentsave) && angular.isFunction(vm.parentsave)) {
            vm.parentsave({ doctor: vm.doctor });
          } else if (angular.isDefined(vm.doctor.$save) && angular.isFunction(vm.doctor.$save)) {
            vm.doctor.$save();
          }
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */

/**
 * Created by lari on 08/06/2017.
 */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.doctor').component('doctornew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="doctornew-component" data-hook="doctornew-component">\n        <h3>Neuen Arzt anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addDoctor()" ng-hide="vm.newdoctor">Neuen Arzt anlegen</div>\n        <div ng-show="vm.newdoctor">\n          <doctorform doctor="vm.newdoctor" parentsave="vm.saveNewDoctor(doctor)" oncancel="vm.cancel()"></doctorform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Arzt erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Arztes wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Arzt konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctor', 'Rlog', function ($log, Doctor, Rlog) {
      var vm = this;
      vm.addDoctor = addDoctor;
      vm.saveNewDoctor = saveNewDoctor;
      vm.cancel = cancel;

      function addDoctor() {
        vm.newdoctor = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewDoctor(doctor) {
        $log.debug('debug: create new doctor: ', doctor);
        delete vm.newdoctor;
        Doctor.$create(doctor).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new doctor failed: ', err);
          Rlog.error('vcutils.doctor', 'doctornew', 'Creation of new doctor failed: ', { error: err, doctor: vm.newdoctor });
        });
      }

      function cancel() {
        delete vm.newdoctor;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */

/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of doctors (patients) to display or load doctors */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.doctor').component('doctorlist', {
    restrict: 'E',
    bindings: {
      doctors: '<?'
    },
    template: '\n        <div class="doctorlist-component" data-hook="doctorlist-component">\n          <table class="table table-striped">\n              <thead>\n              <tr>\n                  <th>Nachname/Institut</th>\n                  <th>Vorname</th>\n                  <th>Spezialisierung</th>\n                  <th>Ort</th>\n                  <th></th>\n              </tr>\n              </thead>\n              <tr ng-repeat="doctor in vm.doctors">\n                  <td>{{doctor.lastname}} {{doctor.institute}} </td>\n                  <td>{{doctor.firstname}}</td>\n                  <td>{{doctor.speciality}}</td>\n                  <td>{{doctor.postcode}} {{doctor.city}}</td>\n                  <td>\n                      <button class="btn btn-primary" ng-click="vm.editDoctor(doctor)">Editeren</button>\n                      <button class="btn btn-danger" ng-click="vm.removeDoctor(doctor)">Löschen</button>\n                  </td>\n              </tr>\n          </table>\n          \n          <div uib-pagination total-items="vm.totalItems"\n                          items-per-page="{{vm.pageSize}}"\n                          max-size="10"\n                          first-text="Erste"\n                          last-text="Letzte"\n                          next-text="N&auml;chste"\n                          previous-text="Vorige"\n                          boundary-links="true"\n                          rotate="false"\n                          ng-model="vm.currentPage"\n                          ng-change="vm.pageChanged()"></div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Doctor', 'DoctorHelper', 'vertxEventBusService', function ($log, $http, Rlog, Doctor, DoctorHelper, vertxEventBusService) {
      var vm = this;
      vm.pageSize = 10;
      vm.currentPage = 1;
      vm.pageChanged = pageChanged;
      vm.removeDoctor = removeDoctor;
      vm.editDoctor = DoctorHelper.editDoctor;

      vm.$onInit = function () {
        // unless doctor list has been passed for test purposes, retrieve doctor list from web
        if (angular.isUndefined(vm.doctors)) {
          // $log.debug('### doctors loading from backend');

          var search = {};
          search.page = vm.currentpage;
          search.query = {};
          search.query.active = true;
          search.options = {};

          if (angular.isDefined(vm.pageSize)) {
            search.options.pagesize = vm.pageSize;
          }

          /*              search.options.fields = {
                          _id: 1,
                          created: 1,
                          speciality: 1,
                          institute: 1,
                          lastname: 1,
                          firstname: 1,
                          titlefront: 1,
                          titleback: 1,
                          address: 1,
                          postcode: 1,
                          city: 1,
                          phone1: 1,
                          phone2: 1,
                          fax: 1,
                          email:1,
                          notes: 1
                        };*/
          var sort = {};
          sort['institute'] = 1;
          sort['lastname'] = 1;

          search.options.sort = sort;

          Doctor.$search(search).$then(function (doctors) {
            vm.doctors = doctors;
            vm.totalItems = doctors.$pageCount;
          });
        }
      }; // $onInit()

      function removeDoctor(doctor) {
        doctor.active = false;
        doctor.$save();
        pageChanged();
      }

      function pageChanged() {
        vm.doctors.$refresh({ page: vm.currentPage }).$then(function (doctors) {
          vm.totalItems = doctors.$pageCount;
        });
      }

      var doctorsUpdateHandler = function doctorsUpdateHandler(message) {
        $log.debug('debug: doctor update received: ', message);
        if (angular.isDefined(vm.doctors)) {
          vm.doctors.$refresh({ page: vm.currentPage }).$then(function (doctors) {
            vm.totalItems = doctors.$pageCount;
            $log.debug('debug: doctorlist refreshed doctors');
          }, function (err) {
            $log.debug('debug: doctorlist refresh doctors failed: ', err);
          });
        }
      };

      vertxEventBusService.on('doctors.update', {}, doctorsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('doctors.update', {}, doctorsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcutils.doctor').component('doctorform', {
    restrict: 'E',
    bindings: {
      doctor: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcutils/doctor/doctorform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'DoctorHelper', function ($log, DoctorHelper) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastdoctor = angular.copy(vm.doctor);
      };

      function save() {
        if (!angular.equals(vm.doctor, vm.lastdoctor)) {
          vm.doctor.fname = DoctorHelper.fname(vm.doctor);
          vm.lastdoctor = angular.copy(vm.doctor);
          vm.parentsave({ doctor: vm.doctor });
        }
      }

      function cancel() {
        vm.doctor = angular.copy(vm.lastdoctor);
        vm.oncancel();
      }

      function zipsave(zip, city) {
        // $log.debug('debug: doctorform zipsave called: ', zip, city);
        vm.doctor.postcode = zip;
        vm.doctor.city = city;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */

'use strict';

(function () {
  'use strict';
  angular.module('vcutils.doctor').component('doctoreditor', {
    restrict: 'E',
    bindings: {
      doctor: '<?',
      doctorid: '<?'
    },
    template: '\n        <doctorform doctor="vm.doctor" parentsave="vm.childsave(doctor)" oncancel="vm.oncancel()"></doctorform>\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Arzt/Institut erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Arztes/Instituts wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Arzt/Institut  konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctor', 'Rlog', '$timeout', function ($log, Doctor, Rlog, $timeout) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.zipsave = zipsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.doctor) || !vm.doctor.hasOwnProperty('_id')) && angular.isDefined(vm.doctorid)) {
          Doctor.$find(vm.doctorid).$then(function (doctor) {
            vm.doctor = doctor;
          }, function (err) {
            $log.error('doctor not found, id: ', vm.doctorid, err);
            Rlog.error('doctor', 'doctoreditor', 'doctor not found', { _id: vm.doctorid, error: err });
          });
        }
      };

      function childsave(doctor) {
        // vm.doctor = angular.copy(doctor);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in doctor) {
          if (doctor.hasOwnProperty(key)) {
            vm.doctor[key] = doctor[key];
          }
        }
        vm.save();
      }

      function zipsave(zip, city) {
        vm.doctor.postcode = zip;
        vm.doctor.city = city;
        vm.save();
      }

      function save() {
        // Create formatted name string for use with doctorsearch box
        if (angular.isString(vm.doctor.lastname) && !angular.isString(vm.doctor.institute)) {
          vm.doctor.fname = vm.doctor.titlefront + ' ' + vm.doctor.firstname + ' ' + vm.doctor.lastname + ', ' + vm.doctor.city;
        }
        if (!angular.isString(vm.doctor.lastname) && angular.isString(vm.doctor.institute)) {
          vm.doctor.fname = vm.doctor.institute + ', ' + vm.doctor.city;
        }
        if (angular.isString(vm.doctor.lastname) && angular.isString(vm.doctor.institute)) {
          vm.doctor.fname = vm.doctor.institute + ', ' + vm.doctor.titlefront + ' ' + vm.doctor.lastname + ', ' + vm.doctor.city;
        }

        if (vm.doctor.$hasPendingActions()) {
          vm.doctor.$cancel();
          vm.doctor.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            reset('saved');
            $log.error('saving of doctor failed: ', err);
            Rlog.error('vcutils.doctor', 'doctoreditor', 'Saving of doctor failed: ', { error: err, doctorid: vm.doctor._id });
          });
        } else {
          vm.doctor.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            reset('saved');
            $log.error('saving of doctor failed: ', err);
            Rlog.error('vcutils.doctor', 'doctoreditor', 'Saving of doctor failed: ', { error: err, doctorid: vm.doctor._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
        reset('save');
      }

      function reset(rvar) {
        $timeout(function () {
          delete vm[rvar];
        }, 3500);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */

'use strict';

(function () {
  'use strict';

  angular.module('vcutils.doctor').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcutilsdoctor', {
      url: '/vcutilsdoctor',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;doctorsearch doctor="" doctorref="" editinplace="true"&gt;</tt></h3><div ui-view="doctorsearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctorsearch doctor="" doctorref="" parentsave=""&gt;</tt></h3><div ui-view="doctorsearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctoreditor doctor="" mode="" onClose=""&gt;</tt></h3><div ui-view="doctoreditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctornew&gt;</tt></h3><div ui-view="doctornewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctorlist doctors="?"&gt;</tt></h3><div ui-view="doctorlistview"></div>\n            '
        }
      },
      onEnter: ['$log', function ($log) {
        $log.debug('debug/routes - playground.vcutilsdoctor entered');
      }]
    });

    $stateProvider.state('playground.vcutilsdoctor.allcomponents', {
      url: '/allcomponents',
      resolve: {
        doctor: function doctor() {
          return '';
        },
        doctorref: function doctorref() {
          return '';
        },
        somedoctor: ['Doctor', function (Doctor) {
          return Doctor.$find('570a73678dd4bd20cb031193');
        }],
        alldoctors: ['Doctor', function (Doctor) {
          return Doctor.$search({ active: true });
        }],
        parentsavesearch: function parentsavesearch() {
          return function (doctor, doctorref) {
            console.log('debug: dummy parentsave called for doctorsearch with: ', doctor, doctorref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'doctorsearchview@playground.vcutilsdoctor': {
          component: 'doctorsearch',
          bindings: {
            doctor: 'doctor',
            doctorref: 'doctorref',
            editinplace: 'eip'
          }
        },
        'doctorsearchview2@playground.vcutilsdoctor': {
          component: 'doctorsearch',
          bindings: {
            doctor: 'doctor',
            doctorref: 'doctorref',
            parentsave: 'parentsavesearch'
          }
        },
        'doctoreditview@playground.vcutilsdoctor': {
          component: 'doctoreditor',
          bindings: {
            doctor: 'somedoctor'
          }
        },
        'doctornewview@playground.vcutilsdoctor': {
          component: 'doctornew',
          bindings: {}
        },
        'doctorlistview@playground.vcutilsdoctor': {
          component: 'doctorlist',
          bindings: {}
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcutilsdoctor.allcomponents entered');
      }
    });
  } // all routes
})();
/* global angular, moment */

'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name doctor.factory:DoctorHelper
   *
   * @description
   *
   */
  angular.module('vcutils.doctor').factory('DoctorHelper', DoctorHelper);

  DoctorHelper.$inject = ['Doctor', '$uibModal', '$log', 'Rlog'];

  function DoctorHelper(Doctor, $uibModal, $log, Rlog) {
    var DoctorHelperBase = {};

    DoctorHelperBase.editDoctor = editDoctor;
    DoctorHelperBase.addDoctor = addDoctor;
    DoctorHelperBase.fname = fname;

    function addDoctor(success, error) {
      // noinspection JSUnresolvedVariable
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctorform doctor="doctoraCtrl.doctor" parentsave="doctoraCtrl.childsave(doctor)" oncancel="doctoraCtrl.cancel()"></doctornew></div>',
        controllerAs: 'doctoraCtrl',
        controller: ['doctor', function () {
          var vm = this;
          vm.doctor = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doctor) {
            Doctor.$create(doctor).$then(function (newdoctor) {
              vm.created = true;
              success(newdoctor);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ doctor-helper.addDoctor: ', err);
              Rlog.error('vcutils.doctor', 'doctor-helper.addDoctor', 'Creation of new SV failed: ', { error: err, doctor: doctor });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          doctor: function doctor() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editDoctor(ldoctor) {
      // noinspection JSUnresolvedVariable
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctorform doctor="doctoreCtrl.doctor" parentsave="doctoreCtrl.childsave(doctor)" oncancel="doctoreCtrl.cancel()"></doctorform></div>',
        controllerAs: 'doctoreCtrl',
        controller: ['doctor', function (sdoctor) {
          var vm = this;
          vm.doctor = sdoctor;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doctor) {
            // vm.doctor = angular.copy(doctor);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in doctor) {
              if (doctor.hasOwnProperty(key)) {
                vm.doctor[key] = doctor[key];
              }
            }

            if (vm.doctor.$hasPendingActions()) {
              vm.doctor.$cancel();
              vm.doctor.$save();
              cancel();
            } else {
              vm.doctor.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          doctor: function doctor() {
            return ldoctor;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function fname(doc) {
      $log.debug('input doc: ', doc);
      // noinspection JSUnresolvedVariable
      if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.institute) && angular.isString(doc.speciality)) {
        // noinspection JSUnresolvedVariable
        doc.text = doc.firstname + ' ' + doc.lastname + ', ' + doc.institute + ', ' + doc.speciality;
        $log.debug('var 1 doc: ', doc.text);
      }
      // noinspection JSUnresolvedVariable
      else if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.speciality)) {
          // noinspection JSUnresolvedVariable
          doc.text = doc.firstname + ' ' + doc.lastname + ', ' + doc.speciality;
          $log.debug('var 2 doc: ', doc.text);
        }
        // noinspection JSUnresolvedVariable
        else if (angular.isString(doc.firstname) && angular.isString(doc.lastname) && angular.isString(doc.institute)) {
            // noinspection JSUnresolvedVariable
            doc.text = doc.fistname + ', ' + doc.lastname + ', ' + doc.institute;
            $log.debug('var 3 doc: ', doc.text);
          }
          // noinspection JSUnresolvedVariable
          else if (angular.isString(doc.institute) && angular.isString(doc.speciality)) {
              // noinspection JSUnresolvedVariable
              doc.text = doc.institute + ', ' + doc.speciality;
              $log.debug('var 4 doc: ', doc.text);
            }

      return doc.text;
    }

    return DoctorHelperBase;
  }
})();
/* global angular, moment */

/**
 * Created by lari on 07/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcutils.doctor.factory:Doctor
   *
   * @description
   *
   */
  angular.module('vcutils.doctor').factory('Doctor', Doctor);

  Doctor.$inject = ['restmod'];
  function Doctor(restmod) {
    return restmod.model('/routes/doctors', 'PagedModel').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/doctors/docahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcasset.vcsafe
   * @description
   *
   */
  angular.module('vcuser.vcuser', []);
})();
'use strict';

(function () {
    'use strict';
    angular.module('vcuser.vcuser').component('usersearch', {
        restrict: 'E',
        bindings: {
            user: '<',
            userref: '<',
            parentsave: '&?',
            editinplace: '@?',
            ti: '@?'
        },
        template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Benutzer"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showuser($item, $model, $label)"\n                   uib-typeahead="user as user.text for user in vm.getUsers($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keinen User gefunden\n          <span class="btn btn-success" ng-click="vm.addUser()" ng-hide="vm.error">Neuen User eingeben</span>\n          <span ng-click="vm.addUser()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> User konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <usereditor user="vm.user"></usereditor>\n        </div>\n        \n        \n      ',
        controllerAs: 'vm',
        controller: ['$log', 'User', 'UserHelper', function ($log, User, UserHelper) {
            var vm = this;
            vm.save = save;
            vm.showuser = showuser;

            vm.getUsers = getUsers;
            // vm.addUser = UserHelper.addUser;
            vm.addUser = addUser;
            vm.editUser = UserHelper.editUser;

            vm.$onInit = function () {
                vm.newuser = {};

                if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
                    vm.editinplace = true;
                }

                $log.debug('debug - editinplace', vm.editinplace);

                if (angular.isUndefined(vm.ti)) {
                    vm.ti = 0;
                    vm.tabi = 0;
                }
                if (angular.isString(vm.ti)) {
                    vm.tabi = parseInt(vm.ti, 10);
                } else {
                    vm.tabi = 0;
                }
                vm.lastuser = angular.copy(vm.userresult);
                vm.lastuserref = angular.copy(vm.userref);
            };

            function addUser() {
                $log.debug('debug - usersearch addUser called');
                UserHelper.addUser(function (user) {
                    $log.debug('debug: handle newly create user');
                    vm.user = {};
                    vm.user.username = user.username;
                    vm.user.realName = user.realName;
                    vm.user._id = user._id;
                    vm.userref = user._id;
                    vm.user.email = user.email;
                    vm.user.tel = user.tel;
                    vm.asyncSelected = user.short;
                    vm.parentsave({ user: vm.user, userref: vm.userref });
                }, function (err) {
                    vm.error = true;
                    $log.error(err);
                });
            }

            // typeahead user search backend query
            function getUsers(val) {
                return User.$searchahead({
                    query: val,
                    fields: ['username', 'realName', 'email', 'tel']
                }).$asPromise().then(function (response) {
                    return response.map(function (user) {
                        user.text = user.username + ', ';
                        if (user.realName != null) user.text += user.realName + ': ';
                        if (user.email != null) user.text += user.email + ', ';
                        if (user.tel != null) user.text += user.tel;
                        delete vm.error;
                        return user;
                    });
                });
            }

            // typeahead user search action
            function showuser($item, $model, $label) {
                /* jshint unused:false */
                /* eslint "no-unused-lets": [2, {"args": "none"}] */
                vm.user = $model;
                vm.userref = $model._id;
                delete vm.asyncSelected;
                if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
                    vm.editinplace = true;
                }
                $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
                if (vm.editinplace === true) {
                    vm.user = $model;
                    vm.userref = $model._id;
                    $log.debug('debug - usersearch editinplace');
                } else {
                    vm.user = {};
                    vm.user.username = $model.username;
                    vm.user.realName = $model.realName;
                    vm.user._id = $model._id;
                    vm.userref = $model._id;
                    vm.user.email = $model.email;
                    vm.user.tel = $model.tel;
                    vm.parentsave({ user: vm.user, userref: vm.userref });
                    $log.debug('debug - usersearch do not  editinplace', vm.parentsave);
                }
            }

            function save() {
                if (!angular.equals(vm.user, vm.lastuser) || !angular.equals(vm.userref, vm.lastuserref)) {
                    vm.lastuser = angular.copy(vm.user);
                    vm.lastuserref = angular.copy(vm.userref);
                    vm.parentsave({ user: vm.user, userref: vm.userref });
                }
            }
        }] // controller
    }); // component

    // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcuser.vcuser').component('usernew', {
    restrict: 'E',
    bindings: {
      parentsave: '&',
      roles: '<?'
    },
    template: '\n      <div class="usernew-component" data-hook="usernew-component">\n        <h3>Neuen Benutzer anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addUser()" ng-hide="vm.newuser">Neuen Benutzer anlegen</div>\n        <div ng-show="vm.newuser">\n          <userform user="vm.newuser" parentsave="vm.saveNewUser(user)" oncancel="vm.cancel()" roles="vm.roles"></userform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Benutzer erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen Benutzers wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Benutzer konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n        <div ng-show="vm.userexists === true" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Benutzer konnte nicht angelegt werden, weil dieser Benutzernamen bereits exisitiert. \n          </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'User', 'Rlog', '$timeout', function ($log, User, Rlog, $timeout) {
      var vm = this;
      vm.addUser = addUser;
      vm.saveNewUser = saveNewUser;
      vm.cancel = cancel;

      vm.$onInit = function () {
        if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
          vm.roles = [{ role: 'admin', label: 'Administrator' }, { role: 'user', label: 'Anwender' }];
        }
      };

      function addUser() {
        vm.newuser = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewUser(user) {
        $log.debug('debug: create new user: ', user);
        delete vm.newuser;
        User.$create(user).$then(function (result) {
          vm.created = true;
          reset('created');
          vm.parentsave({ user: result });
        }, function (err) {
          $log.debug('error response: ', err.$response.status);
          if (err.$response.status === 403) {
            vm.userexists = true;
          } else {
            vm.created = false;
            reset('created');
            $log.error('Creation of new user failed: ', err);
            Rlog.error('vcutils.user', 'usernew', 'Creation of new user failed: ', {
              user: vm.newuser.username
            });
          }
        });
      }

      function cancel() {
        delete vm.newuser;
        vm.canceled = true;
        reset('canceled');
      }

      function reset(rvar) {
        $timeout(function () {
          delete vm[rvar];
        }, 3500);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of users (patients) to display or load users */

'use strict';

(function () {
  'use strict';
  angular.module('vcuser.vcuser').component('userlist', {
    restrict: 'E',
    bindings: {
      users: '<?',
      roles: '<'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Username</th>\n            <th>Vor- und Nachname</th>\n            <th>E-Mail</th>\n            <th>Telefonnummer</th>\n            <th>Rolle</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="user in vm.users">\n            <td>{{user.username}}</td>\n            <td>{{user.realName}}</td>\n            <td>{{user.email}}</td>\n            <td>{{user.tel}}</td>\n            <td ng-bind="vm.getRoleLabel(user)"></td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editUser(user, vm.roles)" uib-tooltip="Editieren"><i class="fa fa-edit"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeUser(user)" uib-tooltip="Löschen"><i class="fa fa-remove"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'User', 'UserHelper', 'vertxEventBusService', function ($log, $http, Rlog, User, UserHelper, vertxEventBusService) {
      var vm = this;
      vm.editUser = UserHelper.editUser;
      vm.removeUser = removeUser;
      vm.getRoleLabel = getRoleLabel;

      vm.$onInit = function () {
        if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
          vm.roles = [{ role: 'admin', label: 'Administrator' }, { role: 'user', label: 'Anwender' }];
        }
        // unless users list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.users)) {
          vm.users = User.$search({ active: true });
        }
      }; // $onInit()

      function removeUser(user) {
        user.active = false;
        user.$save();
      }

      function getRoleLabel(user) {
        if (angular.isDefined(vm.roles)) {
          for (var i = 0; i < vm.roles.length; i++) {
            if (vm.roles[i].role === user.roles[0]) {
              return vm.roles[i].label;
            }
          }
        }
      }

      var usersUpdateHandler = function usersUpdateHandler(message) {
        $log.debug('debug: user update received: ', message);
        // let messages = message.split(':');
        if (angular.isDefined(vm.users)) {
          vm.users.$refresh().$then(function () {
            $log.debug('debug: userlist refreshed users');
          }, function (error) {
            $log.debug('debug: userlist refresh users failed: ', error);
          });
        }
      };

      vertxEventBusService.on('users.update', {}, usersUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('users.update', {}, usersUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcuser.vcuser').component('userform', {
    restrict: 'E',
    bindings: {
      user: '<',
      parentsave: '&',
      oncancel: '&',
      roles: '<?'
    },
    templateUrl: 'vcuser/vcuser/userform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastuser = angular.copy(vm.user);
        if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
          vm.roles = [{ role: 'admin', label: 'Administrator' }, { role: 'user', label: 'Anwender' }];
        }
      };

      function save() {
        $log.debug('user role: ', vm.user.role);
        if (angular.isDefined(vm.user.role) && angular.isString(vm.user.role) && vm.user.role.length > 0) {
          vm.user.roles = [vm.user.role];
        }
        if (!angular.equals(vm.user, vm.lastuser)) {
          vm.lastuser = angular.copy(vm.user);
          vm.parentsave({ user: vm.user });
        }
      }

      function cancel() {
        vm.user = angular.copy(vm.lastuser);
        vm.oncancel();
      }

      /*          function zipsave (zip, city) {
       $log.debug('debug: userform zipsave called: ', zip, city);
       // vm.user.postcode = zip;
       // vm.user.city = city;
       }*/
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcuser.vcuser').component('usereditor', {
    restrict: 'E',
    bindings: {
      user: '<?',
      userid: '<?',
      roles: '<?'
    },
    template: '\n        <userform user="vm.user" parentsave="vm.childsave(user)" oncancel="vm.oncancel()" roles="vm.roles"></userform>\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> User erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen User wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> User konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'User', 'Rlog', '$timeout', function ($log, User, Rlog, $timeout) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
          vm.roles = [{ role: 'admin', label: 'Administrator' }, { role: 'user', label: 'Anwender' }];
        }
        if ((angular.isUndefined(vm.user) || !vm.user.hasOwnProperty('_id')) && angular.isDefined(vm.userid)) {
          User.$find(vm.userid).$then(function (user) {
            console.log("user found: ");
            console.log(user);
            vm.user = user;
          }, function (err) {
            $log.error('user not found, id: ', vm.userid);
            Rlog.error('user', 'usereditor', 'user not found', { _id: vm.userid });
          });
        }
      };

      function childsave(user) {
        // vm.user = angular.copy(user);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in user) {
          if (user.hasOwnProperty(key)) {
            vm.user[key] = user[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.user.$hasPendingActions()) {
          vm.user.$cancel();
          vm.user.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            reset('saved');
            $log.error('saving of user failed: ', err);
            Rlog.error('vcutils.user', 'usereditor', 'Saving of user failed: ', { userid: vm.user._id });
          });
        } else {
          vm.user.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            reset('saved');
            $log.error('saving of user failed: ', err);
            Rlog.error('vcutils.user', 'usereditor', 'Saving of user failed: ', { userid: vm.user._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
        reset('canceled');
      }

      function reset(rvar) {
        $timeout(function () {
          delete vm[rvar];
        }, 3500);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
    'use strict';

    angular.module('vcuser.vcuser').config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider.state('playground.vcuseruser', {
            url: '/vcuseruser',
            views: {
                'playgroundmain@playground': {
                    template: '\n              <h3 class="alert alert-info"><tt>&lt;usersearch user="" userref="" editinplace="true"&gt;</tt></h3><div ui-view="usersearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;usersearch user="" userref="" parentsave=""&gt;</tt></h3><div ui-view="usersearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;usereditor user="" mode="" onClose=""&gt;</tt></h3><div ui-view="usereditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;usernew&gt;</tt></h3><div ui-view="usernewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;userlist users="?"&gt;</tt></h3><div ui-view="userlistview"></div>\n            '
                }
            },
            onEnter: function onEnter($log) {
                $log.debug('debug/routes - playground.vcuservcuser entered');
            }
        });

        $stateProvider.state('playground.vcuseruser.allcomponents', {
            url: '/allcomponents',
            resolve: {
                user: function user() {
                    return '';
                },
                userref: function userref() {
                    return '';
                },
                roles: function roles() {
                    return [{ role: 'tech', label: 'Techniker' }, { role: 'extern', label: 'Externer Mitabeiter' }, { role: 'admin', label: 'Administrator' }];
                },
                someuser: ['User', function (User) {
                    return User.$find('5980850517c1652dc7195b2f');
                }],
                allusers: ['User', function (User) {
                    return User.$search({ active: true });
                }],
                parentsavesearch: function parentsavesearch() {
                    return function (user, userref) {
                        console.log('debug: dummy parentsave called for usersearch with: ', user, userref);
                    };
                },
                eip: function eip() {
                    return true;
                }
            },
            views: {
                // When `fooState.barState` is active, `fooComponent`
                // is loaded into the <ui-view name='content' />
                // which was created by `fooState`.
                // The component's `foo` input receives `fooData` resolve
                'usersearchview@playground.vcuseruser': {
                    component: 'usersearch',
                    bindings: {
                        user: 'user',
                        userref: 'userref',
                        editinplace: 'eip'
                    }
                },
                'usersearchview2@playground.vcuseruser': {
                    component: 'usersearch',
                    bindings: {
                        user: 'user',
                        userref: 'userref',
                        parentsave: 'parentsavesearch'
                    }
                },
                'usereditview@playground.vcuseruser': {
                    component: 'usereditor',
                    bindings: {
                        user: 'someuser'
                    }
                },
                'usernewview@playground.vcuseruser': {
                    component: 'usernew',
                    bindings: {}
                },
                'userlistview@playground.vcuseruser': {
                    component: 'userlist',
                    bindings: {
                        users: 'allusers'
                    }
                }
            },
            onEnter: function onEnter() {
                console.log('playground.vcuseruser.allcomponents entered');
            }
        });
    } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcuser.vcuser.factory:UserHelper
   *
   * @description
   *
   */
  angular.module('vcuser.vcuser').factory('UserHelper', UserHelper);

  UserHelper.$inject = ['User', '$uibModal', '$log', 'Rlog'];

  function UserHelper(User, $uibModal, $log, Rlog) {
    var UserHelperBase = {};

    UserHelperBase.editUser = editUser;
    UserHelperBase.addUser = addUser;

    function addUser(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><userform user="vm.user" parentsave="vm.childsave(user)" oncancel="vm.cancel()"></usernew></div>',
        controllerAs: 'useraCtrl',
        controller: ['user', function () {
          var vm = this;
          vm.user = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(user) {
            User.$create(user).$then(function (newuser) {
              vm.created = true;
              success(newuser);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ user-helper.addUser: ', err);
              Rlog.error('vcutils.user', 'user-helper.addUser', 'Creation of new user failed: ', {
                user: user
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          user: function user() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editUser(luser, lroles) {
      var dialog = $uibModal.open({
        template: '\n          <div class="modalspacer">\n              <userform user="usereCtrl.user" parentsave="usereCtrl.childsave(user)" oncancel="usereCtrl.cancel()" roles="usereCtrl.roles"></userform>\n          </div>\n        ',
        controllerAs: 'usereCtrl',
        controller: ['user', 'roles', function (luser, lroles) {
          var vm = this;
          vm.user = luser;
          vm.roles = lroles;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(user) {
            // vm.user = angular.copy(user);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in user) {
              if (user.hasOwnProperty(key)) {
                vm.user[key] = user[key];
              }
            }

            if (vm.user.$hasPendingActions()) {
              vm.user.$cancel();
              vm.user.$save();
              cancel();
            } else {
              vm.user.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          user: function user() {
            return luser;
          },
          roles: function roles() {
            return lroles;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return UserHelperBase;
  }
})();
'use strict';

(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name vcuser.user.factory:User
     *
     * @description
     *
     */
    angular.module('vcuser.vcuser').factory('User', User);

    User.$inject = ['restmod'];

    function User(restmod) {
        return restmod.model('/routes/users').mix({
            created: {
                init: function init() {
                    return moment().toISOString();
                }
            },
            active: { init: true },
            $extend: {
                Model: {
                    $searchahead: function $searchahead(_params) {
                        return this.$collection().$decorate({
                            'before-request': function beforeRequest(_req) {
                                _req.method = 'GET';
                                _req.url = '/routes/user/searchahead';
                            }
                        }, function () {
                            return this.$fetch(_params);
                        });
                    },
                    $searchBy: function $searchBy(key, val) {
                        var tmp = {};
                        tmp[key] = val;
                        return this.$search({ query: tmp });
                    }
                } // Model
            } // extend
        });
    }

    // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcasset.vcsafe
   * @description
   *
   */
  angular.module('vcuser.vclogin', []);
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcuser.vclogin').component('loginform', {
    restrict: 'E',
    bindings: {
      dialog: '<',
      url: '<'
    },
    templateUrl: 'vcuser/vclogin/loginform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', '$cookies', '$window', '$state', function ($log, $http, $cookies, $window, $state) {
      var vm = this;
      vm.sendcreds = sendcreds;

      function sendcreds() {
        $http.post('/routes/login', { username: vm.login.username, password: vm.login.password }).then(function (user) {
          $log.debug('user', user);
          $cookies.put('username', vm.login.username);
          $cookies.put('userfull', user.data.realName);
          $cookies.put('userid', user.data._id);
          $cookies.put('userroles', user.data.roles);
          $log.debug('redirect url: ', vm.url);
          $log.debug('dialog: ', vm.dialog);
          vm.dialog.close();
          if (angular.isDefined(vm.url) && angular.isString(vm.url) && vm.url.length > 0 && vm.url !== '/login') {
            $log.debug('$window: ', $window.location);
            $window.location.href = '#' + vm.url;
            // $location.url(vm.url);
            $window.location.reload();
            //
            $log.debug('after login redirect active $state.$current: ', $state.$current);
            $state.go($state.$current, null, { reload: true });
            // $state.go('home', null, {reload: true});
          } else {
              $state.go('home', null, { reload: true });
            }
        }, function () {
          $log.debug('login error');
          vm.login.username = '';
          vm.login.password = '';
          vm.error = true;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
    'use strict';

    angular.module('vcuser.vclogin').config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        // show modal for login
        $stateProvider.state('login', {
            url: '/login',
            params: { url: {} },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                console.log('urls in onEnter: ', $stateParams.url);
                $uibModal.open({
                    template: '<div class="modalspacer"><loginform url="vm.url" dialog="vm.$uibModalInstance"></loginform></div>',
                    controllerAs: 'vm',
                    controller: ['url', '$uibModalInstance', function (url, $uibModalInstance) {
                        console.log('$stateParams in uib controller: ', url);
                        var vm = this;
                        vm.url = url;
                        vm.$uibModalInstance = $uibModalInstance;
                    }],

                    resolve: {
                        url: function url() {
                            console.log('url in resolve: ', $stateParams.url);
                            return $stateParams.url;
                        }
                    }
                });
            }]
        });

        $stateProvider.state('logout', {
            url: '/logout',
            onEnter: ['$state', '$http', function ($state, $http) {

                $http.get('/routes/logout').then(function () {
                    $state.go('login');
                });
            }]
        });
    }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vcunicat
   * @description
   *
   */
  angular.module('vcfinance.unicat', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.unicat').component('unicatsearch', {
    restrict: 'E',
    bindings: {
      unicat: '<',
      unicatref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   autofocus\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showunicat($item, $model, $label)"\n                   uib-typeahead="unicat as unicat.text for unicat in vm.getUnicats($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addUnicat()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addUnicat()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <unicateditor unicat="vm.unicat"></unicateditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Unicat', 'UnicatHelper', function ($log, Unicat, UnicatHelper) {
      var vm = this;
      vm.save = save;
      vm.showunicat = showunicat;

      vm.getUnicats = getUnicats;
      // vm.addUnicat = UnicatHelper.addUnicat;
      vm.addUnicat = addUnicat;
      vm.editUnicat = UnicatHelper.editUnicat;

      vm.$onInit = function () {
        vm.newunicat = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastunicat = angular.copy(vm.unicatresult);
        vm.lastunicatref = angular.copy(vm.unicatref);
      };

      function addUnicat() {
        $log.debug('debug - unicatsearch addUnicat called');
        UnicatHelper.addUnicat(function (unicat) {
          $log.debug('debug: handle newly create unicat');
          vm.unicat = {};
          vm.unicat.name = unicat.name;
          vm.unicat.short = unicat.short;
          vm.unicat._id = unicat._id;
          vm.unicatref = unicat._id;
          vm.asyncSelected = unicat.short;
          vm.parentsave({ unicat: vm.unicat, unicatref: vm.unicatref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead unicat search backend query
      function getUnicats(val) {
        // return Unicatahead.$search({query: val}).$asPromise().then(function (response) {
        return Unicat.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (unicat) {
            unicat.text = unicat.short;
            delete vm.error;
            return unicat;
          });
        });
      }

      // typeahead unicat search action
      function showunicat($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.unicat = $model;
        vm.unicatref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.unicat = $model;
          vm.unicatref = $model._id;
          $log.debug('debug - unicatsearch editinplace');
        } else {
          vm.unicat = {};
          vm.unicat.name = $model.name;
          vm.unicat.short = $model.short;
          vm.unicat._id = $model._id;
          vm.unicatref = $model._id;
          vm.parentsave({ unicat: vm.unicat, unicatref: vm.unicatref });
          $log.debug('debug - unicatsearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.unicat, vm.lastunicat) || !angular.equals(vm.unicatref, vm.lastunicatref)) {
          vm.lastunicat = angular.copy(vm.unicat);
          vm.lastunicatref = angular.copy(vm.unicatref);
          vm.parentsave({ unicat: vm.unicat, unicatref: vm.unicatref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.unicat').component('unicatnew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="unicatnew-component" data-hook="unicatnew-component">\n        <h3>Neue/s unicat anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addUnicat()" ng-hide="vm.newunicat">Neue/s unicat anlegen</div>\n        <div ng-show="vm.newunicat">\n          <unicatform unicat="vm.newunicat" parentsave="vm.saveNewUnicat(unicat)" oncancel="vm.cancel()"></unicatform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> unicat erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen unicat wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> unicat konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Unicat', 'Rlog', function ($log, Unicat, Rlog) {
      var vm = this;
      vm.addUnicat = addUnicat;
      vm.saveNewUnicat = saveNewUnicat;
      vm.cancel = cancel;

      function addUnicat() {
        vm.newunicat = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewUnicat(unicat) {
        $log.debug('debug: create new unicat: ', unicat);
        delete vm.newunicat;
        Unicat.$create(unicat).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new unicat failed: ', err);
          Rlog.error('vcutils.unicat', 'unicatnew', 'Creation of new unicat failed: ', { error: err, unicat: vm.newunicat });
        });
      }

      function cancel() {
        delete vm.newunicat;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of unicats (patients) to display or load unicats */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.unicat').component('unicatlist', {
    restrict: 'E',
    bindings: {},
    template: '\n        <h2 id="toc">Inhaltsverzeichnis</h2>\n        <div class="row" ng-repeat="chap in vm.tree.chapters">\n          <div class="col-xs-12">\n            <h3>{{chap._id}}</h3>\n            <div class="threecol">\n              <div ng-repeat="cat in chap.categories" class="keeptogether"><a ng-click="vm.goto(cat.categorie)">{{cat.categorie}}</a>\n                <ul>\n                    <li ng-repeat="grp in cat.groups"><a ng-click="vm.goto(grp.group)">{{grp.group}}</a></li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!--<div class="panel-heading"><h3>{{cat.categorie}}</h3></div>-->\n          <div class="row" ng-repeat="chap in vm.tree.chapters">\n            <div class="col-xs-12">\n            <h2>\n                <span class="pull-left"> Kapitel {{chap._id}}</span>\n                <span class="pull-right"><i class="fa fa-list" uib-tooltip="Inhaltverzeichnis" ng-click="vm.goto(\'toc\')"></i></span>\n                <div class="clearfix"></div>\n            </h2>\n            <div class="panel panel-info" ng-repeat="cat in chap.categories">\n              <div class="panel-heading">\n                <h3 id="{{cat.categorie}}">\n                   <span class="pull-left">{{cat.categorie}}</span>\n                   <span class="pull-right"><i class="fa fa-list"  ng-click="vm.goto(\'toc\')" uib-tooltip="Inhaltverzeichnis"></i></span>\n                   <div class="clearfix"></div>\n                </h3>\n              </div>\n              <div class="panel-body">\n                <div ng-repeat="grp in cat.groups">\n                  <div class="grptitle">\n                    <h3  id="{{grp.group}}">\n                        <span class="pull-left">{{grp.group}}</span>\n                        <span class="pull-right"><i class="fa fa-list"  ng-click="vm.goto(\'toc\')" uib-tooltip="Inhaltverzeichnis"></i></span>\n                        <div class="clearfix"></div>\n                    </h3>\n                  </div>\n                  <div ng-repeat="e in grp.entries ">\n                    <h4><a ng-click="vm.toggleedit(e)"> <tt>{{e}} - </tt>{{vm.elu[e].name}}</a></h4>\n                    <div ng-show="vm.showedit[e]">\n                       <unicateditor entry="vm.elu[e]"></unicateditor>\n                    </div>\n                  </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Unicat', 'UnicatHelper', 'vertxEventBusService', '$location', '$anchorScroll', function ($log, $http, Rlog, Unicat, UnicatHelper, vertxEventBusService, $location, $anchorScroll) {
      var vm = this;
      vm.removeEntry = removeEntry;
      vm.goto = gotoanchor;
      vm.toggleedit = toggleedit;
      vm.$onInit = function () {

        Unicat.$find('tree').$then(function (tree) {
          vm.tree = tree;
        }, function (err) {
          $log.error('unicat tree lookup failed');
          Rlog.error('unicat', 'unicateditor', 'unicat tree lookup failed', {});
        });

        Unicat.$search({ type: 'entry' }).$then(function (unicat) {
          vm.unicat = unicat;
          $log.debug('***** unicat: ', unicat);
          // generate entry lookup table by sprnum
          vm.elu = {};
          vm.showedit = {};
          for (var i = 0; i < unicat.length; i++) {
            vm.elu[unicat[i].sprnum] = unicat[i];
            vm.showedit[unicat[i].sprnum] = false;
          }
        }, function (err) {
          $log.error('unicat not found');
          Rlog.error('unicat', 'unicateditor', 'unicat not found', {});
        });
      }; // $onInit()

      function gotoanchor(target) {
        $location.hash(target);
        $anchorScroll();
      }

      function toggleedit(entry) {
        vm.showedit[entry] = !vm.showedit[entry];
      }

      function removeEntry(unicat) {
        unicat.active = false;
        unicat.$save();
      }

      var unicatUpdateHandler = function unicatUpdateHandler(message) {
        $log.debug('debug: unicat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.unicat)) {
          vm.unicats.$refresh().$then(function () {
            $log.debug('debug: unicatlist refreshed unicat');
          }, function (error) {
            $log.debug('debug: unicatlist refresh unicat failed: ', error);
          });
        }
      };

      vertxEventBusService.on('unicat.update', {}, unicatUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('unicat.update', {}, unicatUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.unicat').component('unicatform', {
    restrict: 'E',
    bindings: {
      unicat: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcfinance/unicat/unicatform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastunicat = angular.copy(vm.unicat);
      };

      function save() {
        if (!angular.equals(vm.unicat, vm.lastunicat)) {
          vm.lastunicat = angular.copy(vm.unicat);
          vm.parentsave({ unicat: vm.unicat });
        }
      }

      function cancel() {
        vm.unicat = angular.copy(vm.lastunicat);
        vm.oncancel();
      }

      /*          function zipsave (zip, city) {
                  $log.debug('debug: unicatform zipsave called: ', zip, city);
                  // vm.unicat.postcode = zip;
                  // vm.unicat.city = city;
                }*/
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.unicat').component('unicateditor', {
    restrict: 'E',
    bindings: {
      entry: '='
    },
    templateUrl: 'vcfinance/unicat/unicateditor-component.tpl.html',

    controllerAs: 'vm',
    controller: ['$log', 'Unicat', 'Rlog', function ($log, Unicat, Rlog) {
      var vm = this;
      vm.save = save;
      // vm.oncancel = oncancel;

      vm.$onInit = function () {};

      // save directly inside editor, unicat editing is fringe sscenario for experienced users
      function save(cat) {
        if (cat.$hasPendingActions()) {
          cat.$cancel();
          cat.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of unicat failed: ', err);
            Rlog.error('vcutils.unicat', 'unicateditor', 'Saving of unicat failed: ', { unicatid: cat._id });
          });
        } else {
          cat.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of unicat failed: ', err);
            Rlog.error('vcutils.unicat', 'unicateditor', 'Saving of unicat failed: ', { unicatid: cat._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcfinance.unicat').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcfinanceunicat', {
      url: '/financeunicat',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;unicateditor unicat=""&gt;</tt></h3><div ui-view="unicateditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;unicatlist&gt;</tt></h3><div ui-view="unicatlistview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vcfinanceunicat entered');
      }
    });

    $stateProvider.state('playground.vcfinanceunicat.allcomponents', {
      url: '/allcomponents',
      resolve: {},
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve

        'unicateditview@playground.vcfinanceunicat': {
          component: 'unicateditor',
          bindings: {
            unicat: 'someunicat'
          }
        },
        'unicatlistview@playground.vcfinanceunicat': {
          component: 'unicatlist',
          bindings: {}
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcfinanceunicat.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.vcunicat.factory:UnicatHelper
   *
   * @description
   *
   */
  angular.module('vcfinance.unicat').factory('UnicatHelper', UnicatHelper);

  UnicatHelper.$inject = ['Unicat', '$uibModal', '$log', 'Rlog'];

  function UnicatHelper(Unicat, $uibModal, $log, Rlog) {
    var UnicatHelperBase = {};

    UnicatHelperBase.editUnicat = editUnicat;
    UnicatHelperBase.addUnicat = addUnicat;

    function addUnicat(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><unicatform unicat="vm.unicat" parentsave="vm.childsave(unicat)" oncancel="vm.cancel()"></unicatnew></div>',
        controllerAs: 'unicataCtrl',
        controller: ['unicat', function () {
          var vm = this;
          vm.unicat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(unicat) {
            Unicat.$create(unicat).$then(function (newunicat) {
              vm.created = true;
              success(newunicat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ unicat-helper.addUnicat: ', err);
              Rlog.error('vcutils.unicat', 'unicat-helper.addUnicat', 'Creation of new SV failed: ', { error: err, unicat: unicat });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          unicat: function unicat() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editUnicat(lunicat) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><unicatform unicat="unicateCtrl.unicat" parentsave="unicateCtrl.childsave(unicat)" oncancel="unicateCtrl.cancel()"></unicatform></div>',
        controllerAs: 'unicateCtrl',
        controller: ['unicat', function (sunicat) {
          var vm = this;
          vm.unicat = sunicat;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(unicat) {
            // vm.unicat = angular.copy(unicat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in unicat) {
              if (unicat.hasOwnProperty(key)) {
                vm.unicat[key] = unicat[key];
              }
            }

            if (vm.unicat.$hasPendingActions()) {
              vm.unicat.$cancel();
              vm.unicat.$save();
              cancel();
            } else {
              vm.unicat.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          unicat: function unicat() {
            return lunicat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return UnicatHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.unicat.factory:Unicat
   *
   * @description
   *
   */
  angular.module('vcfinance.unicat').factory('Unicat', Unicat);

  Unicat.$inject = ['restmod'];
  function Unicat(restmod) {
    return restmod.model('/routes/unicat').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/unicat/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return this.$search({ key: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name turnover
   * @description
   *
   */
  angular.module('vcfinance.turnover', ['ui.router']);
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name turnover.factory:Turnover
   *
   * @description
   *
   */
  angular.module('vcfinance.turnover').factory('Turnover', Turnover);

  Turnover.$inject = ['restmod'];

  function Turnover(restmod) {
    return restmod.model('/routes/sales');
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.turnover').component('turnover', {
    restrict: 'E',
    templateUrl: 'vcfinance/turnover/turnover-component.tpl.html',
    controllerAs: 'vm',
    controller: ['Turnover', '$log', '$http', function (Turnover, $log, $http) {
      var vm = this;

      // set default view on page open
      vm.view = 'summary';

      // vm.today = moment().locale('de-at').format('ll');
      // vm.thisday = moment().format('YYYY-MM-DD').toString();
      // vm.thismonth = moment().format('YYYY-MM').toString();
      // vm.thisyear = moment().format('YYYY').toString();

      // NOTE TO SELF: Statistics with Stornos and Discounts is REALLY tricky!!!!!!
      // please note the following

      // inv.netto = sum of net prices
      // inv.totalbefore = brutto sum before discount
      // inv.tax = tax sum before discount
      // inv.taxdiscounted = discounted tax sum
      // inv.nettodiscounted = nett sum discounted, also set when discount was 0
      // inv.discounttaxsum = array with taxes per steuersatz, post discount, also set when discount was 0

      // some fun new queries to cashinvoices
      // [{$match: {test:false}},{$group:{_id: {year: {$substr:['$date',0,4]},month: {$substr: ['$date',5,2]} },count: {$sum:1}, monthlytotal: {$sum: '$total'}, monthlytotalstorno: {$sum: {$cond:[{$eq: ['$storno', true]},'$total', 0]}}   }}]
      // moment().startOf('quarter')

      // this month, quarter, year stats
      vm.thisyear = {};

      // dummy object for zero results
      var emptystat = {
        avg: 0.00,
        card: 0.00,
        cash: 0.00,
        discount: 0.00,
        invcount: 0,
        max: 0.00,
        min: 0.00,
        netto: 0.00,
        nettodiscounted: 0.00,
        open: 0.00,
        paid: 0.00,
        stddev: 0.00,
        storno: 0.00,
        stornocount: 0,
        tax: 0.00,
        taxdiscounted: 0.00,
        total: 0.00,
        totalcount: 0
      };

      var todayquerycash = [mongomatchstartend(moment().locale('de').startOf('day').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('cash', 'this')];
      var todayquerycheck = [mongomatchstartend(moment().locale('de').startOf('day').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('check', 'this')];

      var thisweekquerycash = [mongomatchstartend(moment().locale('de').startOf('week').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('cash', 'this')];
      var thisweekquerycheck = [mongomatchstartend(moment().locale('de').startOf('week').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('check', 'this')];

      var thismonthquerycash = [mongomatchstartend(moment().startOf('month').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('cash', 'this')];
      var thismonthquerycheck = [mongomatchstartend(moment().startOf('month').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('check', 'this')];

      var thisquarterquerycash = [mongomatchstartend(moment().startOf('quarter').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('cash', 'this')];
      var thisquarterquerycheck = [mongomatchstartend(moment().startOf('quarter').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('check', 'this')];

      var thisyearquerycash = [mongomatchstartend(moment().startOf('year').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('cash', 'this')];
      var thisyearquerycheck = [mongomatchstartend(moment().startOf('year').toISOString(), moment().add(1, 'days').toISOString()), mongogenblock('check', 'this')];

      // cashinvoices today
      $http.post('/routes/cashinvoices/aggregate', todayquerycash).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.todaycashstats = response.data;
        } else {
          vm.thisyear.todaycashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('todayquerycash Aggregate failed: ', response);
      });

      // checkinvoices today
      $http.post('/routes/checkinvoices/aggregate', todayquerycheck).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.todaycheckstats = response.data;
        } else {
          vm.thisyear.todaycheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thismonthquerycheck Aggregate failed: ', response);
      });

      // cashinvoices this week
      $http.post('/routes/cashinvoices/aggregate', thisweekquerycash).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.weekcashstats = response.data;
        } else {
          vm.thisyear.weekcashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.error('thisweekquerycash Aggregate failed: ', response);
      });

      // checkinvoices this week
      $http.post('/routes/checkinvoices/aggregate', thisweekquerycheck).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.weekcheckstats = response.data;
        } else {
          vm.thisyear.weekcheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thisweekquerycheck Aggregate failed: ', response);
      });

      // cashinvoices this month
      $http.post('/routes/cashinvoices/aggregate', thismonthquerycash).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.monthcashstats = response.data;
        } else {
          vm.thisyear.monthcashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thismonthquerycash Aggregate failed: ', response);
      });

      // checkinvoices this month
      $http.post('/routes/checkinvoices/aggregate', thismonthquerycheck).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.monthcheckstats = response.data;
        } else {
          vm.thisyear.monthcheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thismonthquerycheck Aggregate failed: ', response);
      });

      // cashinvoices this quarter
      $http.post('/routes/cashinvoices/aggregate', thisquarterquerycash).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.quartercashstats = response.data;
        } else {
          vm.thisyear.quartercashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thisquarterquerycash Aggregate failed: ', response);
      });

      // checkinvoices this quarter
      $http.post('/routes/checkinvoices/aggregate', thisquarterquerycheck).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.quartercheckstats = response.data;
        } else {
          vm.thisyear.quartercheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thisquarterquerycheck Aggregate failed: ', response);
      });

      // cashinvoices this year
      $http.post('/routes/cashinvoices/aggregate', thisyearquerycash).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.yearcashstats = response.data;
        } else {
          vm.thisyear.yearcashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thisyearquerycash Aggregate failed: ', response);
      });

      // checkinvoices this year
      $http.post('/routes/checkinvoices/aggregate', thisyearquerycheck).then(function success(response) {
        if (!angular.equals({}, response.data)) {
          vm.thisyear.yearcheckstats = response.data;
        } else {
          vm.thisyear.yearcheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('thisyearquerycheck Aggregate failed: ', response);
      });

      // monthly stats for the whole business period
      var monthlyquerycash = [{ $match: { test: false } }, mongogenblock('cash', 'month')];
      var monthlyquerycheck = [{ $match: { test: false } }, mongogenblock('check', 'month')];

      $log.debug('monthlyquerycash: ', monthlyquerycash);
      // cashinvoices per month
      $http.post('/routes/cashinvoices/aggregate', monthlyquerycash).then(function success(response) {
        $log.debug('monthlyquerycash response: ', response);
        if (angular.isArray(response.data) && response.data.length > 0) {
          vm.monthlycashstats = response.data;
          $log.debug('monthlycashstats: ', vm.monthlycashstats);
        } else if (angular.isObject(response.data)) {
          vm.monthlycashstats = response.data;
        } else {
          vm.monthlycashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('monthlychash Aggregate failed: ', response);
      });

      // checkinvoices per month
      $http.post('/routes/checkinvoices/aggregate', monthlyquerycheck).then(function success(response) {
        $log.debug('monthlyquerycheck response: ', response);
        if (angular.isArray(response.data) && response.data.length > 0) {
          vm.monthlycheckstats = response.data;
          $log.debug('monthlycheckstats: ', vm.monthlycheckstats);
        } else if (angular.isObject(response.data)) {
          vm.monthlycheckstats = response.data;
        } else {
          vm.monthlycheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('monthlyquerycheck Aggregate failed: ', response);
      });

      // yearly stats for the whole business period
      var yearlyquerycash = [{ $match: { test: false } }, mongogenblock('cash', 'year')];
      var yearlyquerycheck = [{ $match: { test: false } }, mongogenblock('check', 'year')];

      // chashinvoices per year
      $http.post('/routes/cashinvoices/aggregate', yearlyquerycash).then(function success(response) {
        $log.debug('yearlycashstats response: ', response);
        if (angular.isArray(response.data) && response.data.length > 0) {
          vm.yearlycashstats = response.data;
          $log.debug('yearlycashstats: ', vm.yearlycashstats);
        } else if (angular.isObject(response.data)) {
          vm.yearlycashstats = response.data;
        } else {
          vm.yearlycashstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('yearlycashstats Aggregate failed: ', response);
      });

      // Checkinvoices per year
      $http.post('/routes/checkinvoices/aggregate', yearlyquerycheck).then(function success(response) {
        $log.debug('yearlyquerycheck response: ', response);

        if (angular.isArray(response.data) && response.data.length > 0) {
          vm.yearlycheckstats = response.data;
          $log.debug('yearlycheckstats: ', vm.yearlycheckstats);
        } else if (angular.isObject(response.data)) {
          vm.yearlycheckstats = response.data;
        } else {
          vm.yearlycheckstats = angular.copy(emptystat);
        }
      }, function error(response) {
        $log.debug('yearlycheckstats Aggregate failed: ', response);
      });

      function mongomatchstartend(start, end) {
        return {
          $match: {
            $and: [{ date: { $gt: start } }, { date: { $lt: end } }, { test: false }]
          }
        };
      }

      function mongogenblock(type, id) {
        var specficquery = {};
        var groupid = {};
        if (id === 'month') {
          groupid = {
            year: { $substr: ['$date', 0, 4] },
            month: { $substr: ['$date', 5, 2] }
          };
        } else if (id === 'year') {
          groupid = {
            year: { $substr: ['$date', 0, 4] }
          };
        } else {
          groupid = 1;
        }

        if (type === 'cash') {
          specficquery = {
            $group: {
              _id: groupid, totalcount: { $sum: 1 },
              invcount: { $sum: { $cond: [{ $eq: ['$storno', false] }, 1, 0] } },
              stornocount: { $sum: { $cond: [{ $eq: ['$storno', true] }, 1, 0] } },
              total: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              netto: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$netto', 0] } },
              nettodiscounted: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$nettodiscounted', 0] } },
              discount: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$discount', 0] } },
              tax: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$tax', 0] } },
              taxdiscounted: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$taxdiscounted', 0] } },
              storno: { $sum: { $cond: [{ $eq: ['$storno', true] }, '$total', 0] } },
              avg: { $avg: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              stddev: { $stdDevPop: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              max: { $max: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              min: { $min: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              cash: {
                $sum: {
                  $cond: [{
                    $and: [{ $eq: ['$storno', false] }, { $eq: ['$paytype', 'cash'] }]
                  }, '$total', 0]
                }
              },
              card: {
                $sum: {
                  $cond: [{
                    $and: [{ $eq: ['$storno', false] }, { $eq: ['$paytype', 'card'] }]
                  }, '$total', 0]
                }
              }
            }
          };
        } else if (type === 'check') {
          specficquery = {
            $group: {
              _id: groupid, totalcount: { $sum: 1 },
              invcount: { $sum: { $cond: [{ $eq: ['$storno', false] }, 1, 0] } },
              stornocount: { $sum: { $cond: [{ $eq: ['$storno', true] }, 1, 0] } },
              total: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              netto: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$netto', 0] } },
              nettodiscounted: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$nettodiscounted', 0] } },
              discount: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$discount', 0] } },
              tax: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$tax', 0] } },
              taxdiscounted: { $sum: { $cond: [{ $eq: ['$storno', false] }, '$taxdiscounted', 0] } },
              storno: { $sum: { $cond: [{ $eq: ['$storno', true] }, '$total', 0] } },
              avg: { $avg: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              stddev: { $stdDevPop: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              max: { $max: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              min: { $min: { $cond: [{ $eq: ['$storno', false] }, '$total', 0] } },
              open: {
                $sum: {
                  $cond: [{
                    $and: [{ $eq: ['$storno', false] }, { $eq: ['$paid', false] }]
                  }, '$total', 0]
                }
              },
              paid: {
                $sum: {
                  $cond: [{
                    $and: [{ $eq: ['$storno', false] }, { $eq: ['$paid', true] }]
                  }, '$total', 0]
                }
              }
            }
          };
        }

        return specficquery;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vcprivcat
   * @description
   *
   */
  angular.module('vcfinance.privcat', []);
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatsearch', {
    restrict: 'E',
    bindings: {
      privcat: '<',
      privcatref: '<',
      editinplace: '@?',
      hideaddoption: '@?',
      onselectcb: '&?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   autofocus\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showprivcat($item, $model, $label)"\n                   uib-typeahead="privcat as privcat.text for privcat in vm.getPrivcats($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-warning"></i> Keine Privatleistungen gefunden\n          <span class="btn btn-success" ng-click="vm.addPrivcat()" ng-hide="vm.error || vm.hideaddoption">Neue Privatleistung eingeben</span>\n          <span ng-click="vm.addPrivcatEntry()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Privatleistung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true || vm.editinplace === \'true\'">\n          <span ng-show="vm.privcat.type===\'entry\'">\n            <privcatentryeditor privcatentry="vm.privcat"></privcatentryeditor>\n          </span>\n          <span ng-show="vm.privcat.type===\'group\'">\n            <privcatgroupeditor privcatgroup="vm.privcat"></privcatgroupeditor>\n          </span>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', 'PrivcatHelper', function ($log, Privcat, PrivcatHelper) {
      var vm = this;
      vm.save = save;
      vm.showprivcat = showprivcat;

      vm.getPrivcats = getPrivcats;
      vm.addPrivcatEntry = PrivcatHelper.addPrivcatEntry;
      vm.addPrivcatGroup = PrivcatHelper.addPrivcatGroup;
      vm.editPrivcatEntry = PrivcatHelper.editPrivcatEntry;
      vm.editPrivcatGroup = PrivcatHelper.editPrivcatGroup;

      vm.$onInit = function () {
        vm.newprivcat = {};

        if (angular.isDefined(vm.hideaddoption) && vm.hideaddoption === 'true') {
          vm.hideaddoption = true;
        } else {
          vm.hideaddoption = false;
        }

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastprivcat = angular.copy(vm.privcatresult);
        vm.lastprivcatref = angular.copy(vm.privcatref);
      };

      function addPrivcatEntry() {
        $log.debug('debug - privcatsearch addPrivcat called');
        PrivcatHelper.addPrivcat(function (privcat) {
          $log.debug('debug: handle newly create privcat');
          vm.privcat = {};
          vm.privcat.name = privcat.name;
          vm.privcat.short = privcat.short;
          vm.privcat._id = privcat._id;
          vm.privcatref = privcat._id;
          vm.asyncSelected = privcat.short;
          vm.parentsave({ privcat: vm.privcat, privcatref: vm.privcatref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead privcat search backend query
      function getPrivcats(val) {
        // return Privcatahead.$search({query: val}).$asPromise().then(function (response) {
        return Privcat.$searchahead({
          query: val,
          fields: ['shortcut', 'name']
        }).$asPromise().then(function (response) {
          return response.map(function (privcat) {
            if (privcat.type === 'entry') {
              privcat.text = privcat.shortcut + ' - ' + privcat.name;
            } else {
              privcat.text = 'Gruppe ' + privcat.shortcut + ' - ' + privcat.name;
            }

            delete vm.error;
            return privcat;
          });
        });
      }

      // typeahead privcat search action
      function showprivcat($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.privcat = $model;
        vm.privcatref = $model._id;
        delete vm.asyncSelected;
        // $log.debug('debug showprivcat  - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true || vm.editinplace === 'true') {
          // $log.debug('edit inplace true path');
          vm.privcat = $model;
          vm.privcatref = $model._id;
          // $log.debug('debug - privcatsearch editinplace');
        } else {
            // $log.debug('edit inplace false path');

            vm.privcat = {};
            vm.privcat.name = $model.name;
            vm.privcat.short = $model.short;
            vm.privcat._id = $model._id;
            vm.privcat.type = $model.type;
            vm.privcat.active = $model.active;
            vm.privcatref = $model._id;
            if ($model.type = 'entry') {
              vm.privcat.details = $model.details;
              vm.privcat.price = $model.price;
              vm.privcat.tax = $model.tax;
              vm.privcat.repeatable = $model.repeatable;
              vm.privcat.svs = angular.copy($model.svs);
            }
            if ($model.type = 'group') {
              vm.privcat.items = angular.copy($model.items);
            }

            if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
              vm.onselectcb({ privcat: vm.privcat, privcatref: vm.privcatref });
            } else {
              $log.error('No privcat search callback provided');
            }
          }
      }

      function save() {
        if (!angular.equals(vm.privcat, vm.lastprivcat) || !angular.equals(vm.privcatref, vm.lastprivcatref)) {
          vm.lastprivcat = angular.copy(vm.privcat);
          vm.lastprivcatref = angular.copy(vm.privcatref);
          vm.parentsave({ privcat: vm.privcat, privcatref: vm.privcatref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatnewgroup', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="privcatnewgroup-component" data-hook="privcatnewgroup-component">\n        <h3>Neue Leistungsgruppe anlegen</h3>\n        <div class="btn btn-success" style="margin-bottom: 12px"\n        ng-click="vm.addPrivcatGroup()" ng-hide="vm.newprivcatgroup">Neue Leistungsgruppe anlegen</div>\n        <div ng-show="vm.newprivcatgroup">\n          <privcatgroupform privcatgroup="vm.newprivcatgroup" parentsave="vm.saveNewPrivcatGroup(privcatgroup)" oncancel="vm.cancel()"></privcatgroupform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Leistungsgruppe erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info-circle"></i> Das Anlegen einer neuen Leistungsgruppe wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Leistungsgruppe konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', 'Rlog', function ($log, Privcat, Rlog) {
      var vm = this;
      vm.addPrivcatGroup = addPrivcatGroup;
      vm.saveNewPrivcatGroup = saveNewPrivcatGroup;
      vm.cancel = cancel;

      function addPrivcatGroup() {
        vm.newprivcatgroup = {
          type: 'group'
        };
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewPrivcatGroup(privcatgroup) {
        $log.debug('debug: create new privcat: ', privcatgroup);
        delete vm.newprivcatgroup;
        Privcat.$create(privcatgroup).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new privcatgroup failed: ', err);
          Rlog.error('vcutils.privcat', 'privcatgroupnew', 'Creation of new privcatgroup failed: ', { privcatgroup: privcatgroup });
        });
      }

      function cancel() {
        delete vm.newprivcatgroup;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatnewentry', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="privcatnewentry-component" data-hook="privcatnewentry-component">\n        <h3>Neue Privatleistung anlegen</h3>\n        <div class="btn btn-success"   style="margin-bottom: 12px"\n        ng-click="vm.addPrivcatEntry()" ng-hide="vm.newprivcatentry">Neue Privatleistung anlegen</div>\n        <div ng-show="vm.newprivcatentry">\n          <privcatentryform privcatentry="vm.newprivcatentry" parentsave="vm.saveNewPrivcatEntry(privcat)" oncancel="vm.cancel()"></privcatentryform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Privatleistung erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info-circle"></i> Das Anlegen einer neuen Privatleistung wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Privatleistung konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      <div class="spacer-bottom">&nbsp;</div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', 'Rlog', function ($log, Privcat, Rlog) {
      var vm = this;
      vm.addPrivcatEntry = addPrivcatEntry;
      vm.saveNewPrivcatEntry = saveNewPrivcatEntry;
      vm.cancel = cancel;

      function addPrivcatEntry() {
        vm.newprivcatentry = {
          type: 'entry',
          repeatable: false,
          tax: 0,
          svs: {}
        };
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewPrivcatEntry(privcat) {
        delete vm.newprivcatentry;
        Privcat.$create(privcat).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new privcatentry failed: ', err);
          Rlog.error('vcutils.privcat', 'privcatnew', 'Creation of new privcatentry failed: ', { error: err, privacatentry: privcat });
        });
      }

      function cancel() {
        delete vm.newprivcatentry;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatgrouplist', {
    restrict: 'E',
    bindings: {
      privcatgroups: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Kürzel</th>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="group in vm.privcatgroups">\n            <td>{{group.shortcut}}</td>\n            <td>{{group.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editGroup(group)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeGroup(group)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n          <tr ng-repeat-end>\n            <td colspan="3">\n            <div ng-if="vm.editgroup[$index]"\n            \n</td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService', function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
      var vm = this;
      vm.editGroup = PrivcatHelper.editPrivcatGroup;
      vm.removeGroup = removeGroup;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.privcatgroups)) {
          vm.privcatgroups = Privcat.$search({ type: 'group', active: true });
        }
      }; // $onInit()

      function removeGroup(entry) {
        entry.active = false;
        entry.$save();
      }

      var privcatUpdateHandler = function privcatUpdateHandler(message) {
        $log.debug('debug: privcat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.privcatgroups)) {
          vm.privcatgroups.$refresh().$then(function () {
            $log.debug('debug: privcatgrouplist refreshed privcat');
          }, function (error) {
            $log.debug('debug: privcatgrouplist refresh failed: ', error);
          });
        }
      };

      vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatgroupform', {
    restrict: 'E',
    bindings: {
      privcatgroup: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcfinance/privcat/privcatgroupform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', function ($log, Privcat) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.addPrivcat = addPrivcat;
      vm.getPrivcats = getPrivcats;
      vm.removeEntry = removeEntry;

      vm.$onInit = function () {
        vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
      };

      function save() {
        // $log.debug('saving group: ', vm.privcatgroup);

        vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
        vm.parentsave({ privcatgroup: vm.privcatgroup });
        // Those lines failed on adding a new entry to entries hastable
        /*            if (!angular.equals(vm.privcatgroup, vm.lastprivcatgroup)) {
          $log.debug('saving group: ', vm.privcatgroup);
          vm.lastprivcatgroup = angular.copy(vm.privcatgroup);
          vm.parentsave({privcatgroup: vm.privcatgroup});
        }*/
      }

      function cancel() {
        vm.privcatgroup = angular.copy(vm.lastprivcatgroup);
        vm.oncancel();
      }

      // typeahead privcat search backend query
      function getPrivcats(val) {
        return Privcat.$searchahead({
          query: val,
          fields: ['shortcut', 'name']
        }).$asPromise().then(function (response) {
          return response.filter(function (privcat) {
            if (privcat.type === 'entry') {
              return privcat;
            }
          }).map(function (privcat) {
            privcat.text = privcat.shortcut + ' - ' + privcat.name;
            delete vm.error;
            return privcat;
          });
        });
      }

      // typeahead privcat search action
      function addPrivcat($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.privcat = $model;
        vm.privcatref = $model._id;
        delete vm.asyncSelected;

        var privcat = {};
        privcat.name = $model.name;
        privcat.shortcut = $model.shortcut;
        privcat._id = $model._id;
        if (angular.isUndefined(vm.privcatgroup.items)) {
          vm.privcatgroup.items = [];
        }
        vm.privcatgroup.items.push(privcat);
      }

      function removeEntry(i) {
        vm.privcatgroup.items.splice(i, 1);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatgroupeditor', {
    restrict: 'E',
    bindings: {
      privcatgroup: '<?',
      pricatgroupid: '<?'
    },
    template: '\n        <privcatgroupform privcatgroup="vm.privcatgroup" parentsave="vm.childsave(privcatgroup)" oncancel="vm.oncancel()"></privcatgroupform>\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Leistungsgruppe erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Editieren einer Leistungsgruppe wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Leistungsgruppe konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', 'Rlog', function ($log, Privcat, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      /*
                vm.$onInit = function () {
                  if ((angular.isUndefined(vm.privcatgroup) || !vm.privcatgroup.hasOwnProperty('_id'))
                    && angular.isDefined(vm.pricatgroupid)) {
                    Privcat.$find(vm.pricatgroupid).$then(function (privcatgroup) {
                      vm.privcatgroup = privcatgroup;
                    }, function (err) {
                      $log.error('privcatgroup not found, id: ', vm.pricatgroupid);
                      Rlog.error('privcatgroup', 'privcateditor', 'privcatgroup not found', {_id: vm.pricatgroupid});
                    });
                  }
                };
      */

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.pricatgroupid) && angular.isDefined(changes.pricatgroupid.currentValue) && changes.pricatgroupid.currentValue.length > 0) {
          vm.pricatgroupid = changes.pricatgroupid.currentValue;
          Privcat.$find(vm.pricatgroupid).$then(function (privcatgroup) {
            vm.privcatgroup = privcatgroup;
          }, function (err) {
            $log.error('privcatgroup not found, id: ', vm.pricatgroupid);
            Rlog.error('privcatgroup', 'privcateditor', 'privcatgroup not found', { _id: vm.pricatgroupid });
          });
        }
      };

      function childsave(privcatgroup) {
        // vm.privcatgroup = angular.copy(privcatgroup);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in privcatgroup) {
          if (privcatgroup.hasOwnProperty(key)) {
            vm.privcatgroup[key] = privcatgroup[key];
          }
        }
        vm.save();
      }

      function save() {
        delete vm.canceled;
        delete vm.saved;
        delete vm.error;
        if (vm.privcatgroup.$hasPendingActions()) {
          vm.privcatgroup.$cancel();
          vm.privcatgroup.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of privcatgroup failed: ', err);
            Rlog.error('vcutils.privcatgroup', 'privcatgroupeditor', 'Saving of privcatgroup failed: ', {
              error: err,
              privcatgroupid: vm.privcatgroup._id
            });
          });
        } else {
          vm.privcatgroup.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of privcatgroup failed: ', err);
            Rlog.error('vcutils.privcatgroup', 'privcatgroupeditor', 'Saving of privcatgroup failed: ', {
              error: err,
              privcatgroupid: vm.privcatgroup._id
            });
          });
        }
      }

      function oncancel() {
        delete vm.saved;
        delete vm.error;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatgroupchooser', {
    restrict: 'E',
    bindings: {
      privcatgroups: '<?',
      onselectcb: '&'
    },
    template: '\n          <div class="row">\n              <div class="col-xs-12 col-md-4" ng-repeat="group in vm.privcatgroups">\n                  <span class="btn btn-success btn-xs" \n                     uib-tooltip="Leistungen der Gruppe hinzufügen"\n                     ng-click="vm.addServiceOrGroup(group)"><i class="fa fa-cart-plus"></i>&nbsp;{{group.name}}</span>\n              </div>\n              <div class="col-xs-12" ng-show="vm.privcatgroups.length === 0" class="alert alert-info">Sie haben noch keine Leistungsgruppen angelegt. <a ui-sref="settings.services" class="btn btn-primary" target="_blank">Leistungsgruppe anlegen</a></div>\n          </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Privcat', 'vertxEventBusService', function ($log, Rlog, Privcat, vertxEventBusService) {
      var vm = this;

      vm.addServiceOrGroup = addServiceOrGroup;

      vm.$onInit = function () {
        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.privcatgroups)) {
          vm.privcatgroups = Privcat.$search({ type: 'group', active: true });
        }
      }; // $onInit()

      function addServiceOrGroup(group) {
        if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
          var cleangroup = {};
          cleangroup._id = group._id;
          cleangroup.name = group.name;
          cleangroup.shortcut = group.shortcut;
          cleangroup.details = group.details;
          cleangroup.type = group.type;
          cleangroup.active = group.active;
          cleangroup.items = angular.copy(group.items);

          vm.onselectcb({ privcat: cleangroup, privcatref: cleangroup._id });
        }
      }

      var privcatUpdateHandler = function privcatUpdateHandler(message) {
        $log.debug('debug: privcat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.privcatgroups)) {
          vm.privcatgroups.$refresh().$then(function () {
            $log.debug('debug: privcatgrouplist refreshed privcat');
          }, function (error) {
            $log.debug('debug: privcatgrouplist refresh failed: ', error);
          });
        }
      };

      vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatentrylist', {
    restrict: 'E',
    bindings: {
      privcatentries: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Kürzel</th>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="entry in vm.privcatentries">\n            <td>{{entry.shortcut}}</td>\n            <td>{{entry.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editPrivcatEntry(entry)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeEntry(entry)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table> \n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService', function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
      var vm = this;
      vm.editPrivcatEntry = PrivcatHelper.editPrivcatEntry;
      vm.removeEntry = removeEntry;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.privcatentries)) {
          vm.privcatentries = Privcat.$search({ type: 'entry', active: true });
        }
      }; // $onInit()

      function removeEntry(entry) {
        entry.active = false;
        entry.$save();
      }

      var privcatUpdateHandler = function privcatUpdateHandler(message) {
        $log.debug('debug: privcat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.privcatentries)) {
          vm.privcatentries.$refresh().$then(function () {
            $log.debug('debug: privcatentrylist refreshed');
          }, function (error) {
            $log.debug('debug: privcatentrylist refresh failed: ', error);
          });
        }
      };

      vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatentryform', {
    restrict: 'E',
    bindings: {
      privcatentry: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcfinance/privcat/privcatentryform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.normPrice = normPrice;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastprivcatentry = angular.copy(vm.privcatentry);
      };

      function save() {
        vm.lastprivcatentry = angular.copy(vm.privcatentry);
        vm.parentsave({ privcat: vm.privcatentry });
        /*            if (!angular.equals(vm.privcatentry, vm.lastprivcatentry)) {
                      vm.lastprivcatentry = angular.copy(vm.privcatentry);
                      vm.parentsave({privcat: vm.privcatentry});
                    }*/
      }

      function cancel() {
        vm.privcatentry = angular.copy(vm.lastprivcatentry);
        vm.oncancel();
      }

      // turn user entry into units of one/tenth of cents
      function normPrice() {
        if (angular.isDefined(vm.privcatentry.priceuserentry) && angular.isNumber(vm.privcatentry.priceuserentry)) {
          vm.privcatentry.normprice = parseInt(vm.privcatentry.priceuserentry * 1000, 10);
          vm.privcatentry.price = parseFloat(vm.privcatentry.price);
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatentryeditor', {
    restrict: 'E',
    bindings: {
      privcatentry: '<?',
      privcatentryid: '<?'
    },
    template: '\n        <privcatentryform privcatentry="vm.privcatentry" parentsave="vm.childsave(privcatentry)" oncancel="vm.oncancel()"></privcatentryform>\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Privatleistung erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Editieren einer Privatleistung wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Privatleistung konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Privcat', 'Rlog', '$timeout', function ($log, Privcat, Rlog, $timeout) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      /*          vm.$onInit = function () {
                  if ((angular.isUndefined(vm.privcatentry) || !vm.privcatentry.hasOwnProperty('_id'))
                    && angular.isDefined(vm.privcatentryid)) {
                    Privcat.$find(vm.privcatentryid).$then(function (privcatentry) {
                      vm.privcatentry = privcatentry;
                    }, function (err) {
                      $log.error('privcatentry not found, id: ', vm.privcatentryid);
                      Rlog.error('privcatentry', 'privcateditor', 'privcatentry not found', {_id: vm.privcatentryid});
                    });
                  }
                };*/

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.privcatentryid) && angular.isDefined(changes.privcatentryid.currentValue) && changes.privcatentryid.currentValue.length > 0) {
          vm.privcatentryid = changes.privcatentryid.currentValue;
          Privcat.$find(vm.privcatentryid).$then(function (privcatentry) {
            vm.privcatentry = privcatentry;
          }, function (err) {
            $log.error('privcatentry not found, id: ', vm.privcatentryid);
            Rlog.error('privcatentry', 'privcateditor', 'privcatentry not found', { _id: vm.privcatentryid });
          });
        }
      };

      function childsave(privcatentry) {
        // vm.privcatentry = angular.copy(privcatentry);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in privcatentry) {
          if (privcatentry.hasOwnProperty(key)) {
            vm.privcatentry[key] = privcatentry[key];
          }
        }
        vm.save();
      }

      function save() {
        delete vm.canceled;
        delete vm.saved;
        if (vm.privcatentry.$hasPendingActions()) {
          vm.privcatentry.$cancel();
          vm.privcatentry.$save().$then(function () {
            vm.saved = true;
            $timeout(function () {
              $log.debug('******************** timeout');
              delete vm.saved;
            }, 3000);
          }, function (err) {
            vm.saved = false;
            $log.error('saving of privcatentry failed: ', err);
            Rlog.error('vcutils.privcatentry', 'privcatentryeditor', 'Saving of privcatentry failed: ', { error: err, privcatentryid: vm.privcatentry._id });
          });
        } else {
          vm.privcatentry.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $timeout(function () {
              delete vm.saved;
            }, 3000);
            $log.error('saving of privcatentry failed: ', err);
            Rlog.error('vcutils.privcatentry', 'privcatentryeditor', 'Saving of privcatentry failed: ', { error: err, privcatentryid: vm.privcatentry._id });
          });
        }
      }

      function oncancel() {
        delete vm.canceled;
        delete vm.saved;
        vm.canceled = true;
        $timeout(function () {
          delete vm.canceled;
        }, 3000);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of privcats (patients) to display or load privcats */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.privcat').component('privcatentrychooser', {
    restrict: 'E',
    bindings: {
      privcatentries: '<?'
    },
    template: '\n          <div class="row">\n              <div class="col-xs-12 col-md-4" ng-repeat="entry in vm.privcatentries">\n              <span class="btn btn-success btn-xs" \n                    uib-tooltip="Leistungen hinzufügen"\n                    ng-click="vm.addServiceOrGroup(entry)"><i class="fa fa-upload"></i>&nbsp;{{entry.name}}</span>\n              </div>\n          </div>\n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Privcat', 'PrivcatHelper', 'vertxEventBusService', function ($log, $http, Rlog, Privcat, PrivcatHelper, vertxEventBusService) {
      var vm = this;
      vm.addServiceOrGroup = addServiceOrGroup;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.privcatentries)) {
          vm.privcatentries = Privcat.$search({ type: 'entry', active: true });
        }
      }; // $onInit()

      function addServiceOrGroup(entry) {
        //  TODO fill out $http request, what to send / groupid per get, or group object per post?
      }

      var privcatUpdateHandler = function privcatUpdateHandler(message) {
        $log.debug('debug: privcat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.privcatentries)) {
          vm.privcatentries.$refresh().$then(function () {
            $log.debug('debug: privcatentrylist refreshed');
          }, function (error) {
            $log.debug('debug: privcatentrylist refresh failed: ', error);
          });
        }
      };

      vertxEventBusService.on('privcat.update', {}, privcatUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('privcat.update', {}, privcatUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  angular.module('vcfinance.privcat').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcfinanceprivcat', {
      url: '/financeprivcat',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;privcatsearch privcat="" privcatref=""  hideaddoption="true" onselectcb="&"&gt;</tt></h3><div ui-view="privcatsearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatsearch privcat="" privcatref="" editinplace="true" hideaddoption="true"&gt;</tt></h3><div ui-view="privcatsearchview3"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatysearch privcat="" privcatref="" parentsave=""&gt;</tt></h3><div ui-view="privcatsearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatentryeditor privcat="" onClose=""&gt;</tt></h3><div ui-view="privcateditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatnewentry&gt;</tt></h3><div ui-view="privcatnewentryview"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatnewgroup&gt;</tt></h3><div ui-view="privcatnewgroupview"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatentrylist privcatentries="?"&gt;</tt></h3><div ui-view="privcatentrylistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;privcatgrouplist privcatgroups="?"&gt;</tt></h3><div ui-view="privcatgrouplistview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.financevcprivcat entered');
      }
    });

    $stateProvider.state('playground.vcfinanceprivcat.allcomponents', {
      url: '/allcomponents',
      resolve: {
        privcat: function privcat() {
          return '';
        },
        privcatref: function privcatref() {
          return '';
        },
        someprivcat: function someprivcat(Privcat) {
          return Privcat.$find('572b31b07c01597e3e150923');
        },
        allprivcats: function allprivcats(Privcat) {
          return Privcat.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (privcat, privcatref) {
            console.log('debug: dummy parentsave called for privcatsearch with: ', privcat, privcatref);
          };
        },
        eip: function eip() {
          return true;
        },
        eipf: function eipf() {
          return false;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'privcatsearchview@playground.vcfinanceprivcat': {
          component: 'privcatsearch',
          bindings: {
            privcat: 'privcat',
            privcatref: 'privcatref',
            editinplace: 'eipf',
            hideaddoption: 'eip'
          }
        },
        'privcatsearchview2@playground.vcfinanceprivcat': {
          component: 'privcatsearch',
          bindings: {
            privcat: 'privcat',
            privcatref: 'privcatref',
            parentsave: 'parentsavesearch',
            editinplace: 'eip'
          }
        },
        'privcatsearchview3@playground.vcfinanceprivcat': {
          component: 'privcatsearch',
          bindings: {
            privcat: 'privcat',
            privcatref: 'privcatref',
            parentsave: 'parentsavesearch',
            editinplace: 'eip',
            hideaddoption: 'eip'
          }
        },
        'privcateditview@playground.vcfinanceprivcat': {
          component: 'privcatentryeditor',
          bindings: {}
        },
        'privcatnewentryview@playground.vcfinanceprivcat': {
          component: 'privcatnewentry',
          bindings: {}
        },
        'privcatnewgroupview@playground.vcfinanceprivcat': {
          component: 'privcatnewgroup',
          bindings: {}
        },
        'privcatentrylistview@playground.vcfinanceprivcat': {
          component: 'privcatentrylist',
          bindings: {}
        },
        'privcatgrouplistview@playground.vcfinanceprivcat': {
          component: 'privcatgrouplist',
          bindings: {}
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcfinanceprivcat.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.vcprivcat.factory:PrivcatHelper
   *
   * @description
   *
   */
  angular.module('vcfinance.privcat').factory('PrivcatHelper', PrivcatHelper);

  PrivcatHelper.$inject = ['Privcat', '$uibModal', '$log', 'Rlog'];

  function PrivcatHelper(Privcat, $uibModal, $log, Rlog) {
    var PrivcatHelperBase = {};

    PrivcatHelperBase.editPrivcatEntry = editPrivcatEntry;
    PrivcatHelperBase.addPrivcatEntry = addPrivcatEntry;
    PrivcatHelperBase.editPrivcatGroup = editPrivcatGroup;
    PrivcatHelperBase.addPrivcatGroup = addPrivcatGroup;

    function addPrivcatEntry(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatform privcat="vm.privcat" parentsave="vm.childsave(privcat)" oncancel="vm.cancel()"></privcatnew></div>',
        controllerAs: 'privcataCtrl',
        controller: ['privcat', function () {
          var vm = this;
          vm.privcat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcat) {
            Privcat.$create(privcat).$then(function (newprivcat) {
              vm.created = true;
              success(newprivcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ privcat-helper.addPrivcat: ', err);
              Rlog.error('vcutils.privcat', 'privcat-helper.addPrivcat', 'Creation of new SV failed: ', {
                error: err,
                privcat: privcat
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          privcat: function privcat() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editPrivcatEntry(lprivcat) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatentryform privcatentry="privcateCtrl.privcat" parentsave="privcateCtrl.childsave(privcatentry)" oncancel="privcateCtrl.cancel()"></privcatentryform></div>',
        controllerAs: 'privcateCtrl',
        controller: ['privcat', function (sprivcat) {
          var vm = this;
          vm.privcat = sprivcat;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcatentry) {
            // vm.privcat = angular.copy(privcat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in privcatentry) {
              if (privcatentry.hasOwnProperty(key)) {
                vm.privcat[key] = privcatentry[key];
              }
            }

            if (vm.privcat.$hasPendingActions()) {
              vm.privcat.$cancel();
              vm.privcat.$save();
              cancel();
            } else {
              vm.privcat.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          privcat: function privcat() {
            return lprivcat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function addPrivcatGroup(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><privcatform privcat="vm.privcat" parentsave="vm.childsave(privcat)" oncancel="vm.cancel()"></privcatnew></div>',
        controllerAs: 'privcataCtrl',
        controller: ['privcat', function () {
          var vm = this;
          vm.privcat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcat) {
            Privcat.$create(privcat).$then(function (newprivcat) {
              vm.created = true;
              success(newprivcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ privcat-helper.addPrivcat: ', err);
              Rlog.error('vcutils.privcat', 'privcat-helper.addPrivcat', 'Creation of new SV failed: ', {
                error: err,
                privcat: privcat
              });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          privcat: function privcat() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editPrivcatGroup(lprivcat) {
      var dialog = $uibModal.open({
        template: '\n<div class="panel panel-default"><div class="panel-heading">\n<span class="pull-left">Leistungsgrupp editieren</span>\n<span class="pull-right"><span class="btn btn-danger btn-xs" ng-click="privcateCtrl.dialog.close()"><i class="fa fa-remove"></i></span>  </span>\n<div class="clearfix"></div>\n</div>\n<div class="panel-body">\n            <div class="modalspacer">\n                <privcatgroupform privcatgroup="privcateCtrl.privcat" \n                                  parentsave="privcateCtrl.childsave(privcatgroup)" \n                                  oncancel="privcateCtrl.cancel()">\n                </privcatgroupform>\n            </div>\n\n\n</div> </div>',
        controllerAs: 'privcateCtrl',
        controller: ['privcat', '$uibModalInstance', function (sprivcat, dialog) {
          var vm = this;
          vm.privcat = sprivcat;
          vm.dialog = dialog;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(privcatgroup) {
            $log.debug('helper childsave saving group: ', privcatgroup);
            // vm.privcat = angular.copy(privcat);
            // the above code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in privcatgroup) {
              if (privcatgroup.hasOwnProperty(key)) {
                vm.privcat[key] = privcatgroup[key];
              }
            }
            $log.debug('helper childsave saving vm.privcat: ', vm.privcat);
            if (vm.privcat.$hasPendingActions()) {
              vm.privcat.$cancel();
              vm.privcat.$save();
              cancel();
            } else {
              vm.privcat.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          privcat: function privcat() {
            return lprivcat;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
      return dialog;
    }

    return PrivcatHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.privcat.factory:Privcat
   *
   * @description
   *
   */
  angular.module('vcfinance.privcat').factory('Privcat', Privcat);

  Privcat.$inject = ['restmod'];
  function Privcat(restmod) {
    return restmod.model('/routes/privcat').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/privcat/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return this.$search({ key: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular.module('vcfinance.rksv', ['ui.router', 'ui.bootstrap']);
})();
/**
 * Created by lari on 04/03/2017.
 */

'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name config.component:todowidget
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="todo">
   <file name="index.html">
   <rksv-zero></rksv-zero>
   </file>
   </example>
   *
   */

  angular.module('vcfinance.rksv').component('rksvZero', {
    restrict: 'E',
    template: '<h2>Null-Beleg, Signatur über ausgefallene Signaturen</h2>' + '<button class="btn btn-primary" ng-click="vm.createNullBeleg()">Null-Beleg erstellen</button>' + '<div class="alert alert-{{vm.status || info}} spacer-top" ng-hide="vm.status === \'init\'">' + '<h3>{{vm.message}}</h3>' + '<p ng-show="vm.pdfid"><a href="/routes/pdfreader/{{vm.pdfid}}" target="_blank">PDF anzeigen</a></p>' + '<p ng-show="vm.hint">{{vm.hint}}</p>' + '</div>',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'RksvHelper', function ($log, $http, RksvHelper) {
      var vm = this;
      vm.status = 'init';
      vm.createNullBeleg = createNullBeleg;

      $log.debug('RKSV zero called');

      function createNullBeleg() {
        var invoiceobj = RksvHelper.getNullBeleg();

        $http.post('/routes/rksvzero', invoiceobj).then(function (res) {
          vm.status = 'success';
          vm.message = 'Erstellung des Nullbelegs ' + res.data.nbnum + ' war erfolgreich';
          vm.pdfid = res.data.pdfid;
          vm.hint = 'QR Code: ' + res.data.qrcode;
          $log.debug('RKSV zero record sent successfully');
        }, function (res) {
          $log.error('RKSV zero record failed');
          vm.status = 'danger';
          vm.message = 'Erstellung des Nullbelegs ist fehlgeschlagen';
          vm.hint = '';
        });
      }
    }]
  });

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  angular.module('vcfinance.rksv').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcfinancerksv', {
      url: '/financerksv',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;rksv-zero &gt;</tt></h3><div ui-view="rksvzeroview"></div>\n              <h3 class="alert alert-info"><tt>&lt;rksv-init&gt;</tt></h3><div ui-view="rksvinitview"></div>\n              \n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vcfinancerksv entered');
      }
    });

    $stateProvider.state('playground.vcfinancerksv.allcomponents', {
      url: '/allcomponents',
      resolve: {
        eip: function eip() {
          return true;
        },
        eipf: function eipf() {
          return false;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'rksvzeroview@playground.vcfinancerksv': {
          component: 'rksvZero',
          bindings: {}
        },
        'rksvinitview@playground.vcfinancerksv': {
          component: 'rksvInit',
          bindings: {}
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcfinancerksv.allcomponents entered');
      }
    });
  } // all routes
})();
/**
 * Created by lari on 04/03/2017.
 */

'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name config.component:todowidget
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="todo">
   <file name="index.html">
   <rksv-init></rksv-init>
   </file>
   </example>
   *
   */

  // var todowidget;

  angular.module('vcfinance.rksv').component('rksvInit', {
    restrict: 'E',
    // templateUrl: 'config/todowidget-directive.tpl.html',
    template: '<h2>Startbeleg</h2>' + '<button class="btn btn-primary" ng-click="vm.createStartBeleg()">Start-Beleg erstellen</button>' + '<div class="alert alert-{{vm.status || info}} spacer-top" ng-hide="vm.status === \'init\'">' + '<h3>{{vm.message}}</h3>' + '<p ng-show="vm.pdfid"><a href="/routes/pdfreader/{{vm.pdfid}}" target="_blank">PDF anzeigen</a></p>' + '<p ng-show="vm.hint">{{vm.hint}}</p>' + '</div>',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'RksvHelper', function ($log, $http, RksvHelper) {
      var vm = this;
      vm.status = 'init';
      vm.createStartBeleg = createStartBeleg;

      $log.debug('RKSV Init called');

      function createStartBeleg() {
        var invoiceobj = RksvHelper.getNullBeleg();

        $http.post('/routes/rksvinit', invoiceobj).then(function (res) {
          vm.status = 'success';
          vm.message = 'Erstellung des Startbelegs ' + res.data.nbnum + ' war erfolgreich';
          vm.pdfid = res.data.pdfid;
          vm.hint = 'QR Code: ' + res.data.qrcode;
          $log.debug('RKSV init record sent successfully');
        }, function (res) {
          $log.error('RKSV init record failed');
          vm.status = 'danger';
          vm.message = 'Erstellung des Startbelegs ist fehlgeschlagen';
          vm.hint = 'Hinweis: Der Startbeleg kann nur ein mal erstellt werden!';
        });
      }
    }]
  });

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name config.factory:RksvHelper
   *
   * @description
   *
   */
  angular.module('vcfinance.rksv').factory('RksvHelper', RksvHelper);

  function RksvHelper() {
    var RksvHelperBase = {};

    function getNullBeleg() {
      var invoice = {};

      invoice.consultid = 'nullbeleg';
      invoice.rootelement = 'invoice';

      invoice.date = moment().toISOString();
      invoice.fdate = moment(invoice.date).locale('de-at').format('ll');
      invoice.ftime = moment(invoice.date).locale('de-at').format('LTS');

      invoice.storno = false;
      invoice.test = false;

      // invoice.items = vm.patient.openConsult.service.items;
      // get rid of unselected excess items that clutter up the database
      invoice.items = [{
        _id: '56ae72d68dd4bd59ac0423af',
        created: '2016-02-09T21:21:30.978Z',
        active: true,
        cat: '0',
        group: '0',
        num: '00',
        name: 'Nullleistung',
        opoints: 0,
        points: 0,
        tax: 0,
        comment: 'Nullbeleg für Finanzamt',
        price: 0.00,
        include: true,
        selected: true
      }];

      invoice.netto = 0.00;
      invoice.totalbefore = 0.00;
      invoice.nettodiscounted = 0.00;
      invoice.bruttodiscounted = 0.00;
      invoice.taxdiscounted = 0.00;
      invoice.discount = 0.00;
      invoice.tax = 0.00;
      // discounttaxsum is actually an array with the accumulated tax per tax bracket
      // discounttaxsum kept for backward compatibility, new type is discounttaxarray
      invoice.discounttaxsum = { '0': 0.00 };
      invoice.discounttaxarray = { '0': 0.00 };
      invoice.discountnettoarray = { '0': 0.00 };
      invoice.discountbruttoarray = { '0': 0.00 };
      invoice.total = 0.00;
      invoice.invoicediagnoses = 'foo';

      invoice.paytype = 'cash';
      invoice.paid = true;
      invoice.type = 'Barrechnung';
      invoice.cash = true;
      invoice.paiddate = invoice.date;
      invoice.patient = {
        _id: '123412341234123412341234',
        primarycontact: {
          firstname: 'Maximilian',
          lastname: 'Mustermann'
        }
      };

      return invoice;
    }

    RksvHelperBase.getNullBeleg = getNullBeleg;
    return RksvHelperBase;
  }
})();
/**
 * Created by lari on 17/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.rksv').component('deplist', {
    restrict: 'E',
    templateUrl: 'vcfinance/rksv/deplist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Deplist', 'vertxEventBusService', function ($log, Deplist, vertxEventBusService) {
      var vm = this;
      vm.currentPage = 1;
      vm.pageChanged = pageChanged;

      this.$onInit = function () {
        var search = {};

        search.page = vm.currentpage;
        search.query = {};

        search.options = {};
        search.options.fields = {
          _id: 1,
          created: 1,
          receiptnr: 1,
          type: 1,
          signatureok: 1,
          pdfid: 1,
          storno: 1
        };

        vm.dep = Deplist.$search(search).$then(function (dep) {
          vm.totalItems = dep.$pageCount;
        });
      };

      function pageChanged() {
        vm.dep.$refresh({ page: vm.currentPage }).$then(function (dep) {
          vm.totalItems = dep.$pageCount;
        });
      }

      var rksvUpdateHandler = function rksvUpdateHandler(message) {
        $log.debug('debug: RKSV DEP update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.dep)) {
          vm.dep.$refresh().$then(function () {
            $log.debug('vm.dep refreshed successfully');
          }, function (error) {
            $log.error('vm.dep refresh failed: ', error);
          });
        }
      };

      vertxEventBusService.on('rksvdep.update', {}, rksvUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('rksvdep.update', {}, rksvUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 31/03/2017.
 */

'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name finance.rksv.component:depexport
   * @restrict E
   * @element
   *
   * @description
   *
   * @example
   <example module="finance.rksv">
   <file name="index.html">
   <depexport></depexport>
   </file>
   </example>
   *
   */

  angular.module('vcfinance.rksv').component('depexport', {
    restrict: 'E',
    templateUrl: 'vcfinance/rksv/depexport-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', function ($log, $http) {
      var vm = this;
      vm.status = 'init';
      vm.exportDEP = exportDEP;
      vm.thisyear = thisyear;
      vm.allyears = allyears;
      vm.startdate = new Date(moment().year(), 0, 1).toISOString();
      $log.debug('Startdate: ', vm.startdate);
      // vm.enddate = new Date().toISOString();
      vm.enddate = moment().endOf('day').toISOString();
      vm.dateOptions = {
        formatYear: 'yyyy',
        startingDay: 1
      };

      vm.altInputFormats = ['yyyy-MM-dd', 'dd.MM.yyyy'];

      function thisyear() {
        vm.startdate = moment().startOf('year').toISOString();
        vm.enddate = moment().endOf('year').toISOString();
        exportDEP();
      }

      function allyears() {
        vm.startdate = moment('2017-01-01 00:00:00').toISOString();
        vm.enddate = moment().toISOString();
        exportDEP();
      }

      function exportDEP() {

        var timerange = {
          $gte: vm.startdate,
          $lt: vm.enddate
        };

        var query = {};
        query.created = timerange;

        $http.post('/routes/depexport', query).then(function (res) {
          var anchor = angular.element('<a/>');
          $log.debug('res data: ', res);
          $log.debug('data string: ', res.data.toString());
          anchor.attr({
            href: 'data:attachment/json;charset=utf-8,' + encodeURI(angular.toJson(res.data, true)),
            target: '_blank',
            download: 'depexport.json'
          })[0].click();
          vm.status = 'success';
          vm.message = 'DEP Export war erfolgreich';

          $log.debug('RKSV zero record sent successfully');
        }, function () {
          $log.error('DEP Export failed');
          vm.status = 'danger';
          vm.message = 'DEP Export ist fehlgeschlagen';
        });
      }
    }]
  });

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name finance.rksv.factory:finance.rksvService
   *
   * @description
   *
   */
  angular.module('vcfinance.rksv').factory('Deplist', Deplist).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Deplist.$inject = ['restmod'];

  function Deplist(restmod) {
    return restmod.model('/routes/rksvdep', 'PagedModel');
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name finance.vckkcat
   * @description
   *
   */
  angular.module('finance.vckkcat', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('finance.vckkcat').component('kkcatsearch', {
    restrict: 'E',
    bindings: {
      kkcat: '<',
      kkcatref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   autofocus\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showkkcat($item, $model, $label)"\n                   uib-typeahead="kkcat as kkcat.text for kkcat in vm.getKkcats($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addKkcat()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addKkcat()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <kkcateditor kkcat="vm.kkcat"></kkcateditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Kkcat', 'KkcatHelper', function ($log, Kkcat, KkcatHelper) {
      var vm = this;
      vm.save = save;
      vm.showkkcat = showkkcat;

      vm.getKkcats = getKkcats;
      // vm.addKkcat = KkcatHelper.addKkcat;
      vm.addKkcat = addKkcat;
      vm.editKkcat = KkcatHelper.editKkcat;

      vm.$onInit = function () {
        vm.newkkcat = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastkkcat = angular.copy(vm.kkcatresult);
        vm.lastkkcatref = angular.copy(vm.kkcatref);
      };

      function addKkcat() {
        $log.debug('debug - kkcatsearch addKkcat called');
        KkcatHelper.addKkcat(function (kkcat) {
          $log.debug('debug: handle newly create kkcat');
          vm.kkcat = {};
          vm.kkcat.name = kkcat.name;
          vm.kkcat.short = kkcat.short;
          vm.kkcat._id = kkcat._id;
          vm.kkcatref = kkcat._id;
          vm.asyncSelected = kkcat.short;
          vm.parentsave({ kkcat: vm.kkcat, kkcatref: vm.kkcatref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead kkcat search backend query
      function getKkcats(val) {
        // return Kkcatahead.$search({query: val}).$asPromise().then(function (response) {
        return Kkcat.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (kkcat) {
            kkcat.text = kkcat.short;
            delete vm.error;
            return kkcat;
          });
        });
      }

      // typeahead kkcat search action
      function showkkcat($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.kkcat = $model;
        vm.kkcatref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.kkcat = $model;
          vm.kkcatref = $model._id;
          $log.debug('debug - kkcatsearch editinplace');
        } else {
          vm.kkcat = {};
          vm.kkcat.name = $model.name;
          vm.kkcat.short = $model.short;
          vm.kkcat._id = $model._id;
          vm.kkcatref = $model._id;
          vm.parentsave({ kkcat: vm.kkcat, kkcatref: vm.kkcatref });
          $log.debug('debug - kkcatsearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.kkcat, vm.lastkkcat) || !angular.equals(vm.kkcatref, vm.lastkkcatref)) {
          vm.lastkkcat = angular.copy(vm.kkcat);
          vm.lastkkcatref = angular.copy(vm.kkcatref);
          vm.parentsave({ kkcat: vm.kkcat, kkcatref: vm.kkcatref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('finance.vckkcat').component('kkcatnew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="kkcatnew-component" data-hook="kkcatnew-component">\n        <h3>Neue/s kkcat anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addKkcat()" ng-hide="vm.newkkcat">Neue/s kkcat anlegen</div>\n        <div ng-show="vm.newkkcat">\n          <kkcatform kkcat="vm.newkkcat" parentsave="vm.saveNewKkcat(kkcat)" oncancel="vm.cancel()"></kkcatform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> kkcat erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen kkcat wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> kkcat konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Kkcat', 'Rlog', function ($log, Kkcat, Rlog) {
      var vm = this;
      vm.addKkcat = addKkcat;
      vm.saveNewKkcat = saveNewKkcat;
      vm.cancel = cancel;

      function addKkcat() {
        vm.newkkcat = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewKkcat(kkcat) {
        $log.debug('debug: create new kkcat: ', kkcat);
        delete vm.newkkcat;
        Kkcat.$create(kkcat).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new kkcat failed: ', err);
          Rlog.error('vcutils.kkcat', 'kkcatnew', 'Creation of new kkcat failed: ', { error: err, kkcat: vm.newkkcat });
        });
      }

      function cancel() {
        delete vm.newkkcat;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of kkcats (patients) to display or load kkcats */

'use strict';

(function () {
  'use strict';
  angular.module('finance.vckkcat').component('kkcatlist', {
    restrict: 'E',
    bindings: {
      kkcats: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="kkcat in vm.kkcats">\n            <td>{{kkcat.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editKkcat(kkcat)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeKkcat(kkcat)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Kkcat', 'KkcatHelper', 'vertxEventBusService', function ($log, $http, Rlog, Kkcat, KkcatHelper, vertxEventBusService) {
      var vm = this;
      vm.editKkcat = KkcatHelper.editKkcat;
      vm.removeKkcat = removeKkcat;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.kkcats)) {
          vm.kkcats = Kkcat.$search();
        }
      }; // $onInit()

      function removeKkcat(kkcat) {
        kkcat.active = false;
        kkcat.$save();
      }

      var kkcatsUpdateHandler = function kkcatsUpdateHandler(message) {
        $log.debug('debug: kkcat update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.kkcats)) {
          vm.kkcats.$refresh().$then(function () {
            $log.debug('debug: kkcatlist refreshed kkcats');
          }, function (error) {
            $log.debug('debug: kkcatlist refresh kkcats failed: ', error);
          });
        }
      };

      vertxEventBusService.on('kkcats.update', {}, kkcatsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('kkcats.update', {}, kkcatsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('finance.vckkcat').component('kkcatform', {
    restrict: 'E',
    bindings: {
      kkcat: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcfinance/kkcat/kkcatform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastkkcat = angular.copy(vm.kkcat);
      };

      function save() {
        if (!angular.equals(vm.kkcat, vm.lastkkcat)) {
          vm.lastkkcat = angular.copy(vm.kkcat);
          vm.parentsave({ kkcat: vm.kkcat });
        }
      }

      function cancel() {
        vm.kkcat = angular.copy(vm.lastkkcat);
        vm.oncancel();
      }

      /*          function zipsave (zip, city) {
                  $log.debug('debug: kkcatform zipsave called: ', zip, city);
                  // vm.kkcat.postcode = zip;
                  // vm.kkcat.city = city;
                }*/
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('finance.vckkcat').component('kkcateditor', {
    restrict: 'E',
    bindings: {
      kkcat: '<?',
      kkcatid: '<?'
    },
    template: '\n        <kkcatform kkcat="vm.kkcat" parentsave="vm.childsave(kkcat)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> kkcat erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen kkcat wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> kkcat konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Kkcat', 'Rlog', function ($log, Kkcat, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.kkcat) || !vm.kkcat.hasOwnProperty('_id')) && angular.isDefined(vm.kkcatid)) {
          getKKcat();
        }
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.kkcatid) && angular.isDefined(changes.kkcatid.currentValue) && changes.kkcatid.currentValue.length > 0) {
          vm.kkcatid = changes.kkcatid.currentValue;
          getKKcat();
        }
      };

      function getKKcat() {
        Kkcat.$find(vm.kkcatid).$then(function (kkcat) {
          vm.kkcat = kkcat;
        }, function (err) {
          $log.error('kkcat not found, id: ', vm.kkcatid);
          Rlog.error('kkcat', 'kkcateditor', 'kkcat not found', { _id: vm.kkcatid });
        });
      }

      function childsave(kkcat) {
        // vm.kkcat = angular.copy(kkcat);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in kkcat) {
          if (kkcat.hasOwnProperty(key)) {
            vm.kkcat[key] = kkcat[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.kkcat.$hasPendingActions()) {
          vm.kkcat.$cancel();
          vm.kkcat.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of kkcat failed: ', err);
            Rlog.error('vcutils.kkcat', 'kkcateditor', 'Saving of kkcat failed: ', { error: err, kkcatid: vm.kkcat._id });
          });
        } else {
          vm.kkcat.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of kkcat failed: ', err);
            Rlog.error('vcutils.kkcat', 'kkcateditor', 'Saving of kkcat failed: ', { error: err, kkcatid: vm.kkcat._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('finance.vckkcat').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.financekkcat', {
      url: '/financekkcat',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;kkcatsearch kkcat="" kkcatref="" editinplace="true"&gt;</tt></h3><div ui-view="kkcatsearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;kkcatsearch kkcat="" kkcatref="" parentsave=""&gt;</tt></h3><div ui-view="kkcatsearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;kkcateditor kkcat="" mode="" onClose=""&gt;</tt></h3><div ui-view="kkcateditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;kkcatnew&gt;</tt></h3><div ui-view="kkcatnewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;kkcatlist kkcats="?"&gt;</tt></h3><div ui-view="kkcatlistview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.financevckkcat entered');
      }
    });

    $stateProvider.state('playground.financekkcat.allcomponents', {
      url: '/allcomponents',
      resolve: {
        kkcat: function kkcat() {
          return '';
        },
        kkcatref: function kkcatref() {
          return '';
        },
        somekkcat: function somekkcat(Kkcat) {
          return Kkcat.$find('572b31b07c01597e3e150923');
        },
        allkkcats: function allkkcats(Kkcat) {
          return Kkcat.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (kkcat, kkcatref) {
            console.log('debug: dummy parentsave called for kkcatsearch with: ', kkcat, kkcatref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'kkcatsearchview@playground.financekkcat': {
          component: 'kkcatsearch',
          bindings: {
            kkcat: 'kkcat',
            kkcatref: 'kkcatref',
            editinplace: 'eip'
          }
        },
        'kkcatsearchview2@playground.financekkcat': {
          component: 'kkcatsearch',
          bindings: {
            kkcat: 'kkcat',
            kkcatref: 'kkcatref',
            parentsave: 'parentsavesearch'
          }
        },
        'kkcateditview@playground.financekkcat': {
          component: 'kkcateditor',
          bindings: {
            kkcat: 'somekkcat'
          }
        },
        'kkcatnewview@playground.financekkcat': {
          component: 'kkcatnew',
          bindings: {}
        },
        'kkcatlistview@playground.financekkcat': {
          component: 'kkcatlist',
          bindings: {
            kkcats: 'allkkcats'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.financekkcat.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.vckkcat.factory:KkcatHelper
   *
   * @description
   *
   */
  angular.module('finance.vckkcat').factory('KkcatHelper', KkcatHelper);

  KkcatHelper.$inject = ['Kkcat', '$uibModal', '$log', 'Rlog'];

  function KkcatHelper(Kkcat, $uibModal, $log, Rlog) {
    var KkcatHelperBase = {};

    KkcatHelperBase.editKkcat = editKkcat;
    KkcatHelperBase.addKkcat = addKkcat;

    function addKkcat(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><kkcatform kkcat="vm.kkcat" parentsave="vm.childsave(kkcat)" oncancel="vm.cancel()"></kkcatnew></div>',
        controllerAs: 'kkcataCtrl',
        controller: ['kkcat', function () {
          var vm = this;
          vm.kkcat = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(kkcat) {
            Kkcat.$create(kkcat).$then(function (newkkcat) {
              vm.created = true;
              success(newkkcat);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ kkcat-helper.addKkcat: ', err);
              Rlog.error('vcutils.kkcat', 'kkcat-helper.addKkcat', 'Creation of new SV failed: ', { error: err, kkcat: kkcat });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          kkcat: function kkcat() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editKkcat(lkkcat) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><kkcatform kkcat="kkcateCtrl.kkcat" parentsave="kkcateCtrl.childsave(kkcat)" oncancel="kkcateCtrl.cancel()"></kkcatform></div>',
        controllerAs: 'kkcateCtrl',
        controller: ['kkcat', function (skkcat) {
          var vm = this;
          vm.kkcat = skkcat;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(kkcat) {
            // vm.kkcat = angular.copy(kkcat);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in kkcat) {
              if (kkcat.hasOwnProperty(key)) {
                vm.kkcat[key] = kkcat[key];
              }
            }

            if (vm.kkcat.$hasPendingActions()) {
              vm.kkcat.$cancel();
              vm.kkcat.$save();
              cancel();
            } else {
              vm.kkcat.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          kkcat: function kkcat() {
            return lkkcat;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return KkcatHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.kkcat.factory:Kkcat
   *
   * @description
   *
   */
  angular.module('finance.vckkcat').factory('Kkcat', Kkcat);

  Kkcat.$inject = ['restmod'];
  function Kkcat(restmod) {
    return restmod.model('/routes/kkcats').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/kkcats/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return $search({ key: key, val: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name invoice
   * @description
   *
   */
  angular.module('vcfinance.invoice', ['ui.router',
  // 'utils.filereader',
  'ui.bootstrap']).filter('bezahlt', function () {
    return function (input) {
      return input ? 'bezahlt' : 'offen';
    };
  }).filter('gemahnt', function () {
    return function (input) {
      return input ? 'gemahnt' : 'nicht gemahnt';
    };
  });

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name invoice.directive:invoicebrowser
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="invoice">
   <file name="index.html">
   <invoicebrowser></invoicebrowser>
   </file>
   </example>
   *
   */
  angular.module('vcfinance.invoice').directive('invoicebrowser', invoicebrowser);

  function invoicebrowser() {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'vcfinance/invoice/invoicebrowser-directive.tpl.html',
      replace: false,
      controllerAs: 'invCtrl',
      bindToController: true,
      controller: function controller() {}
      // this is an empty controller!

      // controller
    };
  } // directive

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name checkinvoice.factory:Checkinvoice
   *
   * @description
   *
   */
  angular.module('vcfinance.invoice').factory('Checkinvoice', Checkinvoice);

  Checkinvoice.$inject = ['restmod'];

  function Checkinvoice(restmod) {
    return restmod.model('/routes/checkinvoices', 'PagedModel').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      }
    });
  }
})();
/**
 * Created by lari on 07/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.invoice').component('checkinvoice', {
    restrict: 'E',
    templateUrl: 'vcfinance/invoice/checkinvoice-component.tpl.html',
    controllerAs: 'vm',
    bindings: {
      mode: '@'
    },
    controller: ['Checkinvoice', '$log', '$http', '$uibModal', function (Checkinvoice, $log, $http, $uibModal) {
      var vm = this;

      this.$onInit = function () {
        var search = {};

        vm.currentpage = 1;

        vm.invdatetpl = 'finance/invoice/invoiceDateTpl.html';

        vm.pageChanged = pageChanged;
        vm.storno = storno;
        vm.sendReminder = sendReminder;
        vm.enterPaidDate = enterPaidDate;

        search.page = vm.currentpage;
        search.query = {};

        switch (vm.mode) {
          case 'showstorno':
            search.query.storno = true;
            vm.title = 'Stornierte Zielrechnungen';
            break;
          case 'hidestorno':
            search.query.storno = false;
            vm.title = 'Unstornierte Zielrechnungen';
            break;
          case 'showstest':
            search.query.test = true;
            vm.title = 'Test-Zielrechnungen';
            break;
          case 'hidetest':
            search.query.test = false;
            vm.title = 'Zielrechnungen (ohne Testrechnungen)';
            break;
          case 'open':
            search.query.paid = false;
            search.query.test = false;
            search.query.storno = false;
            vm.title = 'Offene Zielrechnungen';
            break;
          case 'paid':
            search.query.paid = true;
            search.query.test = false;
            search.query.storno = false;
            vm.title = 'Bezahlte Zielrechnungen';
            break;
          case 'overdue':
            search.query.paid = false;
            search.query.test = false;
            search.query.storno = false;
            search.query.date = { $lt: moment().subtract(15, 'days').toISOString() };
            vm.title = 'Überfällige Zielrechnungen';
            break;
          default:
            vm.title = 'Zielrechnungen';
            break;
        }

        search.options = {};
        search.options.fields = {
          _id: 1,
          invoicenr: 1,
          date: 1,
          fdate: 1,
          total: 1,
          tax: 1,
          storno: 1,
          test: 1,
          paytype: 1,
          patientinvoiceid: 1,
          doctorinvoiceid: 1,
          receiptid: 1,
          stornoreceiptid: 1,
          patientid: 1,
          paiddate: 1,
          fpaiddate: 1,
          duedate: 1,
          paid: 1
        };

        vm.checkinvoices = Checkinvoice.$search(search).$then(function (inv) {
          vm.totalItems = inv.$pageCount;
        });
      }; // $onInit

      function pageChanged() {
        vm.checkinvoices.$refresh({ page: vm.currentPage });
      }

      function storno(invoice) {
        $log.debug('storno invoice: ', invoice);
        invoice.$destroy().$then(function () {
          vm.checkinvoices.$refresh().$then(function (inv) {
            vm.totalItems = inv.$pageCount;
          });
        });
      }

      function enterPaidDate(_invoice) {
        $uibModal.open({
          templateUrl: 'vcfinance/invoice/invoiceDateTpl.html',
          controllerAs: 'miCtrl',
          controller: ['invoice', '$uibModalInstance', function (inv, $uibModalInstance) {
            var vmi = this;
            vmi.invoice = inv;
            vmi.dialog = $uibModalInstance;

            // TODO: options are completyl ignored, figure out how to enable maxDate
            vmi.dateoptions = {
              maxDate: new Date(),
              showWeeks: true
            };
            vmi.setDate = setDate;

            function setDate() {
              vmi.invoice.paiddate = moment(vmi.paiddate).toISOString();
              vmi.invoice.fpaiddate = moment(vmi.paiddate).locale('de-at').format('ll');
              vmi.invoice.paid = true;
              // $log.debug('Paiddate: ', vmi.paiddate);
              // $log.debug('Invoice Paiddate: ', vmi.invoice.paiddate);
              $log.debug('Invoice FPaiddate: ', vmi.invoice.fpaiddate);
              vmi.invoice.$save();
              vmi.dialog.close();
            }
          }],
          resolve: {
            invoice: function invoice() {
              return _invoice;
            }
          },
          size: 'md'
        });
      }

      // TODO: this does not work yet
      function sendReminder(invoice) {
        invoice.reminded = true;
        invoice.remindeddate = moment().toISOString();
        invoice.fremindeddate = moment().locale('de-at').format('ll');

        $http({
          url: '/routes/pdfprinter/consultprint',
          method: 'GET',
          params: {
            patientid: invoice.patientid,
            consultid: invoice.consultid,
            doctype: 'reminder'
          }
        }).then(function success(r) {
          if (!angular.isArray(invoice.reminders)) {
            invoice.reminders = [];
          }
          invoice.reminders.push({ date: invoice.remindeddate, fdate: invoice.fremindeddate, doc: r.docid });
          $log.debug('Reminder docid: ', r.docid);
          // invoice.$save();
        }, function error(r) {
          $log.debug('Printsaving Reminder PDF failed: ', r);
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name cashinvoice.factory:Cashinvoice
   *
   * @description
   *
   */
  angular.module('vcfinance.invoice').factory('Cashinvoice', Cashinvoice);

  Cashinvoice.$inject = ['restmod'];

  function Cashinvoice(restmod) {
    return restmod.model('/routes/cashinvoices', 'PagedModel').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      }
    });
  }
})();
/**
 * Created by lari on 06/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.invoice').component('cashinvoice', {
    restrict: 'E',
    templateUrl: 'vcfinance/invoice/cashinvoice-component.tpl.html',
    controllerAs: 'vm',
    bindings: {
      mode: '@'
    },
    controller: ['Cashinvoice', '$log', function (Cashinvoice, $log) {
      var vm = this;

      vm.currentPage = 1;
      vm.pageChanged = pageChanged;
      vm.storno = storno;

      this.$onInit = function () {
        var search = {};

        search.page = vm.currentpage;
        search.query = {};

        switch (vm.mode) {
          case 'showstorno':
            search.query.storno = true;
            vm.title = 'Stornierte Barrechnungen';
            break;
          case 'hidestorno':
            search.query.storno = false;
            vm.title = 'Unstornierte Barrechnungen';
            break;
          case 'showstest':
            search.query.test = true;
            vm.title = 'Test-Barrechnungen';
            break;
          case 'hidetest':
            search.query.test = false;
            vm.title = 'Barrechnungen (ohne Testrechnungen)';
            break;
          default:
            vm.title = 'Barrechnungen';
            break;
        }

        search.options = {};
        search.options.fields = {
          _id: 1,
          invoicenr: 1,
          date: 1,
          fdate: 1,
          total: 1,
          tax: 1,
          storno: 1,
          test: 1,
          paytype: 1,
          patientinvoiceid: 1,
          doctorinvoiceid: 1,
          receiptid: 1,
          stornoreceiptid: 1,
          patientid: 1
        };

        vm.cashinvoices = Cashinvoice.$search(search).$then(function (inv) {
          vm.totalItems = inv.$pageCount;
        });
      };

      function pageChanged() {
        vm.cashinvoices.$refresh({ page: vm.currentPage }).$then(function (inv) {
          vm.totalItems = inv.$pageCount;
        });
      }

      function storno(invoice) {
        $log.debug('storno invoice: ', invoice);
        invoice.$destroy().$then(function () {
          vm.cashinvoices.$refresh();
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcfinance.closing', ['ui.router', 'ui.bootstrap']);
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name closing.factory:Closing
   *
   * @description
   *
   */
  angular.module('vcfinance.closing').factory('Closing', Closing);

  Closing.$inject = ['restmod'];

  function Closing(restmod) {
    return restmod.model('/routes/fiscaljournal');
  }
})();
/**
 * @ngdoc directive
 * @name closing.directive:closing
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="closing">
 <file name="index.html">
 <closing></closing>
 </file>
 </example>
 *
 */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.closing').component('closing', {
    restrict: 'E',
    templateUrl: 'vcfinance/closing/closing-component.tpl.html',
    controllerAs: 'vm',
    controller: ['Closing', '$log', '$http', function (Closing, $log, $http) {
      var vm = this;
      vm.startdate = new Date(moment().year(), 0, 1).toISOString();
      // vm.enddate = new Date().toISOString();
      vm.enddate = moment().add(1, 'days').toISOString();
      vm.rangequery = rangequery;
      vm.lastmonth = lastmonth;
      vm.freeinterval = freeinterval;

      function lastmonth() {
        var lastm = moment().subtract(1, 'month');
        var start = lastm.startOf('month').toISOString();
        var end = lastm.endOf('month').toISOString();
        $log.debug('Startdate: ', start);
        $log.debug('enddate: ', end);
        var cashname = 'umsatz_bar_karte-' + lastm.format('YYYY_MM') + '.csv';
        var checkname = 'umsatz_zielrechnung-' + lastm.format('YYYY_MM') + '.csv';
        rangequery(start, end, '/routes/fiscaljournal', cashname);
        rangequery(start, end, '/routes/checkjournal', checkname);
      }

      function freeinterval() {
        var start = moment.utc(vm.startdate).toISOString();
        var end = moment.utc(vm.enddate).toISOString();
        $log.debug('Startdate: ', start);
        $log.debug('enddate: ', end);
        var cashname = 'umsatz_bar_karte.csv';
        var checkname = 'umsatz_zielrechnung.csv';
        rangequery(start, end, '/routes/fiscaljournal', cashname);
        rangequery(start, end, '/routes/checkjournal', checkname);
        vm.start = null;
        vm.end = null;
      }

      function rangequery(start, end, url, filename) {
        var query = {
          created: {
            $gte: start,
            $lt: end
          }
        };
        var qq = {
          $gte: start,
          $lt: end
        };

        $log.debug('query: ', JSON.stringify(qq));
        var tmp = url + '?created=' + encodeURIComponent(JSON.stringify(qq));
        $log.debug('tmp: ', tmp);
        // $log.debug('query: ', JSON.stringify(query));
        $http.get(tmp, {}).success(function (data, status, headers, config) {
          var anchor = angular.element('<a/>');
          anchor.attr({
            href: 'data:attachment/csv;charset=utf-8,' + encodeURI(data),
            target: '_blank',
            download: filename
          })[0].click();
        }).error(function (data, status, headers, config) {
          $log.error('Ficaljournal filegeneration and export failed');
          $log.error(status);
          $log.error(headers);
          $log.error(data);
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name cashbook
   * @description
   *
   */
  angular.module('vcfinance.cashbook', ['ui.router']);
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name cashbook.factory:Cashbook
   *
   * @description
   *
   */
  angular.module('vcfinance.cashbook').factory('Cashbook', Cashbook).factory('Fiscaljournal', Fiscaljournal);

  Cashbook.$inject = ['restmod', '$log'];
  Fiscaljournal.$inject = ['restmod', '$log'];

  // gets the current cash-amount
  function Cashbook(restmod) {
    return restmod.model('/routes/cashbook');
  }

  // gets cashbook history
  function Fiscaljournal(restmod) {
    return restmod.model('/routes/cashbookhistory', 'PagedModel');
  }
})();
/**
 * Created by lari on 09/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.cashbook').component('cashbook', {
    restrict: 'E',
    templateUrl: 'vcfinance/cashbook/cashbook-component.tpl.html',
    controllerAs: 'vm',
    controller: ['Cashbook', 'Fiscaljournal', '$log', 'vertxEventBusService', function (Cashbook, Fiscaljournal, $log, vertxEventBusService) {
      var vm = this;
      vm.currentPage = 1;
      vm.pageChanged = pageChanged;

      vm.cashbook = Cashbook.$search();
      vm.cashlog = Fiscaljournal.$search().$then(function (log) {
        vm.totalItems = log.$pageCount;
      });

      vm.deposit = deposit;
      vm.withdrawal = withdrawal;

      function deposit() {
        vm.cashbook[0].amount = vm.depositvalue;
        vm.cashbook[0].add = true;
        vm.cashbook[0].$save().$then(function () {
          vm.depositvalue = 0;
          vm.cashbook.$refresh();
          vm.cashlog.$refresh();
        });
      }

      function withdrawal() {
        vm.cashbook[0].amount = vm.withdrawalvalue;
        vm.cashbook[0].add = false;
        vm.cashbook[0].$save().$then(function () {
          vm.withdrawalvalue = 0;
          vm.cashbook.$refresh();
          vm.cashlog.$refresh();
        });
      }

      function pageChanged() {
        vm.cashlog.$refresh({ page: vm.currentPage }).$then(function (log) {
          vm.totalItems = log.$pageCount;
        });
      }

      var journalUpdateHandler = function journalUpdateHandler(message) {
        $log.debug('debug: examtemplate update received: ', message);
        if (angular.isDefined(vm.cashbook)) {
          vm.cashbook.$refresh().$then(function () {
            $log.debug('debug: examtemplatelist refreshed examtemplates');
          }, function (error) {
            $log.debug('debug: examtemplatelist refresh examtemplates failed: ', error);
          });
        }
      };

      vertxEventBusService.on('journal.update', {}, journalUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('journal.update', {}, journalUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcfinance.cart
   * @description
   *
   */
  angular.module('vcfinance.cart', ['vcutils', 'vcutils.printhelper']);
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of carts (patients) to display or load carts */

'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.cart').component('cartlist', {
    restrict: 'E',
    bindings: {
      clientid: '<'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="cart in vm.carts">\n            <td>{{cart.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editCart(cart)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeCart(cart)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Cart', 'CartHelper', 'vertxEventBusService', function ($log, $http, Rlog, Cart, CartHelper, vertxEventBusService) {
      var vm = this;
      vm.editCart = CartHelper.editCart;
      vm.removeCart = removeCart;

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.clientid)) {
            vm.clientid = changes.clientid.currentValue;
            // Cart.$getCart({clientid: vm.clientid}).$then(function (carts) {
            Cart.$getCart(vm.clientid).$then(function (carts) {
              vm.cart = carts[0];
            }, function (err) {
              $log.error('cart search by foreign id failed, clientid: ', vm.clientid);
              Rlog.error('cart', 'cartlist', 'cart search by foreign id failed', {
                clientid: vm.clientid
              });
            });
          }
        }
      };

      function removeCart(cart) {
        cart.active = false;
        cart.$save();
      }

      vertxEventBusService.on('carts.update', function (message) {
        $log.debug('debug: cart update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.carts)) {
          vm.carts.$refresh().$then(function () {
            $log.debug('debug: cartlist refreshed carts');
          }, function (error) {
            $log.debug('debug: cartlist refresh carts failed: ', error);
          });
        }
      });

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('carts.update', {}, function () {}, function (err) {
          $log.error('Failed to unregister carts.update handler: ', err);
        });
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.cart').component('cartform', {
    restrict: 'E',
    bindings: {
      cart: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcfinance/cart/cartform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastcart = angular.copy(vm.cart);
      };

      function save() {
        if (!angular.equals(vm.cart, vm.lastcart)) {
          vm.lastcart = angular.copy(vm.cart);
          vm.parentsave({ cart: vm.cart });
        }
      }

      function cancel() {
        vm.cart = angular.copy(vm.lastcart);
        vm.oncancel();
      }

      /*          function zipsave (zip, city) {
                  $log.debug('debug: cartform zipsave called: ', zip, city);
                  // vm.cart.postcode = zip;
                  // vm.cart.city = city;
                }*/
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
    'use strict';
    angular.module('vcfinance.cart').component('carteditorstandalone', {
        restrict: 'E',
        bindings: {
            clientid: '<?',
            showtaxdetails: '@?',
            diagnoses: '<?',
            timeframe: '<?',
            test: '<?'
        },
        template: '\n        <form>\n<!--        <div ng-show="vm.diagnoses">\n          <h4>Diagnosen für Rechnung</h4>\n          <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.parentsave()"></diagnosesedit>\n          &lt;!&ndash;<textarea ng-model="vm.cart.invoicediagnoses" class="form-control" required ng-blur="vm.setDiagnoses(vm.cart.invoicediagnoses)"></textarea>&ndash;&gt;\n        </div>-->\n        \n        <h3>Rechung ohne neue Konsultation erstellen</h3>\n        <div ng-show="vm.timeframe">\n          <h4>Leistungszeitraum</h4>\n          <input type="text" ng-model="vm.cart.timeframe" class="form-control" required ng-blur="vm.setTimeframe(vm.cart.timeframe)">\n        </div>\n        <h4>Suche nach Dienstleistungen</h4>\n        <privcatsearch privcat="" privcatref="" hideaddoption="true" onselectcb="vm.addItem(privcat, privcatref)"></privcatsearch>\n\n        <h4>Leistungsgruppen</h4>\n        <privcatgroupchooser onselectcb="vm.addItem(privcat, privcatref)"></privcatgroupchooser>\n\n\n        <h4>Warenkorb</h4>\n        <table class="table">\n        <colgroup>\n          <col width="15%">\n          <col width="63%">\n          <col width="12%">\n          <col width="10%">\n        </colgroup>\n        <tr class="table-header">\n          <th>Stk</th>\n          <th>Bezeichnung</div>\n          <th class="text-right">Brutto</th>\n          <th class="text-right">Steuer</th>\n        </tr>\n        \n<!--    items -->\n        <tr ng-repeat="item in vm.cart.items">\n          <td  style="vertical-align: middle">\n          <span class="input-group">\n            <input type="number" ng-if="item.repeatable === true" ng-model="item.quantity" min="1"\n                   class="form-control"\n                   ng-change="vm.updateItem(item)">\n            <input type="number" ng-if="item.repeatable === false" ng-model="item.quantity" min="1" max="1"\n                   class="form-control"\n                   readonly\n                   ng-change="vm.updateItem(item)">\n                   <span class="input-group-btn">\n                        <span class="btn btn-danger" uib-tooltip="Position entfernen"\n                              ng-click="vm.removeItem(item)">\n                            <i class="fa fa-remove"></i></span>\n                        </span>\n                   </span>\n          </td>\n          <td  style="vertical-align: middle">{{item.name}}\n            <br ng-show="item.details && item.details.length >0">{{item.details}} </td>\n          <td class="text-right"  style="vertical-align: middle">&euro;&nbsp;{{(item.price * item.quantity) | number: 2}}</td>\n          <td class="text-right"  style="vertical-align: middle">{{item.tax}}%</td>\n        </tr>\n<!-- cart summary -->\n        <tr style="font-weight: bold; border-top: solid 1px black;">\n          <td></td>\n          <td class="text-right">Netto:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.netto| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: solid 1px black;">\n          <td></td>\n          <td class="text-right">Steuer gesamt:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.taxdiscounted| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold;" ng-show="vm.showtaxdetails" ng-repeat="(key, val) in vm.cart.inv.discounttaxsum">\n          <td></td>\n          <td class="text-right">Steuer {{key}}%:</td>\n          <td class="text-right">&euro;&nbsp;{{val| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n                <tr style="font-weight: bold; border-bottom: double 1px black;">\n          <td></td>\n          <td class="text-right">Brutto:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.totalbefore| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: solid 1px black; vertical-align: middle">\n          <td></td>\n          <td class="text-right" style="vertical-align: middle">Rabatt:</td>\n          <!--<td class="text-right">&euro;&nbsp;-{{vm.cart.inv.discount| number: 2}}</td>-->\n          <td class="text-right" style="white-space: nowrap;">&euro;&nbsp;&ndash;&nbsp;<input type="quantity" step="0.01" min="0"  max="{{vm.cart.inv.total}}"\n                                                     class="form-control"\n                                                     style="width: 75%; display: inline; text-align: right"\n                                                     ng-blur="vm.setDiscount(vm.cart.inv.discount)"\n                                                     ng-model="vm.cart.inv.discount">\n          </td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: double 1px black;">\n          <td></td>\n          <td class="text-right">Gesamt:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.total| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        </table>\n        </form>\n   \n\n        \n         <form name="payment" ng-hide="vm.invstarted">\n              <!--    Payment method     -->\n              <div class="spacer-top">\n                  <div class="alert alert-warning" ng-show="vm.cart.items.length  > 0">\n                      <h4>Bezahlmethode</h4>\n                      <label><input type="radio" ng-model="vm.paytype" value="cash" required> Bar</label>\n                      <label><input type="radio" ng-model="vm.paytype" value="card" required> Bankomat o. Kreditkarte</label>\n                      <label><input type="radio" ng-model="vm.paytype" value="bill" required> Rechnung mit Zahlschein</label>\n                  </div>\n              </div>\n            \n              <!--   Wechselgeld -->\n              <div class="spacer-top spacer-bottom" ng-hide="vm.paytype !== \'cash\'">\n                  <div class="alert alert-info">\n                      <div class="row">\n                      <div class="col-xs-12"><h4>Wechselgeld</h4></div>\n                      <div class="col-xs-6">\n                          <label>Erhalten</label>\n                          <input type="quantity" min="0" step="0.01" ng-model="vm.cashin"\n                                 ng-model-options="{ debounce: 1000 }"\n                                 style="text-align: right" class="form-control"\n                                 ng-change="vm.calcChange(vm.cashin, vm.cart.inv.total)"\n                                 >\n                      </div>\n                      <div class="col-xs-6">\n                          <label>Retour</label>\n                          <input type="quantity" min="0" step="0.01" ng-model="vm.return"\n                                 class="form-control" readonly style="text-align: right">\n                      </div>\n                      </div>\n                  </div>\n              </div>\n              <!-- Buttons -->\n              <!--   Invoice Preview -->\n              <div class="spacer-top spacer-bottom" ng-show="vm.cart.items.length > 0">\n                  <a class="btn btn-info" href="{{vm.previewlink}}" target="_blank">\n                        <i class="fa fa-eye"></i> Rechnungsvorschau\n                  </a>\n                  <div class="btn btn-success" ng-click="vm.invoiceCart()"  ng-show="vm.cart.items.length > 0" ng-disabled="payment.$invalid">\n                    <i class="fa fa-money"></i> Rechnung ausstellen\n                  </div>                  \n              </div>\n         </form>    \n         \n            <div class="spacer-bottom spacer-top" ng-show="vm.invstarted">\n              <h4>Rechnungen/Beleg</h4>\n              <div class="alert alert-info" ng-show="vm.invcount">\n                  <h4><i class="fa fa-spinner fa-spin"></i> {{vm.invcount}} Rechnungsdokumente werden erstellt!</h4>\n              </div>\n              <div ng-repeat="doc in vm.invdocs">\n                <a href="/routes/pdfreader/{{doc.fileid}}" target="_blank">\n                  <span class="fa fa-file-pdf-o"></span> {{doc.type}}\n                </a>\n              </div>\n            </div> \n      ',
        controllerAs: 'vm',
        controller: ['$log', 'Cart', 'Rlog', 'vertxEventBusService', 'ConsultHelper', 'PrintHelper', 'ClientHelper', '$http', function ($log, Cart, Rlog, vertxEventBusService, ConsultHelper, PrintHelper, ClientHelper, $http) {
            var vm = this;
            vm.updateItem = updateItem;
            vm.addItem = addItem;
            vm.removeItem = removeItem;
            vm.setDiscount = setDiscount;
            vm.setDiagnoses = setDiagnoses;
            vm.setTimeframe = setTimeframe;
            vm.calcChange = calcChange;
            vm.parentsave = parentsave;
            vm.invoiceCart = invoiceCart;

            vm.invdocs = [];
            vm.invstarted = false;

            function invoiceCart() {
                vm.invstarted = true;

                if (vm.paytype === 'cash' || vm.paytype === 'card') {
                    vm.invcount = 3;
                    $http.post('/routes/cashinvoices/' + vm.clientid + '/' + vm.paytype).then(function (inv) {
                        $log.debug('cash inv answer: ', inv);

                        vm.invdocs.push({
                            type: 'Rechnung (Patientenkopie)',
                            fileid: inv.data.patientinvoiceid
                        });
                        vm.invdocs.push({
                            type: 'Rechnung (Arztkopie)',
                            fileid: inv.data.doctorinvoiceid
                        });
                        if (angular.isDefined(inv.data.doctorinvoiceid) && inv.data.doctorinvoiceid.length > 0) {
                            vm.invdocs.push({ type: 'Beleg', fileid: inv.data.receiptid });
                        }
                        $http.post('/routes/carts/' + vm.clientid + '/closecart').then(function () {
                            $log.debug('Cart close succeeded');
                        }, function (err) {
                            $log.error('Cart close failed', err);
                        });
                        vm.invcount = 0;
                    }, function (error) {
                        $log.error('CashinvoicePrintfailed: ', error);
                        vm.invdocs.push({ type: 'Rechnung fehlgeschlagen', fileid: '' });
                        vm.invcount = 0;
                    });
                }

                if (vm.paytype === 'bill') {
                    vm.invcount = 2;
                    $http.post('/routes/checkinvoices/' + vm.clientid).then(function (inv) {
                        vm.invdocs.push({
                            type: 'Rechnung (Patientenkopie)',
                            fileid: inv.data.patientinvoiceid
                        });
                        vm.invdocs.push({
                            type: 'Rechnung (Arztkopie)',
                            fileid: inv.data.doctorinvoiceid
                        });
                        $http.post('/routes/carts/' + vm.clientid + '/closecart').then(function () {
                            $log.debug('Cart close succeeded');
                        }, function (err) {
                            $log.error('Cart close failed', err);
                        });
                        vm.invcount = 0;
                    }, function (error) {
                        $log.error('CheckinvoicePrintfailed: ', error);
                        // $rootScope.connfailure = 0;
                        vm.invdocs.push({ type: 'Rechnung fehlgeschlagen', fileid: '' });
                        vm.invcount = 0;
                    });
                }
            }

            $log.debug('Carteditor called: ', vm.clientid, vm.diagnoses);

            vm.$onInit = function () {
                if ((angular.isUndefined(vm.cart) || !vm.cart.hasOwnProperty('_id')) && angular.isDefined(vm.cartid)) {
                    Cart.$find(vm.cartid).$then(function (cart) {
                        vm.cart = cart;
                    }, function (err) {
                        $log.error('cart not found, id: ', vm.cartid);
                        Rlog.error('cart', 'carteditor', 'cart not found', { _id: vm.cartid });
                    });
                }
                if (angular.isDefined(vm.clientid)) {
                    getCart();
                    getClient();
                }
            };

            // vm.clientid might be late propagating, get exams on first change
            vm.$onChanges = function (changes) {
                if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue) && changes.clientid.currentValue.length > 0) {
                    vm.clientid = changes.clientid.currentValue;
                    /*              if (angular.isDefined(vm.clientid)) {
                                    getCart();
                                  }*/
                    getCart();
                    getClient();
                }
                $log.debug('changes: ', changes);
                if (angular.isDefined(changes.diagnoses) && angular.isDefined(changes.diagnoses.currentValue)) {
                    vm.initialdiagnoses = changes.diagnoses.currentValue;
                }

                if (angular.isDefined(changes.timeframe) && angular.isDefined(changes.timeframe.currentValue)) {
                    vm.timeframe = changes.timeframe.currentValue;
                    Cart.setTimeframe(vm.clientid, vm.timeframe);
                }
            };

            function calcChange(received, total) {
                var quantity = received - total;
                var factor = Math.pow(10, 2);
                vm['return'] = Math.round(quantity * factor) / factor;
            }

            function getCart() {
                Cart.getCart(vm.clientid).then(function (res) {
                    $log.debug('getCart res: ', res);
                    vm.cart = res.data;
                    if (angular.isDefined(vm.initialdiagnoses)) {
                        vm.cart.invoicediagnoses = vm.initialdiagnoses;
                    }

                    if (angular.isDefined(vm.timeframe)) {
                        vm.cart.timeframe = vm.timeframe;
                    }
                    vm.previewlink = PrintHelper.cartPreviewUrl(vm.cart._id);
                }, function (err) {
                    $log.error('getCart failed for clientid: ', vm.clientid);
                });
            }

            function getClient() {
                ClientHelper.find('patient', vm.clientid).$then(function (client) {
                    vm.client = client;
                    if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                        vm.client.deleteddiagnoses = [];
                        vm.client.$save();
                        $log.debug('initalised deleteddiagnoses to empty array');
                    }
                    setDiagnoses(vm.client.diagnoses);
                }, function (err) {
                    vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
                    Rlog.error('client', 'carteditor', 'client.$find() failed', { id: vm.clientid });
                });
            }

            function updateItem(item) {
                Cart.updateItem(vm.clientid, item).then(function (res) {}, function (err) {
                    $log.error('updateItem failed for clientid/clientid, item: ', vm.clientid, item._id, item.name);
                });
            }

            function removeItem(item) {
                Cart.removeItem(vm.clientid, item).then(function (res) {}, function (err) {
                    $log.error('removeItem failed for clientid/clientid, item: ', vm.clientid, item._id, item.name);
                });
            }

            function addItem(privcat, privcatref) {
                $log.debug('addItem privcat: ', privcat, privcatref);
                Cart.addItem(vm.clientid, privcat).then(function (res) {}, function (err) {
                    $log.error('addItem failed for clientid/clientid, item: ', vm.clientid, privcat._id, privcat.name);
                });
            }

            function setDiscount(discount) {
                Cart.setDiscount(vm.clientid, discount).then(function (res) {}, function (err) {
                    $log.error('setDiscount failed for clientid/clientid, item: ', vm.clientid);
                });
            }

            function setTimeframe(timeframe) {
                Cart.setDiscount(vm.clientid, timeframe).then(function (res) {}, function (err) {
                    $log.error('setTimeframe failed for clientid/clientid, item: ', vm.clientid);
                });
            }

            function setDiagnoses(diagnoses) {
                $log.debug('setdiagnoses called with: ', diagnoses);
                var invoicediagnoses = [];
                diagnoses.forEach(function (d) {
                    $log.debug('d: ', d, !d.hasOwnProperty('active') || d.active === true, !d.hasOwnProperty('hideInInvoices') || d.hideInInvoices === false);

                    if ((!d.hasOwnProperty('active') || d.active === true) && (!d.hasOwnProperty('hideInInvoice') || d.hideInInvoice === false)) {
                        $log.debug('d selected: ', d);
                        invoicediagnoses.push(d.key);
                    }
                });

                var flatdiagnoses = invoicediagnoses.join(', ');

                $log.debug('Updated flatdiagnoses: ', flatdiagnoses);
                Cart.setDiagnoses(vm.clientid, flatdiagnoses).then(function (res) {}, function (err) {
                    $log.error('setDiagnoses failed for clientid/clientid, item: ', vm.clientid);
                });
            }

            function parentsave() {
                $log.debug('**** carteditor parentsave called:', vm.client.diagnoses);
                setDiagnoses(vm.client.diagnoses);
                if (!angular.equals(vm.client, vm.lastclient)) {
                    vm.client.flatdiagnoses = vm.client.diagnoses.map(function (diag) {
                        return diag.key;
                    });
                    $log.debug('**** patientheader saving child :', vm.client.diagnoses, vm.client.flatdiagnoses);
                    vm.lastclient = angular.copy(vm.client);
                    if (vm.client.$hasPendingActions) {
                        vm.client.$cancel();
                    }
                    setDiagnoses(vm.client.diagnoses);
                    vm.client.$save().$then(function () {}, function (err) {
                        $log.error('debug/error: client save failed!', err);
                        Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: vm.client._id });
                    });
                }
            }

            var patientsUpdateHandler = function patientsUpdateHandler(message) {
                $log.debug('debug: Patient update received: ', message);
                var messages = message.split(':');
                if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
                    vm.client.$refresh().$then(function () {
                        setDiagnoses(vm.client.diagnoses);
                        $log.debug('debug: carteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                    }, function (error) {
                        $log.debug('debug: carteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
                    });
                }
            };

            var cartsUpdateHandler = function cartsUpdateHandler(message) {
                var messages = message.split(':');
                vm.cart = getCart();
                $log.debug('(carteditor) refreshed cart');
                // only refresh exam if change was NOT triggered by this browser tab
                /*            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
                              vm.cart = getCart();
                              $log.debug('(carteditor) refreshed cart');
                            }
                            else {
                              $log.debug(' (carteditor) ignored cart change');
                            }*/
            };

            vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
            vertxEventBusService.on('carts.update', {}, cartsUpdateHandler);

            vm.$onDestroy = function () {
                vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
                vertxEventBusService.unregisterHandler('carts.update', {}, cartsUpdateHandler);
            };
        }] // controller
    }); // component

    // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.cart').component('carteditor', {
    restrict: 'E',
    bindings: {
      clientid: '<?',
      showtaxdetails: '@?',
      diagnoses: '<?',
      timeframe: '<?',
      test: '<?'
    },
    template: '\n        <form>\n        <div ng-show="vm.diagnoses">\n          <h4>Diagnosen für Rechnung</h4>\n          <diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.parentsave()"></diagnosesedit>\n          <!--<textarea ng-model="vm.cart.invoicediagnoses" class="form-control" required ng-blur="vm.setDiagnoses(vm.cart.invoicediagnoses)"></textarea>-->\n        </div>\n        <div ng-show="vm.timeframe">\n          <h4>Leistungszeitraum</h4>\n          <input type="text" ng-model="vm.cart.timeframe" class="form-control" required ng-blur="vm.setTimeframe(vm.cart.timeframe)">\n        </div>\n        <h4>Suche nach Dienstleistungen</h4>\n        <privcatsearch privcat="" privcatref="" hideaddoption="true" onselectcb="vm.addItem(privcat, privcatref)"></privcatsearch>\n\n        <h4>Leistungsgruppen</h4>\n        <privcatgroupchooser onselectcb="vm.addItem(privcat, privcatref)"></privcatgroupchooser>\n\n\n        <h4>Warenkorb</h4>\n        <table class="table">\n        <colgroup>\n          <col width="15%">\n          <col width="63%">\n          <col width="12%">\n          <col width="10%">\n        </colgroup>\n        <tr class="table-header">\n          <th>Stk</th>\n          <th>Bezeichnung</div>\n          <th class="text-right">Brutto</th>\n          <th class="text-right">Steuer</th>\n        </tr>\n        \n    \n        <tr ng-repeat="item in vm.cart.items">\n          <td  style="vertical-align: middle">\n          <span class="input-group">\n            <input type="number" ng-if="item.repeatable === true" ng-model="item.quantity" min="1"\n                   class="form-control"\n                   ng-change="vm.updateItem(item)">\n            <input type="number" ng-if="item.repeatable === false" ng-model="item.quantity" min="1" max="1"\n                   class="form-control"\n                   readonly\n                   ng-change="vm.updateItem(item)">\n                   <span class="input-group-btn">\n                        <span class="btn btn-danger" uib-tooltip="Position entfernen"\n                              ng-click="vm.removeItem(item)">\n                            <i class="fa fa-remove"></i></span>\n                        </span>\n                   </span>\n          </td>\n          <td  style="vertical-align: middle">{{item.name}}\n            <br ng-show="item.details && item.details.length >0">{{item.details}} </td>\n          <td class="text-right"  style="vertical-align: middle">&euro;&nbsp;{{(item.price * item.quantity) | number: 2}}</td>\n          <td class="text-right"  style="vertical-align: middle">{{item.tax}}%</td>\n        </tr>\n\n        <tr style="font-weight: bold; border-top: solid 1px black;">\n          <td></td>\n          <td class="text-right">Netto:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.netto| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: solid 1px black;">\n          <td></td>\n          <td class="text-right">Steuer gesamt:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.taxdiscounted| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold;" ng-show="vm.showtaxdetails" ng-repeat="(key, val) in vm.cart.inv.discounttaxsum">\n          <td></td>\n          <td class="text-right">Steuer {{key}}%:</td>\n          <td class="text-right">&euro;&nbsp;{{val| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n                <tr style="font-weight: bold; border-bottom: double 1px black;">\n          <td></td>\n          <td class="text-right">Brutto:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.totalbefore| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: solid 1px black; vertical-align: middle">\n          <td></td>\n          <td class="text-right" style="vertical-align: middle">Rabatt:</td>\n          <!--<td class="text-right">&euro;&nbsp;-{{vm.cart.inv.discount| number: 2}}</td>-->\n          <td class="text-right" style="white-space: nowrap;">&euro;&nbsp;&ndash;&nbsp;<input type="quantity" step="0.01" min="0"  max="{{vm.cart.inv.total}}"\n                                                     class="form-control"\n                                                     style="width: 75%; display: inline; text-align: right"\n                                                     ng-blur="vm.setDiscount(vm.cart.inv.discount)"\n                                                     ng-model="vm.cart.inv.discount">\n          </td>\n          <td class="text-right"></td>\n        </tr>\n        <tr style="font-weight: bold; border-bottom: double 1px black;">\n          <td></td>\n          <td class="text-right">Gesamt:</td>\n          <td class="text-right">&euro;&nbsp;{{vm.cart.inv.total| number: 2}}</td>\n          <td class="text-right"></td>\n        </tr>\n        </table>\n        </form>\n        \n        <div class="spacer-top spacer-bottom" ng-show="vm.cart.items.length > 0">\n            <div class="alert alert-info">\n                <div class="row">\n                <div class="col-xs-12"><h4>Wechselgeld</h4></div>\n                <div class="col-xs-6">\n                    <label>Erhalten</label>\n                    <input type="quantity" min="0" step="0.01" ng-model="vm.cashin"\n                           ng-model-options="{ debounce: 1000 }"\n                           style="text-align: right" class="form-control"\n                           ng-change="vm.calcChange(vm.cashin, vm.cart.inv.total)"\n                           >\n                </div>\n                <div class="col-xs-6">\n                    <label>Retour</label>\n                    <input type="quantity" min="0" step="0.01" ng-model="vm.return"\n                           class="form-control" readonly style="text-align: right">\n                </div>\n                </div>\n            </div>\n        </div>\n        \n        <div class="spacer-top spacer-bottom" ng-show="vm.cart.items.length > 0">\n            <a class="btn btn-info" href="{{vm.previewlink}}" target="_blank">\n                      <i class="fa fa-eye"></i> Rechnungsvorschau\n            </a>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Cart', 'Rlog', 'vertxEventBusService', 'ConsultHelper', 'PrintHelper', 'ClientHelper', function ($log, Cart, Rlog, vertxEventBusService, ConsultHelper, PrintHelper, ClientHelper) {
      var vm = this;
      vm.updateItem = updateItem;
      vm.addItem = addItem;
      vm.removeItem = removeItem;
      vm.setDiscount = setDiscount;
      vm.setDiagnoses = setDiagnoses;
      vm.setTimeframe = setTimeframe;
      vm.calcChange = calcChange;
      vm.parentsave = parentsave;

      $log.debug('Carteditor called: ', vm.clientid, vm.diagnoses);

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.cart) || !vm.cart.hasOwnProperty('_id')) && angular.isDefined(vm.cartid)) {
          Cart.$find(vm.cartid).$then(function (cart) {
            vm.cart = cart;
          }, function (err) {
            $log.error('cart not found, id: ', vm.cartid);
            Rlog.error('cart', 'carteditor', 'cart not found', { _id: vm.cartid });
          });
        }
        if (angular.isDefined(vm.clientid)) {
          getCart();
          getClient();
        }
      };

      // vm.clientid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue) && changes.clientid.currentValue.length > 0) {
          vm.clientid = changes.clientid.currentValue;
          /*              if (angular.isDefined(vm.clientid)) {
                          getCart();
                        }*/
          getCart();
          getClient();
        }
        $log.debug('changes: ', changes);
        if (angular.isDefined(changes.diagnoses) && angular.isDefined(changes.diagnoses.currentValue)) {
          vm.initialdiagnoses = changes.diagnoses.currentValue;
        }

        if (angular.isDefined(changes.timeframe) && angular.isDefined(changes.timeframe.currentValue)) {
          vm.timeframe = changes.timeframe.currentValue;
          Cart.setTimeframe(vm.clientid, vm.timeframe);
        }
      };

      function calcChange(received, total) {
        var quantity = received - total;
        var factor = Math.pow(10, 2);
        vm['return'] = Math.round(quantity * factor) / factor;
      }

      function getCart() {
        Cart.getCart(vm.clientid).then(function (res) {
          $log.debug('getCart res: ', res);
          vm.cart = res.data;
          if (angular.isDefined(vm.initialdiagnoses)) {
            vm.cart.invoicediagnoses = vm.initialdiagnoses;
          }

          if (angular.isDefined(vm.timeframe)) {
            vm.cart.timeframe = vm.timeframe;
          }
          vm.previewlink = PrintHelper.cartPreviewUrl(vm.cart._id);
        }, function (err) {
          $log.error('getCart failed for patientid: ', vm.clientid);
        });
      }

      function getClient() {
        ClientHelper.find('patient', vm.clientid).$then(function (client) {
          vm.client = client;
          if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
            vm.client.deleteddiagnoses = [];
            vm.client.$save();
            $log.debug('initalised deleteddiagnoses to empty array');
          }
          setDiagnoses(vm.client.diagnoses);
        }, function (err) {
          vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
          Rlog.error('client', 'carteditor', 'client.$find() failed', { id: vm.clientid });
        });
      }

      function updateItem(item) {
        Cart.updateItem(vm.clientid, item).then(function (res) {}, function (err) {
          $log.error('updateItem failed for clientid/patientid, item: ', vm.clientid, item._id, item.name);
        });
      }

      function removeItem(item) {
        Cart.removeItem(vm.clientid, item).then(function (res) {}, function (err) {
          $log.error('removeItem failed for clientid/patientid, item: ', vm.clientid, item._id, item.name);
        });
      }

      function addItem(privcat, privcatref) {
        $log.debug('addItem privcat: ', privcat, privcatref);
        Cart.addItem(vm.clientid, privcat).then(function (res) {}, function (err) {
          $log.error('addItem failed for clientid/patientid, item: ', vm.clientid, privcat._id, privcat.name);
        });
      }

      function setDiscount(discount) {
        Cart.setDiscount(vm.clientid, discount).then(function (res) {}, function (err) {
          $log.error('setDiscount failed for clientid/patientid, item: ', vm.clientid);
        });
      }

      function setTimeframe(timeframe) {
        Cart.setDiscount(vm.clientid, timeframe).then(function (res) {}, function (err) {
          $log.error('setTimeframe failed for clientid/patientid, item: ', vm.clientid);
        });
      }

      function setDiagnoses(diagnoses) {
        $log.debug('setdiagnoses called with: ', diagnoses);
        var invoicediagnoses = [];
        diagnoses.forEach(function (d) {
          $log.debug('d: ', d, !d.hasOwnProperty('active') || d.active === true, !d.hasOwnProperty('hideInInvoices') || d.hideInInvoices === false);

          if ((!d.hasOwnProperty('active') || d.active === true) && (!d.hasOwnProperty('hideInInvoice') || d.hideInInvoice === false)) {
            $log.debug('d selected: ', d);
            invoicediagnoses.push(d.key);
          }
        });

        var flatdiagnoses = invoicediagnoses.join(', ');

        $log.debug('Updated flatdiagnoses: ', flatdiagnoses);
        Cart.setDiagnoses(vm.clientid, flatdiagnoses).then(function (res) {}, function (err) {
          $log.error('setDiagnoses failed for clientid/patientid, item: ', vm.clientid);
        });
      }

      function parentsave() {
        $log.debug('**** carteditor parentsave called:', vm.client.diagnoses);
        setDiagnoses(vm.client.diagnoses);
        if (!angular.equals(vm.client, vm.lastclient)) {
          vm.client.flatdiagnoses = vm.client.diagnoses.map(function (diag) {
            return diag.key;
          });
          $log.debug('**** patientheader saving child :', vm.client.diagnoses, vm.client.flatdiagnoses);
          vm.lastclient = angular.copy(vm.client);
          if (vm.client.$hasPendingActions) {
            vm.client.$cancel();
          }
          setDiagnoses(vm.client.diagnoses);
          vm.client.$save().$then(function () {}, function (err) {
            $log.error('debug/error: client save failed!', err);
            Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: vm.client._id });
          });
        }
      }

      var cartsUpdateHandler = function cartsUpdateHandler(message) {
        var messages = message.split(':');
        vm.cart = getCart();
        $log.debug('(carteditor) refreshed cart');
        // only refresh exam if change was NOT triggered by this browser tab
        /*            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
                      vm.cart = getCart();
                      $log.debug('(carteditor) refreshed cart');
                    }
                    else {
                      $log.debug(' (carteditor) ignored cart change');
                    }*/
      };

      var patientsUpdateHandler = function patientsUpdateHandler(message) {
        $log.debug('debug: Patient update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
          vm.client.$refresh().$then(function () {
            setDiagnoses(vm.client.diagnoses);
            $log.debug('debug: carteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          }, function (error) {
            $log.debug('debug: carteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          });
        }
      };

      vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
      vertxEventBusService.on('carts.update', {}, cartsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
        vertxEventBusService.unregisterHandler('carts.update', {}, cartsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.cart').component('cartcounter', {
    restrict: 'E',
    bindings: {
      clientid: '<'
    },
    template: '\n        <span class="badge badge-info"  \n              uib-tooltip="Anzahl der unterschiedlichen Leistungen/Waren im Warenkorb, Gesamtzahl der Leistungen/Waren"  \n              tooltip-placement="auto">{{vm.counter}}/{{vm.total}}</span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Cart', 'Rlog', 'vertxEventBusService', '$http', function ($log, Cart, Rlog, vertxEventBusService, $http) {
      var vm = this;

      var getCounter = function getCounter() {
        Cart.getCount(vm.clientid).then(function (res) {
          vm.counter = 0;
          vm.total = 0;
          // $log.debug('**** cart Counter data: ', res.data );
          vm.counter = res.data.count;
          vm.total = res.data.total;
        }, function (err) {
          $log.error(err);
          Rlog.error('vcfinance.cart', 'cartcounter', 'counter aqusistion  failed', {});
        });
      };

      // vm.clientid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue)) {
          vm.clientid = changes.clientid.currentValue;
          if (angular.isDefined(vm.clientid)) {
            getCounter();
          }
        }
      };

      // listen for files updates
      vertxEventBusService.on('carts.update', getCounter);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('carts.update', {}, getCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcfinance.cart').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcfinancecart', {
      url: '/financecart',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;cartcounter clientid=""&gt;</tt></h3><div ui-view="cartcounterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;carteditor clientid=""&gt;</tt></h3><div ui-view="carteditview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.financevccart entered');
      }
    });

    $stateProvider.state('playground.vcfinancecart.allcomponents', {
      url: '/allcomponents',
      resolve: {
        clientid: function clientid() {
          return '571df9c97c01594fd0bbdf96';
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve

        'carteditview@playground.vcfinancecart': {
          component: 'carteditor',
          bindings: {
            clientid: 'clientid',
            showtaxdetails: 'clientid'
          }
        },
        'cartcounterview@playground.vcfinancecart': {
          component: 'cartcounter',
          bindings: {
            clientid: 'clientid'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcfinancecart.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcfinance.cart.factory:CartHelper
   *
   * @description
   *
   */
  angular.module('vcfinance.cart').factory('CartHelper', CartHelper);

  CartHelper.$inject = ['Cart', '$uibModal', '$log', 'Rlog'];

  function CartHelper(Cart, $uibModal, $log, Rlog) {
    var CartHelperBase = {};

    CartHelperBase.editCart = editCart;

    function editCart(lclientid, ldiagnoses, ltest) {
      $log.debug('CartHelper.edit cart called');
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><carteditor clientid="carteCtrl.clientid"  diagnoses="carteCtrl.diagnoses" test="carteCtrl.test"></carteditor></div>',
        controllerAs: 'carteCtrl',
        controller: ['sclientid', 'sdiagnoses', 'stest', function (sclientid, sdiagnoses, stest) {
          var vm = this;
          vm.clientid = sclientid;
          vm.diagnoses = sdiagnoses;
          vm.test = stest;
          vm.cancel = cancel;

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          sclientid: function sclientid() {
            return lclientid;
          },
          stest: function stest() {
            return ltest;
          },
          sdiagnoses: function sdiagnoses() {
            var flatdiagnosesarr = [];
            if (angular.isDefined(ldiagnoses) && angular.isArray(ldiagnoses)) {
              ldiagnoses.map(function (d) {
                flatdiagnosesarr.push(d.key);
              });
              return flatdiagnosesarr.join(', ');
            } else {
              return '';
            }
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return CartHelperBase;
  }
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name finance.cart.factory:Cart
   *
   * @description
   *
   */
  angular.module('vcfinance.cart').factory('Cart', Cart);

  Cart.$inject = ['$http', '$log'];

  function Cart($http, $log) {
    var service = {};
    service.getCart = getCart;
    service.addItem = addItem;
    service.updateItem = updateItem;
    service.removeItem = removeItem;
    service.setDiscount = setDiscount;
    service.setDiagnoses = setDiagnoses;
    service.setTimeframe = setTimeframe;
    service.getCount = getCount;

    function getCart(patid) {
      return $http.get('/routes/carts/' + patid + '/getcart');
    }

    function addItem(patid, item) {
      return $http.post('/routes/carts/' + patid + '/additem', item);
    }

    function updateItem(patid, item) {
      return $http.post('/routes/carts/' + patid + '/updateitem', item);
    }

    function removeItem(patid, item) {
      return $http.post('/routes/carts/' + patid + '/deleteitem', item);
    }

    function setDiscount(patid, discount) {
      return $http.post('/routes/carts/' + patid + '/setdiscount', discount);
    }

    function setDiagnoses(patid, diagnoses) {
      return $http.post('/routes/carts/' + patid + '/setdiagnoses', diagnoses);
    }

    function setTimeframe(patid, timeframe) {
      return $http.post('/routes/carts/' + patid + '/settimeframe', timeframe);
    }

    function getCount(patid, item) {
      return $http.get('/routes/carts/' + patid + '/getcount');
    }

    return service;
  }

  /*
    let newprivcatitem = {
      "_id": "5a672d9a1f16225102273d84",
      "created": "2018-01-23T12:42:02.326Z",
      "active": true,
      "type": "entry",
      "repeatable": true,
      "tax": 0,
      "svs": {"bva": "bvaO1", "sva": "svaO1", "vaeb": "vaebO1", "wgkk": "wgkkO1", "noegkk": "noegkkO1", "bgkk": "bgkkO1"},
      "shortcut": "O1",
      "name": "Erstordination 45Min",
      "details": "foobar",
      "price": 160
    };*/
  /*
   alte rechungstruktur
   let foo = {
      "_id": "5748a6eb7c01596daef2254c",
      "date": "2016-05-27T19:57:55.105Z",
      "fdate": "27. Mai 2016",
      "ftime": "21:57:55",
      "storno": false,
      "test": false,
      "items": [{
        "_id": "5748a65c7c01596daef22539",
        "created": "2016-05-27T19:56:13.608Z",
        "active": true,
        "name": "Erste Ordination (BVA etc)",
        "price": 70,
        "details": "Erste Ordination E1",
        "num": 5,
        "cat": "Priv",
        "include": true
      }],
      "netto": 70,
      "tax": 0,
      "total": 70,
      "paytype": "cash",
      "paid": true,
      "type": "Barrechnung",
      "cash": true,
      "paiddate": "2016-05-27T19:57:55.105Z",
      "invoicenr": "B22",
      "receiptnr": "21",
      "patientinvoiceid": "5748a6d07c01596daef22544",
      "doctorinvoiceid": "5748a6d97c01596daef22546",
      "receiptid": "5748a6da7c01596daef22548",
      "patientid": "573410687c01597c1aa2178d",
      "consultid": "5748a6737c01596daef2253a",
      "finished": false,
      "nettodiscounted": 70,
      "taxdiscounted": 0,
      "discount": 0,
      "totalbefore": 70
    }*/

  // Cart.$inject = ['restmod'];
  /*function Cart(restmod) {
    return restmod.model('/routes/carts').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/carts/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $addEntryOrGroup: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                // console.log('*************** restmod additem _params', _params);// => _params = {clientid: "a234b234.."}
                let url = '/routes/carts/' + _params.clientid + '/additem';
                _req.method = 'POST';
                _req.url = url;
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $getCart: function (id) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                console.log('*************** restmod getcart _params', _params);
                let url = '/routes/carts/' + _params + '/getcart';
                _req.method = 'GET';
                _req.url = url;
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            return $search({key, val});
          }
        } // Model
      }// extend
    });
  }*/

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcprinter
   * @description
   *
   */
  angular.module('vcdms.vcprinter', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcprinter').component('printersearch', {
    restrict: 'E',
    bindings: {
      printer: '<',
      printerref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showprinter($item, $model, $label)"\n                   uib-typeahead="printer as printer.text for printer in vm.getPrinters($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addPrinter()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addPrinter()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <printereditor printer="vm.printer"></printereditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Printer', 'PrinterHelper', function ($log, Printer, PrinterHelper) {
      var vm = this;
      vm.save = save;
      vm.showprinter = showprinter;

      vm.getPrinters = getPrinters;
      // vm.addPrinter = PrinterHelper.addPrinter;
      vm.addPrinter = addPrinter;
      vm.editPrinter = PrinterHelper.editPrinter;

      vm.$onInit = function () {
        vm.newprinter = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastprinter = angular.copy(vm.printerresult);
        vm.lastprinterref = angular.copy(vm.printerref);
      };

      function addPrinter() {
        $log.debug('debug - printersearch addPrinter called');
        PrinterHelper.addPrinter(function (printer) {
          $log.debug('debug: handle newly create printer');
          vm.printer = {};
          vm.printer.name = printer.name;
          vm.printer.short = printer.short;
          vm.printer._id = printer._id;
          vm.printerref = printer._id;
          vm.asyncSelected = printer.short;
          vm.parentsave({ printer: vm.printer, printerref: vm.printerref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead printer search backend query
      function getPrinters(val) {
        // return Printerahead.$search({query: val}).$asPromise().then(function (response) {
        return Printer.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (printer) {
            printer.text = printer.short;
            delete vm.error;
            return printer;
          });
        });
      }

      // typeahead printer search action
      function showprinter($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.printer = $model;
        vm.printerref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.printer = $model;
          vm.printerref = $model._id;
          $log.debug('debug - printersearch editinplace');
        } else {
          vm.printer = {};
          vm.printer.name = $model.name;
          vm.printer.short = $model.short;
          vm.printer._id = $model._id;
          vm.printerref = $model._id;
          vm.parentsave({ printer: vm.printer, printerref: vm.printerref });
          $log.debug('debug - printersearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.printer, vm.lastprinter) || !angular.equals(vm.printerref, vm.lastprinterref)) {
          vm.lastprinter = angular.copy(vm.printer);
          vm.lastprinterref = angular.copy(vm.printerref);
          vm.parentsave({ printer: vm.printer, printerref: vm.printerref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcprinter').component('printernew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="printernew-component" data-hook="printernew-component">\n        <h3>Neue/s printer anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addPrinter()" ng-hide="vm.newprinter">Neue/s printer anlegen</div>\n        <div ng-show="vm.newprinter">\n          <printerform printer="vm.newprinter" parentsave="vm.saveNewPrinter(printer)" oncancel="vm.cancel()"></printerform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> printer erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen printer wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> printer konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Printer', 'Rlog', function ($log, Printer, Rlog) {
      var vm = this;
      vm.addPrinter = addPrinter;
      vm.saveNewPrinter = saveNewPrinter;
      vm.cancel = cancel;

      function addPrinter() {
        vm.newprinter = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewPrinter(printer) {
        $log.debug('debug: create new printer: ', printer);
        delete vm.newprinter;
        Printer.$create(printer).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new printer failed: ', err);
          Rlog.error('vcutils.printer', 'printernew', 'Creation of new printer failed: ', { printer: vm.newprinter });
        });
      }

      function cancel() {
        delete vm.newprinter;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of printers (patients) to display or load printers */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcprinter').component('printerlist', {
    restrict: 'E',
    bindings: {
      printers: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="printer in vm.printers">\n            <td>{{printer.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editPrinter(printer)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removePrinter(printer)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Printer', 'PrinterHelper', 'vertxEventBusService', function ($log, $http, Rlog, Printer, PrinterHelper, vertxEventBusService) {
      var vm = this;
      vm.editPrinter = PrinterHelper.editPrinter;
      vm.removePrinter = removePrinter;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.printers)) {
          vm.printers = Printer.$search();
        }
      }; // $onInit()

      function removePrinter(printer) {
        printer.active = false;
        printer.$save();
      }

      var printersUpdateHandler = function printersUpdateHandler(message) {
        if (angular.isDefined(vm.printers)) {
          vm.printers.$refresh().$then(function () {
            // $log.debug('debug: printerlist refreshed printers');
          }, function (error) {
            $log.debug('debug: printerlist refresh printers failed: ', error);
          });
        }
      };

      vertxEventBusService.on('printers.update', {}, printersUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('printers.update', {}, printersUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcprinter').component('printerform', {
    restrict: 'E',
    bindings: {
      printer: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcdms/vcprinterform-component.tpl.html',
    controllerAs: 'vm',
    controller: function controller() {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.lastprinter = angular.copy(vm.printer);
      };

      function save() {
        if (!angular.equals(vm.printer, vm.lastprinter)) {
          vm.lastprinter = angular.copy(vm.printer);
          vm.parentsave({ printer: vm.printer });
        }
      }

      function cancel() {
        vm.printer = angular.copy(vm.lastprinter);
        vm.oncancel();
      }
    } // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcprinter').component('printereditor', {
    restrict: 'E',
    bindings: {
      printer: '<?',
      printerid: '<?'
    },
    template: '\n        <printerform printer="vm.printer" parentsave="vm.childsave(printer)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> printer erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen printer wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> printer konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Printer', 'Rlog', function ($log, Printer, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.printer) || !vm.printer.hasOwnProperty('_id')) && angular.isDefined(vm.printerid)) {
          getPrinter();
        }
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.printerid) && angular.isDefined(changes.printerid.currentValue) && changes.printerid.currentValue.length > 0) {
          vm.printerid = changes.printerid.currentValue;
          getPrinter();
        }
      };

      function getPrinter() {
        Printer.$find(vm.printerid).$then(function (printer) {
          vm.printer = printer;
        }, function (err) {
          $log.error('printer not found, id: ', vm.printerid, err);
          Rlog.error('printer', 'printereditor', 'printer not found', { _id: vm.printerid });
        });
      }

      function childsave(printer) {
        // vm.printer = angular.copy(printer);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in printer) {
          if (printer.hasOwnProperty(key)) {
            vm.printer[key] = printer[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.printer.$hasPendingActions()) {
          vm.printer.$cancel();
          vm.printer.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of printer failed: ', err);
            Rlog.error('vcutils.printer', 'printereditor', 'Saving of printer failed: ', { printerid: vm.printer._id });
          });
        } else {
          vm.printer.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of printer failed: ', err);
            Rlog.error('vcutils.printer', 'printereditor', 'Saving of printer failed: ', { printerid: vm.printer._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcprinter').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmsprinter', {
      url: '/vcdmsprinter',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;printersearch printer="" printerref="" editinplace="true"&gt;</tt></h3><div ui-view="printersearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;printersearch printer="" printerref="" parentsave=""&gt;</tt></h3><div ui-view="printersearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;printereditor printer="" mode="" onClose=""&gt;</tt></h3><div ui-view="printereditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;printernew&gt;</tt></h3><div ui-view="printernewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;printerlist printers="?"&gt;</tt></h3><div ui-view="printerlistview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcprinter entered');
      }
    });

    $stateProvider.state('playground.vcdmsprinter.allcomponents', {
      url: '/allcomponents',
      resolve: {
        printer: function printer() {
          return '';
        },
        printerref: function printerref() {
          return '';
        },
        someprinter: function someprinter(Printer) {
          return Printer.$find('572b31b07c01597e3e150923');
        },
        allprinters: function allprinters(Printer) {
          return Printer.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (printer, printerref) {
            console.log('debug: dummy parentsave called for printersearch with: ', printer, printerref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'printersearchview@playground.vcdmsprinter': {
          component: 'printersearch',
          bindings: {
            printer: 'printer',
            printerref: 'printerref',
            editinplace: 'eip'
          }
        },
        'printersearchview2@playground.vcdmsprinter': {
          component: 'printersearch',
          bindings: {
            printer: 'printer',
            printerref: 'printerref',
            parentsave: 'parentsavesearch'
          }
        },
        'printereditview@playground.vcdmsprinter': {
          component: 'printereditor',
          bindings: {
            printer: 'someprinter'
          }
        },
        'printernewview@playground.vcdmsprinter': {
          component: 'printernew',
          bindings: {}
        },
        'printerlistview@playground.vcdmsprinter': {
          component: 'printerlist',
          bindings: {
            printers: 'allprinters'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmsprinter.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcprinter.factory:PrinterHelper
   *
   * @description
   *
   */
  angular.module('vcdms.vcprinter').factory('PrinterHelper', PrinterHelper);

  PrinterHelper.$inject = ['Printer', '$uibModal', '$log', 'Rlog'];

  function PrinterHelper(Printer, $uibModal, $log, Rlog) {
    var PrinterHelperBase = {};

    PrinterHelperBase.editPrinter = editPrinter;
    PrinterHelperBase.addPrinter = addPrinter;

    function addPrinter(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><printerform printer="vm.printer" parentsave="vm.childsave(printer)" oncancel="vm.cancel()"></printernew></div>',
        controllerAs: 'printeraCtrl',
        controller: ['printer', function () {
          var vm = this;
          vm.printer = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(printer) {
            Printer.$create(printer).$then(function (newprinter) {
              vm.created = true;
              success(newprinter);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ printer-helper.addPrinter: ', err);
              Rlog.error('vcutils.printer', 'printer-helper.addPrinter', 'Creation of new printer failed: ', { printer: printer });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          printer: function printer() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editPrinter(lprinter) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><printerform printer="printereCtrl.printer" parentsave="printereCtrl.childsave(printer)" oncancel="printereCtrl.cancel()"></printerform></div>',
        controllerAs: 'printereCtrl',
        controller: ['printer', function (sprinter) {
          var vm = this;
          vm.printer = sprinter;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(printer) {
            // vm.printer = angular.copy(printer);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in printer) {
              if (printer.hasOwnProperty(key)) {
                vm.printer[key] = printer[key];
              }
            }

            if (vm.printer.$hasPendingActions()) {
              vm.printer.$cancel();
              vm.printer.$save();
              cancel();
            } else {
              vm.printer.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          printer: function printer() {
            return lprinter;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return PrinterHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.printer.factory:Printer
   *
   * @description
   *
   */
  angular.module('vcdms.vcprinter').factory('Printer', Printer);

  Printer.$inject = ['restmod'];
  function Printer(restmod) {
    return restmod.model('/routes/printers').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/printers/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name bmfexport
   * @description
   *
   */
  angular.module('vcfinance.bmfexport', ['ui.router', 'ui.bootstrap']);
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name bmfexport.factory:Bmfexport
   *
   * @description
   *
   */
  angular.module('vcfinance.bmfexport').factory('Bmfexport', Bmfexport);

  Bmfexport.$inject = ['restmod'];

  function Bmfexport(restmod) {
    return restmod.model('/routes/bmfexport');
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcfinance.bmfexport').component('bmfexport', {
    restrict: 'E',
    templateUrl: 'vcfinance/bmfexport/bmfexport-component.tpl.html',
    controllerAs: 'vm',
    controller: ['Config', '$log', '$http', function (Config, $log, $http) {
      var vm = this;
      vm.name = 'bmfexport';
      vm.rangequery = rangequery;
      vm.conf = Config.$find('configuration');
      // vm.startdate = moment(moment().year() + '-01-01', 'YYYY-MM-DD').toDate();
      vm.startdate = new Date(moment().year(), 0, 1).toISOString();
      $log.debug('Startdate: ', vm.startdate);
      vm.enddate = new Date().toISOString();
      vm.dateOptions = {
        formatYear: 'yyyy',
        startingDay: 1
      };

      vm.altInputFormats = ['yyyy-MM-dd', 'dd.MM.yyyy'];

      var thisyear = {
        $gte: moment().startOf('year').toISOString(),
        $lt: moment().endOf('year').toISOString()
      };

      vm.thisyearquery = '/routes/bmfexport' + '?created=' + encodeURIComponent(JSON.stringify(thisyear));

      function rangequery(start, end) {
        var qq = {
          $gte: start,
          $lt: end
        };
        var tmp = '/routes/bmfexport' + '?created=' + encodeURIComponent(JSON.stringify(qq));
        $log.debug('tmp: ', tmp);
        $http.get(tmp, {}).then(function (data, status, headers, config) {
          var anchor = angular.element('<a/>');
          anchor.attr({
            href: 'data:application/octet-stream;base64,' + encodeURI(data),
            target: '_blank',
            download: 'bmfexport.zip'
          })[0].click();
        }, function (err) {
          $log.error('bmfexport filegeneration and export failed: ', err);
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcscan
   * @description
   *
   */
  angular.module('vcdms.vcscan', ['ui.router', 'pdf', 'ngTagsInput', 'ui.bootstrap.typeahead']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcscan').component('signoffcounter', {
    restrict: 'E',
    bindings: {
      patientid: '<?'
    },
    template: '\n        <span class="badge badge-error"  data-hook="signoffcounter" ng-bind="vm.counter" uib-tooltip="Dokumente zu vidieren" tooltip-placement="auto"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http', function ($log, File, Rlog, vertxEventBusService, $http) {
      var vm = this;

      var getCounter = function getCounter(patid) {
        var lpatid = patid || undefined;
        var query = [{
          $match: {
            scanstatus: 'assigned',
            active: true
          }
        }, {
          $group: {
            _id: null,
            counter: { $sum: 1 }
          }
        }];

        if (angular.isDefined(lpatid)) {
          query[0].$match.patientid = lpatid;
        }

        $http.post('/routes/files/aggregate', query).then(function (res) {
          vm.counter = 0;
          if (res.data.counter) {
            vm.counter = res.data.counter;
            $log.debug('refreshed signoffcounter: ', vm.counter);
          }
        }, function (err) {
          Rlog.error('dms.scan', 'signoffcounter', 'signoffcounter.$aggregate failed', {});
          $log.error('signoffcounter.$aggregate failed', err);
        });
      };

      var getComplexCounter = function getComplexCounter(message) {
        $log.debug('signoffcounter scanfile.update msg caught, refreshing: ', message);
        if (angular.isDefined(vm.patientid)) {
          getCounter(vm.patientid);
        } else {
          getCounter();
        }
      };

      vm.$onInit = function () {
        if (angular.isUndefined(vm.patientid)) {
          getCounter();
        }

        // listen for updates
        vertxEventBusService.on('scanfile.update', {}, getComplexCounter);
        vertxEventBusService.on('files.update', {}, getComplexCounter);
        vertxEventBusService.on('files.create', {}, getComplexCounter);
      }; // $onInit()

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue)) {
          vm.patientid = changes.patientid.currentValue;
          getCounter(vm.patientid);
        }
      }; // $onInit()

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.update', {}, getComplexCounter);
        vertxEventBusService.unregisterHandler('scanfile.update', {}, getComplexCounter);
        vertxEventBusService.unregisterHandler('files.create', {}, getComplexCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcscan').component('scansorter', {
    restrict: 'E',
    bindings: {
      file: '=',
      fileid: '=',
      saved: '=',
      saving: '=',
      saveerror: '=',
      parentsave: '&',
      parentrendered: '&',
      clientmode: '<?',
      filemode: '@'
    },
    templateUrl: 'vcdms/scan/scansorter-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'pdfDelegate', 'Config', '$scope', '$http', 'LogReminderHelper', '$cookies', 'ClientHelper', function ($log, Rlog, pdfDelegate, Config, $scope, $http, LogReminderHelper, $cookies, ClientHelper) {
      var vm = this;
      vm.save = save;
      vm.saveClient = saveClient;
      vm.parentRendered = parentRendered;
      vm.resetViewer = resetViewer;

      vm.getTags = getTags;
      vm.clearPatient = clearPatient;
      vm.clearClient = clearClient;
      vm.saveKeywords = saveKeywords;
      vm.assignCat = assignCat;

      vm.formDisabled = formDisabled;
      vm.formSignoffDisabled = formSignoffDisabled;
      vm.finish = finish;
      vm.finishSignoff = finishSignoff;
      vm.diagClientSave = diagClientSave;

      vm.addLog = addLog;
      vm.addReminder = addReminder;

      // Control PDF Viewer
      vm.nextPage = nextPage;
      vm.previousPage = previousPage;
      vm.rotatePage = rotatePage;
      vm.gotoPage = gotoPage;
      vm.zoomIn = zoomIn;
      vm.zoomOut = zoomOut;

      vm.firstchange = true;

      $scope.$watch(function () {
        return vm.file;
      }, function (newValue, oldValue, scope) {
        // $log.debug('[DMS][SCAN][ScanSorter] file watch fired old, new: ', oldValue._id, newValue._id, scope);
        // Rlog.debug('dms.scan', 'scansorter', 'watch triggered', {newValue: newValue, oldValue: oldValue});
        if (angular.isDefined(newValue) && vm.firstchange || angular.isDefined(newValue) && angular.isDefined(oldValue) && oldValue.fileid !== newValue.fileid) {
          // $log.debug('[DMS][SCAN][ScanSorter] Is firstchange: ', vm.firstchange);
          vm.firstchange = false;
          // if (angular.isDefined(newValue)) {
          $log.debug('[DMS][SCAN][ScanSorter] file watch fired, fileid changed: ', newValue.fileid, oldValue.fileid);
          vm.resetViewer();

          pdfDelegate.load('/routes/files/filereader/' + newValue.fileid).then(function () {
            $log.debug('[DMS][SCAN][ScanSorter] Scansorter retrieved binaryfile: ', newValue.fileid);
            Rlog.debug('dms.scan', 'scansorter', 'successfully rendered pdf file', {
              mode: vm.filemode,
              fileid: newValue.fileid
            });
            delete vm.docloading;
            vm.docready = true;
            vm.parentRendered(vm.file, true);
            vm.maxpc = pdfDelegate.getPageCount();
            vm.currentpage = pdfDelegate.getCurrentPage();
          }, function (err) {
            vm.parentRendered(vm.file, false);
            vm.docready = true;
            vm.pdferror = true;
            delete vm.docloading;
            $log.warning('[DMS][SCAN][ScanSorter] PDF delegate failed: ', err);
            Rlog.error('dms.scan', 'scansorter', 'failed to rendered pdf file', {});
          });
          // get patient diagnoses

          if (angular.isDefined(vm.file.patientid)) {
            ClientHelper.find(vm.clientmode, vm.file.patientid).$then(function (client) {
              vm.client = client;
              if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
                vm.client.deleteddiagnoses = [];
                vm.client.$save();
                $log.debug('[DMS][SCAN][ScanSorter] initalised deleteddiagnoses to empty array');
              }
            });
          }
          // $scope.apply();
        }
      }, true);

      vm.$onInit = function () {
        vm.rotatestate = 0;
        vm.landscape = false;
        $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onInit file: ', vm.file._id, vm.file);

        // retrieve customer document classifications
        Config.$find('dmsgencat').$then(function (dc) {
          vm.dmsgencat = dc.dmsgencat;
        });
        Config.$find('dmspatientcat').$then(function (pc) {
          vm.dmspatientcat = pc.dmspatientcat;
        });

        // get document pagecount
        vm.maxpc = pdfDelegate.$getByHandle('scans-pdf-container').getPageCount();
      };

      function resetViewer() {
        vm.docloading = true;
        vm.docready = false;
        vm.pdferror = false;
        vm.ready = false;
        while (vm.rotatestate !== 0) {
          vm.rotatePage();
        }
        vm.currentpage = 1;
        vm.maxpc = 1;
      }

      // catch late propagating clientmode changes
      vm.$onChanges = function (changes) {
        // $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onChanges');
        if (!changes.isFirstChange) {
          // $log.debug('[DMS][SCAN][ScanSorter] Scansorter $onChanges not first change: ', changes);
          if (angular.isDefined(changes.clientmode) && angular.isDefined(changes.clientmode.currentValue)) {
            $log.debug('[DMS][SCAN][ScanSorter] $onChanges clientmode changed: ', changes.clientmode.currentValue);

            vm.clientmode = changes.clientmode.currentValue;
            if (vm.clientmode === 'patient') {
              vm.kunde = 'Patient';
              vm.kunden = 'Patienten';
            } else {
              vm.kunde = 'Kunde';
              vm.kunden = 'Kunden';
            }
          }
        }
      };

      // use aggregate query to obtain a list of distinct tags
      // first match all documents containing a tag that fits the regex
      // then unwind the document per tag to obtain multiple copies
      function getTags(val) {
        // $log.debug('[DMS][SCAN][ScanSorter] getTags query; ', val);
        // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var myregex = val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];
        // $log.debug('[DMS][SCAN][ScanSorter] scansorter  Sending tags query');
        return $http.post('/routes/files/aggregate', match).then(function (response) {
          // $log.debug('[DMS][SCAN][ScanSorter] tags received: ', response);
          var tags = new Set();
          if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
            // create set to group by value
            tags = new Set(response.data.map(function (tag) {
              return tag._id;
            }));
            // $log.debug('[DMS][SCAN][ScanSorter] tags set from array result: ', tags);
          } else if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data._id)) {
              tags = new Set([response.data._id]);
              // $log.debug('[DMS][SCAN][ScanSorter] tags set from single result: ', tags);
            }
          // return array because ngTagsLib expects an array not a set
          // $log.debug('[DMS][SCAN][ScanSorter] array for ngTagsLib : ', Array.from(tags));
          return Array.from(tags);
        });
      }

      function saveClient(client, mode) {
        $log.debug('[DMS][SCAN][ScanSorter] saveClient called with: ', client, mode);
        if (mode === 'patient') {
          vm.file.patientid = client._id;
          vm.file.patientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname + ', ' + client.svdata.svnr;
        } else {
          vm.file.clientid = client._id;
          vm.file.clientfname = client.primarycontact.firstname + ' ' + client.primarycontact.lastname;
        }

        ClientHelper.find(mode, client._id).$then(function (lclient) {
          vm.client = lclient;
        });

        $log.debug('[DMS][SCAN][ScanSorter] saveClient assigned fname: ', vm.file.patientfname, vm.file.clientfname);

        vm.save(false);
      }

      function diagClientSave() {
        if (vm.client.$hasPendingActions()) {
          vm.client.$cancel();
        }
        vm.client.$save().$then(function () {}, function (error) {
          $log.error('[DMS][SCAN][ScanSorter] failed to save client (diagnoses): ', error);
          Rlog.error('vcdms', 'scansorter', 'failed to save client (diagnoses)', {});
          // Rlog.error('vcdms', 'scansorter', 'failed to save client (diagnoses)', {clientid: vm.client._id, mode: vm.clientmode});
        });
      }

      function assignCat(cat) {
        switch (cat) {
          case 'generic':
            if (vm.clientmode === 'patient') {
              clearPatient();
            } else {
              clearClient();
            }
            break;
          case 'patient':
            break;
          default:
            break;
        }
        vm.file.doccat = cat;
        vm.save(false);
      }

      function finish() {

        switch (vm.file.doccat) {
          case 'generic':
            vm.file.scanstatus = 'finished';
            break;
          case 'patient':
            vm.file.scanstatus = 'assigned';
            break;
          default:
            break;
        }
        $log.debug('[DMS][SCAN][ScanSorter] vm.finish() assigning called for: ', vm.file._id, vm.file.scanstatus);
        save(true);
      }

      function finishSignoff() {
        $log.debug('[DMS][SCAN][ScanSorter] vm.finishSignoff() called');

        vm.file.scanstatus = 'finished';
        vm.file.signatureuser = $cookies.get('username');
        save(true);
      }

      function saveKeywords() {
        $log.debug('[DMS][SCAN][ScanSorter] save keywords: ', vm.file.keywords);
        var flattags = [];
        if (angular.isArray(vm.file.keywords)) {
          for (var i = 0; i < vm.file.keywords.length; i++) {
            flattags.push(vm.file.keywords[i].text);
          }
          vm.file.flattags = flattags;
          vm.save(false);
        }
      }

      function clearPatient() {
        delete vm.file.patientid;
        delete vm.file.patientfname;
        // delete vm.file.doccat;
        vm.file.scanstatus = 'captured';
        vm.save(false);
      }

      function clearClient() {
        delete vm.file.clientid;
        delete vm.file.clientfname;
        // delete vm.file.doccat;
        vm.file.scanstatus = 'captured';
        vm.save(false);
      }

      function formDisabled(scan) {
        var answer = true;
        if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'patient' && (angular.isString(scan.patientid) || angular.isString(scan.clientid))) {
          answer = false;
        }
        if (angular.isObject(scan) && scan.hasOwnProperty('doccat') && scan.doccat === 'generic') {
          answer = false;
        }
        return answer;
      }

      function formSignoffDisabled(scan) {
        var answer = true;

        if (angular.isObject(scan) && scan.hasOwnProperty('signature') && angular.isString(scan.signature) && scan.signature.length > 0) {
          answer = false;
        }
        return answer;
      }

      function save(lfinish) {
        if (!lfinish) {
          lfinish = false;
        }
        $log.debug('[DMS][SCAN][ScanSorter] save called for file._id, fileid, finish: ', vm.file._id, vm.file.fileid, lfinish);
        vm.parentsave({ file: vm.file, finish: lfinish });
      }

      function parentRendered(file, success) {
        $log.debug('[DMS][SCAN][ScanSorter] rendered file success: ', vm.file._id, success);
        vm.parentrendered({ file: vm.file, success: success });
      }

      function addLog() {
        if (vm.clientmode === 'patient') {
          LogReminderHelper.addLog(vm.file.patientid, vm.clientmode);
        } else {
          LogReminderHelper.addLog(vm.file.clientid, vm.clientmode);
        }
      }

      function addReminder() {
        if (vm.clientmode === 'patient') {
          LogReminderHelper.addReminder(vm.file.patientid, vm.clientmode);
        } else {
          LogReminderHelper.addReminder(vm.file.clientid, vm.clientmode);
        }
      }

      // PDF Viewer Function wrappers
      function previousPage() {
        pdfDelegate.$getByHandle('scans-pdf-container').prev();
        vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
      }

      function nextPage() {
        pdfDelegate.$getByHandle('scans-pdf-container').next();
        vm.currentpage = pdfDelegate.$getByHandle('scans-pdf-container').getCurrentPage();
      }

      function zoomIn() {
        pdfDelegate.$getByHandle('scans-pdf-container').zoomIn();
      }

      function zoomOut() {
        pdfDelegate.$getByHandle('scans-pdf-container').zoomOut();
      }

      function rotatePage() {
        pdfDelegate.$getByHandle('scans-pdf-container').rotate();
        vm.rotatestate = (vm.rotatestate + 1) % 4;
        vm.landscape = vm.rotatestate === 1 || vm.rotatestate === 3;
        $log.debug('[DMS][SCAN][ScanSorter] rotating, now at position: ', vm.rotatestate);
        $log.debug('[DMS][SCAN][ScanSorter] landscape view: ', vm.landscape);
      }

      function gotoPage() {
        if (vm.currentpage > 0 && vm.currentpage <= vm.maxpc) {
          pdfDelegate.$getByHandle('scans-pdf-container').goToPage(vm.currentpage);
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcscan').component('scancounter', {
    restrict: 'E',
    bindings: {},
    template: '\n        <span class="badge badge-warning" data-hook="scancounter" ng-bind="vm.counter"  uib-tooltip="Neue Scans zu sortieren"  tooltip-placement="auto"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$http', function ($log, File, Rlog, vertxEventBusService, $http) {
      var vm = this;

      var getCounter = function getCounter() {
        var query = [{
          $match: {
            scanstatus: 'captured',
            active: true
          }
        }, {
          $group: {
            _id: null,
            counter: { $sum: 1 }
          }
        }];

        $http.post('/routes/files/aggregate', query).then(function (res) {
          vm.counter = 0;
          if (res.data.counter) {
            vm.counter = res.data.counter;
          }
        }, function (err) {
          $log.error('scancounter.$aggregate failed: ', err);
          Rlog.error('dms.scan', 'scancounter', 'scancounter.$aggregate failed', {});
        });
      };

      vm.$onInit = function () {
        getCounter();

        // listen for files updates
        vertxEventBusService.on('scanfile.update', {}, getCounter);
        vertxEventBusService.on('files.update', {}, getCounter);
        vertxEventBusService.on('files.create', {}, getCounter);
      }; // $onInit()

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.update', {}, getCounter);
        vertxEventBusService.unregisterHandler('scanfile.update', {}, getCounter);
        vertxEventBusService.unregisterHandler('files.create', {}, getCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcscan').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmsscan', {
      url: '/vcdmsscan',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;scansorter file=""  parentsave=""&gt;</tt></h3><div ui-view="scansorterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;scancounter&gt;</tt></h3><div ui-view="scancounterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;signoffcounter&gt;</tt></h3><div ui-view="signoffcounterview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcscan entered');
      }
    });

    $stateProvider.state('playground.vcdmsscan.allcomponents', {
      url: '/allcomponents',
      resolve: {
        scan: function scan() {
          return '';
        },
        scanref: function scanref() {
          return '';
        },
        somescan: function somescan(File) {
          return File.$find('572b31b07c01597e3e150923');
        },
        allscans: function allscans(File) {
          return File.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (file) {
            console.log('debug: dummy parentsave called for scansorter with: ', file);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'scansorterview@playground.vcdmsscan': {
          component: 'scansorter',
          bindings: {
            file: 'scan',
            parentsave: 'parentsavesearch'
          }
        },
        'scancounterview@playground.vcdmsscan': {
          component: 'scancounter'

        },
        'signoffcounterview@playground.vcdmsscan': {
          component: 'signoffcounter'
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmsscan.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcscan').component('filebrowser', {
    restrict: 'E',
    bindings: {
      filemode: '@',
      clientid: '<?',
      clientmode: '@?'
    },
    template: '\n        <h3  ng-show="vm.files.length === 0">\n            <span ng-show="vm.filemode === \'scan\'">Dokumente zuordnen</span>\n            <span ng-show="vm.filemode === \'signoff\'">Dokumente vidieren</span>\n        </h3>\n        <div class="alert alert-info" ng-show="vm.files.length === 0">\n\n            <h4><i class="fa fa-info-circle"></i> Es sind derzeit keine Dokumente zu bearbeiten.</h4>\n        </div>\n        <div ng-show="vm.files.length > 0">\n          <h3>\n            <div class="pull-left">\n  \n              <button class="btn btn-primary" data-hook="first_scan" ng-click="vm.firstFile()"  ng-disabled="vm.disableNavigation || vm.selectedfile === 1" uib-tooltip="Erste Datei"><i class="fa fa-step-backward"></i></button>\n              <button class="btn btn-primary"  data-hook="last_scan"  ng-click="vm.previousFile()"  ng-disabled="vm.disableNavigation || vm.selectedfile === 1" uib-tooltip="Vorherige Datei"><i class="fa fa-arrow-left"></i></button>\n               <span ng-show="vm.filemode === \'scan\'">Dokumente zuordnen: </span>\n              <span ng-show="vm.filemode === \'signoff\'">Dokumente vidieren: </span>\n              Datei <span data-hook="selected_scan">{{vm.selectedfile}}</span> von {{vm.files.length}}\n            </div>\n            <div class="pull-right">\n              <button class="btn btn-primary" data-hook="next_scan" ng-click="vm.nextFile()" ng-disabled="vm.disableNavigation || vm.selectedfile === vm.files.length" uib-tooltip="Nächste Datei"><i class="fa fa-arrow-right"></i></button>\n              <button class="btn btn-primary" data-hook="last_scan" ng-click="vm.lastFile()" ng-disabled="vm.disableNavigation || vm.selectedfile === vm.files.length" uib-tooltip="Letzte Datei"><i class="fa fa-step-forward"></i></button>\n            </div>\n          </h3>\n          <div class="clearfix"></div>\n          <scansorter ng-if="vm.ready === true"\n                      file="vm.files[vm.selectedfileindex]" \n                      parentsave="vm.childsave(file, finish)" \n                      parentrendered="vm.childrendered(file, success)" \n                      clientmode="vm.clientmode"\n                      filemode="{{vm.filemode}}" \n                      saving="vm.saving"\n                      saved="vm.saved"\n                      saveerror="vm.saveerror"\n                      ng-show="vm.filemode === \'scan\' || vm.filemode === \'signoff\' "></scansorter>\n          </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', 'vertxEventBusService', '$window', '$timeout', function ($log, File, Rlog, vertxEventBusService, $window, $timeout) {
      var vm = this;
      vm.childsave = childsave;
      vm.childrendered = fileRendered;
      vm.firstFile = firstFile;
      vm.lastFile = lastFile;
      vm.nextFile = nextFile;
      vm.previousFile = previousFile;

      vm.ready = false;

      vm.$onInit = function () {
        $log.debug('[DMS][SCAN][FileBrowser] run getFiles $onInit');
        vm.disableNavigation = true;
        vm.saved = false;
        vm.saveerror = false;
        vm.saving = false;
        getFiles();
      };

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue)) {
            vm.clientid = changes.clientid.currentValue;
            $log.debug('[DMS][SCAN][FileBrowser]  run getFiles $onChange');
            getFiles();
          }
        }
      };

      function getFiles() {
        $log.debug('[DMS][SCAN][FileBrowser]  Get files called');
        if (angular.isDefined(vm.filemode)) {
          var modeerror = false;
          var query = {};
          switch (vm.filemode) {
            case 'scan':
              query = { active: true, scanstatus: 'captured' };
              break;
            case 'signoff':
              query = { active: true, scanstatus: 'assigned' };
              break;
            case 'findings':
              query = { active: true, findingsstatus: 'captured' };
              break;
            case 'findingsignoff':
              query = { active: true, findingsstatus: 'assigned' };
              break;
            default:
              modeerror = true;
          }

          if (angular.isDefined(vm.clientid)) {
            if (vm.clientmode === 'patient') {
              query.patientid = vm.clientid;
            } else {
              query.clientid = vm.clientid;
            }
          }

          if (!modeerror) {
            File.$search(query).$then(function (files) {
              $log.debug('[DMS][SCAN][FileBrowser]  Loaded files mode: ', vm.filemode, files);
              Rlog.debug('dms.scan', 'filebrowser', 'loaded files', {
                mode: vm.filemode,
                numberOfFiles: files.length
              });
              vm.files = files;
              vm.ready = true;
              vm.selectedfile = 1;
              vm.selectedfileindex = 0;
            }, function (err) {
              $log.error('[DMS][SCAN][FileBrowser]  file loading error', err);
              Rlog.error('dms.scan', 'filebrowser', 'file loading error', {});
              vm.files = [];
            });
          } else {
            vm.files = [];
          }
        }
      }

      function firstFile() {
        vm.selectedfile = 1;
        vm.selectedfileindex = 0;
        vm.disableNavigation = true;
        vm.saved = false;
        vm.saveerror = false;
        vm.saving = false;
      }

      function lastFile() {
        vm.selectedfile = vm.files.length;
        vm.selectedfileindex = vm.files.length - 1;
        vm.disableNavigation = true;
        vm.saved = false;
        vm.saveerror = false;
        vm.saving = false;
      }

      function nextFile() {
        if (vm.selectedfile < vm.files.length) {
          vm.selectedfile++;
          vm.selectedfileindex++;
          vm.disableNavigation = true;
          vm.saved = false;
          vm.saveerror = false;
          vm.saving = false;
        }
      }

      function previousFile() {
        if (vm.selectedfile > 0) {
          vm.selectedfile--;
          vm.selectedfileindex--;
          vm.disableNavigation = true;
          vm.saved = false;
          vm.saveerror = false;
          vm.saving = false;
        }
      }

      function fileRendered(file, success) {
        $log.debug('[DMS][SCAN][FileBrowser]  file rendered received: ', file._id, success);
        vm.saved = false;
        vm.saveerror = false;
        vm.saving = false;
        vm.disableNavigation = false;
      }

      function childsave(file, finish) {
        vm.saved = false;
        vm.saving = false;
        vm.saveerror = false;
        if (finish) {
          vm.saving = finish;
        }
        $log.debug('[DMS][SCAN][FileBrowser] save called for file._id, fileid, finish: ', file._id, file.fileid, finish);

        if (file.$hasPendingActions()) {
          $log.warn('[DMS][SCAN][FileBrowser] file save had pending actions, cancelling now.');
          file.$cancel();
          $timeout(function (file, finish) {
            $log.warn('[DMS][SCAN][FileBrowser] waited 1.5 seconds because of file having had pending actions, saving now.');
            reallysave(file, finish, true);
          }, 1500);
        } else {
          reallysave(file, finish, false);
        }
      }

      function reallysave(file, finish, aftercancel) {
        $log.debug('[DMS][SCAN][FileBrowser] reallysave called  aftercancel for file._id, fileid, finish: ', aftercancel, file._id, file.fileid, finish);
        // TODO: error from automated test:  file undefined!!! WTF
        file.$save().$then(function () {
          $log.debug('[DMS][SCAN][FileBrowser] file saved successfully: ', file._id);
          if (finish) {
            vm.saving = false;
            vm.saved = true;

            // reposition file pointer
            $log.debug('[DMS][SCAN][FileBrowser] finishing selected file index: ', vm.selectedfile, vm.selectedfileindex, vm.files.length, file);
            while (vm.selectedfile >= vm.files.length) {
              vm.selectedfile--;
              vm.selectedfileindex--;
              vm.disableNavigation = true;
            }

            $log.debug('[DMS][SCAN][FileBrowser] publish scanfile.update message for: ', file._id);

            vertxEventBusService.publish('scanfile.update', { origin: 'filebrowser' }, { timeout: 2000 }).then(function (reply) {
              $log.debug('[DMS][SCAN][FileBrowser] eb reply received: ', reply);
            })['catch'](function () {
              $log.warn('[DMS][SCAN][FileBrowser] no eb reply received within 2 seconds');
            });
          }
        }, function (errmodel) {
          $log.error('[DMS][SCAN][FileBrowser] misplaced  error branch file save failed: ', file._id, errmodel);

          if (errmodel.$response.status !== 200) {
            if (finish) {
              vm.saving = false;
              vm.saveerror = true;
            }
            $log.error('[DMS][SCAN][FileBrowser] file save failed: ', file._id, errmodel.$response.headers.status, errmodel);
            Rlog.error('vcdms.vcscan', 'filebrowser', 'Saving of file failed: ', { fileid: file._id });
          }
        });
      }

      var scanfileUpdateHandler = function scanfileUpdateHandler(message) {
        $log.debug('[DMS][SCAN][FileBrowser] vertx eb scanfile.update, refresh files: ', message);
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function (files) {
            $log.debug('[DMS][SCAN][FileBrowser] Files refresh for scanfile.update successfull: ', files);
            Rlog.debug('dms.scan', 'filebrowser', 'Files refresh for scanfile.update success', {});
          }, function (err) {
            $log.error('[DMS][SCAN][FileBrowser] Files refresh for scanfile.update failed: ', err);
            // Rlog.error('dms.scan', 'filebrowser', 'Files refresh for scanfile.update failed', {error: err});
            Rlog.error('dms.scan', 'filebrowser', 'Files refresh for scanfile.update failed', {});
          });
        }
      };

      var filesUpdateHandler = function filesUpdateHandler(message) {
        $log.debug('[DMS][SCAN][FileBrowser] eb files.update caught: ', message);
        var fileid = message.split(':')[0];
        var tabid = message.split(':')[1];
        if (angular.isDefined(vm.files)) {

          // check if the updated file is inside the set
          if (vm.files.some(function (f) {
            return f._id === fileid;
          })) {
            // and change was not caused by us
            if (tabid !== $window.sessionStorage.getItem('sprtabid')) {
              $log.debug('[DMS][SCAN][FileBrowser] eb files.update refreshed because change did not originate in this viewer: ', message);
              vm.files.$refresh();
            }
          }
        }
      };

      // listen for files updates
      vertxEventBusService.on('files.update', {}, filesUpdateHandler);

      // listen for scan files updates
      vertxEventBusService.on('scanfile.update', {}, scanfileUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
        vertxEventBusService.unregisterHandler('scanfile.update', {}, scanfileUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcfile
   * @description
   *
   */
  angular.module('vcdms.vcfile', ['ui.router', 'ui.grid', 'ui.bootstrap', 'ngTagsInput', 'vcexam']);

  angular.module('vcdms.vcfile').filter('trustUrl', ['$sce', function ($sce) {
    return function (recordingUrl) {
      return $sce.trustAsResourceUrl('/routes/files/filereader/' + recordingUrl);
    };
  }]);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('patfileupload', {
    restrict: 'E',
    bindings: {
      patientid: '<?'
    },
    template: '\n        <fileupload parentsave="vm.savewithsigning(filedata)"\n            label="Hinaufladen mit Vidierung"\n            color="success"\n            clientid="vm.patientid"\n            method="vidieren">\n        </fileupload>\n        <fileupload parentsave="vm.savewithoutsigning()"\n            label="Hinaufladen ohne Vidierung"\n            color="warning"\n            clientid="vm.patientid"\n            method="nichtvidieren">\n        </fileupload>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', function ($log, File, Rlog) {
      var vm = this;
      vm.savewithsigning = savewithsigning;
      vm.savewithoutsigning = savewithoutsigning;

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue) && changes.clientid.currentValue.length > 0) {
          vm.patientid = changes.clientid.currentValue;
          vm.clientid = changes.clientid.currentValue;
        }
      };

      function savewithsigning(filedata) {
        File.$find(filedata.fileid).$then(function (file) {
          $log.debug('save filewithsigning: ', file);
          /*              file.scanstatus = 'assigned';
                        file.signedoff = 'false';
                        file.doccat = 'patient';
                        file.active = true;
                        file.$save().$then(()=>{},(err)=>{
                          $log.error('fileupload metdata for vidierung could not be saved: ', err);
                          Rlog.error('vcdms.file', 'patfileupload', 'fileupload metdata for vidierung could not be saved', {file: file._id});
          
                        });*/
        }, function (err) {
          $log.error('fileupload metdata could not be retrieved for further editing: ', err);
          Rlog.error('vcdms.file', 'patfileupload', 'fileupload metdata could not be retrieved for further editing', {});
        });
      }

      function savewithoutsigning() {
        $log.debug('saved without vidieren');
        // do nothing, defaults are set for patient fileupload without vidierung
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('imagecapture', {
    restrict: 'E',
    bindings: {
      filehandle: '=',
      parentsave: '&',
      label: '@?',
      color: '@?',
      consultid: '<?',
      examid: '<?',
      clientid: '<?',
      filecat: '@?'
    },
    template: '\n          <input type="file" name="imgc{{vm.captureid}}" id="imgc{{vm.captureid}}"\n                 class="inputfile"  accept="image/*;capture=camera" />\n          <label class="btn btn-{{vm.color || \'primary\'}}" for="imgc{{vm.captureid}}"\n                 uib-tooltip="Kamera oder Photo upload"><i class="fa fa-camera"></i> {{vm.label || \'\'}}\n            <span ng-show="vm.saved"><i class="fa fa-check text-success"></i></span>\n            <span ng-show="vm.error"><i class="fa fa-warning text-danger"></i></span>\n          </label>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Fileupload', '$element', '$timeout', function ($log, $http, Rlog, Fileupload, $element, $timeout) {
      var vm = this;
      vm.upload = upload;

      // create unique identifiers for fileupload input ids

      // init
      vm.$onInit = function () {
        vm.captureid = guid();

        if (angular.isUndefined(vm.clientid)) {
          vm.clientid = '';
        }
        if (angular.isUndefined(vm.consultid)) {
          vm.consultid = '';
        }
        if (angular.isUndefined(vm.examid)) {
          vm.examid = '';
        }

        if (angular.isUndefined(vm.filecat)) {
          vm.filecat = 'imagecapture';
        }
        $element.bind('change', function (e) {
          vm.icfile = (e.srcElement || e.target).files[0];
          vm.upload();
        });
      };

      // vm.consultid, etc might be late propagating
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid)) {
            vm.consultid = changes.consultid.currentValue;
          }
          if (angular.isDefined(changes.clientid)) {
            vm.clientid = changes.clientid.currentValue;
          }
          if (angular.isDefined(changes.examid)) {
            vm.examid = changes.examid.currentValue;
          }
        }
      };

      function upload() {
        $log.debug('vm.filecat', vm.filecat);
        Fileupload.uploadFileToUrl(vm.icfile, vm.filecat, vm.consultid, vm.clientid, vm.examid).then(function () {
          vm.saved = true;
          $timeout(function () {
            delete vm.saved;
          }, 5000);
        }, function (err) {
          $log.error('Fileupload error: ', err);
          vm.error = true;
          $timeout(function () {
            delete vm.error;
          }, 5000);
        });
      }

      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('genfileupload', {
    restrict: 'E',
    bindings: {},
    template: '\n        <fileupload\n            parentsave="vm.savewithoutsigning(filedata)"\n            label="Hinaufladen ohne Vidierung"\n            color="success">\n        </fileupload>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', function ($log, File, Rlog) {
      var vm = this;
      vm.savewithoutsigning = savewithoutsigning;

      function savewithoutsigning(filedata) {
        File.$find(filedata.fileid).$then(function (file) {
          $log.debug('save filewithsigning: ', file);
          file.scanstatus = 'finished';
          file.signedoff = 'false';
          file.doccat = 'generic';
          file.active = true;
          file.$save();
        }, function (err) {
          $log.error('fileupload metdata could not be retrieved for further editing: ', err);
          Rlog.error('vcdms.file', 'genfileupload', 'fileupload metdata could not be retrieved for further editing', { fileid: filedata.fileid });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global FormData */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name utils.fileuploader.factory:Fileupload
   *
   * @description
   *
   */
  angular.module('vcdms.vcfile').factory('Fileupload', Fileupload);

  Fileupload.$inject = ['$http', '$log', 'Rlog'];

  function Fileupload($http, $log, Rlog) {
    var FileuploadBase = {};
    FileuploadBase.uploadFileToUrl = function (file, filecat, consultid, clientid, examid, method) {
      var fd = new FormData();

      // TODO: tweak backend to accept patientfname or look it up by itself
      fd.append('file', file);
      fd.append('filecat', filecat);
      fd.append('consultid', consultid);
      fd.append('patientid', clientid);
      fd.append('clientid', clientid);
      fd.append('examid', examid);
      fd.append('method', method);
      $log.debug('Uploading using method: ', method);
      Rlog.debug('vcdms.file', 'fileupload-factory', 'Uploading using method: ' + method, { method: method });

      return $http.post('/routes/files/upload', fd, {
        transformRequest: angular.identity,
        headers: { 'Content-Type': undefined }
      });
    };
    return FileuploadBase;
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('fileupload', {
    restrict: 'E',
    bindings: {
      parentsave: '&',
      label: '@?',
      color: '@?',
      consultid: '<?',
      examid: '<?',
      clientid: '<?',
      method: '@?'
    },
    template: '\n          <input type="file" name="{{vm.uuid}}" id="{{vm.uuid}}" class="inputfile" />\n          <label class="btn btn-{{vm.color || \'primary\'}}" for="{{vm.uuid}}" uib-tooltip="Datei upload">\n            <i class="fa fa-upload" ></i> {{vm.label || \'\' }}\n            <span ng-show="vm.saved"><i class="fa fa-check text-success"></i></span>\n            <span ng-show="vm.error"><i class="fa fa-warning text-danger"></i></span>\n          </label>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Fileupload', '$element', '$timeout', function ($log, $http, Rlog, Fileupload, $element, $timeout) {
      var vm = this;
      vm.upload = upload;

      // create unique identifiers for fileupload input ids
      vm.uuid = guid();

      // init
      vm.$onInit = function () {
        // handle optional parameters

        if (angular.isUndefined(vm.clientid)) {
          vm.clientid = '';
          vm.patientid = '';
        }
        if (angular.isUndefined(vm.consultid)) {
          vm.consultid = '';
        }
        if (angular.isUndefined(vm.examid)) {
          vm.examid = '';
        }
        if (angular.isUndefined(vm.method)) {
          vm.method = 'unspecified';
        }
        $element.bind('change', function (e) {
          vm.ufile = (e.srcElement || e.target).files[0];
          vm.upload();
        });
      };

      // vm.consultid, etc might be late propagating
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid)) {
            vm.consultid = changes.consultid.currentValue;
          }
          if (angular.isDefined(changes.clientid)) {
            vm.clientid = changes.clientid.currentValue;
          }
          if (angular.isDefined(changes.examid)) {
            vm.examid = changes.examid.currentValue;
          }
        }
      };

      function upload() {
        Fileupload.uploadFileToUrl(vm.ufile, 'fileupload', vm.consultid, vm.clientid, vm.examid, vm.method).then(function (res) {
          $log.debug('Fileupload successful: ', res);
          vm.saved = true;
          vm.parentsave({ filedata: res.data });
          $timeout(function () {
            delete vm.saved;
          }, 5000);
        }, function (err) {
          $log.error('Fileupload error: ', err);
          Rlog.error('vcdms.file', 'fileupload-component', 'Fileupload error: ', { ufile: vm.ufile });

          vm.error = true;
          $timeout(function () {
            delete vm.error;
          }, 5000);
          return res;
        });
      }

      function guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('filesearch', {
    restrict: 'E',
    bindings: {
      file: '<',
      fileref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   \n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showfile($item, $model, $label)"\n                   uib-typeahead="file as file.text for file in vm.getFiles($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addFile()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addFile()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <fileeditor file="vm.file"></fileeditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'FileHelper', function ($log, File, FileHelper) {
      var vm = this;
      vm.save = save;
      vm.showfile = showfile;

      vm.getFiles = getFiles;
      // vm.addFile = FileHelper.addFile;
      vm.addFile = addFile;
      vm.editFile = FileHelper.editFile;

      vm.$onInit = function () {
        vm.newfile = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastfile = angular.copy(vm.fileresult);
        vm.lastfileref = angular.copy(vm.fileref);
      };

      function addFile() {
        $log.debug('debug - filesearch addFile called');
        FileHelper.addFile(function (file) {
          $log.debug('debug: handle newly create file');
          vm.file = {};
          vm.file.name = file.name;
          vm.file.short = file.short;
          vm.file._id = file._id;
          vm.fileref = file._id;
          vm.asyncSelected = file.short;
          vm.parentsave({ file: vm.file, fileref: vm.fileref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead file search backend query
      function getFiles(val) {
        // return Fileahead.$search({query: val}).$asPromise().then(function (response) {
        return File.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (file) {
            file.text = file.short;
            delete vm.error;
            return file;
          });
        });
      }

      // typeahead file search action
      function showfile($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.file = $model;
        vm.fileref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.file = $model;
          vm.fileref = $model._id;
          $log.debug('debug - filesearch editinplace');
        } else {
          vm.file = {};
          vm.file.name = $model.name;
          vm.file.short = $model.short;
          vm.file._id = $model._id;
          vm.fileref = $model._id;
          vm.parentsave({ file: vm.file, fileref: vm.fileref });
          $log.debug('debug - filesearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.file, vm.lastfile) || !angular.equals(vm.fileref, vm.lastfileref)) {
          vm.lastfile = angular.copy(vm.file);
          vm.lastfileref = angular.copy(vm.fileref);
          vm.parentsave({ file: vm.file, fileref: vm.fileref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('filenew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="filenew-component" data-hook="filenew-component">\n        <h3>Neue/s file anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addFile()" ng-hide="vm.newfile">Neue/s file anlegen</div>\n        <div ng-show="vm.newfile">\n          <fileform file="vm.newfile" parentsave="vm.saveNewFile(file)" oncancel="vm.cancel()"></fileform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> file erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen file wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> file konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', function ($log, File, Rlog) {
      var vm = this;
      vm.addFile = addFile;
      vm.saveNewFile = saveNewFile;
      vm.cancel = cancel;

      function addFile() {
        vm.newfile = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewFile(file) {
        $log.debug('debug: create new file: ', file);
        delete vm.newfile;
        File.$create(file).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new file failed: ', err);
          Rlog.error('vcutils.file', 'filenew', 'Creation of new file failed: ', { file: vm.newfile });
        });
      }

      function cancel() {
        delete vm.newfile;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('filelist', {
    restrict: 'E',
    bindings: {
      files: '<?',
      fidname: '@?',
      fid: '<?'
    },
    template: '\n        <table class="table table-striped hidden-xs hidden-sm">\n          <thead>\n          <tr>\n            <th>Datum</th>\n            <th>Bezeichnung</th>\n            <th>Tags</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="file in vm.files">\n          <td>{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</td>\n            <td>\n                <span ng-show="file.filename" uib-tooltip="{{file.filename}}">{{file.type}}</span>\n                <span ng-hide="file.filename">{{file.type}}</span>\n            </td>\n            <td>\n              <span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}</span>\n            </td>\n            <td>\n             <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">\n                <i class="fa fa-eye"></i>\n             </a>\n             <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">\n                <i class="fa fa-download"></i>\n             </a>\n             <!-- delete file, mit Rückfrage -->\n             <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"\n                ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">\n                <i class="fa fa-remove"></i>\n             </a>\n             <!-- unlink file, mit Rückfrage -->\n             <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"\n               ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n               class="btn btn-warning btn-xs">\n                <i class="fa fa-unlink"></i>\n             </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>\n            </td>\n          </tr>\n        </table>\n        <div class="hidden-md hidden-lg hidden-xl">\n          <div class="row" ng-repeat="file in vm.files">\n            <div class="col-xs-6">{{file.type}}</div>\n            <div class="col-xs-6">{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>\n            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->\n            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}<wbr></span></div>\n            <div class="col-xs-12">\n               <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">\n                  <i class="fa fa-eye"></i>\n               </a>\n               <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">\n                  <i class="fa fa-download"></i>\n               </a>\n               <!-- delete file, mit Rückfrage -->\n               <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"\n                  ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">\n                  <i class="fa fa-remove"></i>\n               </a>\n               <!-- unlink file, mit Rückfrage -->\n               <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"\n                 ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n                 class="btn btn-warning btn-xs">\n                  <i class="fa fa-unlink"></i>\n               </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>\n            </div>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService', function ($log, $http, Rlog, File, FileHelper, vertxEventBusService) {
      var vm = this;
      vm.editFile = FileHelper.editFile;
      vm.removeFile = removeFile;
      vm.getTags = getTags;

      vm.$onInit = function () {
        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.files)) {
          if (angular.isDefined(vm.fid) && angular.isDefined(vm.fidname)) {
            File.$searchBy(vm.fidname, vm.fid).$then(function (files) {
              vm.files = files;
            }, function (err) {
              $log.error('files search by foreign id failed, id: ', vm.fidname, vm.fid, err);
              Rlog.error('files', 'filelist', 'files search by foreign id failed ', {
                fid: vm.fid,
                fidname: vm.fidname
              });
            });
          }
        }
      }; // $onInit()

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.fid)) {
            vm.fid = changes.fid.currentValue;
            File.$searchBy(vm.fidname, vm.fid).$then(function (files) {
              vm.files = files;
            }, function (err) {
              $log.error('files search by foreign id failed, id: ', vm.fidname, vm.fid, err);
              Rlog.error('files', 'filelist', 'files search by foreign id failed ', {
                fid: vm.fid,
                fidname: vm.fidname
              });
            });
          }
        }
      };

      function removeFile(file) {
        file.active = false;
        file.$save();
      }

      function getTags(val) {
        $log.debug('debug - getTags called!');
        var myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];

        return $http.post('/routes/files/aggregate', match).then(function (response) {
          var tags = [];
          // $log.debug('tags data received: ', response);
          for (var i = 0; i < response.data.length; i++) {
            tags.push({ text: response.data[i]._id });
          }
          $log.debug('debug - tags: ', tags);
          return tags;
        });
      }

      var filesUpdateHandler = function filesUpdateHandler(message) {
        $log.debug('debug: file update received: ', message);
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function () {
            $log.debug('debug: filelist refreshed files');
          }, function (error) {
            $log.debug('debug: filelist refresh files failed: ', error);
          });
        }
      };

      vertxEventBusService.on('files.update', {}, filesUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
      };

      vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die \n            Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. \n            W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('fileeditor', {
    restrict: 'E',
    bindings: {
      file: '<?',
      fileid: '<?'
    },
    template: '\n        <fileform file="vm.file" parentsave="vm.childsave(file)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> file erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen file wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> file konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'File', 'Rlog', function ($log, File, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.file) || !vm.file.hasOwnProperty('_id')) && angular.isDefined(vm.fileid)) {
          getFile();
        }
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.fileid) && angular.isDefined(changes.fileid.currentValue) && changes.fileid.currentValue.length > 0) {
          vm.fileid = changes.fileid.currentValue;
          getFile();
        }
      };

      function getFile() {
        File.$find(vm.fileid).$then(function (file) {
          vm.file = file;
        }, function (err) {
          $log.error('file not found, id: ', vm.fileid, err);
          Rlog.error('file', 'fileeditor', 'file not found', { _id: vm.fileid });
        });
      }

      function childsave(file) {
        // vm.file = angular.copy(file);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in file) {
          if (file.hasOwnProperty(key)) {
            vm.file[key] = file[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.file.$hasPendingActions()) {
          vm.file.$cancel();
          vm.file.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of file failed: ', err);
            Rlog.error('vcutils.file', 'fileeditor', 'Saving of file failed: ', { fileid: vm.file._id });
          });
        } else {
          vm.file.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of file failed: ', err);
            Rlog.error('vcutils.file', 'fileeditor', 'Saving of file failed: ', { fileid: vm.file._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcfile').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmsfile', {
      url: '/vcdmsfile',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;filesearch file="" fileref="" editinplace="true"&gt;</tt></h3><div ui-view="filesearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;filesearch file="" fileref="" parentsave=""&gt;</tt></h3><div ui-view="filesearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;fileeditor file="" mode="" onClose=""&gt;</tt></h3><div ui-view="fileeditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;fileupload label="@?" color="@?" clientid="&lt;?" consultid="&lt;?" examid="&lt;?"&gt;</tt></h3><div ui-view="filenewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;imagecapture label="@?" color="@?" clientid="&lt;?" consultid="&lt;?" examid="&lt;?"&gt;</tt></h3><div ui-view="filenewview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;filelist files="?"&gt;</tt></h3><div ui-view="filelistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;consultfilelist consultid=""&gt;</tt></h3><div ui-view="consultfilelistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;complexfilelist files="?"&gt;</tt></h3><div ui-view="complexfilelistview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcfile entered');
      }
    });

    $stateProvider.state('playground.vcdmsfile.allcomponents', {
      url: '/allcomponents',
      resolve: {
        file: function file() {
          return '';
        },
        fileref: function fileref() {
          return '';
        },
        someconsultid: function someconsultid() {
          return '586e2b49a60359af68ae5cb9';
        },
        somefile: function somefile(File) {
          return File.$find('572b31b07c01597e3e150923');
        },
        allfiles: function allfiles(File) {
          return File.$search({ active: true });
        },
        pscans: function pscans(File) {
          return File.$search({ jobid: 'processedscan', active: { $ne: false } });
        },
        scans: function scans(File) {
          return File.$search({ jobid: 'scan', active: { $ne: false } });
        },
        parentsavesearch: function parentsavesearch() {
          return function (file, fileref) {
            console.log('debug: dummy parentsave called for filesearch with: ', file, fileref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'filesearchview@playground.vcdmsfile': {
          component: 'filesearch',
          bindings: {
            file: 'file',
            fileref: 'fileref',
            editinplace: 'eip'
          }
        },
        'filesearchview2@playground.vcdmsfile': {
          component: 'filesearch',
          bindings: {
            file: 'file',
            fileref: 'fileref',
            parentsave: 'parentsavesearch'
          }
        },
        'fileeditview@playground.vcdmsfile': {
          component: 'fileeditor',
          bindings: {
            file: 'somefile'
          }
        },
        'filenewview@playground.vcdmsfile': {
          component: 'fileupload',
          bindings: {
            consultid: 'someconsultid'
          }
        },
        'filenewview2@playground.vcdmsfile': {
          component: 'imagecapture',
          bindings: {
            consultid: 'someconsultid'
          }
        },
        'filelistview@playground.vcdmsfile': {
          component: 'filelist',
          bindings: {
            files: 'allfiles'
          }
        },
        'consultfilelistview@playground.vcdmsfile': {
          component: 'consultfilelist',
          bindings: {
            consultid: 'someconsultid'
          }
        },
        'complexfilelistview@playground.vcdmsfile': {
          component: 'complexfilelist',
          bindings: {
            files: 'pscans'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmsfile.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcfile.factory:FileHelper
   *
   * @description
   *
   */
  angular.module('vcdms.vcfile').factory('FileHelper', FileHelper);

  FileHelper.$inject = ['File', '$uibModal', '$log', 'Rlog'];

  function FileHelper(File, $uibModal, $log, Rlog) {
    var FileHelperBase = {};

    FileHelperBase.editFile = editFile;
    FileHelperBase.addFile = addFile;

    function addFile(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><fileform file="vm.file" parentsave="vm.childsave(file)" oncancel="vm.cancel()"></filenew></div>',
        controllerAs: 'fileaCtrl',
        controller: ['file', function () {
          var vm = this;
          vm.file = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(file) {
            File.$create(file).$then(function (newfile) {
              vm.created = true;
              success(newfile);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ file-helper.addFile: ', err);
              Rlog.error('vcutils.file', 'file-helper.addFile', 'Creation of new File failed: ', { file: file });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          file: function file() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editFile(lfile) {
      var dialog = $uibModal.open({
        template: '\n          <div class="modalspacer">\n            <fileform file="fileeCtrl.file" parentsave="fileeCtrl.childsave(file)"\n                      oncancel="fileeCtrl.cancel()"></fileform>\n          </div>\n        ',
        controllerAs: 'fileeCtrl',
        controller: ['file', function (sfile) {
          var vm = this;
          vm.file = sfile;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(file) {
            // vm.file = angular.copy(file);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in file) {
              if (file.hasOwnProperty(key)) {
                vm.file[key] = file[key];
              }
            }

            if (vm.file.$hasPendingActions()) {
              vm.file.$cancel();
              vm.file.$save();
              cancel();
            } else {
              vm.file.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          file: function file() {
            return lfile;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return FileHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.file.factory:File
   *
   * @description
   *
   */
  angular.module('vcdms.vcfile').factory('File', File);

  File.$inject = ['restmod'];
  function File(restmod) {
    return restmod.model('/routes/files', 'DebouncedModel').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/files/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var realquery = {};
            realquery[key] = val;
            realquery.active = { $ne: false };
            return this.$search(realquery);
          },
          $searchMetaBy: function $searchMetaBy(key, val) {
            // TODO: this one is probably not needed, file collection only contains metadata
            var realquery = { active: { $ne: false } };
            realquery[key] = val;

            return this.$search({
              query: realquery,
              options: {
                fields: {
                  _id: true,
                  created: true,
                  type: true,
                  filename: true,
                  patientid: true,
                  invoicenr: true,
                  receiptnr: true,
                  examid: true
                }
              }
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('consultimagelist', {
    restrict: 'E',
    bindings: {
      consultid: '<?'
    },
    template: '\n      <div ng-show="vm.images && vm.images.length > 0"  data-hook="consultimagelist-component">\n        <h4>Bilder &amp; Videos</h4>\n        <div class="row">\n          <div class="col-xs-12 col-md-3" ng-repeat="img in vm.images">\n            <img class="img-responsive" ng-src="/routes/files/filereader/{{img.fileid}}" ng-if="vm.isimg(img.mimetype)" data-hook="consultimage" data-filename="{{img.filename}}" data-consult-medium-index="{{$index}}">\n            <video controls class="img-responsive" ng-src="{{img.fileid | trustUrl}}"  ng-if="vm.isvideo(img.mimetype)" data-hook="consultvideo" data-filename="{{img.filename}}" data-consult-medium-index="{{$index}}"></video>\n            <video controls class="img-responsive" ng-src="/routes/files/filereader/{{img.fileid}}"  ng-if="vm.isvideo(img.mimetype)"></video>\n            <br>\n            <span ng-show="vm.isimg(img.mimetype)">\n                <input type="checkbox" ng-model="img.include" ng-change="vm.saveFile(img)" data-hook="includeconsultimg-{{$index}}" data-label-for="{{img.filename}}">&nbsp;in Befund inkludieren\n            </span>\n            <span ng-show="vm.isvideo(img.mimetype)"><input type="checkbox" disabled ng-model="img.include">&nbsp;in Befund inkludieren </span>\n            <input type="text" ng-model="img.label"  data-hook="includeconsultimglabel-{{$index}}"\n                   ng-blur="vm.saveFile(img)"\n                   class="form-control" placeholder="Bildunterschrift ..."><br>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService', '$window', function ($log, $http, Rlog, File, FileHelper, vertxEventBusService, $window) {
      var vm = this;
      vm.editFile = FileHelper.editFile;
      vm.removeFile = removeFile;
      vm.saveFile = saveFile;
      vm.getTags = getTags;
      vm.isimg = isimg;
      vm.isvideo = isvideo;

      vm.$onInit = function () {
        if (angular.isDefined(vm.consultid)) {
          // let query = {consultid: vm.consultid, type: 'Bild/Foto'};
          // TODO: fix the query / issue
          var query = { consultid: vm.consultid, type: { $ne: 'Datei' }, sharetype: { $ne: 'generic' } };

          File.$search(query).$then(function (files) {
            vm.images = files;
          });
        }
      };

      // vm.consultid might be late propagating, get files on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            // File.$search({consultid: vm.consultid, type: 'Bild/Foto'}).$then(function (files) {
            // TODO: fix the query / issue
            File.$search({
              consultid: vm.consultid,
              type: { $ne: 'Datei' },
              sharetype: { $ne: 'generic' }
            }).$then(function (files) {
              vm.images = files;
            }, function (err) {
              $log.error('image file lookup failed for consultid id: ', vm.consultid, err);
              Rlog.error('file', 'consultimagelist', 'image file lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      function isimg(mt) {
        return mt.indexOf('image') >= 0;
      }

      function isvideo(mt) {
        return mt.indexOf('video') >= 0;
      }

      function saveFile(file) {
        if (file.$hasPendingActions()) {
          file.$cancel();
          $log.debug('cancelled file pending actions in consultimagelist');
        }
        file.$save().$then(function () {
          vm.saved = true;
        }, function (err) {
          vm.saved = false;
          $log.error('saving of consult failed: ', err);
          Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
            consultid: file._id
          });
        });
      }

      function removeFile(file) {
        file.active = false;
        file.$save();
      }

      function getTags(val) {
        $log.debug('debug - getTags called!');
        var myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];

        return $http.post('/routes/files/aggregate', match).then(function (response) {

          var tags = [];
          // $log.debug('tags data received: ', response);
          for (var i = 0; i < response.data.length; i++) {
            tags.push({ text: response.data[i]._id });
          }
          $log.debug('debug - tags: ', tags);
          return tags;
        });
      }

      var filesCreateHandler = function filesCreateHandler(message) {
        $log.debug('debug: file update received: ', message);
        if (angular.isDefined(vm.images)) {
          vm.images.$refresh().$then(function () {
            $log.debug('dms:file:consultimagelist refreshed files');
          }, function (error) {
            $log.error('dms:file:consultimagelist refresh files failed: ', error);
          });
        }
      };

      var filesUpdateHandler = function filesUpdateHandler(message) {
        $log.debug('debug: file update received: ', message);
        var messages = message.split(':');

        // only refresh list if change was NOT triggered by this browser
        if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && angular.isDefined(vm.exam) && vm.exam._id === messages[0]) {
          if (angular.isDefined(vm.images)) {
            vm.images.$refresh().$then(function () {
              $log.debug('dms:file:consultimagelist refreshed files');
            }, function (error) {
              $log.debug('dms:file:consultimagelist refresh files failed: ', error);
            });
            $log.debug('(consultimagelist) refreshed images');
          }
        } else {
          $log.debug(' ((consultimagelist)) ignored images change');
        }
      };

      vertxEventBusService.on('files.create', {}, filesCreateHandler);

      vertxEventBusService.on('files.update', {}, filesUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.create', {}, filesCreateHandler);
        vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
      };

      vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die \n            Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. \n            W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of files (patients) to display or load files */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('consultfilelist', {
    restrict: 'E',
    bindings: {
      consultid: '<?'
    },
    template: '\n      <div ng-show="vm.files && vm.files.length > 0">\n      <h4>Dateien</h4>\n        <table class="table table-striped hidden-xs hidden-sm">\n          <thead>\n          <tr>\n            <th width="15%">Datum</th>\n            <th width="30%">Bezeichnung</th>\n            <th width="35%">Tags</th>\n            <th width="20%">Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="file in vm.files">\n          <td>{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</td>\n            <td>\n                <input type="text" class="form-control" ng-model="file.description" id="desc_{{$index}}" ng-blur="vm.saveFile(file)"></input>\n            </td>\n            <!-- tags -->\n            <td>\n            <tags-input ng-model="file.keywords"\n                display-property="text"\n                id="filekeywords{{$index}}"\n                add-on-paste="true"\n                add-on-comma="false"\n                add-on-enter="true"\n                min-length="1"\n                ng-blur="vm.saveFile(file)"\n                enable-editing-last-tag="true"\n                add-from-autocomplete-only="false"\n                replace-spaces-with-dashes="false"\n                template="filetag-template">\n              <auto-complete source="vm.getTags($query)"\n                             min-length="1"\n                             load-on-focus="true"\n                             load-on-empty="false"\n                             load-on-down-arrow="true"\n                             max-results-to-show="32"\n                             select-first-match="true"\n                             template="filetagautocomplete-template">\n              </auto-complete>\n            </tags-input>\n<!-- <span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}</span> -->\n            </td>\n            <td>\n             <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">\n                <i class="fa fa-eye"></i>\n             </a>\n             <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">\n                <i class="fa fa-download"></i>\n             </a>\n             <!-- delete file, mit Rückfrage -->\n             <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"\n                ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">\n                <i class="fa fa-remove"></i>\n             </a>\n             <!-- unlink file, mit Rückfrage -->\n             <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"\n               ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n               class="btn btn-warning btn-xs">\n                <i class="fa fa-unlink"></i>\n             </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>\n            </td>\n          </tr>\n        </table>\n\n        <!-- xs, sm view -->\n        <div class="hidden-md hidden-lg hidden-xl">\n          <div class="row" ng-repeat="file in vm.files">\n            <div class="col-xs-6"><input ng-model="file.type" id="type_{{$index}}" ng-blur="vm.saveFile(file)" placeholder="Dateityp ..."></input></span></div>\n            <div class="col-xs-6">{{file.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>\n            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->\n            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in file.flattags">{{tag}}<wbr></span></div>\n            <div class="col-xs-12">             \n               <a href="/routes/files/filereader/{{file.fileid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">\n                  <i class="fa fa-eye"></i>\n               </a>\n               <a href="/routes/files/filedownload/{{file.fileid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">\n                  <i class="fa fa-download"></i>\n               </a>\n               <!-- delete file, mit Rückfrage -->\n               <a ng-really-click="vm.removeFile(file, $index)" class="btn btn-danger btn-xs" uib-tooltip="Datei l&ouml;schen"\n                  ng-really-message="Wollen Sie diese Datei wirklich l&ouml;schen?">\n                  <i class="fa fa-remove"></i>\n               </a>\n               <!-- unlink file, mit Rückfrage -->\n               <a ng-really-click="vm.unlinkFile(row.entity, $index)" uib-tooltip="Dateizuordnung aufheben"\n                 ng-really-message="Wollen Sie die Zuordnung dieser Datei r&uuml;ckg&auml;gig machen?"\n                 class="btn btn-warning btn-xs">\n                  <i class="fa fa-unlink"></i>\n               </a><sprhelp tip="Dateizuordnung aufheben" descref="vm.helpunlink"></sprhelp>\n            </div>\n          </div>\n        </div>\n        </div>\n        <!-- tag template -->\n<script type="text/ng-template" id="filetag-template">\n    <div class="tag-template">\n        <div class="right-panel">\n            <span>{{$getDisplayText()}}</span>\n            <a class="remove-button" ng-click="$removeTag()">&#10006;</a>\n        </div>\n    </div>\n</script>\n\n<!-- tag autocomplete template -->\n<script type="text/ng-template" id="filetagautocomplete-template">\n    <div class="filetagautocomplete-template" style="z-index: 10000">\n        <div>\n            <span ng-bind-html="$highlight($getDisplayText())">{{text}}</span>\n        </div>\n    </div>\n</script>\n',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'File', 'FileHelper', 'vertxEventBusService', function ($log, $http, Rlog, File, FileHelper, vertxEventBusService) {
      var vm = this;
      vm.editFile = FileHelper.editFile;
      vm.removeFile = removeFile;
      vm.saveFile = saveFile;
      vm.getTags = getTags;

      vm.$onInit = function () {
        if (angular.isDefined(vm.consultid)) {
          var query = { consultid: vm.consultid, type: 'Datei' };
          File.$search(query).$then(function (files) {
            vm.fileinations = files;
          });
        }
      };

      // vm.consultid might be late propagating, get files on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            File.$search({ consultid: vm.consultid, type: 'Datei' }).$then(function (files) {
              vm.files = files;
            }, function (err) {
              $log.error('file lookup failed for consultid id: ', vm.consultid, err);
              Rlog.error('file', 'consultfilelist', 'file lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      function saveFile(file) {
        if (file.$hasPendingActions()) {
          file.$cancel();
        }
        file.$save().$then(function () {
          vm.saved = true;
        }, function (err) {
          vm.saved = false;
          $log.error('saving of consult failed: ', err);
          Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
            consultid: file._id
          });
        });
      }

      function removeFile(file) {
        file.active = false;
        file.$save();
      }

      function getTags(val) {
        $log.debug('debug - getTags called!');
        var myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];

        return $http.post('/routes/files/aggregate', match).then(function (response) {
          var tags = [];
          // $log.debug('tags data received: ', response);
          for (var i = 0; i < response.data.length; i++) {
            tags.push({ text: response.data[i]._id });
          }
          $log.debug('debug - tags: ', tags);
          return tags;
        });
      }

      var filesUpdateHandler = function filesUpdateHandler(message) {
        $log.debug('debug: file update received: ', message);
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function () {
            $log.debug('debug: filelist refreshed files');
          }, function (error) {
            $log.debug('debug: filelist refresh files failed: ', error);
          });
        }
      };

      vertxEventBusService.on('files.update', {}, filesUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[DMS][FILE][ConsultFileList] onDestroy called');
        vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandler);
      };

      vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 24/04/2017. **/

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcfile').component('complexfilelist', {
    restrict: 'E',
    bindings: {
      files: '<',
      key: '@?',
      value: '@?'
    },
    templateUrl: 'vcdms/file/complexfilelist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', '$scope', 'uiGridConstants', 'vertxEventBusService', 'File', function ($log, $http, Rlog, $scope, uiGridConstants, vertxEventBusService, File) {
      var vm = this;
      vm.fileactiontemplate = 'fileactiontemplate';
      vm.filetagtemplate = 'filetagtemplate';
      vm.getTags = getTags;
      vm.saveFile = saveFile;
      vm.removeFile = removeFile;
      vm.unlinkFile = unlinkFile;
      vm.spinners = [];

      // init
      vm.$onInit = function () {
        if (angular.isUndefined(vm.files)) {
          if (angular.isString(vm.key) && angular.isString(vm.value)) {
            vm.mode = 'patient';
            // vm.files = File.$searchBy(vm.key, vm.value);
            var query = { active: { $ne: false }, sharetype: { $ne: 'generic' } };
            query[vm.key] = vm.value;
            vm.files = File.$search(query);
          } else {
            vm.mode = 'generic';
            vm.files = File.$search({ active: { $ne: false } });
          }
        } else {
          vm.mode = 'generic';
        }

        vm.gridOptions = {
          enableFiltering: true,
          enableSorting: true,
          columnDefs: [{
            field: 'created', displayName: 'Datum', type: 'date', width: '15%',
            cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.created | moment: \'lll\'}}</span></div>',
            filters: [{
              condition: uiGridConstants.filter.GREATER_THAN,
              placeholder: 'nach'
            }, {
              condition: uiGridConstants.filter.LESS_THAN,
              placeholder: 'vor'
            }],
            sort: {
              direction: uiGridConstants.DESC,
              priority: 1
            }
          }, {
            field: 'type', displayName: 'Typ', width: '20%',
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            displayName: 'Stichworte', name: 'flattags', cellClass: 'gridalignleft', width: '49%',
            cellTemplate: vm.filetagtemplate, enableFiltering: true,
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            displayName: 'Aktion', name: 'fileaction', cellClass: 'gridalignright', width: '16%',
            cellTemplate: vm.fileactiontemplate, enableFiltering: false, enableSorting: false
          }],
          data: vm.files,
          onRegisterApi: function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;
          }
        };
      };

      function getTags(val) {
        // TODO: evaluate need for ^ regex to beginning of tag
        // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var myregex = val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];

        return $http.post('/routes/files/aggregate', match).then(function (response) {
          $log.debug('tags received: ', response);
          var tags = new Set();
          if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
            // create set to group by value
            tags = new Set(response.data.map(function (tag) {
              return tag._id;
            }));
          } else if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data._id)) {
            tags = new Set([response.data._id]);
            $log.debug('tags: ', tags);
          }
          // return array because ngTagsLib expects an array not a set
          $log.debug('array working: ', Array.from(tags));

          return Array.from(tags);
        });
      }

      function saveFile(doc) {
        $log.debug('debug - saveFile called!');
        var flattags = [];
        $log.debug('doc: ', doc);
        if (angular.isArray(doc.keywords)) {
          for (var i = 0; i < doc.keywords.length; i++) {
            flattags.push(doc.keywords[i].text);
          }
          doc.flattags = flattags;
          doc.$save().$then(function () {
            vm.files.$refresh().$then(function () {
              vm.gridApi.core.refresh();
            });
          });
        }
      }

      function removeFile(file) {
        $log.debug('debug - removeFile: ', file);
        file.active = false;
        file.$save().$then(function () {
          vm.files.$refresh().$then(function () {
            vm.gridApi.core.refresh();
          });
        });
      }

      function unlinkFile(file) {
        delete file.doccat;
        delete file.type;
        delete file.signature;
        delete file.signedoff;
        delete file.patientname;
        delete file.patientid;
        // TODO: figure out correct jobid, processingstate after fileimport refactoring
        file.jobid = 'scan';
        file.processingstate = 'unprocessed';
        file.$save().$then(function () {
          vm.files.$refresh().$then(function () {
            vm.gridApi.core.refresh();
          });
        });
      }

      vm.helpunlink = 'Wenn Sie die Dateizuordnung aufheben, wird die Datei wieder in die Scan- bzw. Dateizuordnungliste eingereiht und kann erneut zugeordnet werden. W&auml;hlen Sie diese Option zum Beispiel dann, wenn Sie eine Datei der falschen Person zugeordnet haben.';

      var filesCreateHandler = function filesCreateHandler(message) {
        // $log.debug('debug: document update received: ', message);
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function () {
            $log.debug('debug: documentlist refreshed documents');
          }, function (error) {
            $log.debug('debug: documentlist refresh documents failed: ', error);
          });
        }
      };

      vertxEventBusService.on('files.create', {}, filesCreateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('files.create', {}, filesCreateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcpdfprinter
   * @description
   *
   */
  angular.module('vcdms.vcpdfprinter', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter').component('pdfprintersearch', {
    restrict: 'E',
    bindings: {
      pdfprinter: '<',
      pdfprinterref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showpdfprinter($item, $model, $label)"\n                   uib-typeahead="pdfprinter as pdfprinter.text for pdfprinter in vm.getPdfprinters($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addPdfprinter()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addPdfprinter()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <pdfprintereditor pdfprinter="vm.pdfprinter"></pdfprintereditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Pdfprinter', 'PdfprinterHelper', function ($log, Pdfprinter, PdfprinterHelper) {
      var vm = this;
      vm.save = save;
      vm.showpdfprinter = showpdfprinter;

      vm.getPdfprinters = getPdfprinters;
      // vm.addPdfprinter = PdfprinterHelper.addPdfprinter;
      vm.addPdfprinter = addPdfprinter;
      vm.editPdfprinter = PdfprinterHelper.editPdfprinter;

      vm.$onInit = function () {
        vm.newpdfprinter = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastpdfprinter = angular.copy(vm.pdfprinterresult);
        vm.lastpdfprinterref = angular.copy(vm.pdfprinterref);
      };

      function addPdfprinter() {
        $log.debug('debug - pdfprintersearch addPdfprinter called');
        PdfprinterHelper.addPdfprinter(function (pdfprinter) {
          $log.debug('debug: handle newly create pdfprinter');
          vm.pdfprinter = {};
          vm.pdfprinter.name = pdfprinter.name;
          vm.pdfprinter.short = pdfprinter.short;
          vm.pdfprinter._id = pdfprinter._id;
          vm.pdfprinterref = pdfprinter._id;
          vm.asyncSelected = pdfprinter.short;
          vm.parentsave({ pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead pdfprinter search backend query
      function getPdfprinters(val) {
        // return Pdfprinterahead.$search({query: val}).$asPromise().then(function (response) {
        return Pdfprinter.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (pdfprinter) {
            pdfprinter.text = pdfprinter.short;
            delete vm.error;
            return pdfprinter;
          });
        });
      }

      // typeahead pdfprinter search action
      function showpdfprinter($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.pdfprinter = $model;
        vm.pdfprinterref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.pdfprinter = $model;
          vm.pdfprinterref = $model._id;
          $log.debug('debug - pdfprintersearch editinplace');
        } else {
          vm.pdfprinter = {};
          vm.pdfprinter.name = $model.name;
          vm.pdfprinter.short = $model.short;
          vm.pdfprinter._id = $model._id;
          vm.pdfprinterref = $model._id;
          vm.parentsave({ pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref });
          $log.debug('debug - pdfprintersearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.pdfprinter, vm.lastpdfprinter) || !angular.equals(vm.pdfprinterref, vm.lastpdfprinterref)) {
          vm.lastpdfprinter = angular.copy(vm.pdfprinter);
          vm.lastpdfprinterref = angular.copy(vm.pdfprinterref);
          vm.parentsave({ pdfprinter: vm.pdfprinter, pdfprinterref: vm.pdfprinterref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter').component('pdfprinternew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="pdfprinternew-component" data-hook="pdfprinternew-component">\n        <h3>Neue/s pdfprinter anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addPdfprinter()" ng-hide="vm.newpdfprinter">Neue/s pdfprinter anlegen</div>\n        <div ng-show="vm.newpdfprinter">\n          <pdfprinterform pdfprinter="vm.newpdfprinter" parentsave="vm.saveNewPdfprinter(pdfprinter)" oncancel="vm.cancel()"></pdfprinterform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> pdfprinter erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen pdfprinter wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> pdfprinter konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Pdfprinter', 'Rlog', function ($log, Pdfprinter, Rlog) {
      var vm = this;
      vm.addPdfprinter = addPdfprinter;
      vm.saveNewPdfprinter = saveNewPdfprinter;
      vm.cancel = cancel;

      function addPdfprinter() {
        vm.newpdfprinter = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewPdfprinter(pdfprinter) {
        $log.debug('debug: create new pdfprinter: ', pdfprinter);
        delete vm.newpdfprinter;
        Pdfprinter.$create(pdfprinter).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new pdfprinter failed: ', err);
          Rlog.error('vcutils.pdfprinter', 'pdfprinternew', 'Creation of new pdfprinter failed: ', { pdfprinter: vm.newpdfprinter });
        });
      }

      function cancel() {
        delete vm.newpdfprinter;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of pdfprinters (patients) to display or load pdfprinters */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter').component('pdfprinterlist', {
    restrict: 'E',
    bindings: {
      pdfprinters: '<?'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="pdfprinter in vm.pdfprinters">\n            <td>{{pdfprinter.name}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editPdfprinter(pdfprinter)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removePdfprinter(pdfprinter)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Pdfprinter', 'PdfprinterHelper', 'vertxEventBusService', function ($log, $http, Rlog, Pdfprinter, PdfprinterHelper, vertxEventBusService) {
      var vm = this;
      vm.editPdfprinter = PdfprinterHelper.editPdfprinter;
      vm.removePdfprinter = removePdfprinter;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.pdfprinters)) {
          vm.pdfprinters = Pdfprinter.$search();
        }
      }; // $onInit()

      function removePdfprinter(pdfprinter) {
        pdfprinter.active = false;
        pdfprinter.$save();
      }

      var pdfprinterUpdateHandler = function pdfprinterUpdateHandler(message) {
        $log.debug('debug: pdfprinter update received: ', message);
        if (angular.isDefined(vm.pdfprinters)) {
          vm.pdfprinters.$refresh().$then(function () {
            $log.debug('debug: pdfprinterlist refreshed pdfprinters');
          }, function (error) {
            $log.debug('debug: pdfprinterlist refresh pdfprinters failed: ', error);
          });
        }
      };

      vertxEventBusService.on('pdfprinters.update', {}, pdfprinterUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('pdfprinters.update', {}, pdfprinterUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter').component('pdfprinterform', {
    restrict: 'E',
    bindings: {
      pdfprinter: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcdms/vcpdfprinterform-component.tpl.html',
    controllerAs: 'vm',
    controller: function controller() {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.lastpdfprinter = angular.copy(vm.pdfprinter);
      };

      function save() {
        if (!angular.equals(vm.pdfprinter, vm.lastpdfprinter)) {
          vm.lastpdfprinter = angular.copy(vm.pdfprinter);
          vm.parentsave({ pdfprinter: vm.pdfprinter });
        }
      }

      function cancel() {
        vm.pdfprinter = angular.copy(vm.lastpdfprinter);
        vm.oncancel();
      }
    } // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcpdfprinter').component('pdfprintereditor', {
    restrict: 'E',
    bindings: {
      pdfprinter: '<?',
      pdfprinterid: '<?'
    },
    template: '\n        <pdfprinterform pdfprinter="vm.pdfprinter" parentsave="vm.childsave(pdfprinter)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> pdfprinter erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen pdfprinter wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> pdfprinter konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Pdfprinter', 'Rlog', function ($log, Pdfprinter, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.pdfprinter) || !vm.pdfprinter.hasOwnProperty('_id')) && angular.isDefined(vm.pdfprinterid)) {
          Pdfprinter.$find(vm.pdfprinterid).$then(function (pdfprinter) {
            vm.pdfprinter = pdfprinter;
          }, function (err) {
            $log.error('pdfprinter not found, id: ', vm.pdfprinterid, err);
            Rlog.error('pdfprinter', 'pdfprintereditor', 'pdfprinter not found', { _id: vm.pdfprinterid });
          });
        }
      };

      function childsave(pdfprinter) {
        // vm.pdfprinter = angular.copy(pdfprinter);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in pdfprinter) {
          if (pdfprinter.hasOwnProperty(key)) {
            vm.pdfprinter[key] = pdfprinter[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.pdfprinter.$hasPendingActions()) {
          vm.pdfprinter.$cancel();
          vm.pdfprinter.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of pdfprinter failed: ', err);
            Rlog.error('vcutils.pdfprinter', 'pdfprintereditor', 'Saving of pdfprinter failed: ', { pdfprinterid: vm.pdfprinter._id });
          });
        } else {
          vm.pdfprinter.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of pdfprinter failed: ', err);
            Rlog.error('vcutils.pdfprinter', 'pdfprintereditor', 'Saving of pdfprinter failed: ', { pdfprinterid: vm.pdfprinter._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcpdfprinter').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmspdfprinter', {
      url: '/vcdmspdfprinter',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;pdfprintersearch pdfprinter="" pdfprinterref="" editinplace="true"&gt;</tt></h3><div ui-view="pdfprintersearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;pdfprintersearch pdfprinter="" pdfprinterref="" parentsave=""&gt;</tt></h3><div ui-view="pdfprintersearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;pdfprintereditor pdfprinter="" mode="" onClose=""&gt;</tt></h3><div ui-view="pdfprintereditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;pdfprinternew&gt;</tt></h3><div ui-view="pdfprinternewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;pdfprinterlist pdfprinters="?"&gt;</tt></h3><div ui-view="pdfprinterlistview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcpdfprinter entered');
      }
    });

    $stateProvider.state('playground.vcdmspdfprinter.allcomponents', {
      url: '/allcomponents',
      resolve: {
        pdfprinter: function pdfprinter() {
          return '';
        },
        pdfprinterref: function pdfprinterref() {
          return '';
        },
        somepdfprinter: function somepdfprinter(Pdfprinter) {
          return Pdfprinter.$find('572b31b07c01597e3e150923');
        },
        allpdfprinters: function allpdfprinters(Pdfprinter) {
          return Pdfprinter.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (pdfprinter, pdfprinterref) {
            console.log('debug: dummy parentsave called for pdfprintersearch with: ', pdfprinter, pdfprinterref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'pdfprintersearchview@playground.vcdmspdfprinter': {
          component: 'pdfprintersearch',
          bindings: {
            pdfprinter: 'pdfprinter',
            pdfprinterref: 'pdfprinterref',
            editinplace: 'eip'
          }
        },
        'pdfprintersearchview2@playground.vcdmspdfprinter': {
          component: 'pdfprintersearch',
          bindings: {
            pdfprinter: 'pdfprinter',
            pdfprinterref: 'pdfprinterref',
            parentsave: 'parentsavesearch'
          }
        },
        'pdfprintereditview@playground.vcdmspdfprinter': {
          component: 'pdfprintereditor',
          bindings: {
            pdfprinter: 'somepdfprinter'
          }
        },
        'pdfprinternewview@playground.vcdmspdfprinter': {
          component: 'pdfprinternew',
          bindings: {}
        },
        'pdfprinterlistview@playground.vcdmspdfprinter': {
          component: 'pdfprinterlist',
          bindings: {
            pdfprinters: 'allpdfprinters'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmspdfprinter.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcpdfprinter.factory:PdfprinterHelper
   *
   * @description
   *
   */
  angular.module('vcdms.vcpdfprinter').factory('PdfprinterHelper', PdfprinterHelper);

  PdfprinterHelper.$inject = ['Pdfprinter', '$uibModal', '$log', 'Rlog'];

  function PdfprinterHelper(Pdfprinter, $uibModal, $log, Rlog) {
    var PdfprinterHelperBase = {};

    PdfprinterHelperBase.editPdfprinter = editPdfprinter;
    PdfprinterHelperBase.addPdfprinter = addPdfprinter;

    function addPdfprinter(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><pdfprinterform pdfprinter="vm.pdfprinter" parentsave="vm.childsave(pdfprinter)" oncancel="vm.cancel()"></pdfprinternew></div>',
        controllerAs: 'pdfprinteraCtrl',
        controller: ['pdfprinter', function () {
          var vm = this;
          vm.pdfprinter = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(pdfprinter) {
            Pdfprinter.$create(pdfprinter).$then(function (newpdfprinter) {
              vm.created = true;
              success(newpdfprinter);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ pdfprinter-helper.addPdfprinter: ', err);
              Rlog.error('vcutils.pdfprinter', 'pdfprinter-helper.addPdfprinter', 'Creation of new pdfprinter failed: ', { pdfprinter: pdfprinter });
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          pdfprinter: function pdfprinter() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editPdfprinter(lpdfprinter) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><pdfprinterform pdfprinter="pdfprintereCtrl.pdfprinter" parentsave="pdfprintereCtrl.childsave(pdfprinter)" oncancel="pdfprintereCtrl.cancel()"></pdfprinterform></div>',
        controllerAs: 'pdfprintereCtrl',
        controller: ['pdfprinter', function (spdfprinter) {
          var vm = this;
          vm.pdfprinter = spdfprinter;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(pdfprinter) {
            // vm.pdfprinter = angular.copy(pdfprinter);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in pdfprinter) {
              if (pdfprinter.hasOwnProperty(key)) {
                vm.pdfprinter[key] = pdfprinter[key];
              }
            }

            if (vm.pdfprinter.$hasPendingActions()) {
              vm.pdfprinter.$cancel();
              vm.pdfprinter.$save();
              cancel();
            } else {
              vm.pdfprinter.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          pdfprinter: function pdfprinter() {
            return lpdfprinter;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return PdfprinterHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.pdfprinter.factory:Pdfprinter
   *
   * @description
   *
   */
  angular.module('vcdms.vcpdfprinter').factory('Pdfprinter', Pdfprinter);

  Pdfprinter.$inject = ['restmod'];
  function Pdfprinter(restmod) {
    return restmod.model('/routes/pdfprinters').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/pdfprinters/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcdocument
   * @description
   *
   */
  angular.module('vcdms.vcdocument', ['ui.router', 'ui.grid', 'ui.bootstrap', 'ngTagsInput']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documentsearch', {
    restrict: 'E',
    bindings: {
      document: '<',
      documentref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showdocument($item, $model, $label)"\n                   uib-typeahead="document as document.text for document in vm.getDocuments($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addDocument()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addDocument()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <documenteditor document="vm.document"></documenteditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Document', 'DocumentHelper', function ($log, Document, DocumentHelper) {
      var vm = this;
      vm.save = save;
      vm.showdocument = showdocument;

      vm.getDocuments = getDocuments;
      // vm.addDocument = DocumentHelper.addDocument;
      vm.addDocument = addDocument;
      vm.editDocument = DocumentHelper.editDocument;

      vm.$onInit = function () {
        vm.newdocument = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastdocument = angular.copy(vm.documentresult);
        vm.lastdocumentref = angular.copy(vm.documentref);
      };

      function addDocument() {
        $log.debug('debug - documentsearch addDocument called');
        DocumentHelper.addDocument(function (doc) {
          $log.debug('debug: handle newly create document');
          vm.document = {};
          vm.document.name = doc.name;
          vm.document.short = doc.short;
          vm.document._id = doc._id;
          vm.documentref = doc._id;
          vm.asyncSelected = doc.short;
          vm.parentsave({ document: vm.document, documentref: vm.documentref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead document search backend query
      function getDocuments(val) {
        // return Documentahead.$search({query: val}).$asPromise().then(function (response) {
        return Document.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (doc) {
            doc.text = doc.short;
            delete vm.error;
            return doc;
          });
        });
      }

      // typeahead document search action
      function showdocument($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.document = $model;
        vm.documentref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.document = $model;
          vm.documentref = $model._id;
          $log.debug('debug - documentsearch editinplace');
        } else {
          vm.document = {};
          vm.document.name = $model.name;
          vm.document.short = $model.short;
          vm.document._id = $model._id;
          vm.documentref = $model._id;
          vm.parentsave({ document: vm.document, documentref: vm.documentref });
          $log.debug('debug - documentsearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.document, vm.lastdocument) || !angular.equals(vm.documentref, vm.lastdocumentref)) {
          vm.lastdocument = angular.copy(vm.document);
          vm.lastdocumentref = angular.copy(vm.documentref);
          vm.parentsave({ document: vm.document, documentref: vm.documentref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documentnew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="documentnew-component" data-hook="documentnew-component">\n        <h3>Neue/s document anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addDocument()" ng-hide="vm.newdocument">Neue/s document anlegen</div>\n        <div ng-show="vm.newdocument">\n          <documentform document="vm.newdocument" parentsave="vm.saveNewDocument(document)" oncancel="vm.cancel()"></documentform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> document erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen document wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> document konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Document', 'Rlog', function ($log, Document, Rlog) {
      var vm = this;
      vm.addDocument = addDocument;
      vm.saveNewDocument = saveNewDocument;
      vm.cancel = cancel;

      function addDocument() {
        vm.newdocument = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewDocument(document) {
        $log.debug('debug: create new document: ', document);
        delete vm.newdocument;
        Document.$create(document).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new document failed: ', err);
          Rlog.error('vcutils.document', 'documentnew', 'Creation of new document failed: ', { document: vm.newdocument });
        });
      }

      function cancel() {
        delete vm.newdocument;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of documents (patients) to display or load documents */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documentlist', {
    restrict: 'E',
    bindings: {
      documents: '<?',
      key: '@?',
      value: '@?'
    },
    template: '\n        <table class="table table-striped hidden-xs hidden-sm">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Typ</th>\n            <th>Datum</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="document in vm.documents | filter: {active: !false}">\n            <td>{{document.documentname}}</td>\n            <td>{{document.type}}</td>\n            <td>{{document.created | javadate: \'lll\'}}</td>\n            <td>\n              <a href="/routes/pdfreader/{{document._id}}" target="_blank" class="btn btn-primary" uib-tooltip="PDF anzeigen"><i class="fa fa-eye"></i></a>\n              <a href="/routes/pdfdownload/{{document._id}}" class="btn btn-primary" uib-tooltip="PDF speichern"><i class="fa fa-download"></i></a>\n<!--              <button class="btn btn-danger" ng-really-click="vm.removeDocument(document)" ng-really-message="Wollen sie das Dokument {{document.type}} wirklich l&ouml;schen?"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>-->\n            </td>\n          </tr>\n        </table>\n\n        <div class="hidden-md hidden-lg hidden-xl">\n          <div class="row" ng-repeat="document in vm.documents">\n            <div class="col-xs-6">{{document.type}}</div>\n            <div class="col-xs-6">{{document.created |  moment: \'DD.MM.YYYY hh:mm\'}}</div>\n            <!-- Note! <wbr> is needed to allow linebreaking of tag array -->\n            <div class="col-xs-12"><span class="label label-info tagspacer" ng-repeat="tag in document.flattags">{{tag}}<wbr></span></div>\n            <div class="col-xs-12">\n               <a href="/routes/pdfreader/{{document.documentid}}" target="_blank" class="btn btn-primary btn-xs" uib-tooltip="Datei anzeigen">\n                  <i class="fa fa-eye"></i>\n               </a>\n               <a href="/routes/pdfdownload/{{document.documentid}}" class="btn btn-primary btn-xs" uib-tooltip="Datei herunterladen">\n                  <i class="fa fa-download"></i>\n               </a>\n            </div>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Document', 'DocumentHelper', 'vertxEventBusService', function ($log, $http, Rlog, Document, DocumentHelper, vertxEventBusService) {
      var vm = this;
      vm.editDocument = DocumentHelper.editDocument;
      vm.removeDocument = removeDocument;

      vm.$onInit = function () {

        if (angular.isUndefined(vm.documents)) {
          if (angular.isString(vm.key) && angular.isString(vm.value)) {
            vm.documents = Document.$searchMetaBy(vm.key, vm.value);
          } else {
            vm.documents = Document.$search();
          }
        }
      }; // $onInit()

      function removeDocument(doc) {
        doc.active = false;
        doc.$save().$then(function () {
          vm.documents.$refresh();
        });
      }

      var documentsUpdateHandler = function documentsUpdateHandler(message) {
        $log.debug('debug: document update received: ', message);
        if (angular.isDefined(vm.document)) {
          vm.documents.$refresh().$then(function () {
            $log.debug('debug: documentlist refreshed documents');
          }, function (error) {
            $log.debug('debug: documentlist refresh documents failed: ', error);
          });
        }
      };

      vertxEventBusService.on('documents.update', {}, documentsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('documents.update', {}, documentsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documentform', {
    restrict: 'E',
    bindings: {
      document: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcdms/document/documentform-component.tpl.html',
    controllerAs: 'vm',
    controller: function controller() {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      // vm.zipsave = zipsave;

      vm.$onInit = function () {
        vm.lastdocument = angular.copy(vm.document);
      };

      function save() {
        if (!angular.equals(vm.document, vm.lastdocument)) {
          vm.lastdocument = angular.copy(vm.document);
          vm.parentsave({ document: vm.document });
        }
      }

      function cancel() {
        vm.document = angular.copy(vm.lastdocument);
        vm.oncancel();
      }
    } // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documenteditor', {
    restrict: 'E',
    bindings: {
      document: '<?',
      documentid: '<?'
    },
    template: '\n        <documentform document="vm.document" parentsave="vm.childsave(document)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> document erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen document wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> document konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Document', 'Rlog', function ($log, Document, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      /*          vm.$onInit = function () {
                  if ((angular.isUndefined(vm.document) || !vm.document.hasOwnProperty('_id'))
                    && angular.isDefined(vm.documentid)) {
                    getDocument();
                  }
                };*/

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.documentid) && angular.isDefined(changes.documentid.currentValue) && changes.documentid.currentValue.length > 0) {
          vm.documentid = changes.documentid.currentValue;
          getDocument();
        }
      };

      function getDocument() {
        Document.$find(vm.documentid).$then(function (document) {
          vm.document = document;
        }, function (err) {
          $log.error('document not found, id: ', vm.documentid, err);
          Rlog.error('document', 'documenteditor', 'document not found', { _id: vm.documentid });
        });
      }

      function childsave(doc) {
        // vm.document = angular.copy(document);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in doc) {
          if (doc.hasOwnProperty(key)) {
            vm.document[key] = doc[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.document.$hasPendingActions()) {
          vm.document.$cancel();
          vm.document.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of document failed: ', err);
            Rlog.error('vcutils.document', 'documenteditor', 'Saving of document failed: ', { documentid: vm.document._id });
          });
        } else {
          vm.document.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of document failed: ', err);
            Rlog.error('vcutils.document', 'documenteditor', 'Saving of document failed: ', { documentid: vm.document._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('documentconfig', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>Patientenbezogene Dokumentkategorien</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>Häufig gebrauchte Dokumentkategorien</label>\n            <listeditor list="vm.dmspatientcat.dmspatientcat" parentsave="vm.childsavepat(list)"></listeditor>\n          </div>\n        </div>\n                <div class="panel panel-info spacer-top">\n        <div class="panel-heading">\n          <h3>Allgemeine Dokumentkategorien</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>Häufig gebrauchte Dokumentkategorien</label>\n            <listeditor list="vm.dmsgencat.dmsgencat" parentsave="vm.childsavegen(list)"></listeditor>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService', function ($log, Config, Rlog, vertxEventBusService) {
      var vm = this;
      vm.childsavepat = childsavepat;
      vm.childsavegen = childsavegen;

      vm.$onInit = function () {
        // db.appconfig.insert({_id: 'dmsgencat', dmsgencat: conf.dmsgencat});
        // db.appconfig.insert({_id: 'dmspatientcat', dmspatientcat: conf.dmspatientcat});
        Config.$find('dmsgencat').$then(function (dmsgencat) {
          vm.dmsgencat = dmsgencat;
          // intialize if still empty
          if (angular.isUndefined(vm.dmsgencat.dmsgencat)) {
            vm.dmsgencat._id = 'dmsgencat';
            vm.dmsgencat.dmsgencat = [];
          }
        });
        Config.$find('dmspatientcat').$then(function (dmspatientcat) {
          vm.dmspatientcat = dmspatientcat;
          // intialize if still empty
          if (angular.isUndefined(vm.dmspatientcat.dmspatientcat)) {
            vm.dmspatientcat._id = 'dmspatientcat';
            vm.dmspatientcat.dmspatientcat = [];
          }
        });
      };

      function childsavegen(list) {
        vm.dmsgencat.dmsgencat = list;
        savegen();
      }

      function childsavepat(list) {
        vm.dmspatientcat.dmspatientcat = list;
        savepat();
      }

      function savegen() {
        if (vm.dmsgencat.$hasPendingActions()) {
          vm.dmsgencat.$cancel();
        }
        vm.dmsgencat.$save();
      }

      function savepat() {
        if (vm.dmspatientcat.$hasPendingActions()) {
          vm.dmspatientcat.$cancel();
        }
        vm.dmspatientcat.$save();
      }

      var configUpdateHandler = function configUpdateHandler(message) {
        // $log.debug('debug: config update received: ', message);
        var messages = message.split(':');
        if (messages[0] === 'dmspatientcat') {
          if (angular.isDefined(vm.dmspatientcat)) {
            vm.dmspatientcat.$refresh().$then(function () {
              $log.debug('debug: config refresh dmspatientcat');
            }, function (error) {
              $log.debug('debug: config refresh dmspatientcat failed: ', error);
            });
          }
        }

        if (messages[0] === 'dmsgencat') {
          if (angular.isDefined(vm.dmsgencat)) {
            vm.dmsgencat.$refresh().$then(function () {
              $log.debug('debug: config refresh dmsgencat');
            }, function (error) {
              $log.debug('debug: config refresh dmsgencat failed: ', error);
            });
          }
        }
      };

      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcdocument').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmsdocument', {
      url: '/vcdmsdocument',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;documentsearch document="" documentref="" editinplace="true"&gt;</tt></h3><div ui-view="documentsearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;documentsearch document="" documentref="" parentsave=""&gt;</tt></h3><div ui-view="documentsearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;documenteditor document="" mode="" onClose=""&gt;</tt></h3><div ui-view="documenteditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;documentnew&gt;</tt></h3><div ui-view="documentnewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;documentlist documents="?"&gt;</tt></h3><div ui-view="documentlistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;documentlist key="?" value="?"&gt;</tt></h3><div ui-view="documentlistview2"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcdocument entered');
      }
    });

    $stateProvider.state('playground.vcdmsdocument.allcomponents', {
      url: '/allcomponents',
      resolve: {
        document: function document() {
          return '';
        },
        documentref: function documentref() {
          return '';
        },
        somedocument: function somedocument(Document) {
          return Document.$find('572b31b07c01597e3e150923');
        },
        alldocuments: function alldocuments(Document) {
          return Document.$search({ active: { $ne: false } });
        },
        consultdocuments: function consultdocuments(Document) {
          return Document.$searchMetaBy('consultid', '57163e2f7c01595d1efa74cf');
        },
        parentsavesearch: function parentsavesearch() {
          return function (document, documentref) {
            console.log('debug: dummy parentsave called for documentsearch with: ', document, documentref);
          };
        },
        eip: function eip() {
          return true;
        },
        keyconsultid: function keyconsultid() {
          return 'consultid';
        },
        valconsultid: function valconsultid() {
          return '57163e2f7c01595d1efa74cf';
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'documentsearchview@playground.vcdmsdocument': {
          component: 'documentsearch',
          bindings: {
            document: 'document',
            documentref: 'documentref',
            editinplace: 'eip'
          }
        },
        'documentsearchview2@playground.vcdmsdocument': {
          component: 'documentsearch',
          bindings: {
            document: 'document',
            documentref: 'documentref',
            parentsave: 'parentsavesearch'
          }
        },
        'documenteditview@playground.vcdmsdocument': {
          component: 'documenteditor',
          bindings: {
            document: 'somedocument'
          }
        },
        'documentnewview@playground.vcdmsdocument': {
          component: 'documentnew',
          bindings: {}
        },
        'documentlistview@playground.vcdmsdocument': {
          component: 'documentlist',
          bindings: {
            documents: 'alldocuments'
          }
        },
        'documentlistview2@playground.vcdmsdocument': {
          component: 'documentlist',
          bindings: {
            key: 'keyconsultid',
            value: 'valconsultid'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmsdocument.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcdocument.factory:DocumentHelper
   *
   * @description
   *
   */
  angular.module('vcdms.vcdocument').factory('DocumentHelper', DocumentHelper);

  DocumentHelper.$inject = ['Document', '$uibModal', '$log', 'Rlog'];

  function DocumentHelper(Document, $uibModal, $log, Rlog) {
    var DocumentHelperBase = {};

    DocumentHelperBase.editDocument = editDocument;
    DocumentHelperBase.addDocument = addDocument;

    function addDocument(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><documentform document="vm.document" parentsave="vm.childsave(document)" oncancel="vm.cancel()"></documentnew></div>',
        controllerAs: 'documentaCtrl',
        controller: ['document', function () {
          var vm = this;
          vm.document = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(document) {
            Document.$create(document).$then(function (newdocument) {
              vm.created = true;
              success(newdocument);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ document-helper.addDocument: ', err);
              Rlog.error('vcutils.document', 'document-helper.addDocument', 'Creation of new SV failed: ', { document: document });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          document: function document() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editDocument(ldocument) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><documentform document="documenteCtrl.document" parentsave="documenteCtrl.childsave(document)" oncancel="documenteCtrl.cancel()"></documentform></div>',
        controllerAs: 'documenteCtrl',
        controller: ['document', function (sdocument) {
          var vm = this;
          vm.document = sdocument;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doc) {
            // vm.document = angular.copy(doc);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in doc) {
              if (doc.hasOwnProperty(key)) {
                vm.document[key] = doc[key];
              }
            }

            if (vm.document.$hasPendingActions()) {
              vm.document.$cancel();
              vm.document.$save();
              cancel();
            } else {
              vm.document.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          document: function document() {
            return ldocument;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return DocumentHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.document.factory:Document
   *
   * @description
   *
   */
  angular.module('vcdms.vcdocument').factory('Document', Document);

  Document.$inject = ['restmod'];

  function Document(restmod) {
    return restmod.model('/routes/binarypdf', {
      $hooks: {
        'before-request': function beforeRequest(req) {
          console.log('before-fetch-many this, req: ', this, req);
          // this hook adapts the request to onlz return meta data, not the binary file content
          if (angular.isUndefined(req.params) || req.params === null) {
            req.params = {};
          }
          if (angular.isUndefined(req.params) || angular.isUndefined(req.params.options)) {
            req.params.options = {
              fields: {
                _id: true,
                created: true,
                type: true,
                filename: true,
                patientid: true,
                invoicenr: true,
                receiptnr: true,
                examid: true,
                clientid: true,
                consultid: true,
                keywords: true,
                flattags: true,
                date: true,
                isodate: true,
                examtype: true
              }
            };
          }

          console.log('before-fetch-many this, req: ', this, req);
        }
      }
    }).mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/binarypdf/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var realquery = { active: { $ne: false } };
            realquery[key] = val;
            return this.$search({
              query: realquery,
              options: {
                fields: {
                  _id: true,
                  created: true,
                  type: true,
                  filename: true,
                  patientid: true,
                  invoicenr: true,
                  receiptnr: true,
                  examid: true,
                  clientid: true,
                  consultid: true,
                  keywords: true,
                  flattags: true,
                  date: true,
                  isodate: true,
                  examtype: true
                }
              }
            });
          },
          $searchMetaBy: function $searchMetaBy(key, val) {
            var realquery = { active: { $ne: false } };
            realquery[key] = val;

            return this.$search({
              query: realquery,
              options: {
                fields: {
                  _id: true,
                  created: true,
                  type: true,
                  filename: true,
                  patientid: true,
                  invoicenr: true,
                  receiptnr: true,
                  examid: true,
                  clientid: true,
                  consultid: true,
                  keywords: true,
                  flattags: true,
                  date: true,
                  isodate: true,
                  examtype: true
                }
              }
            });
          },
          $getLast: function $getLast(patid, type) {
            var realquery = { active: { $ne: false } };
            realquery.patientid = patid;
            realquery.pdftype = type;

            return this.$search({
              query: realquery,
              options: {
                fields: {
                  file: false
                },
                sort: { _id: -1 },
                limit: 1
              }
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
/**
 * Created by lari on 24/04/2017. **/

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdocument').component('complexdocumentlist', {
    restrict: 'E',
    bindings: {
      documents: '<?',
      key: '@?',
      value: '@?'
    },
    templateUrl: 'vcdms/document/complexdocumentlist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Document', 'Rlog', '$scope', 'uiGridConstants', 'vertxEventBusService', function ($log, $http, Document, Rlog, $scope, uiGridConstants, vertxEventBusService) {
      var vm = this;
      vm.documentactiontemplate = 'documentactiontemplate';
      vm.documenttagtemplate = 'documenttagtemplate';
      vm.getTags = getTags;
      vm.saveDocument = saveDocument;
      vm.removeDocument = removeDocument;
      // vm.unlinkdocument = unlinkdocument;
      vm.spinners = [];

      vm.$onInit = function () {
        if (angular.isUndefined(vm.documents)) {
          if (angular.isString(vm.key) && angular.isString(vm.value)) {
            vm.documents = Document.$searchMetaBy(vm.key, vm.value);
          } else {
            vm.documents = Document.$search();
          }
        }

        vm.gridOptions = {
          enableFiltering: true,
          enableSorting: true,
          columnDefs: [{
            field: 'created', displayName: 'Datum', type: 'date', width: '15%',
            cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.created | moment: \'lll\'}}</span></div>',
            filters: [{
              condition: uiGridConstants.filter.GREATER_THAN,
              placeholder: 'nach'
            }, {
              condition: uiGridConstants.filter.LESS_THAN,
              placeholder: 'vor'
            }],
            sort: {
              direction: uiGridConstants.DESC,
              priority: 1
            }
          }, {
            field: 'type', displayName: 'Typ', width: '40%',
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            displayName: 'Stichworte', name: 'flattags', cellClass: 'gridalignleft', width: '33%',
            cellTemplate: vm.documenttagtemplate, enableFiltering: true, enableSorting: false,
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            displayName: 'Aktion', name: 'documentaction', cellClass: 'gridalignright', width: '12%',
            cellTemplate: vm.documentactiontemplate, enableFiltering: false, enableSorting: false
          }],
          data: vm.documents,
          onRegisterApi: function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;
          }
        };
      }; // $onInit()

      function getTags(val) {
        // TODO: evaluate need for ^ regex to beginning of tag
        // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
        var myregex = val; // when using $regex, do not include '/' for regex delimiter
        var match = [{ $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $unwind: '$flattags' }, { $match: { flattags: { $regex: myregex, $options: 'i' } } }, { $group: { _id: '$flattags', total: { $sum: 1 } } }];

        return $http.post('/routes/binarypdf/aggregate', match).then(function (response) {
          $log.debug('complexdoclist tags received: ', response);
          var tags = new Set();
          if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
            // create set to group by value
            tags = new Set(response.data.map(function (tag) {
              return tag._id;
            }));
            $log.debug('complexdoclist tags from result array: ', tags);
          } else if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data._id)) {
            tags = new Set([response.data._id]);
            $log.debug('complexdoclist tags from single result: ', tags);
          }
          // return array because ngTagsLib expects an array not a set
          $log.debug('complexdoclist Array from tags set: ', Array.from(tags), tags);
          return Array.from(tags);
        });
      }

      function saveDocument(doc) {
        $log.debug('complex document lsit - savedocument called! ', doc.keywords);
        var flattags = [];
        $log.debug('doc: ', doc);
        if (angular.isArray(doc.keywords)) {
          for (var i = 0; i < doc.keywords.length; i++) {
            flattags.push(doc.keywords[i].text);
          }
          doc.flattags = flattags;
          doc.$save().$then(function () {
            vm.documents.$refresh().$then(function () {
              vm.gridApi.core.refresh();
            });
          });
        }
      }

      function removeDocument(ldocument) {
        ldocument.active = false;
        ldocument.$save().$then(function () {
          vm.documents.$refresh();
          vm.gridApi.core.refresh();
        });
      }

      var documentsCreateHandler = function documentsCreateHandler(message) {
        $log.debug('debug: document update received: ', message);
        if (angular.isDefined(vm.documents)) {
          vm.documents.$refresh().$then(function () {
            $log.debug('debug: documentlist refreshed documents');
          }, function (error) {
            $log.debug('debug: documentlist refresh documents failed: ', error);
          });
        }
      };

      vertxEventBusService.on('documents.create', {}, documentsCreateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('documents.create', {}, documentsCreateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms.vcdoctype
   * @description
   *
   */
  angular.module('vcdms.vcdoctype', []);
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name printer.factory:Printer
   *
   * @description
   *
   */
  angular.module('vcdms.vcdoctype').factory('Printer', Printer).factory('Printerlist', Printerlist);

  Printer.$inject = ['restmod'];

  function Printer(restmod) {
    return restmod.model('/routes/printer');
  }

  Printerlist.$inject = ['restmod'];

  function Printerlist(restmod) {
    var model = restmod.model('/routes/printer');
    var printers = {};
    function getPrinters() {
      return model.$search();
    }

    printers.getPrinters = getPrinters;
    printers.model = model;

    return printers;
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdoctype').component('doctypesearch', {
    restrict: 'E',
    bindings: {
      doctype: '<',
      doctyperef: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showdoctype($item, $model, $label)"\n                   uib-typeahead="doctype as doctype.text for doctype in vm.getDoctypes($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-refresh"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-remove"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addDoctype()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addDoctype()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <doctypeeditor doctype="vm.doctype"></doctypeeditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctype', 'DoctypeHelper', function ($log, Doctype, DoctypeHelper) {
      var vm = this;
      vm.save = save;
      vm.showdoctype = showdoctype;

      vm.getDoctypes = getDoctypes;
      // vm.addDoctype = DoctypeHelper.addDoctype;
      vm.addDoctype = addDoctype;
      vm.editDoctype = DoctypeHelper.editDoctype;

      vm.$onInit = function () {
        vm.newdoctype = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastdoctype = angular.copy(vm.doctyperesult);
        vm.lastdoctyperef = angular.copy(vm.doctyperef);
      };

      function addDoctype() {
        $log.debug('debug - doctypesearch addDoctype called');
        DoctypeHelper.addDoctype(function (doctype) {
          $log.debug('debug: handle newly create doctype');
          vm.doctype = {};
          vm.doctype.name = doctype.name;
          vm.doctype.short = doctype.short;
          vm.doctype._id = doctype._id;
          vm.doctyperef = doctype._id;
          vm.asyncSelected = doctype.short;
          vm.parentsave({ doctype: vm.doctype, doctyperef: vm.doctyperef });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead doctype search backend query
      function getDoctypes(val) {
        // return Doctypeahead.$search({query: val}).$asPromise().then(function (response) {
        return Doctype.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (doctype) {
            doctype.text = doctype.short;
            delete vm.error;
            return doctype;
          });
        });
      }

      // typeahead doctype search action
      function showdoctype($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.doctype = $model;
        vm.doctyperef = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.doctype = $model;
          vm.doctyperef = $model._id;
          $log.debug('debug - doctypesearch editinplace');
        } else {
          vm.doctype = {};
          vm.doctype.name = $model.name;
          vm.doctype.short = $model.short;
          vm.doctype._id = $model._id;
          vm.doctyperef = $model._id;
          vm.parentsave({ doctype: vm.doctype, doctyperef: vm.doctyperef });
          $log.debug('debug - doctypesearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.doctype, vm.lastdoctype) || !angular.equals(vm.doctyperef, vm.lastdoctyperef)) {
          vm.lastdoctype = angular.copy(vm.doctype);
          vm.lastdoctyperef = angular.copy(vm.doctyperef);
          vm.parentsave({ doctype: vm.doctype, doctyperef: vm.doctyperef });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdoctype').component('doctypenew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="doctypenew-component" data-hook="doctypenew-component">\n        <h3>Neue/s doctype anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addDoctype()" ng-hide="vm.newdoctype">Neue/s doctype anlegen</div>\n        <div ng-show="vm.newdoctype">\n          <doctypeform doctype="vm.newdoctype" parentsave="vm.saveNewDoctype(doctype)" oncancel="vm.cancel()"></doctypeform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> doctype erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines/r neuen doctype wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> doctype konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctype', 'Rlog', function ($log, Doctype, Rlog) {
      var vm = this;
      vm.addDoctype = addDoctype;
      vm.saveNewDoctype = saveNewDoctype;
      vm.cancel = cancel;

      function addDoctype() {
        vm.newdoctype = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewDoctype(doctype) {
        $log.debug('debug: create new doctype: ', doctype);
        delete vm.newdoctype;
        Doctype.$create(doctype).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new doctype failed: ', err);
          Rlog.error('vcutils.doctype', 'doctypenew', 'Creation of new doctype failed: ', { doctype: vm.newdoctype });
        });
      }

      function cancel() {
        delete vm.newdoctype;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of doctypes (patients) to display or load doctypes */

'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdoctype').component('doctypelist', {
    restrict: 'E',
    bindings: {
      doctypes: '<?'
    },
    template: '\n        <h3>Dokumententypen und Drucker</h3>\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>ID</th>\n            <th>Name</th>\n            <th>XSLT</th>\n            <th>Drucker</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="dt in vm.doctypes">\n            <td>{{dt._id}}</td>\n            <td>{{dt.name}}</td>\n            <td>{{dt.stylesheet}}</td>\n            <td>{{dt.printer}}</td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editDoctype(dt)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeDoctype(dt)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Doctype', 'DoctypeHelper', 'vertxEventBusService', function ($log, $http, Rlog, Doctype, DoctypeHelper, vertxEventBusService) {
      var vm = this;
      vm.editDoctype = DoctypeHelper.editDoctype;
      vm.removeDoctype = removeDoctype;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.doctypes)) {
          vm.doctypes = Doctype.$search();
        }
      }; // $onInit()

      function removeDoctype(doctype) {
        doctype.active = false;
        doctype.$save();
      }
      var doctypesUpdateHandler = function doctypesUpdateHandler(message) {
        $log.debug('debug: doctype update received: ', message);
        vm.doctypes.$refresh().$then(function () {
          $log.debug('debug: doctypelist refreshed doctypes');
        }, function (error) {
          $log.debug('debug: doctypelist refresh doctypes failed: ', error);
        });
      };

      vertxEventBusService.on('doctypes.update', {}, doctypesUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('doctypes.update', {}, doctypesUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdoctype').component('doctypeform', {
    restrict: 'E',
    bindings: {
      doctype: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcdms/doctype/doctypeform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Printerlist', function ($log, Printerlist) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.lastdoctype = angular.copy(vm.doctype);
        vm.allprinters = Printerlist.getPrinters();
      };

      function save() {
        if (!angular.equals(vm.doctype, vm.lastdoctype)) {
          vm.lastdoctype = angular.copy(vm.doctype);
          vm.parentsave({ doctype: vm.doctype });
        }
      }

      function cancel() {
        vm.doctype = angular.copy(vm.lastdoctype);
        vm.oncancel();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdms.vcdoctype').component('doctypeeditor', {
    restrict: 'E',
    bindings: {
      doctype: '<?',
      doctypeid: '<?'
    },
    template: '\n        <doctypeform doctype="vm.doctype" parentsave="vm.childsave(doctype)" oncancel="vm.oncancel()"></doctypeform>\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> doctype erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen doctype wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> doctype konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Doctype', 'Rlog', '$timeout', function ($log, Doctype, Rlog, $timeout) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.doctype) || !vm.doctype.hasOwnProperty('_id')) && angular.isDefined(vm.doctypeid)) {
          Doctype.$find(vm.doctypeid).$then(function (doctype) {
            vm.doctype = doctype;
          }, function (err) {
            $log.error('doctype not found, id: ', vm.doctypeid, err);
            Rlog.error('doctype', 'doctypeeditor', 'doctype not found', { _id: vm.doctypeid });
          });
        }
      };

      function childsave(doctype) {
        // vm.doctype = angular.copy(doctype);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in doctype) {
          if (doctype.hasOwnProperty(key)) {
            vm.doctype[key] = doctype[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.doctype.$hasPendingActions()) {
          vm.doctype.$cancel();
          vm.doctype.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            $log.error('saving of doctype failed: ', err);
            Rlog.error('vcutils.doctype', 'doctypeeditor', 'Saving of doctype failed: ', { doctypeid: vm.doctype._id });
          });
        } else {
          vm.doctype.$save().$then(function () {
            vm.saved = true;
            reset('saved');
          }, function (err) {
            vm.saved = false;
            reset('saved');
            $log.error('saving of doctype failed: ', err);
            Rlog.error('vcutils.doctype', 'doctypeeditor', 'Saving of doctype failed: ', { doctypeid: vm.doctype._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
        reset('canceled');
      }

      function reset(rvar) {
        $timeout(function () {
          delete vm[rvar];
        }, 3500);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdms.vcdoctype').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.vcdmsdoctype', {
      url: '/vcdmsdoctype',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;doctypesearch doctype="" doctyperef="" editinplace="true"&gt;</tt></h3><div ui-view="doctypesearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctypesearch doctype="" doctyperef="" parentsave=""&gt;</tt></h3><div ui-view="doctypesearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctypeeditor doctype="" mode="" onClose=""&gt;</tt></h3><div ui-view="doctypeeditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctypenew&gt;</tt></h3><div ui-view="doctypenewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;doctypelist doctypes="?"&gt;</tt></h3><div ui-view="doctypelistview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdmsvcdoctype entered');
      }
    });

    $stateProvider.state('playground.vcdmsdoctype.allcomponents', {
      url: '/allcomponents',
      resolve: {
        doctype: function doctype() {
          return '';
        },
        doctyperef: function doctyperef() {
          return '';
        },
        somedoctype: function somedoctype(Doctype) {
          return Doctype.$find('572b31b07c01597e3e150923');
        },
        alldoctypes: function alldoctypes(Doctype) {
          return Doctype.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (doctype, doctyperef) {
            console.log('debug: dummy parentsave called for doctypesearch with: ', doctype, doctyperef);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'doctypesearchview@playground.vcdmsdoctype': {
          component: 'doctypesearch',
          bindings: {
            doctype: 'doctype',
            doctyperef: 'doctyperef',
            editinplace: 'eip'
          }
        },
        'doctypesearchview2@playground.vcdmsdoctype': {
          component: 'doctypesearch',
          bindings: {
            doctype: 'doctype',
            doctyperef: 'doctyperef',
            parentsave: 'parentsavesearch'
          }
        },
        'doctypeeditview@playground.vcdmsdoctype': {
          component: 'doctypeeditor',
          bindings: {
            doctype: 'somedoctype'
          }
        },
        'doctypenewview@playground.vcdmsdoctype': {
          component: 'doctypenew',
          bindings: {}
        },
        'doctypelistview@playground.vcdmsdoctype': {
          component: 'doctypelist',
          bindings: {
            doctypes: 'alldoctypes'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcdmsdoctype.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcdoctype.factory:DoctypeHelper
   *
   * @description
   *
   */
  angular.module('vcdms.vcdoctype').factory('DoctypeHelper', DoctypeHelper);

  DoctypeHelper.$inject = ['Doctype', '$uibModal', '$log', 'Rlog'];

  function DoctypeHelper(Doctype, $uibModal, $log, Rlog) {
    var DoctypeHelperBase = {};

    DoctypeHelperBase.editDoctype = editDoctype;
    DoctypeHelperBase.addDoctype = addDoctype;

    function addDoctype(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><doctypeform doctype="vm.doctype" parentsave="vm.childsave(doctype)" oncancel="vm.cancel()"></doctypenew></div>',
        controllerAs: 'doctypeaCtrl',
        controller: ['doctype', function () {
          var vm = this;
          vm.doctype = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doctype) {
            Doctype.$create(doctype).$then(function (newdoctype) {
              vm.created = true;
              success(newdoctype);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ doctype-helper.addDoctype: ', err);
              Rlog.error('vcutils.doctype', 'doctype-helper.addDoctype', 'Creation of new new Doctype failed: ', { doctype: doctype });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          doctype: function doctype() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editDoctype(ldoctype) {
      var dialog = $uibModal.open({
        template: '\n          <div class="modalspacer">\n             <doctypeform doctype="doctypeeCtrl.doctype" parentsave="doctypeeCtrl.childsave(doctype)"\n                          oncancel="doctypeeCtrl.cancel()"></doctypeform>\n          </div>',
        controllerAs: 'doctypeeCtrl',
        controller: ['doctype', function (sdoctype) {
          var vm = this;
          vm.doctype = sdoctype;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(doctype) {
            // vm.doctype = angular.copy(doctype);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in doctype) {
              if (doctype.hasOwnProperty(key)) {
                vm.doctype[key] = doctype[key];
              }
            }

            if (vm.doctype.$hasPendingActions()) {
              vm.doctype.$cancel();
              vm.doctype.$save();
              cancel();
            } else {
              vm.doctype.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          doctype: function doctype() {
            return ldoctype;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return DoctypeHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.doctype.factory:Doctype
   *
   * @description
   *
   */
  angular.module('vcdms.vcdoctype').factory('Doctype', Doctype);

  Doctype.$inject = ['restmod'];
  function Doctype(restmod) {
    return restmod.model('/routes/doctypes').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/doctypes/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var query = {};
            query[key] = val;
            return this.$search(query);
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @description
   *
   */
  angular.module('vcutils', ['ui.router', 'vcutils.config', 'vcutils.doctor', 'vcutils.heartbeat', 'vcutils.listeditor', 'vcutils.map', 'vcutils.rlog', 'vcutils.sprhelp', 'vcutils.sv', 'vcutils.vcfields', 'vcutils.printhelper', 'vcutils.vcshare', 'vcutils.zipcode']);
})();
'use strict';

(function () {
    'use strict';

    /* @ngdoc object
     * @name vcasset
     * @description
     *
     */
    angular.module('vcuser', ['vcuser.vcuser', 'vcuser.vclogin']);
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vctracker
   * @description
   *
   */
  angular.module('vctracker', []);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackervaluenew', {
    restrict: 'E',
    bindings: {
      clientid: '<',
      trackerid: '<?',
      onentrycb: '&?'
    },
    template: '\n      <div class="trackervaluenew-component" data-hook="trackervaluenew-component">\n        <h3>Meßwerte eingeben</h3>\n        <div class="row" ng-show="vm.trackers.length == 0">\n          <div class="col-xs-12">\n            <div class="alert alert-info">\n              <i class="fa fa-info-circle fa-2x"></i> Sie haben noch keine Meßwert-Tracker definiert. Legen Sie einen <a href="/#/settings/tracker" style="text-decoration: underline;">neuen Meßwert-Tracker</a> im Einstellungsmenü an.\n           </div>\n          </div>\n        </div>\n        <div class="row" ng-repeat="t in vm.trackers" ng-show="vm.trackers.length > 0">\n            <div class="col-xs-12 col-md-6">\n              <!-- TODO: graph trackervalues -->\n              <div class="panel panel-info">\n                  <div class="panel-heading">\n                    <span class="pull-left">{{t.name}}</span>\n                    <span class="pull-right">\n                      <div class="btn btn-primary btn-xs" ng-click="vm.snapshot()" ng-show="vm.plotlyref"><i class="fa fa-camera"></i></div>\n                      <div class="btn-group" ng-init="showtable = false">\n                          <label class="btn btn-primary btn-xs" ng-model="showtable" uib-btn-radio="false"><i class="fa fa-line-chart"></i> </label>\n                          <label class="btn btn-primary btn-xs" ng-model="showtable" uib-btn-radio="true"><i class="fa fa-table"></i> </label>\n                      </div>\n                    </span>\n                    <span class="clearfix"></span>\n                  </div>\n                  <div class="panel-body">\n                    <trackervaluegraph ng-hide="showtable === true" trackerid="t._id" clientid="vm.clientid" \n                        snapshothandle="vm.addSnapShotReference(snapshot)"></trackervaluegraph>\n                    <trackervaluelist  ng-show="showtable === true" trackerid="t._id" clientid="vm.clientid"></trackervaluelist>\n                  </div>\n                </div>\n            </div>\n            <div class="col-xs-12 col-md-6">\n                <div class="panel panel-info">\n                <div class="panel-heading">{{t.name}}:\n                    <span ng-if="t.def.length === 1">Neuen Wert eingeben</span>\n                    <span ng-if="t.def.length > 1">Neue Werte eingeben</span>\n                </div>\n                <div class="panel-body">\n                    <trackervalueform trackervalue="vm.newvalues[t._id]"\n                                      trackerid="t._id"\n                                      parentsave="vm.saveNewTrackervalue(trackervalue, trackerid)"\n                                      oncancel="vm.cancel()">\n                    </trackervalueform>\n                </div>\n            </div>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Trackervalue', 'Tracker', 'Rlog', 'vertxEventBusService', function ($log, Trackervalue, Tracker, Rlog, vertxEventBusService) {
      var vm = this;
      vm.addTrackervalue = addTrackervalue;
      vm.saveNewTrackervalue = saveNewTrackervalue;
      vm.addSnapShotReference = addSnapShotReference;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.values = {};
        vm.newvalues = {};

        // If trackerid is not defined load all active trackers
        // Show UI for each Tracker on patient/client Tracker page
        if (angular.isUndefined(vm.trackerid)) {
          getTrackers({ active: true });
        }

        // Show only UI for Tracker identified by trackerid
        else if (angular.isString(vm.trackerid) && vm.trackerid.length > 0) {
            getTrackers({ active: true, _id: vm.trackerid });
          }
      };

      // clientid might be propagating late
      // clientid is only needed to add new tracking data
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue && changes.clientid.currentValue.length > 0)) {
          vm.clientid = changes.clientid.currentValue;
        }

        // trackeridid might be propagating late
        if (angular.isDefined(changes.trackerid) && angular.isDefined(changes.trackerid.currentValue && changes.trackerid.currentValue.length > 0)) {
          vm.trackerid = changes.trackerid.currentValue;
          getTrackers({ active: true, _id: vm.trackerid });
        }
      };

      function getTrackers(query) {
        Tracker.$search(query).$then(function (tr) {
          var date = moment();
          vm.trackers = tr;
          vm.trackers.map(function (t) {
            vm.newvalues[t._id] = {
              name: t.name,
              trackerid: t._id,
              def: angular.copy(t.def),
              dateiso: date.toISOString(),
              datesortable: date.format('YYYY-MM-DD'),
              dateat: date.format('DD.MM.YYYY'),
              datejs: date.format(),
              datesv: date.format('DDMMYY')
            };
          });
        });
      }

      function addTrackervalue() {
        vm.newtrackervalue = {};
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewTrackervalue(trackervalue, trackerid) {
        $log.debug('debug: saving new trackervalue: ', trackervalue);
        trackervalue.trackerid = trackerid;
        trackervalue.clientid = vm.clientid;
        trackervalue.patientid = vm.clientid;
        Trackervalue.$create(trackervalue).$then(function () {
          vm.created = true;
          if (angular.isDefined(vm.onentrycb) && angular.isFunction(vm.onentrycb)) {
            $log.debug('calling onentrycb with: ', trackervalue);
            vm.onentrycb({ trackervalue: trackervalue });
          }
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new trackervalue failed: ', err);
          Rlog.error('vctrackervalue', 'trackervaluenew', 'Creation of new trackervalue failed: ', { trackervalue: vm.newtrackervalue });
        });
      }

      function cancel() {
        delete vm.newtrackervalue;
        vm.canceled = true;
      }

      function addSnapShotReference(snapshot) {
        $log.debug('debug: adding new snapshot reference: ', snapshot);
        vm.snapshot = snapshot;
        vertxEventBusService.publish('trackerimage.new', { clientid: vm.clientid, image: snapshot, trackerid: vm.trackerid });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackervalues (patients) to display or load trackervalues */

'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackervaluelist', {
    restrict: 'E',
    bindings: {
      clientid: '<',
      trackerid: '<'
    },
    template: '\n        <table class="table table-striped">\n          <thead>\n          <tr>\n            <th>Datum</th>\n            <th>Wert(e)</th>\n            <th>Aktion</th>\n          </tr> \n          </thead>\n          <tr ng-repeat="trackervalue in vm.trackervalues">\n            <td>{{trackervalue.dateat}}</td>\n            <td>\n                <div ng-repeat="def in trackervalue.def">\n                    <span class="pull-left">{{def.label}}</span>\n                    <span class="pull-right" style="text-align: right">{{def.value}} {{def.unit}}</span>\n                    <span class="clearfix"></span>\n                </div>\n            </td>\n            <td>\n              <button class="btn btn-primary btn-xs" ng-click="vm.editTrackervalue(trackervalue)" uib-tooltip="Editieren"><i class="fa fa-edit"></i></button>\n              <button class="btn btn-danger btn-xs" ng-click="vm.removeTrackervalue(trackervalue)" uib-tooltip="Löschen"><i class="fa fa-remove"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Trackervalue', 'TrackervalueHelper', 'vertxEventBusService', function ($log, $http, Rlog, Trackervalue, TrackervalueHelper, vertxEventBusService) {
      var vm = this;
      vm.editTrackervalue = TrackervalueHelper.editTrackervalue;
      vm.removeTrackervalue = removeTrackervalue;

      vm.$onInit = function () {
        if (angular.isDefined(vm.trackerid && vm.trackerid.length > 0)) {
          vm.trackervalues = Trackervalue.$search({ trackerid: vm.trackerid, active: true, patientid: vm.clientid });
        }
      }; // $onInit()

      // trackerid migth be late propagating
      /*          vm.$onChanges = function (changes) {
                  if (angular.isDefined(changes.trackerid) &&
                      angular.isDefined(changes.trackerid.currentValue) &&
                    changes.trackerid.currentValue.length > 0) {
                    vm.trackerid = changes.trackerid.currentValue;
                    vm.trackervalues = Trackervalue.$search({trackerid: vm.trackerid});
                  }
                }; // $onChanges()*/

      function removeTrackervalue(trackervalue) {
        $log.debug('tracker value list remove: ', trackervalue);
        trackervalue.active = false;
        trackervalue.$save();
      }

      var tvUpdateHandler = function tvUpdateHandler(message) {
        $log.debug('debug: trackervalue update received in trackervaluelist: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.trackervalues)) {
          vm.trackervalues.$refresh().$then(function () {
            $log.debug('debug: trackervaluelist refreshed trackervalues');
          }, function (error) {
            $log.debug('debug: trackervaluelist refresh trackervalues failed: ', error);
          });
        }
      };

      vertxEventBusService.on('trackervalues.update', {}, tvUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('trackervalues.update', {}, tvUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* globals vis*/
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackervalues (patients) to display or load trackervalues */

'use strict';

(function () {
    'use strict';
    angular.module('vctracker').component('trackervaluegraph', {
        restrict: 'E',
        bindings: {
            clientid: '<',
            trackerid: '<',
            snapshothandle: '&'
        },
        template: '\n           <div class="alert alert-info" ng-show="vm.novalue"><h4><i class="fa fa-info-circle"></i> Keine Daten vorhanden!</h4></div>\n           <div class="graph" id="{{vm.graphid}}"></div>\n           <div class="btn btn-primary" ng-click="vm.snap()"><i class="fa fa-camera"></i> </div>\n      ',
        controllerAs: 'vm',
        controller: ['$log', '$http', 'Rlog', 'Trackervalue', 'TrackervalueHelper', 'vertxEventBusService', '$document', function ($log, $http, Rlog, Trackervalue, TrackervalueHelper, vertxEventBusService, $document) {
            var vm = this;
            vm.editTrackervalue = TrackervalueHelper.editTrackervalue;
            vm.removeTrackervalue = removeTrackervalue;
            vm.snap = snap;

            vm.$onChanges = function (changes) {
                // clientid might be propagating late
                if (angular.isDefined(changes.clientid) && angular.isDefined(changes.clientid.currentValue && changes.clientid.currentValue.length > 0)) {
                    vm.clientid = changes.clientid.currentValue;
                }
                // trackerid might be propagating late
                if (angular.isDefined(changes.trackerid) && angular.isDefined(changes.trackerid.currentValue && changes.trackerid.currentValue.length > 0)) {
                    vm.trackerid = changes.trackerid.currentValue;
                    // create unique graph containerid in case componed is rendered multiple times
                    vm.graphid = changes.trackerid.currentValue + Math.floor(Math.random() * 10000).toString();
                }
                // only get values once both ids are ready and values have not been fetched yet
                if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0 && angular.isDefined(vm.trackerid) && angular.isString(vm.trackerid) && vm.trackerid.length > 0 && angular.isUndefined(vm.trackervalues)) {
                    $log.debug('onChanges getValues for tracker: ', vm.trackerid);
                    getValuesAndDraw();
                }
            };

            function getValuesAndDraw() {
                Trackervalue.$search({
                    query: { trackerid: vm.trackerid, active: true, clientid: vm.clientid },
                    options: { sort: { dateiso: 1 } }
                }).$then(function (values) {
                    // only draw, if there is a container to draw into
                    $log.debug('values in search.$then: ', values);
                    vm.trackervalues = values;
                    drawWithPlotly(vm.trackervalues);
                });
            }

            function drawWithPlotly(values) {
                if (angular.isDefined(values) && angular.isArray(values) && values.length > 0) {
                    var container = $document[0].getElementById(vm.graphid);

                    // format of values: [{value1}, {value2}, ...]
                    // format for value: {name, dateat, dateiso, def: [{dp_subgraph11}, {dp_subgraph2}, ...]}
                    // format for dp_subgraph: {absmax, absmin, normmax, normmin, step, unit, value, label}

                    if (angular.isDefined(container) && container !== null) {
                        (function () {

                            //  target: var data = [ subgraph1, subgraph2, ... ];
                            //  target subgraph: {x: [], y: [], mode: 'lines'}  mode options: lines, markers, lines+markers
                            //  create linegraph for all subgraphs
                            //  create ok symbol scatter graph for all ok values for all subgraphs
                            //  create not-ok symbol scatter graph for all not-ok values for all subgraphs

                            var numOfSubgraphs = values[0].def.length; // TODO: make sure to get the absolute value of max sub graphs

                            var subgraphs = [];
                            var posgraph = {
                                x: [],
                                y: [],
                                mode: 'markers',
                                name: 'normal',
                                marker: {
                                    color: 'green',
                                    size: 10,
                                    symbol: 'circle'
                                }
                            };
                            var neggraph = {
                                x: [],
                                y: [],
                                mode: 'markers',
                                name: 'nicht normal',
                                marker: {
                                    color: 'red',
                                    size: 10,
                                    symbol: 'x'
                                }
                            };
                            var neutralgraph = {
                                x: [],
                                y: [],
                                mode: 'markers',
                                name: 'kein Normbereich',
                                marker: {
                                    color: 'grey',
                                    size: 10,
                                    symbol: 'star'
                                }
                            };

                            values.forEach(function (val) {
                                for (var i = 0; i < numOfSubgraphs; i++) {
                                    var dp = val.def[i];
                                    if (angular.isUndefined(subgraphs[i])) {
                                        subgraphs[i] = {
                                            x: [],
                                            y: [],
                                            mode: 'lines',
                                            name: dp.label + ' [' + dp.unit + ']',
                                            line: {
                                                shape: 'spline',
                                                smoothing: 1.3
                                            }
                                        };
                                    }

                                    subgraphs[i].x.push(val.dateiso);
                                    subgraphs[i].y.push(dp.value);

                                    if (angular.isDefined(dp.normmin) && angular.isDefined(dp.normmin) && dp.value >= dp.normmin && dp.value <= dp.normmax) {
                                        posgraph.x.push(val.dateiso);
                                        posgraph.y.push(dp.value);
                                    } else if (angular.isDefined(dp.normmin) && angular.isDefined(dp.normmin) && (dp.value < dp.normmin || dp.value > dp.normmax)) {
                                        neggraph.x.push(val.dateiso);
                                        neggraph.y.push(dp.value);
                                    } else {
                                        neutralgraph.x.push(val.dateiso);
                                        neutralgraph.y.push(dp.value);
                                    }
                                }
                            });

                            var totalPoints = 0;
                            if (posgraph.x.length > 0) {
                                subgraphs.push(posgraph);
                                totalPoints += posgraph.x.length;
                            }
                            if (neggraph.x.length > 0) {
                                subgraphs.push(neggraph);
                                totalPoints += neggraph.x.length;
                            }
                            if (neutralgraph.x.length > 0) {
                                subgraphs.push(neutralgraph);
                                totalPoints += neutralgraph.x.length;
                            }

                            var layout = {
                                title: values[0].name,
                                hovermode: 'closest'
                            };

                            if (totalPoints === 1) {
                                layout.xaxis = { range: [moment().subtract(2, 'days').toISOString(), moment().add(2, 'days').toISOString()] };
                            }

                            var options = {
                                hovermode: 'closest',
                                scrollZoom: true,
                                locale: 'de-at',
                                showLink: false,
                                displaylogo: false,
                                modeBarButtonsToRemove: ['sendDataToCloud', 'lasso2d', 'select2d']
                            };

                            Plotly.react(container, subgraphs, layout, options).then(function (plotlyref) {
                                $log.debug('plotlyref in promise: ', plotlyref);
                                vm.plotlyref = plotlyref;
                                vm.snapshothandle({ plotlyref: plotlyref, trackerid: vm.trackerid });
                            });
                        })();
                    } else {
                        $log.debug('container for graph not found, graphid: ', vm.graphid);
                    }
                } else {
                    vm.novalue = true;
                }
            }

            function removeTrackervalue(trackervalue) {
                trackervalue.active = false;
                trackervalue.$save();
            }

            function snap() {
                var style = angular.element(vm.plotlyref)[0].firstChild.firstChild.style;
                var width = parseInt(style.width.substr(0, style.width.indexOf('px')), 10);
                var height = parseInt(style.height.substr(0, style.height.indexOf('px')), 10);
                Plotly.toImage(vm.plotlyref, { height: height, width: width }).then(function (url) {
                    // $log.debug('img url: ', url);
                    vm.snapshothandle({ snapshot: url });
                });
            }

            var tvUpdateHandler = function tvUpdateHandler(message) {
                if (angular.isDefined(vm.trackervalues)) {
                    vm.trackervalues.$refresh().$then(function (values) {
                        $log.debug('******** refreshed values for message: ', values, message);
                        drawWithPlotly(values);
                    }, function (error) {
                        $log.error('debug: trackervaluegraph refresh trackervalues failed: ', error);
                    });
                }
            };

            var tiSaveHandler = function tiSaveHandler(message) {
                $log.debug('******** saved tracker image for tracker: ', message);
            };

            vertxEventBusService.on('trackervalues.update', {}, tvUpdateHandler);
            vertxEventBusService.on('trackerimage.saved', {}, tiSaveHandler);

            vm.$onDestroy = function () {
                vertxEventBusService.unregisterHandler('trackervalues.update', {}, tvUpdateHandler);
                vertxEventBusService.unregisterHandler('trackerimage.saved', {}, tiSaveHandler());
            };
        }] // controller
    }); // component

    // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackervalueform', {
    restrict: 'E',
    bindings: {
      trackervalue: '<',
      trackerid: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vctracker/trackervalueform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.formatdate = formatdate;
      vm.cleardate = cleardate;

      vm.$onInit = function () {
        vm.lasttrackervalue = angular.copy(vm.trackervalue);
      };

      function save() {
        $log.debug('trackervalue form save');
        if (!angular.equals(vm.trackervalue, vm.lasttrackervalue)) {
          $log.debug('trackervalue form now saving');
          vm.lasttrackervalue = angular.copy(vm.trackervalue);
          vm.parentsave({ trackervalue: vm.trackervalue, trackerid: vm.trackerid });
        }
      }

      // trackerid might be propagating late
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.trackerid) && angular.isDefined(changes.trackerid.currentValue && changes.trackerid.currentValue.length > 0)) {
          vm.trackerid = changes.trackerid.currentValue;
        }
      };

      function cancel() {
        vm.trackervalue = angular.copy(vm.lasttrackervalue);
        vm.oncancel();
      }

      function formatdate(fdate) {
        // moment.locale('de-at');
        var returnval = undefined;
        var date = moment(fdate, ['D.M.YYYY', 'DD.MM.YYYY', 'D/M/YYYY', 'DDMMYYYY']);
        var plausible = date.isAfter(moment('1900-01-01', 'YYYY-MM-DD')) && date.isBefore(moment().add(1, 'days'));
        var valid = date.isValid();
        // $log.debug('debug: valid, plausible: ', valid, plausible);

        if (!plausible) {
          vm.dateerror = 'Unplausibles Datum';
          returnval = 'implausible';
        }

        if (!valid) {
          vm.dateerror = 'Ungültiges Datum';
          returnval = 'invalid';
        }

        if (valid && plausible) {
          vm.trackervalue.dateiso = date.toISOString();
          vm.trackervalue.datesortable = date.format('YYYY-MM-DD');
          vm.trackervalue.dateat = date.format('DD.MM.YYYY');
          vm.trackervalue.datejs = date.format();
          vm.trackervalue.datesv = date.format('DDMMYY');
          delete vm.dateerror;
          returnval = date.format('DD.MM.YYYY');
        }
        return returnval;
      }

      function cleardate() {
        delete vm.trackervalue.date;
        delete vm.trackervalue.dateiso;
        delete vm.trackervalue.datesortable;
        delete vm.trackervalue.datejs;
        delete vm.trackervalue.dateat;
        delete vm.trackervalue.datesv;
        delete vm.dateerror;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackervalueeditor', {
    restrict: 'E',
    bindings: {
      trackervalue: '<?',
      trackervalueid: '<?'
    },
    template: '\n        <trackervalueform trackervalue="vm.trackervalue" parentsave="vm.childsave(trackervalue)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> trackervalue erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen trackervalue wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> trackervalue konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Trackervalue', 'Rlog', function ($log, Trackervalue, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.trackervalue) || !vm.trackervalue.hasOwnProperty('_id')) && angular.isDefined(vm.trackervalueid)) {
          Trackervalue.$find(vm.trackervalueid).$then(function (trackervalue) {
            vm.trackervalue = trackervalue;
          }, function (err) {
            $log.error('trackervalue not found, id: ', vm.trackervalueid);
            Rlog.error('trackervalue', 'trackervalueeditor', 'trackervalue not found', { _id: vm.trackervalueid });
          });
        }
      };

      function childsave(trackervalue) {
        // vm.trackervalue = angular.copy(trackervalue);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in trackervalue) {
          if (trackervalue.hasOwnProperty(key)) {
            vm.trackervalue[key] = trackervalue[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.trackervalue.$hasPendingActions()) {
          vm.trackervalue.$cancel();
          vm.trackervalue.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of trackervalue failed: ', err);
            Rlog.error('vcutils.trackervalue', 'trackervalueeditor', 'Saving of trackervalue failed: ', { error: err, trackervalueid: vm.trackervalue._id });
          });
        } else {
          vm.trackervalue.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of trackervalue failed: ', err);
            Rlog.error('vcutils.trackervalue', 'trackervalueeditor', 'Saving of trackervalue failed: ', { error: err, trackervalueid: vm.trackervalue._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vctrackervalue.factory:TrackervalueHelper
   *
   * @description
   *
   */
  angular.module('vctracker').factory('TrackervalueHelper', TrackervalueHelper);

  TrackervalueHelper.$inject = ['Trackervalue', '$uibModal', '$log', 'Rlog'];

  function TrackervalueHelper(Trackervalue, $uibModal, $log, Rlog) {
    var TrackervalueHelperBase = {};

    TrackervalueHelperBase.editTrackervalue = editTrackervalue;
    TrackervalueHelperBase.addTrackervalue = addTrackervalue;

    function addTrackervalue(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackervalueform trackervalue="vm.trackervalue" parentsave="vm.childsave(trackervalue)" oncancel="vm.cancel()"></trackervaluenew></div>',
        controllerAs: 'trackervalueaCtrl',
        controller: ['trackervalue', function () {
          var vm = this;
          vm.trackervalue = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(trackervalue) {
            Trackervalue.$create(trackervalue).$then(function (newtrackervalue) {
              vm.created = true;
              success(newtrackervalue);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ trackervalue-helper.addTrackervalue: ', err);
              Rlog.error('vctracker', 'trackervalue-helper.addTrackervalue', 'Creation of new TRackervalue failed: ', { trackervalue: trackervalue });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          trackervalue: function trackervalue() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editTrackervalue(ltrackervalue) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackervalueform trackervalue="trackervalueeCtrl.trackervalue" parentsave="trackervalueeCtrl.childsave(trackervalue)" oncancel="trackervalueeCtrl.cancel()"></trackervalueform></div>',
        controllerAs: 'trackervalueeCtrl',
        controller: ['trackervalue', function (strackervalue) {
          var vm = this;
          vm.trackervalue = strackervalue;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(trackervalue) {
            // vm.trackervalue = angular.copy(trackervalue);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in trackervalue) {
              if (trackervalue.hasOwnProperty(key)) {
                vm.trackervalue[key] = trackervalue[key];
              }
            }

            if (vm.trackervalue.$hasPendingActions()) {
              vm.trackervalue.$cancel();
              vm.trackervalue.$save();
              cancel();
            } else {
              vm.trackervalue.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          trackervalue: function trackervalue() {
            return ltrackervalue;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return TrackervalueHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name tracker.factory:Tracker
   *
   * @description
   *
   */
  angular.module('vctracker').factory('Trackervalue', Trackervalue);

  Trackervalue.$inject = ['restmod'];
  function Trackervalue(restmod) {
    return restmod.model('/routes/trackervalues').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/trackervalues/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return $search({ key: key, val: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackersearch', {
    restrict: 'E',
    bindings: {
      tracker: '<',
      trackerref: '<',
      parentsave: '&?',
      editinplace: '@?',
      hideaddoption: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="0"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   autofocus\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showtracker($item, $model, $label)"\n                   uib-typeahead="tracker as tracker.text for tracker in vm.getTrackers($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="glyphicon glyphicon-refresh"></i>\n        <div ng-show="noResults">\n          <i class="glyphicon glyphicon-remove"></i> Kein Tracker gefunden\n          <span class="btn btn-success" ng-click="vm.addTracker()" ng-hide="vm.error">Neuen Tracker anlegen</span>\n          <span ng-click="vm.addTracker()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Tracker konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="(vm.editinplace === true || vm.editinplace === \'true\') && vm.tracker">\n          <trackereditor tracker="vm.tracker"></trackereditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Tracker', 'TrackerHelper', function ($log, Tracker, TrackerHelper) {
      var vm = this;
      vm.save = save;
      vm.showtracker = showtracker;

      vm.getTrackers = getTrackers;
      // vm.addTracker = TrackerHelper.addTracker;
      vm.addTracker = addTracker;
      vm.editTracker = TrackerHelper.editTracker;

      vm.$onInit = function () {
        vm.newtracker = {};

        if (angular.isDefined(vm.hideaddoption) && vm.hideaddoption === 'true') {
          vm.hideaddoption = true;
        }

        vm.lasttracker = angular.copy(vm.trackerresult);
        vm.lasttrackerref = angular.copy(vm.trackerref);
      };

      function addTracker() {
        $log.debug('debug - trackersearch addTracker called');
        TrackerHelper.addTracker(function (tracker) {
          $log.debug('debug: handle newly create tracker');
          vm.tracker = {};
          vm.tracker.name = tracker.name;
          vm.tracker.name = tracker.name;
          vm.tracker.def = tracker.def;
          vm.trackerref = tracker._id;
          vm.asyncSelected = tracker.short;
          vm.parentsave({ tracker: vm.tracker, trackerref: vm.trackerref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead tracker search backend query
      function getTrackers(val) {
        // return Trackerahead.$search({query: val}).$asPromise().then(function (response) {
        return Tracker.$searchahead({
          query: val,
          fields: ['name', 'def.0.label', 'def.1.label', 'def.2.label'] }).$asPromise().then(function (response) {
          return response.map(function (tracker) {
            tracker.text = tracker.name;
            if (tracker.def.length > 1) {
              var labels = '';
              tracker.def.map(function (d) {
                labels += d.label;
                labels += ', ';
              });
              labels = labels.substring(0, labels.length - 2);
              tracker.text += ' (' + labels + ')';
            }
            delete vm.error;
            return tracker;
          });
        });
      }

      // typeahead tracker search action
      function showtracker($item, $model, $label) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        vm.tracker = $model;
        vm.trackerref = $model._id;
        delete vm.asyncSelected;
        if (vm.editinplace === true || vm.editinplace === 'true') {
          vm.tracker = $model;
          vm.trackerref = $model._id;
        } else {
          vm.tracker = {};
          vm.tracker.name = $model.name;
          vm.tracker.text = $model.text;
          vm.tracker.def = angular.copy($model.text.def);
          vm.tracker._id = $model._id;
          vm.trackerref = $model._id;
          vm.parentsave({ tracker: vm.tracker, trackerref: vm.trackerref });
        }
      }

      function save() {
        if (!angular.equals(vm.tracker, vm.lasttracker) || !angular.equals(vm.trackerref, vm.lasttrackerref)) {
          vm.lasttracker = angular.copy(vm.tracker);
          vm.lasttrackerref = angular.copy(vm.trackerref);
          vm.parentsave({ tracker: vm.tracker, trackerref: vm.trackerref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackernew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="trackernew-component" data-hook="trackernew-component">\n        <h3>Neuen Tracker anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addTracker()" ng-hide="vm.newtracker">Neuen Tracker anlegen</div>\n        <div class="spacer-top"></div>\n        <div ng-show="vm.newtracker">\n          <trackerform tracker="vm.newtracker" parentsave="vm.saveNewTracker(tracker)" oncancel="vm.cancel()"></trackerform>\n        </div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Tracker erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen eines neuen Trackers wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Tracker konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Tracker', 'Rlog', function ($log, Tracker, Rlog) {
      var vm = this;
      vm.addTracker = addTracker;
      vm.saveNewTracker = saveNewTracker;
      vm.cancel = cancel;

      function addTracker() {
        vm.newtracker = {
          name: '',
          def: [{
            label: '',
            unit: '',
            step: 0,
            normmin: 0,
            normmax: 100,
            absmin: 0,
            absmax: 100
          }]
        };
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewTracker(tracker) {
        $log.debug('debug: create new tracker: ', tracker);
        delete vm.newtracker;
        Tracker.$create(tracker).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new tracker failed: ', err);
          Rlog.error('vcutils.tracker', 'trackernew', 'Creation of new tracker failed: ', { tracker: vm.newtracker });
        });
      }

      function cancel() {
        delete vm.newtracker;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackers (patients) to display or load trackers */

'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackerlist', {
    restrict: 'E',
    bindings: {
      trackers: '<?'
    },
    template: '\n        <div class="row" ng-show="vm.trackers.length == 0">\n          <div class="alert alert-info">\n            <i class="fa fa-info-circle fa-2x"></i> Sie haben noch keine Meßwert-Tracker definiert.\n          </div>\n        </div>\n        <table class="table table-striped" ng-show="vm.trackers.length > 0">\n          <thead>\n          <tr>\n            <th>Bezeichnung</th>\n            <th>Inhalt</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="tracker in vm.trackers">\n            <td>{{tracker.name}}</td>\n            <td>\n                <ul>\n                    <li ng-repeat="t in tracker.def">{{t.label}}</li>\n                </ul>\n            </td>\n            <td>\n              <button class="btn btn-primary" ng-click="vm.editTracker(tracker)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>\n              <button class="btn btn-danger" ng-click="vm.removeTracker(tracker)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Tracker', 'TrackerHelper', 'vertxEventBusService', function ($log, $http, Rlog, Tracker, TrackerHelper, vertxEventBusService) {
      var vm = this;
      vm.editTracker = TrackerHelper.editTracker;
      vm.removeTracker = removeTracker;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.trackers)) {
          vm.trackers = Tracker.$search();
        }
      }; // $onInit()

      function removeTracker(tracker) {
        tracker.active = false;
        tracker.$save();
      }

      var trackersUpdateHandler = function trackersUpdateHandler(message) {
        $log.debug('debug: tracker update received: ', message);
        if (angular.isDefined(vm.trackers)) {
          vm.trackers.$refresh().$then(function () {
            $log.debug('debug: trackerlist refreshed trackers');
          }, function (error) {
            $log.debug('debug: trackerlist refresh trackers failed: ', error);
          });
        }
      };

      vertxEventBusService.on('trackers.update', {}, trackersUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('trackers.update', {}, trackersUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackerform', {
    restrict: 'E',
    bindings: {
      tracker: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vctracker/trackerform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.defsave = defsave;
      vm.addDef = addDef;
      vm.removeDef = removeDef;

      /*          vm.$onInit = function () {
                  if (angular.isUndefined(vm.tracker.def)) {
                    vm.tracker.def = [];
                  }
                  vm.lasttracker = angular.copy(vm.tracker);
                };*/

      // tracker arrive late!
      vm.$onChanges = function (changes) {
        if (angular.isDefined(vm.tracker) && angular.isObject(vm.tracker)) {
          if (angular.isUndefined(vm.tracker.def)) {
            vm.tracker.def = [];
          }
          vm.lasttracker = angular.copy(vm.tracker);
        }
      };

      function save() {
        if (!angular.equals(vm.tracker, vm.lasttracker)) {
          vm.lasttracker = angular.copy(vm.tracker);
          vm.parentsave({ tracker: vm.tracker });
        }
      }

      function cancel() {
        vm.tracker = angular.copy(vm.lasttracker);
        vm.oncancel();
      }

      function defsave(trackerdef, index) {
        $log.debug('debug: trackerform defsave called: ', trackerdef);
        vm.tracker.def[index] = angular.copy(trackerdef);
        // vm.tracker.postcode = zip;
        // vm.tracker.city = city;
      }

      function addDef() {
        vm.tracker.def.push({
          label: '',
          unit: '',
          step: 0,
          normmin: 0,
          normmax: 100,
          absmin: 0,
          absmax: 100
        });
      }

      function removeDef(index) {
        vm.tracker.def.splice(index, 1);
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackereditor', {
    restrict: 'E',
    bindings: {
      tracker: '<?',
      trackerid: '<?'
    },
    template: '\n        <trackerform tracker="vm.tracker" parentsave="vm.childsave(tracker)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Tracker erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Editieren eines neuen Trackers wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Tracker konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Tracker', 'Rlog', function ($log, Tracker, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.tracker) || !vm.tracker.hasOwnProperty('_id')) && angular.isDefined(vm.trackerid)) {
          Tracker.$find(vm.trackerid).$then(function (tracker) {
            vm.tracker = tracker;
          }, function (err) {
            $log.error('tracker not found, id: ', vm.trackerid);
            Rlog.error('tracker', 'trackereditor', 'tracker not found', { _id: vm.trackerid });
          });
        }
      };

      function childsave(tracker) {
        // vm.tracker = angular.copy(tracker);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in tracker) {
          if (tracker.hasOwnProperty(key)) {
            vm.tracker[key] = tracker[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.tracker.$hasPendingActions()) {
          vm.tracker.$cancel();
          vm.tracker.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of tracker failed: ', err);
            Rlog.error('vcutils.tracker', 'trackereditor', 'Saving of tracker failed: ', { trackerid: vm.tracker._id });
          });
        } else {
          vm.tracker.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of tracker failed: ', err);
            Rlog.error('vcutils.tracker', 'trackereditor', 'Saving of tracker failed: ', { trackerid: vm.tracker._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
    'use strict';
    angular.module('vctracker').component('trackerdef', {
        restrict: 'E',
        bindings: {
            trackerdef: '<',
            index: '<',
            parentsave: '&'
        },
        template: '\n          <div class="row">\n              <div class="form-group col-xs-12 col-md-3">\n                  <label for="trackername">Name/Label*</label>\n                  <input class="form-control" id="trackerdefname" ng-model="vm.trackerdef.label" required>\n              </div>\n              <div class="form-group col-xs-12 col-md-3">\n                  <label for="trackerdefunit">Maßeinheit*</label>\n                  <input type="text" class="form-control" id="trackerdefunit" ng-model="vm.trackerdef.unit" required>\n              </div>\n              <div class="form-group col-xs-12 col-md-6">\n                  <label for="trackerdefstep">Zahlentyp*</label>\n                  <label class="radio-inline"><input type="radio" id="trackerdefstep1" value="1"\n                                                     ng-model="vm.trackerdef.step"> Ganzahlig</label>\n                  <label class="radio-inline"><input type="radio" id="trackerdefstep2" value="0.1"\n                                                     ng-model="vm.trackerdef.step"> Eine Nachkommastelle</label>\n                  <label class="radio-inline"><input type="radio" id="trackerdefstep3" value="0.01"\n                                                     ng-model="vm.trackerdef.step"> Zwei Nachkommastellen</label>\n              </div>\n          </div>\n          <div class="row">\n              <div class="form-group col-xs-6 col-md-3">\n                  <label for="trackerdefnormmin">Untere Normgrenze</label>\n                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefnormmin"\n                         required ng-blur="vm.save()"\n                         ng-model="vm.trackerdef.normmin">\n              </div>\n              <div class="form-group col-xs-6 col-md-3">\n                  <label for="trackerdefnormmax">Obere Normgrenze</label>\n                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefnormmax"\n                         required ng-blur="vm.save()"\n                         ng-model="vm.trackerdef.normmax">\n              </div>\n              <div class="form-group col-xs-6 col-md-3">\n                  <label for="trackerdefabsmin">Absolutes Minimum</label>\n                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefabsmin"\n                         required ng-blur="vm.save()"\n                         ng-model="vm.trackerdef.absmin">\n              </div>\n              <div class="form-group col-xs-6 col-md-3">\n                  <label for="trackerdefabsmax">Absolutes Maximum</label>\n                  <input type="number" step="{{vm.trackerdef.step}}" class="form-control" id="trackerdefabsmax"\n                         required ng-blur="vm.save()"\n                         ng-model="vm.trackerdef.absmax">\n              </div>\n          </div>      \n      ',
        controllerAs: 'vm',
        controller: ['$log', function ($log) {
            var vm = this;
            vm.save = save;
            // vm.cancel = cancel;
            // vm.zipsave = zipsave;

            vm.$onInit = function () {
                vm.lasttracker = angular.copy(vm.trackerdef);
            };

            function save() {
                if (!angular.equals(vm.trackerdef, vm.lasttracker)) {
                    vm.lasttracker = angular.copy(vm.trackerdef);
                    vm.parentsave({ trackerdef: vm.trackerdef, index: vm.index });
                }
            }
            /*
                      function cancel() {
                        vm.trackerdef = angular.copy(vm.lasttracker);
                        vm.oncancel();
                      }*/
        }] // controller
    }); // component

    // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of trackers (patients) to display or load trackers */

'use strict';

(function () {
  'use strict';
  angular.module('vctracker').component('trackerchooser', {
    restrict: 'E',
    bindings: {
      trackers: '<?',
      onselectcb: '&?'
    },
    template: '\n        <div>\n          <span class="btn btn-success btn-xs"\n                ng-repeat="tracker in vm.trackers"\n                uib-tooltip="Tracker hinzufügen"\n                ng-click="vm.addTracker(tracker)">\n            <i class="fa fa-plus"></i><i class="fa fa-line-chart"></i>&nbsp;{{tracker.name}}</span>\n           <div ng-show="vm.trackers.length === 0" class="alert alert-info">Sie haben noch keine Tracker angelegt. <a ui-sref="settings.tracker" class="btn btn-primary" target="_blank">Tracker anlegen</a></div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Tracker', 'TrackerHelper', 'vertxEventBusService', function ($log, $http, Rlog, Tracker, TrackerHelper, vertxEventBusService) {
      var vm = this;
      vm.addTracker = addTracker;
      vm.$onInit = function () {
        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.trackers)) {
          vm.trackers = Tracker.$search({ active: true });
        }
      }; // $onInit()

      function addTracker(tracker) {
        $log.debug('vm.addTracker called');
        if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
          $log.debug('calling parentsave for tracker: ', tracker);
          vm.onselectcb({ tracker: tracker });
        }
      }

      var trackersUpdateHandler = function trackersUpdateHandler(message) {
        $log.debug('debug: tracker update received: ', message);
        if (angular.isDefined(vm.trackers)) {
          vm.trackers.$refresh().$then(function () {
            $log.debug('debug: trackerlist refreshed trackers');
          }, function (error) {
            $log.debug('debug: trackerlist refresh trackers failed: ', error);
          });
        }
      };

      vertxEventBusService.on('trackers.update', {}, trackersUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('trackers.update', {}, trackersUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vctracker').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.tracker', {
      url: '/tracker',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;trackersearch tracker="" trackerref="" editinplace="true"&gt;</tt></h3><div ui-view="trackersearchview"></div>\n              <h3 class="alert alert-info"><tt>&lt;trackersearch tracker="" trackerref="" parentsave=""&gt;</tt></h3><div ui-view="trackersearchview2"></div>\n              <h3 class="alert alert-info"><tt>&lt;trackereditor tracker="" mode="" onClose=""&gt;</tt></h3><div ui-view="trackereditview"></div>\n              <h3 class="alert alert-info"><tt>&lt;trackernew&gt;</tt></h3><div ui-view="trackernewview"></div>\n              <h3 class="alert alert-info"><tt>&lt;trackerlist trackers="?"&gt;</tt></h3><div ui-view="trackerlistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;trackervaluenew clientid="?"&gt;</tt></h3><div ui-view="trackervaluenewview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vctracker entered');
      }
    });

    $stateProvider.state('playground.tracker.allcomponents', {
      url: '/allcomponents',
      resolve: {
        tracker: function tracker() {
          return '';
        },
        trackerref: function trackerref() {
          return '';
        },
        sometracker: function sometracker(Tracker) {
          return Tracker.$find('572b31b07c01597e3e150923');
        },
        alltrackers: function alltrackers(Tracker) {
          return Tracker.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (tracker, trackerref) {
            console.log('debug: dummy parentsave called for trackersearch with: ', tracker, trackerref);
          };
        },
        eip: function eip() {
          return true;
        },
        clientid: function clientid() {
          return '586fcf4fa60359ae2a632d64'; // Druide Miraculix
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'trackersearchview@playground.tracker': {
          component: 'trackersearch',
          bindings: {
            tracker: 'tracker',
            trackerref: 'trackerref',
            editinplace: 'eip'
          }
        },
        'trackersearchview2@playground.tracker': {
          component: 'trackersearch',
          bindings: {
            tracker: 'tracker',
            trackerref: 'trackerref',
            parentsave: 'parentsavesearch'
          }
        },
        'trackereditview@playground.tracker': {
          component: 'trackereditor',
          bindings: {
            tracker: 'sometracker'
          }
        },
        'trackernewview@playground.tracker': {
          component: 'trackernew',
          bindings: {}
        },
        'trackerlistview@playground.tracker': {
          component: 'trackerlist',
          bindings: {
            trackers: 'alltrackers'
          }
        },
        'trackervaluenewview@playground.tracker': {
          component: 'trackervaluenew',
          bindings: {
            cientid: 'clientid'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.tracker.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vctracker.factory:TrackerHelper
   *
   * @description
   *
   */
  angular.module('vctracker').factory('TrackerHelper', TrackerHelper);

  TrackerHelper.$inject = ['Tracker', '$uibModal', '$log', 'Rlog'];

  function TrackerHelper(Tracker, $uibModal, $log, Rlog) {
    var TrackerHelperBase = {};

    TrackerHelperBase.editTracker = editTracker;
    TrackerHelperBase.addTracker = addTracker;

    function addTracker(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackerform tracker="vm.tracker" parentsave="vm.childsave(tracker)" oncancel="vm.cancel()"></trackernew></div>',
        controllerAs: 'trackeraCtrl',
        controller: ['tracker', function () {
          var vm = this;
          vm.tracker = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(tracker) {
            Tracker.$create(tracker).$then(function (newtracker) {
              vm.created = true;
              success(newtracker);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ tracker-helper.addTracker: ', err);
              Rlog.error('vcutils.tracker', 'tracker-helper.addTracker', 'Creation of new SV failed: ', { error: err, tracker: tracker });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          tracker: function tracker() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editTracker(ltracker) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><trackerform tracker="trackereCtrl.tracker" parentsave="trackereCtrl.childsave(tracker)" oncancel="trackereCtrl.cancel()"></trackerform></div>',
        controllerAs: 'trackereCtrl',
        controller: ['tracker', function (stracker) {
          var vm = this;
          vm.tracker = stracker;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(tracker) {
            // vm.tracker = angular.copy(tracker);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in tracker) {
              if (tracker.hasOwnProperty(key)) {
                vm.tracker[key] = tracker[key];
              }
            }

            if (vm.tracker.$hasPendingActions()) {
              vm.tracker.$cancel();
              vm.tracker.$save();
              cancel();
            } else {
              vm.tracker.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          tracker: function tracker() {
            return ltracker;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return TrackerHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name tracker.factory:Tracker
   *
   * @description
   *
   */
  angular.module('vctracker').factory('Tracker', Tracker);

  Tracker.$inject = ['restmod'];
  function Tracker(restmod) {
    return restmod.model('/routes/trackers').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/trackers/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return $search({ key: key, val: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name todo
   * @description
   *
   */
  angular.module('vctodo', []);
})();
/**
 * Created by lari on 12/01/2017.
 */

'use strict';

(function () {
    'use strict';
    /**
     * @ngdoc directive
     * @name todo.directive:todowidget
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="todo">
     <file name="index.html">
     <todowidget></todowidget>
     </file>
     </example>
     *
     */

    // var todowidget;

    angular.module('vctodo').component('todowidget', {
        restrict: 'E',
        templateUrl: 'vctodo/todowidget-component.tpl.html',
        controllerAs: 'vm',
        controller: ['Todo', '$log', '$cookies', '$window', 'vertxEventBusService', '$interval', '$timeout', function (Todo, $log, $cookies, $window, vertxEventBusService, $interval, $timeout) {
            var vm = this;

            vm.todos = {};

            vm.save = save;
            vm.add = add;
            vm.calcdue = calcdue;

            // initalise data bindings
            vm.todos.upcoming = upcoming();
            vm.todos.overdue = dueandoverdue();
            vm.todos.lastcompleted = lastcompleted();

            /*
                                // after a minute start repeating refreshs every 10 minutes
                                $timeout(function () {
                                    $interval(function () {
                                        refreshAll();
                                    }, 600000);
                                }, 60000);
            */

            function add() {
                vm.newitem.done = false;
                vm.newitem.user = $cookies.get('username');
                if (!vm.newitem.due) {
                    vm.newitem.due = moment().toISOString();
                    vm.newitem.duestr = 'Sofort';
                }
                Todo.$create(vm.newitem).$then(function () {
                    vm.todos.upcoming.$refresh();
                    vm.todos.overdue.$refresh();
                    vm.todos.lastcompleted.$refresh();
                });
                vm.newitem = '';
            }

            function save(item) {
                if (item.done === true) {
                    item.completed = moment().toISOString();
                } else {
                    delete item.completed;
                }
                item.$save().$then(function () {
                    refreshAll();
                });
            }

            function refreshAll() {
                vm.todos.upcoming.$refresh();
                vm.todos.overdue.$refresh();
                vm.todos.lastcompleted.$refresh();
            }

            function calcdue(days, str) {
                vm.newitem.due = moment().add(days, 'days').toISOString();
                vm.newitem.duestr = str;
            }

            function lastcompleted() {
                return Todo.$search({
                    completed: { $gte: moment().subtract(3, 'days').toISOString() },
                    done: true
                });
            }

            function upcoming() {
                return Todo.$search({
                    due: { $gte: moment().add('days', 1).startOf('day').toISOString() },
                    done: false
                });
            }

            function dueandoverdue() {
                return Todo.$search({
                    due: { $lt: moment().add('days', 1).startOf('day').toISOString() },
                    done: false
                });
            }

            var todosUpdateHandler = function todosUpdateHandler(message) {
                var messages = message.split(':');
                $log.debug('Todos updated: ', message);
                if (messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
                    refreshAll();
                    $log.debug('(todo) refreshed todos');
                } else {
                    $log.debug('(todo) ignored todo refresh');
                }
            };

            // listen for todos updates from other tabs
            vertxEventBusService.on('todos.update', {}, todosUpdateHandler);

            vm.$onDestroy = function () {
                vertxEventBusService.unregisterHandler('todos.update', {}, todosUpdateHandler);
            };
        }]
    });

    // klammerfriedhof
})();
'use strict';

(function () {
    'use strict';

    angular.module('vctodo').config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider.state('playground.vctodo', {
            url: '/vctodo',
            views: {
                'playgroundmain@playground': {
                    template: '\n              <h3 class="alert alert-info"><tt>&lt;todowidget&gt;</tt></h3><div ui-view="todowidget"></div>\n            '
                }
            },
            onEnter: function onEnter($log) {
                $log.debug('debug/routes - playground.vctodo entered');
            }
        });
        $stateProvider.state('playground.vctodo.allcomponents', {
            url: '/allcomponents',
            resolve: {
                todo: function todo() {
                    return '';
                }
            },
            views: {
                // When `fooState.barState` is active, `fooComponent`
                // is loaded into the <ui-view name='content' />
                // which was created by `fooState`.
                // The component's `foo` input receives `fooData` resolve
                'todowidget@playground.vctodo': {
                    component: 'todowidget'
                }
            },
            onEnter: function onEnter() {
                console.log('playground.vctodo.allcomponents entered');
            }
        });
    } // all routes
})();
'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name todo.factory:Todoservice
   *
   * @description
   *
   */
  angular.module('vctodo').factory('Todo', Todo).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Todo.$inject = ['restmod'];

  function Todo(restmod) {
    return restmod.model('/routes/todos').mix({
      // owner: { belongsTo: 'User', key: 'userid' }, // todo add user to todowidget
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      done: { init: false },
      owner: { init: '' }
    });
  }
})();
/**
 * Created by lari on 09/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name reminder
   * @description
   *
   */
  angular.module('vcreminder', []);
})();
'use strict';

(function () {
    'use strict';

    angular.module('vcreminder').config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider.state('playground.vcreminder', {
            url: '/vcreminder',
            views: {
                'playgroundmain@playground': {
                    template: '\n              <h3 class="alert alert-info"><tt>&lt;allreminders&gt;</tt></h3><div ui-view="allreminders"></div>\n              <h3 class="alert alert-info"><tt>&lt;patientreminder patient=""&gt;</tt></h3><div ui-view="patientreminder"></div>\n            '
                }
            },
            onEnter: function onEnter($log) {
                $log.debug('debug/routes - playground.vcreminder entered');
            }
        });
        $stateProvider.state('playground.vcreminder.allcomponents', {
            url: '/allcomponents',
            resolve: {
                reminder: function reminder() {
                    return '';
                }
            },
            views: {
                // When `fooState.barState` is active, `fooComponent`
                // is loaded into the <ui-view name='content' />
                // which was created by `fooState`.
                // The component's `foo` input receives `fooData` resolve
                'allreminders@playground.vcreminder': {
                    component: 'allreminders'
                },
                'patientreminder@playground.vcreminder': {
                    component: 'patientreminder',
                    bindings: {
                        patient: 'patient'
                    }
                }

            },
            onEnter: function onEnter() {
                console.log('playground.vcreminder.allcomponents entered');
            }
        });
    } // all routes
})();
/**
 * Created by lari on 12/06/2017.
 */
'use strict';

(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name reminder.factory:ReminderService
     *
     * @description
     *
     */
    angular.module('vcreminder').factory('Reminder', Reminder).config(config);

    config.$inject = ['restmodProvider'];

    function config(restmodProvider) {
        restmodProvider.rebase({
            $config: {
                primaryKey: '_id'
            }
        });
    }

    Reminder.$inject = ['restmod'];

    function Reminder(restmod) {
        return restmod.model('/routes/reminders').mix({
            created: {
                init: function init() {
                    return moment().toISOString();
                }
            },
            active: { init: true },
            $extend: {
                Model: {
                    $searchahead: function $searchahead(_params) {
                        return this.$collection().$decorate({
                            'before-request': function beforeRequest(_req) {
                                _req.method = 'GET';
                                _req.url = '/routes/reminders/searchahead';
                            }
                        }, function () {
                            return this.$fetch(_params);
                        });
                    },
                    $searchBy: function $searchBy(key, val) {
                        var realquery = {};
                        realquery[key] = val;
                        return this.$search(realquery);
                    }
                } // Model
            } // extend
        });
    }

    // Klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcdms.vcFile.factory:FileHelper
   *
   * @description
   *
   */
  angular.module('vcreminder').factory('LogReminderHelper', LogReminderHelper);

  LogReminderHelper.$inject = ['$uibModal', '$log', 'Rlog'];

  function LogReminderHelper($uibModal, $log, Rlog) {
    var HelperBase = {};

    HelperBase.addLog = addLog;
    HelperBase.addReminder = addReminder;

    function addLog(_clientid, _clientmode) {
      console.log('log modal add log: ', _clientid, _clientmode);
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><clientlog clientid="vm.clientid" mode="vm.clientmode"></clientlog></div>',
        controllerAs: 'vm',
        controller: ['clientid', 'clientmode', function (lclientid, lclientmode) {
          var vm = this;
          console.log('log modal ctrl: ', lclientid, lclientmode);
          vm.clientid = lclientid;
          vm.clientmode = lclientmode;
        }],
        resolve: {
          clientid: function clientid() {
            return _clientid;
          },
          clientmode: function clientmode() {
            return _clientmode;
          }
        },
        size: 'lg'
      });
    }

    function addReminder(_clientid2, _clientmode2) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><clientreminder clientid="vm.clientid" mode="vm.clientmode"></clientreminder></div>',
        controllerAs: 'vm',
        controller: ['clientid', 'clientmode', function (lclientid, lclientmode) {
          var vm = this;
          vm.clientid = lclientid;
          vm.clientmode = lclientmode;
        }],
        resolve: {
          clientid: function clientid() {
            return _clientid2;
          },
          clientmode: function clientmode() {
            return _clientmode2;
          }
        },
        size: 'lg'
      });
    }

    return HelperBase;
  }
})();
/**
 * Created by lari on 12/06/2017.
 */
'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name log.factory:ClientlogService
   *
   * @description
   *
   */
  angular.module('vcreminder').factory('Clientlog', Clientlog).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Clientlog.$inject = ['restmod'];

  function Clientlog(restmod) {
    return restmod.model('/routes/clientlogs').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/clientlogs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      } // extend
    });
  }

  // Klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcreminder').component('clientreminder', {
    restrict: 'E',
    bindings: {
      clientid: '<',
      mode: '<?'
    },
    templateUrl: 'vcreminder/clientreminder-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Reminder', 'ClientHelper', 'Clientlog', 'vertxEventBusService', function ($log, $http, Rlog, Reminder, ClientHelper, Clientlog, vertxEventBusService) {

      var vm = this;

      vm.addTodoEntry = addTodoEntry;
      vm.calcdue = calcdue;
      vm.save = save;

      vm.$onInit = function () {
        vm.newreminder = {};

        var query = {
          query: {
            $and: [{ $or: [{ clientid: vm.clientid }, { patientid: vm.clientid }] }, { $or: [{ done: false }, { completed: { $gt: moment().subtract(3, 'days').toISOString() } }] }]
          }
        };

        if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
          vm.mode = 'client';
          query = {
            query: {
              clientid: vm.clientid,
              $or: [{ done: false }, { completed: { $gt: moment().subtract(3, 'days').toISOString() } }]
            }
          };
        }

        if (angular.isDefined(vm.clientid)) {
          Reminder.$search(query).$then(function (reminders) {
            vm.reminders = reminders;
          }, function (err) {
            $log.error('### reminders not found, id: ', vm.clientid, vm.mode, vm.query);
            Rlog.error('reminder', 'clientreminder', 'reminder search failed', { clientid: vm.clientid });
          });

          ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
            vm.client = client;
          }, function (err) {
            $log.error('### reminders -> client nor found, clientid, mode: ', vm.clientid, vm.mode, err);
            Rlog.error('reminder', 'clientreminder', 'patient search failed', { clientid: vm.clientid });
          });
        }
      };

      function addTodoEntry() {
        vm.newreminder.done = false;
        if (angular.isDefined(vm.client.primarycontact.firstname) && angular.isDefined(vm.client.primarycontact.lastname)) {
          vm.newreminder.pfname = vm.client.primarycontact.firstname;
          vm.newreminder.plname = vm.client.primarycontact.lastname;
        }
        if (angular.isDefined(vm.client.svdata.svnr)) {
          vm.newreminder.psvnr = vm.client.svdata.svnr;
        } else if (angular.isDefined(vm.client.svdata.bdateat)) {
          vm.newreminder.pbdateat = vm.client.svdata.bdateat;
        }
        vm.newreminder.clientid = vm.clientid;
        if (!vm.newreminder.due) {
          vm.newreminder.due = moment().toISOString();
          vm.newreminder.duestr = 'Sofort';
        }

        Reminder.$create(vm.newreminder).$then(function (rem) {
          var logentry = {};
          logentry.created = moment().toISOString();
          logentry.clientid = vm.clientid;
          logentry.patientid = vm.clientid;
          logentry.entry = 'Todo erstellt: ' + rem.label;
          Clientlog.$create(logentry);
        }, function (err) {
          $log.error('reminders not created, id: ', vm.clientid, err);
          Rlog.error('reminder', 'clientreminder', 'reminder creation failed', { clientid: vm.clientid });
        });
        vm.newreminder = {};
      }

      function calcdue(days, str) {
        vm.newreminder.due = moment().add(days, 'days').toISOString();
        vm.newreminder.duestr = str;
      }

      function save(item) {

        var logentry = {};
        logentry.created = moment().toISOString();
        logentry.clientid = vm.clientid;
        logentry.patientid = vm.clientid;
        if (item.done === true) {
          item.completed = moment().toISOString();
          logentry.entry = 'Todo abgeschlossen: ' + item.label;
        }
        if (item.done === false) {
          delete item.completed;
          logentry.entry = 'Todo wieder geöffnet: ' + item.label;
        }

        if (item.$hasPendingActions()) {
          item.$cancel();
        }
        item.$save().$then(function () {
          Clientlog.$create(logentry);
        }, function (err) {
          $log.error('reminders state could not be changed: ', item);
          Rlog.error('reminder', 'clientreminder', 'reminder status change failed', {
            reminderid: item._id,
            clientid: vm.clientid
          });
        });
      }

      var remindersUpdateHandler = function remindersUpdateHandler(message) {
        var messages = message.split(':');
        $log.debug('Reminders updated: ', message);
        if (angular.isDefined(vm.reminders)) {
          vm.reminders.$refresh();
        }
      };

      // listen for reminder updates
      vertxEventBusService.on('reminders.update', remindersUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('reminders.update', {}, remindersUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcreminder').component('clientlog', {
    restrict: 'E',
    bindings: {
      clientid: '<',
      mode: '<?'
    },
    template: '\n      <h4>Logbuch</h4>\n      <!-- Add new logentry -->\n      <form class="form-vertical spacer-bottom">\n        <div class="input-group">\n          <input type="text" ng-model="vm.newlogentry" class="form-control" id="newlog"\n                 placeholder="Neuer Logeintrag">\n          <span class="input-group-btn">\n            <button class="btn btn-success" type="submit" ng-click="vm.addLogEntry()">\n              <i class="fa fa-plus"></i>\n            </button>\n          </span>\n        </div>\n      </form>\n      <!-- Show logs -->\n      <div class="myscrollbox spacer-bottom scrollwindow">\n        <dl class="dl-vertical" ng-repeat="le in vm.logs | orderBy: \'-created\' ">\n          <dt ng-bind="le.created | moment: \'ll\' "></dt>\n          <dd ng-bind="le.entry"></dd>\n        </dl>\n      </div>\n      <div class="alert alert-info spacer-top" ng-hide="vm.logs.length > 0">Keine Logeinträge</div>\n\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Reminder', 'ClientHelper', 'Clientlog', 'vertxEventBusService', function ($log, $http, Rlog, Reminder, ClientHelper, Clientlog, vertxEventBusService) {

      var vm = this;

      vm.addLogEntry = addLogEntry;

      vm.$onInit = function () {
        vm.newlogentry = '';
        var query = {};
        if (!angular.isDefined(vm.mode) || vm.mode !== 'patient') {
          vm.mode = 'client';
        }

        if (angular.isDefined(vm.clientid)) {
          if (vm.mode === 'patient') {
            query = { patientid: vm.clientid };
          } else {
            query = { clientid: vm.clientid };
          }

          Clientlog.$search(query).$then(function (logs) {
            vm.logs = logs;
          }, function (err) {
            $log.error('clientlog not found , id: ', vm.clientid);
            Rlog.error('reminder', 'clientlog', 'clientlog search failed', { clientid: vm.clientid, mode: vm.mode });
          });
        }
      };

      function addLogEntry() {
        var logentry = {};
        logentry.created = moment().toISOString();
        logentry.clientid = vm.clientid;
        logentry.patientid = vm.clientid;
        logentry.entry = vm.newlogentry;
        Clientlog.$create(logentry).$then(function () {
          vm.newlogentry = '';
        }, function (err) {
          $log.error('logentry state could not be added: ', vm.newlogentry);
          Rlog.error('reminder', 'clientlog', 'logentry add  failed', { clientid: vm.clientid });
        });
      }

      var clUpdateHandler = function clUpdateHandler(message) {
        var messages = message.split(':');
        $log.debug('clientlogs updated: ', message);
        if (angular.isDefined(vm.logs)) {
          vm.logs.$refresh();
        }
      };

      // listen for clientlog updates
      vertxEventBusService.on('clientlogs.update', {}, clUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('clientlogs.update', {}, clUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 09/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcreminder').component('allreminders', {
    restrict: 'E',
    bindings: {},
    templateUrl: 'vcreminder/allreminders-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Reminder', 'Client', 'Clientlog', 'vertxEventBusService', function ($log, Reminder, Client, Clientlog, vertxEventBusService) {
      var vm = this;
      vm.save = save;
      vm.switchRange = switchRange;

      var refreshAll = function refreshAll() {
        vm.todos.upcoming.$refresh();
        vm.todos.overdue.$refresh();
        vm.todos.lastcompleted.$refresh();
      };

      vm.$onInit = function () {
        vm.weeks = 2;
        // vm.upcoming = moment().add(2, 'weeks').toISOString();
        vm.name = 'allReminder';

        vm.todos = {};
        vm.todos.upcoming = upcoming();
        vm.todos.overdue = dueandoverdue();
        vm.todos.lastcompleted = lastcompleted();
      };

      function lastcompleted() {
        return Reminder.$search({
          completed: {
            // $lt: moment().toISOString().add(1, 'days'),
            $gte: moment().subtract(2, 'days').toISOString()
          }, done: true
        });
      }

      function upcoming() {
        return Reminder.$search({
          due: {
            $lt: moment().add(vm.weeks, 'weeks').toISOString(),
            $gte: moment().add(1, 'days').startOf('day').toISOString()
          }, done: false
        });
      }

      function dueandoverdue() {
        return Reminder.$search({
          due: { $lt: moment().add(1, 'days').startOf('day').toISOString() },
          done: false
        });
      }

      function switchRange(weeks) {
        vm.weeks = weeks;
        vm.todos.upcoming = upcoming();
      }

      function save(item) {
        var logentry = {};
        logentry.created = moment().toISOString();
        logentry.clientid = item.clientid;
        if (angular.isDefined(item.patientid)) {
          logentry.patientid = item.patientid;
        } else {
          logentry.patientid = item.clientid;
        }

        if (item.done === true) {
          item.completed = moment().toISOString();
          logentry.entry = 'Todo abgeschlossen: ' + item.label;
        }
        if (item.done === false) {
          delete item.completed;
          logentry.entry = 'Todo wieder geöffnet: ' + item.label;
        }
        item.$save().$asPromise().then(function () {
          refreshAll();
          Clientlog.$create(logentry);
        });
      }

      vertxEventBusService.on('reminders.update', {}, refreshAll);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('reminders.update', {}, refreshAll);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcpatdocs
   * @description
   *
   */
  angular.module('vcpatdocs', ['ui.router', 'ui.tinymce', 'ui.bootstrap']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('timeslip', {
    restrict: 'E',
    bindings: {},
    template: '\n        <h3>Zeitbestätigung</h3>\n        <form class="form-vertical"  id="timeform" name="timeform">\n        <!-- Überweisung für: -->\n          <div class="form-group">\n            <!-- Patientensuche -->\n            <label for="reffor">Patient</label>\n            <div class="form-group  col-xs-12" ng-hide="vm.timeslip.patientid">\n              <clientsearch id="patient" parentsave="vm.savePatient(client, mode)" mode="patient"></clientsearch>\n            </div>\n            <div class="form-group col-xs-12" ng-show="vm.timeslip.patientid">\n              <div class="input-group">\n                <input type="text" class="form-control"\n                       id="patientname"\n                       tabindex="0"\n                       readonly\n                       ng-model="vm.timeslip.patient.fname">\n                <span class="input-group-btn">\n                  <button class="btn btn-danger"\n                          ng-click="vm.clearPatient()"><i class="fa fa-remove"></i>\n                  </button>\n                </span>\n              </div>\n            </div>\n          </div>\n        \n        <!-- Datum: -->\n          <div class="form-group">\n            <label for="tdate">Datum</label>\n              <input type="text" class="form-control"\n                     id="tdate"\n                     tabindex="0"\n                     ng-model="vm.timeslip.date">\n          </div>\n          \n        <!-- Zeit: -->\n          <div class="form-group">\n            <label for="tfrom">Von</label>\n              <input type="text" class="form-control"\n                     id="tfrom"\n                     tabindex="0"\n                     ng-model="vm.timeslip.fromtime">\n          </div>\n            \n          <div class="form-group">\n            <label for="tto">Bis</label>\n              <input type="text" class="form-control"\n                     id="tto"\n                     tabindex="0"\n                     ng-model="vm.timeslip.totime">\n          </div>    \n                  \n          <div class="form-group">\n            <label for="dontdrive" style="display: block">Einschränkungen</label>\n              <input type="checkbox" \n                     id="dontdrive"\n                     tabindex="0"\n                     ng-model="vm.timeslip.dontdrive"> Nicht verkehrs- und geschäftsfähig\n                     \n                     <div ng-show="vm.timeslip.dontdrive === true">\n                        <label for="ddtto" style="display: block">Bis</label>\n                        <input type="text" class="form-control"\n                               id="ddtto"\n                               tabindex="0"\n                               ng-model="vm.timeslip.dontdrivetime">\n                     </div>\n          </div>\n        \n        \n        \n          <!-- Buttons -->\n          <divclass="spacer-bottom ">\n            <button class="btn btn-success" ng-disabled="timeform.$invalid" type="button" ng-click="vm.print();"\n                    tabindex="0">\n              Drucken\n            </button>\n          </div>\n          <div class="alert alert-success" ng-show="vm.printed === true"><i class="fa fa-check"></i> Zeitbestätigung erfolgreich\n            gedruckt\n          </div>\n          <div class="alert alert-danger" ng-show="vm.printed === false"><i class="fa fa-warning"></i> Druck der Zeitbestätigung\n            fehlgeschlagen\n          </div>\n        </form>\n',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper', function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper) {
      var vm = this;

      vm.savePatient = savePatient;
      vm.clearPatient = clearPatient;

      vm.add = add;
      vm.cancel = cancel;
      vm.print = print;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };

      vm.$onInit = function () {
        vm.mode = 'patient';
        inittimeslip();
      }; // $onInit()

      // reset timeslip form
      function inittimeslip() {
        vm.timeslip = {};
        vm.timeslip.type = 'timeslip';
        vm.timeslip.date = moment().locale('de-at').format('ll');
        vm.timeslip.fromtime = moment().subtract(53, 'minutes').format('HH:mm');
        vm.timeslip.totime = moment().add(5, 'minutes').format('HH:mm');
        vm.timeslip.dontdrivetime = moment().add(5, 'minutes').add(1, 'days').format('DD.MM.YYYY, HH:mm');
        vm.timeslip.dontdrive = false;
      }

      // save patient data
      function savePatient(client, mode) {
        $log.debug('patient in savePAtient: ', client, mode);
        delete vm.timeslip.patient;
        vm.patient = client;
        vm.patientid = client._id;
        vm.timeslip.patient = {};
        vm.timeslip.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
        vm.timeslip.patient.svdata = vm.patient.svdata;
        vm.timeslip.patientid = vm.patient._id;
        vm.timeslip.patient._id = vm.patient._id;
        vm.timeslip.patient.primarycontact = vm.patient.primarycontact;
      }

      // clear timelip patient
      function clearPatient() {
        delete vm.timeslip.patient;
        delete vm.timeslip.patientid;
      }

      function add() {
        Patdocs.$create(vm.timeslip).$then(function () {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          inittimeslip();
          $timeout(function () {
            vm.saved = false;
          }, 3000);
        });
      }

      function cancel() {
        vm.saved = false;
        vm.canceled = true;
        vm.savefailed = false;
        inittimeslip();
        $timeout(function () {
          vm.canceled = false;
        }, 3000);
      }

      function print() {
        Patdocs.$create(vm.timeslip).$then(function (timeslip) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 3000);
          inittimeslip();
          $log.debug('timelip returned: ', timeslip);
          PrintHelper.jsonPrint(vm.patientid, 'time', timeslip).then(function () {
            $log.debug('printing timeslip succeeded');
            vm.printed = true;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
          }, function (err) {
            vm.printed = false;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
            $log.error('printing timeslip failed: ', err);
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('textprocessing', {
    restrict: 'E',
    bindings: {},
    templateUrl: 'vcpatdocs/textprocesssing-smartcomponent.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper', 'Drug', '$window', function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper, Drug, $window) {
      var vm = this;

      vm.savePatient = savePatient;
      vm.clearPatient = clearPatient;

      vm.saveDoctor = saveDoctor;
      vm.clearDoctor = clearDoctor;

      vm.add = add;
      vm.cancel = cancel;
      vm.print = print;
      vm.preview = preview;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };
      vm.tinymceOptions = {
        selector: 'textarea',
        skin: 'lightgray',
        theme: 'modern',
        resize: true,
        width: '100%',
        height: 300,
        entity_encoding: 'raw',
        plugins: 'link searchreplace table spellchecker print preview template',
        menubar: 'file edit insert view format table tools',
        toolbar: 'undo redo | formatselect fontsizeselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent'
      };

      vm.$onInit = function () {
        vm.mode = 'patient';
        inittextdoc();
      }; // $onInit()

      // reset textdoc form
      function inittextdoc() {
        vm.textdoc = {};
        vm.textdoc.type = 'textdoc';
        vm.textdoc.fdate = moment().locale('de-at').format('ll');
      }

      // save patient data
      function savePatient(client, mode) {
        $log.debug('patient in savePatient: ', client, mode);
        delete vm.textdoc.patient;
        vm.patient = client;
        vm.patientid = client._id;
        vm.textdoc.patient = {};
        vm.textdoc.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
        vm.textdoc.patient.svdata = vm.patient.svdata;
        vm.textdoc.patient.diagnoses = vm.patient.diagnoses;
        vm.textdoc.patient.risk = vm.patient.risk;
        vm.textdoc.patient.notes = vm.patient.notes;
        vm.textdoc.patientid = vm.patient._id;
        vm.textdoc.patient._id = vm.patient._id;
        vm.textdoc.patient.primarycontact = vm.patient.primarycontact;
        $log.debug('textdoc contents: ', vm.textdoc);
      }

      // clear timeslip patient
      function clearPatient() {
        delete vm.textdoc.patient;
        delete vm.textdoc.patientid;
      }

      // save referral doctor
      function saveDoctor(doctor) {
        delete vm.textdoc.to;
        vm.textdoc.doctor = doctor;
      }

      // clear referral doctor
      function clearDoctor() {
        delete vm.textdoc.doctor;
      }

      function add() {
        Patdocs.$create(vm.textdoc).$then(function () {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          inittextdoc();
          $timeout(function () {
            vm.saved = false;
          }, 3000);
        });
      }

      function cancel() {
        vm.saved = false;
        vm.canceled = true;
        vm.savefailed = false;
        inittextdoc();
        $timeout(function () {
          vm.canceled = false;
        }, 3000);
      }

      function print() {
        vm.textdoc.xhtml = '<xhtml>' + vm.xhtml.toString() + '</xhtml>';
        $log.debug('vm.newtext.xhtml: ', vm.textdoc.xhtml);

        if (vm.textdoc.getdrugs === true) {
          Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
            vm.textdoc.patdrugs = drugs[0];
            printhandler();
          }, function (err) {
            $log.error('Patient drugs acquisition failed: ', err);
          });
        } else {
          printhandler();
        }
      }

      function preview() {
        $log.debug('preview called');
        vm.textdoc.xhtml = '<xhtml>' + vm.xhtml.toString() + '</xhtml>';
        $log.debug('vm.newtext.xhtml: ', vm.textdoc.xhtml);

        if (vm.textdoc.getdrugs === true) {
          Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
            vm.textdoc.patdrugs = drugs[0];
            previewhandler();
          }, function (err) {
            $log.error('Patient drugs acquisition failed: ', err);
          });
        } else {
          previewhandler();
        }
      }

      function printhandler() {
        Patdocs.$create(vm.textdoc).$then(function (textdoc) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 3000);
          $log.debug('timelip returned: ', textdoc);
          PrintHelper.jsonPrint(vm.patientid, 'freeform', textdoc).then(function () {
            inittextdoc();
            $log.debug('printing textdoc succeeded');
            vm.printed = true;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
          }, function (err) {
            vm.printed = false;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
            $log.error('printing textdoc failed: ', err);
          });
        });
      }

      function previewhandler() {
        Patdocs.$create(vm.textdoc).$then(function (textdoc) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 3000);

          // using fetch because restmod screwed with the pdf encoding
          fetch('/routes/fop/plainjson/false/false/' + vm.patientid + '/freeform', {
            method: 'POST',
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrer: 'no-referrer', // no-referrer, *client
            body: JSON.stringify(textdoc)
          }).then(function (response) {
            if (response.ok) {
              return response.blob();
            }
          }).then(function (blob) {
            $log.debug('previewing textdoc succeeded: ', blob);
            var previewBlob = new Blob([blob], { type: "application/pdf" });
            var url = $window.URL || $window.webkitURL;
            vm.previewUrl = url.createObjectURL(previewBlob);
            $log.debug('previewUrl: ', vm.previewUrl);
            $window.open(vm.previewUrl, '_blank');
          })['catch'](function (err) {
            $log.error('Failed to generate freeform text preview; ', err);
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('testpdf', {
    restrict: 'E',
    bindings: {},
    template: '\n          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau"  target="_blank"\n                  href="/routes/fop/prescription/false/false/571d67207c01594fd0bbdf45">\n            <i class="fa fa-eye"></i> Rezept</a></div>\n          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"\n                  href="/routes/fop/aide/false/false/586fcf4fa60359ae2a632d64/58f88208b148b776e918dd0d">\n            <i class="fa fa-eye"></i> Hilfsmittel</a></div>\n          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"\n                  href="/routes/fop/referral/false/false/586fcf4fa60359ae2a632d64/58f88208b148b776e918dd0d">\n            <i class="fa fa-eye"></i> Überweisung</a></div>\n          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"\n                  href="/routes/fop/exam/false/false/58f8820cb148b776e918dd0e/58f88208b148b776e918dd0d">\n            <i class="fa fa-eye"></i> Untersuchung</a></div>\n                      <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"\n                  href="/routes/fop/examlabels/false/false/59c7db409593e058516aa638">\n            <i class="fa fa-eye"></i> Untersuchungs Labels</a></div>   \n          <div class="spacer-bottom"><a class="btn btn-info" uib-tooltip="PDF Vorschau" target="_blank"\n                  href="/routes/fop/consult/false/false/58f88208b148b776e918dd0d">\n            <i class="fa fa-eye"></i> Gesamtbefund</a></div>      \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', '$timeout', function ($log, Rlog, $timeout) {
      var vm = this;
      /*          vm.testPrescriptionPreview = testPrescriptionPreview;
                vm.testPrescriptionPrint = testPrescriptionPrint;*/

      /*
                function testPrescriptionPreview() {
                  PatdocaggregateHelper.prescriptionpreview('571d67207c01594fd0bbdf45');
                }
      
                function testPrescriptionPrint() {
                  PatdocaggregateHelper.prescriptionprint('571d67207c01594fd0bbdf45');
                }*/

      vm.getUrl = function () {};
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of patdocss (patients) to display or load patdocss */

'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('reflist', {
    restrict: 'E',
    bindings: {
      consultid: '<?'
    },
    template: '\n <div ng-show="vm.referrals.length === 0" class="alert alert-info"><h4>Es wurden noch keine Überweisungen angelegt.</h4></div>\n        <div ng-show="vm.referrals.length > 0">\n        <h2>Bestehende Überweisungen</h2>\n        <div ng-repeat="ref in vm.referrals">\n          <div class="row">\n            <div class="col-sm-11"><h4>Überweisung</h4></div>\n            <div class="col-sm-1">\n              <button class="btn btn-danger" ng-click="vm.removeReferral(ref)" uib-tooltip="Überweisung löschen">\n                <i class="fa fa-remove"></i>\n              </button>\n            </div>\n          </div>\n        \n          <div class="row">\n            <div class="col-xs-12">\n              <dl class="dl-horizontal">\n                <dt>An/zu</dt>\n                <dd>{{ref.to}}{{ref.doctor.fname}}</dd>\n                <dt>Diagnose</dt>\n                <dd ng-bind="ref.diag"></dd>\n                <dt ng-hide="ref.labvalues.length > 0">Erbeten</dt>\n                <dd ng-hide="ref.labvalues.length > 0" ng-model="ref.ref">{{ref.ref}}</dd>\n                <dt ng-show="ref.cleangroups.length > 0">Laborwerte</dt>\n                <dd ng-show="ref.cleangroups.length > 0"><div\n                    ng-repeat="grp in ref.cleangroups">{{grp.name}}: <span ng-repeat="val in grp.values"> {{val}}{{$last ? \'\' : \', \'}}</span></div></dd>\n                <dt ng-show="ref.biolabels.length > 0">Biopsien</dt>\n                <dd ng-show="ref.biolabels.length > 0">\n                  <div ng-repeat="label in ref.biolabels">{{label}}</div>\n                  </dd>\n                <dt>Datum</dt>\n                <dd ng-bind="ref.refdate"></dd>\n              </dl>\n            </div>\n          </div>\n        </div>\n        \n        <!-- PDF Vorschau -->\n        <a class="btn btn-info" target="_blank" ng-show="vm.referrals.length"\n           href="{{vm.previewurl}}">\n          <i class="fa fa-eye"></i> PDF Vorschau\n        </a>\n        <div style="min-height:3cm">&nbsp;</div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Patdocs', 'PatdocsHelper', 'vertxEventBusService', 'PrintHelper', function ($log, $http, Rlog, Patdocs, PatdocsHelper, vertxEventBusService, PrintHelper) {
      var vm = this;
      vm.removeReferral = removeReferral;

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.patdocss)) {
          vm.patdocss = Patdocs.$search();
        }
      }; // $onInit()

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue)) {
            vm.consultid = changes.consultid.currentValue;
            Patdocs.$search({ consultid: vm.consultid, active: true, type: 'referral' }).$then(function (referrals) {
              vm.referrals = referrals;
              if (referrals.length > 0) {
                vm.previewurl = PrintHelper.referralPreviewUrl(referrals[0].patientid, vm.consultid);
                $log.debug('ref preview url', vm.previewurl);
              }
            }, function (err) {
              $log.error('referrals lookup failed: ', vm.consultid);
              Rlog.error('patdocs', 'reflist', 'referral lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      function removeReferral(ref) {
        ref.active = false;
        ref.$save();
      }

      var patdocsUpdateHandler = function patdocsUpdateHandler(message) {
        if (angular.isDefined(vm.referrals)) {
          vm.referrals.$refresh().$then(function (referrals) {
            vm.previewurl = PrintHelper.referralPreviewUrl(referrals[0].patientid, vm.consultid);
            $log.debug('debug: reflist refreshed patdocss');
          }, function (error) {
            $log.debug('debug: reflist refresh patdocs failed: ', error);
          });
        }
      };

      vertxEventBusService.on('patdocs.update', {}, patdocsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdocs.update', {}, patdocsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('refcounter', {
    restrict: 'E',
    bindings: {
      consultid: '<'
    },
    template: '\n        <span class="badge" ng-bind="vm.counter"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'Rlog', 'vertxEventBusService', '$http', function ($log, Patdocs, Rlog, vertxEventBusService, $http) {
      var vm = this;

      var getCounter = function getCounter() {
        var query = [{
          $match: {
            consultid: vm.consultid,
            type: 'referral',
            active: true
          }
        }, {
          $group: {
            _id: 'refcounter',
            counter: { $sum: 1 }
          }
        }];

        $http.post('/routes/patdocs/aggregate', query).then(function (res) {
          vm.counter = 0;
          if (res.data.counter) {
            vm.counter = res.data.counter;
          }
        }, function (err) {
          $log.error(err);
          Rlog.error('patdocs', 'refcounter', 'refcounter.$aggregate failed', {});
        });
      };

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0) {
            vm.consultid = changes.consultid.currentValue;
            getCounter();
          }
        }
      };

      // listen for patdocs updates
      vertxEventBusService.on('patdocs.update', {}, getCounter);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdocs.update', {}, getCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcpatdocs').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.patdocs', {
      url: '/patdocs',
      views: {
        'playgroundmain@playground': {
          template: '\n              <!--<h3 class="alert alert-info"><tt>&lt;patdocssearch patdocs="" patdocsref="" editinplace="true"&gt;</tt></h3><div ui-view="patdocssearchview"></div>-->\n              <!--<h3 class="alert alert-info"><tt>&lt;patdocssearch patdocs="" patdocsref="" parentsave=""&gt;</tt></h3><div ui-view="patdocssearchview2"></div>-->\n              <!--<h3 class="alert alert-info"><tt>&lt;patdocseditor patdocs="" mode="" onClose=""&gt;</tt></h3><div ui-view="patdocseditview"></div>-->\n              <h3 class="alert alert-info"><tt>&lt;newref consultid="" clientid=""&gt;</tt></h3><div ui-view="patdocsnewrefview"></div>\n              <h3 class="alert alert-info"><tt>&lt;newaide consultid="" clientid=""&gt;</tt></h3><div ui-view="patdocsnewaideview"></div>\n              <h3 class="alert alert-info"><tt>&lt;refcounter consultid=""&gt;</tt></h3><div ui-view="patdocsrefcounterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;aidecounter consultid=""&gt;</tt></h3><div ui-view="patdocsaidecounterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;labvalueconfig&gt;</tt></h3><div ui-view="labvalueconfigview"></div>\n              <h3 class="alert alert-info"><tt>&lt;imagingconfig&gt;</tt></h3><div ui-view="imagingconfigview"></div>\n              <h3 class="alert alert-info"><tt>&lt;aideconfig&gt;</tt></h3><div ui-view="aideconfigview"></div>\n              <h3 class="alert alert-info"><tt>&lt;testpdf&gt;</tt></h3><div ui-view="testpdfview"></div>\n              <!--<h3 class="alert alert-info"><tt>&lt;patdocslist patdocss="?"&gt;</tt></h3><div ui-view="patdocslistview"></div>-->\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vcpatdocs entered');
      }
    });

    $stateProvider.state('playground.patdocs.allcomponents', {
      url: '/allcomponents',
      resolve: {
        clientid: function clientid() {
          return '586fcf4fa60359ae2a632d64';
        },
        consultid: function consultid() {
          return '58f88208b148b776e918dd0d';
        },
        patdocsref: function patdocsref() {
          return '';
        },
        somepatdocs: function somepatdocs(Patdocs) {
          return Patdocs.$find('572b31b07c01597e3e150923');
        },
        allpatdocss: function allpatdocss(Patdocs) {
          return Patdocs.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (patdocs, patdocsref) {
            console.log('debug: dummy parentsave called for patdocssearch with: ', patdocs, patdocsref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'patdocssearchview@playground.patdocs': {
          component: 'patdocssearch',
          bindings: {
            patdocs: 'patdocs',
            patdocsref: 'patdocsref',
            editinplace: 'eip'
          }
        },
        /*'patdocssearchview2@playground.patdocs': {
          component: 'patdocssearch',
          bindings: {
            patdocs: 'patdocs',
            patdocsref: 'patdocsref',
            parentsave: 'parentsavesearch'
          }
        },
        'patdocseditview@playground.patdocs': {
          component: 'patdocseditor',
          bindings: {
            patdocs: 'somepatdocs'
          }
        },*/
        'patdocsnewrefview@playground.patdocs': {
          component: 'newref',
          bindings: {}
        },
        'patdocsnewaideview@playground.patdocs': {
          component: 'newaide',
          bindings: {}
        },
        'patdocsrefcounterview@playground.patdocs': {
          component: 'refcounter',
          bindings: {}
        },
        'patdocsaidecounterview@playground.patdocs': {
          component: 'aidecounter',
          bindings: {}
        },
        'labvalueconfigview@playground.patdocs': {
          component: 'labvalueconfig',
          bindings: {}
        },
        'imagingconfigview@playground.patdocs': {
          component: 'imagingconfig',
          bindings: {}
        },
        'aideconfigview@playground.patdocs': {
          component: 'aideconfig',
          bindings: {}
        },
        'patdocslistview@playground.patdocs': {
          component: 'patdocslist',
          bindings: {
            patdocss: 'allpatdocss'
          }
        },
        'testpdfview@playground.patdocs': {
          component: 'testpdf',
          bindings: {}
        }
      },
      onEnter: function onEnter() {
        console.log('playground.patdocs.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcpatdocs.factory:PatdocsHelper
   *
   * @description
   *
   */
  angular.module('vcpatdocs').factory('PatdocsHelper', PatdocsHelper);

  PatdocsHelper.$inject = ['Patdocs', '$uibModal', '$log', 'Rlog'];

  function PatdocsHelper(Patdocs, $uibModal, $log, Rlog) {
    var PatdocsHelperBase = {};

    PatdocsHelperBase.addReferral = addReferral;
    PatdocsHelperBase.addAide = addAide;
    // PatdocsHelperBase.addBiopsyReferral = addBiopsyReferral;

    function addReferral(_consultid, _clientid) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer">\n            <div style="text-align: right">\n              <button class="btn btn-danger" ng-click="vm.$uibModalInstance.close()" uib-tooltip="Fenster schließen">\n                <i class="fa fa-remove"></i>\n              </button>\n            </div>\n            <newref consultid="vm.consultid" patientid="vm.clientid" mode="patient" modal="vm.$uibModalInstance"></newref>\n            <reflist consultid="vm.consultid"></reflist>\n            </div>',
        controllerAs: 'vm',
        controller: ['consultid', 'clientid', '$uibModalInstance', function (lconsultid, lclientid, $uibModalInstance) {
          var vm = this;
          vm.patdocs = {};
          vm.consultid = lconsultid;
          vm.clientid = lclientid;
          vm.$uibModalInstance = $uibModalInstance;
        }],
        resolve: {
          consultid: function consultid() {
            return _consultid;
          },
          clientid: function clientid() {
            return _clientid;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
    }

    function addAide(_consultid2, _clientid2) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer">\n            <div style="text-align: right">\n              <button class="btn btn-danger" ng-click="vm.$uibModalInstance.close()" uib-tooltip="Fenster schließen">\n                <i class="fa fa-remove"></i>\n              </button>\n            </div>\n            <newaide consultid="vm.consultid" patientid="vm.clientid"  mode="patient"  modal="vm.$uibModalInstance"></newaide>\n            <aidelist consultid="vm.consultid"></aidelist>\n            </div>',
        controllerAs: 'vm',
        controller: ['consultid', 'clientid', '$uibModalInstance', function (lconsultid, lclientid, $uibModalInstance) {
          var vm = this;
          vm.patdocs = {};
          vm.consultid = lconsultid;
          vm.clientid = lclientid;
          vm.$uibModalInstance = $uibModalInstance;
        }],
        resolve: {
          consultid: function consultid() {
            return _consultid2;
          },
          clientid: function clientid() {
            return _clientid2;
          }
        },
        size: 'lg',
        backdrop: 'static'
      });
    }

    // add patho referral for biopsies
    function oldaddBiopsyReferral() {
      var biolabels = [];
      var label;
      var i;
      if (!vm.patient.openConsult.hasOwnProperty('referrals') || !(vm.patient.openConsult.referrals instanceof Array)) {
        vm.patient.openConsult.referrals = [];
      }

      if (!vm.patient.openConsult.hasOwnProperty('newreferral')) {
        vm.patient.openConsult.newreferral = {};
      }
    }

    return PatdocsHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name patdocs.factory:Patdocs
   *
   * @description
   *
   */
  angular.module('vcpatdocs').factory('Patdocs', Patdocs);

  Patdocs.$inject = ['restmod'];
  function Patdocs(restmod) {
    return restmod.model('/routes/patdocs').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/patdocs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          /* $aggregate: function (_params) {
             console.log('##### restmod aggregate this: ', this);
             console.log('##### restmod aggregate _params: ', _params);
             return this.$record().$decorate({
               'before-request': function (_req) {
                 _req.method = 'POST';
                 _req.url = '/routes/patdocs/aggregate';
               }
             }, function () {
               return this.$fetch(_params);
             });
           },*/
          $searchBy: function $searchBy(key, val) {
            var realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('newref', {
    restrict: 'E',
    bindings: {
      consultid: '<?',
      patientid: '<?',
      mode: '@?',
      modal: '<?'
    },
    templateUrl: 'vcpatdocs/newref-smartcomponent.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper', '$window', function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper, $window) {
      var vm = this;
      vm.saveDoctor = saveDoctor;
      vm.clearDoctor = clearDoctor;

      vm.savePatient = savePatient;
      vm.clearPatient = clearPatient;

      vm.saveLabvalues = saveLabvalues;
      vm.saveImagingvalues = saveImagingvalues;
      vm.setRefDate = setRefDate;
      vm.setDiag = setDiag;

      vm.add = add;
      vm.cancel = cancel;
      vm.print = print;
      vm.preview = preview;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };

      vm.$onInit = function () {
        vm.mode = 'patient';
        initNewRef();

        vm.labreset = 0;
        vm.imagingreset = 0;

        vm.standalone = angular.isUndefined(vm.patientid) && angular.isUndefined(vm.consultid);

        // determine client mode
        if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
          vm.kunde = 'Patient';
          vm.testkunde = 'Testpatient';
        } else {
          vm.mode = 'client';
          vm.kunde = 'Kunde';
          vm.testkunde = 'Testkunde';
        }

        //  get labvalues and groups from config
        Config.$find('labconfiguration').$then(function (labconfig) {
          vm.labgroups = labconfig.groups;
          vm.labvalues = labconfig.values;
        }, function (error) {
          $log.error(error);
          Rlog.error('patdocs', 'newref', 'labconfiguration.$find() failed', { id: vm.patientid });
        });
      }; // $onInit()

      // vm.patientid, consultid might be late propagating, get them on first real change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.patientid) && angular.isString(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
            vm.patientid = changes.patientid.currentValue;
            // get client/patient information for inclusion inside document
            ClientHelper.find(vm.mode, vm.patientid).$then(function (patient) {
              vm.patient = patient;
              vm.newref.patient = {};
              vm.newref.patient.svdata = vm.patient.svdata;
              vm.diagnoses = vm.patient.flatdiagnoses.map(function (d) {
                return { text: d, use: false };
              });
              vm.newref.patientid = vm.patient._id;
              vm.newref.patient._id = vm.patient._id;
              vm.newref.patient.primarycontact = vm.patient.primarycontact;
            }, function (err) {
              $log.error('patient not found, id: ', vm.patientid, err);
              Rlog.error('patdocs', 'newref', 'client.$find() failed', { id: vm.patientid });
            });
          }
          if (angular.isDefined(changes.consultid)) {
            vm.consultid = changes.consultid.currentValue;
            if (angular.isUndefined(vm.newref)) {
              initNewRef();
            } else {
              vm.newref.consultid = vm.consultid;
            }
          }
        }
      };

      // reset ref form
      function initNewRef() {
        vm.newref = {};
        vm.newref.type = 'referral';
        vm.newref.refdate = '';
        vm.newref.ginclude = [];
        vm.newref.additionalvalues = [];
        if (angular.isDefined(vm.consultid)) {
          vm.newref.consultid = vm.consultid;
        }
        if (angular.isDefined(vm.patient)) {
          vm.newref.patient = {};
          vm.newref.patient.svdata = vm.patient.svdata;
          vm.newref.patientid = vm.patient._id;
          vm.newref.patient._id = vm.patient._id;
          vm.newref.patient.primarycontact = vm.patient.primarycontact;
        }
      }

      // save referral doctor
      function saveDoctor(doctor) {
        delete vm.newref.to;
        vm.newref.doctor = doctor;
      }

      // clear referral doctor
      function clearDoctor() {
        delete vm.newref.doctor;
      }

      // save referral labvalues
      function saveLabvalues(allvalues, ginclude, additionalvalues, cleangroups) {
        vm.newref.labvalues = allvalues;
        vm.newref.ginclude = ginclude;
        vm.newref.additionalvalues = additionalvalues;
        vm.newref.cleangroups = cleangroups;
      }

      // save referral imagevalues
      function saveImagingvalues(allvalues, ginclude, additionalvalues) {
        vm.newref.imagingvalues = allvalues;
        vm.newref.ginclude = ginclude;
        vm.newref.additionalvalues = additionalvalues;
      }

      function setRefDate() {
        vm.newref.refdate = moment().locale('de-at').format('ll');
      }

      function setDiag() {
        var tmp = vm.diagnoses.filter(function (d) {
          if (d.use) return d;
        }).map(function (d) {
          return d.text;
        });
        vm.newref.diag = tmp.join(', ');
      }

      // save patient data
      function savePatient(client, mode) {
        $log.debug('patient in savePAtient: ', client, mode);
        delete vm.newref.patient;
        vm.patient = client;
        vm.patientid = client._id;
        vm.newref.patient = {};
        vm.newref.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
        vm.newref.patient.svdata = vm.patient.svdata;
        vm.newref.patientid = vm.patient._id;
        vm.newref.patient._id = vm.patient._id;
        vm.newref.patient.primarycontact = vm.patient.primarycontact;
      }

      // clear patient
      function clearPatient() {
        delete vm.newref.patient;
        delete vm.newref.patientid;
      }

      function add() {
        Patdocs.$create(vm.newref).$then(function () {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          initNewRef();
          delete vm.newref.reftype;
          vm.imagingreset++;
          vm.labreset++;
          $timeout(function () {
            vm.saved = false;
            if (angular.isDefined(vm.modal)) {
              vm.modal.close();
            }
          }, 2000);
        }, function (err) {
          vm.savefailed = true;
          $log.error('adding single referral failed: ', err);
          $timeout(function () {
            vm.savefailed = false;
          }, 3000);
        });
      }

      function cancel() {
        vm.saved = false;
        vm.canceled = true;
        vm.savefailed = false;
        initNewRef();
        vm.labreset++;
        vm.imagingreset++;
        $timeout(function () {
          vm.canceled = false;
          if (angular.isDefined(vm.modal)) {
            vm.modal.close();
          }
        }, 1500);
      }

      function print() {
        Patdocs.$create(vm.newref).$then(function (referral) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 3000);
          initNewRef();
          $log.debug('referral returned: ', referral);
          PrintHelper.referralSinglePrint(referral._id, vm.patientid).then(function () {
            $log.debug('printing single erferral succeeded');
            vm.printed = true;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
          }, function (err) {
            vm.printed = false;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
            $log.error('printing single referral failed: ', err);
          });
        });
      }

      function preview() {
        Patdocs.$create(vm.newref).$then(function (referral) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 3000);
          initNewRef();
          $log.debug('referral returned: ', referral);
          PrintHelper.referralSinglePreview(referral._id, vm.patientid).then(function (url) {
            $log.debug('previewing single referral succeeded: ', url);
            vm.previewurl = url.data;
            vm.previewed = true;
            $window.open(url);
            $timeout(function () {
              delete vm.previewed;
            }, 3000);
          }, function (err) {
            vm.previewed = false;
            $timeout(function () {
              delete vm.previewed;
            }, 3000);
            $log.error('previewing single referral failed: ', err);
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('newaide', {
    restrict: 'E',
    bindings: {
      consultid: '<?',
      patientid: '<?',
      mode: '@?',
      modal: '<?'
    },
    templateUrl: 'vcpatdocs/newaide-smartcomponent.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'ClientHelper', 'Config', 'Rlog', '$timeout', 'PrintHelper', function ($log, Patdocs, ClientHelper, Config, Rlog, $timeout, PrintHelper) {
      var vm = this;
      vm.saveDoctor = saveDoctor;
      vm.clearDoctor = clearDoctor;

      vm.savePatient = savePatient;
      vm.clearPatient = clearPatient;

      vm.loadValues = loadValues;
      vm.toggleGroup = toggleGroup;
      vm.joinValues = joinValues;
      vm.flattenArray = flattenArray;
      vm.setRefDate = setRefDate;

      vm.add = add;
      vm.cancel = cancel;
      vm.print = print;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };

      vm.$onInit = function () {
        vm.mode = 'patient';
        initNewRef();

        vm.labreset = 0;
        vm.imagingreset = 0;

        vm.standalone = angular.isUndefined(vm.patientid) && angular.isUndefined(vm.consultid);

        //  get labvalues and groups from config
        Config.$find('aideconfiguration').$then(function (aideconfig) {
          vm.aideconfig = aideconfig;
        }, function (error) {
          Rlog.error('patdocs', 'newaide', 'aideconfiguration.$find() failed', { id: vm.patientid });
          $log.error('aideconfiguration.$find() failed', error);
        });
      }; // $onInit()

      // vm.patientid, consultid might be late propagating, get them on first real change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.patientid) && angular.isString(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
            vm.patientid = changes.patientid.currentValue;
            // get client/patient information for inclusion inside document
            ClientHelper.find(vm.mode, vm.patientid).$then(function (patient) {
              vm.patient = patient;
              vm.newaide.patient = {};
              vm.newaide.patient.svdata = vm.patient.svdata;
              vm.newaide.patientid = vm.patient._id;
              vm.newaide.patient._id = vm.patient._id;
              vm.newaide.patient.primarycontact = vm.patient.primarycontact;
            }, function (err) {
              $log.error('patient not found, id: ', vm.patientid, err);
              Rlog.error('patdocs', 'newaide', 'client.$find() failed', { id: vm.patientid });
            });
          }
          if (angular.isDefined(changes.consultid)) {
            vm.consultid = changes.consultid.currentValue;
            if (angular.isUndefined(vm.newaide)) {
              initNewRef();
            } else {
              vm.newaide.consultid = vm.consultid;
            }
          }
        }
      };

      function setRefDate() {
        vm.newaide.refdate = moment().locale('de-at').format('ll');
      }

      function toggleGroup() {
        var tmpa = [];
        for (var i = 0; i < vm.aideconfig.groups.length; i++) {
          if (vm.newaide.ginclude[i] === true) {
            tmpa = tmpa.concat(vm.aideconfig.groups[i].values);
          }
        }
        vm.autoselectedvalues = uniq(flattenArray(tmpa));
        joinValues();
      }

      function joinValues() {
        var tmpa = [];
        if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.newaide.additionalvalues)) {
          tmpa = vm.autoselectedvalues.concat(flattenArray(vm.newaide.additionalvalues));
        } else {
          if (angular.isArray(vm.autoselectedvalues)) {
            tmpa = vm.autoselectedvalues;
          }
          if (angular.isArray(vm.newaide.additionalvalues)) {
            tmpa = flattenArray(vm.newaide.additionalvalues);
          }
        }
        vm.newaide.allvalues = uniq(tmpa);
      }

      function flattenArray(a) {
        var tmpa = [];
        if (angular.isArray(a)) {
          for (var i = 0; i < a.length; i++) {
            tmpa.push(a[i].name);
          }
        }
        return tmpa;
      }

      // make array values uniq
      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        // ngtags needs a promise as input
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.aideconfig.values);
          reject();
        });
        return promise.then(function (values) {
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          $log.debug('filtered values: ', filteredValues);
          return filteredValues;
        });
      }

      // reset ref form
      function initNewRef() {
        vm.newaide = {};
        vm.newaide.type = 'aide';
        vm.newaide.refdate = '';
        vm.newaide.ginclude = [];
        vm.newaide.additionalvalues = [];
        if (angular.isDefined(vm.consultid)) {
          vm.newaide.consultid = vm.consultid;
        }
        if (angular.isDefined(vm.patient)) {
          vm.newaide.patient = {};
          vm.newaide.patient.svdata = vm.patient.svdata;
          vm.newaide.patientid = vm.patient._id;
          vm.newaide.patient._id = vm.patient._id;
          vm.newaide.patient.primarycontact = vm.patient.primarycontact;
        }
      }

      // save referral doctor
      function saveDoctor(doctor) {
        delete vm.newaide.to;
        vm.newaide.doctor = doctor;
      }

      // clear referral doctor
      function clearDoctor() {
        delete vm.newaide.doctor;
      }

      // save patient data
      function savePatient(client, mode) {
        $log.debug('patient in savePAtient: ', client, mode);
        delete vm.newaide.patient;
        vm.patient = client;
        vm.patientid = client._id;
        vm.newaide.patient = {};
        vm.newaide.patient.fname = vm.patient.primarycontact.firstname + ' ' + vm.patient.primarycontact.lastname;
        vm.newaide.patient.svdata = vm.patient.svdata;
        vm.newaide.patientid = vm.patient._id;
        vm.newaide.patient._id = vm.patient._id;
        vm.newaide.patient.primarycontact = vm.patient.primarycontact;
      }

      // clear patient
      function clearPatient() {
        delete vm.newaide.patient;
        delete vm.newaide.patientid;
      }

      function add() {
        Patdocs.$create(vm.newaide).$then(function () {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          initNewRef();
          $timeout(function () {
            vm.saved = false;
            if (angular.isDefined(vm.modal)) {
              vm.modal.close();
            }
          }, 2000);
        }, function (err) {
          vm.savefailed = true;
          $log.error('adding single aide failed: ', err);
          $timeout(function () {
            vm.savefailed = false;
          }, 3000);
        });
      }

      function cancel() {
        vm.saved = false;
        vm.canceled = true;
        vm.savefailed = false;
        initNewRef();
        $timeout(function () {
          vm.canceled = false;
          if (angular.isDefined(vm.modal)) {
            vm.modal.close();
          }
        }, 1500);
      }

      function print() {
        Patdocs.$create(vm.newaide).$then(function (aide) {
          vm.saved = true;
          vm.savefailed = false;
          vm.canceled = false;
          $timeout(function () {
            vm.saved = false;
          }, 2000);
          initNewRef();
          $log.debug('aide returned: ', aide);
          PrintHelper.aideSinglePrint(aide._id, vm.patientid).then(function () {
            $log.debug('printing single aide succeeded');
            vm.printed = true;
            $timeout(function () {
              delete vm.printed;
            }, 2000);
          }, function (err) {
            vm.printed = false;
            $timeout(function () {
              delete vm.printed;
            }, 3000);
            $log.error('printing single aide failed: ', err);
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('labvalueconfig', {
    restrict: 'E',
    bindings: {},
    templateUrl: 'vcpatdocs/labvalueconfig-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', '$timeout', function ($log, Config, Rlog, $timeout) {
      var vm = this;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };
      vm.saveConfig = saveConfig;
      vm.loadValues = loadValues;
      vm.addGroup = addGroup;
      vm.removeGroup = removeGroup;
      vm.saveConfig = saveConfig;

      vm.$onInit = function () {
        //  get labvalues and groups from config
        Config.$find('labconfiguration').$then(function (labconfig) {
          if (!labconfig.hasOwnProperty('_id')) {
            labconfig._id = 'labconfiguration';
          }
          if (!labconfig.hasOwnProperty('groups')) {
            labconfig.groups = [];
          }
          if (!labconfig.hasOwnProperty('values')) {
            labconfig.values = [];
          }
          vm.labconfig = labconfig;
        }, function (error) {
          $log.error('Loading of labconfiguration failed');
          Rlog.error('patdocs', 'labvalueconfig', 'labconfiguration.$find() failed', { id: 'labconfiguration' });
        });
      }; // $onInit()

      function addGroup() {
        // vm.labconfig.groups.push({name: vm.newgroup, values: []});
        vm.labconfig.groups.splice(0, 0, { name: vm.newgroup, values: [] });
        vm.labconfig.groups.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        vm.newgroup = '';
        vm.saveConfig();
      }

      function removeGroup(index) {
        vm.labconfig.groups.splice(index, 1);
        vm.saveConfig();
      }

      function saveConfig() {
        var changedgroups = [];

        vm.labconfig.values = uniq(vm.labconfig.values);
        for (var i = 0; i < vm.labconfig.groups.length; i++) {
          changedgroups.push({
            name: vm.labconfig.groups[i].name,
            values: uniq(vm.labconfig.groups[i].values)
          });
        }
        vm.labconfig.groups = changedgroups;
        vm.labconfig.$save();
      }

      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.labconfig.values);
        });
        return promise.then(function (values) {
          $log.debug('promise values: ', values);
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          console.log('filtered values: ', filteredValues);
          return filteredValues;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('labreferral', {
    restrict: 'E',
    bindings: {
      parentsave: '&',
      reset: '<'
    },
    templateUrl: 'vcpatdocs/labreferral-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', '$timeout', function ($log, Config, Rlog, $timeout) {
      var vm = this;

      vm.loadValues = loadValues;
      vm.toggleGroup = toggleGroup;
      vm.joinValues = joinValues;
      vm.flattenArray = flattenArray;
      vm.deleteLabVal = deleteLabVal;
      vm.undeleteLabVal = undeleteLabVal;

      vm.$onInit = function () {
        // reset/initialise resultset
        reset();
        //  get labvalues and groups from config
        Config.$find('labconfiguration').$then(function (labconfig) {
          vm.labconfig = labconfig;
        }, function (error) {
          Rlog.error('patdocs', 'newref', 'labconfiguration.$find() failed', { id: vm.clientid });
          $log.error('labconfiguration.$find() failed', error);
        });
      }; // $onInit()

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.reset)) {
            reset();
          }
        }
      };

      function reset() {
        vm.labvalues = [];
        vm.allvalues = [];
        vm.ginclude = [];
        vm.selectedGroups = [];
        vm.deleteList = [];
        vm.additionalvalues = [];
      }

      function toggleGroup() {
        var tmpa = [];
        vm.selectedGroups = [];
        for (var i = 0; i < vm.labconfig.groups.length; i++) {
          if (vm.ginclude[i] === true) {
            tmpa = tmpa.concat(vm.labconfig.groups[i].values);
            vm.selectedGroups.push(vm.labconfig.groups[i]);
            cleanSelectedGroups();
          }
        }

        vm.autoselectedvalues = uniq(flattenArray(tmpa));
        joinValues();
      }

      function deleteLabVal(tag) {
        vm.deleteList.push(tag);
        cleanSelectedGroups();
      }

      function undeleteLabVal(tag) {
        joinValues();
        cleanSelectedGroups();
      }

      function cleanSelectedGroups() {
        vm.cleanGroups = [];
        vm.selectedGroups.map(function (group) {
          vm.cleanGroups.push({
            name: group.name, values: flattenArray(group.values).filter(function (e) {
              return this.indexOf(e) < 0;
            }, flattenArray2(vm.deleteList))
          });
        });
        if (angular.isDefined(vm.additionalvalues) && vm.additionalvalues.length > 0) {
          vm.cleanGroups.push({
            name: 'Weiters', values: flattenArray(vm.additionalvalues).filter(function (e) {
              return this.indexOf(e) < 0;
            }, flattenArray2(vm.deleteList))
          });
        }
        $log.debug('vm.cleanGroups: ', vm.cleanGroups);
      }

      function joinValues() {
        var tmpa = [];
        if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.additionalvalues)) {
          tmpa = vm.autoselectedvalues.concat(flattenArray(vm.additionalvalues));
        } else {
          if (angular.isArray(vm.autoselectedvalues)) {
            tmpa = vm.autoselectedvalues;
          }
          if (angular.isArray(vm.additionalvalues)) {
            tmpa = flattenArray(vm.additionalvalues);
          }
        }
        vm.allvalues = uniq(tmpa);
        $log.debug('joinValues vm.allvalues:', vm.allvalues);
        // vm.deleteList =

        vm.filtered = vm.allvalues.filter(function (e) {
          return this.indexOf(e) < 0;
        }, flattenArray2(vm.deleteList));

        cleanSelectedGroups();

        // vm.parentsave({allvalues: vm.allvalues, ginclude: vm.ginclude, additionalvalues: vm.additionalvalues});
        vm.parentsave({ allvalues: flattenArray2(vm.filtered), ginclude: vm.ginclude, additionalvalues: vm.additionalvalues, cleangroups: vm.cleanGroups });
      }

      function flattenArray(a) {
        var tmpa = [];
        if (angular.isArray(a)) {
          for (var i = 0; i < a.length; i++) {
            tmpa.push(a[i].name);
          }
        }
        return tmpa;
      }

      function flattenArray2(a) {
        var tmpa = [];
        if (angular.isArray(a)) {
          for (var i = 0; i < a.length; i++) {
            tmpa.push(a[i].text);
          }
        }
        return tmpa;
      }

      // make array values uniq
      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        // ngtags needs a promise as input
        // eslint-disable-next-line no-unused-vars
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.labconfig.values);
        });
        return promise.then(function (values) {
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          $log.debug('filtered values: ', filteredValues);
          return filteredValues;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('imagingreferral', {
    restrict: 'E',
    bindings: {
      parentsave: '&',
      reset: '<'
    },
    templateUrl: 'vcpatdocs/imagingreferral-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', '$timeout', function ($log, Config, Rlog, $timeout) {
      var vm = this;

      vm.loadValues = loadValues;
      vm.toggleGroup = toggleGroup;
      vm.joinValues = joinValues;
      vm.flattenArray = flattenArray;

      vm.$onInit = function () {
        // reset/initialise resultset
        reset();
        //  get imagingvalues and groups from config
        Config.$find('imagingconfiguration').$then(function (imagingconfig) {
          vm.imagingconfig = imagingconfig;
        }, function (error) {
          Rlog.error('patdocs', 'newref', 'imagingconfiguration.$find() failed', { id: 'imagingconfiguration' });
        });
      }; // $onInit()

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.reset)) {
            reset();
          }
        }
      };

      function reset() {
        vm.imagingvalues = [];
        vm.allvalues = [];
        vm.ginclude = [];
        vm.additionalvalues = [];
      }

      function toggleGroup() {
        var tmpa = [];
        for (var i = 0; i < vm.imagingconfig.groups.length; i++) {
          if (vm.ginclude[i] === true) {
            tmpa = tmpa.concat(vm.imagingconfig.groups[i].values);
          }
        }
        vm.autoselectedvalues = uniq(flattenArray(tmpa));
        joinValues();
      }

      function joinValues() {
        var tmpa = [];
        if (angular.isArray(vm.autoselectedvalues) && angular.isArray(vm.additionalvalues)) {
          tmpa = vm.autoselectedvalues.concat(flattenArray(vm.additionalvalues));
        } else {
          if (angular.isArray(vm.autoselectedvalues)) {
            tmpa = vm.autoselectedvalues;
          }
          if (angular.isArray(vm.additionalvalues)) {
            tmpa = flattenArray(vm.additionalvalues);
          }
        }
        vm.allvalues = uniq(tmpa);
        vm.parentsave({ allvalues: vm.allvalues, ginclude: vm.ginclude, additionalvalues: vm.additionalvalues });
      }

      function flattenArray(a) {
        var tmpa = [];
        if (angular.isArray(a)) {
          for (var i = 0; i < a.length; i++) {
            tmpa.push(a[i].name);
          }
        }
        return tmpa;
      }

      // make array values uniq
      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        // ngtags needs a promise as input
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.imagingconfig.values);
        });
        return promise.then(function (values) {
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          $log.debug('filtered values: ', filteredValues);
          return filteredValues;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('imagingconfig', {
    restrict: 'E',
    bindings: {},
    templateUrl: 'vcpatdocs/imagingconfig-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', '$timeout', function ($log, Config, Rlog, $timeout) {
      var vm = this;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };
      vm.saveConfig = saveConfig;
      vm.loadValues = loadValues;
      vm.addGroup = addGroup;
      vm.removeGroup = removeGroup;
      vm.saveConfig = saveConfig;

      vm.$onInit = function () {
        //  get imagings and groups from config
        Config.$find('imagingconfiguration').$then(function (imagingconfig) {
          if (!imagingconfig.hasOwnProperty('_id')) {
            imagingconfig._id = 'imagingconfiguration';
          }
          if (!imagingconfig.hasOwnProperty('groups')) {
            imagingconfig.groups = [];
          }
          if (!imagingconfig.hasOwnProperty('values')) {
            imagingconfig.values = [];
          }
          vm.imagingconfig = imagingconfig;
        }, function (error) {
          $log.error('Loading of imagingconfiguration failed');
          Rlog.error('patdocs', 'imagingconfig', 'imagingconfiguration.$find() failed', { id: 'imagingconfiguration' });
        });
      }; // $onInit()

      function addGroup() {
        // vm.imagingconfig.groups.push({name: vm.newgroup, values: []});
        vm.imagingconfig.groups.splice(0, 0, { name: vm.newgroup, values: [] });
        vm.newgroup = '';
        vm.saveConfig();
      }

      function removeGroup(index) {
        vm.imagingconfig.groups.splice(index, 1);
        vm.saveConfig();
      }

      function saveConfig() {
        var changedgroups = [];

        vm.imagingconfig.values = uniq(vm.imagingconfig.values);
        for (var i = 0; i < vm.imagingconfig.groups.length; i++) {
          changedgroups.push({
            name: vm.imagingconfig.groups[i].name,
            values: uniq(vm.imagingconfig.groups[i].values)
          });
        }
        vm.imagingconfig.groups = changedgroups;
        vm.imagingconfig.$save();
      }

      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.imagingconfig.values);
        });
        return promise.then(function (values) {
          $log.debug('promise values: ', values);
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          console.log('filtered values: ', filteredValues);
          return filteredValues;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of patdocss (patients) to display or load patdocss */

'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('aidelist', {
    restrict: 'E',
    bindings: {
      consultid: '<?'
    },
    template: '\n        <div ng-show="vm.aides.length === 0" class="alert alert-info"><h4>Es wurden noch keine Verordnungen angelegt.</h4></div>\n        <div ng-show="vm.aides.length > 0">\n        <h2>Bestehende Hilfsmittelverordnungen</h2>\n        <div ng-repeat="aide in vm.aides">\n          <div class="row">\n            <div class="col-sm-11"><h4>Überweisung</h4></div>\n            <div class="col-sm-1">\n              <button class="btn btn-danger" ng-click="vm.removeReferral(aide)" uib-tooltip="Verordnung löschen">\n                <i class="fa fa-remove"></i>\n              </button>\n            </div>\n          </div>\n        \n          <div class="row">\n            <div class="col-xs-12">\n              <dl class="dl-horizontal">\n                <dt>An/zu</dt>\n                <dd ng-bind="aide.to"></dd>\n                <dt>Diagnose</dt>\n                <dd ng-bind="aide.diag"></dd>\n                <dt>Verordnung</dt>\n                <dd>\n                    <p ng-repeat="aide in aide.allvalues">{{aide}}</p>\n                    <p>{{aide.aide}}</p>\n                </dd>\n                <dt>Datum</dt>\n                <dd ng-bind="aide.refdate"></dd>\n              </dl>\n            </div>\n          </div>\n        </div>\n        \n        <!-- PDF Vorschau -->\n        <a class="btn btn-info" target="_blank" ng-show="vm.aides.length"\n           href="{{vm.previewurl}}">\n          <i class="fa fa-eye"></i> PDF Vorschau\n        </a>\n        <div style="min-height:3cm">&nbsp;</div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Patdocs', 'PatdocsHelper', 'vertxEventBusService', 'PrintHelper', function ($log, $http, Rlog, Patdocs, PatdocsHelper, vertxEventBusService, PrintHelper) {
      var vm = this;
      vm.removeReferral = removeReferral;

      vm.getPreviewUrl = getPreviewUrl;

      function getPreviewUrl() {
        PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
      }

      vm.$onInit = function () {

        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.patdocss)) {
          vm.patdocss = Patdocs.$search();
        }
      }; // $onInit()

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0) {
            vm.consultid = changes.consultid.currentValue;
            Patdocs.$search({ consultid: vm.consultid, active: true, type: 'aide' }).$then(function (aides) {
              vm.aides = aides;
              if (aides.length > 0) {
                vm.previewurl = PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
              }
            }, function (err) {
              $log.error('aides lookup failed: ', vm.consultid);
              Rlog.error('patdocs', 'aidelist', 'aide lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      function removeReferral(ref) {
        ref.active = false;
        ref.$save();
      }

      var patdocsUpdateHandler = function patdocsUpdateHandler(message) {
        if (angular.isDefined(vm.aides)) {
          vm.aides.$refresh().$then(function (aides) {
            vm.previewurl = PrintHelper.aidePreviewUrl(aides[0].patientid, vm.consultid);
            $log.debug('debug: aidelist refreshed patdocss');
          }, function (error) {
            $log.debug('debug: aidelist refresh patdocs failed: ', error);
          });
        }
      };

      vertxEventBusService.on('patdocs.update', {}, patdocsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdocs.update', {}, patdocsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('aidecounter', {
    restrict: 'E',
    bindings: {
      consultid: '<'
    },
    template: '\n        <span class="badge" ng-bind="vm.counter"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Patdocs', 'Rlog', 'vertxEventBusService', '$http', function ($log, Patdocs, Rlog, vertxEventBusService, $http) {
      var vm = this;
      var getCounter = function getCounter() {
        var query = [{
          $match: {
            consultid: vm.consultid,
            type: 'aide',
            active: true
          }
        }, {
          $group: {
            _id: 'aidecounter',
            counter: { $sum: 1 }
          }
        }];

        $http.post('/routes/patdocs/aggregate', query).then(function (res) {
          vm.counter = 0;
          if (res.data.counter) {
            vm.counter = res.data.counter;
          }
        }, function (err) {
          $log.error(err);
          Rlog.error('patdocs', 'refcounter', 'refcounter.$aggregate failed', {});
        });
      };

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue)) {
            vm.consultid = changes.consultid.currentValue;
            getCounter();
          }
        }
      };

      // listen for patdocs updates
      vertxEventBusService.on('patdocs.update', {}, getCounter);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdocs.update', {}, getCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcpatdocs').component('aideconfig', {
    restrict: 'E',
    bindings: {},
    templateUrl: 'vcpatdocs/aideconfig-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', '$timeout', function ($log, Config, Rlog, $timeout) {
      var vm = this;

      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };
      vm.saveConfig = saveConfig;
      vm.loadValues = loadValues;
      vm.addGroup = addGroup;
      vm.removeGroup = removeGroup;
      vm.saveConfig = saveConfig;

      vm.$onInit = function () {
        //  get aides and groups from config
        Config.$find('aideconfiguration').$then(function (aideconfig) {
          if (!aideconfig.hasOwnProperty('_id')) {
            aideconfig._id = 'aideconfiguration';
          }
          if (!aideconfig.hasOwnProperty('groups')) {
            aideconfig.groups = [];
          }
          if (!aideconfig.hasOwnProperty('values')) {
            aideconfig.values = [];
          }
          vm.aideconfig = aideconfig;
        }, function (error) {
          $log.error('Loading of aideconfiguration failed');
          Rlog.error('patdocs', 'aideconfig', 'aideconfiguration.$find() failed', { id: 'aideconfiguration' });
        });
      }; // $onInit()

      function addGroup() {
        // vm.aideconfig.groups.push({name: vm.newgroup, values: []});
        vm.aideconfig.groups.splice(0, 0, { name: vm.newgroup, values: [] });
        vm.newgroup = '';
        vm.saveConfig();
      }

      function removeGroup(index) {
        vm.aideconfig.groups.splice(index, 1);
        vm.saveConfig();
      }

      function saveConfig() {
        var changedgroups = [];

        vm.aideconfig.values = uniq(vm.aideconfig.values);
        for (var i = 0; i < vm.aideconfig.groups.length; i++) {
          changedgroups.push({
            name: vm.aideconfig.groups[i].name,
            values: uniq(vm.aideconfig.groups[i].values)
          });
        }
        vm.aideconfig.groups = changedgroups;
        vm.aideconfig.$save();
      }

      function uniq(a) {
        return a.sort().filter(function (item, pos, ary) {
          return !pos || item !== ary[pos - 1];
        });
      }

      // load and filter autocomplete values
      function loadValues($query) {
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.aideconfig.values);
        });
        return promise.then(function (values) {
          $log.debug('promise values: ', values);
          var filteredValues = values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
          console.log('filtered values: ', filteredValues);
          return filteredValues;
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name finance
   * @description
   *
   */
  angular.module('vcfinance', ['vcfinance.closing', 'vcfinance.rksv', 'vcfinance.cashbook', 'vcfinance.invoice', 'vcfinance.bmfexport', 'vcfinance.unicat', 'vcfinance.privcat', 'vcfinance.cart', 'vcfinance.turnover']);

  angular.module('vcfinance').filter('datetime', function () {
    return function (dateString) {
      return moment(dateString).locale('de-at').format('lll');
    };
  });

  //  Klammerfriedhof
})();
/**
 * Created by lari on 09/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name examtemplate
   * @description
   *
   */
  angular.module('vcexamtemplate', ['ui.router', 'ui.tree', 'ui.bootstrap', 'ngTagsInput', 'vcfinance.privcat', 'vctracker']);
})();
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexamtemplate').component('fieldgroupname', {
    restrict: 'E',
    bindings: {
      fgname: '=',
      ondone: '&'
    },
    template: '\n          <div class="input-group">\n            <span class="input-group-btn">\n              <button class="btn btn-danger" type="cancel" uib-tooltip="Abbrechen"  ng-click="vm.cancel()"><i class="fa fa-remove"></i></button>\n            </span>\n            <input type="text" ng-model="vm.tmpfgname" class="form-control" placeholder="Neuen Namen eingeben ...">\n            <span class="input-group-btn">\n              <button class="btn btn-success" type="submit" uib-tooltip="Kategorie/Feldgruppe umbenennen" ng-click="vm.save()"><i class="fa fa-check"></i></button>\n            </span>\n          </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.tmpfgname = angular.copy(vm.fgname);
        vm.lastfgname = angular.copy(vm.fgname);
      };

      function save() {
        if (!angular.equals(vm.tmpfgname, vm.lastfgname)) {
          vm.fgname = angular.copy(vm.tmpfgname);
          vm.ondone();
        }
      }

      function cancel() {
        vm.fgname = angular.copy(vm.lastfgname);
        vm.ondone();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcexamtemplate').component('examtemplatenew', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="examtemplatenew-component" data-hook="examtemplatenew-component">\n        <h3>Neue Untersuchungs-/Befundvorlage anlegen</h3>\n        <div class="btn btn-success" ng-click="vm.addExamtemplate()" ng-hide="vm.newexamtemplate">Neue Untersuchungs-/Befundvorlage anlegen</div>\n        <div ng-show="vm.newexamtemplate">\n          <examtemplateform examtemplate="vm.newexamtemplate" parentsave="vm.saveNewExamtemplate(examtemplate)" oncancel="vm.cancel()"></examtemplateform>\n        </div>\n        <div class="spacer-top"></div>\n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Untersuchungs-/Befundvorlage erfolgreich angelegt!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Untersuchungs-/Befundvorlage wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Untersuchungs-/Befundvorlage konnte nicht angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Examtemplate', 'Rlog', function ($log, Examtemplate, Rlog) {
      var vm = this;
      vm.addExamtemplate = addExamtemplate;
      vm.saveNewExamtemplate = saveNewExamtemplate;
      vm.cancel = cancel;

      function addExamtemplate() {
        vm.newexamtemplate = {
          template: {
            includefindings: false,
            loadfiles: false,
            layout: 'col' }
        };
        delete vm.created;
        delete vm.canceled;
      }

      function saveNewExamtemplate(examtemplate) {
        $log.debug('debug: create new examtemplate: ', examtemplate);
        delete vm.newexamtemplate;
        Examtemplate.$create(examtemplate).$then(function () {
          vm.created = true;
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new examtemplate failed: ', err);
          Rlog.error('vcutils.examtemplate', 'examtemplatenew', 'Creation of new examtemplate failed: ', { error: err, examtemplate: vm.newexamtemplate });
        });
      }

      function cancel() {
        delete vm.newexamtemplate;
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of examtemplates (patients) to display or load examtemplates */

'use strict';

(function () {
  'use strict';
  angular.module('vcexamtemplate').component('examtemplatelist', {
    restrict: 'E',
    bindings: {
      examtemplates: '<?'
    },
    template: '\n        <h3>Bestehende Befundvorlagen</h3>\n        <table class="table table-striped">\n          <tr>\n            <th width="10%">Ordnung</th>\n            <th width="10%">Kürzel</th>\n            <th width="50%">Name</th>\n            <th width="10%">Typ</th>\n            <th width="10%">Aktiv</th>\n            <th width="15%">Aktion</th>\n          </tr>\n          <tr ng-repeat="t in vm.examtemplates | orderBy :template.nr">\n            <td><input class="form-control" type="number" ng-model="t.template.nr" ng-blur="vm.saveTemplate(t)"/> </td>\n            <td ng-bind="t.template.type"></td>\n            <td ng-bind="t.template.displayname"></td>\n            <td>\n                <span ng-show="t.template.includefindings === true" uib-tooltip="Befund wird im Gesamtbefund inkludiert"><i class="fa fa-file-text-o"></i></span>\n                <span ng-show="t.template.includefindings === false" uib-tooltip="Befund wird als seperate Datei erstellt"><i class="fa fa-files-o"></i></span>\n            </td>\n            <td>\n              <div class="btn"\n                   ng-class="t.active ? \'btn-success\' : \'btn-danger\'"\n                   ng-model="t.active"\n                   ng-click="vm.toggleActive(t)"\n                   uib-tooltip="Status ändern">\n                <span ng-show="t.active == true">Aktiv</span>\n                <span ng-show="t.active == false">Nicht aktiv</span>\n              </div>\n            </td>\n            <td>\n              <div class="btn btn-primary"\n                   ng-click="vm.editTemplate(t)"\n                   uib-tooltip="Editieren"><i class="fa fa-edit"></i>\n              </div>\n              <div class="btn btn-primary"\n                   ng-click="vm.testTemplate(t)"\n                   uib-tooltip="Ausprobieren"><i class="fa fa-eye"></i>\n              </div>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Examtemplate', 'ExamtemplateHelper', 'vertxEventBusService', 'Exam', 'ExamHelper', function ($log, $http, Rlog, Examtemplate, ExamtemplateHelper, vertxEventBusService, Exam, ExamHelper) {
      var vm = this;
      vm.editExamtemplate = ExamtemplateHelper.editExamtemplate;
      vm.toggleActive = toggleActive;
      vm.editTemplate = ExamtemplateHelper.editExamtemplate;
      vm.testTemplate = testTemplate;
      vm.saveTemplate = saveTemplate;

      vm.$onInit = function () {
        // unless examtemplates list has been passed for test purposes, retrieve examtemplates list from web
        if (angular.isUndefined(vm.examtemplates)) {
          vm.examtemplates = Examtemplate.$search();
        }
      }; // $onInit()

      function toggleActive(examtemplate) {
        examtemplate.active = !examtemplate.active;
        examtemplate.$save();
      }

      function testTemplate(template) {
        $http.get('/routes/patients/sampledata/').then(function (pat) {
          startSampleExam(pat.data, template);
        }, function (err) {
          $log.error('Loading of sampledata patient failed', err);
        });
      }

      function saveTemplate(template) {
        template.$save().$then(function (res) {}, function (err) {
          return $log.info('failed to save templ: ', err);
        });
      }

      function startSampleExam(pat, et) {
        var newexam = {};
        newexam.templateid = et._id;
        newexam.print = true;
        newexam.patientid = pat._id;
        newexam.clientid = pat._id;
        newexam.consultid = '1234';
        newexam.patlastname = pat.primarycontact.lastname;
        newexam.patfirstname = pat.primarycontact.firstname;
        newexam.templateid = et._id;
        newexam.template = angular.copy(et.template);
        newexam.type = et.template.displayname;
        newexam.test = true;
        newexam.fdate = moment().locale('de-at').format('ll');
        $log.debug('Newexam before insert: ', newexam);
        Exam.$create(newexam).$then(function (exam) {
          $log.debug('exam for template test sucessfully created: ', exam);
          ExamHelper.editSampleExam(exam);
        }, function (err) {
          $log.error('exam creation for template test failes: ', err);
        });
      }

      var etUpdateHandler = function etUpdateHandler(message) {
        $log.debug('debug: examtemplate update received: ', message);
        if (angular.isDefined(vm.examtemplates)) {
          vm.examtemplates.$refresh().$then(function () {
            $log.debug('debug: examtemplatelist refreshed examtemplates');
          }, function (error) {
            $log.debug('debug: examtemplatelist refresh examtemplates failed: ', error);
          });
        }
      };

      vertxEventBusService.on('examtemplates.update', {}, etUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('examtemplates.update', {}, etUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexamtemplate').component('examtemplateform', {
    restrict: 'E',
    bindings: {
      examtemplate: '<',
      parentsave: '&',
      oncancel: '&'
    },
    templateUrl: 'vcexamtemplate/examtemplateform-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$timeout', 'Config', 'Share', function ($log, $timeout, Config, Share) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;
      vm.newSubItem = newSubItem;
      vm.newFieldGroup = newFieldGroup;
      vm.remove = remove;
      vm.addNamedField = addNamedField;
      vm.removeNamedField = removeNamedField;
      vm.toggle = toggle;
      vm.showFGN = showFGN;
      vm.hideFGN = hideFGN;
      vm.addCatItem = addCatItem;
      vm.addCatGroup = addCatGroup;
      vm.removeCatItem = removeCatItem;
      vm.removeCatGroup = removeCatGroup;
      vm.addTracker = addTracker;
      vm.removeTracker = removeTracker;

      vm.modalitypes = [];
      vm.modalitypes.push({ type: 'US', text: 'Ultraschall' });
      vm.modalitypes.push({ type: 'CD', text: 'Color flow doppler' });
      vm.modalitypes.push({ type: 'DD', text: 'Duplex Doppler' });
      vm.modalitypes.push({ type: 'CR', text: 'Computergeschützte Radiologie' });
      vm.modalitypes.push({ type: 'XR', text: 'Digitale Radiographie' });
      vm.modalitypes.push({ type: 'XR', text: 'Intraorale Radiographie' });
      vm.modalitypes.push({ type: 'CT', text: 'Coputertomographie' });
      vm.modalitypes.push({ type: 'MR', text: 'Magnetresonanztomographie' });
      vm.modalitypes.push({ type: 'ES', text: 'Endoskopie' });
      vm.modalitypes.push({ type: 'AU', text: 'Audio ECG' });

      /*        Complete list of allowed dicom modality tytpes
                CR 	Computed Radiography
                CT 	Computed Tomography
                MR 	Magnetic Resonance
                US 	Ultrasound
                OT 	Other
                BI 	Biomagnetic imaging
                CD 	Color flow Doppler
                DD 	Duplex Doppler
                DG 	Diaphanography
                ES 	Endoscopy
                LS 	Laser surface scan
                PT 	Positron emission tomography (PET)
                RG 	Radiographic imaging (conventional film/screen)
                ST 	Single-photon emission computed tomography (SPECT)
                TG 	Thermography
                XA 	X-Ray Angiography
                RF 	Radio Fluoroscopy
                RTIMAGE 	Radiotherapy Image
                RTDOSE 	Radiotherapy Dose
                RTSTRUCT 	Radiotherapy Structure Set
                RTPLAN 	Radiotherapy Plan
                RTRECORD 	RT Treatment Record
                HC 	Hard Copy
                DX 	Digital Radiography
                NM 	Nuclear Medicine
                MG 	Mammography
                IO 	Intra-oral Radiography
                PX 	Panoramic X-Ray
                GM 	General Microscopy
                SM 	Slide Microscopy
                XC 	External-camera Photography
                PR 	Presentation State
                AU 	Audio ECG
                EPS 	Cardiac Electrophysiology
                HD 	Hemodynamic Waveform
                SR 	SR Document
                IVUS 	Intravascular Ultrasound
                OP 	Ophthalmic Photography
                SMR 	Stereometric Relationship*/

      vm.$onInit = function () {
        vm.fgnshow = [];
        vm.lastexamtemplate = angular.copy(vm.examtemplate);

        Config.$find('dicomaetitle').$then(function (dicomaetitle) {
          vm.dicomaetitle = dicomaetitle;
          // intialize if still empty
          if (angular.isUndefined(vm.dicomaetitle.dicomaetitle)) {
            vm.dicomerror = 'Es wurden keine DICOM Geräte konfiguriert: Menü Einstellungen -> Dicom ';
          }
        });

        Config.$find('gdtsoftware').$then(function (gdtsoftware) {
          vm.gdtsoftware = gdtsoftware;
          // intialize if still empty
          if (angular.isUndefined(vm.gdtsoftware.gdtsoftware)) {
            vm.gdtswerror = 'Es wurden keine GDT Software konfiguriert: Menü Einstellungen -> GDT Software ';
          }
        });

        Config.$find('gdtprofil').$then(function (gdtprofil) {
          vm.gdtprofil = gdtprofil;
          // intialize if still empty
          if (angular.isUndefined(vm.gdtprofil.gdtprofil)) {
            vm.gdtperror = 'Es wurde kein GDT Profil konfiguriert: Menü Einstellungen -> GDT Profile ';
          }
        });

        Share.$search().$then(function (shares) {
          if (shares.length === 0) {
            vm.shareserror = 'Es wurden keine Netzlaufwerke konfiguriert: Menü Einstellungen -> Netzlaufwerke / GDT ';
          }
          vm.allshares = shares;
          vm.gdtshares = shares.filter(function (share) {
            return angular.isDefined(share.sharetype) && share.sharetype === 'gdt';
          });
          if (vm.gdtshares.length === 0) {
            vm.gdtswerror = 'Es wurde keine GDT Software konfiguriert: Menü Einstellungen -> Netzlaufwerke / GDT ';
          }
        });
      };

      function save() {
        if (!angular.equals(vm.examtemplate, vm.lastexamtemplate)) {
          vm.lastexamtemplate = angular.copy(vm.examtemplate);
          vm.parentsave({ examtemplate: vm.examtemplate });
        }
      }

      function cancel() {
        vm.examtemplate = angular.copy(vm.lastexamtemplate);
        vm.oncancel();
      }

      function showFGN(index) {
        vm.fgnshow[index] = true;
      }

      function hideFGN(index) {
        vm.fgnshow[index] = false;
      }

      function newFieldGroup() {
        if (angular.isUndefined(vm.examtemplate.template.fieldgroups) || !angular.isArray(vm.examtemplate.template.fieldgroups)) {
          vm.examtemplate.template.fieldgroups = [];
        }
        vm.examtemplate.template.fieldgroups.push({
          label: 'Neue Feldgruppe',
          fields: [{
            label: 'Neues Feld',
            avalues: [],
            values: []
          }]
        });
      }

      function newSubItem(scope) {
        var nodeData = scope.$modelValue;
        if (angular.isUndefined(nodeData.fields) || !angular.isArray(nodeData.fields)) {
          nodeData.fields = [];
        }
        nodeData.fields.push({
          label: 'Neues Feld',
          avalues: [],
          values: []
        });
      }

      function remove(scope) {
        scope.remove();
        $timeout(function () {
          vm.examtemplate.$save();
        }, 500);
        // vm.examtemplate.$save();
      }

      function addNamedField(type) {
        var labels = {
          comment: 'Kommentar',
          biopsy: 'Biopsie',
          recommendation: 'Empfehlung',
          diagnosis: 'Zusammenfassung'
        };
        var biopsy = {
          label: '',
          avalues: [],
          values: []
        };
        vm.examtemplate.template[type] = {
          label: labels[type],
          avalues: [],
          values: []
        };
        if (type === 'biopsy') {
          vm.examtemplate.template[type].biopsies = [];
          vm.examtemplate.template[type].biopsies.push(biopsy);
        }
        vm.examtemplate.$save();
      }

      function removeNamedField(type) {
        delete vm.examtemplate.template[type];
        vm.examtemplate.$save();
      }

      function toggle(scope) {
        scope.toggle();
      }

      // search can return both item or group
      function addCatItem(privcat, privcatref) {
        if (privcat.type === 'entry') {
          checkServiceStructure();
          delete privcat.price;
          delete privcat.price;
          vm.examtemplate.template.services.items.push(privcat);
        } else {
          addCatGroup(privcat, privcatref);
        }
      }

      // group picker always returns group
      function addCatGroup(privcat, privcatref) {
        checkServiceStructure();
        vm.examtemplate.template.services.groups.push(privcat);
      }

      function removeCatItem(index) {
        vm.examtemplate.template.services.items.splice(index, 1);
      }

      function removeCatGroup(index) {
        vm.examtemplate.template.services.groups.splice(index, 1);
      }

      function checkServiceStructure() {
        if (angular.isUndefined(vm.examtemplate.template.services)) {
          vm.examtemplate.template.services = {};
          vm.examtemplate.template.services.items = [];
          vm.examtemplate.template.services.groups = [];
        }
      }

      function addTracker(tracker) {
        if (angular.isUndefined(vm.examtemplate.template.trackers)) {
          vm.examtemplate.template.trackers = [];
        }
        vm.examtemplate.template.trackers.push(tracker);
      }

      function removeTracker(index) {
        vm.examtemplate.template.trackers.splice(index, 1);
      }

      vm.sprlayout = 'Sie können zwischen spalten- und zeilenorientiertem Layout wählen. \n             Das spaltenorientierte Layout eignet sich für Befunde die ein kurzes Schlagwort (z.B. "Leber") \n             mit längeren Ausführungen kombinieren. Das zeilenorientierte Layout eignet sich, wenn Sie längere \n             Erklärungstexte (z.B. Patientenfragebögen) mit kurzen oder auch längeren Antworten abbilden möchten. \n             Sie können das Layout jederzeit umstellen, die Änderung wirkt sich allerdings nur auf die \n             nachfolgenden Aufrufe aus.';
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcexamtemplate').component('examtemplateeditor', {
    restrict: 'E',
    bindings: {
      examtemplate: '<?',
      examtemplateid: '<?'
    },
    template: '\n        <examtemplateform examtemplate="vm.examtemplate" parentsave="vm.childsave(examtemplate)" oncancel="vm.oncancel()">\n        <div ng-show="vm.saved === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> examtemplate erfolgreich gespeichert!</h3>\n        </div>\n        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">\n          <h3><i class="fa fa-info"></i> Das Anlegen einer/s neuen examtemplate wurde abgebrochen!</h3>\n        </div>\n        <div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> examtemplate konnte nicht gespeichert werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Examtemplate', 'Rlog', function ($log, Examtemplate, Rlog) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;

      vm.$onInit = function () {
        if ((angular.isUndefined(vm.examtemplate) || !vm.examtemplate.hasOwnProperty('_id')) && angular.isDefined(vm.examtemplateid)) {
          Examtemplate.$find(vm.examtemplateid).$then(function (examtemplate) {
            vm.examtemplate = examtemplate;
          }, function (err) {
            $log.error('examtemplate not found, id: ', vm.examtemplateid);
            Rlog.error('examtemplate', 'examtemplateeditor', 'examtemplate not found', { _id: vm.examtemplateid });
          });
        }
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.examtemplateid) && angular.isDefined(changes.examtemplateid.currentValue) && changes.examtemplateid.currentValue.length > 0) {
          vm.examtemplateid = changes.examtemplate.currentValue;
          Examtemplate.$find(vm.examtemplateid).$then(function (examtemplate) {
            vm.examtemplate = examtemplate;
          }, function (err) {
            $log.error('examtemplate not found, id: ', vm.examtemplateid);
            Rlog.error('examtemplate', 'examtemplateeditor', 'examtemplate not found', { _id: vm.examtemplateid });
          });
        }
      };

      function childsave(examtemplate) {
        // vm.examtemplate = angular.copy(examtemplate);
        // the abouve code threw an restmod error, despite actually saving
        // the below variant does not raise an error
        for (var key in examtemplate) {
          if (examtemplate.hasOwnProperty(key)) {
            vm.examtemplate[key] = examtemplate[key];
          }
        }
        vm.save();
      }

      function save() {
        if (vm.examtemplate.$hasPendingActions()) {
          vm.examtemplate.$cancel();
          vm.examtemplate.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of examtemplate failed: ', err);
            Rlog.error('vcutils.examtemplate', 'examtemplateeditor', 'Saving of examtemplate failed: ', { error: err, examtemplateid: vm.examtemplate._id });
          });
        } else {
          vm.examtemplate.$save().$then(function () {
            vm.saved = true;
          }, function (err) {
            vm.saved = false;
            $log.error('saving of examtemplate failed: ', err);
            Rlog.error('vcutils.examtemplate', 'examtemplateeditor', 'Saving of examtemplate failed: ', { error: err, examtemplateid: vm.examtemplate._id });
          });
        }
      }

      function oncancel() {
        vm.canceled = true;
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcexamtemplate').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.examtemplate', {
      url: '/examtemplate',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;examtemplatenew&gt;</tt></h3><div ui-view="examtemplatenewview"></div>\n              <!--<h3 class="alert alert-info"><tt>&lt;examtemplateeditor examtemplate="" onClose=""&gt;</tt></h3><div ui-view="examtemplateeditview"></div>-->\n              <h3 class="alert alert-info"><tt>&lt;examtemplatelist examtemplates="?"&gt;</tt></h3><div ui-view="examtemplatelistview"></div>\n            '
        }
      },
      onEnter: function onEnter($log) {
        $log.debug('debug/routes - playground.vcexamtemplate entered');
      }
    });

    $stateProvider.state('playground.examtemplate.allcomponents', {
      url: '/allcomponents',
      resolve: {
        examtemplate: function examtemplate(ExamtemplateHelper) {
          return ExamtemplateHelper.getSampleTemplate();
        },
        examtemplateref: function examtemplateref() {
          return '';
        },
        someexamtemplate: function someexamtemplate(Examtemplate) {
          return Examtemplate.$find('572b31b07c01597e3e150923');
        },
        allexamtemplates: function allexamtemplates(Examtemplate) {
          return Examtemplate.$search();
        },
        parentsavesearch: function parentsavesearch() {
          return function (examtemplate, examtemplateref) {
            console.log('debug: dummy parentsave called for examtemplatesearch with: ', examtemplate, examtemplateref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        'examtemplatesearchview@playground.examtemplate': {
          component: 'examtemplatesearch',
          bindings: {
            examtemplate: 'examtemplate',
            examtemplateref: 'examtemplateref',
            editinplace: 'eip'
          }
        },
        'examtemplatenewview@playground.examtemplate': {
          component: 'examtemplatenew',
          bindings: {}
        }, /*,
           'examtemplateeditview@playground.examtemplate': {
            component: 'examtemplateeditor',
            bindings: {
              examtemplate: 'someexamtemplate'
            }
           },
           'examtemplatenewview@playground.examtemplate': {
            component: 'examtemplatenew',
            bindings: {
            }
           }*/
        'examtemplatelistview@playground.examtemplate': {
          component: 'examtemplatelist',
          bindings: {
            examtemplates: 'allexamtemplates'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.examtemplate.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcexamtemplate.factory:ExamtemplateHelper
   *
   * @description
   *
   */
  angular.module('vcexamtemplate').factory('ExamtemplateHelper', ExamtemplateHelper);

  ExamtemplateHelper.$inject = ['Examtemplate', '$uibModal', '$log', 'Rlog'];

  function ExamtemplateHelper(Examtemplate, $uibModal, $log, Rlog) {
    var ExamtemplateHelperBase = {};
    var sampletemplate = {
      type: 'newexam',
      displayname: 'Neue Untersuchung',
      device: { label: 'Ger&auml;t', name: '' },
      loadfiles: false,
      shareid: '',
      fieldgroups: [{
        label: 'Untersuchungsdaten',
        fields: [{ label: 'Untersuchender Arzt', avalues: [], values: [] }, { label: 'Assistenz', avalues: [], values: [] }, { label: 'Sedierung', avalues: [], values: [] }, { label: 'Narkose', avalues: [], values: [] }]
      }, {
        label: 'Feldgruppe1',
        fields: [{ label: 'Neues Feld', avalues: [], values: [] }, { label: 'Neues Feld', avalues: [], values: [] }]
      }, {
        label: 'Feldgruppe2',
        fields: [{ label: 'Neues Feld', avalues: [], values: [] }, { label: 'Neues Feld', avalues: [], values: [] }]
      }],
      biopsy: {
        label: 'Biopsien',
        values: [],
        biopsies: [{ label: '', avalues: [], values: [] }]
      },
      comment: { label: 'Anmerkungen', avalues: [], values: [] },
      diagnosis: { label: 'Zusammenfassung', avalues: [], values: [] },
      recommendation: { label: 'Empfehlung', avalues: [], values: [] }
    };
    ExamtemplateHelperBase.editExamtemplate = editExamtemplate;
    ExamtemplateHelperBase.addExamtemplate = addExamtemplate;
    ExamtemplateHelperBase.getSampleTemplate = getSampleTemplate;

    function addExamtemplate(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><examtemplateform examtemplate="vm.examtemplate" parentsave="vm.childsave(examtemplate)" oncancel="vm.cancel()"></examtemplatenew></div>',
        controllerAs: 'examtemplateaCtrl',
        controller: ['examtemplate', function () {
          var vm = this;
          vm.examtemplate = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(examtemplate) {
            Examtemplate.$create(examtemplate).$then(function (newexamtemplate) {
              vm.created = true;
              success(newexamtemplate);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ examtemplate-helper.addExamtemplate: ', err);
              Rlog.error('vcutils.examtemplate', 'examtemplate-helper.addExamtemplate', 'Creation of new SV failed: ', { error: err, examtemplate: examtemplate });
              error(err);
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          examtemplate: function examtemplate() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editExamtemplate(lexamtemplate) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><examtemplateform examtemplate="examtemplateeCtrl.examtemplate" parentsave="examtemplateeCtrl.childsave(examtemplate)" oncancel="examtemplateeCtrl.cancel()"></examtemplateform></div>',
        controllerAs: 'examtemplateeCtrl',
        controller: ['examtemplate', function (lexamtemplate) {
          var vm = this;
          vm.examtemplate = lexamtemplate;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(examtemplate) {
            // vm.examtemplate = angular.copy(examtemplate);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in examtemplate) {
              if (examtemplate.hasOwnProperty(key)) {
                vm.examtemplate[key] = examtemplate[key];
              }
            }

            if (vm.examtemplate.$hasPendingActions()) {
              vm.examtemplate.$cancel();
              vm.examtemplate.$save();
              cancel();
            } else {
              vm.examtemplate.$save();
              dialog.close();
            }
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          examtemplate: function examtemplate() {
            return lexamtemplate;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function getSampleTemplate() {
      return sampletemplate;
    }

    return ExamtemplateHelperBase;
  }
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name examtemplate.factory:Examtemplate
   *
   * @description
   *
   */
  angular.module('vcexamtemplate').factory('Examtemplate', Examtemplate);

  Examtemplate.$inject = ['restmod'];
  function Examtemplate(restmod) {
    return restmod.model('/routes/examtemplates').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/examtemplates/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            return $search({ key: key, val: val });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name exam
   * @description
   *
   */
  angular.module('vcexam', ['ui.router', 'ngSanitize', 'ngTagsInput', 'ui.bootstrap.typeahead', 'vcutils.doctor', 'vcconsult', 'vcutils.rlog', 'ui.grid', 'ui.grid.edit']);
})();
/**
 * Created by lari on 26/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('sampleexameditor', {
    restrict: 'E',
    bindings: {
      exam: '=',
      dialog: '<?'
    },
    templateUrl: 'vcexam/sampleexameditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'vertxEventBusService', '$window', '$cookies', 'PrintHelper', function ($log, vertxEventBusService, $window, $cookies, PrintHelper) {
      var vm = this;
      vm.save = save;
      // vm.addBiopsyField = addBiopsyField;
      // vm.printBiopsyLabels = printBiopsyLabels;
      vm.finishEdit = finishEdit;
      vm.cancelEdit = cancelEdit;
      vm.addTrackerValue = addTrackerValue;

      // vm.clearDoctor = clearDoctor;
      vm.$onInit = function () {
        if (angular.isDefined(vm.exam) && vm.exam.hasOwnProperty('_id')) {
          $log.debug('sampleexameditor $onInit exam: ', vm.exam);
          vm.examcopy = angular.copy(vm.exam);
          vm.previewUrl = PrintHelper.examSamplePreviewUrl(vm.exam._id);
        }
        if (angular.isDefined(vm.dialog) && angular.isObject(vm.dialog)) {
          $log.debug('sampleexameditor $onInit dialog: ', vm.dialog);
          vm.dialog = angular.copy(vm.dialog);
        }
      };

      function finishEdit() {
        // add formated date for easy identification and display ordering
        vm.exam.lastestchange = moment().locale('de-at').format('lll');

        // vm.exam.postediting = false;

        if (vm.exam.$hasPendingActions()) {
          vm.exam.cancel();
        }

        $log.debug('finishEdit exam: ', vm.exam, angular.isFunction(vm.exam.$save));

        // vm.exam.$save();
        vm.exam.$save().$then(function () {
          $log.debug('sampleexamedit finishEdit, saving exam succeeded');
        }, function (err) {
          $log.error('sampleexamedit, saving exam failed:', err);
        });
      } // finishExam

      function cancelEdit() {
        vm.exam = angular.copy(vm.examcopy);
        if (angular.isDefined(vm.dialog)) {
          vm.dialog.close();
        }
      }

      function addTrackerValue(trackervalue) {
        $log.debug('exam editor addTrackervalue called for: ', trackervalue);
        if (angular.isUndefined(vm.exam.template.trackervalues)) {
          vm.exam.template.trackervalues = {};
        }
        // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
        if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
          vm.exam.template.trackervalues['v' + trackervalue.trackerid] = { name: trackervalue.name, entries: [] };
        }
        vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
      }

      function save() {
        $log.debug('sampleexameditor save called');
        // doing nothing, by design post exam changes do need to be synced accross browser,
        // but do require an additional pdf to be rendered
        if (vm.exam.$hasPendingActions()) {
          vm.exam.cancel();
        }
        vm.exam.$save().$then(function () {
          $log.debug('sampleexamedit, saving exam succeeded');
        }, function (err) {
          $log.error('sampleexamedit, saving exam failed:', err);
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 26/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('postexameditor', {
    restrict: 'E',
    bindings: {
      exam: '=',
      dialog: '<?'
    },
    templateUrl: 'vcexam/postexameditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'vertxEventBusService', '$window', '$cookies', 'PrintHelper', function ($log, vertxEventBusService, $window, $cookies, PrintHelper) {
      var vm = this;
      vm.save = save;
      // vm.addBiopsyField = addBiopsyField;
      // vm.printBiopsyLabels = printBiopsyLabels;
      vm.finishEdit = finishEdit;
      vm.cancelEdit = cancelEdit;
      vm.addTrackerValue = addTrackerValue;

      // vm.clearDoctor = clearDoctor;
      vm.$onInit = function () {
        if (angular.isDefined(vm.exam) && vm.exam.hasOwnProperty('_id')) {
          $log.debug('postexameditor $onInit exam: ', vm.exam);
          vm.previewUrl = PrintHelper.examPreviewUrl(vm.exam._id, vm.exam.consultid);
          vm.examcopy = angular.copy(vm.exam);
        }
        if (angular.isDefined(vm.dialog) && angular.isObject(vm.dialog)) {
          $log.debug('postexameditor $onInit dialog: ', vm.dialog);
          vm.dialog = angular.copy(vm.dialog);
        }
      };

      /*
                vm.$onChanges = function (changes) {
                  if (angular.isDefined(changes.exam) && angular.isDefined(changes.exam.currentValue) && changes.exam.currentValue.hasOwnProperty('_id')) {
                    $log.debug('postexameditor changes exam: ', changes.exam.currentValue);
                    vm.exam = angular.copy(changes.exam.currentValue);
                    vm.examcopy = angular.copy(vm.exam);
                  }
                  if (angular.isDefined(changes.dialog) && angular.isDefined(changes.dialog.currentValue)) {
                    $log.debug('postexameditor changes dialog: ', changes.dialog.currentValue);
                    vm.dialog = angular.copy(changes.dialog.currentValue);
                  }
                };*/

      function printFindings() {
        PrintHelper.examPrint(vm.exam._id, vm.exam.consultid).then(function () {
          if (angular.isDefined(vm.dialog)) {
            vm.dialog.close();
          }
        }, function (err) {
          $log.error('postexameditor, Printing failed for exam: ', vm.exam._id, vm.exam.template.displayName, err);
        });
      }

      // TODO: refactor for new exam finish
      function finishEdit() {
        // add formated date for easy identification and display ordering
        vm.exam.lastestchange = moment().locale('de-at').format('lll');

        // vm.exam.postediting = false;

        if (vm.exam.$hasPendingActions()) {
          vm.exam.cancel();
        }

        $log.debug('finishEdit exam: ', vm.exam, angular.isFunction(vm.exam.$save));

        // vm.exam.$save();
        vm.exam.$save().$then(function () {
          $log.debug('postexamedit finishEdit, saving exam succeeded');
          printFindings();
        }, function (err) {
          $log.error('postexamedit, saving exam failed:', err);
        });
      } // finishExam

      function cancelEdit() {
        vm.exam = angular.copy(vm.examcopy);
        if (angular.isDefined(vm.dialog)) {
          vm.dialog.close();
        }
      }

      function addTrackerValue(trackervalue) {
        $log.debug('exam editor addTrackervalue called for: ', trackervalue);
        if (angular.isUndefined(vm.exam.template.trackervalues)) {
          vm.exam.template.trackervalues = {};
        }
        // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
        if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
          vm.exam.template.trackervalues['v' + trackervalue.trackerid] = { name: trackervalue.name, entries: [] };
        }
        vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
      }

      function save() {
        $log.debug('postexameditor save called');
        // doing nothing, by design post exam changes do need to be synced accross browser,
        // but do require an additional pdf to be rendered
        if (vm.exam.$hasPendingActions()) {
          vm.exam.cancel();
        }
        vm.exam.$save().$then(function () {
          $log.debug('postexamedit, saving exam succeeded');
        }, function (err) {
          $log.error('postexamedit, saving exam failed:', err);
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('gdtsoftwareconfig', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>GDT Software Endpunkt</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>Bezeichnung des GDT Softwareendpunkts</label>\n            <listeditor list="vm.gdtsoftware.gdtsoftware" parentsave="vm.childsavepat(list)"></listeditor>\n          </div>\n        </div>\n \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService', function ($log, Config, Rlog, vertxEventBusService) {
      var vm = this;
      vm.childsavepat = childsavepat;

      vm.$onInit = function () {

        Config.$find('gdtsoftware').$then(function (gdtsoftware) {
          vm.gdtsoftware = gdtsoftware;
          // intialize if still empty
          if (angular.isUndefined(vm.gdtsoftware.gdtsoftware)) {
            vm.gdtsoftware._id = 'gdtsoftware';
            vm.gdtsoftware.gdtsoftware = [];
          }
        });
      };

      function childsavepat(list) {
        vm.gdtsoftware.gdtsoftware = list;
        savepat();
      }

      function savepat() {
        if (vm.gdtsoftware.$hasPendingActions()) {
          vm.gdtsoftware.$cancel();
        }
        vm.gdtsoftware.$save();
      }

      vertxEventBusService.on('config.update', function (message) {
        // $log.debug('debug: config update received: ', message);
        var messages = message.split(':');

        if (messages[0] === 'gdtsoftware' && angular.isDefined(vm.gdtsoftware)) {
          vm.gdtsoftware.$refresh().$then(function () {
            $log.debug('debug: config refresh gdtsoftware');
          }, function (error) {
            $log.debug('debug: config refresh gdtsoftware failed: ', error);
          });
        }
      });

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] config.update');

        vertxEventBusService.unregisterHandler('config.update', {}, function () {}, function (err) {
          $log.error('Failed to unregister examinations.update handler: ', err);
        });
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('gdtprofilconfig', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>GDT Profil</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>Name des in der Software eingrichteten Profils</label>\n            <listeditor list="vm.gdtprofil.gdtprofil" parentsave="vm.childsavepat(list)"></listeditor>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService', function ($log, Config, Rlog, vertxEventBusService) {
      var vm = this;
      vm.childsavepat = childsavepat;

      vm.$onInit = function () {

        Config.$find('gdtprofil').$then(function (gdtprofil) {
          vm.gdtprofil = gdtprofil;
          // intialize if still empty
          if (angular.isUndefined(vm.gdtprofil.gdtprofil)) {
            vm.gdtprofil._id = 'gdtprofil';
            vm.gdtprofil.gdtprofil = [];
          }
        });
      };

      function childsavepat(list) {
        vm.gdtprofil.gdtprofil = list;
        savepat();
      }

      function savepat() {
        if (vm.gdtprofil.$hasPendingActions()) {
          vm.gdtprofil.$cancel();
        }
        vm.gdtprofil.$save();
      }

      var configUpdateHandler = function configUpdateHandler(message) {
        var messages = message.split(':');
        if (messages[0] === 'gdtprofil') {
          if (angular.isDefined(vm.gdtprofil)) {
            vm.gdtprofil.$refresh().$then(function () {
              $log.debug('debug: config refresh gdtprofil');
            }, function (error) {
              $log.debug('debug: config refresh gdtprofil failed: ', error);
            });
          }
        }
      };

      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] config.update');
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 26/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('fieldgroup', {
    restrict: 'E',
    bindings: {
      fieldgroup: '=',
      gi: '@',
      onFieldgroupChange: '&'
    },
    templateUrl: 'vcexam/fieldgroup-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;

      function save() {
        $log.debug('fieldgroup.save called: ', vm.fieldgroup.label);
        vm.onFieldgroupChange();
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examview', {
    restrict: 'E',
    bindings: {
      exam: '='
    },
    templateUrl: 'vcexam/examview-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examtagstring', {
    restrict: 'E',
    bindings: {
      valuearray: '='
    },
    template: '<span ng-repeat="val in vm.valuearray">{{val.name}}{{$last ? \'\' : \', \'}}</span>',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 03/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examstarter', {
    restrict: 'E',
    bindings: {
      // templates: '=',
      consult: '='
    },
    template: '\n      <div class="spacer-bottom" data-hook="examstarter">\n        <span ng-repeat="et in vm.examtemplates | orderBy: \'template.nr\'" ng-show="vm.examtemplates">\n          <span class="btn btn-spacer-top btn-primary" ng-class="{\'btn-info\': et.template.includefindings, \'btn-warning\': et.template.isgdt,\'btn-success\': et.template.isdicom}"\n                data-exam-type="{{et.template.type}}"\n                ng-click="vm.startExam(et);">{{et.template.displayname}} <span ng-if="et.template.isgdt">({{vm.getsharename(et.template.gdtsoftwareshareid)}})</span>\n          </span>\n        </span>\n      </div>\n      <div class="spacer-top alert alert-warning" ng-show="vm.gdterror">\n        <h3><span class="pull-left"><i class="fa fa-warning"></i> GDT Konflikt</span><span class="pull-right"><span class="btn btn-warning" ng-click="vm.cleargdterror()"><i class="fa fa-remove"></i></span></span></h3>\n        <div class="clearfix"></div>\n        <p ng-bind-html="vm.gdterror"></p>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Exam', 'Examtemplate', '$http', 'lodash', 'Cart', function ($log, Exam, Examtemplate, $http, ld, Cart) {
      var vm = this;
      vm.startExam = startExam;

      vm.cleargdterror = function () {
        delete vm.gdterror;
      };

      vm.getsharename = function (s) {
        if (s.length > 0) {
          return s.split("$")[1];
        } else return;
      };

      vm.$onInit = function () {
        vm.examtemplates = Examtemplate.$search({ active: true });
        // vm.examinations = Exam.$search({active: true, open: true, patientid: vm.consult.patientid});
      };

      function startExam(et) {
        var newexam = {};
        newexam.templateid = et._id;
        newexam.print = true;
        newexam.patientid = vm.consult.patientid;
        newexam.clientid = vm.consult.patientid;
        newexam.consultid = vm.consult._id;
        newexam.patlastname = vm.consult.patlastname;
        newexam.patfirstname = vm.consult.patfirstname;
        newexam.patbdate = vm.consult.patbdate;
        newexam.templateid = et._id;
        newexam.template = angular.copy(et.template);
        newexam.type = et.template.displayname;
        newexam.fdate = moment().locale('de-at').format('ll');

        if (et.template.loadfiles === true && et.template.shareid) {
          newexam.shareid = et.template.shareid;
        }
        if (et.template.isdicom === true && angular.isDefined(et.template.dicommodalityaetitle) && et.template.dicommodalityaetitle.length > 0) {
          newexam.isdicom = true;
          newexam.dicommodalitytype = et.template.dicommodalitytype;
          newexam.dicommodalityaetitle = et.template.dicommodalityaetitle;
          newexam.dicomexamid = moment().valueOf().toString() + Math.floor(Math.random() * 999).toString();
          newexam.dicompatname = newexam.patlastname.toUpperCase() + '^' + newexam.patfirstname.toUpperCase();
          newexam.dicomdob = moment(newexam.patbdate, 'DD.MM.YYYY').format('YYYYMMDD');
          newexam.dicomdate = moment().format('YYYYMMDD');
          newexam.dicomtime = moment().format('HHmmss.SS');
          newexam.dicomdescription = et.template.displaytitle;
          newexam.dicompatid = vm.consult.dicompatid;
          newexam.dicomconsultid = vm.consult.dicomconsultid;
        }

        if (et.template.isgdt === true && angular.isDefined(et.template.gdtsoftwareshareid) && angular.isDefined(et.template.gdtprofil)) {
          Exam.$opengdtshare().$then(function (shares) {
            $log.debug('open gdt shares', shares);
            var shareparts = et.template.gdtsoftwareshareid.split("$");
            var shareid = shareparts[0];
            var sharename = shareparts[1];
            $log.debug('shares include: ', shares[0].openshares, shares[0].openshares.includes(shareid));
            if (shares[0].openshares.includes(shareid)) {
              vm.gdterror = 'GDT Gerät-Konflikt für Untersuchung <strong>' + et.template.displayname + '</strong>. \n                    Es kann immer nur eine Untersuchung für die GDT Verbindung <strong>' + sharename + '</strong> aktiv sein. \n                    Beenden Sie bitte die offene Untersuchung bevor Sie eine neue starten.';
              return;
            } else {
              newexam.isgdt = true;
              newexam.shareid = shareid;
              newexam.sharename = sharename;
              newexam.gdtprofile = et.template.gdtprofil;
              newexam.gdtpatid = vm.consult.gdtpatid;
              createExam(newexam);
            }
          });
        } else {
          createExam(newexam);
        }
      }

      function createExam(newexam) {
        Exam.$create(newexam).$then(function (exam) {
          if (angular.isDefined(exam.template.services)) {
            if (angular.isDefined(exam.template.services.groups)) {
              exam.template.services.groups.map(function (g) {
                Cart.addItem(exam.patientid, g);
              });
            }
            // TODO: decide if item details will be fetched by backend upon receiving the request
            if (angular.isDefined(exam.template.services.items)) {
              exam.template.services.items.map(function (i) {
                Cart.addItem(exam.patientid, i);
              });
            }
          }
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examgdtfiles', {
    restrict: 'E',
    bindings: {
      // examinations: '='
      examid: '<'
    },
    // templateUrl: 'exam/currentexams-component.tpl.html',
    template: '\n        <div ng-show="vm.files.length > 0">\n        <div class="spacer-top"></div>\n          <div class="panel panel-default">\n            <div class="panel-heading">\n                <h4 style="vertical-align: baseline">\n                    <div class="pull-left">PDFs der Untersuchung</div>\n                    <div class="pull-right"> 1 \n                      <span class="switch" ng-click="vm.toggleImgNr()">\n                        <input type="checkbox" ng-model="vm.img3">\n                        <span class="slider round"></span>\n                      </span>  3 Bilder pro Zeile\n                    </div>\n                    <div class="clearfix"></div>\n                </h4>\n            </div>\n            <div class="panel-body">\n              <div class="col-xs-{{vm.colwidth}}" ng-repeat="file in vm.files | filter: {active: true}">\n                <a  href="/routes/files/filereader/{{file.fileid}}" target="_blank"><i class="fa fa-file-pdf-o fa-4x"></i></a><br>\n                <div><input type="checkbox" ng-model="file.print" ng-change="vm.save(file)">&nbsp;mit  Befund ausdrucken</div>\n                <div><input type="text" ng-model="file.label"  ng-blur="vm.save(file)" class="form-control"></div>\n              </div>\n            </div>\n        </div>\n        <div class="clearfix spacer-bottom"></div>  \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'File', 'vertxEventBusService', '$window', function ($log, Rlog, File, vertxEventBusService, $window) {
      var vm = this;
      vm.img3 = true;
      vm.colwidth = 4;
      vm.save = save;
      vm.deleteFile = deleteFile;

      // vm.toggleImgNr = toggleImgNr;

      vm.$onInit = function () {
        if (angular.isDefined(vm.examid)) {
          var query = { examid: vm.examid };
          File.$search(query).$then(function (files) {
            vm.files = files;
          }, function (err) {
            $log.error('examfiles lookup failed for examid id: ', vm.examid);
            Rlog.error('exam', 'examfiles', 'examfiles lookup failed', { examid: vm.examid });
          });
        }
      };

      // vm.examid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.examid.currentValue)) {
          vm.examid = changes.examid.currentValue;
          if (angular.isDefined(vm.examid)) {
            File.$search({ examid: vm.examid }).$then(function (files) {
              vm.files = files;
              // $log.debug('******* current exam files : ', files);
            }, function (err) {
              $log.error('examfiles lookup failed for examid id: ', vm.examid);
              Rlog.error('exam', 'examfiles', 'examfiles lookup failed', { examid: vm.examid });
            });
          }
        }
      };

      /*            function toggleImgNr() {
                    vm.img3 = !vm.img3;
      
                    if (vm.img3 === true) {
                      vm.colwidth = 4;
                    } else {
                      vm.colwidth = 12;
                    }
                    $log.debug('vm.img3 :', vm.img3);
                    $log.debug('vm.colwidth :', vm.colwidth);
                  }*/

      function deleteFile(file) {
        file.active = false;
        vm.save(file);
      }

      function save(file) {
        if (file.$hasPendingActions()) {
          file.$cancel();
        }
        file.$save().$then(function () {}, function () {
          Rlog.debug('exam', 'examfiles', 'file delete save failed', { examid: exam._id, fileid: file._id });
        });
      }

      var examfileUpdateHandler = function examfileUpdateHandler(message) {
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function () {
            $log.debug('debug: examfiles refreshed');
          }, function (error) {
            $log.debug('debug: examfiles could not refresh exams: ', error);
          });
        }
      };

      $log.debug('[Vert.x subscribe] examfile.update');
      // TODO: figure out how to conviniently sync label and include file updates
      vertxEventBusService.on('examfile.update', {}, examfileUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examfile.update');
        vertxEventBusService.unregisterHandler('examfile.update', {}, examfileUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examfiles', {
    restrict: 'E',
    bindings: {
      // examinations: '='
      examid: '<'
    },
    // templateUrl: 'exam/currentexams-component.tpl.html',
    template: '\n        <div ng-show="vm.files.length > 0">\n        <div class="spacer-top"></div>\n          <div class="panel panel-default" data-hook="examfiles-component">\n            <div class="panel-heading">\n                <h4 style="vertical-align: baseline">\n                    <div class="pull-left">Bilder der Untersuchung</div>\n                    <div class="pull-right"> 1 \n                      <span class="switch" ng-click="vm.toggleImgNr()">\n                        <input type="checkbox" ng-model="vm.img3">\n                        <span class="slider round"></span>\n                      </span>  3 Bilder pro Zeile\n                    </div>\n                    <div class="clearfix"></div>\n                </h4>\n            </div>\n            <div class="panel-body">\n              <div class="col-xs-{{vm.colwidth}}" ng-repeat="file in vm.files | filter: {active: true}">\n                <img class="img-responsive"  ng-src="/routes/files/filereader/{{file.fileid}}"  data-hook="examimage" data-filename="{{file.filename}}" ><br>\n                <div><input type="checkbox" ng-model="file.inc" ng-change="vm.save(file)">&nbsp;in Befund inkludiert</div>\n                <div><input type="text" ng-model="file.label"  ng-blur="vm.save(file)"  data-hook="includeexamimglabel" data-label-for-exam-img="{{file.filename}}" class="form-control"></div>\n              </div>\n          </div>\n        </div>\n        <div class="clearfix spacer-bottom"></div>  \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'File', 'vertxEventBusService', '$window', function ($log, Rlog, File, vertxEventBusService, $window) {
      var vm = this;
      vm.img3 = true;
      vm.colwidth = 4;
      vm.save = save;
      vm.deleteFile = deleteFile;

      vm.toggleImgNr = toggleImgNr;
      vm.$onInit = function () {
        if (angular.isDefined(vm.examid)) {
          var query = { examid: vm.examid };
          File.$search(query).$then(function (files) {
            vm.files = files;
          }, function (err) {
            $log.error('examfiles lookup failed for examid id: ', vm.examid, err);
            Rlog.error('exam', 'examfiles', 'examfiles lookup failed', { examid: vm.examid });
          });
        }
      };

      // vm.examid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.examid.currentValue)) {
          vm.examid = changes.examid.currentValue;
          if (angular.isDefined(vm.examid)) {
            File.$search({ examid: vm.examid }).$then(function (files) {
              vm.files = files;
              // $log.debug('******* current exam files : ', files);
            }, function (err) {
              $log.error('examfiles lookup failed for examid id: ', vm.examid, err);
              Rlog.error('exam', 'examfiles', 'examfiles lookup failed', { examid: vm.examid });
            });
          }
        }
      };

      function toggleImgNr() {
        vm.img3 = !vm.img3;

        if (vm.img3 === true) {
          vm.colwidth = 4;
        } else {
          vm.colwidth = 12;
        }
        $log.debug('vm.img3 :', vm.img3);
        $log.debug('vm.colwidth :', vm.colwidth);
      }

      function deleteFile(file) {
        file.active = false;
        vm.save(file);
      }

      function save(file) {
        if (file.$hasPendingActions()) {
          file.$cancel();
        }
        file.$save().$then(function () {}, function () {
          Rlog.debug('exam', 'examfiles', 'file delete save failed', { examid: vm.examid, fileid: file._id });
        });
      }

      var examfileUpdateHandle = function examfileUpdateHandle(message) {
        $log.debug('vertxbus examfiles: examfile.update received: ', message);
        if (angular.isDefined(vm.files)) {
          vm.files.$refresh().$then(function () {
            $log.debug('examfiles: examfiles refreshed');
          }, function (error) {
            $log.debug('examfiles: examfiles could not refresh exams: ', error);
          });
        }
      };

      var filesUpdateHandle = function filesUpdateHandle(message) {
        $log.debug('vertxbus examfiles: files.update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.files) && messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
          if (vm.files.some(function (f) {
            return f._id === messages[0];
          })) {
            vm.files.$refresh().$then(function () {
              $log.debug('examfiles: exam files refreshed');
            }, function (error) {
              $log.debug('examfiles: exam files could not refresh exams: ', error);
            });
          }
        }
      };

      $log.debug('[Vert.x subscribe] examfile.update');
      vertxEventBusService.on('examfile.update', {}, examfileUpdateHandle);

      $log.debug('[Vert.x subscribe] files.update');
      vertxEventBusService.on('files.update', {}, filesUpdateHandle);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] files.update');
        vertxEventBusService.unregisterHandler('files.update', {}, filesUpdateHandle);

        $log.debug('[Vert.x unsubscribe] examfile.update');
        vertxEventBusService.unregisterHandler('examfile.update', {}, examfileUpdateHandle);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 26/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examfield', {
    restrict: 'E',
    bindings: {
      field: '=',
      onFieldChange: '&',
      ti: '@?',
      gi: '@?'
    },
    templateUrl: 'vcexam/examfield-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.loadValues = loadValues;

      vm.$onInit = function () {
        // make copy of the field entry originally passed
        vm.laststate = angular.copy(vm.field);
        // calculate tabindex position
        vm.fti = 100 * vm.groupi + vm.tabi;
      };

      function save() {
        // save is triggered by onBlur, only save if there really have been changes to the field
        // if field changed, overwrite parent value and trigger parent change handler
        if (!angular.equals(vm.laststate, vm.field)) {
          vm.laststate = angular.copy(vm.field);
          vm.onFieldChange();
        }
      }

      // tagsInput expects a promise that will resolve into an array, it doesn't accept arrays
      function loadValues($query) {
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.field.values);
        });
        return promise.then(function (values) {
          return values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 26/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('exameditor', {
    restrict: 'E',
    bindings: {
      exam: '='
    },
    templateUrl: 'vcexam/exameditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'vertxEventBusService', '$window', 'ExamHelper', 'Rlog', 'PrintHelper', '$http', '$timeout', function ($log, vertxEventBusService, $window, ExamHelper, Rlog, PrintHelper, $http, $timeout) {
      var vm = this;
      vm.save = save;
      vm.addBiopsyField = addBiopsyField;
      vm.printBiopsyLabels = printBiopsyLabels;
      vm.finishExam = ExamHelper.finishExam;
      vm.clearDoctor = clearDoctor;
      vm.saveDoctor = saveDoctor;
      vm.previewUrl = PrintHelper.examPreviewUrl(vm.exam._id, vm.exam.consultid);
      vm.addTrackerValue = addTrackerValue;

      function save() {
        $log.debug('[EXAM][ExamEditor] save called');
        vm.exam.$save();
      }

      function addBiopsyField() {
        var biopsy = {
          label: '',
          avalues: [],
          values: []
        };
        vm.exam.template.biopsy.biopsies.push(biopsy);
        $log.debug('[EXAM][ExamEditor] Biospies: ', vm.exam.template.biopsy.biopsies);
      }

      function printBiopsyLabels() {
        if (vm.exam.$hasPendingActions) {
          $log.warn('[EXAM][ExamEditor] exam save had pending actions, cancelling now.');
          vm.exam.$cancel();
          $timeout(function () {
            $log.warn('[EXAM][ExamEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
            reallyPrint();
          }, 1500);
        } else {
          reallyPrint();
        }
      }

      // /routes/fop/exam/false/false/58f8820cb148b776e918dd0e/58f88208b148b776e918dd0d
      function reallyPrint() {
        $http({
          url: '/routes/fop/examlabels/true/true/' + vm.exam._id,
          method: 'GET'
        }).success(function () {
          vm.labelsprinted = true;
        }).error(function () {
          vm.labelsprinted = false;
        });
      }

      function saveDoctor(doctor) {
        vm.exam.template.biopsy.pathology = doctor;
        vm.save();
      }

      function clearDoctor() {
        delete vm.exam.template.biopsy.pathology;
        /*            if (vm.newref && vm.newref.doctor) {
                      delete vm.newref.doctor;
                    }*/
      }

      function addTrackerValue(trackervalue) {
        $log.debug('exam editor addTrackervalue called for: ', trackervalue);
        if (angular.isUndefined(vm.exam.template.trackervalues)) {
          vm.exam.template.trackervalues = {};
        }
        // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
        if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
          vm.exam.template.trackervalues['v' + trackervalue.trackerid] = { name: trackervalue.name, entries: [] };
        }
        vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
        vm.save();
      }

      var examsUpdateHandler = function examsUpdateHandler(message) {
        var messages = message.split(':');
        // only refresh exam if change was NOT triggered by this browser
        if (angular.isDefined(vm.exam) && messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
          vm.exam.$refresh();
          $log.debug('(exameditor) refreshed openexam');
        } else {
          $log.debug(' (exameditor) ignored openexam change');
        }
      };

      $log.debug('[Vert.x subscribe] examinations.update');
      vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.update');
        vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
      };

      vm.sprref = 'Überweisungen für abgeschlossene Untersuchungen können Sie in der Überweisungsansicht der\n                       Konsultation einsehen und editieren. Änderungen an Biospiefeldern, die Sie nach Abschluß der\n                       Untersuchung vornehmen, werden NICHT automatisch in bestehende Überweisungen übernommen.';
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 24/04/2017.
 */
'use strict';

(function () {
  'use strict';

  angular.module('vcexam').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider.state('playground.exam', {
      url: '/exam',
      views: {
        'playgroundmain@playground': {
          template: '<h3><tt>&lt;examlist exams=""&gt;</tt></h3><div ui-view="examlistview"></div>' + '<h3><tt>&lt;examedit exam=""&gt;</tt></h3><div ui-view="exameditview"></div>' + '<h3><tt>&lt;examfield field="" on-field-change="" gi="" fi=""&gt;</tt></h3><div ui-view="examfieldview"></div>' + '<h3><tt>&lt;fieldgroup on-fieldgroup-change="" gi=""&gt;</tt></h3><div ui-view="examfieldgroupview"></div>' + '<h3><tt>&lt;examview exam=""&gt;</tt></h3><div ui-view="examview"></div>' + '<h3><tt>&lt;currentexams examinations=""&gt;</tt></h3><div ui-view="currentexamsview"></div>'
        }
      },
      onEnter: function onEnter() {
        console.log('playground.exam entered');
      }
    });

    $stateProvider.state('playground.exam.allcomponents', {
      url: '/allcomponents',
      // the `users` input binding on the component receives
      // the `userlist` resolve value (from the state)
      // bind $transistions to gain access to $transition$ object

      resolve: {
        exams: function exams(ExamHelper) {
          return ExamHelper.getAllClosed();
          // return {};
        },
        field: function field() {
          return getfield(1);
        },
        fieldgroup: function fieldgroup() {
          return getfieldgroup('dummy group');
        },
        exam: function exam(ExamHelper) {
          // return ExamHelper.getOneOpen();
          return getExam(true, true);
        },
        currentexams: function currentexams() {
          return getExams();
        },
        onfieldchange: function onfieldchange() {
          return function () {
            console.log('dummy onfieldchange called');
          };
        },
        onfieldgroupchange: function onfieldgroupchange() {
          return function () {
            console.log('dummy onfieldgroupchange called');
          };
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'examlistview@playground.exam': {
          component: 'examlist',
          bindings: {
            exams: 'currentexams'
          }
        },
        'examfieldview@playground.exam': {
          component: 'examfield',
          bindings: {
            field: 'field',
            onFieldChange: 'onfieldchange'
          } // bindings
        },
        'examfieldgroupview@playground.exam': {
          component: 'fieldgroup',
          bindings: {
            fieldgroup: 'fieldgroup',
            onFieldgroupChange: 'onfieldgroupchange'
          }
        },
        'exameditview@playground.exam': {
          component: 'exameditor',
          bindings: {
            exam: 'exam'
          }
        },
        'examview@playground.exam': {
          component: 'examview',
          bindings: {
            exam: 'exam'
          }
        },
        'currentexamsview@playground.exam': {
          component: 'currentexams',
          bindings: {
            examinations: 'currentexams'
          }
        }
      },
      /*views: {
       'examlistview@playground.exam': {
       template: 'Some useless Text'
       }
       },*/
      onEnter: function onEnter() {
        console.log('playground.exam.allcomponents entered');
      }
    });
  } // all routes

  function getfield(num) {
    return {
      label: 'Feld ' + num,
      avalues: [],
      values: [{
        name: 'bang'
      }, {
        name: 'bong'
      }, {
        name: 'bing'
      }, {
        name: 'bung'
      }, {
        name: 'beng'
      }]
    };
  }

  function getfieldgroup(label) {
    return {
      label: label,
      fields: [getfield(2), getfield(3)]
    };
  }

  function getFiles(num) {
    var files = [];

    for (var i = 0; i < num; i++) {
      if (i % 2) {
        files.push(getFile(true));
      } else {
        files.push(getFile(false));
      }
    }
    return files;
  }

  function getFile(inc) {
    return {
      label: 'ein label',
      fileid: '571de5357c01594fd0bbdf56',
      idinfiles: '571de5357c01594fd0bbdf5a',
      mimetype: 'image/jpeg',
      include: inc
    };
  }

  function getExam(open, active) {
    var exam = {
      _id: '571d67437c01594fd0bbdf47',
      created: '2016-04-25T00:39:31.368Z',
      templateid: '56a3aaca65db7f0fa271ee56',
      template: getTemplate(),
      files: getFiles(5),
      fdate: '25. Apr. 2016',
      diagnosis: 'total krank',
      type: 'Testexam',
      docid: '571d674d7c01594fd0bbdf48',
      patientid: '571d67207c01594fd0bbdf45',
      consultid: '571d67287c01594fd0bbdf46'
    };
    exam.open = open;
    exam.active = active;
    return exam;
  }

  function getExams() {
    return [getExam(true, true), getExam(true, false), getExam(false, true), getExam(false, false)];
  }

  function getTemplate(files) {
    var template = {
      type: 'Test',
      displayname: 'Testexam',
      device: {
        label: 'Gerät',
        name: ''
      },
      shareid: '',
      fieldgroups: [getfieldgroup('fieldgroup1'), getfieldgroup('fieldgroup2')],
      diagnosis: getDiagnoses(),
      recommendation: getRecommendations(),
      comment: getComment(),
      biopsy: getBiopsies()
    };

    template.loadfiles = files;
    if (files) {
      template.files = getFiles(5);
    }
    return template;
  }

  function getDiagnoses() {
    return {
      label: 'Diagnose',
      avalues: [{
        name: 'Krank'
      }],
      values: [{
        name: 'Quux'
      }, {
        name: 'Snafu'
      }, {
        name: 'Qietsch'
      }]
    };
  }

  function getComment() {
    return {
      label: 'Kommentar',
      avalues: [{
        name: 'Wichtiger Kommentar'
      }],
      values: [{
        name: 'Quux'
      }, {
        name: 'Snafu'
      }, {
        name: 'Qietsch'
      }]
    };
  }

  function getRecommendations() {
    return {
      label: 'Empfehlung',
      avalues: [{
        name: 'Ruhe'
      }],
      values: [{
        name: 'Quux'
      }, {
        name: 'Snafu'
      }, {
        name: 'Qietsch'
      }]
    };
  }

  function getBiopsies() {
    return {
      label: 'Biopsie',
      avalues: [{
        name: 'Speiseröhre'
      }],
      values: [{
        name: 'Speiseröhre'
      }, {
        name: 'Magen'
      }, {
        name: 'Darm'
      }],
      biopsies: [{
        label: 'PE 1 Test ohne Share',
        avalues: [],
        values: []
      }]
    };
  }

  // klammerfriedhof
})();
/**
 * Created by lari on 24/04/2017. **/

'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('examlist', {
    restrict: 'E',
    bindings: {
      exams: '<?',
      patientid: '<?'
    },
    templateUrl: 'vcexam/exam-list-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Exam', '$http', 'Rlog', '$scope', 'uiGridConstants', 'PrintHelper', '$uibModal', 'vertxEventBusService', '$window', function ($log, Exam, $http, Rlog, $scope, uiGridConstants, PrintHelper, $uibModal, vertxEventBusService, $window) {
      var vm = this;
      vm.examactiontemplate = 'examactiontemplate';
      vm.editExam = editExam;
      vm.spinners = [];

      // init
      vm.$onInit = function () {
        // unless exam list has been passed for test purposes, retrieve exams list from web
        if (angular.isUndefined(vm.exams) && angular.isUndefined(vm.patientid)) {
          vm.exams = Exam.$search();
        }

        vm.gridOptions = {
          enableFiltering: true,
          columnDefs: [{
            field: 'created', displayName: 'Datum', type: 'date', width: '15%',
            cellTemplate: '<span>{{row.entity.created | moment: \'lll\'}}</span>',
            filters: [{
              condition: uiGridConstants.filter.GREATER_THAN,
              placeholder: 'nach'
            }, {
              condition: uiGridConstants.filter.LESS_THAN,
              placeholder: 'vor'
            }]
          }, {
            field: 'type', displayName: 'Typ', width: '20%',
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            field: 'diagnosis', displayName: 'Befund', width: '43%',
            filter: {
              condition: uiGridConstants.filter.CONTAINS,
              placeholder: 'beinhaltet ...'
            }
          }, {
            displayName: 'Aktion', name: 'examaction', cellClass: 'gridalignright', width: '20%',
            cellTemplate: vm.examactiontemplate, enableFiltering: false
          }],
          data: vm.exams
        };
      };

      // changes
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          vm.exams = Exam.$search({ patientid: vm.patientid, active: true });
        }
      };

      function editExam(exam, index) {
        $log.debug('examlist editExam called with: ', exam, index);
        $uibModal.open({
          template: '\n                <div class="modalspacer">\n                  <postexameditor exam="lc.exam" dialog="lc.dialog"></postexameditor>\n                </div>',
          size: 'lg',
          controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
            var lc = this;
            $log.debug('lexam inside modal controaller: ', lexam);
            lc.exam = lexam;
            lc.dialog = $uibModalInstance;
          }],
          controllerAs: 'lc',
          resolve: {
            lexam: function lexam() {
              $log.debug('exam inside resolve: ', exam);
              return exam;
            }
          }
        });
      }

      var examsUpdateHandler = function examsUpdateHandler(message) {
        var messages = message.split(':');
        // only refresh exam if change was NOT triggered by this browser
        if (angular.isDefined(vm.exams) && messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
          vm.exams.$refresh();
          $log.debug('(postexameditor) refreshed exams');
        } else {
          $log.debug(' (postexameditor) ignored exams change');
        }
      };

      $log.debug('[Vert.x subscribe] examinations.update');
      vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.update');
        vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name exam.factory:ExamHelper
   *
   * @description
   *
   */
  angular.module('vcexam').factory('ExamHelper', ExamHelper);

  ExamHelper.$inject = ['Exam', 'Patdocs', '$http', '$log', 'Rlog', '$uibModal', '$timeout'];

  function ExamHelper(Exam, Patdocs, $http, $log, Rlog, $uibModal, $timeout) {
    // private

    // public
    var service = {};

    // used in scansorter and examlist view
    service.editPostExam = function (exam) {
      $log.debug('examlist editExam called with: ', exam);
      $uibModal.open({
        template: '\n                <div class="modalspacer">\n                  <postexameditor exam="lc.exam" dialog="lc.dialog"></postexameditor>\n                </div>',
        size: 'lg',
        controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
          var lc = this;
          $log.debug('lexam inside modal controaller: ', lexam);
          lc.exam = lexam;
          lc.dialog = $uibModalInstance;
        }],
        controllerAs: 'lc',
        resolve: {
          lexam: function lexam() {
            $log.debug('exam inside resolve: ', exam);
            return exam;
          }
        }
      });
    };

    // used in examtemplate list view to preview new templates on a defined sample patient
    service.editSampleExam = function (exam) {
      $log.debug('examlist editSampleExam called with: ', exam);
      $uibModal.open({
        template: '\n                <div class="modalspacer">\n                  <sampleexameditor exam="lc.exam" dialog="lc.dialog"></sampleexameditor>\n                </div>',
        size: 'lg',
        controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
          var lc = this;
          $log.debug('lexam inside modal controaller: ', lexam);
          lc.exam = lexam;
          lc.dialog = $uibModalInstance;
        }],
        controllerAs: 'lc',
        resolve: {
          lexam: function lexam() {
            $log.debug('exam inside resolve: ', exam);
            return exam;
          }
        }
      });
    };

    service.finishExam = function finishExam(exam) {
      $log.debug('exam helper factory finishexam called');
      exam.open = false;

      // build diagnosis string from parts for quick reference
      if (angular.isObject(exam.template.diagnosis)) {
        exam.diagnosis = '';
        for (var i = 0; i < exam.template.diagnosis.avalues.length; i++) {
          exam.diagnosis += exam.template.diagnosis.avalues[i].name;
          if (i !== exam.template.diagnosis.avalues.length - 1) {
            exam.diagnosis += ', ';
          }
        }
      }

      // add formated date vor easy identification and display ordering
      exam.time = moment().format('HH:mm');

      // test if biopsie entries where actually created
      if (angular.isObject(exam.template.biopsy) && exam.template.biopsy.biopsies.length > 0) {
        var biopsies = exam.template.biopsy.biopsies;
        var btest = false;
        for (var i = 0; i < biopsies.length; i++) {
          if (biopsies[i].avalues.length > 0) {
            btest = true;
          }
        }
        if (btest) {
          createReferral(exam);
        }
      }

      if (exam.$hasPendingActions) {
        $log.warn('[EXAM][HELPER] exam save had pending actions, cancelling now.');
        exam.$cancel();
        $timeout(function () {
          $log.warn('[EXAM][HELPER]  waited 1.5 seconds because of exam having had pending actions, saving now.');
          savesave(exam);
        }, 1500);
      } else {
        savesave(exam);
      }
    };

    function savesave(exam) {
      exam.$save().$then(function () {
        $log.debug('exam helper factory finishexam save successful');
      }, function () {
        $log.error('exam helper factory finishexam save failed');

        Rlog.debug('exam', 'examhelperfactory', 'exam finish (save) failed', { examid: exam._id });
      });
    }

    function createReferral(exam) {
      var newreferral = {};
      if (angular.isObject(exam.template.biopsy.pathology)) {
        newreferral.doctor = exam.template.biopsy.pathology;
      } else {
        newreferral.to = 'Pathologie';
      }

      if (angular.isString(exam.template.biopsy.pathdiag)) {
        newreferral.diag = exam.template.biopsy.pathdiag;
      } else {
        newreferral.diag = 'Auffälligkeiten';
      }

      if (angular.isString(exam.template.biopsy.pathcomment)) {
        newreferral.ref = exam.template.biopsy.pathcomment;
      } else {
        newreferral.comment = 'Biopsien';
      }

      var biolabels = [];
      var label = undefined;
      for (var i = 1; i <= exam.template.biopsy.biopsies.length; i++) {
        label = exam.template.type + ' PE ' + i + ': ';
        exam.template.biopsy.biopsies[i - 1].avalues.forEach(function (v) {
          label += v.name;
          label += ', ';
        });
        // strip last comma and space
        biolabels.push(label.substring(0, label.length - 2));
      }

      newreferral.biolabels = biolabels;
      newreferral.type = 'referral';
      newreferral.reftype = 'bio';
      newreferral.refdate = moment().locale('de-at').format('ll');
      newreferral.pdate = true;
      newreferral.consultid = exam.consultid;
      newreferral.patientid = exam.patientid;

      $log.debug('#### new biopsy referral: ', newreferral);

      Patdocs.$create(newreferral).$then(function success() {
        $log.debug('creation of biopsy referral succeeded');
      }, function error(err) {
        $log.error('creation of biopsy referral failed: ', err);
        Rlog.error('exam', 'examhelperfactory', 'creation of biopsy referral failed', {
          examid: exam._id, patientid: exam.patientid,
          consultid: exam.consultid, biolabels: newreferral.biolabels
        });
      });
    }

    service.getAllOpen = function () {
      var query = {
        open: true,
        active: true
      };
      return Exam.$search(query);
    };

    service.getOneOpen = function () {
      var query = {
        open: true,
        active: true
      };
      return Exam.$search(query).$asPromise().then(function (openexams) {
        return openexams[0];
      });
    };

    service.getAllClosed = function () {
      var query = {
        open: false,
        active: true
      };
      return Exam.$search(query);
    };

    service.getAllClosedPerPatient = function (patid) {
      var query = {
        open: false,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    service.getAllOpenPerPatient = function (patid) {
      var query = {
        open: true,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    // TODO: use aggregate query to limit set
    service.getLastNPerPatient = function (patid, n) {
      var query = {
        open: true,
        active: true,
        patientid: patid
      };
      return Exam.$search(query);
    };

    service.getAllPerConsult = function (consultid) {
      var query = {
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };

    service.getAllClosedPerConsult = function (consultid) {
      var query = {
        open: false,
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };

    service.getAllPerOpenConsult = function (consultid) {
      var query = {
        open: true,
        active: true,
        consultid: consultid
      };
      return Exam.$search(query);
    };

    return service;
  }

  // lammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name examination.factory:Exam
   *
   * @description
   *
   */
  angular.module('vcexam').factory('Exam', Exam).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Exam.$inject = ['restmod'];

  function Exam(restmod) {
    return restmod.model('/routes/examinations', 'DebouncedModel').mix({
      // patient: {belongsTo: 'Client', key: 'clientid'},
      // consult: {belongsTo: 'Consult', key: 'consultid'},
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      open: { init: true }, $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $opengdtshare: function $opengdtshare(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations/opengdtshare';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/examinations';
              }
            }, function (key, val) {
              var realquery = {};
              realquery[key] = val;
              realquery.active = true;
              return this.$search(realquery);
            });
          }
          /*$searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          },*/
        } // Model
      } // extend
    });
  }
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('dicomconfig', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>DICOM Modalities</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>AE Title DICOM fähiger Geräte</label>\n            <listeditor list="vm.dicomaetitle.dicomaetitle" parentsave="vm.childsavepat(list)"></listeditor>\n          </div>\n        </div>\n \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Config', 'Rlog', 'vertxEventBusService', function ($log, Config, Rlog, vertxEventBusService) {
      var vm = this;
      vm.childsavepat = childsavepat;

      vm.$onInit = function () {

        Config.$find('dicomaetitle').$then(function (dicomaetitle) {
          vm.dicomaetitle = dicomaetitle;
          // intialize if still empty
          if (angular.isUndefined(vm.dicomaetitle.dicomaetitle)) {
            vm.dicomaetitle._id = 'dicomaetitle';
            vm.dicomaetitle.dicomaetitle = [];
          }
        });
      };

      function childsavepat(list) {
        vm.dicomaetitle.dicomaetitle = list;
        savepat();
      }

      function savepat() {
        if (vm.dicomaetitle.$hasPendingActions()) {
          vm.dicomaetitle.$cancel();
        }
        vm.dicomaetitle.$save();
      }

      var configUpdateHandler = function configUpdateHandler(message) {
        var messages = message.split(':');
        if (angular.isDefined(vm.dicomaetitle) && messages[0] === 'dicomaetitle') {
          vm.dicomaetitle.$refresh().$then(function () {
            $log.debug('debug: config refresh dicomaetitle');
          }, function (error) {
            $log.debug('debug: config refresh dicomaetitle failed: ', error);
          });
        }
      };

      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] config.update');
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('currentexamstherapies', {
    restrict: 'E',
    bindings: {
      consultid: '<'
    },
    template: '\n          <span class="btn btn-info btn-xs"\n                ng-show="vm.examinations.length"\n                popover-trigger="\'outsideClick\'"\n                uib-popover-template="vm.popover"\n                popover-title="Therapie-Einträge der Untersuchungen"\n                popover-placement="auto bottom"><i class="fa fa-list-ul"></i></span>\n          \n          \n          <script type="text/ng-template" id="examtherapies_popver.tpl.html">\n            <div>\n              <div ng-repeat="exam in vm.examinations  | filter: {active: true}">\n                <h5 ng-bind="exam.template.displayname" style="font-weight: bold"></h5>\n                <span ng-show="exam.template.recommendation.avalues.length > 0" ng-repeat="val in exam.template.recommendation.avalues">{{val.name}}{{$last ? \'\' : \', \'}}</span>\n                <span ng-hide="exam.template.recommendation.avalues.length > 0"> Keine Empfehlung</span>\n              </div>\n          \n          <p class="alert alert-info" style="margin-top: 10pt;">\n            Die Therapie-Empfehlungen der einzelnen Untersuchungen werden automatisch in den Gesamtbefund/Arztbrief übernommen.</p>\n          \n            </div>\n          </script>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window', function ($log, Rlog, Exam, vertxEventBusService, $window) {
      var vm = this;

      vm.popover = 'examtherapies_popver.tpl.html';
      vm.$onInit = function () {
        if (angular.isDefined(vm.consultid)) {
          var query = { consultid: vm.consultid };
          Exam.$search(query).$then(function (exams) {
            vm.examinations = exams;
          });
        }
      };

      // vm.consultid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            Exam.$search({ consultid: vm.consultid }).$then(function (exams) {
              vm.examinations = exams;
              // $log.debug('******* current exams : ', exams);
            }, function (err) {
              $log.error('exam lookup failed in currentexamstherapies for consultid id: ', vm.consultid);
              Rlog.error('exam', 'currentexamstherapies', 'exam lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      var examsUpdateHandler = function examsUpdateHandler(message) {
        $log.debug('exam update mesg: ', message);
        vm.examinations.$refresh();
      };

      $log.debug('[Vert.x subscribe] examinations.update');
      vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.update');
        vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('currentexamsfindings', {
    restrict: 'E',
    bindings: {
      consultid: '<'
    },
    template: '\n          <span class="btn btn-info btn-xs"\n                ng-show="vm.examinations.length"\n                popover-trigger="\'outsideClick\'"\n                uib-popover-template="vm.popover"\n                popover-title="Zusammenfassungen der Untersuchungen"\n                popover-placement="auto bottom"><i class="fa fa-list-ul"></i></span>\n          \n          \n          <script type="text/ng-template" id="examfindings_popver.tpl.html">\n            <div>\n              <div ng-repeat="exam in vm.examinations  | filter: {active: true}">\n                <h5 ng-bind="exam.template.displayname" style="font-weight: bold"></h5>\n                <span ng-show="exam.template.diagnosis.avalues.length > 0" ng-repeat="val in exam.template.diagnosis.avalues">{{val.name}}{{$last ? \'\' : \', \'}}</span>\n                <span ng-hide="exam.template.diagnosis.avalues.length > 0"> Keine Zusammenfassung</span>\n              </div>\n          \n          <p class="alert alert-info" style="margin-top: 10pt;">\n            Die Untersuchungszusammenfassungen werden automatisch in den Gesamtbefund/Arztbrief übernommen.</p>\n            </div>\n          </script>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window', function ($log, Rlog, Exam, vertxEventBusService, $window) {
      var vm = this;

      vm.popover = 'examfindings_popver.tpl.html';
      vm.$onInit = function () {
        if (angular.isDefined(vm.consultid)) {
          var query = { consultid: vm.consultid };
          Exam.$search(query).$then(function (exams) {
            vm.examinations = exams;
          });
        }
      };

      // vm.consultid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            Exam.$search({ consultid: vm.consultid }).$then(function (exams) {
              vm.examinations = exams;
              // $log.debug('******* current exams : ', exams);
            }, function (err) {
              $log.error('exam lookup failed in currentexamstherapies for consultid id: ', vm.consultid);
              Rlog.error('exam', 'currentexamstherapies', 'exam lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      var examsUpdateHandler = function examsUpdateHandler(message) {
        $log.debug('exam update mesg: ', message);
        vm.examinations.$refresh();
      };

      $log.debug('[Vert.x subscribe] examinations.update');
      vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.update');
        vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('currentexamscomments', {
    restrict: 'E',
    bindings: {
      consultid: '<'
    },
    template: '\n          <span class="btn btn-warning btn-xs"\n                ng-show="vm.examinations.length"\n                popover-trigger="\'outsideClick\'"\n                uib-popover-template="vm.popover"\n                popover-title="Anmerkungen zu den Untersuchungen"\n                popover-placement="auto bottom"><i class="fa fa-list-ul"></i></span>\n          \n          \n          <script type="text/ng-template" id="examcomments_popver.tpl.html">\n            <div>\n              <div ng-repeat="exam in vm.examinations  | filter: {active: true}">\n                <h5 ng-bind="exam.template.displayname" style="font-weight: bold"></h5>\n                <span ng-show="exam.template.comments.avalues.length > 0" ng-repeat="val in exam.template.comments.avalues">{{val.name}}{{$last ? \'\' : \', \'}}</span>\n                <span ng-hide="exam.template.comments.avalues.length > 0"> Keine Anmerkungen</span>\n              </div>\n          \n          <p class="alert alert-warning" style="margin-top: 10pt;">\n            Die Anmerkungen der einzelnen Untersuchungen werden <strong>NICHT</strong> automatisch in den Gesamtbefund/Arztbrief übernommen.</p>\n            </div>\n          </script>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window', function ($log, Rlog, Exam, vertxEventBusService, $window) {
      var vm = this;

      vm.popover = 'examcomments_popver.tpl.html';
      vm.$onInit = function () {
        if (angular.isDefined(vm.consultid)) {
          var query = { consultid: vm.consultid };
          Exam.$search(query).$then(function (exams) {
            vm.examinations = exams;
          });
        }
      };

      // vm.consultid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            Exam.$search({ consultid: vm.consultid }).$then(function (exams) {
              vm.examinations = exams;
            }, function (err) {
              $log.error('exam lookup failed in currentexamstherapies for consultid id: ', vm.consultid);
              Rlog.error('exam', 'currentexamstherapies', 'exam lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      var examsUpdateHandler = function examsUpdateHandler(message) {
        // $log.debug('exam update mesg: ', message);
        if (angular.isDefined(vm.examinations)) {
          vm.examinations.$refresh();
        }
      };

      $log.debug('[Vert.x subscribe] examinations.update');
      vertxEventBusService.on('examinations.update', {}, examsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.update');
        vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('currentexams', {
    restrict: 'E',
    bindings: {
      // examinations: '='
      consultid: '<'
    },
    templateUrl: 'vcexam/currentexams-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Exam', 'ExamHelper', 'vertxEventBusService', '$window', 'PrintHelper', '$timeout', function ($log, Rlog, Exam, ExamHelper, vertxEventBusService, $window, PrintHelper, $timeout) {
      var vm = this;
      vm.deleteExam = deleteExam;
      vm.finishExam = ExamHelper.finishExam;
      vm.showeditor = showeditor;
      vm.showview = showview;
      vm.setprint = setprint;
      vm.examPreviewUrl = PrintHelper.examPreviewUrl;

      vm.$onInit = function () {
        vm.status = {};
        vm.status.isOpen = [];
        vm.status.isOpen[0] = true;
        $log.debug('vm.status: ', vm.status);
        if (angular.isDefined(vm.consultid)) {
          var query = { consultid: vm.consultid };
          Exam.$search(query).$then(function (exams) {
            vm.examinations = exams;
          });
        }
      };

      // vm.consultid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.consultid = changes.consultid.currentValue;
          if (angular.isDefined(vm.consultid)) {
            Exam.$search({ consultid: vm.consultid }).$then(function (exams) {
              vm.examinations = exams;
              // TODO: code only needed during development, remove before final release
              for (var i = 0; i < vm.examinations.length; i++) {
                if (angular.isUndefined(vm.examinations[i].print)) {
                  vm.examinations[i].print = true;
                  vm.examinations[i].$save();
                }
              }
              // $log.debug('******* current exams : ', exams);
            }, function (err) {
              $log.error('exam lookup failed for consultid id: ', vm.consultid);
              Rlog.error('exam', 'currentexams', 'exam lookup failed', { consultid: vm.consultid });
            });
          }
        }
      };

      function setprint(exam, val) {
        exam.print = val;
        $log.debug('Changing exam print status to: ', val, exam);

        exam.$save();
      }

      function showeditor(open, edit) {
        return open === true && (angular.isUndefined(edit) || edit === true) || open === false && edit === true;
      }

      function showview(open, edit) {
        return open === true && edit === false || open === false && (edit === false || angular.isUndefined(edit));
      }

      function deleteExam(exam) {
        exam.active = false;
        if (exam.$hasPendingActions) {
          $log.warn('[EXAM][CurrentExams] exam delete save had pending actions, cancelling now.');
          exam.$cancel();
          $timeout(function () {
            $log.warn('[EXAM][CurrentExams]  waited 1.5 seconds because of exam having had pending actions, saving now.');
            savesave(exam);
          }, 1500);
        } else {
          savesave(exam);
        }
      }

      function savesave(exam) {
        exam.$save().$then(function () {
          $log.debug('exam helper factory finishexam save successful');
        }, function () {
          $log.error('exam helper factory finishexam save failed');

          Rlog.debug('exam', 'examhelperfactory', 'exam finish (save) failed', { examid: exam._id });
        });
      }

      var examCreateHandle = function examCreateHandle(message) {
        // $log.debug('debug: Exam create received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.examinations)) {
          vm.examinations.$refresh().$then(function () {
            if (angular.isDefined(vm.status) && angular.isDefined(vm.status.isOpen)) {
              vm.status.isOpen[0] = true;
            }
            $log.debug('debug: currentexams refreshed');
          }, function (error) {
            $log.debug('debug: currentexams could not refresh exams: ', error);
          });
        }
      };

      $log.debug('[Vert.x subscribe] examinations.create');
      vertxEventBusService.on('examinations.create', examCreateHandle);

      vm.$onDestroy = function () {
        $log.debug('[Vert.x unsubscribe] examinations.create');

        vertxEventBusService.unregisterHandler('examinations.create', {}, examCreateHandle);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('consultexamlist', {
    restrict: 'E',
    bindings: {
      examinations: '='
    },
    templateUrl: 'vcexam/consultexamlist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', function ($log, Rlog) {
      var vm = this;
      vm.deleteExam = deleteExam;
      vm.showeditor = showeditor;
      vm.showview = showview;

      function showeditor(open, edit) {
        return open === true && (angular.isUndefined(edit) || edit === true) || open === false && edit === true;
      }

      function showview(open, edit) {
        return open === true && edit === false || open === false && (edit === false || angular.isUndefined(edit));
      }

      function deleteExam(exam) {
        exam.active = false;
        exam.open = false;
        exam.$save().$then(function () {}, function (err) {
          $log.error('Exam delete failed for exam: ', exam._id, err);
          Rlog.debug('exam', 'currentexams', 'exam delete save failed', { examid: exam._id });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 28/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('biopsyfield', {
    restrict: 'E',
    bindings: {
      field: '=',
      bvalues: '=',
      onFieldChange: '&',
      ti: '@?'
    },
    templateUrl: 'vcexam/biopsyfield-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.loadBValues = loadBValues;

      vm.$onInit = function () {
        vm.tabi = parseInt(vm.ti, 10);
        vm.fti = 1000 + vm.tabi;

        // make copy of the field entry originally passed
        vm.laststate = angular.copy(vm.field);
        // calculate tabindex position
        vm.fti = 100 * vm.groupi + vm.tabi;
      };

      function save() {
        // save is triggered by onBlur, only save if there really have been changes to the field
        // if field changed, overwrite parent value and trigger parent change handler
        if (!angular.equals(vm.laststate, vm.field)) {
          vm.laststate = angular.copy(vm.field);
          $log.debug('calling biopsz field save');
          vm.onFieldChange();
        }
      }

      // tagsInput expects a promise that will resolve into an array, it doesn't accept arrays
      function loadBValues($query) {
        var promise = new Promise(function (resolve, reject) {
          resolve(vm.bvalues);
        });
        return promise.then(function (values) {
          return values.filter(function (value) {
            return value.name.toLowerCase().indexOf($query.toLowerCase()) !== -1;
          });
        });
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 27/04/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcexam').component('addexamdiagnoses', {
    restrict: 'E',
    bindings: {
      patientid: '<?'
    },
    templateUrl: 'vcexam/addexamdiagnoses-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Exam', 'vertxEventBusService', '$window', function ($log, Rlog, Exam, vertxEventBusService, $window) {
      var vm = this;
      vm.showexam = [];

      // vm.consultid might be late propagating, get exams on first change
      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          // if (angular.isDefined(changes.consultid.currentValue)) {
          vm.patientid = changes.patientid.currentValue;
          if (angular.isDefined(vm.patientid)) {
            Exam.$search({ patientid: vm.patientid }).$then(function (exams) {
              vm.examinations = exams;
              $log.debug('addexamdiagnoses onChanges loaded exams for patient ', vm.patientid, exams);
            }, function (err) {
              $log.error('exam lookup failed for consultid id: ', vm.patientid, err);
              Rlog.error('exam', 'currentexams', 'exam lookup failed', { patientid: vm.patientid });
            });
          }
        }
      };

      vm.sprpreview = 'Die Untersuchung wurde nachträglich editiert. Sobald die Änderung abgeschlossen ist, \n              wird ein neues PDF File erzeugt. Bis der Editiervorgang abgeschlossen ist, kann eine PDF Vorschau \n              angezeigt werden. ';
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdrug
   * @description
   *
   */
  angular.module('vcdrug', ['ngLodash', 'vcutils.config', 'vcutils.printhelper']);

  angular.module('vcdrug').filter('drugname', function () {
    return function (value) {
      if (!value) {
        return '';
      }
      return value.split(' ')[0];
    };
  });
})();
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */

// TODO: figure out what this thing is actually good for? Might be obsolete, doesn't work as expected?

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('numberofactivedrugs', {
    restrict: 'E',
    bindings: {
      patientid: '@?'
    },
    template: '\n        <span ng-bind="vm.activedrugs"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService', function ($log, Rlog, Drug, vertxEventBusService) {
      var vm = this;

      vm.$onInit = function () {
        Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
          vm.patdrugs = drugs[0];
          calculateActivedrugs(vm.patdrugs);
        });
      };

      function calculateActivedrugs(drugs) {
        vm.activedrugs = 0;
        for (var i = 0; i < drugs.drugs.length; i++) {
          if (drugs.drugs[i] && drugs.drugs[i].active === true && drugs.drugs[i].foreign === false) {
            vm.activedrugs++;
          }
        }
      }

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.patdrugs) && vm.patdrugs._id === messages[0]) {
          vm.patdrugs.$refresh().$then(function (drugs) {
            calculateActivedrugs(drugs);
            $log.debug('refreshed patdrugs active nr: ', vm.activedrugs);
          }, function (error) {
            $log.debug('refreshing patdrugs active number failed: ', error, vm.activedrugs);
          });
        }
      };

      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler());

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name drug.factory:Med
   *
   * @description
   *
   */
  angular.module('vcdrug').factory('Med', Med);

  Med.$inject = ['restmod'];
  function Med(restmod) {
    return restmod.model('/routes/meds').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/meds/medahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }, $searchpharma: function $searchpharma(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/meds/replacement';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drugprescription', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    templateUrl: 'vcdrug/drugprescription-smartcomponent.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Drug', 'Med', 'Config', 'vertxEventBusService', '$element', 'lodash', '$sce', '$window', '$timeout', function ($log, Rlog, Drug, Med, Config, vertxEventBusService, $element, _, $sce, $window, $timeout) {
      var vm = this;
      vm.ready = 'loading';
      vm.data = null;
      vm.getDrugs = getDrugs;
      vm.showdruginfo = showdruginfo;
      vm.addDrug = addDrug;
      vm.replaceDrug = replaceDrug;

      // popover templates
      vm.drugalternativestpl = 'drugalternativestpl.html';
      vm.repopovertpl = 'repopovertpl.html';
      vm.pppopovertpl = 'pppopovertpl.html';
      vm.indpopovertpl = 'indpopovertpl.html';
      vm.hintpopovertpl = 'hintpopovertpl.html';
      vm.kzpopover = 'kzpopover.html';
      vm.atcalternativestpl = 'atcalternativestpl.html';

      vm.$onInit = function () {
        Config.$find('drugconfig').$then(function (sigs) {
          //  vm.conf.drugsignature.length
          vm.conf = sigs;
          // intialize if still empty
          if (!angular.isArray(vm.conf.drugsignature)) {
            vm.drugsignature.drugsignature = [];
          }
          if (!angular.isString(vm.conf._id)) {
            vm.drugsignature._id = 'drugconfig';
          }
        });
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
            $log.info('drugs found: ', drugs);
            vm.patdrugs = drugs[0];
            vm.ready = true;
          });
        }
      };

      // drugahead drug name completion
      function getDrugs(val) {
        console.log('loading drug names');
        vm.newdrug = {};
        return Med.$searchahead({ query: val }).$asPromise().then(function (response) {
          // console.log('drug search response: ', response);
          return response.map(function (drug) {
            if (angular.isString(drug.amount) && angular.isString(drug.amounttype)) {
              drug.text = drug.name + ' (' + drug.amount + drug.amounttype + ')';
            } else {
              drug.text = drug.ZBEZ + ' (' + drug.ZLNUMM + ')';
            }
            return drug;
          });
        });
      }

      // typeahead drug search information
      function showdruginfo($item) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        var atcquery = undefined;
        var atcar = [];

        vm.newdrug = {};

        $log.debug('showdruginfo called: ', $item);
        vm.selectedDrug = $item;

        if (angular.isString(vm.selectedDrug.name)) {
          vm.newdrug.name = vm.selectedDrug.name;
        } else {
          vm.newdrug.name = vm.selectedDrug.ZBEZ;
        }
        vm.newdrug.op = 'OP I';
        vm.newdrug.permanent = true;

        // Suchtgiftvignette
        if (vm.selectedDrug.ZSUCHT === 'SG') {
          vm.newdrug.vignette = true;
          vm.newdrug.comment = 'Suchtgiftvignette! Mengenangaben aussschreiben!';
        }

        // SV Box system
        if (angular.isString(vm.selectedDrug.box)) {
          vm.newdrug.box = vm.selectedDrug.box;
        } else {

          if (vm.selectedDrug.atcarray.length === 1) {
            atcquery = { atcarray: vm.selectedDrug.atcarray[0] };
          } else {
            vm.selectedDrug.atcarray.forEach(function (a) {
              atcar.push({ atcarray: a });
            });
            atcquery = { $or: atcar };
            // var foo = {$or: [{columnA: 3}, {columnB: 'string'}]};
          }

          vm.newdrug.atcalternatives = Drug.$search(atcquery);
        }

        // Pharmanr
        if (angular.isString(vm.selectedDrug.pharmanr)) {
          vm.newdrug.pharmanr = vm.selectedDrug.pharmanr;
        }

        // Zulassungsnummer
        if (angular.isString(vm.selectedDrug.ZLNUMM)) {
          vm.newdrug.ZLNUMM = vm.selectedDrug.ZLNUMM;
        }

        // Array aller ATC codes
        if (angular.isArray(vm.selectedDrug.atcarray)) {
          vm.newdrug.atcarray = vm.selectedDrug.atcarray;
        }

        // Fachinformationen
        if (angular.isString(vm.selectedDrug.fi)) {
          // "fi" : "/fi_pdf/1-21520.pdf"
          // "fi" : "/eu_pdf/1-21520.pdf"
          vm.newdrug.fi = vm.selectedDrug.fi.replace(/_/g, '');
          vm.newdrug.fi = vm.newdrug.fi.replace(/\.pdf/g, '');
        }

        // Postion im SV ekotool preivergleich
        if (angular.isString(vm.selectedDrug.position)) {
          vm.newdrug.svpos = parseInt(vm.selectedDrug.position, 10);
        }

        // packungsgröße/art
        if (angular.isString(vm.selectedDrug.amount) && angular.isString(vm.selectedDrug.amounttype)) {
          vm.newdrug.pkgsize = vm.selectedDrug.amount + ' ' + vm.selectedDrug.amounttype;
        }

        if (angular.isString(vm.selectedDrug.amount) && !angular.isString(vm.selectedDrug.amounttype)) {
          vm.newdrug.pkgsize = vm.selectedDrug.amount;
        }

        // if (angular.isString()) {}

        // Hinweis zum Medikament
        if (vm.selectedDrug.hint) {
          vm.newdrug.hint = $sce.trustAsHtml('<div>' + vm.selectedDrug.hint + '</div>'); // overlay html must be contained in single tag
        }

        // kassenzeichen
        // KZ RE1 RE2
        if (vm.selectedDrug.kz === 'RE1' || vm.selectedDrug.kz === 'RE2') {
          vm.newdrug.re = vm.selectedDrug.kz;
        }
        if (vm.selectedDrug.recriteria) {
          $log.debug('recriteria: ', vm.selectedDrug.recriteria);
          vm.newdrug.recriteria = $sce.trustAsHtml('<div>' + vm.selectedDrug.recriteria + '</div>'); // overlay html must be contained in single tag
        }

        // KZ IND
        if (vm.selectedDrug.kz && vm.selectedDrug.kz === 'IND') {
          vm.newdrug.ind = true;
        }

        if (vm.selectedDrug.indcriteria) {
          vm.newdrug.indcriteria = $sce.trustAsHtml('<div>' + vm.selectedDrug.indcriteria + '</div>');
        }

        // All other KZ entries, use popover lookup table
        if (vm.selectedDrug.kz !== '' && vm.selectedDrug.kz !== 'RE1' && vm.selectedDrug.kz !== 'RE2' && vm.selectedDrug.kz !== 'IND') {
          vm.newdrug.kz = vm.selectedDrug.kz;
        }

        // Langzeitbewilligung
        if (vm.selectedDrug.permpermit !== '') {
          vm.newdrug.permpermit = vm.selectedDrug.permpermit;
        }

        // alternatives
        vm.newdrug.alternatives = [];
        if (angular.isArray(vm.selectedDrug.alternatives)) {
          vm.newdrug.alternatives = [];
          // reorder by price/posnr
          // sv data format is crap - alternatives are not sorted by proce/posnr
          // more than one drug can occupy the same posnr
          // at least they had the decency to leave space for ex-aequo drugs
          // if more than 3 products tie, I simply don't care, third place gets overridden
          for (var i = 0; i < vm.selectedDrug.alternatives.length; i++) {
            if (vm.selectedDrug.alternatives[i].posnr < vm.newdrug.svpos) {
              switch (vm.selectedDrug.alternatives[i].comparetype) {
                case '1':
                  vm.selectedDrug.alternatives[i].color = 'success';
                  vm.selectedDrug.alternatives[i].tooltip = 'Alternative mit gleichem Wirkstoff und gleicher Stärke';
                  break;
                case '2':
                  vm.selectedDrug.alternatives[i].color = 'warning';
                  vm.selectedDrug.alternatives[i].tooltip = 'Biosimilar, Alternative mit gleichem Wirkstoff und ähnlicher Stärke';
                  break;
                case '3':
                  vm.selectedDrug.alternatives[i].color = 'error';
                  vm.selectedDrug.alternatives[i].tooltip = 'Alternative mit anderem Wirkstoff';
                  break;
                default:
                  break;
              }
            } else {
              vm.selectedDrug.alternatives[i].color = 'default';
              vm.selectedDrug.alternatives[i].tooltip = 'Alternative ist nicht günstiger als das gewählte Produkt';
            }
            if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr - 1]) {
              vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr - 1] = vm.selectedDrug.alternatives[i];
            } else {
              if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr]) {
                vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr] = vm.selectedDrug.alternatives[i];
              } else {
                if (!vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 1]) {
                  vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 1] = vm.selectedDrug.alternatives[i];
                } else {
                  vm.newdrug.alternatives[vm.selectedDrug.alternatives[i].posnr + 2] = vm.selectedDrug.alternatives[i];
                }
              }
            }
          }

          // type 3: Anderer Wirkstoff
          for (var i = 0; i < vm.newdrug.svpos; i++) {
            if (vm.newdrug.alternatives[i].comparetype === '3') {
              vm.newdrug.alttype = 'danger';
              vm.newdrug.alttypetext = 'Alternativen mit anderen Wirkstoffen sind günstiger';
            }
          }

          // type 2: Gleicher Wirkstoff, andere Dosis, Biosimilars
          for (var i = 0; i < vm.newdrug.svpos; i++) {
            if (vm.newdrug.alternatives[i].comparetype === '2') {
              vm.newdrug.alttype = 'warning';
              vm.newdrug.alttypetext = 'Alternativen mit Biosimilars (gleicher Wirkstoff, ähnliche Stärke) sind günstiger';
            }
          }

          // type 1: Gleicher Wirkstoff, gleiche Stärke
          for (var i = 0; i < vm.newdrug.svpos; i++) {
            if (vm.newdrug.alternatives[i].comparetype === '1') {
              vm.newdrug.alttype = 'success';
              vm.newdrug.alttypetext = 'Alternativen mit gleichem Wirkstoff und gleicher Stärke sind günstiger';
            }
          }

          // if med was already in first position, greyout alternatives option
          if (vm.newdrug.svpos === 1) {
            vm.newdrug.alttype = 'default';
            vm.newdrug.alttypetext = 'Dieses Medikament ist das günstigste mit diesem Wirkstoff und dieser Stärke';
          }

          $log.debug('selected drug: ', vm.selectedDrug);
          $log.debug('new drug: ', vm.newdrug);
        } // rebuild alternatives
      }

      function replaceDrug(replacement) {
        //          $log.debug('replacement: ', replacement.pharmanr);
        Med.$searchpharma({ pharmanr: replacement.pharmanr }).$asPromise().then(function (rdrug) {
          vm.newdrug = {};
          vm.showdruginfo(rdrug[0]);
          if (rdrug.length > 1) {
            $log.error('Pharmanr search returned more than one result');
          }
        });
      }

      function addDrug() {
        delete vm.noResults;
        vm.newdrug.color = 'primary';
        vm.newdrug.foreign = false;
        vm.newdrug.active = true;
        vm.newdrug.startDate = moment().toISOString();
        vm.newdrug.print = true;
        if (!vm.newdrug.permanent) {
          vm.newdrug.endDate = moment().add(14, 'days').toISOString();
        }
        vm.patdrugs.drugs.push(vm.newdrug);
        // calculateActivedrugs();
        vm.patdrugs.$save();
        vm.selectedDrug = {};
        vm.newdrug = {};
        vm.newdrug.op = 'OP I';
        vm.asyncSelected = '';
      }

      // sprhelp texte
      vm.sprgen = '';
      vm.sprsearch = 'Bitte geben Sie mindestens drei Buchstaben ein, um Medikamentenvorschläge zu erhalten.\n            Medikamente die sich in der Green Box oder Yellow Box des Erstattungscodex befinden, werden nach\n            Packungsgröße getrennt angezeigt. Günstigere Alternativen werden nach auswahl eines Medikaments rechts\n            bzw. unterhalb nach Preis gestaffelt angezeigt. Sie können Nahrungsergänzungsmittel, Tees, udgl.\n            durch Ausschreiben des Prodktnames verordnen. Den Hinweis, dass kein entsprechendes Medikament gefunden wurde,\n            ignorieren Sie in diesem Fall einfach.';

      vm.sprsignature = 'W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.\n            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.';
      vm.sprpkgsize = 'Die Packungsgr&ouml;&szlig;e wird bei Medikamenten, die von der Krankenkasse erstattet werden,\n            automatisch ausfeg&uuml;ellt.';
      vm.sprpkgnr = 'Wenn f&uuml;r langzeitbewilligbare Medikamente mehr als drei Packungen erforderlich sind,\n            vermerken Sie das bitte unter dem L\'x\' Hinweis im Rezeptvermerk.';
      vm.sprduration = 'Anla&szlig;bezogene Medikation (z.B. Antibiotika) wird 14 Tage nach der Verschreibung automatisch deaktiviert\n             und ist danach nur noch in der Medikationshistorie ersichtlich.\n             Dauermedikation (z.B. Beta-Blocker) verbleibt in der Medikamentenliste des Patienten bis Sie es manuell absetzen.';
      vm.sprcomment = 'Im Falle einer Suchgiftverschreibung ergänzen Sie bitte Packungszanzahl und Dosierung in Worten:\n             z.B. zweihundert Milligramm, eine Packung. Bei Suchtgiften für den eigenen Gebrauch ergänzen\n             Sie bitte "pro ordinatione" oder "für N.N.".';
      vm.sprind = 'Verschreibungen die bestimmten Indikationen unterleigen wir der Vermerk "IND" automatisch angebracht.\n             Es empfiehlt sich zusätzlich die jeweilige Indikation im Rezeptvermerk anzuführen.\n             Die zulässigen Indikationen entnehmen Sie bitte der obigen "IND" Schaltfläche';

      var configUpdateHandler = function configUpdateHandler(message) {
        $log.debug('******** config update received: ', message);
        var messages = message.split(':');

        if (angular.isDefined(vm.conf)) {
          if (messages[0] === 'drugsignature') {
            vm.conf.$refresh().$then(function () {
              $log.debug('******* config refresh drugsignatures');
            }, function (error) {
              $log.debug('******* config refresh drugsignatures failed: ', error);
            });
          }
        }
      };

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
          vm.patdrugs.$refresh().$then(function (drugs) {
            $log.debug('refreshed patdrugs for drugprescription: ', vm.patdrugsid);
            // only show vm. drug_saved when change was triggered by this browser
            if (messages[1] === $window.sessionStorage.getItem('sprtabid')) {
              vm.drug_saved = true;
              $timeout(function () {
                delete vm.drug_saved;
              }, 3000);
              $log.debug('(drugprescription) drug saved');
            }
          }, function (error) {
            $log.debug('refreshing patdrugs drugprescription failed: ', error, vm.patdrugsid);
          });
        }
      };

      // update dugsignature list TODO: doesnt work, needs backend update message
      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      // update patientdrugs
      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of drugs (patients) to display or load drugs */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('druglist', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n        <hr class="spacer-bottom spacer-top">\n        <h4>Medikationsliste</h4>\n          <div class="alert alert-info" ng-show="vm.ready === \'loading\'">\n            <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...\n          </div>\n          <div class="alert alert-info" ng-show="vm.totalcount === 0">\n            <i class="fa fa-info-circle"></i> Keine Medikationsdaten gefunden!\n          </div>\n        <div ng-hide="vm.totalcount === 0">\n          <span class="btn btn-success" ng-click="vm.prescriptionPrint(vm.patientid)">\n            <i class="fa fa-print" ng-hide="vm.printstarted"></i>\n            <i class="fa fa-spinner fa-spin" ng-show="vm.printstarted"></i> Rezept(e) drucken</span>\n          <a class="btn btn-primary" ng-show="vm.pdfbinurl"  href="{{vm.pdfbinurl}}" target="_blank">\n            <i class="fa fa-eye"></i> Neuerstelltes Rezept ansehen\n          </a>\n          <a class="btn btn-info" href="{{vm.prescriptionPreview(vm.patientid)}}" target="_blank">\n            <i class="fa fa-eye"></i> Rezept(e) Vorschau\n          </a>\n          <a class="btn btn-info" href="{{vm.lastfileUrl}}" ng-show="vm.lastfileUrl" target="_blank">\n            <i class="fa fa-eye"></i> {{vm.lastfileName}}\n          </a>\n        </div>\n        <div><input type="checkbox" ng-model="vm.patdrugs.printdate" ng-change="vm.save()"> Datum auf Rezept</div>\n        <table class="table table-striped"  ng-hide="vm.totalcount === 0">\n          <thead>\n          <tr>\n            <th>Drucken <sprhelp tip="Rezept f&uuml;r Medikament drucken" descref="vm.sprprint"></sprhelp></th>\n            <th>Aktuell <sprhelp tip="Dauermedikation oder aktuelle Anla&szlig;medikation"></sprhelp></th>\n            <th>Name</th>\n            <th>Einnahme</th>\n            <th>Pkg Anzahl</th>\n            <th>Aktion</th>\n          </tr>\n          </thead>\n          <tr ng-repeat="drug in vm.patdrugs.drugs | orderBy: [\'-active\', \'foreign\']" ng-class="{druginactive: !drug.active}">\n            <td><input type="checkbox" ng-model="drug.print" ng-show="drug.foreign === false && drug.active === true" ng-change="vm.save()"></td>\n            <td><input type="checkbox" ng-model="drug.active" disabled></td>\n            <td>\n                <span class="label label-{{drug.color}}" ng-show="drug.active === true">{{drug.name}}</span>\n                <span ng-show="drug.active === false" style="color: #999999">{{drug.name}}</span>\n                <span ng-show="drug.foreign === true"> (Fremdverordnung)</span>\n                <span ng-show="drug.converted === true"> (Konvertierte&nbsp;Fremdverordnung)</span>\n            </td>\n            <td ng-bind="drug.amount" ng-show="drug.foreign === false || drug.active === false"></td>\n            <td ng-show="drug.foreign === true && drug.active === true">\n            <input class="form-control" ng-model="drug.amount" ng-blur="vm.editForeign(drug, oldamount)" ng-focus="oldamount = drug.amount">                              \n            </td>\n            <td ng-bind="drug.op"></td>\n            <td>\n              <button class="btn btn-primary"\n                      ng-show="drug.foreign === false && drug.active === true"\n                      ng-click="vm.editDrug(drug)">\n                 <i class="fa fa-edit" uib-tooltip="Editieren"></i>\n              </button>\n              <sprhelp ng-show="drug.foreign === false && drug.active === true"\n                       tip="Rezept ab&auml;ndern" descref="vm.spredit"></sprhelp>\n              <button class="btn btn-success"\n                      ng-show="drug.foreign === false && drug.active === false"\n                      ng-click="vm.reactivateDrug(drug)">\n                 <i class="fa fa-repeat" uib-tooltip="Wieder verschreiben"></i>\n              </button>\n              <sprhelp ng-show="drug.foreign === false && drug.active === false"\n                       tip="Wieder verschreiben" descref="vm.spractivate"></sprhelp>\n              <button class="btn btn-warning"\n                      ng-show="drug.foreign === true && drug.active === true"\n                      ng-click="vm.convertDrug(drug)">\n                 <i class="fa fa-retweet" uib-tooltip="Fremdverordnung in Eigenverordnung umwandeln"></i>\n              </button>\n              <sprhelp ng-show="drug.foreign === true && drug.active === true"\n                       tip="Fremdverordnung in Eigenverordnung umwandeln" descref="vm.sprconvert"></sprhelp>\n            </td>\n          </tr>\n        </table>\n      ',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Drug', 'vertxEventBusService', '$uibModal', 'PrintHelper', 'Document', '$timeout', function ($log, $http, Rlog, Drug, vertxEventBusService, $uibModal, PrintHelper, Document, $timeout) {
      var vm = this;
      // vm.editDrug = DrugHelper.editDrug;
      vm.editDrug = editDrug;
      vm.save = save;
      vm.editForeign = editForeign;
      vm.convertDrug = convertDrug;
      vm.reactivateDrug = reactivateDrug;
      vm.checkSignatureUpdate = checkSignatureUpdate;
      vm.prescriptionPrint = prescriptionPrint;
      vm.prescriptionPreview = PrintHelper.prescriptionPreviewUrl;

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          getPatdrugs();
        }
      };

      function getPatdrugs() {
        Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
          vm.patdrugs = drugs[0];
          if (angular.isUndefined(vm.patdrugs.printdate)) {
            vm.patdrugs.printdate = true;
          }
          $log.info('patdrugs search result: ', drugs);
          calcdrugs(vm.patdrugs);
          vm.ready = true;
        });
        lastprint(vm.patientid);
      }

      function convertDrug(drug) {
        var tmpdrug = angular.copy(drug);
        tmpdrug.patdrugsnr = getPatdrugsnr();
        tmpdrug.startDate = moment().toISOString();
        tmpdrug.endate = moment().add(14, 'days').toISOString();
        tmpdrug.print = true;
        tmpdrug.op = 'OP I';
        tmpdrug.foreign = false;
        tmpdrug.color = 'primary';
        tmpdrug.permanent = false;
        tmpdrug.converted = true;
        $log.debug('converted drug: ', tmpdrug);
        vm.patdrugs.drugs.push(tmpdrug);
        save();
      }

      function reactivateDrug(drug) {
        // reactivate by copying record with a new startdate
        var tmpdrug = angular.copy(drug);
        tmpdrug.startDate = moment().toISOString();
        if (!drug.permanent) {
          tmpdrug.endate = moment().add(14, 'days').toISOString();
        }
        tmpdrug.print = true;
        tmpdrug.active = true;
        vm.patdrugs.drugs.push(tmpdrug);
        save();
      }

      function save() {
        if (vm.patdrugs.$hasPendingActions()) {
          vm.patdrugs.cancel();
        }
        vm.patdrugs.$save();
      }

      function getPatdrugsnr() {
        return moment().unix() + '_' + Math.floor(Math.random() * 1000 + 1);
      }

      function editDrug(ldrug) {
        var dialog = $uibModal.open({
          template: '\n                   <div class="modalspacer">\n                        <drugeditor drug="drugeCtrl.drug" parentsave="drugeCtrl.childsave(drug)" oncancel="drugeCtrl.cancel()"></drugeditor>\n                   </div>\n              ',
          controllerAs: 'drugeCtrl',
          controller: ['drug', 'drugs', function (sdrug, sdrugs) {
            var lvm = this;
            lvm.drug = sdrug;
            lvm.childsave = childsave;
            lvm.cancel = cancel;

            function childsave(drug) {
              // vm.drug = angular.copy(drug);
              // the abouve code threw an restmod error, despite actually saving
              // the below variant does not raise an error
              if (ldrug.amount !== drug.amount) {
                var tmpdrug = angular.copy(drug);
                tmpdrug.startDate = moment().toISOString();
                if (!tmpdrug.permanent) {
                  tmpdrug.endDate = moment().add(14, 'days').toISOString();
                }
                if (tmpdrug.permanent && tmpdrug.endDate) {
                  delete tmpdrug.endDate;
                }

                ldrug.active = false;
                ldrug.print = false;
                ldrug.endDate = moment().toISOString();
                sdrugs.push(tmpdrug);
              } else {
                // ldrug = angular.copy(drug);
                for (var key in drug) {
                  if (drug.hasOwnProperty(key)) {
                    ldrug[key] = drug[key];
                  }
                }
              }
              save();
              dialog.close();
            }

            function cancel() {
              dialog.close();
            }
          }],
          resolve: {
            drug: function drug() {
              return ldrug;
            },
            drugs: function drugs() {
              return vm.patdrugs.drugs;
            }
          },
          size: 'lg'
        });
        return dialog;
      }

      function editForeign(drug, oldamount) {
        if (drug.amount !== oldamount && drug.amount.length > 0) {
          var newfdrug = angular.copy(drug);
          drug.amount = oldamount;
          var now = moment().toISOString();
          newfdrug.startDate = now;
          drug.endDate = now;
          drug.active = false;
          vm.patdrugs.drugs.push(newfdrug);
          vm.patdrugs.$save();
        } else {
          drug.amount = oldamount;
        }
      }

      function calcdrugs(drugs) {
        vm.ready = 'done';
        vm.activecount = 0;
        vm.totalcount = 0;
        if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
          vm.totalcount = drugs.drugs.length;
          var saveneeded = 0;
          for (var i = 0; i < drugs.drugs.length; i++) {
            // deactivate expired "once-off" drugs
            if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].end && drugs.drugs[i].end < moment().toISOString()) {
              drugs.drugs[i].active = false;
              drugs.drugs[i].print = false;
              saveneeded++;
            }
            if (drugs.drugs[i] && drugs.drugs[i].active) {
              vm.activecount++;
            }
            if (saveneeded > 0) {
              save();
            }
          }
        } else {
          vm.activecount = 0;
          vm.totalcount = 0;
        }
      }

      function prescriptionPrint(patientid) {
        vm.printstarted = true;
        if (vm.patdrugs.printdate === true) {
          vm.patdrugs.date = moment().format('ll');
          // $log.debug('[][][] new date: ', vm.patdrugs.date);
        } else {
            vm.patdrugs.date = '';
            // $log.debug('no date: ', vm.patdrugs.date);
          }
        if (vm.patdrugs.$hasPendingActions()) {
          vm.patdrugs.cancel();
          $log.debug('[VCDRUG][DRUGLIST][PRESCRIPTIONPRINT] cancelling pending actions');
          // some delay between cancel and retry is needed
          $timeout(reallyPrint(patientid), 1500);
        } else {
          reallyPrint(patientid);
        }
      }

      function reallyPrint(patientid) {
        vm.patdrugs.$save().$then(function (patdrugs) {
          $log.debug('[VCDRUG][DRUGLIST][prescriptionPrint] saved before print succeeded: ', patdrugs);
          PrintHelper.prescriptionPrint(patientid).then(function (pdfbin) {
            $log.debug('[VCDRUG][DRUGLIST][prescriptionPrint] print succeeded: ', pdfbin);
            vm.printstarted = false;
            vm.pdfbinurl = '/routes/pdfreader/' + pdfbin.data.docid;
          }, function (err) {
            $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] prescriptionPrint failed', err);
          });
        }, function (err) {
          // TODO: super weird error - the call is ok, but the error handler is called WTF! see dms.scan.filebrowser for similar problem
          $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] save before print failed - or not: ', err);
          // ignore error and try anyway
          PrintHelper.prescriptionPrint(patientid).then(function (pdfbin) {
            vm.printstarted = false;
            vm.pdfbinurl = '/routes/pdfreader/' + pdfbin.data.docid;
          }, function (printerr) {
            $log.error('[VCDRUG][DRUGLIST][prescriptionPrint] prescriptionPrint failed', printerr);
            Rlog.error('vcdrug.druglist', 'prescriptionPrint', 'Printing of prescription pdf failed for patient: ', { patientid: patientid });
          });
        });
      }

      function lastprint(patientid) {
        Document.$getLast(patientid, 'prescription').$then(function (lastdocarray) {
          $log.debug(' ###### lastdocarr: ', lastdocarray);
          if (lastdocarray.length === 1) {
            var lastdoc = lastdocarray[0];
            vm.lastfileUrl = '/routes/pdfreader/' + lastdoc._id;
            vm.lastfileName = 'Letztes Rezept vom ' + lastdoc.fdate + ', ' + lastdoc.ftime;
          }
        }, function (err) {
          $log.error('prescription lookup failed for patientid: ', patientid, err);
        });
      }

      function checkSignatureUpdate(drug) {
        $log.debug('**************** checkSignatureUpdate called for: ', drug);
        if (angular.isString(drug.newamount) && drug.newamount.length > 0) {
          if (drug.newamount !== drug.amount) {
            // copy drug
            var tmpdrug = angular.copy(drug);
            // create new drug
            tmpdrug.startDate = moment().toISOString();
            tmpdrug.amount = tmpdrug.newamount;
            delete tmpdrug.newamount;
            // deactive old drug
            drug.active = false;
            drug.endDate = moment().toISOString();
            $log.debug('drug: ', drug);
            $log.debug('tmpdrug: ', tmpdrug);
            vm.patient.drugs.push(tmpdrug);
            $log.debug('vm.patdrugs after: ', vm.patdrugs.drugs);
            save();
          } else {
            drug.newamount = '';
          }
        }
      }

      vm.sprconvert = 'Wandeln Sie die Fremdverordnung wir in eine befristete Eigenverordnung um damit Sie\n            ein Rezept f&uuml; eine Fremdverordnung austellen k&ouml;nnen. Die Fremdverodnung bleibt erhalten,\n            die resultierende Eigenverordnung wird nach 14 Tagen automatisch deaktiviert.';

      vm.spractivate = 'Reaktivieren sie bereits fr&uuml;her verschriebene Anla&szlig;medikation oder\n            abgesetzte Dauermedikation. Die zuletzt verwendendeten Rezepteinstellungen bleiben erhalten.';
      vm.spredit = '&Auml;ndern Sie Einnahmeanweisung/Signatur, Packungsanzahl, Rezeptvermerk und Dauermedikationststatus.\n            Beim &Auml;nderungen an der Einnahmeanweisung/Signatur wird das Medikament abgesetzt und\n            mit neuer Einnahmeanweisung neuverschrieben, damit Sie &Uuml;berblick\n            &uuml;ber Dosis&auml;nderungen behalten.';
      vm.sprprint = 'Markierte Medikamente werden als Rezept(e) gedruckt. Die Aufteilung erfolgt automatisch.\n            Suchtgiftrezepte und bewilligungspflichtige werden gesondert ausgefolgt.';

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        // if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
        if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id)) {
          vm.patdrugs.$refresh().$then(function () {
            $log.debug('[vcdrug][druglist] refreshed patdrugs for druglist: ', vm.patdrugsid);
            calcdrugs(vm.patdrugs);
            vm.ready = true;
          }, function (error) {
            $log.debug('[vcdrug][druglist] refreshing patdrugs for druglist failed: ', error, vm.patdrugsid);
          });
        } else {
          getPatdrugs();
          $log.debug('[vcdrug][druglist] refreshed patdrugs for druglist, inital fetch for an undfined patdrug ');
        }
      };

      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name drug.factory:Drug
   *
   * @description
   *
   */
  angular.module('vcdrug').factory('DrugInteraction', DrugInteraction);

  DrugInteraction.$inject = ['restmod'];

  function DrugInteraction(restmod) {
    return restmod.model('/routes/druginteractions').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true }
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('druginteraction', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n      <div>\n        <span ng-repeat="int in vm.ints | orderBy: \'-Grad\'"\n            class="btn" ng-class="int.Grad" ng-bind="int.Grad"\n            uib-tooltip="{{int.Eff}}" popover-trigger="outsideClick"\n                      uib-popover-template="vm.intpopovertpl" popover-title="{{int.Eff}}"\n                      popover-placement="auto bottom"\n            ></span>\n      </div>\n      <!-- Alternativen Pop-Over -->\n      <script type="text/ng-template" id="intpopover.html">\n          <div style="padding: 20px"><!-- template must be enclosed by single tag -->\n          <h4 ng-show="int.Eff">Effekt</h4>\n          <p ng-show="int.Eff">{{int.Eff}}</p>\n          <h4 ng-show="int.Mechanismus">Mechanismus</h4>\n          <p ng-show="int.Mechanismus">{{int.Mechanismus}}</p>\n          <h4>Medikamente</h4>\n          <ul>\n            <li ng-show="int.drugname1">\n              {{int.drugname1}} ({{int.Atc1}}<span ng-show="int.Name1"> , {{int.Name1}}</span>)\n            </li>\n            <li ng-show="int.drugname2">\n              {{int.drugname2}} ({{int.Atc2}}<span ng-show="int.Name2"> , {{int.Name2}}</span>)\n            </li>\n            <li ng-repeat="n in int.drugnames track by $index">{{n}} ({{int.Atc1}})</li>\n          </ul>\n          <h4>Klinik: {{int.Kli}}</h4>\n          <p>{{int.Klinik}}</p>\n          <h4 ng-show="int.Pmids">Publikationen</h4>\n          <ul ng-show="int.Pmids">\n            <li ng-repeat="pub in int.Pmids.split(\',\')">\n              <a href="https://www.ncbi.nlm.nih.gov/pubmed/?term={{pub}}" target="_blank">PubMed {{pub}}</a>\n            </li>\n          </ul>\n          </div>\n      </script>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'DrugInteraction', 'Drug', 'Rlog', 'vertxEventBusService', '$http', function ($log, DrugInteraction, Drug, Rlog, vertxEventBusService, $http) {
      var vm = this;
      vm.intpopovertpl = 'intpopover.html';

      vm.$onInit = function () {

        DrugInteraction.$search({ patientid: vm.patientid }).$then(function (int) {
          $log.debug(int);
          vm.interactions = int;
        });

        // we need to lookup patdrugs to be able to trigger interaction refresh on patdrugs update
        Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
          vm.patdrugs = drugs[0];
          var drugsByAtc = {};
          var atcs = [];
          vm.ints = [];
          vm.intsnix = [];
          for (var i = 0; i < vm.patdrugs.drugs.length; i++) {
            if (vm.patdrugs.drugs[i] && vm.patdrugs.drugs[i].active) {
              if (angular.isArray(vm.patdrugs.drugs[i].atcarray)) {
                for (var j = 0; j < vm.patdrugs.drugs[i].atcarray.length; j++) {
                  if (drugsByAtc.hasOwnProperty(vm.patdrugs.drugs[i].atcarray[j])) {
                    drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]].push(vm.patdrugs.drugs[i]);
                  } else {
                    atcs.push(vm.patdrugs.drugs[i].atcarray[j]);
                    drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]] = [];
                    drugsByAtc[vm.patdrugs.drugs[i].atcarray[j]].push(vm.patdrugs.drugs[i]);
                  }
                }
              } else {
                var tmpz = {
                  Grad: 'U',
                  Kli: 'Dieses Medikament hat keinen ATC Wirkstoffcode. Es k&ouml;nnen keine Aussagen zu Interaktionen getroffen werden.',
                  drugname1: vm.patdrugs.drugs[i].name
                };
                vm.ints.push(tmpz);
              }
            }
          }
          // $log.debug('*********** drugsByAtc array: ', drugsByAtc, atcs);

          Object.keys(drugsByAtc).forEach(function (atc) {
            if (drugsByAtc[atc].length > 1) {
              var tmpz = {
                Grad: 'Y',
                Kli: 'Mögliche Überdosierung.',
                Klinik: 'Es wurden mehrere Medikamente mit dem selben Wirkstoff verordnet. Möglicherweise liegt eine Überdosierung vor.',
                Atc1: atc
              };

              var drugnames = [];
              for (var i = 0; i < drugsByAtc[atc].length; i++) {
                drugnames.push(drugsByAtc[atc][i].name);
              }
              tmpz.drugnames = drugnames;
              vm.ints.push(tmpz);
            }
          });
          // $log.debug('*********** ints array: ', vm.ints);

          var _loop = function (i) {
            var _loop2 = function (j) {

              $http.get('/routes/druginteractions/' + atcs[i] + '/' + atcs[j]).then(function (int) {
                // $log.debug('******* interaction i, j, int: ', atcs[i], atcs[j], int.data, int.data[0]);
                if (int.data.length > 0) {
                  var tmp = int.data[0];
                  $log.debug('}} dru by atc: ', drugsByAtc[atcs[i]]);
                  tmp.drugname1 = drugsByAtc[atcs[i]][0].name;
                  tmp.drugname2 = drugsByAtc[atcs[j]][0].name;
                  vm.ints.push(tmp);
                } else {
                  var tmp = {
                    Grad: 'Z',
                    Kli: 'Es wurden keine Interaktionsdaten gefunden.',
                    Klinik: 'Es wurden keine Interaktionsdaten gefunden. Es können keine Aussagen zu Interaktionen getroffen werden.'
                  };
                  tmp.Atc1 = atcs[i];
                  tmp.Atc2 = atcs[j];
                  tmp.drugname1 = drugsByAtc[atcs[i]][0].name;
                  tmp.drugname2 = drugsByAtc[atcs[j]][0].name;
                  vm.intsnix.push(tmp);
                }
              }); // $http.get
            };

            for (var j = i + 1; j < atcs.length; j++) {
              _loop2(j);
            }
          };

          for (var i = 0; i < atcs.length; i++) {
            _loop(i);
          } // loop i
          // $log.debug('*********** ints array: ', vm.ints);
        });
      };

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.patdrugs)) {
          if (vm.patdrugs._id === messages[0]) {
            vm.interactions.$refresh().$then(function () {
              $log.debug('refreshed interactions for: ', vm.patientid);
            }, function (error) {
              $log.debug('refreshing interactions failed: ', error, vm.patientid);
            });
          }
        }
      };

      // refresh interactions on patdrugschange
      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global vis*/
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drughistory', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n        <hr class="spacer-bottom spacer-top">\n        <h4>Medikationshistorie</h4>\n          <div class="alert alert-info" ng-show="vm.ready === \'loading\'">\n            <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...\n          </div>\n          <div class="alert alert-info" ng-show="vm.totalcount === 0">\n            <i class="fa fa-info-circle"></i> Keine Medikationsdaten gefunden!\n          </div>\n          <div id="drughistoryvis" ng-show="vm.totalcount > 0"></div>\n          <div class="spacer-bottom">&nbsp;</div>\n        </div>\n  ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService', '$element', 'lodash', '$document', function ($log, Rlog, Drug, vertxEventBusService, $element, _, $document) {
      var vm = this;
      vm.ready = 'loading';

      // Create the timeline object
      var viselement = angular.element($document[0].querySelectorAll('#drughistoryvis'));
      vm.timeline = new vis.Timeline(viselement[0]);

      // vm.patientid might be late propagating, get files on first change
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          getPatdrugs(vm.patientid);
        }
      };

      function getPatdrugs(patientid) {
        Drug.$searchBy('patientid', patientid).$then(function (drugs) {
          vm.patdrugs = [];
          if (angular.isArray(drugs) && drugs.length > 0) {
            vm.patdrugs = drugs[0];
            $log.info('getPatdrugs patdrugs search result as vm.patdrugs: ', vm.patdrugs);
            calcdrugs(vm.patdrugs);
            drawdrugs(vm.patdrugs);
          }
        });
      }

      function calcdrugs(drugs) {
        vm.ready = 'done';
        vm.activecount = 0;
        vm.totalcount = 0;
        if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
          vm.totalcount = drugs.drugs.length;
          var saveneeded = 0;
          for (var i = 0; i < drugs.drugs.length; i++) {
            // deactivate expired "once-off" drugs
            if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].end && drugs.drugs[i].end < moment().toISOString()) {
              drugs.drugs[i].active = false;
              drugs.drugs[i].print = false;
              saveneeded++;
            }
            if (drugs.drugs[i] && drugs.drugs[i].active) {
              vm.activecount++;
            }
            if (saveneeded > 0) {
              drugs.$save();
            }
          }
        } else {
          vm.activecount = 0;
          vm.totalcount = 0;
        }
      }

      function drawdrugs(drugs) {
        $log.debug('drawdrugs drugs: ', drugs);
        vm.ready = 'done';

        vm.totalcount = drugs.drugs.length;
        vm.activecount = 0;

        // create timeline data set
        // vis-timeline expects a data object containing items[]
        vm.data = {};
        vm.data.items = [];
        var atcs = ['UNBEKANNT'];
        var zlnumms = [];
        var pharmanrs = [];

        for (var i = 0; i < drugs.drugs.length; i++) {
          if (drugs.drugs[i]) {
            var item = {};

            // set item content
            if (angular.isString(drugs.drugs[i].name)) {
              item.content = drugs.drugs[i].name.split(' ')[0] + ', ' + drugs.drugs[i].amount;
            } else {
              item.content = drugs.drugs[i].amount;
            }

            // set item title/tooltip
            item.title = drugs.drugs[i].name + ', ' + drugs.drugs[i].amount;

            // attach comment to drug title/tooltip
            // comment is prescription comment
            if (angular.isString(drugs.drugs[i].comment)) {
              item.title += ', ';
              item.title += drugs.drugs[i].comment;
            }
            // privcomment is doctor only comment e.g reasons for change, termination, ...
            if (angular.isString(drugs.drugs[i].privcomment)) {
              item.title += ', ';
              item.title += drugs.drugs[i].privcomment;
            }
            // handle date, pseudo-end permanent medikation in 5 days time for better graphical representation
            item.start = drugs.drugs[i].startDate;
            if (angular.isString(drugs.drugs[i].endDate)) {
              item.end = drugs.drugs[i].endDate;
            } else {
              // item.end = new Date();
              item.end = moment().add(5, 'days').toISOString();
            }
            item.className = drugs.drugs[i].color;
            // set group to atc drugtype or drug nr
            if (angular.isArray(drugs.drugs[i].atcarray) && drugs.drugs[i].atcarray.length > 0) {
              item.group = drugs.drugs[i].atcarray[0];
              atcs.push(drugs.drugs[i].atcarray[0]);
            } else if (angular.isDefined(drugs.drugs[i].ZLNUMM)) {
              item.group = drugs.drugs[i].ZLNUMM;
              zlnumms.push(drugs.drugs[i].ZLNUMM);
            } else if (angular.isDefined(drugs.drugs[i].pharmanr)) {
              item.group = drugs.drugs[i].pharmanr;
              pharmanrs.push(drugs.drugs[i].pharmanr);
            } else {
              item.group = 'UNBEKANNT';
            }

            item.id = 'drughistitem' + i;
            vm.data.items.push(item);
          } // if drug not null
        } // iterate over drugs

        var options = {
          locale: 'de-at'

        };
        var groups = [];

        var a = _.uniq(atcs);
        var z = _.uniq(zlnumms);
        var p = _.uniq(pharmanrs);

        if (a.length > 0) {
          for (var i = 0; i < a.length; i++) {
            var tmp = {};
            tmp.id = a[i];
            tmp.content = 'ATC ' + a[i];
            groups.push(tmp);
          }
        }
        if (z.length > 0) {
          for (var i = 0; i < z.length; i++) {
            var tmp = {};
            tmp.id = z[i];
            tmp.content = 'ZLNUMM ' + z[i];
            groups.push(tmp);
          }
        }
        if (p.length > 0) {
          for (var i = 0; i < p.length; i++) {
            var tmp = {};
            tmp.id = p[i];
            tmp.content = 'PharmaNr ' + p[i];
            groups.push(tmp);
          }
        }

        vm.timeline.setOptions(options);
        vm.timeline.setItems(vm.data.items);
        vm.timeline.setGroups(groups);
        vm.timeline.redraw();
      } // drawdrugs

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        var messages = message.split(':');
        // if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
        if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id)) {
          vm.patdrugs.$refresh().$then(function (drugs) {
            drawdrugs(drugs);
            $log.debug('[vcdrug][drughistory] refreshed patdrugs for drughistory: ', vm.patientid);
          }, function (error) {
            $log.error('[vcdrug][drughistory] refreshing patdrugs for drughistory failed: ', error, vm.patientid);
          });
        } else {
          $log.debug('[vcdrug][drughistory] refreshed patdrugs for drughistory, inital fetch for an undefined patdrug ');
          getPatdrugs();
        }
      };

      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drugforeign', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n        <h4>Fremdverordnung vermerken</h4>\n        <form class="form-vertical" name="newfdrugform">\n            <div class="row">\n                <div class="col-xs-12 col-md-6">\n                    <label for="newfdrugname">Medikament <span uib-tooltip="Plichtfeld">*</span><sprhelp tip="Geben Sie mindestens 3 Zeichen um die Suche zu starten"></sprhelp></label>\n                    <input class="form-control" ng-model="vm.newfdrug.name"\n                           type="text" class="form-control" placeholder="Medikament oder PharmaNr."\n                           autocomplete="noway"\n                           typeahead-on-select="vm.showfdruginfo($item)"\n                           typeahead-min-length="3"\n                           uib-typeahead="drug as drug.text for drug in vm.getDrugs($viewValue)"\n                           typeahead-loading="loadingNames"\n                           id="newfdrugname"\n                           select-first-match="false"\n                           typeahead-no-results="vm.noFDResults"\n                           required\n                    />\n                    <div ng-show="vm.noFDResults" style="color: #cc3333; font-weight: bold">\n                        <i class="fa fa-warning"></i> Keine Medikamente gefunden!\n                    </div>\n                </div>\n                <div class="col-xs-12 col-md-6">\n                    <div class="form-group">\n                        <label for="fdrugamount">Einnahme <span uib-tooltip="Plichtfeld">*</span> <sprhelp tip="Ausw&auml;hlen oder eingeben" descref="vm.sprsignature"></sprhelp> </label>\n                        <div class="input-group">\n                            <input class="form-control" ng-model="vm.newfdrug.amount" id="fdrugamount"\n                                   autocomplete="noway" autocorrect="off" autocapitalize="off" spellcheck="false"\n                                   placeholder="1-0-1-0" required ng-class="{ \'has-error\': newfdrugform.$invalid }">\n                            <div class="input-group-btn" uib-dropdown>\n                                <button type="button" class="btn btn-default" uib-dropdown-toggle><span class="caret"></span>\n                                </button>\n                                <ul id="famountmenu" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu>\n                                    <li ng-click="vm.newfdrug.amount=\'1-0-0\'">1-0-0</li>\n                                    <li ng-click="vm.newfdrug.amount=\'1-0-1\'">1-0-1</li>\n                                    <li ng-click="vm.newfdrug.amount=\'0-1-0\'">0-1-0</li>\n                                    <li ng-click="vm.newfdrug.amount=\'0-0-1\'">0-0-1</li>\n                                    <li ng-click="vm.newfdrug.amount=\'1-1-1\'">1-1-1</li>\n                                    <li ng-click="vm.newfdrug.amount=\'0-0-0-1\'">0-0-0-1</li>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12">\n                    <button class="btn btn-success" type="submit" ng-disabled="!newfdrugform.$valid"\n                            ng-click="vm.addForeignDrug()">\n                       <span ng-show="vm.drug_saved"><i class="fa fa-check" ></i>&nbsp;Fremdverordnung gespeichert</span>\n                       <span ng-hide="vm.drug_saved">Fremdverordnung speichern</span>\n                    </button>\n                </div>\n            </div>\n        \n        </form>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Drug', 'Med', 'vertxEventBusService', '$element', 'lodash', '$sce', 'Config', '$timeout', '$window', function ($log, Rlog, Drug, Med, vertxEventBusService, $element, _, $sce, Config, $timeout, $window) {
      var vm = this;
      vm.ready = 'loading';
      vm.data = null;
      vm.getDrugs = getDrugs;
      vm.showfdruginfo = showfdruginfo;
      vm.addForeignDrug = addForeignDrug;

      vm.$onInit = function () {
        vm.newfdrug = {};

        Config.$find('drugconfig').$then(function (sigs) {
          //  vm.conf.drugsignature.length
          vm.conf = sigs;
          // intialize if still empty
          if (!angular.isArray(vm.conf.drugsignature)) {
            vm.drugsignature.drugsignature = [];
          }
          if (!angular.isString(vm.conf._id)) {
            vm.drugsignature._id = 'drugconfig';
          }
        });
      };

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
            $log.info('found existing patdrug record: ', drugs);
            vm.patdrugs = drugs[0];
            vm.ready = true;
          });
        }
      };

      // drugahead drug name completion
      function getDrugs(val) {
        console.log('loading drug names');
        vm.newdrug = {};
        return Med.$searchahead({ query: val }).$asPromise().then(function (response) {
          // console.log('drug search response: ', response);
          return response.map(function (drug) {
            if (angular.isString(drug.amount) && angular.isString(drug.amounttype)) {
              drug.text = drug.name + ' (' + drug.amount + drug.amounttype + ')';
            } else {
              drug.text = drug.ZBEZ + ' (' + drug.ZLNUMM + ')';
            }
            return drug;
          });
        });
      }

      // show foreign drug info
      function showfdruginfo($item) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.newfdrug = {};

        $log.debug('showfdruginfo called: ', $item);
        vm.selectedfDrug = $item;

        if (angular.isString(vm.selectedfDrug.name)) {
          vm.newfdrug.name = vm.selectedfDrug.name;
        } else {
          vm.newfdrug.name = vm.selectedfDrug.ZBEZ;
        }

        vm.newfdrug.permanent = true;

        // Pharmanr
        if (angular.isString(vm.selectedfDrug.pharmanr)) {
          vm.newfdrug.pharmanr = vm.selectedfDrug.pharmanr;
        }

        // Zulassungsnummer
        if (angular.isString(vm.selectedfDrug.ZLNUMM)) {
          vm.newfdrug.ZLNUMM = vm.selectedfDrug.ZLNUMM;
        }

        // Array aller ATC codes
        if (angular.isArray(vm.selectedfDrug.atcarray)) {
          vm.newfdrug.atcarray = vm.selectedfDrug.atcarray;
        }

        // Fachinformationen
        if (angular.isString(vm.selectedfDrug.fi)) {
          // "fi" : "/fi_pdf/1-21520.pdf"
          // "fi" : "/eu_pdf/1-21520.pdf"
          vm.newfdrug.fi = vm.selectedfDrug.fi.replace(/_/g, '');
          vm.newfdrug.fi = vm.newfdrug.fi.replace(/\.pdf/g, '');
        }

        if (angular.isString(vm.selectedfDrug.amount) && !angular.isString(vm.selectedfDrug.amounttype)) {
          vm.newfdrug.pkgsize = vm.selectedfDrug.amount;
        }

        // if (angular.isString()) {}

        // Hinweis zum Medikament
        if (vm.selectedfDrug.hint) {
          vm.newfdrug.hint = $sce.trustAsHtml('<div>' + vm.selectedfDrug.hint + '</div>'); // overlay html must be contained in single tag
        }

        // kassenzeichen
        // KZ RE1 RE2
        if (vm.selectedfDrug.kz === 'RE1' || vm.selectedfDrug.kz === 'RE2') {
          vm.newfdrug.re = vm.selectedfDrug.kz;
        }
        if (vm.selectedfDrug.recriteria) {
          $log.debug('recriteria: ', vm.selectedfDrug.recriteria);
          vm.newfdrug.recriteria = $sce.trustAsHtml('<div>' + vm.selectedfDrug.recriteria + '</div>'); // overlay html must be contained in single tag
        }

        // KZ IND
        if (vm.selectedfDrug.kz && vm.selectedfDrug.kz === 'IND') {
          vm.newfdrug.ind = true;
        }

        if (vm.selectedfDrug.indcriteria) {
          vm.newfdrug.indcriteria = $sce.trustAsHtml('<div>' + vm.selectedfDrug.indcriteria + '</div>');
        }

        // All other KZ entries, use popover lookup table
        if (vm.selectedfDrug.kz !== '' && vm.selectedfDrug.kz !== 'RE1' && vm.selectedfDrug.kz !== 'RE2' && vm.selectedfDrug.kz !== 'IND') {
          vm.newfdrug.kz = vm.selectedfDrug.kz;
        }
      }

      function addForeignDrug() {
        delete vm.noFDResults;
        vm.newfdrug.color = 'info';
        vm.newfdrug.foreign = true;
        vm.newfdrug.permanent = true;
        vm.newfdrug.active = true;
        vm.newfdrug.startDate = moment().toISOString();
        vm.newfdrug.print = false;
        vm.patdrugs.drugs.push(vm.newfdrug);
        vm.newfdrug = null;
        vm.selectedDrug = {};
        vm.asyncSelected = '';
        vm.patdrugs.$save();
      }

      // sprhelp texte
      vm.sprgen = '';

      vm.sprsignature = 'W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.\n            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.';

      vertxEventBusService.on('patdrugs.update', function (message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
          vm.patdrugs.$refresh().$then(function (drugs) {
            $log.debug('refreshed patdrugs for drughistory: ', vm.patdrugsid);
            // only show vm. drug_saved when change was triggered by this browser
            if (messages[1] === $window.sessionStorage.getItem('sprtabid')) {
              vm.drug_saved = true;
              $timeout(function () {
                delete vm.drug_saved;
              }, 3000);
              $log.debug('(drugprescription) saved drug');
            }
          }, function (error) {
            $log.debug('refreshing patdrugs fordrughistory failed: ', error, vm.patdrugsid);
          });
        }
      });

      var configUpdateHandler = function configUpdateHandler(message) {
        $log.debug('******** config update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.conf)) {
          if (messages[0] === 'drugsignature') {
            vm.conf.$refresh().$then(function () {
              $log.debug('******* config refresh drugsignatures');
            }, function (error) {
              $log.debug('******* config refresh drugsignatures failed: ', error);
            });
          }
        }
      };

      // update dugsignature list TODO: doesnt work, needs backend update message
      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drugeditor', {
    restrict: 'E',
    bindings: {
      drug: '<',
      parentsave: '&',
      parentadd: '&',
      oncancel: '&'
    },
    templateUrl: 'vcdrug/drugeditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Drug', 'Config', 'vertxEventBusService', function ($log, Drug, Config, vertxEventBusService) {
      var vm = this;
      vm.save = save;
      vm.cancel = cancel;

      vm.$onInit = function () {
        vm.lastdrug = angular.copy(vm.drug);
        vm.tmpdrug = angular.copy(vm.drug);

        Config.$find('drugconfig').$then(function (sigs) {
          //  vm.conf.drugsignature.length
          vm.conf = sigs;
          // intialize if still empty
          if (!angular.isArray(vm.conf.drugsignature)) {
            vm.drugsignature.drugsignature = [];
          }
          if (!angular.isString(vm.conf._id)) {
            vm.drugsignature._id = 'drugconfig';
          }
        });
      };

      function save() {
        vm.lastdrug = angular.copy(vm.tmpdrug);
        vm.parentsave({ drug: vm.tmpdrug });
      }

      function cancel() {
        vm.canceled = true;
        vm.oncancel();
      }

      var configUpdateHandler = function configUpdateHandler(message) {
        $log.debug('******** config update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.conf)) {
          if (messages[0] === 'drugsignature') {
            vm.conf.$refresh().$then(function () {
              $log.debug('******* config refresh drugsignatures');
            }, function (error) {
              $log.debug('******* config refresh drugsignatures failed: ', error);
            });
          }
        }
      };

      // update dugsignature list TODO: doesnt work, needs backend update message
      vertxEventBusService.on('config.update', {}, configUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('config.update', {}, configUpdateHandler);
      };

      vm.sprsignature = 'W&auml;hlen Sie aus der Liste oder geben Sie eine andere Anweisung ein.\n            Sie k&ouml;nnen die Auswahlliste im Einstellungsmenu unter Einstellungen &auml;ndern.';
      vm.sprpkgsize = 'Die Packungsgr&ouml;&szlig;e wird bei Medikamenten, die von der Krankenkasse erstattet werden,\n            automatisch ausfeg&uuml;ellt.';
      vm.sprpkgnr = 'Wenn f&uuml;r langzeitbewilligbare Medikamente mehr als drei Packungen erforderlich sind,\n            vermerken Sie das bitte unter dem L\'x\' Hinweis im Rezeptvermerk.';
      vm.sprduration = 'Anla&szlig;bezogene Medikation (z.B. Antibiotika) wird 14 Tage nach der Verschreibung automatisch deaktiviert\n             und ist danach nur noch in der Medikationshostorie ersichtlich.\n             Dauermedikation (z.B. Beta-Blocker) verbleibt in der Medikamentenliste des Patienten bis Sie es manuell absetzen.';
    }] // controllerkde
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of drugs (patdrugss) to dispay or load drugs/patdrugss depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drugcurrent', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n    <h4>Aktuelle Medikamente</h4>\n    <div class="input-group">\n      <div class="alert alert-info" ng-show="vm.ready === \'loading\'">\n        <i class="fa fa-spinner fa-spin"></i> Medikation wird geladen ...\n      </div>\n      <div class="alert alert-info" ng-show="vm.activecount === 0 && vm.totalcount > 0">\n        <i class="fa fa-info-circle"></i> Keine aktuelle Medikation gefunden!\n      </div>\n      <div class="alert alert-info" ng-show="vm.activecount === 0 && vm.totalcount === 0">\n        <p><i class="fa fa-info-circle"></i> Keine Medikation gefunden!</p>\n        <!--<p ng-show="vm.state.indexOf(\'drug\') < 0"><i class="fa fa-lightbulb-o"></i> Sie können Medikamente unter dem\n          <a ui-sref="patientrecord.drugs(vm.params)">Karteireiter Medikamente</a> verordnen und dokumentieren.</p>-->\n      </div>\n      <span ng-repeat="drug in vm.patdrugs.drugs" id="quuxbar">\n        <span ng-show="drug.active && vm.datecheck(drug)" uib-dropdown>\n          <button type="button" class="btn btn-{{drug.color}}" uib-dropdown-toggle\n                  ng-class="{\'btn-outline\': drug.foreign}"\n                  data-toggle="uib-dropdown" aria-haspopup="true" aria-expanded="false"\n                  uib-tooltip="{{drug.name}} / {{drug.amount}} / {{drug.privcomment}}">\n            {{drug.name | drugname }} {{drug.amount}}  <i ng-show="drug.converted" class="fa fa-retweet"></i> <span class="caret"></span>\n          </button>\n          <ul uib-dropdown-menu>\n            <li>\n              <a ng-click="vm.updateDrugColor(drug, \'success\')">\n                <span class="label label-success">Grün (Erfolg)</span>\n              </a>\n            </li>\n            <li>\n              <a ng-click="vm.updateDrugColor(drug, \'warning\')">\n                <span class="label label-warning">Gelb (Warnung)</span>\n              </a>\n            </li>\n            <li>\n              <a ng-click="vm.updateDrugColor(drug, \'danger\')">\n                <span class="label label-danger">Rot (Gefahr)</span>\n              </a>\n            </li>\n            <li>\n              <a ng-click="vm.updateDrugColor(drug, \'info\')">\n                <span class="label label-info">Türkis (Information)</span>\n              </a>\n            </li>\n            <li>\n              <a ng-click="vm.updateDrugColor(drug, \'primary\')">\n                <span class="label label-primary">Blau (Aktuell)</span>\n              </a>\n            </li>\n    \n            <li>\n              <a ng-really-message="Dieses Medikament wirklich absetzen?"\n                 ng-really-click="vm.deactivateDrug(drug)">\n                <span class="label label-danger">X</span> Medikament absetzen\n              </a>\n            </li>\n            <li role="separator" class="divider"></li>\n              <form id="commentform">\n              <label for="dcomment">Kommentar</label>\n              <textarea class="form-control dropdown" ng-model="drug.privcomment" id="dcomment"\n                     ng-click="$event.stopPropagation()"\n                     ng-blur="vm.save()"></textarea>\n              </form>\n            </li>\n            <li role="separator"   ng-show="drug.fi" class="divider"></li>\n            <li ng-show="drug.fi"><a\n                   href="/routes{{drug.fi}}" target="_blank"\n                   uib-tooltip="Fachinformationen"><span class="fa fa-file-pdf-o btn btn-info btn-sm"></span> Fachinformationen</a></li>\n          </ul>\n        </span>\n      </span><!-- ng-repeat -->\n    </div>\n  ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Drug', 'vertxEventBusService', '$state', function ($log, Rlog, Drug, vertxEventBusService, $state) {
      var vm = this;
      vm.deactivateDrug = deactivateDrug;
      vm.updateDrugColor = updateDrugColor;
      vm.datecheck = datecheck;
      vm.save = save;

      $log.debug('[vcdrug][drugcurrent] state in drugcurrent: ', $state);
      vm.state = $state.current.name;
      vm.params = $state.current.params;

      vm.ready = 'loading';

      /*          vm.$onInit = function () {
                  if (angular.isDefined(vm.patientid) && vm.patientid.length > 0) {
                    Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
                      vm.patdrugs = drugs[0];
                      calcdrugs(vm.patdrugs);
                    });
                  }
                };*/

      // vm.patientid might be late propagating, get files on first change
      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          getPatdrugs();
        }
      };

      function getPatdrugs() {
        Drug.$searchBy('patientid', vm.patientid).$then(function (drugs) {
          $log.info('[vcdrug][drugcurrent] retrieved existing patdrug record: ', drugs);
          vm.patdrugs = drugs[0];
          $log.debug('[vcdrug][drugcurrent] vm.patdrugs: ', vm.patdrugs);
          calcdrugs(vm.patdrugs);
          $log.debug('[vcdrug][drugcurrent] fixed vm.patdrugs: ', vm.patdrugs);
        });
      }

      // patientid might be late on propagating
      function calcdrugs(drugs) {
        vm.ready = 'done';
        if (angular.isDefined(drugs) && angular.isDefined(drugs.drugs)) {
          vm.totalcount = drugs.drugs.length;
          var saveneeded = 0;
          for (var i = 0; i < drugs.drugs.length; i++) {
            // deactivate expired "once-off" drugs
            if (drugs.drugs[i] && drugs.drugs[i].active && drugs.drugs[i].endDate && drugs.drugs[i].endDate < moment().toISOString()) {
              drugs.drugs[i].active = false;
              drugs.drugs[i].print = false;
              saveneeded++;
            }
            if (saveneeded > 0) {
              vm.save();
            }
          }
        } else {
          vm.activecount = 0;
          vm.totalcount = 0;
        }
      }

      function updateDrugColor(drug, color) {
        drug.color = color;
        vm.save();
      }

      function datecheck(drug) {
        return !moment(drug.endDate).isBefore(moment());
      }

      function deactivateDrug(drug) {
        drug.active = false;
        drug.print = false;
        drug.endDate = moment().toISOString();
        vm.save();
      }

      function save() {
        if (vm.patdrugs.$hasPendingActions()) {
          vm.patdrugs.$cancel();
        }
        vm.patdrugs.$save();
      }

      var patdrugsUpdateHandler = function patdrugsUpdateHandler(message) {
        // $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        // if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id) && vm.patdrugs._id === messages[0]) {
        if (angular.isDefined(vm.patdrugs) && angular.isDefined(vm.patdrugs._id)) {
          vm.patdrugs.$refresh().$then(function (drugs) {
            calcdrugs(drugs);
            $log.debug('[vcdrug][drugcurrent] refreshed patdrugs for patdrugs: ', vm.patientid);
          }, function (error) {
            $log.error(error);
            $log.debug('[vcdrug][drugcurrent] refreshing patdrugs for patdrugs failed: ', error, vm.patientid);
          });
        } else {
          getPatdrugs();
        }
      };

      vertxEventBusService.on('patdrugs.update', {}, patdrugsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patdrugs.update', {}, patdrugsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcdrug').component('drugconfig', {
    restrict: 'E',
    bindings: {},
    template: '\n      <div class="panel panel-info">\n        <div class="panel-heading">\n          <h3>Medikamenten-Signaturen</h3>\n        </div>\n        <div class="panel-body"></div>\n          <div class="modalspacer">\n            <label>Häufig gebrauchte Medikamentensignaturen</label>\n            <listeditor list="vm.drugsignature.drugsignature" parentsave="vm.childsave(list)"></listeditor>\n          </div>\n        </div>\n  ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'Config', 'vertxEventBusService', function ($log, Rlog, Config, vertxEventBusService) {
      var vm = this;
      vm.childsave = childsave;

      vm.$onInit = function () {
        // vm.drugsignature = Config.$find('drugconfig');

        Config.$find('drugconfig').$then(function (sigs) {
          vm.drugsignature = sigs;
          // intialize if still empty
          if (!angular.isArray(vm.drugsignature.drugsignature)) {
            vm.drugsignature.drugsignature = [];
          }
          if (!angular.isString(vm.drugsignature._id)) {
            vm.drugsignature._id = 'drugconfig';
          }
        });
      };

      function childsave(list) {
        vm.drugsignature.drugsignature = list;
        save();
      }

      function save() {
        if (vm.drugsignature.$hasPendingActions()) {
          vm.drugsignature.$cancel();
        }
        vm.drugsignature.$save();
      }

      var consfigUpdateHandler = function consfigUpdateHandler(message) {
        // $log.debug('debug: config update received: ', message);
        var messages = message.split(':');
        if (messages[0] === 'drugsignature') {
          vm.drugsignature.$refresh().$then(function () {
            $log.debug('debug: config refresh drugsignatures');
          }, function (error) {
            $log.debug('debug: config refresh drugsignatures failed: ', error);
          });
        }
      };

      vertxEventBusService.on('config.update', {}, consfigUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('config.update', {}, consfigUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcdrug').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.drug', {
      url: '/drug',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;drugcurrent patientid="" &gt;</tt></h3><div ui-view="drugcurrent"></div>\n              <h3 class="alert alert-info"><tt>&lt;druginteraction patientid="" &gt;</tt></h3><div ui-view="druginteraction"></div>\n              <h3 class="alert alert-info"><tt>&lt;drugprescription patientid=""&gt;</tt></h3><div ui-view="drugprescriptionview"></div>\n              <h3 class="alert alert-info"><tt>&lt;drugforeign patientid=""&gt;</tt></h3><div ui-view="drugforeignview"></div>\n              <h3 class="alert alert-info"><tt>&lt;drughistory patientid=""&gt;</tt></h3><div ui-view="drughistoryview"></div>\n              <h3 class="alert alert-info"><tt>&lt;drugactivenumber&gt;</tt></h3><div ui-view="drugactiveview"></div>\n              <h3 class="alert alert-info"><tt>&lt;druglist patientid=""&gt;</tt></h3><div ui-view="druglistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;drugconfig&gt;</tt></h3><div ui-view="drugconfigview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.vcdrug entered');
      }
    });

    $stateProvider.state('playground.drug.allcomponents', {
      url: '/allcomponents',
      resolve: {
        drug: function drug() {
          return '';
        },
        drugref: function drugref() {
          return '';
        },
        patid: function patid() {
          return '58499f4c878f751a3eab5019';
        },
        somedrug: function somedrug(Drug) {
          return Drug.$find('572b31b07c01597e3e150923');
        },
        alldrugs: function alldrugs(Drug) {
          return Drug.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (drug, drugref) {
            console.log('debug: dummy parentsave called for drugsearch with: ', drug, drugref);
          };
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'drugcurrent@playground.drug': {
          component: 'drugcurrent',
          bindings: {
            patientid: 'patid'
          }
        },
        'druginteraction@playground.drug': {
          component: 'druginteraction',
          bindings: {
            patientid: 'patid'
          }
        },
        'drughistoryview@playground.drug': {
          component: 'drughistory',
          bindings: {
            patientid: 'patid'
          }
        },
        'drugprescriptionview@playground.drug': {
          component: 'drugprescription',
          bindings: {
            patientid: 'patid'
          }
        },
        'drugforeignview@playground.drug': {
          component: 'drugforeign',
          bindings: {
            patientid: 'patid'
          }
        },
        'drugeditview@playground.drug': {
          component: 'drugeditor',
          bindings: {
            patientid: 'patid'
          }
        },
        'drugactiveview@playground.drug': {
          component: 'numberofactivedrugs',
          bindings: {
            patientid: 'patid'
          }
        },
        'druglistview@playground.drug': {
          component: 'druglist',
          bindings: {
            patientid: 'patid'
          }
        },
        'drugconfigview@playground.drug': {
          component: 'drugconfig'
        }
      },
      onEnter: function onEnter() {
        console.log('playground.drug.allcomponents entered');
      }
    });
  } // all routes
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name drug.factory:Drug
   *
   * @description
   *
   */
  angular.module('vcdrug').factory('Drug', Drug);

  Drug.$inject = ['restmod'];
  function Drug(restmod) {
    return restmod.model('/routes/patdrugs').mix({
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      drugs: { init: [] },
      active: { init: true },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/patdrugs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      } // extend
    });
  }

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdms
   * @description
   *
   */
  angular.module('vcdms', ['vcdms.vcfile', 'vcdms.vcdocument', 'vcdms.vcscan', 'vcdms.vcdoctype', 'vcdms.vcpdfprinter', 'vcdms.vcprinter']);
})();
/**
 * Created by lari on 09/06/2017.
 */
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name consult
   * @description
   *
   */
  angular.module('vcconsult', ['ui.router', 'ui.bootstrap', 'vcclient',
  // 'drug',
  // 'document',
  'vcfinance.cart', 'vcexam', 'vcexamtemplate', 'vcpatdocs', 'vcdrug', 'knalli.angular-vertxbus', 'cfp.hotkeys', 'vcutils.doctor', 'vcutils.rlog', 'vcutils.sprhelp', 'vcutils.printhelper', 'vcdms', 'vcdms.vcfile']);
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('recentconsultlist', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="alert alert-info"  ng-show="vm.recentconsults.length === 0">Keine kürzlich geschlossenen Konsultationen</div>\n        <div ng-repeat="rc in vm.recentconsults" ng-show="vm.recentconsults.length > 0">\n          <a ui-sref="patientrecord.current({patientid: rc.patientid, clientid: rc.patientid, mode: \'patient\'})">\n            <span class="pull-left"><img class="img-responsive" style="max-width: 80px" ng-src="{{rc.patimage}}"></span>\n            <h4  style="padding-left: 1em; margin-left: 1em">&nbsp;{{rc.patfirstname}} {{rc.patlastname}}<br>{{rc.patbdate}}</h4>\n            <span class="clearfix"></span>\n          </a>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', function ($log, Consult, Rlog, vertxEventBusService) {
      var vm = this;

      vm.$onInit = function () {
        var cutoff = moment().subtract(1, 'd');
        var comp = cutoff.toISOString();
        Consult.$search({ open: false, active: true, created: { $gte: comp } }).$then(function (rc) {
          vm.recentconsults = rc;
        }, function (err) {
          $log.error('Loading list of recent consults failed: ', err);
          Rlog.error('vcconsult', 'recentconsultlist', 'Loading list of open consults failed', {});
        });
      }; // $onInit()

      var consultUpdateHandler = function consultUpdateHandler(message) {
        if (angular.isDefined(vm.recentconsults) && angular.isDefined(vm.recentconsults.$refresh)) {
          vm.recentconsults.$refresh().$then(function () {
            $log.debug('Loading list of recently closed consults succeeded: ', message);
          }, function (err) {
            $log.error('Loading list of open consults failed: ', err);
            Rlog.error('vcconsult', 'recentconsultlist', 'refreshing list of recently closed consults failed', {});
          });
        }
      };

      // listen for consult updates
      vertxEventBusService.on('consults.update', {}, consultUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('consults.update', {}, consultUpdateHandler);
      };
    }] // controller

  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('openconsultlist', {
    restrict: 'E',
    bindings: {},
    template: '\n        <div class="alert alert-info"  ng-show="vm.openconsults.length === 0">Keine offenen Konsultationen</div>\n        <div ng-repeat="oc in vm.openconsults" ng-show="vm.openconsults.length > 0">\n          <a ui-sref="patientrecord.current({patientid: oc.patientid, clientid: oc.patientid, mode: \'patient\'})">\n            <span class="pull-left"><img class="img-responsive" style="max-width: 80px" ng-src="{{oc.patimage}}"></span>\n            <h4  style="padding-left: 1em; margin-left: 1em">&nbsp;{{oc.patfirstname}} {{oc.patlastname}}<br>{{oc.patbdate}}</h4>\n            <span class="clearfix"></span>\n          </a>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', function ($log, Consult, Rlog, vertxEventBusService) {
      var vm = this;

      vm.$onInit = function () {
        Consult.$search({ open: true, active: true }).$then(function (oc) {
          vm.openconsults = oc;
        }, function (err) {
          $log.error('Loading list of open consults failed: ', err);
          Rlog.error('vcconsult', 'openconsultlist', 'Loading list of open consults failed', {});
        });
      }; // $onInit()

      var consultUpdateHandler = function consultUpdateHandler(message) {
        if (angular.isDefined(vm.openconsults) && angular.isDefined(vm.openconsults.$refresh)) {
          vm.openconsults.$refresh().$then(function () {
            $log.debug('Loading list of open consults succeeded: ', message);
          }, function (err) {
            $log.error('Loading list of open consults failed: ', err);
            Rlog.error('vcconsult', 'openconsultlist', 'refreshing list of open consults failed', {});
          });
        }
      };

      // listen for consult updates
      vertxEventBusService.on('consults.update', {}, consultUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('consults.update', {}, consultUpdateHandler);
      };
    }] // controller

  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('openconsultcounter', {
    restrict: 'E',
    bindings: {},
    template: '\n        <span class="badge badge-info" ng-bind="vm.counter"  uib-tooltip="Offene Konsultationen"  tooltip-placement="auto"></span>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', '$http', function ($log, Consult, Rlog, vertxEventBusService, $http) {
      var vm = this;

      var getCounter = function getCounter() {
        var query = [{
          $match: {
            open: true,
            active: true
          }
        }, {
          $group: {
            _id: null,
            counter: { $sum: 1 }
          }
        }];

        $http.post('/routes/consults/aggregate', query).then(function (res) {
          vm.counter = 0;
          // $log.debug('**** Counter data: ', res.data );
          if (res.data.counter) {
            vm.counter = res.data.counter;
          }
        }, function (err) {
          Rlog.error('consult', 'openconsultcounter', 'consult.$aggregate failed', {});
          $log.error(err);
        });
      };

      vm.$onInit = function () {
        getCounter();
      }; // $onInit()

      // listen for consult updates
      vertxEventBusService.on('consults.update', {}, getCounter);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('consults.update', {}, getCounter);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/*
* Consultsummary is the provides the consutlist accordion header contents
* starred, date, consult keywords, examlabels
* */
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultsummary', {
    restrict: 'E',
    bindings: {
      consult: '<'
    },
    templateUrl: 'vcconsult/consultsummary-component.tpl.html',
    controllerAs: 'vm',
    controller: [function () {
      /* eslint "no-unused-vars": [0, {"args": "none"}] */
      var vm = this;
    }]
  });
  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultsearch', {
    restrict: 'E',
    bindings: {
      consult: '<',
      consultref: '<',
      parentsave: '&?',
      editinplace: '@?',
      ti: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group">\n                <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                   ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                   placeholder="Kürzel"\n                   ng-model="vm.asyncSelected"\n                   typeahead-on-select="$parent.$dismiss();vm.showconsult($item, $model, $label)"\n                   uib-typeahead="consult as consult.text for consult in vm.getConsults($viewValue)"\n                   typeahead-loading="loadingNames"\n                   typeahead-no-results="noResults">\n            <span class="input-group-btn">\n              <button type="submit"\n                      ng-class="{\'btn-warning\': noResults, \'btn-info\': !noResults}"\n                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n            </span>\n          </div>\n        </div>\n        \n        \n        <i ng-show="loadingNames" class="fa fa-spin fa-spinner"></i>\n        <div ng-show="noResults">\n          <i class="fa fa-warning"></i> Keine SV gefunden\n          <span class="btn btn-success" ng-click="vm.addConsult()" ng-hide="vm.error">Neue Sozialversicherung eingeben</span>\n          <span ng-click="vm.addConsult()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Sozialversicherung konnte nicht angelegt werden!</span>\n        </div>\n        \n        <div ng-show="vm.editinplace === true">\n          <consulteditor consult="vm.consult"></consulteditor>\n        </div>\n        \n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'ConsultHelper', function ($log, Consult, ConsultHelper) {
      var vm = this;
      vm.save = save;
      vm.showconsult = showconsult;

      vm.getConsults = getConsults;
      // vm.addConsult = ConsultHelper.addConsult;
      vm.addConsult = addConsult;
      vm.editConsult = ConsultHelper.editConsult;

      vm.$onInit = function () {
        vm.newconsult = {};

        if (angular.isDefined(vm.editinplace) && vm.editinplace === 'true') {
          vm.editinplace = true;
        }

        $log.debug('debug - editinplace', vm.editinplace);

        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }
        vm.lastconsult = angular.copy(vm.consultresult);
        vm.lastconsultref = angular.copy(vm.consultref);
      };

      function addConsult() {
        $log.debug('debug - consultsearch addConsult called');
        ConsultHelper.addConsult(function (consult) {
          $log.debug('debug: handle newly create consult');
          vm.consult = {};
          vm.consult.name = consult.name;
          vm.consult.short = consult.short;
          vm.consult._id = consult._id;
          vm.consultref = consult._id;
          vm.asyncSelected = consult.short;
          vm.parentsave({ consult: vm.consult, consultref: vm.consultref });
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead consult search backend query
      function getConsults(val) {
        // return Consultahead.$search({query: val}).$asPromise().then(function (response) {
        return Consult.$searchahead({ query: val }).$asPromise().then(function (response) {
          return response.map(function (consult) {
            consult.text = consult.short;
            delete vm.error;
            return consult;
          });
        });
      }

      // typeahead consult search action
      function showconsult($item, $model, $label) {
        /* eslint "no-unused-vars": [0, {"args": "none"}] */
        vm.consult = $model;
        vm.consultref = $model._id;
        delete vm.asyncSelected;
        vm.editinplace = true;
        $log.debug('debug - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
        if (vm.editinplace === true) {
          vm.consult = $model;
          vm.consultref = $model._id;
          $log.debug('debug - consultsearch editinplace');
        } else {
          vm.consult = {};
          vm.consult.name = $model.name;
          vm.consult.short = $model.short;
          vm.consult._id = $model._id;
          vm.consultref = $model._id;
          vm.parentsave({ consult: vm.consult, consultref: vm.consultref });
          $log.debug('debug - consultsearch do not  editinplace', vm.parentsave);
        }
      }

      function save() {
        if (!angular.equals(vm.consult, vm.lastconsult) || !angular.equals(vm.consultref, vm.lastconsultref)) {
          vm.lastconsult = angular.copy(vm.consult);
          vm.lastconsultref = angular.copy(vm.consultref);
          vm.parentsave({ consult: vm.consult, consultref: vm.consultref });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultrecord', {
    restrict: 'E',
    bindings: {
      patientid: '<'
    },
    template: '\n      <div class="consultrecord-component" data-hook="consultrecord-component">\n        <consultnew ng-if="vm.show === \'new\' || vm.consult.open === false"\n                    patientid="vm.patientid" oncreate="vm.oncreate(consult)"></consultnew>\n        <carteditorstandalone ng-if="vm.show === \'new\' || vm.consult.open === false"\n                    clientid="vm.patientid"></carteditorstandalone>\n        <consulteditor ng-if="vm.show === \'consult\'"\n                       consultid="vm.consultid" startcheckout="vm.startcheckout()"\n                       onfinish="vm.onfinish(consultid)"></consulteditor>\n        <!--<consultfinish ng-show="vm.show === \'consult\' && vm.consult.open === false" consultid="vm.consultid" onfinish="vm.onfinish(consult)"></div>-->\n        <div ng-show="vm.show === \'error\'">\n          <div class="alert alert-danger">\n              <h3>Mehrere offene Konsultationen für diesen Patienten gefunden!</h3>\n              <p>Wählen Sie eine Konsultation aus um mit dieser fortzufahren. Alle anderen Konsultationen werden geschlossen.</p>\n          </div>\n          <div ng-repeat="cons in vm.openconsults">\n            <span class="pull-left">Konsultation vom {{cons.fdate}}</span>\n            <span class="pull-right"><span class="btn btn-success" ng-click="vm.keepconsult($index)">Konsultation weiterführen</span> </span>\n            <span class="clearfix"></span>\n          </div>\n            <div class="spacer-top"><span class="btn btn-warning" ng-click="vm.keepconsult(-1)">Alle Konsultationen schließen</span> </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'Rlog', 'vertxEventBusService', '$window', function ($log, Consult, Rlog, vertxEventBusService, $window) {
      var vm = this;
      vm.startcheckout = startcheckout;
      vm.onfinish = onfinish;
      vm.oncreate = oncreate;
      vm.keepconsult = keepconsult;

      /*
                vm.$onInit = function () {
                  $log.debug('consultrecord on Init patid: ', vm.patientid);
                  getConsult();
                };*/

      vm.$onChanges = function (changes) {
        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          vm.patientid = changes.patientid.currentValue;
          getConsult();
        }
      }; // $onInit

      function startcheckout() {
        vm.show = 'finish';
      }

      function getConsult() {
        Consult.$search({ patientid: vm.patientid, active: true, open: true }).$then(function (consults) {
          $log.debug('consultrecord number of active open consults: ', consults.length);
          switch (consults.length) {
            case 0:
              vm.show = 'new';
              delete vm.consult;
              break;
            case 1:
              vm.show = 'consult';
              vm.consult = consults[0];
              vm.consultid = consults[0]._id;
              break;
            default:
              vm.show = 'error';
              vm.openconsults = consults;
              break;
          }
        }, function (err) {
          $log.error('consult not found, id: ', vm.consultid, err);
          Rlog.error('consult', 'consulteditor', 'consult not found', { _id: vm.consultid });
        });
      }

      function keepconsult(index) {
        for (var i = 0; i < vm.openconsults.length; i++) {
          vm.show = 'new';
          if (i !== index) {
            vm.openconsults[i].open = false;
            vm.openconsults[i].$save();
          } else {
            vm.consult = vm.openconsults[index];
            vm.show = 'consult';
          }
        }
      }

      function onfinish(consultid) {
        $log.debug(' ### consultrecord on finish called consultid: ', consultid);
        vm.show = 'new';
      }

      function oncreate(consult) {
        vm.consult = consult;
        vm.consultid = consult._id;
        $log.debug(' ### consultrecord on create vm.consult: ', vm.consult);
        vm.show = 'consult';
      }

      var consultCreateHandler = function consultCreateHandler(message) {
        $log.debug(' ### consultrecord  Consults create received: ', message);
        var messages = message.split(':');
        if (messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
          $log.debug(' ### consultrecord received consult create from other tab/client for: ', messages[0]);
          if (vm.show !== 'consult') {
            getConsult(vm.patientid);
          }
        }
      };

      var consultCloseHandler = function consultCloseHandler(message) {
        $log.debug(' ### consultrecord  Consults close received: ', message);
        var messages = message.data.split(':');
        if (angular.isDefined(vm.consult) && angular.isDefined(vm.consult._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.consult._id === messages[0]) {
            $log.debug(' ### consultrecord received consult close from other tab/client for: ', messages[0]);
            vm.show = 'new';
          }
        }
      };

      vertxEventBusService.on('consults.create', {}, consultCreateHandler);
      vertxEventBusService.on('consults.close', {}, consultCloseHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('consults.create', {}, consultCreateHandler);
        vertxEventBusService.unregisterHandler('consults.close', {}, consultCloseHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultnew', {
    restrict: 'E',
    bindings: {
      patientid: '<',
      oncreate: '&'
    },
    template: '\n      <div class="consultnew-component" data-hook="consultnew-component">\n        <div class="btn btn-success spacer-bottom" ng-click="vm.saveNewConsult()" ng-hide="vm.newconsult">Neue Konsultation starten</div>\n        \n        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">\n          <h3><i class="fa fa-check"></i> Konsultation erfolgreich angelegt!</h3>\n        </div>\n       \n        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">\n          <h3>\n            <i class="fa fa-warning"></i> Es konnte keine Konsultation angelegt werden,\n            der Fehler wurde protokolliert!\n            </h3>\n        </div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'Patient', 'Rlog', function ($log, Consult, Patient, Rlog) {
      var vm = this;
      vm.saveNewConsult = saveNewConsult;

      function saveNewConsult() {
        Patient.$find(vm.patientid).$then(function (pat) {
          var newrecord = {
            patientid: vm.patientid,
            clientid: vm.patientid,
            dicomconsultid: moment().valueOf().toString() + Math.floor(Math.random() * 999).toString(),
            patlastname: pat.primarycontact.lastname,
            patfirstname: pat.primarycontact.firstname,
            patimage: pat.image,
            patbdate: pat.svdata.bdateat,
            patsv: pat.svdata.sv,
            patsvnr: pat.svdata.svnr,
            fdate: moment().locale('de-at').format('ll')
          };

          if (angular.isDefined(pat.dicompatid)) {
            newrecord.dicompatid = pat.dicompatid;
          }

          if (angular.isDefined(pat.gdtpatid)) {
            newrecord.gdtpatid = pat.gdtpatid;
          }

          Consult.$create(newrecord).$then(function (cons) {
            vm.created = true;
            vm.oncreate({ consult: cons });
          }, function (err) {
            vm.created = false;
            $log.error('Creation of new consult failed: ', err);
            Rlog.error('vcutils.consult', 'consultnew', 'Creation of new consult failed: ', {
              patientid: vm.patientid
            });
          });
        }, function (err) {
          vm.created = false;
          $log.error('Creation of new consult failed, patient invalid: ', err);
          Rlog.error('vcutils.consult', 'consultnew', 'Creation of new consult failed, patientinvalid: ', {
            patientid: vm.patientid
          });
        });
      } // savenewconsult
    } // controller
    ] // controller
  }); // component

  // klammerfriedhof
})();
/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of consultss (patients) to display or load consultss */

'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultlist', {
    restrict: 'E',
    bindings: {
      consults: '<?',
      patientid: '<?'
    },
    templateUrl: 'vcconsult/consultlist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'Consult', 'ConsultHelper', 'vertxEventBusService', '$q', function ($log, $http, Rlog, Consult, ConsultsHelper, vertxEventBusService, $q) {
      var vm = this;
      vm.editConsult = ConsultsHelper.editConsult;
      vm.removeConsult = removeConsult;
      vm.togglePanel = togglePanel;
      vm.$log = $log;

      /*
                vm.$onInit = function () {
                  vm.display = [];
                  // unless vcclient list has been passed for test purposes, retrieve vcconsult list from web
                  if (angular.isUndefined(vm.consults) && angular.isUndefined(vm.patientid)) {
                    vm.consults = Consult.$search();
                  }
      
                  if (angular.isUndefined(vm.consults) && angular.isDefined(vm.patientid)) {
                    vm.consults = Consult.$searchBy('patientid', vm.patientid);
                  }
                }; // $onInit()
      */

      vm.$onChanges = function (changes) {
        vm.display = [];

        if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
          Consult.$searchBy('patientid', vm.patientid).$then(function (consults) {
            vm.consults = consults;
            vm.numCC = numFinishedConsults(consults);
          });
        }
      }; // $onInit()

      function numFinishedConsults(consults) {
        var fc = consults.filter(function (e) {
          return !e.open;
        });
        return fc.length;
      }

      function removeConsult(consult) {
        consult.active = false;
        consult.$save();
      }

      function togglePanel(i, cons) {
        if (angular.isUndefined(vm.display[i]) || vm.display[i] === false) {
          $q.all(pullDetails(cons)).then(function () {
            $log.debug('debug - documents: ', cons.documents);
            vm.display[i] = true;
          });
        } else {
          // TODO: figure out how to destroy content of individual consults on hide
          // delete cons.documents;
          // delete cons.files;
          // delete cons.examinations;
          vm.display[i] = false;
        }
      }

      function pullDetails(cons) {
        var chain = [];
        chain.push(cons.examinations.$refresh().$asPromise());
        chain.push(cons.documents.$refresh().$asPromise());
        // chain.push(cons.files.$refresh().$asPromise());
        return chain;
      }

      var consultsUpdateHandler = function consultsUpdateHandler(message) {
        $log.debug('debug: consults update received: ', message);
        if (angular.isDefined(vm.consults)) {
          vm.consults.$refresh().$then(function () {
            $log.debug('debug: consultlist refreshed consults');
          }, function (error) {
            $log.debug('debug: consultlist refresh consults failed: ', error);
          });
        }
      };

      vertxEventBusService.on('consults.update', {}, consultsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('consults.update', {}, consultsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/*
* Consultsummary is the provides the consutlist accordion header contents
* starred, date, consult keywords, examlabels
* */
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consultkeywords', {
    restrict: 'E',
    bindings: {
      keywords: '=',
      parentsave: '&'
    },
    templateUrl: 'vcconsult/consultkeywords-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.updateColor = updateColor;
      vm.addKeyword = addKeyword;
      vm.editKeyword = editKeyword;
      vm.removeKeyword = removeKeyword;

      vm.$onInit = function () {
        if (angular.isUndefined(vm.customlabels)) {
          vm.customlabels = {
            primary: 'Neu',
            info: 'Fremdinformation',
            danger: 'Gefahr',
            warning: 'Warnung',
            success: 'Erfolg'
          };
        }
      };

      function editKeyword(kw) {
        $log.debug('edited kw: ', kw);
        save();
      }

      function updateColor(kw, color) {
        kw.col = color;
        save();
      }

      function removeKeyword(kw) {
        kw.active = false;
        save();
      }

      function addKeyword() {
        if (angular.isDefined(vm.newkeyword) && vm.newkeyword.length > 0) {
          var kw = {};
          kw.col = 'primary';
          kw.key = vm.newkeyword;

          if (!angular.isArray(vm.keywords)) {
            vm.keywords = [];
          }
          vm.keywords.push(kw);

          vm.newkeyword = '';
          save();
        }
      }

      function save() {
        $log.debug('***: diagnoseedit calling parentsave: ', vm.parentsave);
        vm.parentsave();
      }

      vm.$onChanges = function (changes) {
        /*                  if (angular.isDefined(changes.starred) && angular.isDefined(changes.starred.currentValue)
                              && changes.starred.currentValue !== '') {
                            vm.starred = changes.starred.currentValue === 'true';
                          }
                           if (angular.isDefined(changes.keywords) && angular.isDefined(changes.keywords.currentValue)
                              && angular.isArray(changes.keywords.currentValue)) {
                            vm.keywords = changes.keywords.currentValue;
                          }*/
        if (angular.isDefined(changes.parentsave) && angular.isDefined(changes.parentsave.currentValue) && angular.isFunction(changes.parentsave.currentValue)) {
          vm.parentsave = changes.parentsave.currentValue;
        }
      };
    }]
  });
  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';
  angular.module('vcconsult').component('consulteditor', {
    restrict: 'E',
    bindings: {
      consultid: '<',
      startcheckout: '&?',
      onfinish: '&?'
    },
    templateUrl: 'vcconsult/consulteditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Consult', 'PatdocsHelper', 'CartHelper', 'ConsultHelper', 'Rlog', 'Patient', 'PrintHelper', 'vertxEventBusService', '$window', '$timeout', function ($log, Consult, PatdocsHelper, CartHelper, ConsultHelper, Rlog, Patient, PrintHelper, vertxEventBusService, $window, $timeout) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;
      vm.oncancel = oncancel;
      vm.addReferralModal = PatdocsHelper.addReferral;
      vm.addAideModal = PatdocsHelper.addAide;
      vm.editCart = CartHelper.editCart;
      vm.closeConsultModal = ConsultHelper.closeConsultModal;
      vm.finish = finish;
      vm.consultPreviewUrl = PrintHelper.consultPreviewUrl;
      vm.togglestar = togglestar;
      // vm.addRecipientModal = addRecipientModal;

      // vm.consultid might be late propagating, get consult on first change
      vm.$onChanges = function (changes) {

        if (angular.isDefined(changes.consultid) && angular.isDefined(changes.consultid.currentValue) && changes.consultid.currentValue.length > 0) {
          vm.consultid = changes.consultid.currentValue;
          Consult.$find(vm.consultid).$then(function (consult) {
            if (angular.isUndefined(consult.recipient)) {
              consult.recipient = 'patient';
            }
            vm.consult = consult;
            $log.debug('[CONSULT][ConsultEditor]loaded consult');
            Patient.$find(vm.consult.patientid).$then(function (pat) {
              $log.debug('[CONSULT][ConsultEditor]loaded patient');
              vm.patient = pat;
            });
          }, function (err) {
            $log.error('[CONSULT][ConsultEditor]consult not found, id: ', vm.consultid, err);
            Rlog.error('consult', 'consulteditor', 'consult not found', { _id: vm.consultid });
          });
        }
      };

      function togglestar() {
        if (angular.isUndefined(vm.consult.stared)) {
          vm.consult.stared = false;
        }
        vm.consult.stared = !vm.consult.stared;
        vm.save();
      }

      function finish(docs, invdocs) {
        $log.debug('[CONSULT][ConsultEditor] consulteditor finish with: ', docs, invdocs);

        vm.consult.docs = docs;
        vm.consult.invdocs = invdocs;
        vm.consult.open = false;

        $log.debug(' ### consulteditor finish, now closing all consult exams');
        try {
          vm.consult.examinations.forEach(function (exam) {
            exam.open = false;
            exam.$save();
          });
        } catch (err) {
          $log.error('[CONSULT][ConsultEditor] Failed to close exam for consultid: ', vm.consultid, err);
        }

        $log.debug('[CONSULT][ConsultEditor] finish, now saving closed consult');
        if (vm.consult.$hasPendingActions) {
          $log.warn('[CONSULT][ConsultEditor] consult save had pending actions, cancelling now.');
          vm.consult.$cancel();
          $timeout(function () {
            $log.warn('[CONSULT][ConsultEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
            finishsave();
          }, 1500);
        } else {
          finishsave();
        }
      }

      function finishsave() {
        vm.consult.$save().$then(function () {
          vm.saved = true;
          var message = vm.consult._id + ':' + $window.sessionStorage.getItem('sprtabid');
          $log.debug('[CONSULT][ConsultEditor]  saving close of consult succeeded, now sending close message: ', message);
          vertxEventBusService.publish('consults.close', { data: message });
          // tell parent to switch view directly
          vm.onfinish({ consultid: vm.consult._id });
        }, function (err) {
          vm.saved = false;
          $log.error('[CONSULT][ConsultEditor]  saving of consult failed: ', err);
          Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
            consultid: vm.consult._id
          });
        });
      }

      function childsave(key, value) {
        vm.consult[key] = value;
        vm.save();
      }

      function save() {
        $log.debug('[CONSULT][ConsultEditor] consult save() called');
        if (vm.consult.$hasPendingActions) {
          $log.warn('[CONSULT][ConsultEditor] consult save had pending actions, cancelling now.');
          vm.consult.$cancel();
          $timeout(function () {
            $log.warn('[CONSULT][ConsultEditor]  waited 1.5 seconds because of consult having had pending actions, saving now.');
            savesave();
          }, 1500);
        } else {
          savesave();
        }
      }

      function savesave() {
        vm.consult.$save().$then(function () {
          $log.debug('[CONSULT][ConsultEditor]  saving of consult succeeded: ');
          vm.saved = true;
        }, function (err) {
          vm.saved = false;
          $log.error('[CONSULT][ConsultEditor] saving of consult failed: ', err);
          Rlog.error('vcutils.consult', 'consulteditor', 'Saving of consult failed: ', {
            consultid: vm.consult._id
          });
        });
      }

      function oncancel() {
        vm.canceled = true;
      }

      vm.sprsymptoms = '\n          Geben Sie hier Symptome byw. Kurzanamnese ein. Um detaillierte Krankheitsgeschichten zu erfassen, \n          empfehlen wir den Einsatz von Statusbefund- bzw. Untersuchungsvorlagen. Lesen Sie die PDF Anleitung zu\n          Untersuchungsvorlagen und sehen Sie sich das Einführungsvideo an.\n          ';

      vm.sprfindings = '\n          Geben Sie hier nur weitere, globale Befunde & Erhebungen ein.\n          Die (Befund-) Zusammenfassungen der einzelnen Untersuchungen werden automatisch in den Gesamtbefund übernommen. \n          Sie können sich die Zusammenfassungen der einzelnen Untersuchungen mit dem Knopf Listenansicht (rechts) \n          ins Gedächnis rufen. Anmerkungen aus den einzelnen Untersuchungen können Sie ebenfalls rechts mit dem Knopf \n          &quot;Warnung&quot; gesammelt einsehen. Anmerkungen werden NICHT automatisch übernommen.\n          ';

      vm.sprtherapy = '\n          Geben Sie hier nur weitere, globale weitere Therapievorschläge ein.\n          Die Therapievorschläge der einzelnen Untersuchungen werden automatisch in den Gesamtbefund übernommen. \n          Sie können sich die Therapievorschläge der einzelnen Untersuchungen mit dem Knopf Listenansicht (rechts) \n          ins Gedächnis rufen.\n          ';

      vm.sprnotes = '\n          Diese Patientennotizen werden nicht in Befunde oder andere Dokumente übernommen. \n          Notieren Sie sich Verwandschaftsverhältnisse, die Namen der Kinder, oder den Umstand, \n          dass Ihr Patient ein ausgemachter Hypochonder ist.\n          ';

      var consultsUpdateHandler = function consultsUpdateHandler(message) {
        $log.debug('debug: Consults update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.consult._id === messages[0]) {
            vm.consult.$refresh().$then(function () {
              $log.debug('debug: consulteditor refreshed consult: ');
            }, function (error) {
              $log.debug('debug: consulteditor could not refresh consult: ', error);
            });
          }
        }
      };

      // only react to consult updates from other tabs/browsers
      vertxEventBusService.on('consults.update', {}, consultsUpdateHandler);

      vm.$onDestroy = function () {
        $log.debug('[CONSULT][ConsultEditor] onDestroy called');
        vertxEventBusService.unregisterHandler('consults.update', {}, consultsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  angular.module('vcconsult').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.consult', {
      url: '/consult',
      views: {
        'playgroundmain@playground': {
          template: '\n              <h3 class="alert alert-info"><tt>&lt;openconsultcounter&gt;</tt></h3><div ui-view="openconsultcounterview"></div>\n              <h3 class="alert alert-info"><tt>&lt;closeconsult&gt;</tt></h3><div ui-view="closeconsultview"></div>\n              <h3 class="alert alert-info"><tt>&lt;openconsultlist&gt;</tt></h3><div ui-view="openconsultlistview"></div>\n              <h3 class="alert alert-info"><tt><recentconsultlist></recentconsultlist></tt></h3><div ui-view="recentconsultlistview"></div>\n              <h3 class="alert alert-info"><tt>&lt;consultrecord patientid=""&gt;</tt></h3><div ui-view="consultrecordview"></div>\n              <!--<h3 class="alert alert-info"><tt>&lt;consultsearch consult="" consultref="" parentsave=""&gt;</tt></h3><div ui-view="consultsearchview2"></div>-->\n              <h3 class="alert alert-info"><tt>&lt;consulteditor consult="" mode="" onClose=""&gt;</tt></h3><div ui-view="consulteditview"></div>\n              <!--<h3 class="alert alert-info"><tt>&lt;consulteditor consult="" mode="" onClose=""&gt;</tt></h3><div ui-view="consulteditview"></div>-->\n              <h3 class="alert alert-info"><tt>&lt;consultlist consults="?"&gt;</tt></h3><div ui-view="consultlistview"></div>\n            '
        }
      },
      onEnter: function onEnter() {
        $log.debug('debug/routes - playground.consult entered');
      }
    });

    $stateProvider.state('playground.consult.allcomponents', {
      url: '/allcomponents',
      resolve: {
        consult: function consult() {
          return '';
        },
        consultref: function consultref() {
          return '';
        },
        maxmusterid: function maxmusterid() {
          return '571df9c97c01594fd0bbdf96';
        },
        someconsult: function someconsult(Consult) {
          return Consult.$find('572b31b07c01597e3e150923');
        },
        somefinish: function somefinish() {
          return function (doc, invdoc) {
            $log.debug('consult finish mock received: ', doc, invdoc);
          };
        },
        someotherconsult: function someotherconsult(Consult) {
          return Consult.$find('58f88208b148b776e918dd0d');
        },
        testpat: function testpat() {
          return true;
        },
        allconsults: function allconsults(Consult) {
          return Consult.$search({ active: true });
        },
        parentsavesearch: function parentsavesearch() {
          return function (consult, consultref) {
            console.log('debug: dummy parentsave called for consultsearch with: ', consult, consultref);
          };
        },
        createNewConsult: function createNewConsult(Consult) {
          return Consult.$create({ clientid: '58499f4c878f751a3eab5019', patientid: '58499f4c878f751a3eab5019' });
        },
        eip: function eip() {
          return true;
        }
      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'openconsultcounterview@playground.consult': {
          component: 'openconsultcounter',
          bindings: {}
        },
        'closeconsultview@playground.consult': {
          template: '<span class="btn btn-warning"\n                             ng-click="vm.close(vm.consult, [{key: \'foo\'}, {key: \'bar\'}, {key: \'baz\'}], true, vm.finish)">\n                          Close Consult Modal\n                       </span>',
          controller: ['ConsultHelper', 'someotherconsult', function (ConsultHelper, consult) {
            var vm = this;
            $log.debug('closeconsultview controller called');
            vm.close = ConsultHelper.closeConsultModal;
            vm.consult = consult;
            vm.consult.examinations.$refresh();
          }],
          controllerAs: 'vm'
        },
        'openconsultlistview@playground.consult': {
          component: 'openconsultlist',
          bindings: {}
        },
        'recentconsultlistview@playground.consult': {
          component: 'recentconsultlist',
          bindings: {}
        },
        'consultsearchview@playground.consult': {
          component: 'consultsearch',
          bindings: {
            consult: 'consult',
            consultref: 'consultref',
            editinplace: 'eip'
          }
        },
        'consultsearchview2@playground.consult': {
          component: 'consultsearch',
          bindings: {
            consult: 'consult',
            consultref: 'consultref',
            parentsave: 'parentsavesearch'
          }
        },
        'consulteditview@playground.consult': {
          component: 'consulteditor',
          bindings: {
            consult: 'someconsult'
          }
        },
        'consultnewview@playground.consult': {
          component: 'consulteditor',
          bindings: {
            consult: 'createNewConsult'
          }
        },
        'consultlistview@playground.consult': {
          component: 'consultlist',
          bindings: {
            // consults: 'allconsults'
            patientid: 'maxmusterid'
          }
        },
        'consultrecordview@playground.consult': {
          component: 'consultrecord',
          bindings: {
            // consults: 'allconsults'
            patientid: 'maxmusterid'
          }
        }
      },
      onEnter: function onEnter() {
        console.log('playground.consult.allcomponents entered');
      }
    });
  } // all routes

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name consult.factory:ConsultHelper
   *
   * @description
   *
   */
  angular.module('vcconsult').factory('ConsultHelper', ConsultHelper);

  ConsultHelper.$inject = ['Consult', '$uibModal', '$log', 'Rlog'];

  function ConsultHelper(Consult, $uibModal, $log, Rlog) {
    var ConsultHelperBase = {};

    ConsultHelperBase.editConsult = editConsult;
    ConsultHelperBase.addConsult = addConsult;
    ConsultHelperBase.closeConsultModal = closeConsultModal;

    // function closeConsultModal(lclientid, ldiagnoses, ltest, lconsultid) {
    function closeConsultModal(lconsult, ldiagnoses, ltest, lfinish) {
      $log.debug('ConsultHelper.closeConsultModal  called');
      var dialog = $uibModal.open({
        template: '\n          <div class="modalspacer">\n            <carteditor clientid="vm.clientid"  diagnoses="vm.diagnoses" test="vm.test" ng-hide="vm.started"></carteditor>\n              \n            <form name="payment" ng-hide="vm.started">\n              <div class="spacer-top">\n                <div class="alert alert-warning" ng-show="vm.itemsnum > 0">\n                    <h4>Bezahlmethode</h4>\n                    <label><input type="radio" ng-model="vm.paytype" value="cash" required> Bar</label>\n                    <label><input type="radio" ng-model="vm.paytype" value="card" required> Bankomat o. Kreditkarte</label>\n                    <label><input type="radio" ng-model="vm.paytype" value="bill" required> Rechnung mit Zahlschein</label>\n                </div>\n              </div>\n            \n            <!-- Buttons -->\n              <div class="spacer-top">\n                <p class="spacer-bottom">\n                  <input type="checkbox" id="nofindings" ng-model="vm.nofindings" data-hook="no_findings"> Keinen Gesamtbefund erstellen\n                </p>\n                <div class="btn btn-success" ng-click="vm.closeInvoiceConsult(vm.consultid)"  data-hook="closeconsult_with_invoice" ng-show="vm.itemsnum > 0" ng-disabled="payment.$invalid">\n                  <i class="fa fa-money"></i> Rechnung austellen und Konsultation abschließen\n                </div>\n                <p>\n                  <div class="btn btn-warning" ng-click="vm.closeConsult(vm.consultid)" data-hook="closeconsult_no_invoice"><i class="fa fa-sign-out"></i> Konsultation ohne Rechnung abschließen\n                  <sprhelp tip="Keine Rechnung" descref="vm.consultnoinvoicehelp"></sprhelp></div>\n                    \n                  <div class="btn btn-danger" ng-click="vm.confirm = true;" ng-hide="vm.confirm"><i class="fa fa-remove"></i> Konsultation beenden und löschen\n                  <sprhelp tip="Ganz weg damit!" descref="vm.consultdeletehelp"></sprhelp></div>\n                    \n                  <div class="alert alert-danger" ng-show="vm.confirm">\n                  <h3>Konsultation löschen</h3>\n                  <p ng-bind="vm.consultdeletehelp"></p>\n                  <p>Schreiben Sie: "Weg damit!" in das Eingabefeld</p>\n                  <div class="spacer-bottom spacer-top">\n                    <input type="text" ng-model="vm.confirmDelete" class="form-control">\n                  </div>\n                  <div class="spacer-bottom spacer-top">\n                    <button ng-click="vm.deleteConsult(vm.consultid)"  data-hook="deleteconsult" class="btn btn-danger">Konsultation beenden und löschen</button>\n                  </div>\n                  </div>\n                \n                </p>\n              </div>\n              </form>\n              \n              <!-- Dokumentgenerierung und Anzeige -->\n              <div class="spacer-top">\n                <div ng-show="vm.started">\n                  <div class="row">\n                    <div class="col-xs-12 col-md-6">\n                      <h4>Dokumente</h4>\n                      <div class="alert alert-info" ng-show="vm.doccount">\n                          <h4><i class="fa fa-spinner fa-spin"></i> {{vm.doccount}} Dokumente werden erstellt!</h4>\n                      </div>\n                      <div ng-repeat="doc in vm.docs"  data-hook="consult_documents">\n                        <a href="/routes/pdfreader/{{doc.fileid}}" target="_blank">\n                          <span class="fa fa-file-pdf-o"></span> {{doc.type}}\n                        </a>\n                      </div>\n                    </div>\n                    <div class="col-xs-12 col-md-6" ng-show="vm.invstarted">\n                      <h4>Rechnungen/Beleg</h4>\n                      <div class="alert alert-info" ng-show="vm.invcount">\n                          <h4><i class="fa fa-spinner fa-spin"></i> {{vm.invcount}} Rechnungsdokumente werden erstellt!</h4>\n                      </div>\n                      <div ng-repeat="doc in vm.invdocs"  data-hook="consult_financial_documents">\n                        <a href="/routes/pdfreader/{{doc.fileid}}" target="_blank">\n                          <span class="fa fa-file-pdf-o"></span> {{doc.type}}\n                        </a>\n                      </div>\n                      \n                    </div>\n                  </div>\n                </div>\n              </div>\n              <!-- Buttons -->\n              <div class="spacer-top"  ng-show="(vm.invcount === 0 && vm.doccount === 0) || (!vm.invcount && vm.doccount === 0)">\n                <div class="row">\n                  <div class="col-xs-12">\n                    <span class="btn btn-success" ng-click="vm.localfinish(vm.docs, vm.invdocs)"  data-hook="closeconsult_no_documents">\n                        <i class="fa fa-sign-out"></i> Konsultation abschließen\n                    </span>\n                  </div>\n                </div>\n              </div>\n               <div class="spacer-top"  ng-show="vm.timeout === true && (vm.invcount > 0 || vm.invdocs > 0)">\n                <div class="row">\n                  <div class="col-xs-12">\n                    <span class="btn btn-warning" ng-click="vm.localfinish(vm.docs, vm.invdocs)" data-hook="closeconsult_no_documents">\n                        <i class="fa fa-sign-out"></i> Konsultation ohne Dokumente abschließen\n                    </span>\n                  </div>\n                </div>\n              </div>\n          </div>\n',
        controllerAs: 'vm',
        controller: ['sconsult', 'PrintHelper', '$scope', 'sdiagnoses', 'stest', '$rootScope', '$http', 'sfinish', '$timeout', 'Cart', 'vertxEventBusService', function (sconsult, PrintHelper, $scope, sdiagnoses, stest, $rootScope, $http, sfinish, $timeout, Cart, vertxEventBusService) {
          var vm = this;

          vm.consult = sconsult;
          // vm.finish = sfinish;
          vm.localfinish = localfinish;
          vm.clientid = vm.consult.patientid;
          vm.diagnoses = sdiagnoses;
          vm.test = stest;
          vm.$scope = $scope;
          vm.$rootscope = $rootScope;

          vm.consultdeletehelp = 'Benutzen Sie diese Option nur, falls Sie versehentlich eine Konsultation gestartet haben. \n              Es werden keine Dokumente erstellt oder gedruckt. Die Konsultation erscheint auch nicht in der Historie.';
          vm.consultnoinvoicehelp = 'Befunde, Verordnungen und Uberweisungen werden gedruckt. Es wird keine Rechnung erstellt. \n              Bestehende Rechnungspositionen verbleiben im Warenkorb.';

          $log.debug('consultHelper controller  called for consultid: ', vm.consult._id);

          vm.consult.examinations.$refresh().$then(function () {
            $log.debug('exam refresh succcess');
          }, function (e) {
            $log.debug('exam refresh failure ', e);
          });

          vm.cancel = cancel;
          // vm.closeConsult = scloseConsult;
          vm.closeInvoiceConsult = closeInvoiceConsult;
          vm.closeConsult = closeConsult;
          vm.deleteConsult = deleteConsult;

          vm.$onInit = function () {
            Cart.getCount(vm.clientid).then(function (res) {
              vm.itemsnum = 0;
              // $log.debug('**** cart Counter data: ', res.data);
              vm.itemsnum = res.data.count;
            }, function (err) {
              $log.error('vcconsult consulthelper counter aquisition  failed: ', err);
              Rlog.error('vcconsult', 'consulthelper', 'counter aquisition  failed', {});
            });
          };

          function localfinish(docs, invdocs) {
            $log.debug(' ### consulthelper localfinish called, now calling sfinish with: ', docs, invdocs);
            sfinish(docs, invdocs);
            dialog.close();
          }

          function cancel() {
            dialog.close();
          }

          function closeInvoiceConsult(consultid) {

            // after 2minutes show force=consult-close button
            $timeout(function () {
              vm.timeout = true;
            }, 120000);
            vm.invstarted = true;
            vm.invdocs = [];
            $log.debug('closeInvoiceConsult called for: ', consultid);

            if (vm.paytype === 'cash' || vm.paytype === 'card') {
              vm.invcount = 3;
              $http.post('/routes/cashinvoices/' + vm.consult.patientid + '/' + vm.paytype + '/' + vm.consult._id).then(function (inv) {
                $log.debug('cash inv answer: ', inv);

                vm.invdocs.push({ type: 'Rechnung (Patientenkopie)', fileid: inv.data.patientinvoiceid });
                vm.invdocs.push({ type: 'Rechnung (Arztkopie)', fileid: inv.data.doctorinvoiceid });
                if (angular.isDefined(inv.data.doctorinvoiceid) && inv.data.doctorinvoiceid.length > 0) {
                  vm.invdocs.push({ type: 'Beleg', fileid: inv.data.receiptid });
                }
                $http.post('/routes/carts/' + vm.clientid + '/closecart').then(function () {
                  $log.debug('Cart close succeeded');
                }, function (err) {
                  $log.error('Cart close failed', err);
                });
                vm.invcount = 0;
              }, function (error) {
                $log.error('CashinvoicePrintfailed: ', error);
                $rootScope.connfailure = 0;
                vm.invdocs.push({ type: 'Rechnung fehlgeschlagen', fileid: '' });
                vm.invcount = 0;
              });
            }

            if (vm.paytype === 'bill') {
              vm.invcount = 2;
              $http.post('/routes/checkinvoices/' + vm.consult.patientid + '/' + vm.consult._id).then(function (inv) {
                vm.invdocs.push({ type: 'Rechnung (Patientenkopie)', fileid: inv.data.patientinvoiceid });
                vm.invdocs.push({ type: 'Rechnung (Arztkopie)', fileid: inv.data.doctorinvoiceid });
                $http.post('/routes/carts/' + vm.clientid + '/closecart').then(function () {
                  $log.debug('Cart close succeeded');
                }, function (err) {
                  $log.error('Cart close failed', err);
                });
                vm.invcount = 0;
              }, function (error) {
                $log.error('CheckinvoicePrintfailed: ', error);
                $rootScope.connfailure = 0;
                vm.invdocs.push({ type: 'Rechnung fehlgeschlagen', fileid: '' });
                vm.invcount = 0;
              });
            }
            $timeout(function () {
              closeConsult();
            }, 500);
          }

          function closeConsult() {
            $log.debug('###################   closeConsult started');
            vm.started = true;
            vm.docs = [];
            vm.doccount = 0;

            vm.consult.examlabelsPrimary = [];
            vm.consult.examlabelsSecondary = [];

            // Gesamtbefund
            if (!vm.nofindings === true) {
              vm.doccount++;
              PrintHelper.consultPrint(vm.consult._id).then(function (doc) {
                vm.docs.push({ type: 'Gesamtbefund', fileid: doc.data.docid });
                vm.doccount--;
                $rootScope.connfailure = 0;
              }, function (error) {
                $log.error('ConsultPrintfailed: ', error);
                vm.doccount--;
                $rootScope.connfailure = 0;
                vm.docs.push({ type: 'Gesamtbefund fehlgeschlagen', fileid: '' });
              });
            }

            // print referrals
            getCounter('referral', vm.consult._id).then(function (res) {
              if (res.data.counter && res.data.counter > 0) {
                vm.doccount++;
                printReferral();
              }
            }, function (err) {
              Rlog.error('consulthelper', 'refcounter', 'refcounter.$aggregate failed', {});
              $log.error('consulthelper, refcounter refcounter.$aggregate failed: ', err);
            });

            // print aides (Hilfsmittelverordnung)
            getCounter('aide', vm.consult._id).then(function (res) {
              if (res.data.counter && res.data.counter > 0) {
                vm.doccount++;
                printAide();
              }
            }, function (err) {
              Rlog.error('consulthelper', 'aidecoutner', 'aidecounter.$aggregate failed', {});
              $log.error('consulthelper, aidecoutner refcounter.$aggregate failed: ', err);
            });

            // print or persist exams depending on settings
            // never persist or print status finding included in general findings report
            vm.consult.examinations.map(function (exam) {
              $log.debug('consult helper factory consult examination loop: ', exam);
              if (exam.active && exam.print && !exam.template.includefindings === true) {
                vm.doccount++;
                // persistExam(exam); // TODO switch back to printExam after test
                printExam(exam);
              }

              if (exam.active && !exam.print && !exam.template.includefindings === true) {
                vm.doccount++;
                persistExam(exam);
              }
            });

            // add exam labels and pdf docids to consult record

            /*              vm.consult.examinations.map(function (exam) {
            
                            if (exam.active && exam.template.includefindings !== true) {
                              vm.consult.examlabelsPrimary.push({type: exam.template.displayname});
                            } else {
                              vm.consult.examlabelsSecondary.push({type: exam.template.displayname});
                            }
                          });
            
                          vm.consult.$save().$then(function () {
                          }, function (err) {
                            $log.error(' ### saving of consult failed after adding examlabels: ', err);
                            Rlog.error('vcutils.consult', 'consult helper factory', 'Saving of consult failed after adding exam labels on finish: ', {
                              consultid: vm.consult._id
                            });
                          });*/
          }

          function deleteConsult() {
            $log.debug('really delete: ', vm.confirmDelete, vm.confirmDelete === 'Weg damit!');
            if (vm.confirmDelete === 'Weg damit!') {
              vm.consult.active = false;
              vm.localfinish([], []);
              $log.debug('###################   deleteConsult started, set active to false');
              vm.started = true;
              vm.docs = [];
              vm.doccount = 0;
            } else {
              delete vm.confirm;
              delete vm.confirmDelete;
            }
          }

          function printExam(exam) {
            $log.debug('exam in printExam: ', exam);

            PrintHelper.examPrint(exam._id, exam.consultid).then(function (doc) {
              vm.docs.push({ type: 'Untersuchungsbefund ' + exam.type, fileid: doc.data.docid, examid: exam._id });
              if (exam.active && exam.template.includefindings !== true) {
                vm.consult.examlabelsPrimary.push({ type: exam.template.displayname, docid: doc.data.docid });
              } else {
                vm.consult.examlabelsSecondary.push({ type: exam.template.displayname });
              }

              exam.docid = doc.data.docid;
              exam.$save().$then(function () {
                return $log.debug('docid saved to exam: ', exam._id);
              }, function (err) {
                return $log.error('saving docid to exam failed: ', exam._id, err);
              });

              vm.doccount--;
              $rootScope.connfailure = 0;
            }, function (error) {
              $log.error('Failed: Untersuchungsbefund print for: ', exam.type, error);
              vm.doccount--;
              $rootScope.connfailure = 0;
              vm.docs.push({ type: 'Untersuchungsbefund ' + exam.type + ' fehlgeschlagen', fileid: '' });
            });
          }

          function persistExam(exam) {
            PrintHelper.examPersist(exam._id, exam.consultid).then(function (doc) {
              vm.docs.push({ type: 'Untersuchungsbefund ' + exam.type, fileid: doc.data.docid, examid: exam._id });
              if (exam.active && exam.template.includefindings !== true) {
                vm.consult.examlabelsPrimary.push({ type: exam.template.displayname, docid: doc.data.docid });
              } else {
                vm.consult.examlabelsSecondary.push({ type: exam.template.displayname });
              }
              exam.docid = doc.data.docid;
              exam.$save().$then(function () {
                return $log.debug('docid saved to exam: ', exam._id);
              }, function (err) {
                return $log.error('savind docid to exam failed: ', exam._id, err);
              });

              vm.doccount--;
              $rootScope.connfailure = 0;
              $log.debug('doccount : ', vm.doccount);
            }, function (error) {
              $log.error('Failed: Untersuchungsbefund persist for: ', exam.type, error);
              vm.doccount--;
              $rootScope.connfailure = 0;
              $log.debug('doccount : ', vm.doccount);
              vm.docs.push({ type: 'Untersuchungsbefund ' + exam.type + ' fehlgeschlagen', fileid: '' });
            });
          }

          function printAide() {
            // TODO: switch Persist back to Print
            PrintHelper.aidePrint(vm.consult.patientid, vm.consult._id).then(function (doc) {
              vm.docs.push({ type: 'Hilsmittel-Verordnung(en)', fileid: doc.data.docid });
              vm.doccount--;
              $rootScope.connfailure = 0;
            }, function (error) {
              $log.error('AidePrintfailed: ', error);
              vm.doccount--;
              $rootScope.connfailure = 0;
              vm.docs.push({ type: 'Hilsmittelverordnung fehlgeschlagen', fileid: '' });
            });
          }

          function printReferral() {
            // TODO: switch Persist back to Print
            PrintHelper.referralPrint(vm.consult.patientid, vm.consult._id).then(function (doc) {
              vm.docs.push({ type: 'Überweisung(en)', fileid: doc.data.docid });
              vm.doccount--;
              $rootScope.connfailure = 0;
            }, function (error) {
              $log.error('ReferralPrintfailed: ', error);
              vm.doccount--;
              $rootScope.connfailure = 0;
              vm.docs.push({ type: 'Überweisung fehlgeschlagen', fileid: '' });
            });
          }

          function getCounter(type, consultid) {
            var query = [{
              $match: {
                consultid: consultid,
                type: type,
                active: true
              }
            }, {
              $group: {
                _id: 'counter',
                counter: { $sum: 1 }
              }
            }];

            return $http.post('/routes/patdocs/aggregate', query);
          }

          vertxEventBusService.on('carts.update', function (message) {
            var messages = message.split(':');
            Cart.getCount(vm.clientid).then(function (res) {
              vm.itemsnum = res.data.count;
            }, function (err) {
              $log.error('vcconsult consulthelper cart counter aquisition  failed: ', err);
              Rlog.error('vcconsult', 'consulthelper', 'caet counter aquisition  failed', {});
            });
            $log.debug('(checkout screen) refreshed cart');
          });
        }],
        resolve: {
          sconsult: function sconsult() {
            return lconsult;
          },
          sfinish: function sfinish() {
            return lfinish;
          },
          stest: function stest() {
            return ltest;
          },
          sdiagnoses: function sdiagnoses() {

            if (angular.isArray(ldiagnoses) && ldiagnoses.length > 0) {
              var _ret = (function () {
                var flatdiagnosesarr = [];
                ldiagnoses.map(function (d) {
                  flatdiagnosesarr.push(d.key);
                });
                return {
                  v: flatdiagnosesarr.join(', ')
                };
              })();

              if (typeof _ret === 'object') return _ret.v;
            } else {
              return '';
            }
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    function addConsult(success, error) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><consultform consult="consultaCtrl.consult" parentsave="consultaCtrl.childsave(consult)" oncancel="consultaCtrl.cancel()"></consultnew></div>',
        controllerAs: 'consultaCtrl',
        controller: ['consult', function () {
          var vm = this;
          vm.consult = {};

          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(consult) {
            Consult.$create(consult).$then(function (newconsult) {
              vm.created = true;
              success(newconsult);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ consult-helper.addConsult: ', err);
              Rlog.error('vcutils.consult', 'consult-helper.addConsult', 'Creation of new SV failed: ', {
                consultid: consult._id
              });
              dialog.close();
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          consult: function consult() {
            return {};
          }
        },
        size: 'lg'
      });
    }

    function editConsult(lconsult) {
      var dialog = $uibModal.open({
        template: '<div class="modalspacer"><consultform consult="consulteCtrl.consult" parentsave="consulteCtrl.childsave(consult)" oncancel="consulteCtrl.cancel()"></consultform></div>',
        controllerAs: 'consulteCtrl',
        controller: ['consult', '$timeout', function (sconsult, $timeout) {
          var vm = this;
          vm.consult = sconsult;
          vm.childsave = childsave;
          vm.cancel = cancel;

          function childsave(consult) {
            // vm.consult = angular.copy(consult);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (var key in consult) {
              if (consult.hasOwnProperty(key)) {
                vm.consult[key] = consult[key];
              }
            }

            if (vm.consult.$hasPendingActions) {
              $log.warn('[CONSULT][HELPER] consult save had pending actions, cancelling now.');

              vm.consult.$cancel();
              $timeout(function () {
                $log.warn('[CONSULT][HELPER]  waited 1.5 seconds because of consult having had pending actions, saving now.');
                savesave();
                dialog.close();
              }, 1500);
            } else {
              savesave();
              dialog.close();
            }
          }

          function savesave() {
            vm.consult.$save().$then(function () {}, function (err) {
              $log.error('[CLIENT][PatientHeader] client save failed!', err);
              Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: vm.client._id });
            });
          }

          function cancel() {
            dialog.close();
          }
        }],
        resolve: {
          consult: function consult() {
            return lconsult;
          }
        },
        size: 'lg'
      });
      return dialog;
    }

    return ConsultHelperBase;
  }
})();

/**
 * Created by lari on 03/09/15.
 */
'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name consult.factory:ConsultService
   *
   * @description
   *
   */
  angular.module('vcconsult').factory('Consult', Consult).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Consult.$inject = ['restmod'];

  function Consult(restmod) {
    return restmod.model('/routes/consults', 'DebouncedModel').mix({
      client: { belongsTo: 'Client', key: 'clientid' },
      examinations: { hasMany: 'Exam' },
      documents: { hasMany: 'Document' },
      // files: {hasMany: 'File'},
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      open: { init: true },
      state: { init: 'edit' },
      symptoms: { init: '' },
      findings: { init: '' },
      therapy: { init: '' },
      keywords: { init: [] },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/consults/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function $searchBy(key, val) {
            var realquery = {};
            realquery[key] = val;
            realquery['active'] = true;
            return this.$search(realquery);
          }
        } // Model
      } // extend
    });
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name vcclient
   * @description
   *
   */
  angular.module('vcclient', ['restmod', 'ui.router', 'ui.bootstrap', 'as.sortable', 'vcreminder', 'vcutils.sprhelp', 'vcutils.zipcode', 'vcutils.doctor', 'vcutils.sv', 'vcutils.rlog', 'vcutils.vcfields']);
})();
/* global angular, moment */
/**
 * Created by lari on 26/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('svedit', {
    bindings: {
      svdata: '=',
      parentsave: '&'
    },
    templateUrl: 'vcclient/svedit-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$scope', function ($log, $scope) {
      var vm = this;
      vm.title = 'svedit-component-controller';
      vm.svsave = svsave;
      vm.save = save;

      vm.formatbdate = formatbdate;
      vm.clearbdate = clearbdate;

      vm.formatSVNR = formatSVNR;
      vm.clearSVNR = clearSVNR;
      vm.clearSV = clearSV;

      vm.savePractDoctor = savePractDoctor;
      vm.saveRefDoctor = saveRefDoctor;
      vm.clearPractDoctor = clearPractDoctor;
      vm.clearRefDoctor = clearRefDoctor;

      vm.calcBMI = calcBMI;
      vm.setBMI = setBMI;

      vm.validateSVNR = validateSVNR;

      vm.childsave = childsave;

      vm.$scope = $scope;
      // Note: first function call is a weird trick to eliminate hardcoded local vm. this identifier!
      $scope.$watch(function () {
        return vm.svdata;
      }, function (scope) {
        $log.debug('scope in watch: ', scope);
        // noinspection JSUnresolvedVariable
        if (angular.isDefined(scope) && angular.isDefined(scope.svnr) && angular.isString(scope.svnr)) {
          // noinspection JSUnresolvedVariable
          vm.isvalidsvnr = vm.validateSVNR(scope.svnr);
        }
      });

      $scope.$watch(function () {
        return vm.svdata;
      }, function (scope) {
        $log.debug('scope in watch: ', scope);
        // noinspection JSUnresolvedVariable
        if (angular.isDefined(scope) && angular.isDefined(scope.insuredwith) && angular.isDefined(scope.insuredwith.svnr) && angular.isString(scope.insuredwith.svnr)) {
          // noinspection JSUnresolvedVariable
          vm.inswvalid = vm.validateSVNR(scope.insuredwith.svnr);
        }
      });

      // Init Routine
      vm.$onInit = function () {

        // make a copy of the current object state
        vm.lastsvdata = angular.copy(vm.svdata);
        $log.debug(' ### svedit $onInit vm.svdata: ', vm.svdata);
        if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.birthdate) && angular.isUndefined(vm.svdata.bdateat)) {
          formatbdate(vm.svdata.birthdate);
        }

        if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.svnr)) {
          vm.isvalidsvnr = vm.validateSVNR(vm.svdata.svnr);
          $log.debug('isvalid: ', vm.isvalidsvnr);
        }
        // noinspection JSUnresolvedVariable
        if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.insuredwith) && angular.isDefined(vm.svdata.insuredwith.svnr)) {
          // noinspection JSUnresolvedVariable
          vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr);
          $log.debug('inswvalid: ', vm.inswvalid);
        }
        if (angular.isDefined(vm.svdata) && (angular.isUndefined(vm.svdata.bmi) || !angular.isNumber(vm.svdata.bmi))) {
          setBMI();
        }
        // create working copy
        vm.svdata = angular.copy(vm.svdata);
        vm.save();
      };

      function childsave(key, value) {
        vm.svdata[key] = value;
        vm.save();
      }

      function saveRefDoctor(doctor) {
        vm.svdata.refdoctor = doctor;
        vm.save();
      }

      function savePractDoctor(doctor) {
        vm.svdata.practdoctor = doctor;
        vm.save();
      }

      function svsave(sv, svref) {
        vm.svdata.sv = angular.copy(sv);
        vm.svdata.svref = svref;
        vm.save();
      }

      function save() {
        vm.parentsave();
      }

      function formatbdate(date) {
        // moment.locale('de-at');
        var returnval = undefined;
        // noinspection ES6ModulesDependencies
        var bdate = moment(date, ['D.M.YYYY', 'DD.MM.YYYY', 'D/M/YYYY', 'DDMMYYYY']);
        // noinspection ES6ModulesDependencies
        var plausible = bdate.isAfter(moment('1900-01-01', 'YYYY-MM-DD')) && bdate.isBefore(moment().add(1, 'days'));
        var valid = bdate.isValid();
        // $log.debug('debug: valid, plausible: ', valid, plausible);

        if (!plausible) {
          vm.bdateerror = 'Unplausibles Datum';
          returnval = 'implausible';
        }

        if (!valid) {
          vm.bdateerror = 'Ungültiges Datum';
          returnval = 'invalid';
        }

        if (valid && plausible) {
          vm.svdata.bdateat = bdate.format('DD.MM.YYYY');
          vm.svdata.bdateiso = bdate.toISOString();
          vm.svdata.bdatesortable = bdate.format('YYYY-MM-DD');
          vm.svdata.bdateat = bdate.format('DD.MM.YYYY');
          vm.svdata.bdatejs = bdate.format();
          vm.svdata.bdatesv = bdate.format('DDMMYY');
          delete vm.bdateerror;
          returnval = bdate.format('DD.MM.YYYY');
          vm.save();
        }
        return returnval;
      }

      function clearbdate() {
        delete vm.svdata.birthdate;
        delete vm.svdata.bdateiso;
        delete vm.svdata.bdatesortable;
        delete vm.svdata.bdatejs;
        delete vm.svdata.bdateat;
        delete vm.svdata.bdatesv;
        delete vm.bdateerror;
        vm.save();
      }

      function validateSVNR(svnr) {
        var result = false;
        if (angular.isDefined(svnr) && svnr.length > 0) {
          var nr = svnr.split('');
          var checksum = (5 * parseInt(nr[4], 10) + 8 * parseInt(nr[5], 10) + 4 * parseInt(nr[6], 10) + 2 * parseInt(nr[7], 10) + parseInt(nr[8], 10) + 6 * parseInt(nr[9], 10) + 3 * parseInt(nr[0], 10) + 7 * parseInt(nr[1], 10) + 9 * parseInt(nr[2], 10)) % 11;
          result = checksum === parseInt(nr[3], 10);
        }
        return result;
      }

      function formatSVNR() {
        $log.debug('debug: formatSVNR called');
        var valid = false;
        // noinspection JSUnresolvedVariable
        if (angular.isDefined(vm.svdata.svnrlfd) && angular.isDefined(vm.svdata.bdatesv)) {
          // noinspection JSUnresolvedVariable
          var svnr = vm.svdata.svnrlfd + vm.svdata.bdatesv;
          valid = vm.validateSVNR(svnr);
          vm.isvalidsvnr = valid;
          vm.svdata.svnr = svnr;
          // noinspection ES6ModulesDependencies
          vm.svdata.medicalnetnr = svnr.substr(0, 8) + moment(vm.svdata.bdateiso).year().toString().substr(0, 2) + svnr.substr(8, 2);
        }
        vm.isvalidsvnr = valid;
        if (vm.isvalidsvnr) {
          vm.save();
        }
        return valid;
      }

      function clearSVNR() {
        delete vm.svdata.svnr;
        vm.save();
      }

      function calcBMI(height, weight) {
        var bmi = 0;
        if (angular.isNumber(height) && angular.isNumber(weight) && height !== 0) {
          bmi = Math.round(weight * 10000 / (height * height) * 10) / 10;
        }
        return bmi;
      }

      function setBMI() {
        if (angular.isDefined(vm.svdata.height) && angular.isDefined(vm.svdata.weight)) {
          vm.svdata.bmi = calcBMI(vm.svdata.height, vm.svdata.weight);
        }
        vm.save();
      }

      function clearSV() {
        delete vm.svdata.sv;
        delete vm.svdata.svref;
        vm.save();
      }

      function clearRefDoctor() {
        delete vm.svdata.refdoctor;
        vm.save();
      }

      function clearPractDoctor() {
        delete vm.svdata.practdoctor;
        vm.save();
      }

      vm.bdatehelp = 'Eingabe im Format T.M.JJJJ, T-M-JJJJ oder TTMMJJJJ. Der Inhalt wird automatisch im zu TT.MM.JJJJ formatiert';
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('riskviewer', {
    restrict: 'E',
    bindings: {
      risk: '='
    },
    template: '\n           <i class="fa fa-glass" ng-class="vm.risk.alcohol ? \'text-danger\' : \'text-muted\'" uib-tooltip="Alkohol: {{vm.risk.alcoholdetails}}"></i>\n           <i class="fa fa-magic" ng-class="vm.risk.nicotin ? \'text-danger\' : \'text-muted\'" uib-tooltip="Nikotin: {{vm.risk.nicotindetails}}"></i>\n           <i class="fa fa-warning" ng-class="vm.risk.otherb ? \'text-danger\' : \'text-muted\'" uib-tooltip="{{vm.risk.other}}"></i>\n      ',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('riskedit', {
    restrict: 'E',
    bindings: {
      risk: '=',
      parentsave: '&'
    },
    templateUrl: 'vcclient/riskedit-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.childsave = childsave;

      vm.$onInit = function () {
        // $log.debug('***** debug: risk: ', vm.risk);
        vm.lastrisk = angular.copy(vm.risk);
      };

      function childsave(key, value) {
        vm.risk[key] = value;
        vm.save();
      }

      function save() {
        $log.debug('debug: riskeditedit save called');
        if (!angular.equals(vm.risk, vm.lastrisk)) {
          vm.lastrisk = angular.copy(vm.risk);
          $log.debug('debug: contactedit calling parentsave');
          vm.parentsave();
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 01/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('patientheader', {
    restrict: 'E',
    bindings: {
      client: '<?',
      clientid: '<?',
      mode: '<?'
    },
    template: '\n       <div class="row">\n      <div class="col-xs-4 col-md-2">\n        <img ng-src="{{vm.client.image}}" class="img-responsive"\n             alt="{{vm.client.primarycontact.firstname}} {{vm.client.primarycontact.lastname}}">\n        <imagecapture captureid="clientphoto" clientid="vm.client._id" class="imgcapture" filehandle="vm.client.image" filecat="patientavatar"></imagecapture>\n      </div>\n      <div class="col-xs-8 col-md-10">\n        <h3>\n        <span class="pull-left">\n          <span class="rwd-line">\n            <span ng-show="vm.client.primarycontact.titlefront" class="hidden-xs hidden-sm">{{vm.client.primarycontact.titlefront}} </span>\n                {{vm.client.primarycontact.firstname}} {{vm.client.primarycontact.lastname}}\n                <i class="fa fa-mars text-primary" ng-show="vm.client.primarycontact.gender === \'männlich\'"></i>\n                <i class="fa fa-venus text-danger" ng-show="vm.client.primarycontact.gender === \'weiblich\'"></i>\n                <i class="fa fa-venus-mars text-success" ng-show="vm.client.primarycontact.gender === \'unbekannt\'"></i>\n            <span ng-show="vm.client.primarycontact.titleback" class="hidden-xs hidden-sm">, {{vm.client.primarycontact.titleback}} </span>,\n          </span>\n          <span class="rwd-line">\n            *&nbsp;{{vm.client.svdata.bdateat}}\n            <a ui-sref="dms.signoffperson({clientid: vm.client._id})"> <signoffcounter patientid="vm.client._id"></signoffcounter></a>\n          </span>\n        </span>\n        <span class="mypull-right">\n            <riskviewer risk="vm.client.risk"></riskviewer>\n        </span>\n        </h3>\n        <div class="clearfix"></div>\n        <div class="hidden-xs hidden-sm"><diagnosesedit diagnoses="vm.client.diagnoses" deleteddiagnoses="vm.client.deleteddiagnoses" parentsave="vm.childsave()" deleteable="true"></diagnosesedit></div>\n      </div>\n      <div class="hidden-md hidden-lg  hidden-xl col-xs-12"><diagnosesedit diagnoses="vm.client.diagnoses" parentsave="vm.childsave()"></diagnosesedit></div>\n      </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'ClientHelper', 'vertxEventBusService', '$window', '$timeout', function ($log, Rlog, ClientHelper, vertxEventBusService, $window, $timeout) {
      var vm = this;
      vm.childsave = childsave;

      vm.$onInit = function () {

        if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
          vm.kunde = 'Patient';
          vm.testkunde = 'Testpatient';
        } else {
          vm.mode = 'client';
          vm.kunde = 'Kunde';
          vm.testkunde = 'Testkunde';
        }

        if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0) {
          ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
            vm.client = client;
            if (angular.isUndefined(vm.client.deleteddiagnoses) || !angular.isArray(vm.client.deleteddiagnoses)) {
              vm.client.deleteddiagnoses = [];
              vm.client.$save();
              $log.debug('initalised deleteddiagnoses to empty array');
            }
          }, function (err) {
            vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
            Rlog.error('client', 'patientheader', 'client.$find() failed', { id: vm.clientid });
          });
        }
      }; // $onInit()

      // vm.clientid might be late propagating, get consult on first change / wasn't needed as all id are resolved in router

      function childsave() {
        $log.debug('**** patientheader childsave called:', vm.client.diagnoses);
        if (!angular.equals(vm.client, vm.lastclient)) {
          vm.client.flatdiagnoses = vm.client.diagnoses.map(function (diag) {
            return diag.key;
          });
          $log.debug('**** patientheader saving child :', vm.client.diagnoses, vm.client.flatdiagnoses);
          vm.lastclient = angular.copy(vm.client);
          if (vm.client.$hasPendingActions) {
            $log.warn('[CLIENT][PatientHeader] client save had pending actions, cancelling now.');

            vm.client.$cancel();
            $timeout(function () {
              $log.warn('[CLIENT][PatientHeader]  waited 1.5 seconds because of client having had pending actions, saving now.');
              savesave();
            }, 1500);
          } else {
            savesave();
          }
        }
      }

      function savesave() {
        vm.client.$save().$then(function () {}, function (err) {
          $log.error('[CLIENT][PatientHeader] debug/error: client save failed!', err);
          Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: vm.client._id });
        });
      }

      function resetOrientation(srcBase64, srcOrientation, callback) {
        var img = new Image();

        img.onload = function () {
          var width = img.width,
              height = img.height,
              canvas = document.createElement('canvas'),
              ctx = canvas.getContext("2d");

          // set proper canvas dimensions before transform & export
          if (4 < srcOrientation && srcOrientation < 9) {
            canvas.width = height;
            canvas.height = width;
          } else {
            canvas.width = width;
            canvas.height = height;
          }

          // transform context before drawing image
          switch (srcOrientation) {
            case 2:
              ctx.transform(-1, 0, 0, 1, width, 0);
              break;
            case 3:
              ctx.transform(-1, 0, 0, -1, width, height);
              break;
            case 4:
              ctx.transform(1, 0, 0, -1, 0, height);
              break;
            case 5:
              ctx.transform(0, 1, 1, 0, 0, 0);
              break;
            case 6:
              ctx.transform(0, 1, -1, 0, height, 0);
              break;
            case 7:
              ctx.transform(0, -1, -1, 0, height, width);
              break;
            case 8:
              ctx.transform(0, -1, 1, 0, 0, width);
              break;
            default:
              break;
          }

          // draw image
          ctx.drawImage(img, 0, 0);

          // export base64
          callback(canvas.toDataURL());
        };

        img.src = srcBase64;
      }

      var patientsUpdateHandler = function patientsUpdateHandler(message) {
        $log.debug('debug: Patient update received: ', message);
        var messages = message.split(':');
        // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
        // if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
        if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
          vm.client.$refresh().$then(function () {
            $log.debug('debug: patientheader refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          }, function (error) {
            $log.debug('debug: patientehader could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          });
        }
      };

      var clientsUpdateHandler = function clientsUpdateHandler(message) {
        $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        // if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
        if (angular.isDefined(vm.client) && vm.client._id === messages[0]) {
          vm.client.$refresh().$then(function () {
            $log.debug('debug: patientheader refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          }, function (error) {
            $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
          });
        }
      };

      vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
      vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
        vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */

'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name patient.factory:PatientService
   *
   * @description
   *
   */
  angular.module('vcclient').factory('Patient', Patient).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Patient.$inject = ['restmod'];

  function Patient(restmod) {
    return restmod.model('/routes/patients', 'PagedModel', 'DebouncedModel').mix({
      consults: { hasMany: 'Consult' },
      reminders: { hasMany: 'Reminder' },
      // keywords: {hasMany: 'Keywords'},
      // diagnoses: {hasMany: 'Diagnoses'},
      // drugs: {hasMany: 'Drugs'},
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      test: { init: false },
      log: { init: [] },
      primarycontact: { init: {} },
      companydata: { init: {} },
      diagnoses: { init: [] },
      deleteddiagnoses: { init: [] },
      svref: { init: {} },
      image: { init: '/img/head_male.png' },
      inconsult: { inconsult: false },
      incheckout: { incheckout: false },
      consultstate: { consultstate: '' },
      checkoutstate: { checkoutstate: '' },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/patients/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      } // extend
    });
  }
})();
/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
'use strict';

(function () {
    'use strict';
    angular.module('vcclient').component('diagnosesedit', {
        restrict: 'E',
        bindings: {
            diagnoses: '=',
            deleteddiagnoses: '=',
            parentsave: '&',
            orderbycolor: '<',
            customlabels: '<?',
            printlabels: '<?',
            deleteable: '@?'
        },
        templateUrl: 'vcclient/diagnosesedit-component.tpl.html',
        controllerAs: 'vm',
        controller: ['$log', function ($log) {
            var vm = this;

            vm.orderkey = 'nr';
            vm.save = save;
            vm.updateColor = updateColor;
            vm.addKeyword = addKeyword;
            vm.editKeyword = editKeyword;
            vm.removeKeyword = removeKeyword;
            vm.updateInvoiceVisibility = updateInvoiceVisibility;

            vm.sortableOptions = {
                itemMoved: function itemMoved(event) {
                    $log.debug('diagnose moved: ', event);
                    save();
                },
                orderChanged: function orderChanged(event) {
                    $log.debug('diagnose order changed: ', event);
                    save();
                }
            };

            function nrResolver(col) {
                var nrR = {
                    primary: 1,
                    info: 2,
                    danger: 3,
                    warning: 4,
                    success: 5
                };
                return nrR[col];
            }

            vm.$onInit = function () {
                if (angular.isUndefined(vm.customlabels)) {
                    vm.customlabels = {
                        primary: 'Neu',
                        info: 'Aktuell',
                        danger: 'Gefahr',
                        warning: 'Warnung',
                        success: 'St.p.'
                    };
                }
                if (angular.isUndefined(vm.printlabels)) {
                    vm.printlabels = {
                        primary: '(neu)',
                        info: '',
                        danger: '',
                        warning: '',
                        success: '(St.p.)'
                    };
                }
                // $log.debug('diagnoseedit diagnoses: ', vm.diagnoses);
            };

            function updateColor(kw, color) {
                kw.col = color;
                kw.nr = nrResolver(color);
                kw.alttext = vm.printlabels[color];
                kw.updated = moment().locale('de-at').format('l');
                save();
            }

            function removeKeyword(kw, index) {
                // $log.debug('deleting diagnose: ', index, kw);
                kw.active = false;
                kw.timestamp = moment().toISOString();
                kw.removed = moment().locale('de-at').format('l');
                vm.diagnoses.splice(index, 1);
                vm.deleteddiagnoses.push(kw);
                // $log.debug('after diagnose delete: ', vm.diagnoses, vm.deleteddiagnoses);
                save();
            }

            function addKeyword() {
                if (angular.isDefined(vm.newkeyword) && vm.newkeyword.length > 0) {
                    var kw = {};
                    kw.col = 'primary';
                    kw.key = vm.newkeyword;
                    kw.nr = nrResolver(kw.col);
                    kw.alttext = vm.printlabels[kw.col];
                    kw.timestamp = moment().toISOString();
                    kw.created = moment().locale('de-at').format('l');
                    kw.updated = moment().locale('de-at').format('l');

                    if (!angular.isArray(vm.diagnoses)) {
                        vm.diagnoses = [];
                    }
                    vm.diagnoses.push(kw);

                    vm.newkeyword = '';
                    save();
                }
            }

            function editKeyword(kw) {
                kw.timestamp = moment().toISOString();
                kw.updated = moment().locale('de-at').format('l');
                $log.debug('edited kw: ', kw);
                save();
            }

            function updateInvoiceVisibility(kw) {
                save();
            }

            function save() {
                // $log.debug('debug: diagnosesedit save called: ', vm.diagnoses,  vm.lastdiagnoses);
                // $log.debug('debug: diagnosesedit save called: ', vm.diagnoses, vm.deleteddiagnoses);
                //   $log.debug('***: diagnoseedit calling parentsave: ', vm.parentsave, vm.deleteddiagnoses);
                vm.parentsave();
            }
        }] // controller
    }); // component

    // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('contactedit', {
    restrict: 'E',
    bindings: {
      contactdata: '=',
      parentsave: '&',
      showrelation: '<?'
    },
    templateUrl: 'vcclient/contactedit-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;
      vm.formatphone = formatphone;
      vm.childsave = childsave;
      vm.zipsave = zipsave;

      vm.$onInit = function () {
        // $log.debug('***** debug: contactdata: ', vm.contactdata);
        if (angular.isUndefined(vm.contactdata.country)) {
          vm.contactdata.country = 'Österreich';
        }
        vm.lastcontact = angular.copy(vm.contactdata);
      };

      vm.$onChange = function (change) {
        $log.debug('***** debug: cahnge contactdata: ', vm.contactdata);
        if (angular.isUndefined(vm.contactdata.country)) {
          vm.contactdata.country = 'Österreich';
        }
        vm.lastcontact = angular.copy(vm.contactdata);
      };

      function childsave(key, value) {
        vm.contactdata[key] = value;
        vm.save();
      }

      function zipsave(zip, city) {
        $log.debug('debug: contactedit zipsave called: ', zip, city);
        vm.contactdata.postcode = zip;
        vm.contactdata.city = city;
        vm.save();
      }

      function formatphone(num) {
        // TODO: phonenumber formatter
        save();
      }

      function save() {
        $log.debug('debug: contactedit save called');
        if (!angular.equals(vm.contactdata, vm.lastcontact)) {
          vm.lastcontact = angular.copy(vm.contactdata);
          $log.debug('debug: contactedit calling parentsave');
          vm.parentsave();
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 04/05/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('companyedit', {
    restrict: 'E',
    bindings: {
      companydata: '<',
      parentsave: '&'
    },
    templateUrl: 'vcclient/companyedit-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', function ($log) {
      var vm = this;
      vm.save = save;

      vm.$onInit = function () {
        vm.lastcompanydata = angular.copy(vm.companydata);
      };

      function save() {
        if (!angular.equals(vm.companydata, vm.lastcompanydata)) {
          vm.lastcompanydata = angular.copy(vm.companydata);
          $log.debug('debug: comapnyedit parentsave() called');
          vm.parentsave();
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 13/07/2017.
 */

'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('clientsearch', {
    restrict: 'E',
    bindings: {
      parentsave: '&',
      mode: '@?',
      redirect: '@?',
      redirectnew: '@?',
      ti: '@?',
      grabfocus: '@?'
    },
    template: '\n        <div class="form-group">\n          <div class="input-group clientsearch">\n            <!--<span class="input-group-btn" ng-show="vm.loadingNames || vm.noResults">-->\n            <span class="input-group-btn">\n              <button type="button" ng-show="vm.asyncSelected && vm.asyncSelected.length > 0"\n                    ng-click="vm.addClient()"\n                    ng-class="{\'btn-success\': vm.noResults, \'btn-warning\': !vm.noResults}"\n                    class="btn" tabindex="-1">\n                <i class="fa fa-user-plus" uib-tooltip="Neuen {{vm.kunden}} anlegen" tooltip-placement="auto bottom"></i>\n              </button>\n              <button type="button" ng-hide="vm.asyncSelected"\n                    ng-click="vm.addClient()"\n                    ng-class="{\'btn-warning\': vm.noResults, \'btn-warning\': !vm.noResults}"\n                    class="btn" tabindex="-1">\n                <i class="fa fa-user-plus" uib-tooltip="Neuen {{vm.kunden}} anlegen" tooltip-placement="auto bottom"></i>\n              </button>\n              <button type="button" ng-show="vm.loadingNames"\n                    class="btn btn-info" tabindex="-1">\n                <i ng-show="loadingNames" class="fa fa-spinner fa-spin"></i>\n              </button>\n              <button type="button" ng-show="vm.noResults"\n                    class="btn btn-warning" tabindex="-1">\n                <i ng-show="vm.noResults" class="fa fa-warning" uib-tooltip="Keine {{vm.kunden}} gefunden" tooltip-placement="auto bottom"></i>\n              </button>\n\n            </span>\n              <input type="text" class="form-control" tabindex="{{vm.tabi}}"\n                ng-class="{\'dirtyfield\': vm.asyncSelected.length > 0}"\n                placeholder="{{vm.placeholder}}"\n                ng-model="vm.asyncSelected"\n                typeahead-on-select="$parent.$dismiss();vm.showclient($item, $model, $label)"\n                uib-typeahead="client as client.text for client in vm.getClients($viewValue)"\n                typeahead-loading="vm.loadingNames"\n                typeahead-focus-first="false"\n                typeahead-no-results="vm.noResults"\n                typeahead-min-length=2 \n\n                class="searchinput"\n                >\n              <span class="input-group-btn">\n                <button type="submit"\n                       ng-class="{\'btn-warning\': vm.noResults, \'btn-info\': !vm.noResults}"\n                       class="btn" tabindex="-1"><i class="fa fa-search"></i></button>\n              </span>\n          </div>\n        </div>\n        \n<!--        <script type="text/ng-template" id="linebreaktpl.html">\n          <ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n              <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" \n              style="max-width: 30em; background-color: red;"\n                  ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n                  &nbsp;<div uib-typeahead-match index=$index" match="match" query="query" template-url="templateUrl"></div>\n              </li>\n          </ul>\n        </script>\n        \n        \n        <script type="text/ng-template" id="item.html">\n            <span>I am an item<a href tabindex="-1" ng-bind-html="match.label | uibTypeaheadHighlight:query" ng-attr-title="{{match.label}}" style="max-width: 20em"></a></span>\n        </script>-->\n        \n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Client', 'ClientHelper', '$state', 'Drug', '$element', function ($log, Client, ClientHelper, $state, Drug, $element) {
      var vm = this;
      // vm.save = save;
      vm.showclient = showclient;

      vm.getClients = getClients;
      vm.addClient = addClient;
      // vm.editClient = ClientHelper.editClient;

      vm.$onInit = function () {
        vm.newclient = {};

        // mode
        if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
          vm.mode = 'client';
          vm.kunde = 'Kunde';
          vm.kunden = 'Kunden';
          vm.placeholder = 'Name, Firma, Stichwort';
        } else {
          vm.kunde = 'Patient';
          vm.kunden = 'Patienten';
          vm.placeholder = 'Name, Diagnose';
        }

        // taborder
        if (angular.isUndefined(vm.ti)) {
          vm.ti = 0;
          vm.tabi = 0;
        }
        if (angular.isString(vm.ti)) {
          vm.tabi = parseInt(vm.ti, 10);
        } else {
          vm.tabi = 0;
        }

        //  grabfocus
        if (angular.isDefined(vm.grabfocus) && vm.grabfocus !== false) {
          angular.element($element)[0].children[0].children[0].children[1].focus();
        }
      }; // $onInit

      function addClient() {
        $log.debug('debug - clientsearch addClient called');
        var client = {};
        client.primarycontact = {};
        client.primarycontact.lastname = vm.asyncSelected[0].toUpperCase() + vm.asyncSelected.slice(1);
        client.primarycontact.country = 'Österreich';
        if (vm.mode === 'patient') {
          client.dicompatid = moment().valueOf().toString() + Math.floor(Math.random() * 999).toString();
        }
        ClientHelper.create(client, vm.mode).$then(function (newclient) {
          delete vm.asyncSelected;
          delete vm.noResults;
          delete vm.loadingNames;
          $log.debug('handle newly create client: ', newclient);
          $log.debug('redirect new handle newly create client: ', vm.redirectnew, vm.mode);
          // If client is a patient, then create a patdrug record entry
          if (vm.mode === 'patient') {
            Drug.$create({ patientid: newclient._id }).$then(function (patdrug) {
              $log.info('freshly created patdrug entry for patient: ', vm.patientid, patdrug);
            }, function (err) {
              $log.error('failed to created patdrug entry for patient: ', vm.patientid);
            });
          }
          if (angular.isDefined(vm.redirectnew) && angular.isDefined(vm.mode)) {
            $state.go(vm.redirectnew, { client: newclient, clientid: newclient._id, mode: vm.mode });
          } else {
            $state.go('clientrecord.basicdata', { client: newclient, clientid: newclient._id, mode: 'client' });
          }
        }, function (err) {
          vm.error = true;
          $log.error(err);
        });
      }

      // typeahead client search backend query
      function getClients(val) {
        return ClientHelper.searchahead({
          query: val,
          fields: ['primarycontact.lastname', 'primarycontact.firstname', 'flatdiagnoses', 'companydata.name', 'svdata.svnr'],
          resultfields: ['primarycontact', 'flatdiagnoses', 'diagnoses', 'notes', 'risk', 'companydata.name', 'svdata.svnr', 'svdata.birthdate', 'svdata.bdateat']
        }, vm.mode).$asPromise().then(function (response) {
          return response.map(function (client) {
            ClientHelper.diagname(client, vm.mode, val);
            delete vm.error;
            return client;
          });
        });
      }

      // typeahead client search action
      function showclient($item, $model, $label, $event) {
        /* jshint unused:false */
        /* eslint "no-unused-lets": [2, {"args": "none"}] */
        // clear searchbox
        delete vm.asyncSelected;
        vm.client = $model;

        $log.debug('debug - vm.redirect: ', vm.redirect);

        if (angular.isDefined(vm.redirect) && angular.isString(vm.redirect) && vm.redirect.length > 0) {
          // TODO: $state.go requires valid state to transistion into
          $state.go(vm.redirect, { client: vm.client, clientid: vm.client._id, mode: vm.mode });
        } else {
          $log.debug('client in clientsearch; ', vm.client);
          vm.parentsave({ client: vm.client, mode: vm.mode });
        }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('clientnotes', {
    restrict: 'E',
    bindings: {
      clientid: '<',
      mode: '@?'
    },
    template: '\n       <vcarea model="vm.client.notes"\n               parentsave="vm.childsave(key, value)"\n               id="notes"\n               options="vm.options">\n       </vcarea>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Client', 'ClientHelper', 'Rlog', 'vertxEventBusService', '$window', function ($log, Client, ClientHelper, Rlog, vertxEventBusService, $window) {
      var vm = this;
      vm.childsave = childsave;
      vm.options = { updateOn: 'default blur', debounce: { 'default': 20000, blur: 0 } };

      vm.$onInit = function () {
        if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
          vm.kunde = 'Patient';
          vm.testkunde = 'Testpatient';
        } else {
          vm.mode = 'client';
          vm.kunde = 'Kunde';
          vm.testkunde = 'Testkunde';
        }

        if (angular.isDefined(vm.clientid)) {
          ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
            vm.client = client;
          }, function (error) {
            vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
            Rlog.error('client', 'clienteditor', 'client.$find() failed', { id: vm.clientid });
          });
        }
      }; // $onInit()

      // vm.clientid might be late propagating, get client on first real change

      vm.$onChanges = function (changes) {
        if (!changes.isFirstChange) {
          if (angular.isDefined(vm.clientid)) {
            ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
              vm.client = client;
            }, function (err) {
              $log.error('client not found, id: ', vm.clientid);
              Rlog.error('client', 'clientnotes', 'client not found', { _id: vm.clientid });
            });
          }
        }
      };

      function childsave(key, value) {
        if (vm.client[key] !== value) {
          vm.client[key] = value;
          if (vm.client.$hasPendingActions) {
            vm.client.$cancel();
          }
          savesave();
        }
      }

      function savesave() {
        // $log.debug('debug: savesave vm.client: ', vm.client.svdata);
        vm.client.$save().$then(function () {}, function () {
          $log.debug('debug/error: client save failed!');
          Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: client._id });
        });
      }

      var patientsUpdateHandler = function patientsUpdateHandler(message) {
        $log.debug('debug: Patient update received: ', message);
        var messages = message.split(':');
        // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
        if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            vm.client.$refresh().$then(function () {
              $log.debug('debug: clienteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            }, function (error) {
              $log.debug('debug: clienteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            });
          }
        }
      };

      var clientsUpdateHandler = function clientsUpdateHandler(message) {
        $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            vm.client.$refresh().$then(function () {
              $log.debug('debug: clienteditor refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            }, function (error) {
              $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            });
          }
        }
      };

      vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
      vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
        vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 04/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('clientnew', {
    restrict: 'E',
    bindings: {
      onCreate: '&',
      onCancel: '&',
      onSelectRecord: '&',
      mode: '@?'
    },
    templateUrl: 'vcclient/clientnew-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Patient', 'Client', 'ClientHelper', '$state', function ($log, $http, Patient, Client, ClientHelper, $state) {
      var vm = this;
      var url = undefined;
      vm.orgSearch = orgSearch;
      vm.nameSearch = nameSearch;
      vm.setLastname = setLastname;
      vm.setOrgname = setOrgname;
      vm.createPatient = createPatient;
      vm.gotoRecord = gotoRecord;

      // wrapper for parent function calls
      /*          vm.oncreate = function () {
       return vm.onCreate();
       };*/

      vm.cancel = function () {
        return vm.onCancel();
      };

      vm.showRecord = function (id) {
        return vm.onSelectRecord({ clientid: id });
      };

      vm.$onInit = function () {
        vm.newclient = {};
        vm.newclient.primarycontact = {};
        vm.newclient.svdata = {};
        vm.newclient.companydata = {};
        if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
          vm.mode = 'client';
          url = '/routes/clients/searchahead';
          vm.kunde = 'Kunde';
          vm.kunden = 'Kunden';
        } else {
          url = '/routes/clients/searchahead';
          vm.kunde = 'Patient';
          vm.kunden = 'Patienten';
        }
        $log.debug('debug: clientnew $onInit() url: ', url);
      }; // $onInit()

      // tagahead organisation search
      function orgSearch(val) {
        return ClientHelper.searchahead({
          query: val,
          fields: ['companydata.name', 'primarycontact.lastname']
        }, vm.mode).$asPromise().then(function (response) {
          return response.map(function (client) {
            ClientHelper.fname(client, vm.mode);
            delete vm.error;
            return client;
          });
        });
      }

      // tagahead name search
      function nameSearch(val) {
        return ClientHelper.searchahead({
          query: val,
          fields: ['primarycontact.lastname', 'primarycontact.firstname']
        }, vm.mode).$asPromise().then(function (response) {
          response.map(function (client) {
            ClientHelper.fname(client, vm.mode);
            delete vm.error;
            return client;
          });
          vm.clientResults = response;
          return response;
        });
      }

      function catchClick($event) {
        $log.debug('event caught: ', $event);
      }

      function gotoRecord(client) {
        $log.debug('debug - gotoRecord going to state: ', client._id);
        // $state.go('playground.vcutilsdoctor.allcomponents', {
        vm.onCreate({ client: client, mode: vm.mode });
        // TODO: target state needs to be valid for transisiton to occur!
        /*        $state.go('clientrecord.basicdata', {
                  client: client,
                  clientid: client._id,
                  patientid: client._id,
                  mode: vm.mode
                });*/
      }

      function setLastname($item, $model, $label, $event) {
        if ($event.toElement.getAttribute('class') === 'btn btn-info gotorec') {
          gotoRecord($item);
        } else {
          if (!angular.isObject(vm.newclient)) {
            vm.newclient = {};
          }
          vm.newclient.primarycontact.lastname = $model.primarycontact.lastname;
        }
      }

      function setOrgname($item, $model, $label, $event) {
        if ($event.toElement.getAttribute('class') === 'btn btn-info gotorec') {
          gotoRecord($item);
        } else {
          if (!angular.isObject(vm.newclient)) {
            vm.newclient = {};
          }
          vm.newclient.companydata.name = $model.companydata.lastname;
        }
      }

      function createPatient() {
        // this is totally ugly, but it seems to work
        $log.debug('vm.newclient create: ', vm.newclient);

        if (vm.mode === 'patient') {
          Patient.$create(vm.newclient).$then(function (client) {
            console.log('patid: ', client._id);
            vm.onCreate({ client: client, mode: vm.mode });
            // $state.go('patientrecord.basicdata', {patientid: vcclient._id});
          });
        } else {
            Client.$create(vm.newclient).$then(function (client) {
              console.log('clientid: ', client._id);
              vm.onCreate({ client: client, mode: vm.mode });
              // $state.go('patientrecord.basicdata', {clientid: vcclient._id});
            });
          }
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
/* either pass list of clients (patients) to dispay or load clients/patients depending on mode */

'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('clientlist', {
    restrict: 'E',
    bindings: {
      mode: '@?',
      clients: '<?',
      redirect: '@?'
    },
    templateUrl: 'vcclient/clientlist-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', '$http', 'Rlog', 'ClientHelper', '$state', 'vertxEventBusService', function ($log, $http, Rlog, ClientHelper, $state, vertxEventBusService) {
      var vm = this;

      vm.currentPage = 1;
      vm.pageSize = 20;
      vm.pageChanged = pageChanged;
      vm.goToRecord = goToRecord;
      vm.removeClient = removeClient;

      vm.$onInit = function () {
        // default mode is 'client', set to 'patient' for sprechstunde compatibility

        if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
          vm.mode = 'client';
        }

        $log.debug('debug - vm.redirect passed is:', vm.redirect);
        // TODO: figure out why automatically derived vm.redirect becomes unset again before use
        if (angular.isUndefined(vm.redirect) || vm.redirect === '' || vm.redirect === null) {
          if (vm.mode === 'patient') {
            vm.redirect = 'clientrecord.basicdata';
          } else {
            vm.redirect = 'clientrecord.basicdata';
          }
          $log.debug('debug - vm.redirect set to:', vm.redirect);
        }
        // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
        if (angular.isUndefined(vm.clients)) {
          $log.debug('debug: clients loading from backend');

          var search = {};
          search.page = vm.currentpage;

          search.query = {};
          search.query.active = true;
          search.options = {};
          if (angular.isDefined(vm.pageSize)) {
            search.options.pagesize = vm.pageSize;
          }

          // not necessary if you want all of the fields
          search.options.fields = {
            _id: 1,
            created: 1,
            test: 1,
            type: 1,
            category: 1,
            iscompany: 1,
            'company.name': 1,
            'primarycontact.firstname': 1,
            'primarycontact.lastname': 1,
            'svdata.bdateat': 1
          };
          var sort = {};

          // get special fields according to vcclient type
          if (vm.mode === 'patient') {
            // search.options.fields.svdata = 1;
            sort['primarycontact.lastname'] = 1;
          } else {
            // search.options.fields.companydata = 1;
            sort['companydata.companyname'] = 1;
          }
          search.options.sort = sort;

          ClientHelper.getAll(search, vm.mode).$then(function (clients) {
            vm.clients = clients;
            vm.totalItems = clients.$pageCount;
          });
        }
      };

      function pageChanged() {
        vm.clients.$refresh({ page: vm.currentPage }).$then(function (clients) {
          vm.totalItems = clients.$pageCount;
        });
      }

      function removeClient(client) {
        client.active = false;
        client.$save();
      }

      function goToRecord(client, target) {
        // TODO: figure out why automatically derived vm.redirect becomes unset again before use
        $log.debug('debug - gotToRecord vm.redirect, vm.mode: ', vm.redirect, vm.mode);
        $log.debug('debug - gotToRecord target: ', target);
        $state.go(vm.redirect, { client: client, clientid: client._id, mode: vm.mode });
        /*                      if (vm.mode === 'patient') {
                                    $state.go(vm.redirect, {client: client, clientid: client._id, mode: vm.mode});
                                } else {
                                    $state.go(vm.redirect, {client: client, clientid: client._id, mode: vm.mode});
                                }*/
      }

      var patientsUpdateHandler = function patientsUpdateHandler(message) {
        $log.debug('debug: Patient update received: ', message);
        vm.clients.$refresh().$then(function () {}, function (error) {
          $log.error(error);
        });
      };

      var clientsUpdateHandler = function clientsUpdateHandler(message) {
        $log.debug('debug: Client update received: ', message);
        vm.clients.$refresh().$then(function () {}, function (error) {
          $log.error(error);
        });
      };

      vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
      vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
        vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 01/06/2017.
 */
'use strict';

(function () {
  'use strict';
  angular.module('vcclient').component('clienteditor', {
    restrict: 'E',
    bindings: {
      client: '<?',
      clientid: '@?',
      parentsave: '&?',
      mode: '@?',
      clientcategories: '<?'
    },
    templateUrl: 'vcclient/clienteditor-component.tpl.html',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', 'ClientHelper', 'vertxEventBusService', '$window', '$timeout', function ($log, Rlog, ClientHelper, vertxEventBusService, $window, $timeout) {
      var vm = this;
      vm.title = 'clienteditor-component-controller';
      vm.save = save;
      vm.addContact = addContact;
      vm.childsave = function () {
        $log.debug('debug: clienteditor childsave called');
        return vm.save();
      };
      vm.savesave = savesave;

      vm.$onInit = function () {
        if (angular.isDefined(vm.mode) && vm.mode === 'patient') {
          vm.kunde = 'Patient';
          vm.testkunde = 'Testpatient';
        } else {
          vm.mode = 'client';
          vm.kunde = 'Kunde';
          vm.testkunde = 'Testkunde';
        }

        if (angular.isDefined(vm.client) && vm.client.hasOwnProperty('_id')) {
          if (angular.isUndefined(vm.client.contacts)) {
            vm.client.contacts = [];
          }

          if (angular.isUndefined(vm.client.companydata)) {
            vm.client.companydata = {};
          }

          if (vm.mode === 'patient' && angular.isUndefined(vm.client.svdata)) {
            vm.client.svdata = {};
          }

          vm.lastclient = angular.copy(vm.client);
          vm.save();
        }

        if (angular.isDefined(vm.clientid) && angular.isDefined(vm.clientid.length) && vm.clientid.length > 0) {
          ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
            vm.client = client;
            if (angular.isUndefined(vm.client.contacts)) {
              vm.client.contacts = [];
            }

            if (angular.isUndefined(vm.client.companydata)) {
              vm.client.companydata = {};
            }

            if (vm.mode === 'patient' && angular.isUndefined(vm.client.svdata)) {
              vm.client.svdata = {};
            }

            vm.lastclient = angular.copy(vm.client);
            vm.save();
          });
        }

        // dead code? Load client/patient from backend if no client object but a clientid was provided
        // ran into problems with un-initialised sub-widgets -> load client object in router
        /*            if (angular.isDefined(vm.client) && angular.isObject(vm.client) && vm.client.hasOwnProperty('_id')) {
                      vm.lastclient = angular.copy(vm.client);
                      makesane();
                      vm.workingclient = angular.copy(vm.client);
                    }
                    else if (angular.isDefined(vm.clientid) && angular.isString(vm.clientid) && vm.clientid.length > 0) {
                      ClientHelper.find(vm.mode, vm.clientid).$then((client) => {
                        vm.client = client;
                        $log.debug('debug: client retrieved my restmod: ', vm.client);
                        makesane();
                        vm.workingclient = angular.copy(vm.client);
                        vm.lastclient = angular.copy(vm.client);
                        $log.debug('debug: workingclient copy', vm.workingclient);
                      }, (error) => {
                        vm.error = 'Der ' + vm.kunde + ' mit der Nummer ' + vm.clientid + ' konnte nicht gefunden werden! Der Fehler wurde protokolliert.';
                        Rlog.error('client', 'clienteditor', 'client.$find() failed', {id: vm.clientid});
                      });
                    }
                    else {
                      $log.debug('debug: client editor - neither client nor clientid was provided');
                      vm.error = 'Es wurde weder ein ' + vm.kunde + 'n Objekt noch eine Identifikationsnummer übergeben. Es sind keine Daten vorhanden. Der Fehler wurde protokolliert.!';
                      Rlog.error('client', 'clienteditor', 'neither client nor clientid was provided', {});
                    }*/
      }; // $onInit()

      function addContact() {
        // $log.debug('debug: addContact called');
        if (angular.isUndefined(vm.client.contacts)) {
          vm.client.contacts = [];
        }
        vm.client.contacts.push({});
      }

      function save() {
        if (!angular.equals(vm.client, vm.lastclient)) {
          vm.lastclient = angular.copy(vm.client);
          if (vm.client.$hasPendingActions) {
            vm.client.$cancel();
            $timeout(function () {
              $log.warn('[CLIENT][ClientEditor] waited 1.5 seconds because of file having had pending actions, saving now.');
              vm.savesave();
            }, 1500);
          } else {
            vm.savesave();
          }
        }
      }

      function savesave() {
        // $log.debug('debug: savesave vm.client: ', vm.client.svdata);
        if (angular.isDefined(vm.client.$save)) {
          vm.client.$save().$then(function () {}, function () {
            $log.debug('debug/error: client save failed!');
            Rlog.error('client', 'clienteditor', 'client.$save() failed', { id: vm.client._id });
          });
        } else {
          $log.debug('debug/error: client $save not defined!');
        }
      }

      var patientsUpdateHandler = function patientsUpdateHandler(message) {
        $log.debug('debug: Patient update received: ', message);
        var messages = message.split(':');
        // $log.debug('debug: $tabid: ', $window.sessionStorage.getItem('sprtabid'));
        if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            vm.client.$refresh().$then(function () {
              $log.debug('debug: clienteditor refreshed patient: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            }, function (error) {
              $log.debug('debug: clienteditor could not refresh patient: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            });
          }
        }
      };

      var clientsUpdateHandler = function clientsUpdateHandler(message) {
        $log.debug('debug: Client update received: ', message);
        var messages = message.split(':');
        if (angular.isDefined(vm.client) && angular.isDefined(vm.client._id)) {
          if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.client._id === messages[0]) {
            vm.client.$refresh().$then(function () {
              $log.debug('debug: clienteditor refreshed client: ', vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            }, function (error) {
              $log.debug('debug: clienteditor could not refresh client: ', error, vm.client.primarycontact.firstname + ' ' + vm.client.primarycontact.lastname);
            });
          }
        }
      };

      vertxEventBusService.on('patients.update', {}, patientsUpdateHandler);
      vertxEventBusService.on('clients.update', {}, clientsUpdateHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('patients.update', {}, patientsUpdateHandler);
        vertxEventBusService.unregisterHandler('clients.update', {}, clientsUpdateHandler);
      };

      // GUI info & help texts
      vm.clientcathelp = 'Kunden können in beliebige Kategorien gruppiert werden. Die Kategorien können entweder frei gewält werden oder als Auswahlliste im Zahnradmenü unter ´Einstellungen´ angelegt werden';
      if (vm.mode === 'patient') {
        vm.testhelp = 'Mit Testpatienten können Sie alle Funktionen, einschließlich Rechnungslegung, ausprobieren, ohne sich das Stornieren von Rechnungen kümmern zu müssen. Alle Rechnungen die Sie auf Testpatienten ausstellen werden automatisch als Test gekennzeichnet und gleich wieder storniert';
      } else {
        vm.testhelp = 'Mit Testkunden können Sie alle Funktionen, einschließlich Rechnungslegung, ausprobieren, ohne sich das Stornieren von Rechnungen kümmern zu müssen. Alle Rechnungen die Sie auf Testkunden ausstellen werden automatisch als Test gekennzeichnet und gleich wieder storniert';
      }
    }] // controller
  }); // component

  // klammerfriedhof
})();
/* global angular, moment */
'use strict';

(function () {
  'use strict';

  angular.module('vcclient').config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider.state('playground.client', {
      url: '/vcclient',
      views: {
        'playgroundmain@playground': {
          template: '<h3 class="alert alert-info"><tt>&lt;patientheader clientid="" mode=""&gt;</tt></h3><div><div ui-view="patientheaderview"></div></div>' + '<h3 class="alert alert-info"><tt>&lt;clientsearch parentsave="getclient(client, mode)"&gt;</tt></h3><div ui-view="clientsearchview1"></div>' + '<h3 class="alert alert-info"><tt>&lt;clientsearch redirect="home"&gt;</tt></h3><div ui-view="clientsearchview2"></div>' + '<h3 class="alert alert-info"><tt>&lt;clientlist clients=""&gt;</tt></h3><div ui-view="clientlistview"></div>' + '<h3 class="alert alert-info"><tt>&lt;clientlist mode=""&gt;</tt></h3><div ui-view="clientlistview2"></div>' + '<h3 class="alert alert-info"><tt>&lt;clientnew mode="" onCreate: "" onCancel: "" onSelectRecord: "",&gt;</tt></h3><div ui-view="clientnewview"></div>' +
          // '<h3 class="alert alert-info"><tt>&lt;clienteditor client="" mode="" clientcategories=""&gt;</tt></h3><div ui-view="clienteditview"></div>' +
          '<h3 class="alert alert-info"><tt>&lt;clienteditor client="" mode="" clientcategories=""&gt;</tt></h3><div ui-view="clienteditview2"></div>' + '<h3 class="alert alert-info"><tt>&lt;svdataedit svdata="" on-change=""&gt;</tt></h3><div ui-view="svdataeditview"></div>' + '<h3 class="alert alert-info"><tt>&lt;contactedit contact="" on-change="" &gt;</tt></h3><div ui-view="contacteditview"></div>' + '<h3 class="alert alert-info"><tt>&lt;companyedit company="" on-change="" &gt;</tt></h3><div ui-view="companyeditview"></div>' + '<h3 class="alert alert-info"><tt>&lt;clientview vcclient=""&gt;</tt></h3><div ui-view="clientview"></div>'
        }
      },
      onEnter: function onEnter() {
        console.log('playground.vcclient entered');
      }
    });

    $stateProvider.state('playground.client.allcomponents', {
      url: '/allcomponents',
      // the `users` input binding on the component receives
      // the `userlist` resolve value (from the state)
      // bind $transistions to gain access to $transition$ object

      resolve: {
        dummyclients: ['ClientHelper', function (ClientHelper) {
          // return ClientHelper.getAll('patient');
          return getClients();
        }],
        emptysvdata: function emptysvdata() {
          return {};
        },
        dummyclient: function dummyclient() {
          return getClient(false, false, 'spr');
        },
        teststate: function teststate() {
          return 'playground.vcutilsdoctor.allcomponents';
        },
        emptyclient: function emptyclient() {
          return { _id: 'somedummyid' };
        },
        patient: function patient() {
          return 'patient';
        },
        basicdata: function basicdata() {
          return 'clientrecord.basicdata';
        },
        home: function home() {
          return 'home';
        },
        realpatient: ['ClientHelper', function (ClientHelper) {
          return ClientHelper.find('patient', '58499f4c878f751a3eab5019');
        }],
        realpatientid: function realpatientid() {
          return '586fcf4fa60359ae2a632d64';
        },
        clientcats: function clientcats() {
          return ['foo', 'bar', 'baz'];
        },
        onfieldchange: function onfieldchange() {
          return function (source) {
            console.log('debug: dummy onfieldchange called from: ', source);
          };
        },
        getclient: function getclient() {
          return function (client, mode) {
            console.log('debug - dummy get client called: client, mode: ', client, mode);
          };
        },
        oncreate: function oncreate() {
          return function () {
            console.log('debug: dummy oncreate called');
          };
        },
        selectrecord: function selectrecord() {
          return function () {
            console.log('debug: dummy select record called');
          };
        },
        oncancel: function oncancel() {
          return function () {
            console.log('debug: dummy oncancel called');
          };
        },
        onSelectRecord: ['$state', function ($state) {
          return function (client, mode) {
            $state.go('clientrecord.basicdata', { client: client, clientid: client._id, mode: mode });
          };
        }],
        onCreate: ['$state', function ($state) {
          return function (client, mode) {
            console.log('debug - onCreate cb with state change called: ', client);
            $state.go('clientrecord.basicdata', { client: client, clientid: client._id, mode: mode });
          };
        }]

      },
      views: {
        // When `fooState.barState` is active, `fooComponent`
        // is loaded into the <ui-view name='content' />
        // which was created by `fooState`.
        // The component's `foo` input receives `fooData` resolve
        'patientheaderview@playground.client': {
          component: 'patientheader',
          bindings: {
            clientid: 'realpatientid',
            mode: 'patient'
          }
        },
        'clientlistview@playground.client': {
          component: 'clientlist',
          bindings: {
            clients: 'dummyclients'
          }
        },
        'clientlistview2@playground.client': {
          component: 'clientlist',
          bindings: {
            mode: 'patient',
            redirect: 'basicdata'
          }
        },
        'clientnewview@playground.client': {
          component: 'clientnew',
          bindings: {
            onCreate: 'onCreate',
            onCancel: 'oncancel',
            onSelectRecord: 'onSelectRecord',
            mode: 'patient'
          }
        },
        'svdataeditview@playground.client': {
          component: 'svedit',
          bindings: {
            svdata: 'emptysvdata',
            parentsave: 'onfieldchange("svdata")'
          }
        },
        'contacteditview@playground.client': {
          component: 'contactedit',
          bindings: {
            contact: 'client.primarycontact',
            parentsave: 'onfieldchange("contact")'
          }
        },
        'companyeditview@playground.client': {
          component: 'companyedit',
          bindings: {
            company: 'client.company',
            parentsave: 'onfieldchange("company")'
          }
        },
        'clienteditview2@playground.client': {
          component: 'clienteditor',
          bindings: {
            client: 'realpatient',
            mode: 'patient',
            clientcategories: 'clientcat'
          }
        },
        'clienteditview@playground.client': {
          component: 'clienteditor',
          bindings: {
            client: 'realpatient',
            mode: 'patient',
            clientcategories: 'clientcat'
          }
        },
        'clientsearchview1@playground.client': {
          component: 'clientsearch',
          bindings: {
            mode: 'patient',
            parentsave: 'getclient(client, id, mode)'
          }
        },
        'clientsearchview2@playground.client': {
          component: 'clientsearch',
          bindings: {
            mode: 'patient',
            redirect: 'teststate'
          }
        } /*,
          'clientview@playground.vcclient': {
           component: 'clientview',
           bindings: {
             vcclient: 'vcclient'
           }
          }*/
      },
      /*views: {
       'clientlistview@playground.vcclient': {
       template: 'Some useless Text'
       }
       },*/
      onEnter: function onEnter() {
        console.log('playground.client.allcomponents entered');
      }
    });
  } // all routes

  function getClient(istest, iscompany, category) {
    var client = {
      _id: '571d67437c01594fd0bbdf47',
      created: '2016-04-25T00:39:31.368Z',
      test: 'Testexam',
      docid: '571d674d7c01594fd0bbdf48',
      patientid: '571d67207c01594fd0bbdf45'
    };
    client.iscompany = iscompany;
    client.test = istest;
    client.category = category;
    client.primarycontact = getContact(Math.floor(Math.random() * 10 + 1));
    client.svdata = {};
    client.contacts = [{}, {}];
    return client;
  }

  function getContact(num) {
    var pers = {};
    switch (num) {
      case 1:
        {
          pers.firstname = 'Martha';
          pers.lastname = 'Stuart';
          pers.address = 'Mustergasse 1';
          pers.postcode = '1070';
          pers.city = 'Wien';
        }
        break;
      case 2:
        {
          pers.firstname = 'Helmut';
          pers.lastname = 'Hofer';
          pers.address = 'Mustergasse 2';
          pers.postcode = '1070';
          pers.city = 'Wien';
        }
        break;
      case 3:
        {
          pers.firstname = 'Maria';
          pers.lastname = 'Schuster';
          pers.address = 'Mustergasse 3';
          pers.postcode = '1070';
          pers.city = 'Wien';
        }
        break;
      default:
        {
          pers.firstname = 'Max';
          pers.lastname = 'Default';
          pers.address = 'Mustergasse 99';
          pers.postcode = '1070';
          pers.city = 'Wien';
        }
        break;
    }
    return pers;
  }

  function getClients() {
    return [getClient(true, true, 'spr'), getClient(true, false, 'spr'), getClient(false, true, 'spr'), getClient(false, false, 'spr'), getClient(true, true, 'other'), getClient(true, false, 'other'), getClient(false, true, 'other'), getClient(false, false, 'other')];
  }
})();
/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
'use strict';

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name vcclient.factory:ClientHelper
   *
   * @description
   *
   */
  angular.module('vcclient').factory('ClientHelper', ClientHelper);

  ClientHelper.$inject = ['Client', 'Patient', '$http', '$log'];

  function ClientHelper(Client, Patient, $http, $log) {
    var service = {};

    service.getAll = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$search(query);
      } else {
        return Client.$search(query);
      }
    };

    service.search = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$search(query);
      } else {
        return Client.$search(query);
      }
    };

    service.create = function (client, mode) {
      if (mode === 'patient') {
        return Patient.$create(client);
      } else {
        return Client.$create(client);
      }
    };

    service.searchahead = function (query, mode) {
      if (mode === 'patient') {
        return Patient.$searchahead(query);
      } else {
        return Client.$searchahead(query);
      }
    };

    service.find = function (mode, id) {
      if (mode === 'patient') {
        return Patient.$find(id);
      } else {
        return Client.$find(id);
      }
    };

    service.fname = function (client, mode) {
      if (mode === 'patient') {
        client.text = '';
        if (angular.isDefined(client.primarycontact) && angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname + ' ';
        }
        client.text += client.primarycontact.lastname;
        if (angular.isDefined(client.svdata.bdateat)) {
          client.text += ', ' + client.svdata.bdateat;
        }
        if (angular.isDefined(client.companydata.name)) {
          client.text += ', ' + client.companydata.name;
        }
      } else {
        client.text = '';
        if (angular.isDefined(client.companydata.name)) {
          client.text += client.companydata.name + ', ';
        }
        if (angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname;
        }
        if (angular.isDefined(client.primarycontact.lastname)) {
          client.text += ' ' + client.primarycontact.lastname;
        }
      }
    };

    service.diagname = function (client, mode, searchterm) {
      if (mode === 'patient') {
        client.text = '';
        if (angular.isDefined(client.primarycontact) && angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname + ' ';
        }
        client.text += client.primarycontact.lastname;
        if (angular.isDefined(client.svdata) && angular.isDefined(client.svdata.bdateat)) {
          client.text += ', ' + client.svdata.bdateat;
        }

        if (angular.isDefined(client.companydata.name)) {
          client.text += ', ' + client.companydata.name;
        }
        if (angular.isDefined(client.flatdiagnoses) && client.flatdiagnoses.length > 0) {
          // $log.debug('[CLIENT][HELPER] flatdiagnoses, searchterm: ',client.flatdiagnoses, searchterm);
          var filtereddiags = client.flatdiagnoses.filter(function (d) {
            return d.includes(searchterm);
          });
          // $log.debug('[CLIENT][HELPER] filtereddiags: ',filtereddiags);

          if (filtereddiags.length > 0) {
            client.text += ', ' + filtereddiags;
          }
        }
      } else {
        client.text = '';
        if (angular.isDefined(client.companydata) && angular.isDefined(client.companydata.name)) {
          client.text += client.companydata.name + ', ';
        }
        if (angular.isDefined(client.primarycontact.firstname)) {
          client.text += client.primarycontact.firstname;
        }
        if (angular.isDefined(client.primarycontact.lastname)) {
          client.text += ' ' + client.primarycontact.lastname;
        }
      }
    };

    return service;
  }

  // klammerfriedhof
})();
/* global angular, moment */
/**
 * Created by lari on 03/05/2017.
 */
'use strict';

(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name vcclient.factory:ClientService
   *
   * @description
   *
   */
  angular.module('vcclient').factory('Client', Client).config(config);

  config.$inject = ['restmodProvider'];

  function config(restmodProvider) {
    restmodProvider.rebase({
      $config: {
        primaryKey: '_id'
      }
    });
  }

  Client.$inject = ['restmod'];

  function Client(restmod) {
    return restmod.model('/routes/clients', 'PagedModel', 'DebouncedModel').mix({
      // consults: {hasMany: 'Consult'},
      // reminders: {hasMany: 'Reminder'},
      // keywords: {hasMany: 'Keywords'},
      created: {
        init: function init() {
          return moment().toISOString();
        }
      },
      active: { init: true },
      test: { init: false },
      log: { init: [] },
      primarycontact: { init: {} },
      companydata: { init: {} },
      image: { init: '/img/head_male.png' },
      inconsult: { inconsult: false },
      incheckout: { incheckout: false },
      consultstate: { consultstate: '' },
      checkoutstate: { checkoutstate: '' },
      $extend: {
        Model: {
          $searchahead: function $searchahead(_params) {
            return this.$collection().$decorate({
              'before-request': function beforeRequest(_req) {
                _req.method = 'GET';
                _req.url = '/routes/clients/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          } // $searchahead
        } // Model
      } // extend
    });
  }
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name chat
   * @description
   *
   */
  angular.module('vcchat', ['ui.router', 'knalli.angular-vertxbus', 'luegg.directives']);
})();
/* global angular, moment, Audio */
/**
 * Created by lari on 03/05/2017.
 */

'use strict';

(function () {
  'use strict';
  angular.module('vcchat').component('chat', {
    restrict: 'E',
    template: '\n        <div class="panel panel-default">\n          <div class="panel-heading">Nachrichten</div>\n          <div class="panel-body">\n            <div scroll-glue class="chatlog">\n              <div ng-repeat="msg in vm.chatlog track by $index">\n                <div ng-bind="msg"></div>\n              </div>\n            </div>\n        \n            <form>\n              <div class="input-group">\n                <input class="form-control"\n                       ng-model="vm.newmessage" id="newgroup" placeholder="Nachricht eingeben" />\n                <span class="input-group-btn">\n                  <button class="btn btn-success"\n                          type="submit"\n                          ng-click="vm.sendMsg()"><i class="fa fa-send"></i></button>\n                </span>\n              </div>\n            </form>\n          </div>\n        </div>\n      ',
    controllerAs: 'vm',
    controller: ['$log', 'Rlog', '$cookies', 'vertxEventBusService', function ($log, Rlog, $cookies, vertxEventBusService) {
      var vm = this;
      vm.sendMsg = sendMsg;

      vm.$onInit = function () {
        vm.chatlog = [];
      };

      function sendMsg() {
        var msg = $cookies.get('username') + ': ' + vm.newmessage;
        vertxEventBusService.publish('chat.to.server', msg);
        vm.newmessage = '';
      }

      var chatHandler = function chatHandler(message) {
        var audio = new Audio('img/submarine.wav');
        audio.play();
        // $log.debug('Received a message: ', message);

        vm.chatlog.push(message);
      };

      vertxEventBusService.on('chat.to.client', {}, chatHandler);

      vm.$onDestroy = function () {
        vertxEventBusService.unregisterHandler('chat.to.client', {}, chatHandler);
      };
    }] // controller
  }); // component

  // klammerfriedhof
})();
'use strict';

(function () {
  'use strict';

  /* @ngdoc object
   * @name home
   * @description
   *
   */
  angular.module('home', ['ui.router', 'vcreminder']);
})();

// 'vctodo'
/**********************************************************************
 ** settings Routes                                                   **
 **********************************************************************/

'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // settings menu
      $stateProvider.state('settings', {
        url: '/settings',
        abstract: true,
        views: {
          'mainmd': {
            template: '\n              <div ui-view="settingsmain"></div>\n              <div ui-view="sm2"></div>\n              <div ui-view="sm3"></div>\n              <div ui-view="sm4"></div>\n              <div ui-view="sm5"></div>\n            '
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('settings state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('settings.services', {
        url: '/services',
        views: {
          settingsmain: { template: '\n                <privcatnewentry></privcatnewentry>\n                <privcatnewgroup></privcatnewgroup>\n                <h3>Bestehende Leistungsgruppen</h3>\n                <privcatgrouplist></privcatgrouplist>\n                <h3>Bestehende Privatleistungen</h3>\n                <privcatentrylist></privcatentrylist>\n\n' }
        }
      });

      $stateProvider.state('settings.doctors', {
        url: '/doctors',
        views: {
          settingsmain: { template: '\n            <h3>Arztsuche</h3>\n            <doctorsearch editinplace="true"></doctorsearch>\n            <doctornew></doctornew>\n            <h3>Ärtzeverzeichnis</h3>\n            <doctorlist editinplace="true"></doctorlist>\n            ' }
        }
      });

      $stateProvider.state('settings.examtemplate', {
        url: '/examtemplate',
        views: {
          settingsmain: { component: 'examtemplatenew' },
          sm2: { component: 'examtemplatelist' }
        },
        onEnter: function onEnter() {
          console.log('settings.examtemplate entered');
        }
      });

      $stateProvider.state('settings.labvalues', {
        url: '/labvalues',
        views: {
          settingsmain: { component: 'labvalueconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.labavalueconfig entered');
        }
      });

      $stateProvider.state('settings.imgvalues', {
        url: '/imgvalues',
        views: {
          settingsmain: { component: 'imagingconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.imgvalues config entered');
        }
      });

      $stateProvider.state('settings.aidevalues', {
        url: '/aidevalues',
        views: {
          settingsmain: { component: 'aideconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.aideconfig entered');
        }
      });

      $stateProvider.state('settings.dms', {
        url: '/dms',
        views: {
          settingsmain: { component: 'documentconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.dms configentered');
        }
      });

      $stateProvider.state('settings.drugconfig', {
        url: '/drugconfig',
        views: {
          settingsmain: { component: 'drugconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.drugconfig entered');
        }
      });

      $stateProvider.state('settings.dicom', {
        url: '/dicomconfig',
        views: {
          settingsmain: { component: 'dicomconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.dicomconfig entered');
        }
      });

      /*      $stateProvider
              .state('settings.gdtsoftware', {
                url: '/gdtsoftwareconfig',
                views: {
                  settingsmain: {component: 'gdtsoftwareconfig'}
                },
                onEnter: function () {
                  console.log('settings.gdtsoftwareconfig entered');
                }
              });*/

      $stateProvider.state('settings.gdtprofil', {
        url: '/gdtprofilconfig',
        views: {
          settingsmain: { component: 'gdtprofilconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.gdtprofilconfig entered');
        }
      });

      // TODO: not sure how much customizing is still left
      $stateProvider.state('settings.config', {
        url: '/config',
        views: {
          settingsmain: { component: 'genconfig' }
        },
        onEnter: function onEnter() {
          console.log('settings.genconfig entered');
        }
      });

      $stateProvider.state('settings.svs', {
        url: '/svs',
        views: {
          settingsmain: { template: '\n            <!--<h3>Arztsuche</h3>-->\n            <!--<ssearch editinplace="true"></ssearch>-->\n            <svnew></svnew>\n            <h3>Sozialversicherungen</h3>\n            <svlist editinplace="true"></svlist>\n            ' }
        }
      });

      // TODO
      $stateProvider.state('settings.shares', {
        url: '/shares',
        views: {
          settingsmain: { template: '<h3>Neues Netzlaufwerk anlegen</h3>' },
          sm2: { component: 'sharenew' },
          sm3: { template: '<h3>Netzlaufwerke</h3>' },
          sm4: { component: 'sharelist' }
        }
      });

      $stateProvider.state('settings.tracker', {
        url: '/tracker',
        views: {
          settingsmain: { template: '\n              <trackernew></trackernew>\n              <h3>Bestehende Tacker</h3>\n              <trackerlist></trackerlist>\n            ' }
        }
      });

      $stateProvider.state('settings.users', {
        url: '/users',
        views: {
          settingsmain: { template: '\n                <usernew></usernew>\n                <h3>Benutzer</h3>\n                <userlist></userlist>\n              '
          }
        }
      });

      $stateProvider.state('settings.dts', {
        url: '/dts',
        views: {
          settingsmain: { template: '<doctypelist></doctypelist>' }
        }
      });

      $stateProvider.state('version', {
        url: '/version',
        views: {
          mainmd: { template: '<version></version>' }
        }
      });
    }
    // klammerfriedhof
  }
})();
/**********************************************************************
 ** PATIENT Routes                                                   **
 **********************************************************************/

'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // view to render patientnew and patientlist components in
      $stateProvider.state('patient', {
        url: '/patient',
        views: {
          main: {
            template: '\n            <h3>Patienten suchen und neuen Patienten anlegen</h3>\n            <form>\n              <div ui-view="patientnewview"></div>\n            </form>\n            <h3>Patienten</h3>\n            <div ui-view="patientlistview"></div>\n          '
          }
        },
        onEnter: function onEnter() {
          console.log('patient state entered');
        }
      });

      // render patientnew, patientlist inside patientview
      $stateProvider.state('patient.patients', {
        url: '/patients',
        // the `users` input binding on the component receives
        // the `userlist` resolve value (from the state)
        // bind $transistions to gain access to $transition$ object

        resolve: {
          patientcats: function patientcats() {
            return ['Patient', 'Organisation', 'Unternehmen'];
          },
          mode: function mode() {
            return 'patient';
          },
          grabfocus: function grabfocus() {
            return true;
          },
          redirect: function redirect() {
            return 'patientrecord.current';
          },
          redirectnew: function redirectnew() {
            return 'patientrecord.basicdata';
          },
          onSelectRecord: ['$state', function ($state) {
            return function (patient, mode) {
              $state.go('patientrecord.basicdata', {
                client: patient,
                clientid: patient._id,
                mode: mode
              });
            };
          }],
          onCreate: ['$state', function ($state) {
            return function (patient, mode) {
              console.log('debug - onCreate cb with state change called: ', patient);
              $state.go('patientrecord.basicdata', { clientid: patient._id, mode: mode });
            };
          }]
        },
        views: {
          'patientnewview@patient': {
            component: 'clientsearch',
            bindings: {
              redirect: 'redirect',
              redirectnew: 'redirectnew',
              mode: 'mode',
              grabfocus: 'grabfocus'
            }
          },
          'patientlistview@patient': {
            component: 'clientlist',
            bindings: {
              mode: 'mode'
            }
          }
        },
        onEnter: function onEnter() {
          console.log('patient.patients state entered');
        }
      });

      // Patientenakte/Patientenakte
      $stateProvider.state('patientrecord', {
        url: '/patientrecord/:mode/:clientid',
        views: {
          'mm1': {
            component: 'patientheader'
          },
          'mm2': {
            templateUrl: 'patientrecordmenu.tpl.html',
            controller: ['$stateParams', function ($stateParams) {
              var vm = this;
              console.log('stateparams in patientrecord state controller: ', $stateParams);
              vm.clientid = $stateParams.clientid;
              vm.mode = $stateParams.mode;
            }],
            controllerAs: 'vm'
          },
          'lb1': {
            component: 'drugcurrent'
          },
          'lb2': {
            component: 'clientreminder',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'lb3': {
            component: 'clientlog',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          clientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          mode: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.mode;
          }]
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('### left panle patientrecord state entered, params: ', $state.params);
        }]
      });

      // Patientenakte Aktuell
      $stateProvider.state('patientrecord.current', {
        url: '/current',
        views: {
          'pr1@patientrecord': {
            component: 'consultrecord',
            bindings: {
              patientid: 'patientid'
            }
          },
          'prsm1@patientrecord': {
            component: 'clientlog',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'prsm2@patientrecord': {
            component: 'clientreminder',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'mode'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }],
          clientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          mode: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.mode;
          }] },
        onEnter: ['$state', function onEnter($state) {
          console.log('### patientrecord.current state entered, params: ', $state.params);
        }]
      });

      // Patientenakte Historie
      $stateProvider.state('patientrecord.history', {
        url: '/history',
        views: {
          'pr1@patientrecord': {
            component: 'consultlist',
            bindings: {
              patientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.history state entered');
        }
      });

      // Patientenakte Medikamente
      $stateProvider.state('patientrecord.drugs', {
        url: '/drugs',
        views: {
          'pr1@patientrecord': {
            component: 'drugcurrent',
            bindings: {
              patientid: 'patientid'
            }
          },
          /*'pr2@patientrecord': {
            component: 'druginteraction',
            bindings: {
              patientid: 'patientid'
            }
          },*/
          'pr3@patientrecord': {
            component: 'drugprescription',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr4@patientrecord': {
            component: 'drugforeign',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr5@patientrecord': {
            component: 'druglist',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr6@patientrecord': {
            component: 'drughistory',
            bindings: {
              patientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.drugs state entered');
        }
      });

      // Patientenakte Untersuchungen
      $stateProvider.state('patientrecord.examinations', {
        url: '/examinations',
        views: {
          'pr1@patientrecord': {
            component: 'examlist',
            bindings: {
              patientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });

      // Patientenakte Dokumente
      $stateProvider.state('patientrecord.documents', {
        url: '/documents',
        views: {
          'pr1@patientrecord': {
            template: '<h3>Dateien für Patienten hinaufladen</h3>'
          },
          'pr2@patientrecord': {
            component: 'patfileupload',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr3@patientrecord': {
            template: '<h3>Dateien, Bilder, Scans</h3>'
          },
          'pr4@patientrecord': {
            component: 'complexfilelist',
            bindings: {
              key: 'idname',
              value: 'patientid'
            }
          },
          'pr5@patientrecord': {
            template: '<h3>Lokal erstellte Dokumente</h3>'
          },
          'pr6@patientrecord': {
            component: 'complexdocumentlist',
            bindings: {
              key: 'idname',
              value: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }],
          idname: function idname() {
            return 'patientid';
          }
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });

      // Patientenakte Tracker
      $stateProvider.state('patientrecord.trackers', {
        url: '/trackers',
        views: {
          'pr1@patientrecord': {
            component: 'trackervaluenew',
            bindings: {
              clientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });

      // Patientenakte Stammdaten
      $stateProvider.state('patientrecord.basicdata', {
        url: '/basicdata',
        views: {
          'pr1@patientrecord': {
            component: 'clienteditor',
            bindings: {
              client: 'patient',
              clientid: 'patientid',
              mode: 'mode',
              patientcategories: 'patientcategories'
            }
          }
        },
        params: {
          client: {},
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          mode: ['$stateParams', function ($stateParams) {
            return $stateParams.mode;
          }],
          patient: ['ClientHelper', '$stateParams', function (ClientHelper, $stateParams) {
            console.log(' ### patientrecord.basicdata log inside resolve: ', $stateParams);
            if (angular.isDefined($stateParams.client) && $stateParams.client.hasOwnProperty('_id')) {
              console.log('patientrecord.basicdata log inside resolve, recycling client: ', $stateParams.client);
              return $stateParams.client;
            }
          }],
          patientid: ['ClientHelper', '$stateParams', function (ClientHelper, $stateParams) {
            console.log('patientrecord.basicdata log inside resolve clientid: ', $stateParams.clientid);
            return $stateParams.clientid;
          }],

          patientcategories: function patientcategories() {
            return ['Patient', 'Organisation', 'Unternehmen'];
          }
        },
        onEnter: function onEnter() {
          console.log('patientrecord.basicdata state entered');
        }
      });

      // show modal for patient searching
      $stateProvider.state('patientsearch', {
        url: 'patientsearch',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            template: '<div class="modalspacer"><form class="form-vertical"><clientsearch mode="patient" redirect="patientrecord"></clientsearch></form></div>'
          });
        }]
      });

      // show modal for searching and entering new patients
      $stateProvider.state('newpatient', {
        url: '/newpatient',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

          console.log('onenter newpatient state: ', $state);
          $uibModal.open({
            template: '<div class="modalspacer"><patientnewsearch dialog="miCtrl.$uibModalInstance"></patientnewsearch></div>',
            controllerAs: 'miCtrl',
            controller: ['$uibModalInstance', function ($uibModalInstance) {
              var vmi = this;
              vmi.$uibModalInstance = $uibModalInstance;
            }],
            size: 'lg'
          });
        }]
      });
    }
    // klammerfriedhof
  }
})();
/**********************************************************************
 ** dms Routes                                                   **
 **********************************************************************/

'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // forms menu
      $stateProvider.state('forms', {
        url: '/forms',
        abstract: true,
        views: {
          'main': {
            template: '\n              <div ui-view="formsmain"></div>\n              <div ui-view="f2"></div>\n              <div ui-view="f3"></div>\n              <div ui-view="f4"></div>\n              <div ui-view="f5"></div>\n            '
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('forms state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('forms.aide', {
        url: '/aide',
        views: {
          formsmain: {
            component: 'newaide',
            bindings: {}
          }
        },
        resolve: {},
        onEnter: ['$state', function onEnter($state) {
          console.log('forms.aide state entered, params: ', $state.params);
        }]

      });

      $stateProvider.state('forms.referral', {
        url: '/referral',
        views: {
          formsmain: {
            component: 'newref',
            bindings: {}
          }
        },
        resolve: {},
        onEnter: ['$state', function onEnter($state) {
          console.log('forms.referral state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('forms.time', {
        url: '/time',
        views: {
          formsmain: {
            component: 'timeslip',
            bindings: {}
          }
        },
        resolve: {},
        onEnter: ['$state', function onEnter($state) {
          console.log('forms.time state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('forms.textprocessing', {
        url: '/textprocessing',
        views: {
          formsmain: {
            component: 'textprocessing',
            bindings: {}
          }
        },
        resolve: {},
        onEnter: ['$state', function onEnter($state) {
          console.log('forms.textprocessing state entered, params: ', $state.params);
        }]
      });
    }

    // klammerfriedhof
  }
})();
/**********************************************************************
 ** Finance Routes                                                   **
 **********************************************************************/

'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // Finance menu
      $stateProvider.state('finance', {
        url: '/finance',
        abstract: true,
        views: {
          'mainmd': {
            template: '<div ui-view="financemain"></div>'
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('finance state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('finance.invoices', {
        url: '/invoices',
        views: {
          financemain: { template: '<invoicebrowser></invoicebrowser>' }
        }
      });

      $stateProvider.state('finance.invoices.cashinv', {
        url: '/cashinv',
        views: {
          invoicedetails: { template: '<cashinvoice mode=""></cashinvoice>' }
        },
        onEnter: function onEnter() {
          console.log('finance.invoices.cashinv entered');
        }
      });

      $stateProvider.state('finance.invoices.checkinv', {
        url: '/checkinv',
        views: {
          invoicedetails: { template: '<checkinvoice mode=""></checkinvoice>' }
        }
      });

      $stateProvider.state('finance.invoices.checkpaid', {
        url: '/checkpaid',
        views: {
          invoicedetails: { template: '<checkinvoice mode="paid"></checkinvoice>' }
        }
      });

      $stateProvider.state('finance.invoices.checkopen', {
        url: '/checkopen',
        views: {
          invoicedetails: { template: '<checkinvoice mode="open"></checkinvoice>' }
        }
      });

      $stateProvider.state('finance.invoices.checkoverdue', {
        url: '/checkoverdue',
        views: {
          invoicedetails: { template: '<checkinvoice mode="overdue"></checkinvoice>' }
        }
      });

      $stateProvider.state('finance.cashbook', {
        url: '/cashbook',
        views: {
          financemain: { component: 'cashbook' }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('finance.cashbook state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('finance.bmfexport', {
        url: '/bmfexport',
        views: {
          financemain: { component: 'bmfexport' }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('finance.bmfexport state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('finance.turnover', {
        url: '/turnover',
        views: {
          financemain: { template: '<turnover></turnover>' }
        }
      });

      $stateProvider.state('finance.rksv', {
        url: '/rksv',
        views: {
          financemain: { template: '<rksv-init></rksv-init><rksv-zero></rksv-zero><depexport></depexport><deplist></deplist>' }
        },
        onEnter: function onEnter() {
          console.log('finance.rksv state entered');
        }
      });
    }
    // klammerfriedhof
  }
})();
/**********************************************************************
 ** dms Routes                                                   **
 **********************************************************************/

'use strict';

(function () {
  'use strict';

  angular.module('home').config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // dms menu
      $stateProvider.state('dms', {
        url: '/dms',
        abstract: true,
        views: {
          'main': {
            template: '\n              <div ui-view="dmsmain"></div>\n              <div ui-view="dm2"></div>\n              <div ui-view="dm3"></div>\n              <div ui-view="dm4"></div>\n              <div ui-view="dm5"></div>\n            '
          }
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('dms state entered, params: ', $state.params);
        }]
      });

      $stateProvider.state('dms.scansorter', {
        url: '/scansorter',
        views: {
          dmsmain: {
            component: 'filebrowser',
            bindings: {
              filemode: 'scan'
            }
          }
        },
        resolve: {
          scan: [function () {
            return 'scan';
          }],
          clientmode: [function () {
            return 'patient';
          }]
        }

      });

      $stateProvider.state('dms.signoff', {
        url: '/signoff',
        views: {
          dmsmain: {
            component: 'filebrowser',
            bindings: {
              filemode: 'signoff'
            }
          }
        },
        resolve: {
          signoff: [function () {
            return 'signoff';
          }],
          clientmode: [function () {
            return 'patient';
          }]
        }

      });

      $stateProvider.state('dms.signoffperson', {
        url: '/signoffperson/:clientid',
        views: {
          dmsmain: {
            component: 'filebrowser',
            bindings: {
              filemode: 'signoff',
              clientmode: 'clientmode',
              clientid: 'clientid'
            }
          }
        },
        resolve: {
          signoff: [function () {
            return 'signoff';
          }],
          clientmode: [function () {
            return 'patient';
          }],
          clientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        }

      });

      $stateProvider.state('dms.genfilebrowser', {
        url: '/genfilebrowser',
        views: {
          dm1: {
            template: '<h3>Dateiupload (nicht patientbezogene Dateien)</h3>'
          },
          dm2: {
            component: 'genfileupload',
            bindings: {}
          },
          dm3: {
            template: '<h3>Dateiübersicht (nicht patientbezogene Dateien)</h3>'
          },
          dm4: {
            component: 'complexfilelist',
            bindings: {
              files: 'genfiles'
            }
          }
        },
        resolve: {
          genfiles: ['File', function (File) {
            return File.$search({ doccat: 'generic', active: { $ne: false } });
          }]
        }

      });
    }

    // klammerfriedhof
  }
})();
'use strict';

(function () {
  'use strict';

  angular.module('sprechstunde').config(config);

  config.$inject = ['$urlRouterProvider', '$stateProvider'];

  // when using states you only need the default route
  function config($urlRouterProvider, $stateProvider) {
    $urlRouterProvider.when('/', '');
    $urlRouterProvider.otherwise('/home');

    // startpage
    $stateProvider.state('home', {
      url: '/home',
      views: {
        main: { templateUrl: 'home/home.tpl.html' }
      }
    });
  }
})();